var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, loglevel$1 = { exports: {} }, loglevel = loglevel$1.exports, hasRequiredLoglevel;
function requireLoglevel() {
  return hasRequiredLoglevel || (hasRequiredLoglevel = 1, (function(r) {
    (function(c, n) {
      r.exports ? r.exports = n() : c.log = n();
    })(loglevel, function() {
      var c = function() {
      }, n = "undefined", t = typeof window !== n && typeof window.navigator !== n && /Trident\/|MSIE /.test(window.navigator.userAgent), e = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
      ], o = {}, p = null;
      function h(x, k) {
        var P = x[k];
        if (typeof P.bind == "function")
          return P.bind(x);
        try {
          return Function.prototype.bind.call(P, x);
        } catch {
          return function() {
            return Function.prototype.apply.apply(P, [x, arguments]);
          };
        }
      }
      function y() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function b(x) {
        return x === "debug" && (x = "log"), typeof console === n ? !1 : x === "trace" && t ? y : console[x] !== void 0 ? h(console, x) : console.log !== void 0 ? h(console, "log") : c;
      }
      function O() {
        for (var x = this.getLevel(), k = 0; k < e.length; k++) {
          var P = e[k];
          this[P] = k < x ? c : this.methodFactory(P, x, this.name);
        }
        if (this.log = this.debug, typeof console === n && x < this.levels.SILENT)
          return "No console available for logging";
      }
      function $(x) {
        return function() {
          typeof console !== n && (O.call(this), this[x].apply(this, arguments));
        };
      }
      function S(x, k, P) {
        return b(x) || $.apply(this, arguments);
      }
      function C(x, k) {
        var P = this, I, T, V, R = "loglevel";
        typeof x == "string" ? R += ":" + x : typeof x == "symbol" && (R = void 0);
        function B(v) {
          var E = (e[v] || "silent").toUpperCase();
          if (!(typeof window === n || !R)) {
            try {
              window.localStorage[R] = E;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(R) + "=" + E + ";";
            } catch {
            }
          }
        }
        function D() {
          var v;
          if (!(typeof window === n || !R)) {
            try {
              v = window.localStorage[R];
            } catch {
            }
            if (typeof v === n)
              try {
                var E = window.document.cookie, F = encodeURIComponent(R), M = E.indexOf(F + "=");
                M !== -1 && (v = /^([^;]+)/.exec(
                  E.slice(M + F.length + 1)
                )[1]);
              } catch {
              }
            return P.levels[v] === void 0 && (v = void 0), v;
          }
        }
        function N() {
          if (!(typeof window === n || !R)) {
            try {
              window.localStorage.removeItem(R);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(R) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function A(v) {
          var E = v;
          if (typeof E == "string" && P.levels[E.toUpperCase()] !== void 0 && (E = P.levels[E.toUpperCase()]), typeof E == "number" && E >= 0 && E <= P.levels.SILENT)
            return E;
          throw new TypeError("log.setLevel() called with invalid level: " + v);
        }
        P.name = x, P.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, P.methodFactory = k || S, P.getLevel = function() {
          return V ?? T ?? I;
        }, P.setLevel = function(v, E) {
          return V = A(v), E !== !1 && B(V), O.call(P);
        }, P.setDefaultLevel = function(v) {
          T = A(v), D() || P.setLevel(v, !1);
        }, P.resetLevel = function() {
          V = null, N(), O.call(P);
        }, P.enableAll = function(v) {
          P.setLevel(P.levels.TRACE, v);
        }, P.disableAll = function(v) {
          P.setLevel(P.levels.SILENT, v);
        }, P.rebuild = function() {
          if (p !== P && (I = A(p.getLevel())), O.call(P), p === P)
            for (var v in o)
              o[v].rebuild();
        }, I = A(
          p ? p.getLevel() : "WARN"
        );
        var g = D();
        g != null && (V = A(g)), O.call(P);
      }
      p = new C(), p.getLogger = function(k) {
        if (typeof k != "symbol" && typeof k != "string" || k === "")
          throw new TypeError("You must supply a name when creating a logger.");
        var P = o[k];
        return P || (P = o[k] = new C(
          k,
          p.methodFactory
        )), P;
      };
      var w = typeof window !== n ? window.log : void 0;
      return p.noConflict = function() {
        return typeof window !== n && window.log === p && (window.log = w), p;
      }, p.getLoggers = function() {
        return o;
      }, p.default = p, p;
    });
  })(loglevel$1)), loglevel$1.exports;
}
var loglevelExports = requireLoglevel(), ConnectionState = /* @__PURE__ */ ((r) => (r.CONNECTED = "CONNECTED", r.DISCONNECTED_FOREVER = "DISCONNECTED_FOREVER", r.INITIAL = "INITIAL", r.PINGING_SERVER = "PINGING_SERVER", r.CONNECTING = "CONNECTING", r.STATIC_CONNECTING = "STATIC_CONNECTING", r.STATIC_CONNECTED = "STATIC_CONNECTED", r))(ConnectionState || {});
const CORS_ERROR_MESSAGE_DOCUMENTATION_LINK = "https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS", WEBSOCKET_STREAM_PATH = "_stcore/stream", SERVER_PING_PATH = "_stcore/health", HOST_CONFIG_PATH = "_stcore/host-config", PING_MINIMUM_RETRY_PERIOD_MS = 100, PING_MAXIMUM_RETRY_PERIOD_MS = 2e3, MAX_RETRIES_BEFORE_CLIENT_ERROR = 6, WEBSOCKET_TIMEOUT_MS = 15 * 1e3, PING_TIMEOUT_MS = 15 * 1e3, IS_DEV_ENV = process.env.NODE_ENV === "development";
var indexMinimal = {}, minimal$1 = {}, aspromise, hasRequiredAspromise;
function requireAspromise() {
  if (hasRequiredAspromise) return aspromise;
  hasRequiredAspromise = 1, aspromise = r;
  function r(c, n) {
    for (var t = new Array(arguments.length - 1), e = 0, o = 2, p = !0; o < arguments.length; )
      t[e++] = arguments[o++];
    return new Promise(function(y, b) {
      t[e] = function($) {
        if (p)
          if (p = !1, $)
            b($);
          else {
            for (var S = new Array(arguments.length - 1), C = 0; C < S.length; )
              S[C++] = arguments[C];
            y.apply(null, S);
          }
      };
      try {
        c.apply(n || null, t);
      } catch (O) {
        p && (p = !1, b(O));
      }
    });
  }
  return aspromise;
}
var base64 = {}, hasRequiredBase64;
function requireBase64() {
  return hasRequiredBase64 || (hasRequiredBase64 = 1, (function(r) {
    var c = r;
    c.length = function(h) {
      var y = h.length;
      if (!y)
        return 0;
      for (var b = 0; --y % 4 > 1 && h.charAt(y) === "="; )
        ++b;
      return Math.ceil(h.length * 3) / 4 - b;
    };
    for (var n = new Array(64), t = new Array(123), e = 0; e < 64; )
      t[n[e] = e < 26 ? e + 65 : e < 52 ? e + 71 : e < 62 ? e - 4 : e - 59 | 43] = e++;
    c.encode = function(h, y, b) {
      for (var O = null, $ = [], S = 0, C = 0, w; y < b; ) {
        var x = h[y++];
        switch (C) {
          case 0:
            $[S++] = n[x >> 2], w = (x & 3) << 4, C = 1;
            break;
          case 1:
            $[S++] = n[w | x >> 4], w = (x & 15) << 2, C = 2;
            break;
          case 2:
            $[S++] = n[w | x >> 6], $[S++] = n[x & 63], C = 0;
            break;
        }
        S > 8191 && ((O || (O = [])).push(String.fromCharCode.apply(String, $)), S = 0);
      }
      return C && ($[S++] = n[w], $[S++] = 61, C === 1 && ($[S++] = 61)), O ? (S && O.push(String.fromCharCode.apply(String, $.slice(0, S))), O.join("")) : String.fromCharCode.apply(String, $.slice(0, S));
    };
    var o = "invalid encoding";
    c.decode = function(h, y, b) {
      for (var O = b, $ = 0, S, C = 0; C < h.length; ) {
        var w = h.charCodeAt(C++);
        if (w === 61 && $ > 1)
          break;
        if ((w = t[w]) === void 0)
          throw Error(o);
        switch ($) {
          case 0:
            S = w, $ = 1;
            break;
          case 1:
            y[b++] = S << 2 | (w & 48) >> 4, S = w, $ = 2;
            break;
          case 2:
            y[b++] = (S & 15) << 4 | (w & 60) >> 2, S = w, $ = 3;
            break;
          case 3:
            y[b++] = (S & 3) << 6 | w, $ = 0;
            break;
        }
      }
      if ($ === 1)
        throw Error(o);
      return b - O;
    }, c.test = function(h) {
      return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(h);
    };
  })(base64)), base64;
}
var eventemitter, hasRequiredEventemitter;
function requireEventemitter() {
  if (hasRequiredEventemitter) return eventemitter;
  hasRequiredEventemitter = 1, eventemitter = r;
  function r() {
    this._listeners = {};
  }
  return r.prototype.on = function(n, t, e) {
    return (this._listeners[n] || (this._listeners[n] = [])).push({
      fn: t,
      ctx: e || this
    }), this;
  }, r.prototype.off = function(n, t) {
    if (n === void 0)
      this._listeners = {};
    else if (t === void 0)
      this._listeners[n] = [];
    else
      for (var e = this._listeners[n], o = 0; o < e.length; )
        e[o].fn === t ? e.splice(o, 1) : ++o;
    return this;
  }, r.prototype.emit = function(n) {
    var t = this._listeners[n];
    if (t) {
      for (var e = [], o = 1; o < arguments.length; )
        e.push(arguments[o++]);
      for (o = 0; o < t.length; )
        t[o].fn.apply(t[o++].ctx, e);
    }
    return this;
  }, eventemitter;
}
var float, hasRequiredFloat;
function requireFloat() {
  if (hasRequiredFloat) return float;
  hasRequiredFloat = 1, float = r(r);
  function r(o) {
    return typeof Float32Array < "u" ? (function() {
      var p = new Float32Array([-0]), h = new Uint8Array(p.buffer), y = h[3] === 128;
      function b(C, w, x) {
        p[0] = C, w[x] = h[0], w[x + 1] = h[1], w[x + 2] = h[2], w[x + 3] = h[3];
      }
      function O(C, w, x) {
        p[0] = C, w[x] = h[3], w[x + 1] = h[2], w[x + 2] = h[1], w[x + 3] = h[0];
      }
      o.writeFloatLE = y ? b : O, o.writeFloatBE = y ? O : b;
      function $(C, w) {
        return h[0] = C[w], h[1] = C[w + 1], h[2] = C[w + 2], h[3] = C[w + 3], p[0];
      }
      function S(C, w) {
        return h[3] = C[w], h[2] = C[w + 1], h[1] = C[w + 2], h[0] = C[w + 3], p[0];
      }
      o.readFloatLE = y ? $ : S, o.readFloatBE = y ? S : $;
    })() : (function() {
      function p(y, b, O, $) {
        var S = b < 0 ? 1 : 0;
        if (S && (b = -b), b === 0)
          y(1 / b > 0 ? (
            /* positive */
            0
          ) : (
            /* negative 0 */
            2147483648
          ), O, $);
        else if (isNaN(b))
          y(2143289344, O, $);
        else if (b > 34028234663852886e22)
          y((S << 31 | 2139095040) >>> 0, O, $);
        else if (b < 11754943508222875e-54)
          y((S << 31 | Math.round(b / 1401298464324817e-60)) >>> 0, O, $);
        else {
          var C = Math.floor(Math.log(b) / Math.LN2), w = Math.round(b * Math.pow(2, -C) * 8388608) & 8388607;
          y((S << 31 | C + 127 << 23 | w) >>> 0, O, $);
        }
      }
      o.writeFloatLE = p.bind(null, c), o.writeFloatBE = p.bind(null, n);
      function h(y, b, O) {
        var $ = y(b, O), S = ($ >> 31) * 2 + 1, C = $ >>> 23 & 255, w = $ & 8388607;
        return C === 255 ? w ? NaN : S * (1 / 0) : C === 0 ? S * 1401298464324817e-60 * w : S * Math.pow(2, C - 150) * (w + 8388608);
      }
      o.readFloatLE = h.bind(null, t), o.readFloatBE = h.bind(null, e);
    })(), typeof Float64Array < "u" ? (function() {
      var p = new Float64Array([-0]), h = new Uint8Array(p.buffer), y = h[7] === 128;
      function b(C, w, x) {
        p[0] = C, w[x] = h[0], w[x + 1] = h[1], w[x + 2] = h[2], w[x + 3] = h[3], w[x + 4] = h[4], w[x + 5] = h[5], w[x + 6] = h[6], w[x + 7] = h[7];
      }
      function O(C, w, x) {
        p[0] = C, w[x] = h[7], w[x + 1] = h[6], w[x + 2] = h[5], w[x + 3] = h[4], w[x + 4] = h[3], w[x + 5] = h[2], w[x + 6] = h[1], w[x + 7] = h[0];
      }
      o.writeDoubleLE = y ? b : O, o.writeDoubleBE = y ? O : b;
      function $(C, w) {
        return h[0] = C[w], h[1] = C[w + 1], h[2] = C[w + 2], h[3] = C[w + 3], h[4] = C[w + 4], h[5] = C[w + 5], h[6] = C[w + 6], h[7] = C[w + 7], p[0];
      }
      function S(C, w) {
        return h[7] = C[w], h[6] = C[w + 1], h[5] = C[w + 2], h[4] = C[w + 3], h[3] = C[w + 4], h[2] = C[w + 5], h[1] = C[w + 6], h[0] = C[w + 7], p[0];
      }
      o.readDoubleLE = y ? $ : S, o.readDoubleBE = y ? S : $;
    })() : (function() {
      function p(y, b, O, $, S, C) {
        var w = $ < 0 ? 1 : 0;
        if (w && ($ = -$), $ === 0)
          y(0, S, C + b), y(1 / $ > 0 ? (
            /* positive */
            0
          ) : (
            /* negative 0 */
            2147483648
          ), S, C + O);
        else if (isNaN($))
          y(0, S, C + b), y(2146959360, S, C + O);
        else if ($ > 17976931348623157e292)
          y(0, S, C + b), y((w << 31 | 2146435072) >>> 0, S, C + O);
        else {
          var x;
          if ($ < 22250738585072014e-324)
            x = $ / 5e-324, y(x >>> 0, S, C + b), y((w << 31 | x / 4294967296) >>> 0, S, C + O);
          else {
            var k = Math.floor(Math.log($) / Math.LN2);
            k === 1024 && (k = 1023), x = $ * Math.pow(2, -k), y(x * 4503599627370496 >>> 0, S, C + b), y((w << 31 | k + 1023 << 20 | x * 1048576 & 1048575) >>> 0, S, C + O);
          }
        }
      }
      o.writeDoubleLE = p.bind(null, c, 0, 4), o.writeDoubleBE = p.bind(null, n, 4, 0);
      function h(y, b, O, $, S) {
        var C = y($, S + b), w = y($, S + O), x = (w >> 31) * 2 + 1, k = w >>> 20 & 2047, P = 4294967296 * (w & 1048575) + C;
        return k === 2047 ? P ? NaN : x * (1 / 0) : k === 0 ? x * 5e-324 * P : x * Math.pow(2, k - 1075) * (P + 4503599627370496);
      }
      o.readDoubleLE = h.bind(null, t, 0, 4), o.readDoubleBE = h.bind(null, e, 4, 0);
    })(), o;
  }
  function c(o, p, h) {
    p[h] = o & 255, p[h + 1] = o >>> 8 & 255, p[h + 2] = o >>> 16 & 255, p[h + 3] = o >>> 24;
  }
  function n(o, p, h) {
    p[h] = o >>> 24, p[h + 1] = o >>> 16 & 255, p[h + 2] = o >>> 8 & 255, p[h + 3] = o & 255;
  }
  function t(o, p) {
    return (o[p] | o[p + 1] << 8 | o[p + 2] << 16 | o[p + 3] << 24) >>> 0;
  }
  function e(o, p) {
    return (o[p] << 24 | o[p + 1] << 16 | o[p + 2] << 8 | o[p + 3]) >>> 0;
  }
  return float;
}
var inquire_1, hasRequiredInquire;
function requireInquire() {
  if (hasRequiredInquire) return inquire_1;
  hasRequiredInquire = 1, inquire_1 = inquire;
  function inquire(moduleName) {
    try {
      var mod = eval("quire".replace(/^/, "re"))(moduleName);
      if (mod && (mod.length || Object.keys(mod).length))
        return mod;
    } catch (r) {
    }
    return null;
  }
  return inquire_1;
}
var utf8 = {}, hasRequiredUtf8;
function requireUtf8() {
  return hasRequiredUtf8 || (hasRequiredUtf8 = 1, (function(r) {
    var c = r;
    c.length = function(t) {
      for (var e = 0, o = 0, p = 0; p < t.length; ++p)
        o = t.charCodeAt(p), o < 128 ? e += 1 : o < 2048 ? e += 2 : (o & 64512) === 55296 && (t.charCodeAt(p + 1) & 64512) === 56320 ? (++p, e += 4) : e += 3;
      return e;
    }, c.read = function(t, e, o) {
      var p = o - e;
      if (p < 1)
        return "";
      for (var h = null, y = [], b = 0, O; e < o; )
        O = t[e++], O < 128 ? y[b++] = O : O > 191 && O < 224 ? y[b++] = (O & 31) << 6 | t[e++] & 63 : O > 239 && O < 365 ? (O = ((O & 7) << 18 | (t[e++] & 63) << 12 | (t[e++] & 63) << 6 | t[e++] & 63) - 65536, y[b++] = 55296 + (O >> 10), y[b++] = 56320 + (O & 1023)) : y[b++] = (O & 15) << 12 | (t[e++] & 63) << 6 | t[e++] & 63, b > 8191 && ((h || (h = [])).push(String.fromCharCode.apply(String, y)), b = 0);
      return h ? (b && h.push(String.fromCharCode.apply(String, y.slice(0, b))), h.join("")) : String.fromCharCode.apply(String, y.slice(0, b));
    }, c.write = function(t, e, o) {
      for (var p = o, h, y, b = 0; b < t.length; ++b)
        h = t.charCodeAt(b), h < 128 ? e[o++] = h : h < 2048 ? (e[o++] = h >> 6 | 192, e[o++] = h & 63 | 128) : (h & 64512) === 55296 && ((y = t.charCodeAt(b + 1)) & 64512) === 56320 ? (h = 65536 + ((h & 1023) << 10) + (y & 1023), ++b, e[o++] = h >> 18 | 240, e[o++] = h >> 12 & 63 | 128, e[o++] = h >> 6 & 63 | 128, e[o++] = h & 63 | 128) : (e[o++] = h >> 12 | 224, e[o++] = h >> 6 & 63 | 128, e[o++] = h & 63 | 128);
      return o - p;
    };
  })(utf8)), utf8;
}
var pool_1, hasRequiredPool;
function requirePool() {
  if (hasRequiredPool) return pool_1;
  hasRequiredPool = 1, pool_1 = r;
  function r(c, n, t) {
    var e = t || 8192, o = e >>> 1, p = null, h = e;
    return function(b) {
      if (b < 1 || b > o)
        return c(b);
      h + b > e && (p = c(e), h = 0);
      var O = n.call(p, h, h += b);
      return h & 7 && (h = (h | 7) + 1), O;
    };
  }
  return pool_1;
}
var longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits) return longbits;
  hasRequiredLongbits = 1, longbits = c;
  var r = requireMinimal$1();
  function c(o, p) {
    this.lo = o >>> 0, this.hi = p >>> 0;
  }
  var n = c.zero = new c(0, 0);
  n.toNumber = function() {
    return 0;
  }, n.zzEncode = n.zzDecode = function() {
    return this;
  }, n.length = function() {
    return 1;
  };
  var t = c.zeroHash = "\0\0\0\0\0\0\0\0";
  c.fromNumber = function(p) {
    if (p === 0)
      return n;
    var h = p < 0;
    h && (p = -p);
    var y = p >>> 0, b = (p - y) / 4294967296 >>> 0;
    return h && (b = ~b >>> 0, y = ~y >>> 0, ++y > 4294967295 && (y = 0, ++b > 4294967295 && (b = 0))), new c(y, b);
  }, c.from = function(p) {
    if (typeof p == "number")
      return c.fromNumber(p);
    if (r.isString(p))
      if (r.Long)
        p = r.Long.fromString(p);
      else
        return c.fromNumber(parseInt(p, 10));
    return p.low || p.high ? new c(p.low >>> 0, p.high >>> 0) : n;
  }, c.prototype.toNumber = function(p) {
    if (!p && this.hi >>> 31) {
      var h = ~this.lo + 1 >>> 0, y = ~this.hi >>> 0;
      return h || (y = y + 1 >>> 0), -(h + y * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, c.prototype.toLong = function(p) {
    return r.Long ? new r.Long(this.lo | 0, this.hi | 0, !!p) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!p };
  };
  var e = String.prototype.charCodeAt;
  return c.fromHash = function(p) {
    return p === t ? n : new c(
      (e.call(p, 0) | e.call(p, 1) << 8 | e.call(p, 2) << 16 | e.call(p, 3) << 24) >>> 0,
      (e.call(p, 4) | e.call(p, 5) << 8 | e.call(p, 6) << 16 | e.call(p, 7) << 24) >>> 0
    );
  }, c.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, c.prototype.zzEncode = function() {
    var p = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ p) >>> 0, this.lo = (this.lo << 1 ^ p) >>> 0, this;
  }, c.prototype.zzDecode = function() {
    var p = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ p) >>> 0, this.hi = (this.hi >>> 1 ^ p) >>> 0, this;
  }, c.prototype.length = function() {
    var p = this.lo, h = (this.lo >>> 28 | this.hi << 4) >>> 0, y = this.hi >>> 24;
    return y === 0 ? h === 0 ? p < 16384 ? p < 128 ? 1 : 2 : p < 2097152 ? 3 : 4 : h < 16384 ? h < 128 ? 5 : 6 : h < 2097152 ? 7 : 8 : y < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal$1;
function requireMinimal$1() {
  return hasRequiredMinimal$1 || (hasRequiredMinimal$1 = 1, (function(r) {
    var c = r;
    c.asPromise = requireAspromise(), c.base64 = requireBase64(), c.EventEmitter = requireEventemitter(), c.float = requireFloat(), c.inquire = requireInquire(), c.utf8 = requireUtf8(), c.pool = requirePool(), c.LongBits = requireLongbits(), c.isNode = !!(typeof commonjsGlobal < "u" && commonjsGlobal && commonjsGlobal.process && commonjsGlobal.process.versions && commonjsGlobal.process.versions.node), c.global = c.isNode && commonjsGlobal || typeof window < "u" && window || typeof self < "u" && self || minimal$1, c.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), c.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), c.isInteger = Number.isInteger || /* istanbul ignore next */
    function(o) {
      return typeof o == "number" && isFinite(o) && Math.floor(o) === o;
    }, c.isString = function(o) {
      return typeof o == "string" || o instanceof String;
    }, c.isObject = function(o) {
      return o && typeof o == "object";
    }, c.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    c.isSet = function(o, p) {
      var h = o[p];
      return h != null && o.hasOwnProperty(p) ? typeof h != "object" || (Array.isArray(h) ? h.length : Object.keys(h).length) > 0 : !1;
    }, c.Buffer = (function() {
      try {
        var e = c.inquire("buffer").Buffer;
        return e.prototype.utf8Write ? e : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    })(), c._Buffer_from = null, c._Buffer_allocUnsafe = null, c.newBuffer = function(o) {
      return typeof o == "number" ? c.Buffer ? c._Buffer_allocUnsafe(o) : new c.Array(o) : c.Buffer ? c._Buffer_from(o) : typeof Uint8Array > "u" ? o : new Uint8Array(o);
    }, c.Array = typeof Uint8Array < "u" ? Uint8Array : Array, c.Long = /* istanbul ignore next */
    c.global.dcodeIO && /* istanbul ignore next */
    c.global.dcodeIO.Long || /* istanbul ignore next */
    c.global.Long || c.inquire("long"), c.key2Re = /^true|false|0|1$/, c.key32Re = /^-?(?:0|[1-9][0-9]*)$/, c.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, c.longToHash = function(o) {
      return o ? c.LongBits.from(o).toHash() : c.LongBits.zeroHash;
    }, c.longFromHash = function(o, p) {
      var h = c.LongBits.fromHash(o);
      return c.Long ? c.Long.fromBits(h.lo, h.hi, p) : h.toNumber(!!p);
    };
    function n(e, o, p) {
      for (var h = Object.keys(o), y = 0; y < h.length; ++y)
        (e[h[y]] === void 0 || !p) && (e[h[y]] = o[h[y]]);
      return e;
    }
    c.merge = n, c.lcFirst = function(o) {
      return o.charAt(0).toLowerCase() + o.substring(1);
    };
    function t(e) {
      function o(p, h) {
        if (!(this instanceof o))
          return new o(p, h);
        Object.defineProperty(this, "message", { get: function() {
          return p;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, o) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), h && n(this, h);
      }
      return o.prototype = Object.create(Error.prototype, {
        constructor: {
          value: o,
          writable: !0,
          enumerable: !1,
          configurable: !0
        },
        name: {
          get: function() {
            return e;
          },
          set: void 0,
          enumerable: !1,
          // configurable: false would accurately preserve the behavior of
          // the original, but I'm guessing that was not intentional.
          // For an actual error subclass, this property would
          // be configurable.
          configurable: !0
        },
        toString: {
          value: function() {
            return this.name + ": " + this.message;
          },
          writable: !0,
          enumerable: !1,
          configurable: !0
        }
      }), o;
    }
    c.newError = t, c.ProtocolError = t("ProtocolError"), c.oneOfGetter = function(o) {
      for (var p = {}, h = 0; h < o.length; ++h)
        p[o[h]] = 1;
      return function() {
        for (var y = Object.keys(this), b = y.length - 1; b > -1; --b)
          if (p[y[b]] === 1 && this[y[b]] !== void 0 && this[y[b]] !== null)
            return y[b];
      };
    }, c.oneOfSetter = function(o) {
      return function(p) {
        for (var h = 0; h < o.length; ++h)
          o[h] !== p && delete this[o[h]];
      };
    }, c.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, c._configure = function() {
      var e = c.Buffer;
      if (!e) {
        c._Buffer_from = c._Buffer_allocUnsafe = null;
        return;
      }
      c._Buffer_from = e.from !== Uint8Array.from && e.from || /* istanbul ignore next */
      function(p, h) {
        return new e(p, h);
      }, c._Buffer_allocUnsafe = e.allocUnsafe || /* istanbul ignore next */
      function(p) {
        return new e(p);
      };
    };
  })(minimal$1)), minimal$1;
}
var writer, hasRequiredWriter;
function requireWriter() {
  if (hasRequiredWriter) return writer;
  hasRequiredWriter = 1, writer = y;
  var r = requireMinimal$1(), c, n = r.LongBits, t = r.base64, e = r.utf8;
  function o(k, P, I) {
    this.fn = k, this.len = P, this.next = void 0, this.val = I;
  }
  function p() {
  }
  function h(k) {
    this.head = k.head, this.tail = k.tail, this.len = k.len, this.next = k.states;
  }
  function y() {
    this.len = 0, this.head = new o(p, 0, 0), this.tail = this.head, this.states = null;
  }
  var b = function() {
    return r.Buffer ? function() {
      return (y.create = function() {
        return new c();
      })();
    } : function() {
      return new y();
    };
  };
  y.create = b(), y.alloc = function(P) {
    return new r.Array(P);
  }, r.Array !== Array && (y.alloc = r.pool(y.alloc, r.Array.prototype.subarray)), y.prototype._push = function(P, I, T) {
    return this.tail = this.tail.next = new o(P, I, T), this.len += I, this;
  };
  function O(k, P, I) {
    P[I] = k & 255;
  }
  function $(k, P, I) {
    for (; k > 127; )
      P[I++] = k & 127 | 128, k >>>= 7;
    P[I] = k;
  }
  function S(k, P) {
    this.len = k, this.next = void 0, this.val = P;
  }
  S.prototype = Object.create(o.prototype), S.prototype.fn = $, y.prototype.uint32 = function(P) {
    return this.len += (this.tail = this.tail.next = new S(
      (P = P >>> 0) < 128 ? 1 : P < 16384 ? 2 : P < 2097152 ? 3 : P < 268435456 ? 4 : 5,
      P
    )).len, this;
  }, y.prototype.int32 = function(P) {
    return P < 0 ? this._push(C, 10, n.fromNumber(P)) : this.uint32(P);
  }, y.prototype.sint32 = function(P) {
    return this.uint32((P << 1 ^ P >> 31) >>> 0);
  };
  function C(k, P, I) {
    for (; k.hi; )
      P[I++] = k.lo & 127 | 128, k.lo = (k.lo >>> 7 | k.hi << 25) >>> 0, k.hi >>>= 7;
    for (; k.lo > 127; )
      P[I++] = k.lo & 127 | 128, k.lo = k.lo >>> 7;
    P[I++] = k.lo;
  }
  y.prototype.uint64 = function(P) {
    var I = n.from(P);
    return this._push(C, I.length(), I);
  }, y.prototype.int64 = y.prototype.uint64, y.prototype.sint64 = function(P) {
    var I = n.from(P).zzEncode();
    return this._push(C, I.length(), I);
  }, y.prototype.bool = function(P) {
    return this._push(O, 1, P ? 1 : 0);
  };
  function w(k, P, I) {
    P[I] = k & 255, P[I + 1] = k >>> 8 & 255, P[I + 2] = k >>> 16 & 255, P[I + 3] = k >>> 24;
  }
  y.prototype.fixed32 = function(P) {
    return this._push(w, 4, P >>> 0);
  }, y.prototype.sfixed32 = y.prototype.fixed32, y.prototype.fixed64 = function(P) {
    var I = n.from(P);
    return this._push(w, 4, I.lo)._push(w, 4, I.hi);
  }, y.prototype.sfixed64 = y.prototype.fixed64, y.prototype.float = function(P) {
    return this._push(r.float.writeFloatLE, 4, P);
  }, y.prototype.double = function(P) {
    return this._push(r.float.writeDoubleLE, 8, P);
  };
  var x = r.Array.prototype.set ? function(P, I, T) {
    I.set(P, T);
  } : function(P, I, T) {
    for (var V = 0; V < P.length; ++V)
      I[T + V] = P[V];
  };
  return y.prototype.bytes = function(P) {
    var I = P.length >>> 0;
    if (!I)
      return this._push(O, 1, 0);
    if (r.isString(P)) {
      var T = y.alloc(I = t.length(P));
      t.decode(P, T, 0), P = T;
    }
    return this.uint32(I)._push(x, I, P);
  }, y.prototype.string = function(P) {
    var I = e.length(P);
    return I ? this.uint32(I)._push(e.write, I, P) : this._push(O, 1, 0);
  }, y.prototype.fork = function() {
    return this.states = new h(this), this.head = this.tail = new o(p, 0, 0), this.len = 0, this;
  }, y.prototype.reset = function() {
    return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new o(p, 0, 0), this.len = 0), this;
  }, y.prototype.ldelim = function() {
    var P = this.head, I = this.tail, T = this.len;
    return this.reset().uint32(T), T && (this.tail.next = P.next, this.tail = I, this.len += T), this;
  }, y.prototype.finish = function() {
    for (var P = this.head.next, I = this.constructor.alloc(this.len), T = 0; P; )
      P.fn(P.val, I, T), T += P.len, P = P.next;
    return I;
  }, y._configure = function(k) {
    c = k, y.create = b(), c._configure();
  }, writer;
}
var writer_buffer, hasRequiredWriter_buffer;
function requireWriter_buffer() {
  if (hasRequiredWriter_buffer) return writer_buffer;
  hasRequiredWriter_buffer = 1, writer_buffer = n;
  var r = requireWriter();
  (n.prototype = Object.create(r.prototype)).constructor = n;
  var c = requireMinimal$1();
  function n() {
    r.call(this);
  }
  n._configure = function() {
    n.alloc = c._Buffer_allocUnsafe, n.writeBytesBuffer = c.Buffer && c.Buffer.prototype instanceof Uint8Array && c.Buffer.prototype.set.name === "set" ? function(o, p, h) {
      p.set(o, h);
    } : function(o, p, h) {
      if (o.copy)
        o.copy(p, h, 0, o.length);
      else for (var y = 0; y < o.length; )
        p[h++] = o[y++];
    };
  }, n.prototype.bytes = function(o) {
    c.isString(o) && (o = c._Buffer_from(o, "base64"));
    var p = o.length >>> 0;
    return this.uint32(p), p && this._push(n.writeBytesBuffer, p, o), this;
  };
  function t(e, o, p) {
    e.length < 40 ? c.utf8.write(e, o, p) : o.utf8Write ? o.utf8Write(e, p) : o.write(e, p);
  }
  return n.prototype.string = function(o) {
    var p = c.Buffer.byteLength(o);
    return this.uint32(p), p && this._push(t, p, o), this;
  }, n._configure(), writer_buffer;
}
var reader, hasRequiredReader;
function requireReader() {
  if (hasRequiredReader) return reader;
  hasRequiredReader = 1, reader = o;
  var r = requireMinimal$1(), c, n = r.LongBits, t = r.utf8;
  function e($, S) {
    return RangeError("index out of range: " + $.pos + " + " + (S || 1) + " > " + $.len);
  }
  function o($) {
    this.buf = $, this.pos = 0, this.len = $.length;
  }
  var p = typeof Uint8Array < "u" ? function(S) {
    if (S instanceof Uint8Array || Array.isArray(S))
      return new o(S);
    throw Error("illegal buffer");
  } : function(S) {
    if (Array.isArray(S))
      return new o(S);
    throw Error("illegal buffer");
  }, h = function() {
    return r.Buffer ? function(C) {
      return (o.create = function(x) {
        return r.Buffer.isBuffer(x) ? new c(x) : p(x);
      })(C);
    } : p;
  };
  o.create = h(), o.prototype._slice = r.Array.prototype.subarray || /* istanbul ignore next */
  r.Array.prototype.slice, o.prototype.uint32 = /* @__PURE__ */ (function() {
    var S = 4294967295;
    return function() {
      if (S = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (S = (S | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (S = (S | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (S = (S | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (S = (S | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128)) return S;
      if ((this.pos += 5) > this.len)
        throw this.pos = this.len, e(this, 10);
      return S;
    };
  })(), o.prototype.int32 = function() {
    return this.uint32() | 0;
  }, o.prototype.sint32 = function() {
    var S = this.uint32();
    return S >>> 1 ^ -(S & 1) | 0;
  };
  function y() {
    var $ = new n(0, 0), S = 0;
    if (this.len - this.pos > 4) {
      for (; S < 4; ++S)
        if ($.lo = ($.lo | (this.buf[this.pos] & 127) << S * 7) >>> 0, this.buf[this.pos++] < 128)
          return $;
      if ($.lo = ($.lo | (this.buf[this.pos] & 127) << 28) >>> 0, $.hi = ($.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
        return $;
      S = 0;
    } else {
      for (; S < 3; ++S) {
        if (this.pos >= this.len)
          throw e(this);
        if ($.lo = ($.lo | (this.buf[this.pos] & 127) << S * 7) >>> 0, this.buf[this.pos++] < 128)
          return $;
      }
      return $.lo = ($.lo | (this.buf[this.pos++] & 127) << S * 7) >>> 0, $;
    }
    if (this.len - this.pos > 4) {
      for (; S < 5; ++S)
        if ($.hi = ($.hi | (this.buf[this.pos] & 127) << S * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return $;
    } else
      for (; S < 5; ++S) {
        if (this.pos >= this.len)
          throw e(this);
        if ($.hi = ($.hi | (this.buf[this.pos] & 127) << S * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
          return $;
      }
    throw Error("invalid varint encoding");
  }
  o.prototype.bool = function() {
    return this.uint32() !== 0;
  };
  function b($, S) {
    return ($[S - 4] | $[S - 3] << 8 | $[S - 2] << 16 | $[S - 1] << 24) >>> 0;
  }
  o.prototype.fixed32 = function() {
    if (this.pos + 4 > this.len)
      throw e(this, 4);
    return b(this.buf, this.pos += 4);
  }, o.prototype.sfixed32 = function() {
    if (this.pos + 4 > this.len)
      throw e(this, 4);
    return b(this.buf, this.pos += 4) | 0;
  };
  function O() {
    if (this.pos + 8 > this.len)
      throw e(this, 8);
    return new n(b(this.buf, this.pos += 4), b(this.buf, this.pos += 4));
  }
  return o.prototype.float = function() {
    if (this.pos + 4 > this.len)
      throw e(this, 4);
    var S = r.float.readFloatLE(this.buf, this.pos);
    return this.pos += 4, S;
  }, o.prototype.double = function() {
    if (this.pos + 8 > this.len)
      throw e(this, 4);
    var S = r.float.readDoubleLE(this.buf, this.pos);
    return this.pos += 8, S;
  }, o.prototype.bytes = function() {
    var S = this.uint32(), C = this.pos, w = this.pos + S;
    if (w > this.len)
      throw e(this, S);
    if (this.pos += S, Array.isArray(this.buf))
      return this.buf.slice(C, w);
    if (C === w) {
      var x = r.Buffer;
      return x ? x.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, C, w);
  }, o.prototype.string = function() {
    var S = this.bytes();
    return t.read(S, 0, S.length);
  }, o.prototype.skip = function(S) {
    if (typeof S == "number") {
      if (this.pos + S > this.len)
        throw e(this, S);
      this.pos += S;
    } else
      do
        if (this.pos >= this.len)
          throw e(this);
      while (this.buf[this.pos++] & 128);
    return this;
  }, o.prototype.skipType = function($) {
    switch ($) {
      case 0:
        this.skip();
        break;
      case 1:
        this.skip(8);
        break;
      case 2:
        this.skip(this.uint32());
        break;
      case 3:
        for (; ($ = this.uint32() & 7) !== 4; )
          this.skipType($);
        break;
      case 5:
        this.skip(4);
        break;
      /* istanbul ignore next */
      default:
        throw Error("invalid wire type " + $ + " at offset " + this.pos);
    }
    return this;
  }, o._configure = function($) {
    c = $, o.create = h(), c._configure();
    var S = r.Long ? "toLong" : (
      /* istanbul ignore next */
      "toNumber"
    );
    r.merge(o.prototype, {
      int64: function() {
        return y.call(this)[S](!1);
      },
      uint64: function() {
        return y.call(this)[S](!0);
      },
      sint64: function() {
        return y.call(this).zzDecode()[S](!1);
      },
      fixed64: function() {
        return O.call(this)[S](!0);
      },
      sfixed64: function() {
        return O.call(this)[S](!1);
      }
    });
  }, reader;
}
var reader_buffer, hasRequiredReader_buffer;
function requireReader_buffer() {
  if (hasRequiredReader_buffer) return reader_buffer;
  hasRequiredReader_buffer = 1, reader_buffer = n;
  var r = requireReader();
  (n.prototype = Object.create(r.prototype)).constructor = n;
  var c = requireMinimal$1();
  function n(t) {
    r.call(this, t);
  }
  return n._configure = function() {
    c.Buffer && (n.prototype._slice = c.Buffer.prototype.slice);
  }, n.prototype.string = function() {
    var e = this.uint32();
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + e, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + e, this.len));
  }, n._configure(), reader_buffer;
}
var rpc = {}, service, hasRequiredService;
function requireService() {
  if (hasRequiredService) return service;
  hasRequiredService = 1, service = c;
  var r = requireMinimal$1();
  (c.prototype = Object.create(r.EventEmitter.prototype)).constructor = c;
  function c(n, t, e) {
    if (typeof n != "function")
      throw TypeError("rpcImpl must be a function");
    r.EventEmitter.call(this), this.rpcImpl = n, this.requestDelimited = !!t, this.responseDelimited = !!e;
  }
  return c.prototype.rpcCall = function n(t, e, o, p, h) {
    if (!p)
      throw TypeError("request must be specified");
    var y = this;
    if (!h)
      return r.asPromise(n, y, t, e, o, p);
    if (!y.rpcImpl) {
      setTimeout(function() {
        h(Error("already ended"));
      }, 0);
      return;
    }
    try {
      return y.rpcImpl(
        t,
        e[y.requestDelimited ? "encodeDelimited" : "encode"](p).finish(),
        function(O, $) {
          if (O)
            return y.emit("error", O, t), h(O);
          if ($ === null) {
            y.end(
              /* endedByRPC */
              !0
            );
            return;
          }
          if (!($ instanceof o))
            try {
              $ = o[y.responseDelimited ? "decodeDelimited" : "decode"]($);
            } catch (S) {
              return y.emit("error", S, t), h(S);
            }
          return y.emit("data", $, t), h(null, $);
        }
      );
    } catch (b) {
      y.emit("error", b, t), setTimeout(function() {
        h(b);
      }, 0);
      return;
    }
  }, c.prototype.end = function(t) {
    return this.rpcImpl && (t || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
  }, service;
}
var hasRequiredRpc;
function requireRpc() {
  return hasRequiredRpc || (hasRequiredRpc = 1, (function(r) {
    var c = r;
    c.Service = requireService();
  })(rpc)), rpc;
}
var roots, hasRequiredRoots;
function requireRoots() {
  return hasRequiredRoots || (hasRequiredRoots = 1, roots = {}), roots;
}
var hasRequiredIndexMinimal;
function requireIndexMinimal() {
  return hasRequiredIndexMinimal || (hasRequiredIndexMinimal = 1, (function(r) {
    var c = r;
    c.build = "minimal", c.Writer = requireWriter(), c.BufferWriter = requireWriter_buffer(), c.Reader = requireReader(), c.BufferReader = requireReader_buffer(), c.util = requireMinimal$1(), c.rpc = requireRpc(), c.roots = requireRoots(), c.configure = n;
    function n() {
      c.util._configure(), c.Writer._configure(c.BufferWriter), c.Reader._configure(c.BufferReader);
    }
    n();
  })(indexMinimal)), indexMinimal;
}
var minimal, hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, minimal = requireIndexMinimal()), minimal;
}
var minimalExports = requireMinimal();
const $Reader = minimalExports.Reader, $Writer = minimalExports.Writer, $util = minimalExports.util, $root = minimalExports.roots.default || (minimalExports.roots.default = {});
$root.Alert = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.body = "", r.prototype.format = 0, r.prototype.icon = "", r.prototype.widthConfig = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.body != null && Object.hasOwnProperty.call(n, "body") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.body), n.format != null && Object.hasOwnProperty.call(n, "format") && t.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(n.format), n.icon != null && Object.hasOwnProperty.call(n, "icon") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.icon), n.widthConfig != null && Object.hasOwnProperty.call(n, "widthConfig") && $root.streamlit.WidthConfig.encode(n.widthConfig, t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Alert();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.body = n.string();
          break;
        }
        case 2: {
          p.format = n.int32();
          break;
        }
        case 3: {
          p.icon = n.string();
          break;
        }
        case 4: {
          p.widthConfig = $root.streamlit.WidthConfig.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.body != null && n.hasOwnProperty("body") && !$util.isString(n.body))
      return "body: string expected";
    if (n.format != null && n.hasOwnProperty("format"))
      switch (n.format) {
        default:
          return "format: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
          break;
      }
    if (n.icon != null && n.hasOwnProperty("icon") && !$util.isString(n.icon))
      return "icon: string expected";
    if (n.widthConfig != null && n.hasOwnProperty("widthConfig")) {
      let t = $root.streamlit.WidthConfig.verify(n.widthConfig);
      if (t)
        return "widthConfig." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Alert)
      return n;
    let t = new $root.Alert();
    switch (n.body != null && (t.body = String(n.body)), n.format) {
      default:
        if (typeof n.format == "number") {
          t.format = n.format;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        t.format = 0;
        break;
      case "ERROR":
      case 1:
        t.format = 1;
        break;
      case "WARNING":
      case 2:
        t.format = 2;
        break;
      case "INFO":
      case 3:
        t.format = 3;
        break;
      case "SUCCESS":
      case 4:
        t.format = 4;
        break;
    }
    if (n.icon != null && (t.icon = String(n.icon)), n.widthConfig != null) {
      if (typeof n.widthConfig != "object")
        throw TypeError(".Alert.widthConfig: object expected");
      t.widthConfig = $root.streamlit.WidthConfig.fromObject(n.widthConfig);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.body = "", e.format = t.enums === String ? "UNUSED" : 0, e.icon = "", e.widthConfig = null), n.body != null && n.hasOwnProperty("body") && (e.body = n.body), n.format != null && n.hasOwnProperty("format") && (e.format = t.enums === String ? $root.Alert.Format[n.format] === void 0 ? n.format : $root.Alert.Format[n.format] : n.format), n.icon != null && n.hasOwnProperty("icon") && (e.icon = n.icon), n.widthConfig != null && n.hasOwnProperty("widthConfig") && (e.widthConfig = $root.streamlit.WidthConfig.toObject(n.widthConfig, t)), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Alert";
  }, r.Format = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "UNUSED"] = 0, n[c[1] = "ERROR"] = 1, n[c[2] = "WARNING"] = 2, n[c[3] = "INFO"] = 3, n[c[4] = "SUCCESS"] = 4, n;
  })(), r;
})();
$root.streamlit = (() => {
  const r = {};
  return r.WidthConfig = (function() {
    function c(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    c.prototype.useStretch = null, c.prototype.useContent = null, c.prototype.pixelWidth = null;
    let n;
    return Object.defineProperty(c.prototype, "widthSpec", {
      get: $util.oneOfGetter(n = ["useStretch", "useContent", "pixelWidth"]),
      set: $util.oneOfSetter(n)
    }), c.create = function(e) {
      return new c(e);
    }, c.encode = function(e, o) {
      return o || (o = $Writer.create()), e.useStretch != null && Object.hasOwnProperty.call(e, "useStretch") && o.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.useStretch), e.useContent != null && Object.hasOwnProperty.call(e, "useContent") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.useContent), e.pixelWidth != null && Object.hasOwnProperty.call(e, "pixelWidth") && o.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(e.pixelWidth), o;
    }, c.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, c.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.streamlit.WidthConfig();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.useStretch = e.bool();
            break;
          }
          case 2: {
            y.useContent = e.bool();
            break;
          }
          case 3: {
            y.pixelWidth = e.uint32();
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, c.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, c.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      let o = {};
      if (e.useStretch != null && e.hasOwnProperty("useStretch") && (o.widthSpec = 1, typeof e.useStretch != "boolean"))
        return "useStretch: boolean expected";
      if (e.useContent != null && e.hasOwnProperty("useContent")) {
        if (o.widthSpec === 1)
          return "widthSpec: multiple values";
        if (o.widthSpec = 1, typeof e.useContent != "boolean")
          return "useContent: boolean expected";
      }
      if (e.pixelWidth != null && e.hasOwnProperty("pixelWidth")) {
        if (o.widthSpec === 1)
          return "widthSpec: multiple values";
        if (o.widthSpec = 1, !$util.isInteger(e.pixelWidth))
          return "pixelWidth: integer expected";
      }
      return null;
    }, c.fromObject = function(e) {
      if (e instanceof $root.streamlit.WidthConfig)
        return e;
      let o = new $root.streamlit.WidthConfig();
      return e.useStretch != null && (o.useStretch = !!e.useStretch), e.useContent != null && (o.useContent = !!e.useContent), e.pixelWidth != null && (o.pixelWidth = e.pixelWidth >>> 0), o;
    }, c.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return e.useStretch != null && e.hasOwnProperty("useStretch") && (p.useStretch = e.useStretch, o.oneofs && (p.widthSpec = "useStretch")), e.useContent != null && e.hasOwnProperty("useContent") && (p.useContent = e.useContent, o.oneofs && (p.widthSpec = "useContent")), e.pixelWidth != null && e.hasOwnProperty("pixelWidth") && (p.pixelWidth = e.pixelWidth, o.oneofs && (p.widthSpec = "pixelWidth")), p;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/streamlit.WidthConfig";
    }, c;
  })(), r.HeightConfig = (function() {
    function c(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    c.prototype.useStretch = null, c.prototype.useContent = null, c.prototype.pixelHeight = null;
    let n;
    return Object.defineProperty(c.prototype, "heightSpec", {
      get: $util.oneOfGetter(n = ["useStretch", "useContent", "pixelHeight"]),
      set: $util.oneOfSetter(n)
    }), c.create = function(e) {
      return new c(e);
    }, c.encode = function(e, o) {
      return o || (o = $Writer.create()), e.useStretch != null && Object.hasOwnProperty.call(e, "useStretch") && o.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.useStretch), e.useContent != null && Object.hasOwnProperty.call(e, "useContent") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.useContent), e.pixelHeight != null && Object.hasOwnProperty.call(e, "pixelHeight") && o.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(e.pixelHeight), o;
    }, c.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, c.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.streamlit.HeightConfig();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.useStretch = e.bool();
            break;
          }
          case 2: {
            y.useContent = e.bool();
            break;
          }
          case 3: {
            y.pixelHeight = e.uint32();
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, c.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, c.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      let o = {};
      if (e.useStretch != null && e.hasOwnProperty("useStretch") && (o.heightSpec = 1, typeof e.useStretch != "boolean"))
        return "useStretch: boolean expected";
      if (e.useContent != null && e.hasOwnProperty("useContent")) {
        if (o.heightSpec === 1)
          return "heightSpec: multiple values";
        if (o.heightSpec = 1, typeof e.useContent != "boolean")
          return "useContent: boolean expected";
      }
      if (e.pixelHeight != null && e.hasOwnProperty("pixelHeight")) {
        if (o.heightSpec === 1)
          return "heightSpec: multiple values";
        if (o.heightSpec = 1, !$util.isInteger(e.pixelHeight))
          return "pixelHeight: integer expected";
      }
      return null;
    }, c.fromObject = function(e) {
      if (e instanceof $root.streamlit.HeightConfig)
        return e;
      let o = new $root.streamlit.HeightConfig();
      return e.useStretch != null && (o.useStretch = !!e.useStretch), e.useContent != null && (o.useContent = !!e.useContent), e.pixelHeight != null && (o.pixelHeight = e.pixelHeight >>> 0), o;
    }, c.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return e.useStretch != null && e.hasOwnProperty("useStretch") && (p.useStretch = e.useStretch, o.oneofs && (p.heightSpec = "useStretch")), e.useContent != null && e.hasOwnProperty("useContent") && (p.useContent = e.useContent, o.oneofs && (p.heightSpec = "useContent")), e.pixelHeight != null && e.hasOwnProperty("pixelHeight") && (p.pixelHeight = e.pixelHeight, o.oneofs && (p.heightSpec = "pixelHeight")), p;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/streamlit.HeightConfig";
    }, c;
  })(), r.GapSize = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "GAP_UNDEFINED"] = 0, n[c[1] = "SMALL"] = 1, n[c[2] = "MEDIUM"] = 2, n[c[3] = "LARGE"] = 3, n[c[4] = "NONE"] = 4, n;
  })(), r.GapConfig = (function() {
    function c(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    c.prototype.gapSize = null;
    let n;
    return Object.defineProperty(c.prototype, "gapSpec", {
      get: $util.oneOfGetter(n = ["gapSize"]),
      set: $util.oneOfSetter(n)
    }), c.create = function(e) {
      return new c(e);
    }, c.encode = function(e, o) {
      return o || (o = $Writer.create()), e.gapSize != null && Object.hasOwnProperty.call(e, "gapSize") && o.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.gapSize), o;
    }, c.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, c.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.streamlit.GapConfig();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.gapSize = e.int32();
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, c.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, c.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.gapSize != null && e.hasOwnProperty("gapSize"))
        switch (e.gapSize) {
          default:
            return "gapSize: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      return null;
    }, c.fromObject = function(e) {
      if (e instanceof $root.streamlit.GapConfig)
        return e;
      let o = new $root.streamlit.GapConfig();
      switch (e.gapSize) {
        default:
          if (typeof e.gapSize == "number") {
            o.gapSize = e.gapSize;
            break;
          }
          break;
        case "GAP_UNDEFINED":
        case 0:
          o.gapSize = 0;
          break;
        case "SMALL":
        case 1:
          o.gapSize = 1;
          break;
        case "MEDIUM":
        case 2:
          o.gapSize = 2;
          break;
        case "LARGE":
        case 3:
          o.gapSize = 3;
          break;
        case "NONE":
        case 4:
          o.gapSize = 4;
          break;
      }
      return o;
    }, c.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return e.gapSize != null && e.hasOwnProperty("gapSize") && (p.gapSize = o.enums === String ? $root.streamlit.GapSize[e.gapSize] === void 0 ? e.gapSize : $root.streamlit.GapSize[e.gapSize] : e.gapSize, o.oneofs && (p.gapSpec = "gapSize")), p;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/streamlit.GapConfig";
    }, c;
  })(), r;
})();
$root.AppPage = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.pageScriptHash = "", r.prototype.pageName = "", r.prototype.icon = "", r.prototype.isDefault = !1, r.prototype.sectionHeader = "", r.prototype.urlPathname = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.pageScriptHash != null && Object.hasOwnProperty.call(n, "pageScriptHash") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.pageScriptHash), n.pageName != null && Object.hasOwnProperty.call(n, "pageName") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.pageName), n.icon != null && Object.hasOwnProperty.call(n, "icon") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.icon), n.isDefault != null && Object.hasOwnProperty.call(n, "isDefault") && t.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(n.isDefault), n.sectionHeader != null && Object.hasOwnProperty.call(n, "sectionHeader") && t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(n.sectionHeader), n.urlPathname != null && Object.hasOwnProperty.call(n, "urlPathname") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.urlPathname), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.AppPage();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.pageScriptHash = n.string();
          break;
        }
        case 2: {
          p.pageName = n.string();
          break;
        }
        case 3: {
          p.icon = n.string();
          break;
        }
        case 4: {
          p.isDefault = n.bool();
          break;
        }
        case 5: {
          p.sectionHeader = n.string();
          break;
        }
        case 6: {
          p.urlPathname = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.pageScriptHash != null && n.hasOwnProperty("pageScriptHash") && !$util.isString(n.pageScriptHash) ? "pageScriptHash: string expected" : n.pageName != null && n.hasOwnProperty("pageName") && !$util.isString(n.pageName) ? "pageName: string expected" : n.icon != null && n.hasOwnProperty("icon") && !$util.isString(n.icon) ? "icon: string expected" : n.isDefault != null && n.hasOwnProperty("isDefault") && typeof n.isDefault != "boolean" ? "isDefault: boolean expected" : n.sectionHeader != null && n.hasOwnProperty("sectionHeader") && !$util.isString(n.sectionHeader) ? "sectionHeader: string expected" : n.urlPathname != null && n.hasOwnProperty("urlPathname") && !$util.isString(n.urlPathname) ? "urlPathname: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.AppPage)
      return n;
    let t = new $root.AppPage();
    return n.pageScriptHash != null && (t.pageScriptHash = String(n.pageScriptHash)), n.pageName != null && (t.pageName = String(n.pageName)), n.icon != null && (t.icon = String(n.icon)), n.isDefault != null && (t.isDefault = !!n.isDefault), n.sectionHeader != null && (t.sectionHeader = String(n.sectionHeader)), n.urlPathname != null && (t.urlPathname = String(n.urlPathname)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.pageScriptHash = "", e.pageName = "", e.icon = "", e.isDefault = !1, e.sectionHeader = "", e.urlPathname = ""), n.pageScriptHash != null && n.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = n.pageScriptHash), n.pageName != null && n.hasOwnProperty("pageName") && (e.pageName = n.pageName), n.icon != null && n.hasOwnProperty("icon") && (e.icon = n.icon), n.isDefault != null && n.hasOwnProperty("isDefault") && (e.isDefault = n.isDefault), n.sectionHeader != null && n.hasOwnProperty("sectionHeader") && (e.sectionHeader = n.sectionHeader), n.urlPathname != null && n.hasOwnProperty("urlPathname") && (e.urlPathname = n.urlPathname), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/AppPage";
  }, r;
})();
$root.Arrow = (() => {
  function r(n) {
    if (this.columnOrder = [], this.selectionMode = [], n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.data = $util.newBuffer([]), r.prototype.styler = null, r.prototype.width = 0, r.prototype.height = 0, r.prototype.useContainerWidth = !1, r.prototype.id = "", r.prototype.columns = "", r.prototype.editingMode = 0, r.prototype.disabled = !1, r.prototype.formId = "", r.prototype.columnOrder = $util.emptyArray, r.prototype.selectionMode = $util.emptyArray, r.prototype.rowHeight = null, r.prototype.borderMode = 0;
  let c;
  return Object.defineProperty(r.prototype, "_rowHeight", {
    get: $util.oneOfGetter(c = ["rowHeight"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    if (e || (e = $Writer.create()), t.data != null && Object.hasOwnProperty.call(t, "data") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(t.data), t.styler != null && Object.hasOwnProperty.call(t, "styler") && $root.Styler.encode(t.styler, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), t.width != null && Object.hasOwnProperty.call(t, "width") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(t.width), t.height != null && Object.hasOwnProperty.call(t, "height") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).uint32(t.height), t.useContainerWidth != null && Object.hasOwnProperty.call(t, "useContainerWidth") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(t.useContainerWidth), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.id), t.columns != null && Object.hasOwnProperty.call(t, "columns") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(t.columns), t.editingMode != null && Object.hasOwnProperty.call(t, "editingMode") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(t.editingMode), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(t.disabled), t.formId != null && Object.hasOwnProperty.call(t, "formId") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(t.formId), t.columnOrder != null && t.columnOrder.length)
      for (let o = 0; o < t.columnOrder.length; ++o)
        e.uint32(
          /* id 11, wireType 2 =*/
          90
        ).string(t.columnOrder[o]);
    if (t.selectionMode != null && t.selectionMode.length) {
      e.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork();
      for (let o = 0; o < t.selectionMode.length; ++o)
        e.int32(t.selectionMode[o]);
      e.ldelim();
    }
    return t.rowHeight != null && Object.hasOwnProperty.call(t, "rowHeight") && e.uint32(
      /* id 13, wireType 0 =*/
      104
    ).uint32(t.rowHeight), t.borderMode != null && Object.hasOwnProperty.call(t, "borderMode") && e.uint32(
      /* id 14, wireType 0 =*/
      112
    ).int32(t.borderMode), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.Arrow();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.data = t.bytes();
          break;
        }
        case 2: {
          h.styler = $root.Styler.decode(t, t.uint32());
          break;
        }
        case 3: {
          h.width = t.uint32();
          break;
        }
        case 4: {
          h.height = t.uint32();
          break;
        }
        case 5: {
          h.useContainerWidth = t.bool();
          break;
        }
        case 6: {
          h.id = t.string();
          break;
        }
        case 7: {
          h.columns = t.string();
          break;
        }
        case 8: {
          h.editingMode = t.int32();
          break;
        }
        case 9: {
          h.disabled = t.bool();
          break;
        }
        case 10: {
          h.formId = t.string();
          break;
        }
        case 11: {
          h.columnOrder && h.columnOrder.length || (h.columnOrder = []), h.columnOrder.push(t.string());
          break;
        }
        case 12: {
          if (h.selectionMode && h.selectionMode.length || (h.selectionMode = []), (y & 7) === 2) {
            let b = t.uint32() + t.pos;
            for (; t.pos < b; )
              h.selectionMode.push(t.int32());
          } else
            h.selectionMode.push(t.int32());
          break;
        }
        case 13: {
          h.rowHeight = t.uint32();
          break;
        }
        case 14: {
          h.borderMode = t.int32();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.data != null && t.hasOwnProperty("data") && !(t.data && typeof t.data.length == "number" || $util.isString(t.data)))
      return "data: buffer expected";
    if (t.styler != null && t.hasOwnProperty("styler")) {
      let e = $root.Styler.verify(t.styler);
      if (e)
        return "styler." + e;
    }
    if (t.width != null && t.hasOwnProperty("width") && !$util.isInteger(t.width))
      return "width: integer expected";
    if (t.height != null && t.hasOwnProperty("height") && !$util.isInteger(t.height))
      return "height: integer expected";
    if (t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && typeof t.useContainerWidth != "boolean")
      return "useContainerWidth: boolean expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.columns != null && t.hasOwnProperty("columns") && !$util.isString(t.columns))
      return "columns: string expected";
    if (t.editingMode != null && t.hasOwnProperty("editingMode"))
      switch (t.editingMode) {
        default:
          return "editingMode: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean")
      return "disabled: boolean expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId))
      return "formId: string expected";
    if (t.columnOrder != null && t.hasOwnProperty("columnOrder")) {
      if (!Array.isArray(t.columnOrder))
        return "columnOrder: array expected";
      for (let e = 0; e < t.columnOrder.length; ++e)
        if (!$util.isString(t.columnOrder[e]))
          return "columnOrder: string[] expected";
    }
    if (t.selectionMode != null && t.hasOwnProperty("selectionMode")) {
      if (!Array.isArray(t.selectionMode))
        return "selectionMode: array expected";
      for (let e = 0; e < t.selectionMode.length; ++e)
        switch (t.selectionMode[e]) {
          default:
            return "selectionMode: enum value[] expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
        }
    }
    if (t.rowHeight != null && t.hasOwnProperty("rowHeight") && !$util.isInteger(t.rowHeight))
      return "rowHeight: integer expected";
    if (t.borderMode != null && t.hasOwnProperty("borderMode"))
      switch (t.borderMode) {
        default:
          return "borderMode: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.Arrow)
      return t;
    let e = new $root.Arrow();
    if (t.data != null && (typeof t.data == "string" ? $util.base64.decode(t.data, e.data = $util.newBuffer($util.base64.length(t.data)), 0) : t.data.length >= 0 && (e.data = t.data)), t.styler != null) {
      if (typeof t.styler != "object")
        throw TypeError(".Arrow.styler: object expected");
      e.styler = $root.Styler.fromObject(t.styler);
    }
    switch (t.width != null && (e.width = t.width >>> 0), t.height != null && (e.height = t.height >>> 0), t.useContainerWidth != null && (e.useContainerWidth = !!t.useContainerWidth), t.id != null && (e.id = String(t.id)), t.columns != null && (e.columns = String(t.columns)), t.editingMode) {
      default:
        if (typeof t.editingMode == "number") {
          e.editingMode = t.editingMode;
          break;
        }
        break;
      case "READ_ONLY":
      case 0:
        e.editingMode = 0;
        break;
      case "FIXED":
      case 1:
        e.editingMode = 1;
        break;
      case "DYNAMIC":
      case 2:
        e.editingMode = 2;
        break;
    }
    if (t.disabled != null && (e.disabled = !!t.disabled), t.formId != null && (e.formId = String(t.formId)), t.columnOrder) {
      if (!Array.isArray(t.columnOrder))
        throw TypeError(".Arrow.columnOrder: array expected");
      e.columnOrder = [];
      for (let o = 0; o < t.columnOrder.length; ++o)
        e.columnOrder[o] = String(t.columnOrder[o]);
    }
    if (t.selectionMode) {
      if (!Array.isArray(t.selectionMode))
        throw TypeError(".Arrow.selectionMode: array expected");
      e.selectionMode = [];
      for (let o = 0; o < t.selectionMode.length; ++o)
        switch (t.selectionMode[o]) {
          default:
            if (typeof t.selectionMode[o] == "number") {
              e.selectionMode[o] = t.selectionMode[o];
              break;
            }
          case "SINGLE_ROW":
          case 0:
            e.selectionMode[o] = 0;
            break;
          case "MULTI_ROW":
          case 1:
            e.selectionMode[o] = 1;
            break;
          case "SINGLE_COLUMN":
          case 2:
            e.selectionMode[o] = 2;
            break;
          case "MULTI_COLUMN":
          case 3:
            e.selectionMode[o] = 3;
            break;
          case "SINGLE_CELL":
          case 4:
            e.selectionMode[o] = 4;
            break;
          case "MULTI_CELL":
          case 5:
            e.selectionMode[o] = 5;
            break;
        }
    }
    switch (t.rowHeight != null && (e.rowHeight = t.rowHeight >>> 0), t.borderMode) {
      default:
        if (typeof t.borderMode == "number") {
          e.borderMode = t.borderMode;
          break;
        }
        break;
      case "ALL":
      case 0:
        e.borderMode = 0;
        break;
      case "NONE":
      case 1:
        e.borderMode = 1;
        break;
      case "HORIZONTAL":
      case 2:
        e.borderMode = 2;
        break;
    }
    return e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    if ((e.arrays || e.defaults) && (o.columnOrder = [], o.selectionMode = []), e.defaults && (e.bytes === String ? o.data = "" : (o.data = [], e.bytes !== Array && (o.data = $util.newBuffer(o.data))), o.styler = null, o.width = 0, o.height = 0, o.useContainerWidth = !1, o.id = "", o.columns = "", o.editingMode = e.enums === String ? "READ_ONLY" : 0, o.disabled = !1, o.formId = "", o.borderMode = e.enums === String ? "ALL" : 0), t.data != null && t.hasOwnProperty("data") && (o.data = e.bytes === String ? $util.base64.encode(t.data, 0, t.data.length) : e.bytes === Array ? Array.prototype.slice.call(t.data) : t.data), t.styler != null && t.hasOwnProperty("styler") && (o.styler = $root.Styler.toObject(t.styler, e)), t.width != null && t.hasOwnProperty("width") && (o.width = t.width), t.height != null && t.hasOwnProperty("height") && (o.height = t.height), t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && (o.useContainerWidth = t.useContainerWidth), t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.columns != null && t.hasOwnProperty("columns") && (o.columns = t.columns), t.editingMode != null && t.hasOwnProperty("editingMode") && (o.editingMode = e.enums === String ? $root.Arrow.EditingMode[t.editingMode] === void 0 ? t.editingMode : $root.Arrow.EditingMode[t.editingMode] : t.editingMode), t.disabled != null && t.hasOwnProperty("disabled") && (o.disabled = t.disabled), t.formId != null && t.hasOwnProperty("formId") && (o.formId = t.formId), t.columnOrder && t.columnOrder.length) {
      o.columnOrder = [];
      for (let p = 0; p < t.columnOrder.length; ++p)
        o.columnOrder[p] = t.columnOrder[p];
    }
    if (t.selectionMode && t.selectionMode.length) {
      o.selectionMode = [];
      for (let p = 0; p < t.selectionMode.length; ++p)
        o.selectionMode[p] = e.enums === String ? $root.Arrow.SelectionMode[t.selectionMode[p]] === void 0 ? t.selectionMode[p] : $root.Arrow.SelectionMode[t.selectionMode[p]] : t.selectionMode[p];
    }
    return t.rowHeight != null && t.hasOwnProperty("rowHeight") && (o.rowHeight = t.rowHeight, e.oneofs && (o._rowHeight = "rowHeight")), t.borderMode != null && t.hasOwnProperty("borderMode") && (o.borderMode = e.enums === String ? $root.Arrow.BorderMode[t.borderMode] === void 0 ? t.borderMode : $root.Arrow.BorderMode[t.borderMode] : t.borderMode), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Arrow";
  }, r.EditingMode = (function() {
    const n = {}, t = Object.create(n);
    return t[n[0] = "READ_ONLY"] = 0, t[n[1] = "FIXED"] = 1, t[n[2] = "DYNAMIC"] = 2, t;
  })(), r.SelectionMode = (function() {
    const n = {}, t = Object.create(n);
    return t[n[0] = "SINGLE_ROW"] = 0, t[n[1] = "MULTI_ROW"] = 1, t[n[2] = "SINGLE_COLUMN"] = 2, t[n[3] = "MULTI_COLUMN"] = 3, t[n[4] = "SINGLE_CELL"] = 4, t[n[5] = "MULTI_CELL"] = 5, t;
  })(), r.BorderMode = (function() {
    const n = {}, t = Object.create(n);
    return t[n[0] = "ALL"] = 0, t[n[1] = "NONE"] = 1, t[n[2] = "HORIZONTAL"] = 2, t;
  })(), r;
})();
$root.Styler = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.uuid = "", r.prototype.caption = "", r.prototype.styles = "", r.prototype.displayValues = $util.newBuffer([]), r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.uuid != null && Object.hasOwnProperty.call(n, "uuid") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.uuid), n.caption != null && Object.hasOwnProperty.call(n, "caption") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.caption), n.styles != null && Object.hasOwnProperty.call(n, "styles") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.styles), n.displayValues != null && Object.hasOwnProperty.call(n, "displayValues") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(n.displayValues), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Styler();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.uuid = n.string();
          break;
        }
        case 2: {
          p.caption = n.string();
          break;
        }
        case 3: {
          p.styles = n.string();
          break;
        }
        case 4: {
          p.displayValues = n.bytes();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.uuid != null && n.hasOwnProperty("uuid") && !$util.isString(n.uuid) ? "uuid: string expected" : n.caption != null && n.hasOwnProperty("caption") && !$util.isString(n.caption) ? "caption: string expected" : n.styles != null && n.hasOwnProperty("styles") && !$util.isString(n.styles) ? "styles: string expected" : n.displayValues != null && n.hasOwnProperty("displayValues") && !(n.displayValues && typeof n.displayValues.length == "number" || $util.isString(n.displayValues)) ? "displayValues: buffer expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Styler)
      return n;
    let t = new $root.Styler();
    return n.uuid != null && (t.uuid = String(n.uuid)), n.caption != null && (t.caption = String(n.caption)), n.styles != null && (t.styles = String(n.styles)), n.displayValues != null && (typeof n.displayValues == "string" ? $util.base64.decode(n.displayValues, t.displayValues = $util.newBuffer($util.base64.length(n.displayValues)), 0) : n.displayValues.length >= 0 && (t.displayValues = n.displayValues)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.uuid = "", e.caption = "", e.styles = "", t.bytes === String ? e.displayValues = "" : (e.displayValues = [], t.bytes !== Array && (e.displayValues = $util.newBuffer(e.displayValues)))), n.uuid != null && n.hasOwnProperty("uuid") && (e.uuid = n.uuid), n.caption != null && n.hasOwnProperty("caption") && (e.caption = n.caption), n.styles != null && n.hasOwnProperty("styles") && (e.styles = n.styles), n.displayValues != null && n.hasOwnProperty("displayValues") && (e.displayValues = t.bytes === String ? $util.base64.encode(n.displayValues, 0, n.displayValues.length) : t.bytes === Array ? Array.prototype.slice.call(n.displayValues) : n.displayValues), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Styler";
  }, r;
})();
$root.ArrowNamedDataSet = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.name = "", r.prototype.hasName = !1, r.prototype.data = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.name != null && Object.hasOwnProperty.call(n, "name") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.name), n.data != null && Object.hasOwnProperty.call(n, "data") && $root.Arrow.encode(n.data, t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), n.hasName != null && Object.hasOwnProperty.call(n, "hasName") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(n.hasName), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.ArrowNamedDataSet();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.name = n.string();
          break;
        }
        case 3: {
          p.hasName = n.bool();
          break;
        }
        case 2: {
          p.data = $root.Arrow.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
      return "name: string expected";
    if (n.hasName != null && n.hasOwnProperty("hasName") && typeof n.hasName != "boolean")
      return "hasName: boolean expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      let t = $root.Arrow.verify(n.data);
      if (t)
        return "data." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.ArrowNamedDataSet)
      return n;
    let t = new $root.ArrowNamedDataSet();
    if (n.name != null && (t.name = String(n.name)), n.hasName != null && (t.hasName = !!n.hasName), n.data != null) {
      if (typeof n.data != "object")
        throw TypeError(".ArrowNamedDataSet.data: object expected");
      t.data = $root.Arrow.fromObject(n.data);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.name = "", e.data = null, e.hasName = !1), n.name != null && n.hasOwnProperty("name") && (e.name = n.name), n.data != null && n.hasOwnProperty("data") && (e.data = $root.Arrow.toObject(n.data, t)), n.hasName != null && n.hasOwnProperty("hasName") && (e.hasName = n.hasName), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/ArrowNamedDataSet";
  }, r;
})();
$root.ArrowVegaLiteChart = (() => {
  function r(c) {
    if (this.datasets = [], this.selectionMode = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.spec = "", r.prototype.data = null, r.prototype.datasets = $util.emptyArray, r.prototype.useContainerWidth = !1, r.prototype.theme = "", r.prototype.id = "", r.prototype.selectionMode = $util.emptyArray, r.prototype.formId = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.spec != null && Object.hasOwnProperty.call(n, "spec") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.spec), n.data != null && Object.hasOwnProperty.call(n, "data") && $root.Arrow.encode(n.data, t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), n.datasets != null && n.datasets.length)
      for (let e = 0; e < n.datasets.length; ++e)
        $root.ArrowNamedDataSet.encode(n.datasets[e], t.uint32(
          /* id 4, wireType 2 =*/
          34
        ).fork()).ldelim();
    if (n.useContainerWidth != null && Object.hasOwnProperty.call(n, "useContainerWidth") && t.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(n.useContainerWidth), n.theme != null && Object.hasOwnProperty.call(n, "theme") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.theme), n.id != null && Object.hasOwnProperty.call(n, "id") && t.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(n.id), n.selectionMode != null && n.selectionMode.length)
      for (let e = 0; e < n.selectionMode.length; ++e)
        t.uint32(
          /* id 8, wireType 2 =*/
          66
        ).string(n.selectionMode[e]);
    return n.formId != null && Object.hasOwnProperty.call(n, "formId") && t.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(n.formId), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.ArrowVegaLiteChart();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.spec = n.string();
          break;
        }
        case 2: {
          p.data = $root.Arrow.decode(n, n.uint32());
          break;
        }
        case 4: {
          p.datasets && p.datasets.length || (p.datasets = []), p.datasets.push($root.ArrowNamedDataSet.decode(n, n.uint32()));
          break;
        }
        case 5: {
          p.useContainerWidth = n.bool();
          break;
        }
        case 6: {
          p.theme = n.string();
          break;
        }
        case 7: {
          p.id = n.string();
          break;
        }
        case 8: {
          p.selectionMode && p.selectionMode.length || (p.selectionMode = []), p.selectionMode.push(n.string());
          break;
        }
        case 9: {
          p.formId = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.spec != null && n.hasOwnProperty("spec") && !$util.isString(n.spec))
      return "spec: string expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      let t = $root.Arrow.verify(n.data);
      if (t)
        return "data." + t;
    }
    if (n.datasets != null && n.hasOwnProperty("datasets")) {
      if (!Array.isArray(n.datasets))
        return "datasets: array expected";
      for (let t = 0; t < n.datasets.length; ++t) {
        let e = $root.ArrowNamedDataSet.verify(n.datasets[t]);
        if (e)
          return "datasets." + e;
      }
    }
    if (n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && typeof n.useContainerWidth != "boolean")
      return "useContainerWidth: boolean expected";
    if (n.theme != null && n.hasOwnProperty("theme") && !$util.isString(n.theme))
      return "theme: string expected";
    if (n.id != null && n.hasOwnProperty("id") && !$util.isString(n.id))
      return "id: string expected";
    if (n.selectionMode != null && n.hasOwnProperty("selectionMode")) {
      if (!Array.isArray(n.selectionMode))
        return "selectionMode: array expected";
      for (let t = 0; t < n.selectionMode.length; ++t)
        if (!$util.isString(n.selectionMode[t]))
          return "selectionMode: string[] expected";
    }
    return n.formId != null && n.hasOwnProperty("formId") && !$util.isString(n.formId) ? "formId: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.ArrowVegaLiteChart)
      return n;
    let t = new $root.ArrowVegaLiteChart();
    if (n.spec != null && (t.spec = String(n.spec)), n.data != null) {
      if (typeof n.data != "object")
        throw TypeError(".ArrowVegaLiteChart.data: object expected");
      t.data = $root.Arrow.fromObject(n.data);
    }
    if (n.datasets) {
      if (!Array.isArray(n.datasets))
        throw TypeError(".ArrowVegaLiteChart.datasets: array expected");
      t.datasets = [];
      for (let e = 0; e < n.datasets.length; ++e) {
        if (typeof n.datasets[e] != "object")
          throw TypeError(".ArrowVegaLiteChart.datasets: object expected");
        t.datasets[e] = $root.ArrowNamedDataSet.fromObject(n.datasets[e]);
      }
    }
    if (n.useContainerWidth != null && (t.useContainerWidth = !!n.useContainerWidth), n.theme != null && (t.theme = String(n.theme)), n.id != null && (t.id = String(n.id)), n.selectionMode) {
      if (!Array.isArray(n.selectionMode))
        throw TypeError(".ArrowVegaLiteChart.selectionMode: array expected");
      t.selectionMode = [];
      for (let e = 0; e < n.selectionMode.length; ++e)
        t.selectionMode[e] = String(n.selectionMode[e]);
    }
    return n.formId != null && (t.formId = String(n.formId)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.datasets = [], e.selectionMode = []), t.defaults && (e.spec = "", e.data = null, e.useContainerWidth = !1, e.theme = "", e.id = "", e.formId = ""), n.spec != null && n.hasOwnProperty("spec") && (e.spec = n.spec), n.data != null && n.hasOwnProperty("data") && (e.data = $root.Arrow.toObject(n.data, t)), n.datasets && n.datasets.length) {
      e.datasets = [];
      for (let o = 0; o < n.datasets.length; ++o)
        e.datasets[o] = $root.ArrowNamedDataSet.toObject(n.datasets[o], t);
    }
    if (n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = n.useContainerWidth), n.theme != null && n.hasOwnProperty("theme") && (e.theme = n.theme), n.id != null && n.hasOwnProperty("id") && (e.id = n.id), n.selectionMode && n.selectionMode.length) {
      e.selectionMode = [];
      for (let o = 0; o < n.selectionMode.length; ++o)
        e.selectionMode[o] = n.selectionMode[o];
    }
    return n.formId != null && n.hasOwnProperty("formId") && (e.formId = n.formId), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/ArrowVegaLiteChart";
  }, r;
})();
$root.Audio = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.url = "", r.prototype.startTime = 0, r.prototype.endTime = 0, r.prototype.loop = !1, r.prototype.autoplay = !1, r.prototype.id = "", r.prototype.widthConfig = null;
  let c;
  return Object.defineProperty(r.prototype, "_widthConfig", {
    get: $util.oneOfGetter(c = ["widthConfig"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.startTime != null && Object.hasOwnProperty.call(t, "startTime") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(t.startTime), t.url != null && Object.hasOwnProperty.call(t, "url") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.url), t.endTime != null && Object.hasOwnProperty.call(t, "endTime") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(t.endTime), t.loop != null && Object.hasOwnProperty.call(t, "loop") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(t.loop), t.autoplay != null && Object.hasOwnProperty.call(t, "autoplay") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.autoplay), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(t.id), t.widthConfig != null && Object.hasOwnProperty.call(t, "widthConfig") && $root.streamlit.WidthConfig.encode(t.widthConfig, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.Audio();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 5: {
          h.url = t.string();
          break;
        }
        case 3: {
          h.startTime = t.int32();
          break;
        }
        case 6: {
          h.endTime = t.int32();
          break;
        }
        case 7: {
          h.loop = t.bool();
          break;
        }
        case 8: {
          h.autoplay = t.bool();
          break;
        }
        case 9: {
          h.id = t.string();
          break;
        }
        case 10: {
          h.widthConfig = $root.streamlit.WidthConfig.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.url != null && t.hasOwnProperty("url") && !$util.isString(t.url))
      return "url: string expected";
    if (t.startTime != null && t.hasOwnProperty("startTime") && !$util.isInteger(t.startTime))
      return "startTime: integer expected";
    if (t.endTime != null && t.hasOwnProperty("endTime") && !$util.isInteger(t.endTime))
      return "endTime: integer expected";
    if (t.loop != null && t.hasOwnProperty("loop") && typeof t.loop != "boolean")
      return "loop: boolean expected";
    if (t.autoplay != null && t.hasOwnProperty("autoplay") && typeof t.autoplay != "boolean")
      return "autoplay: boolean expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.widthConfig != null && t.hasOwnProperty("widthConfig")) {
      let e = $root.streamlit.WidthConfig.verify(t.widthConfig);
      if (e)
        return "widthConfig." + e;
    }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.Audio)
      return t;
    let e = new $root.Audio();
    if (t.url != null && (e.url = String(t.url)), t.startTime != null && (e.startTime = t.startTime | 0), t.endTime != null && (e.endTime = t.endTime | 0), t.loop != null && (e.loop = !!t.loop), t.autoplay != null && (e.autoplay = !!t.autoplay), t.id != null && (e.id = String(t.id)), t.widthConfig != null) {
      if (typeof t.widthConfig != "object")
        throw TypeError(".Audio.widthConfig: object expected");
      e.widthConfig = $root.streamlit.WidthConfig.fromObject(t.widthConfig);
    }
    return e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.startTime = 0, o.url = "", o.endTime = 0, o.loop = !1, o.autoplay = !1, o.id = ""), t.startTime != null && t.hasOwnProperty("startTime") && (o.startTime = t.startTime), t.url != null && t.hasOwnProperty("url") && (o.url = t.url), t.endTime != null && t.hasOwnProperty("endTime") && (o.endTime = t.endTime), t.loop != null && t.hasOwnProperty("loop") && (o.loop = t.loop), t.autoplay != null && t.hasOwnProperty("autoplay") && (o.autoplay = t.autoplay), t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.widthConfig != null && t.hasOwnProperty("widthConfig") && (o.widthConfig = $root.streamlit.WidthConfig.toObject(t.widthConfig, e), e.oneofs && (o._widthConfig = "widthConfig")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Audio";
  }, r;
})();
$root.AudioInput = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.id = "", r.prototype.label = "", r.prototype.help = "", r.prototype.formId = "", r.prototype.disabled = !1, r.prototype.labelVisibility = null, r.prototype.sampleRate = null;
  let c;
  return Object.defineProperty(r.prototype, "_sampleRate", {
    get: $util.oneOfGetter(c = ["sampleRate"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.help != null && Object.hasOwnProperty.call(t, "help") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.help), t.formId != null && Object.hasOwnProperty.call(t, "formId") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.formId), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(t.disabled), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), t.sampleRate != null && Object.hasOwnProperty.call(t, "sampleRate") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(t.sampleRate), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.AudioInput();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.id = t.string();
          break;
        }
        case 2: {
          h.label = t.string();
          break;
        }
        case 3: {
          h.help = t.string();
          break;
        }
        case 4: {
          h.formId = t.string();
          break;
        }
        case 5: {
          h.disabled = t.bool();
          break;
        }
        case 6: {
          h.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        case 7: {
          h.sampleRate = t.int32();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label))
      return "label: string expected";
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help))
      return "help: string expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId))
      return "formId: string expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean")
      return "disabled: boolean expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let e = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (e)
        return "labelVisibility." + e;
    }
    return t.sampleRate != null && t.hasOwnProperty("sampleRate") && !$util.isInteger(t.sampleRate) ? "sampleRate: integer expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.AudioInput)
      return t;
    let e = new $root.AudioInput();
    if (t.id != null && (e.id = String(t.id)), t.label != null && (e.label = String(t.label)), t.help != null && (e.help = String(t.help)), t.formId != null && (e.formId = String(t.formId)), t.disabled != null && (e.disabled = !!t.disabled), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object")
        throw TypeError(".AudioInput.labelVisibility: object expected");
      e.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    return t.sampleRate != null && (e.sampleRate = t.sampleRate | 0), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.id = "", o.label = "", o.help = "", o.formId = "", o.disabled = !1, o.labelVisibility = null), t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.label != null && t.hasOwnProperty("label") && (o.label = t.label), t.help != null && t.hasOwnProperty("help") && (o.help = t.help), t.formId != null && t.hasOwnProperty("formId") && (o.formId = t.formId), t.disabled != null && t.hasOwnProperty("disabled") && (o.disabled = t.disabled), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (o.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, e)), t.sampleRate != null && t.hasOwnProperty("sampleRate") && (o.sampleRate = t.sampleRate, e.oneofs && (o._sampleRate = "sampleRate")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/AudioInput";
  }, r;
})();
$root.LabelVisibilityMessage = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.value = 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.value != null && Object.hasOwnProperty.call(n, "value") && t.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(n.value), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.LabelVisibilityMessage();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.value = n.int32();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.value != null && n.hasOwnProperty("value"))
      switch (n.value) {
        default:
          return "value: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.LabelVisibilityMessage)
      return n;
    let t = new $root.LabelVisibilityMessage();
    switch (n.value) {
      default:
        if (typeof n.value == "number") {
          t.value = n.value;
          break;
        }
        break;
      case "VISIBLE":
      case 0:
        t.value = 0;
        break;
      case "HIDDEN":
      case 1:
        t.value = 1;
        break;
      case "COLLAPSED":
      case 2:
        t.value = 2;
        break;
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.value = t.enums === String ? "VISIBLE" : 0), n.value != null && n.hasOwnProperty("value") && (e.value = t.enums === String ? $root.LabelVisibilityMessage.LabelVisibilityOptions[n.value] === void 0 ? n.value : $root.LabelVisibilityMessage.LabelVisibilityOptions[n.value] : n.value), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/LabelVisibilityMessage";
  }, r.LabelVisibilityOptions = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "VISIBLE"] = 0, n[c[1] = "HIDDEN"] = 1, n[c[2] = "COLLAPSED"] = 2, n;
  })(), r;
})();
$root.AuthRedirect = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.url = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.url != null && Object.hasOwnProperty.call(n, "url") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.url), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.AuthRedirect();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.url = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.url != null && n.hasOwnProperty("url") && !$util.isString(n.url) ? "url: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.AuthRedirect)
      return n;
    let t = new $root.AuthRedirect();
    return n.url != null && (t.url = String(n.url)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.url = ""), n.url != null && n.hasOwnProperty("url") && (e.url = n.url), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/AuthRedirect";
  }, r;
})();
$root.AutoRerun = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.interval = 0, r.prototype.fragmentId = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.interval != null && Object.hasOwnProperty.call(n, "interval") && t.uint32(
      /* id 1, wireType 5 =*/
      13
    ).float(n.interval), n.fragmentId != null && Object.hasOwnProperty.call(n, "fragmentId") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.fragmentId), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.AutoRerun();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.interval = n.float();
          break;
        }
        case 2: {
          p.fragmentId = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.interval != null && n.hasOwnProperty("interval") && typeof n.interval != "number" ? "interval: number expected" : n.fragmentId != null && n.hasOwnProperty("fragmentId") && !$util.isString(n.fragmentId) ? "fragmentId: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.AutoRerun)
      return n;
    let t = new $root.AutoRerun();
    return n.interval != null && (t.interval = Number(n.interval)), n.fragmentId != null && (t.fragmentId = String(n.fragmentId)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.interval = 0, e.fragmentId = ""), n.interval != null && n.hasOwnProperty("interval") && (e.interval = t.json && !isFinite(n.interval) ? String(n.interval) : n.interval), n.fragmentId != null && n.hasOwnProperty("fragmentId") && (e.fragmentId = n.fragmentId), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/AutoRerun";
  }, r;
})();
const BackMsg = $root.BackMsg = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.clearCache = null, r.prototype.setRunOnSave = null, r.prototype.stopScript = null, r.prototype.rerunScript = null, r.prototype.loadGitInfo = null, r.prototype.debugDisconnectWebsocket = null, r.prototype.debugShutdownRuntime = null, r.prototype.fileUrlsRequest = null, r.prototype.appHeartbeat = null, r.prototype.debugLastBackmsgId = "";
  let c;
  return Object.defineProperty(r.prototype, "type", {
    get: $util.oneOfGetter(c = ["clearCache", "setRunOnSave", "stopScript", "rerunScript", "loadGitInfo", "debugDisconnectWebsocket", "debugShutdownRuntime", "fileUrlsRequest", "appHeartbeat"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.clearCache != null && Object.hasOwnProperty.call(t, "clearCache") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(t.clearCache), t.setRunOnSave != null && Object.hasOwnProperty.call(t, "setRunOnSave") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(t.setRunOnSave), t.stopScript != null && Object.hasOwnProperty.call(t, "stopScript") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(t.stopScript), t.rerunScript != null && Object.hasOwnProperty.call(t, "rerunScript") && $root.ClientState.encode(t.rerunScript, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), t.loadGitInfo != null && Object.hasOwnProperty.call(t, "loadGitInfo") && e.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(t.loadGitInfo), t.debugLastBackmsgId != null && Object.hasOwnProperty.call(t, "debugLastBackmsgId") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(t.debugLastBackmsgId), t.debugDisconnectWebsocket != null && Object.hasOwnProperty.call(t, "debugDisconnectWebsocket") && e.uint32(
      /* id 14, wireType 0 =*/
      112
    ).bool(t.debugDisconnectWebsocket), t.debugShutdownRuntime != null && Object.hasOwnProperty.call(t, "debugShutdownRuntime") && e.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(t.debugShutdownRuntime), t.fileUrlsRequest != null && Object.hasOwnProperty.call(t, "fileUrlsRequest") && $root.FileURLsRequest.encode(t.fileUrlsRequest, e.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), t.appHeartbeat != null && Object.hasOwnProperty.call(t, "appHeartbeat") && e.uint32(
      /* id 17, wireType 0 =*/
      136
    ).bool(t.appHeartbeat), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.BackMsg();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 5: {
          h.clearCache = t.bool();
          break;
        }
        case 6: {
          h.setRunOnSave = t.bool();
          break;
        }
        case 7: {
          h.stopScript = t.bool();
          break;
        }
        case 11: {
          h.rerunScript = $root.ClientState.decode(t, t.uint32());
          break;
        }
        case 12: {
          h.loadGitInfo = t.bool();
          break;
        }
        case 14: {
          h.debugDisconnectWebsocket = t.bool();
          break;
        }
        case 15: {
          h.debugShutdownRuntime = t.bool();
          break;
        }
        case 16: {
          h.fileUrlsRequest = $root.FileURLsRequest.decode(t, t.uint32());
          break;
        }
        case 17: {
          h.appHeartbeat = t.bool();
          break;
        }
        case 13: {
          h.debugLastBackmsgId = t.string();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    let e = {};
    if (t.clearCache != null && t.hasOwnProperty("clearCache") && (e.type = 1, typeof t.clearCache != "boolean"))
      return "clearCache: boolean expected";
    if (t.setRunOnSave != null && t.hasOwnProperty("setRunOnSave")) {
      if (e.type === 1)
        return "type: multiple values";
      if (e.type = 1, typeof t.setRunOnSave != "boolean")
        return "setRunOnSave: boolean expected";
    }
    if (t.stopScript != null && t.hasOwnProperty("stopScript")) {
      if (e.type === 1)
        return "type: multiple values";
      if (e.type = 1, typeof t.stopScript != "boolean")
        return "stopScript: boolean expected";
    }
    if (t.rerunScript != null && t.hasOwnProperty("rerunScript")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.ClientState.verify(t.rerunScript);
        if (o)
          return "rerunScript." + o;
      }
    }
    if (t.loadGitInfo != null && t.hasOwnProperty("loadGitInfo")) {
      if (e.type === 1)
        return "type: multiple values";
      if (e.type = 1, typeof t.loadGitInfo != "boolean")
        return "loadGitInfo: boolean expected";
    }
    if (t.debugDisconnectWebsocket != null && t.hasOwnProperty("debugDisconnectWebsocket")) {
      if (e.type === 1)
        return "type: multiple values";
      if (e.type = 1, typeof t.debugDisconnectWebsocket != "boolean")
        return "debugDisconnectWebsocket: boolean expected";
    }
    if (t.debugShutdownRuntime != null && t.hasOwnProperty("debugShutdownRuntime")) {
      if (e.type === 1)
        return "type: multiple values";
      if (e.type = 1, typeof t.debugShutdownRuntime != "boolean")
        return "debugShutdownRuntime: boolean expected";
    }
    if (t.fileUrlsRequest != null && t.hasOwnProperty("fileUrlsRequest")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.FileURLsRequest.verify(t.fileUrlsRequest);
        if (o)
          return "fileUrlsRequest." + o;
      }
    }
    if (t.appHeartbeat != null && t.hasOwnProperty("appHeartbeat")) {
      if (e.type === 1)
        return "type: multiple values";
      if (e.type = 1, typeof t.appHeartbeat != "boolean")
        return "appHeartbeat: boolean expected";
    }
    return t.debugLastBackmsgId != null && t.hasOwnProperty("debugLastBackmsgId") && !$util.isString(t.debugLastBackmsgId) ? "debugLastBackmsgId: string expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.BackMsg)
      return t;
    let e = new $root.BackMsg();
    if (t.clearCache != null && (e.clearCache = !!t.clearCache), t.setRunOnSave != null && (e.setRunOnSave = !!t.setRunOnSave), t.stopScript != null && (e.stopScript = !!t.stopScript), t.rerunScript != null) {
      if (typeof t.rerunScript != "object")
        throw TypeError(".BackMsg.rerunScript: object expected");
      e.rerunScript = $root.ClientState.fromObject(t.rerunScript);
    }
    if (t.loadGitInfo != null && (e.loadGitInfo = !!t.loadGitInfo), t.debugDisconnectWebsocket != null && (e.debugDisconnectWebsocket = !!t.debugDisconnectWebsocket), t.debugShutdownRuntime != null && (e.debugShutdownRuntime = !!t.debugShutdownRuntime), t.fileUrlsRequest != null) {
      if (typeof t.fileUrlsRequest != "object")
        throw TypeError(".BackMsg.fileUrlsRequest: object expected");
      e.fileUrlsRequest = $root.FileURLsRequest.fromObject(t.fileUrlsRequest);
    }
    return t.appHeartbeat != null && (e.appHeartbeat = !!t.appHeartbeat), t.debugLastBackmsgId != null && (e.debugLastBackmsgId = String(t.debugLastBackmsgId)), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.debugLastBackmsgId = ""), t.clearCache != null && t.hasOwnProperty("clearCache") && (o.clearCache = t.clearCache, e.oneofs && (o.type = "clearCache")), t.setRunOnSave != null && t.hasOwnProperty("setRunOnSave") && (o.setRunOnSave = t.setRunOnSave, e.oneofs && (o.type = "setRunOnSave")), t.stopScript != null && t.hasOwnProperty("stopScript") && (o.stopScript = t.stopScript, e.oneofs && (o.type = "stopScript")), t.rerunScript != null && t.hasOwnProperty("rerunScript") && (o.rerunScript = $root.ClientState.toObject(t.rerunScript, e), e.oneofs && (o.type = "rerunScript")), t.loadGitInfo != null && t.hasOwnProperty("loadGitInfo") && (o.loadGitInfo = t.loadGitInfo, e.oneofs && (o.type = "loadGitInfo")), t.debugLastBackmsgId != null && t.hasOwnProperty("debugLastBackmsgId") && (o.debugLastBackmsgId = t.debugLastBackmsgId), t.debugDisconnectWebsocket != null && t.hasOwnProperty("debugDisconnectWebsocket") && (o.debugDisconnectWebsocket = t.debugDisconnectWebsocket, e.oneofs && (o.type = "debugDisconnectWebsocket")), t.debugShutdownRuntime != null && t.hasOwnProperty("debugShutdownRuntime") && (o.debugShutdownRuntime = t.debugShutdownRuntime, e.oneofs && (o.type = "debugShutdownRuntime")), t.fileUrlsRequest != null && t.hasOwnProperty("fileUrlsRequest") && (o.fileUrlsRequest = $root.FileURLsRequest.toObject(t.fileUrlsRequest, e), e.oneofs && (o.type = "fileUrlsRequest")), t.appHeartbeat != null && t.hasOwnProperty("appHeartbeat") && (o.appHeartbeat = t.appHeartbeat, e.oneofs && (o.type = "appHeartbeat")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/BackMsg";
  }, r;
})();
$root.ContextInfo = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.timezone = null, r.prototype.timezoneOffset = null, r.prototype.locale = null, r.prototype.url = null, r.prototype.isEmbedded = null, r.prototype.colorScheme = null;
  let c;
  return Object.defineProperty(r.prototype, "_timezone", {
    get: $util.oneOfGetter(c = ["timezone"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_timezoneOffset", {
    get: $util.oneOfGetter(c = ["timezoneOffset"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_locale", {
    get: $util.oneOfGetter(c = ["locale"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_url", {
    get: $util.oneOfGetter(c = ["url"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_isEmbedded", {
    get: $util.oneOfGetter(c = ["isEmbedded"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_colorScheme", {
    get: $util.oneOfGetter(c = ["colorScheme"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.timezone != null && Object.hasOwnProperty.call(t, "timezone") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.timezone), t.timezoneOffset != null && Object.hasOwnProperty.call(t, "timezoneOffset") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(t.timezoneOffset), t.locale != null && Object.hasOwnProperty.call(t, "locale") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.locale), t.url != null && Object.hasOwnProperty.call(t, "url") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.url), t.isEmbedded != null && Object.hasOwnProperty.call(t, "isEmbedded") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(t.isEmbedded), t.colorScheme != null && Object.hasOwnProperty.call(t, "colorScheme") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.colorScheme), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.ContextInfo();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.timezone = t.string();
          break;
        }
        case 2: {
          h.timezoneOffset = t.int32();
          break;
        }
        case 3: {
          h.locale = t.string();
          break;
        }
        case 4: {
          h.url = t.string();
          break;
        }
        case 5: {
          h.isEmbedded = t.bool();
          break;
        }
        case 6: {
          h.colorScheme = t.string();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.timezone != null && t.hasOwnProperty("timezone") && !$util.isString(t.timezone) ? "timezone: string expected" : t.timezoneOffset != null && t.hasOwnProperty("timezoneOffset") && !$util.isInteger(t.timezoneOffset) ? "timezoneOffset: integer expected" : t.locale != null && t.hasOwnProperty("locale") && !$util.isString(t.locale) ? "locale: string expected" : t.url != null && t.hasOwnProperty("url") && !$util.isString(t.url) ? "url: string expected" : t.isEmbedded != null && t.hasOwnProperty("isEmbedded") && typeof t.isEmbedded != "boolean" ? "isEmbedded: boolean expected" : t.colorScheme != null && t.hasOwnProperty("colorScheme") && !$util.isString(t.colorScheme) ? "colorScheme: string expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.ContextInfo)
      return t;
    let e = new $root.ContextInfo();
    return t.timezone != null && (e.timezone = String(t.timezone)), t.timezoneOffset != null && (e.timezoneOffset = t.timezoneOffset | 0), t.locale != null && (e.locale = String(t.locale)), t.url != null && (e.url = String(t.url)), t.isEmbedded != null && (e.isEmbedded = !!t.isEmbedded), t.colorScheme != null && (e.colorScheme = String(t.colorScheme)), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return t.timezone != null && t.hasOwnProperty("timezone") && (o.timezone = t.timezone, e.oneofs && (o._timezone = "timezone")), t.timezoneOffset != null && t.hasOwnProperty("timezoneOffset") && (o.timezoneOffset = t.timezoneOffset, e.oneofs && (o._timezoneOffset = "timezoneOffset")), t.locale != null && t.hasOwnProperty("locale") && (o.locale = t.locale, e.oneofs && (o._locale = "locale")), t.url != null && t.hasOwnProperty("url") && (o.url = t.url, e.oneofs && (o._url = "url")), t.isEmbedded != null && t.hasOwnProperty("isEmbedded") && (o.isEmbedded = t.isEmbedded, e.oneofs && (o._isEmbedded = "isEmbedded")), t.colorScheme != null && t.hasOwnProperty("colorScheme") && (o.colorScheme = t.colorScheme, e.oneofs && (o._colorScheme = "colorScheme")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ContextInfo";
  }, r;
})();
$root.ClientState = (() => {
  function r(c) {
    if (this.cachedMessageHashes = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.queryString = "", r.prototype.widgetStates = null, r.prototype.pageScriptHash = "", r.prototype.pageName = "", r.prototype.fragmentId = "", r.prototype.isAutoRerun = !1, r.prototype.cachedMessageHashes = $util.emptyArray, r.prototype.contextInfo = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.queryString != null && Object.hasOwnProperty.call(n, "queryString") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.queryString), n.widgetStates != null && Object.hasOwnProperty.call(n, "widgetStates") && $root.WidgetStates.encode(n.widgetStates, t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), n.pageScriptHash != null && Object.hasOwnProperty.call(n, "pageScriptHash") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.pageScriptHash), n.pageName != null && Object.hasOwnProperty.call(n, "pageName") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.pageName), n.fragmentId != null && Object.hasOwnProperty.call(n, "fragmentId") && t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(n.fragmentId), n.isAutoRerun != null && Object.hasOwnProperty.call(n, "isAutoRerun") && t.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(n.isAutoRerun), n.cachedMessageHashes != null && n.cachedMessageHashes.length)
      for (let e = 0; e < n.cachedMessageHashes.length; ++e)
        t.uint32(
          /* id 7, wireType 2 =*/
          58
        ).string(n.cachedMessageHashes[e]);
    return n.contextInfo != null && Object.hasOwnProperty.call(n, "contextInfo") && $root.ContextInfo.encode(n.contextInfo, t.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.ClientState();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.queryString = n.string();
          break;
        }
        case 2: {
          p.widgetStates = $root.WidgetStates.decode(n, n.uint32());
          break;
        }
        case 3: {
          p.pageScriptHash = n.string();
          break;
        }
        case 4: {
          p.pageName = n.string();
          break;
        }
        case 5: {
          p.fragmentId = n.string();
          break;
        }
        case 6: {
          p.isAutoRerun = n.bool();
          break;
        }
        case 7: {
          p.cachedMessageHashes && p.cachedMessageHashes.length || (p.cachedMessageHashes = []), p.cachedMessageHashes.push(n.string());
          break;
        }
        case 8: {
          p.contextInfo = $root.ContextInfo.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.queryString != null && n.hasOwnProperty("queryString") && !$util.isString(n.queryString))
      return "queryString: string expected";
    if (n.widgetStates != null && n.hasOwnProperty("widgetStates")) {
      let t = $root.WidgetStates.verify(n.widgetStates);
      if (t)
        return "widgetStates." + t;
    }
    if (n.pageScriptHash != null && n.hasOwnProperty("pageScriptHash") && !$util.isString(n.pageScriptHash))
      return "pageScriptHash: string expected";
    if (n.pageName != null && n.hasOwnProperty("pageName") && !$util.isString(n.pageName))
      return "pageName: string expected";
    if (n.fragmentId != null && n.hasOwnProperty("fragmentId") && !$util.isString(n.fragmentId))
      return "fragmentId: string expected";
    if (n.isAutoRerun != null && n.hasOwnProperty("isAutoRerun") && typeof n.isAutoRerun != "boolean")
      return "isAutoRerun: boolean expected";
    if (n.cachedMessageHashes != null && n.hasOwnProperty("cachedMessageHashes")) {
      if (!Array.isArray(n.cachedMessageHashes))
        return "cachedMessageHashes: array expected";
      for (let t = 0; t < n.cachedMessageHashes.length; ++t)
        if (!$util.isString(n.cachedMessageHashes[t]))
          return "cachedMessageHashes: string[] expected";
    }
    if (n.contextInfo != null && n.hasOwnProperty("contextInfo")) {
      let t = $root.ContextInfo.verify(n.contextInfo);
      if (t)
        return "contextInfo." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.ClientState)
      return n;
    let t = new $root.ClientState();
    if (n.queryString != null && (t.queryString = String(n.queryString)), n.widgetStates != null) {
      if (typeof n.widgetStates != "object")
        throw TypeError(".ClientState.widgetStates: object expected");
      t.widgetStates = $root.WidgetStates.fromObject(n.widgetStates);
    }
    if (n.pageScriptHash != null && (t.pageScriptHash = String(n.pageScriptHash)), n.pageName != null && (t.pageName = String(n.pageName)), n.fragmentId != null && (t.fragmentId = String(n.fragmentId)), n.isAutoRerun != null && (t.isAutoRerun = !!n.isAutoRerun), n.cachedMessageHashes) {
      if (!Array.isArray(n.cachedMessageHashes))
        throw TypeError(".ClientState.cachedMessageHashes: array expected");
      t.cachedMessageHashes = [];
      for (let e = 0; e < n.cachedMessageHashes.length; ++e)
        t.cachedMessageHashes[e] = String(n.cachedMessageHashes[e]);
    }
    if (n.contextInfo != null) {
      if (typeof n.contextInfo != "object")
        throw TypeError(".ClientState.contextInfo: object expected");
      t.contextInfo = $root.ContextInfo.fromObject(n.contextInfo);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.cachedMessageHashes = []), t.defaults && (e.queryString = "", e.widgetStates = null, e.pageScriptHash = "", e.pageName = "", e.fragmentId = "", e.isAutoRerun = !1, e.contextInfo = null), n.queryString != null && n.hasOwnProperty("queryString") && (e.queryString = n.queryString), n.widgetStates != null && n.hasOwnProperty("widgetStates") && (e.widgetStates = $root.WidgetStates.toObject(n.widgetStates, t)), n.pageScriptHash != null && n.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = n.pageScriptHash), n.pageName != null && n.hasOwnProperty("pageName") && (e.pageName = n.pageName), n.fragmentId != null && n.hasOwnProperty("fragmentId") && (e.fragmentId = n.fragmentId), n.isAutoRerun != null && n.hasOwnProperty("isAutoRerun") && (e.isAutoRerun = n.isAutoRerun), n.cachedMessageHashes && n.cachedMessageHashes.length) {
      e.cachedMessageHashes = [];
      for (let o = 0; o < n.cachedMessageHashes.length; ++o)
        e.cachedMessageHashes[o] = n.cachedMessageHashes[o];
    }
    return n.contextInfo != null && n.hasOwnProperty("contextInfo") && (e.contextInfo = $root.ContextInfo.toObject(n.contextInfo, t)), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/ClientState";
  }, r;
})();
$root.WidgetStates = (() => {
  function r(c) {
    if (this.widgets = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.widgets = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.widgets != null && n.widgets.length)
      for (let e = 0; e < n.widgets.length; ++e)
        $root.WidgetState.encode(n.widgets[e], t.uint32(
          /* id 1, wireType 2 =*/
          10
        ).fork()).ldelim();
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.WidgetStates();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.widgets && p.widgets.length || (p.widgets = []), p.widgets.push($root.WidgetState.decode(n, n.uint32()));
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.widgets != null && n.hasOwnProperty("widgets")) {
      if (!Array.isArray(n.widgets))
        return "widgets: array expected";
      for (let t = 0; t < n.widgets.length; ++t) {
        let e = $root.WidgetState.verify(n.widgets[t]);
        if (e)
          return "widgets." + e;
      }
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.WidgetStates)
      return n;
    let t = new $root.WidgetStates();
    if (n.widgets) {
      if (!Array.isArray(n.widgets))
        throw TypeError(".WidgetStates.widgets: array expected");
      t.widgets = [];
      for (let e = 0; e < n.widgets.length; ++e) {
        if (typeof n.widgets[e] != "object")
          throw TypeError(".WidgetStates.widgets: object expected");
        t.widgets[e] = $root.WidgetState.fromObject(n.widgets[e]);
      }
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.widgets = []), n.widgets && n.widgets.length) {
      e.widgets = [];
      for (let o = 0; o < n.widgets.length; ++o)
        e.widgets[o] = $root.WidgetState.toObject(n.widgets[o], t);
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/WidgetStates";
  }, r;
})();
$root.WidgetState = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.id = "", r.prototype.triggerValue = null, r.prototype.boolValue = null, r.prototype.doubleValue = null, r.prototype.intValue = null, r.prototype.stringValue = null, r.prototype.doubleArrayValue = null, r.prototype.intArrayValue = null, r.prototype.stringArrayValue = null, r.prototype.jsonValue = null, r.prototype.arrowValue = null, r.prototype.bytesValue = null, r.prototype.fileUploaderStateValue = null, r.prototype.stringTriggerValue = null, r.prototype.chatInputValue = null;
  let c;
  return Object.defineProperty(r.prototype, "value", {
    get: $util.oneOfGetter(c = ["triggerValue", "boolValue", "doubleValue", "intValue", "stringValue", "doubleArrayValue", "intArrayValue", "stringArrayValue", "jsonValue", "arrowValue", "bytesValue", "fileUploaderStateValue", "stringTriggerValue", "chatInputValue"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.triggerValue != null && Object.hasOwnProperty.call(t, "triggerValue") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(t.triggerValue), t.boolValue != null && Object.hasOwnProperty.call(t, "boolValue") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(t.boolValue), t.doubleValue != null && Object.hasOwnProperty.call(t, "doubleValue") && e.uint32(
      /* id 4, wireType 1 =*/
      33
    ).double(t.doubleValue), t.intValue != null && Object.hasOwnProperty.call(t, "intValue") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).sint64(t.intValue), t.stringValue != null && Object.hasOwnProperty.call(t, "stringValue") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.stringValue), t.doubleArrayValue != null && Object.hasOwnProperty.call(t, "doubleArrayValue") && $root.DoubleArray.encode(t.doubleArrayValue, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), t.intArrayValue != null && Object.hasOwnProperty.call(t, "intArrayValue") && $root.SInt64Array.encode(t.intArrayValue, e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), t.stringArrayValue != null && Object.hasOwnProperty.call(t, "stringArrayValue") && $root.StringArray.encode(t.stringArrayValue, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), t.jsonValue != null && Object.hasOwnProperty.call(t, "jsonValue") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(t.jsonValue), t.arrowValue != null && Object.hasOwnProperty.call(t, "arrowValue") && $root.ArrowTable.encode(t.arrowValue, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), t.bytesValue != null && Object.hasOwnProperty.call(t, "bytesValue") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).bytes(t.bytesValue), t.fileUploaderStateValue != null && Object.hasOwnProperty.call(t, "fileUploaderStateValue") && $root.FileUploaderState.encode(t.fileUploaderStateValue, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), t.stringTriggerValue != null && Object.hasOwnProperty.call(t, "stringTriggerValue") && $root.StringTriggerValue.encode(t.stringTriggerValue, e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), t.chatInputValue != null && Object.hasOwnProperty.call(t, "chatInputValue") && $root.ChatInputValue.encode(t.chatInputValue, e.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.WidgetState();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.id = t.string();
          break;
        }
        case 2: {
          h.triggerValue = t.bool();
          break;
        }
        case 3: {
          h.boolValue = t.bool();
          break;
        }
        case 4: {
          h.doubleValue = t.double();
          break;
        }
        case 5: {
          h.intValue = t.sint64();
          break;
        }
        case 6: {
          h.stringValue = t.string();
          break;
        }
        case 7: {
          h.doubleArrayValue = $root.DoubleArray.decode(t, t.uint32());
          break;
        }
        case 8: {
          h.intArrayValue = $root.SInt64Array.decode(t, t.uint32());
          break;
        }
        case 9: {
          h.stringArrayValue = $root.StringArray.decode(t, t.uint32());
          break;
        }
        case 10: {
          h.jsonValue = t.string();
          break;
        }
        case 11: {
          h.arrowValue = $root.ArrowTable.decode(t, t.uint32());
          break;
        }
        case 12: {
          h.bytesValue = t.bytes();
          break;
        }
        case 13: {
          h.fileUploaderStateValue = $root.FileUploaderState.decode(t, t.uint32());
          break;
        }
        case 14: {
          h.stringTriggerValue = $root.StringTriggerValue.decode(t, t.uint32());
          break;
        }
        case 15: {
          h.chatInputValue = $root.ChatInputValue.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    let e = {};
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.triggerValue != null && t.hasOwnProperty("triggerValue") && (e.value = 1, typeof t.triggerValue != "boolean"))
      return "triggerValue: boolean expected";
    if (t.boolValue != null && t.hasOwnProperty("boolValue")) {
      if (e.value === 1)
        return "value: multiple values";
      if (e.value = 1, typeof t.boolValue != "boolean")
        return "boolValue: boolean expected";
    }
    if (t.doubleValue != null && t.hasOwnProperty("doubleValue")) {
      if (e.value === 1)
        return "value: multiple values";
      if (e.value = 1, typeof t.doubleValue != "number")
        return "doubleValue: number expected";
    }
    if (t.intValue != null && t.hasOwnProperty("intValue")) {
      if (e.value === 1)
        return "value: multiple values";
      if (e.value = 1, !$util.isInteger(t.intValue) && !(t.intValue && $util.isInteger(t.intValue.low) && $util.isInteger(t.intValue.high)))
        return "intValue: integer|Long expected";
    }
    if (t.stringValue != null && t.hasOwnProperty("stringValue")) {
      if (e.value === 1)
        return "value: multiple values";
      if (e.value = 1, !$util.isString(t.stringValue))
        return "stringValue: string expected";
    }
    if (t.doubleArrayValue != null && t.hasOwnProperty("doubleArrayValue")) {
      if (e.value === 1)
        return "value: multiple values";
      e.value = 1;
      {
        let o = $root.DoubleArray.verify(t.doubleArrayValue);
        if (o)
          return "doubleArrayValue." + o;
      }
    }
    if (t.intArrayValue != null && t.hasOwnProperty("intArrayValue")) {
      if (e.value === 1)
        return "value: multiple values";
      e.value = 1;
      {
        let o = $root.SInt64Array.verify(t.intArrayValue);
        if (o)
          return "intArrayValue." + o;
      }
    }
    if (t.stringArrayValue != null && t.hasOwnProperty("stringArrayValue")) {
      if (e.value === 1)
        return "value: multiple values";
      e.value = 1;
      {
        let o = $root.StringArray.verify(t.stringArrayValue);
        if (o)
          return "stringArrayValue." + o;
      }
    }
    if (t.jsonValue != null && t.hasOwnProperty("jsonValue")) {
      if (e.value === 1)
        return "value: multiple values";
      if (e.value = 1, !$util.isString(t.jsonValue))
        return "jsonValue: string expected";
    }
    if (t.arrowValue != null && t.hasOwnProperty("arrowValue")) {
      if (e.value === 1)
        return "value: multiple values";
      e.value = 1;
      {
        let o = $root.ArrowTable.verify(t.arrowValue);
        if (o)
          return "arrowValue." + o;
      }
    }
    if (t.bytesValue != null && t.hasOwnProperty("bytesValue")) {
      if (e.value === 1)
        return "value: multiple values";
      if (e.value = 1, !(t.bytesValue && typeof t.bytesValue.length == "number" || $util.isString(t.bytesValue)))
        return "bytesValue: buffer expected";
    }
    if (t.fileUploaderStateValue != null && t.hasOwnProperty("fileUploaderStateValue")) {
      if (e.value === 1)
        return "value: multiple values";
      e.value = 1;
      {
        let o = $root.FileUploaderState.verify(t.fileUploaderStateValue);
        if (o)
          return "fileUploaderStateValue." + o;
      }
    }
    if (t.stringTriggerValue != null && t.hasOwnProperty("stringTriggerValue")) {
      if (e.value === 1)
        return "value: multiple values";
      e.value = 1;
      {
        let o = $root.StringTriggerValue.verify(t.stringTriggerValue);
        if (o)
          return "stringTriggerValue." + o;
      }
    }
    if (t.chatInputValue != null && t.hasOwnProperty("chatInputValue")) {
      if (e.value === 1)
        return "value: multiple values";
      e.value = 1;
      {
        let o = $root.ChatInputValue.verify(t.chatInputValue);
        if (o)
          return "chatInputValue." + o;
      }
    }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.WidgetState)
      return t;
    let e = new $root.WidgetState();
    if (t.id != null && (e.id = String(t.id)), t.triggerValue != null && (e.triggerValue = !!t.triggerValue), t.boolValue != null && (e.boolValue = !!t.boolValue), t.doubleValue != null && (e.doubleValue = Number(t.doubleValue)), t.intValue != null && ($util.Long ? (e.intValue = $util.Long.fromValue(t.intValue)).unsigned = !1 : typeof t.intValue == "string" ? e.intValue = parseInt(t.intValue, 10) : typeof t.intValue == "number" ? e.intValue = t.intValue : typeof t.intValue == "object" && (e.intValue = new $util.LongBits(t.intValue.low >>> 0, t.intValue.high >>> 0).toNumber())), t.stringValue != null && (e.stringValue = String(t.stringValue)), t.doubleArrayValue != null) {
      if (typeof t.doubleArrayValue != "object")
        throw TypeError(".WidgetState.doubleArrayValue: object expected");
      e.doubleArrayValue = $root.DoubleArray.fromObject(t.doubleArrayValue);
    }
    if (t.intArrayValue != null) {
      if (typeof t.intArrayValue != "object")
        throw TypeError(".WidgetState.intArrayValue: object expected");
      e.intArrayValue = $root.SInt64Array.fromObject(t.intArrayValue);
    }
    if (t.stringArrayValue != null) {
      if (typeof t.stringArrayValue != "object")
        throw TypeError(".WidgetState.stringArrayValue: object expected");
      e.stringArrayValue = $root.StringArray.fromObject(t.stringArrayValue);
    }
    if (t.jsonValue != null && (e.jsonValue = String(t.jsonValue)), t.arrowValue != null) {
      if (typeof t.arrowValue != "object")
        throw TypeError(".WidgetState.arrowValue: object expected");
      e.arrowValue = $root.ArrowTable.fromObject(t.arrowValue);
    }
    if (t.bytesValue != null && (typeof t.bytesValue == "string" ? $util.base64.decode(t.bytesValue, e.bytesValue = $util.newBuffer($util.base64.length(t.bytesValue)), 0) : t.bytesValue.length >= 0 && (e.bytesValue = t.bytesValue)), t.fileUploaderStateValue != null) {
      if (typeof t.fileUploaderStateValue != "object")
        throw TypeError(".WidgetState.fileUploaderStateValue: object expected");
      e.fileUploaderStateValue = $root.FileUploaderState.fromObject(t.fileUploaderStateValue);
    }
    if (t.stringTriggerValue != null) {
      if (typeof t.stringTriggerValue != "object")
        throw TypeError(".WidgetState.stringTriggerValue: object expected");
      e.stringTriggerValue = $root.StringTriggerValue.fromObject(t.stringTriggerValue);
    }
    if (t.chatInputValue != null) {
      if (typeof t.chatInputValue != "object")
        throw TypeError(".WidgetState.chatInputValue: object expected");
      e.chatInputValue = $root.ChatInputValue.fromObject(t.chatInputValue);
    }
    return e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.id = ""), t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.triggerValue != null && t.hasOwnProperty("triggerValue") && (o.triggerValue = t.triggerValue, e.oneofs && (o.value = "triggerValue")), t.boolValue != null && t.hasOwnProperty("boolValue") && (o.boolValue = t.boolValue, e.oneofs && (o.value = "boolValue")), t.doubleValue != null && t.hasOwnProperty("doubleValue") && (o.doubleValue = e.json && !isFinite(t.doubleValue) ? String(t.doubleValue) : t.doubleValue, e.oneofs && (o.value = "doubleValue")), t.intValue != null && t.hasOwnProperty("intValue") && (typeof t.intValue == "number" ? o.intValue = e.longs === String ? String(t.intValue) : t.intValue : o.intValue = e.longs === String ? $util.Long.prototype.toString.call(t.intValue) : e.longs === Number ? new $util.LongBits(t.intValue.low >>> 0, t.intValue.high >>> 0).toNumber() : t.intValue, e.oneofs && (o.value = "intValue")), t.stringValue != null && t.hasOwnProperty("stringValue") && (o.stringValue = t.stringValue, e.oneofs && (o.value = "stringValue")), t.doubleArrayValue != null && t.hasOwnProperty("doubleArrayValue") && (o.doubleArrayValue = $root.DoubleArray.toObject(t.doubleArrayValue, e), e.oneofs && (o.value = "doubleArrayValue")), t.intArrayValue != null && t.hasOwnProperty("intArrayValue") && (o.intArrayValue = $root.SInt64Array.toObject(t.intArrayValue, e), e.oneofs && (o.value = "intArrayValue")), t.stringArrayValue != null && t.hasOwnProperty("stringArrayValue") && (o.stringArrayValue = $root.StringArray.toObject(t.stringArrayValue, e), e.oneofs && (o.value = "stringArrayValue")), t.jsonValue != null && t.hasOwnProperty("jsonValue") && (o.jsonValue = t.jsonValue, e.oneofs && (o.value = "jsonValue")), t.arrowValue != null && t.hasOwnProperty("arrowValue") && (o.arrowValue = $root.ArrowTable.toObject(t.arrowValue, e), e.oneofs && (o.value = "arrowValue")), t.bytesValue != null && t.hasOwnProperty("bytesValue") && (o.bytesValue = e.bytes === String ? $util.base64.encode(t.bytesValue, 0, t.bytesValue.length) : e.bytes === Array ? Array.prototype.slice.call(t.bytesValue) : t.bytesValue, e.oneofs && (o.value = "bytesValue")), t.fileUploaderStateValue != null && t.hasOwnProperty("fileUploaderStateValue") && (o.fileUploaderStateValue = $root.FileUploaderState.toObject(t.fileUploaderStateValue, e), e.oneofs && (o.value = "fileUploaderStateValue")), t.stringTriggerValue != null && t.hasOwnProperty("stringTriggerValue") && (o.stringTriggerValue = $root.StringTriggerValue.toObject(t.stringTriggerValue, e), e.oneofs && (o.value = "stringTriggerValue")), t.chatInputValue != null && t.hasOwnProperty("chatInputValue") && (o.chatInputValue = $root.ChatInputValue.toObject(t.chatInputValue, e), e.oneofs && (o.value = "chatInputValue")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/WidgetState";
  }, r;
})();
$root.StringArray = (() => {
  function r(c) {
    if (this.data = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.data = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.data != null && n.data.length)
      for (let e = 0; e < n.data.length; ++e)
        t.uint32(
          /* id 1, wireType 2 =*/
          10
        ).string(n.data[e]);
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.StringArray();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.data && p.data.length || (p.data = []), p.data.push(n.string());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      if (!Array.isArray(n.data))
        return "data: array expected";
      for (let t = 0; t < n.data.length; ++t)
        if (!$util.isString(n.data[t]))
          return "data: string[] expected";
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.StringArray)
      return n;
    let t = new $root.StringArray();
    if (n.data) {
      if (!Array.isArray(n.data))
        throw TypeError(".StringArray.data: array expected");
      t.data = [];
      for (let e = 0; e < n.data.length; ++e)
        t.data[e] = String(n.data[e]);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.data = []), n.data && n.data.length) {
      e.data = [];
      for (let o = 0; o < n.data.length; ++o)
        e.data[o] = n.data[o];
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/StringArray";
  }, r;
})();
$root.DoubleArray = (() => {
  function r(c) {
    if (this.data = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.data = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.data != null && n.data.length) {
      t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < n.data.length; ++e)
        t.double(n.data[e]);
      t.ldelim();
    }
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.DoubleArray();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          if (p.data && p.data.length || (p.data = []), (h & 7) === 2) {
            let y = n.uint32() + n.pos;
            for (; n.pos < y; )
              p.data.push(n.double());
          } else
            p.data.push(n.double());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      if (!Array.isArray(n.data))
        return "data: array expected";
      for (let t = 0; t < n.data.length; ++t)
        if (typeof n.data[t] != "number")
          return "data: number[] expected";
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.DoubleArray)
      return n;
    let t = new $root.DoubleArray();
    if (n.data) {
      if (!Array.isArray(n.data))
        throw TypeError(".DoubleArray.data: array expected");
      t.data = [];
      for (let e = 0; e < n.data.length; ++e)
        t.data[e] = Number(n.data[e]);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.data = []), n.data && n.data.length) {
      e.data = [];
      for (let o = 0; o < n.data.length; ++o)
        e.data[o] = t.json && !isFinite(n.data[o]) ? String(n.data[o]) : n.data[o];
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/DoubleArray";
  }, r;
})();
$root.Int32Array = (() => {
  function r(c) {
    if (this.data = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.data = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.data != null && n.data.length) {
      t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < n.data.length; ++e)
        t.int32(n.data[e]);
      t.ldelim();
    }
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Int32Array();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          if (p.data && p.data.length || (p.data = []), (h & 7) === 2) {
            let y = n.uint32() + n.pos;
            for (; n.pos < y; )
              p.data.push(n.int32());
          } else
            p.data.push(n.int32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      if (!Array.isArray(n.data))
        return "data: array expected";
      for (let t = 0; t < n.data.length; ++t)
        if (!$util.isInteger(n.data[t]))
          return "data: integer[] expected";
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Int32Array)
      return n;
    let t = new $root.Int32Array();
    if (n.data) {
      if (!Array.isArray(n.data))
        throw TypeError(".Int32Array.data: array expected");
      t.data = [];
      for (let e = 0; e < n.data.length; ++e)
        t.data[e] = n.data[e] | 0;
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.data = []), n.data && n.data.length) {
      e.data = [];
      for (let o = 0; o < n.data.length; ++o)
        e.data[o] = n.data[o];
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Int32Array";
  }, r;
})();
$root.Int64Array = (() => {
  function r(c) {
    if (this.data = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.data = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.data != null && n.data.length) {
      t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < n.data.length; ++e)
        t.int64(n.data[e]);
      t.ldelim();
    }
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Int64Array();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          if (p.data && p.data.length || (p.data = []), (h & 7) === 2) {
            let y = n.uint32() + n.pos;
            for (; n.pos < y; )
              p.data.push(n.int64());
          } else
            p.data.push(n.int64());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      if (!Array.isArray(n.data))
        return "data: array expected";
      for (let t = 0; t < n.data.length; ++t)
        if (!$util.isInteger(n.data[t]) && !(n.data[t] && $util.isInteger(n.data[t].low) && $util.isInteger(n.data[t].high)))
          return "data: integer|Long[] expected";
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Int64Array)
      return n;
    let t = new $root.Int64Array();
    if (n.data) {
      if (!Array.isArray(n.data))
        throw TypeError(".Int64Array.data: array expected");
      t.data = [];
      for (let e = 0; e < n.data.length; ++e)
        $util.Long ? (t.data[e] = $util.Long.fromValue(n.data[e])).unsigned = !1 : typeof n.data[e] == "string" ? t.data[e] = parseInt(n.data[e], 10) : typeof n.data[e] == "number" ? t.data[e] = n.data[e] : typeof n.data[e] == "object" && (t.data[e] = new $util.LongBits(n.data[e].low >>> 0, n.data[e].high >>> 0).toNumber());
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.data = []), n.data && n.data.length) {
      e.data = [];
      for (let o = 0; o < n.data.length; ++o)
        typeof n.data[o] == "number" ? e.data[o] = t.longs === String ? String(n.data[o]) : n.data[o] : e.data[o] = t.longs === String ? $util.Long.prototype.toString.call(n.data[o]) : t.longs === Number ? new $util.LongBits(n.data[o].low >>> 0, n.data[o].high >>> 0).toNumber() : n.data[o];
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Int64Array";
  }, r;
})();
$root.SInt64Array = (() => {
  function r(c) {
    if (this.data = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.data = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.data != null && n.data.length) {
      t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < n.data.length; ++e)
        t.sint64(n.data[e]);
      t.ldelim();
    }
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.SInt64Array();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          if (p.data && p.data.length || (p.data = []), (h & 7) === 2) {
            let y = n.uint32() + n.pos;
            for (; n.pos < y; )
              p.data.push(n.sint64());
          } else
            p.data.push(n.sint64());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      if (!Array.isArray(n.data))
        return "data: array expected";
      for (let t = 0; t < n.data.length; ++t)
        if (!$util.isInteger(n.data[t]) && !(n.data[t] && $util.isInteger(n.data[t].low) && $util.isInteger(n.data[t].high)))
          return "data: integer|Long[] expected";
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.SInt64Array)
      return n;
    let t = new $root.SInt64Array();
    if (n.data) {
      if (!Array.isArray(n.data))
        throw TypeError(".SInt64Array.data: array expected");
      t.data = [];
      for (let e = 0; e < n.data.length; ++e)
        $util.Long ? (t.data[e] = $util.Long.fromValue(n.data[e])).unsigned = !1 : typeof n.data[e] == "string" ? t.data[e] = parseInt(n.data[e], 10) : typeof n.data[e] == "number" ? t.data[e] = n.data[e] : typeof n.data[e] == "object" && (t.data[e] = new $util.LongBits(n.data[e].low >>> 0, n.data[e].high >>> 0).toNumber());
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.data = []), n.data && n.data.length) {
      e.data = [];
      for (let o = 0; o < n.data.length; ++o)
        typeof n.data[o] == "number" ? e.data[o] = t.longs === String ? String(n.data[o]) : n.data[o] : e.data[o] = t.longs === String ? $util.Long.prototype.toString.call(n.data[o]) : t.longs === Number ? new $util.LongBits(n.data[o].low >>> 0, n.data[o].high >>> 0).toNumber() : n.data[o];
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/SInt64Array";
  }, r;
})();
$root.UInt32Array = (() => {
  function r(c) {
    if (this.data = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.data = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.data != null && n.data.length) {
      t.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork();
      for (let e = 0; e < n.data.length; ++e)
        t.uint32(n.data[e]);
      t.ldelim();
    }
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.UInt32Array();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          if (p.data && p.data.length || (p.data = []), (h & 7) === 2) {
            let y = n.uint32() + n.pos;
            for (; n.pos < y; )
              p.data.push(n.uint32());
          } else
            p.data.push(n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      if (!Array.isArray(n.data))
        return "data: array expected";
      for (let t = 0; t < n.data.length; ++t)
        if (!$util.isInteger(n.data[t]))
          return "data: integer[] expected";
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.UInt32Array)
      return n;
    let t = new $root.UInt32Array();
    if (n.data) {
      if (!Array.isArray(n.data))
        throw TypeError(".UInt32Array.data: array expected");
      t.data = [];
      for (let e = 0; e < n.data.length; ++e)
        t.data[e] = n.data[e] >>> 0;
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.data = []), n.data && n.data.length) {
      e.data = [];
      for (let o = 0; o < n.data.length; ++o)
        e.data[o] = n.data[o];
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/UInt32Array";
  }, r;
})();
$root.StringTriggerValue = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.data = null;
  let c;
  return Object.defineProperty(r.prototype, "_data", {
    get: $util.oneOfGetter(c = ["data"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.data != null && Object.hasOwnProperty.call(t, "data") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.data), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.StringTriggerValue();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.data = t.string();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.data != null && t.hasOwnProperty("data") && !$util.isString(t.data) ? "data: string expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.StringTriggerValue)
      return t;
    let e = new $root.StringTriggerValue();
    return t.data != null && (e.data = String(t.data)), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return t.data != null && t.hasOwnProperty("data") && (o.data = t.data, e.oneofs && (o._data = "data")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/StringTriggerValue";
  }, r;
})();
$root.FileURLsRequest = (() => {
  function r(c) {
    if (this.fileNames = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.requestId = "", r.prototype.fileNames = $util.emptyArray, r.prototype.sessionId = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.requestId != null && Object.hasOwnProperty.call(n, "requestId") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.requestId), n.fileNames != null && n.fileNames.length)
      for (let e = 0; e < n.fileNames.length; ++e)
        t.uint32(
          /* id 2, wireType 2 =*/
          18
        ).string(n.fileNames[e]);
    return n.sessionId != null && Object.hasOwnProperty.call(n, "sessionId") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.sessionId), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.FileURLsRequest();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.requestId = n.string();
          break;
        }
        case 2: {
          p.fileNames && p.fileNames.length || (p.fileNames = []), p.fileNames.push(n.string());
          break;
        }
        case 3: {
          p.sessionId = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.requestId != null && n.hasOwnProperty("requestId") && !$util.isString(n.requestId))
      return "requestId: string expected";
    if (n.fileNames != null && n.hasOwnProperty("fileNames")) {
      if (!Array.isArray(n.fileNames))
        return "fileNames: array expected";
      for (let t = 0; t < n.fileNames.length; ++t)
        if (!$util.isString(n.fileNames[t]))
          return "fileNames: string[] expected";
    }
    return n.sessionId != null && n.hasOwnProperty("sessionId") && !$util.isString(n.sessionId) ? "sessionId: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.FileURLsRequest)
      return n;
    let t = new $root.FileURLsRequest();
    if (n.requestId != null && (t.requestId = String(n.requestId)), n.fileNames) {
      if (!Array.isArray(n.fileNames))
        throw TypeError(".FileURLsRequest.fileNames: array expected");
      t.fileNames = [];
      for (let e = 0; e < n.fileNames.length; ++e)
        t.fileNames[e] = String(n.fileNames[e]);
    }
    return n.sessionId != null && (t.sessionId = String(n.sessionId)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.fileNames = []), t.defaults && (e.requestId = "", e.sessionId = ""), n.requestId != null && n.hasOwnProperty("requestId") && (e.requestId = n.requestId), n.fileNames && n.fileNames.length) {
      e.fileNames = [];
      for (let o = 0; o < n.fileNames.length; ++o)
        e.fileNames[o] = n.fileNames[o];
    }
    return n.sessionId != null && n.hasOwnProperty("sessionId") && (e.sessionId = n.sessionId), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/FileURLsRequest";
  }, r;
})();
$root.FileURLs = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.fileId = "", r.prototype.uploadUrl = "", r.prototype.deleteUrl = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.fileId != null && Object.hasOwnProperty.call(n, "fileId") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.fileId), n.uploadUrl != null && Object.hasOwnProperty.call(n, "uploadUrl") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.uploadUrl), n.deleteUrl != null && Object.hasOwnProperty.call(n, "deleteUrl") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.deleteUrl), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.FileURLs();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.fileId = n.string();
          break;
        }
        case 2: {
          p.uploadUrl = n.string();
          break;
        }
        case 3: {
          p.deleteUrl = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.fileId != null && n.hasOwnProperty("fileId") && !$util.isString(n.fileId) ? "fileId: string expected" : n.uploadUrl != null && n.hasOwnProperty("uploadUrl") && !$util.isString(n.uploadUrl) ? "uploadUrl: string expected" : n.deleteUrl != null && n.hasOwnProperty("deleteUrl") && !$util.isString(n.deleteUrl) ? "deleteUrl: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.FileURLs)
      return n;
    let t = new $root.FileURLs();
    return n.fileId != null && (t.fileId = String(n.fileId)), n.uploadUrl != null && (t.uploadUrl = String(n.uploadUrl)), n.deleteUrl != null && (t.deleteUrl = String(n.deleteUrl)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.fileId = "", e.uploadUrl = "", e.deleteUrl = ""), n.fileId != null && n.hasOwnProperty("fileId") && (e.fileId = n.fileId), n.uploadUrl != null && n.hasOwnProperty("uploadUrl") && (e.uploadUrl = n.uploadUrl), n.deleteUrl != null && n.hasOwnProperty("deleteUrl") && (e.deleteUrl = n.deleteUrl), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/FileURLs";
  }, r;
})();
$root.FileURLsResponse = (() => {
  function r(c) {
    if (this.fileUrls = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.responseId = "", r.prototype.fileUrls = $util.emptyArray, r.prototype.errorMsg = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.responseId != null && Object.hasOwnProperty.call(n, "responseId") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.responseId), n.fileUrls != null && n.fileUrls.length)
      for (let e = 0; e < n.fileUrls.length; ++e)
        $root.FileURLs.encode(n.fileUrls[e], t.uint32(
          /* id 2, wireType 2 =*/
          18
        ).fork()).ldelim();
    return n.errorMsg != null && Object.hasOwnProperty.call(n, "errorMsg") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.errorMsg), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.FileURLsResponse();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.responseId = n.string();
          break;
        }
        case 2: {
          p.fileUrls && p.fileUrls.length || (p.fileUrls = []), p.fileUrls.push($root.FileURLs.decode(n, n.uint32()));
          break;
        }
        case 3: {
          p.errorMsg = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.responseId != null && n.hasOwnProperty("responseId") && !$util.isString(n.responseId))
      return "responseId: string expected";
    if (n.fileUrls != null && n.hasOwnProperty("fileUrls")) {
      if (!Array.isArray(n.fileUrls))
        return "fileUrls: array expected";
      for (let t = 0; t < n.fileUrls.length; ++t) {
        let e = $root.FileURLs.verify(n.fileUrls[t]);
        if (e)
          return "fileUrls." + e;
      }
    }
    return n.errorMsg != null && n.hasOwnProperty("errorMsg") && !$util.isString(n.errorMsg) ? "errorMsg: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.FileURLsResponse)
      return n;
    let t = new $root.FileURLsResponse();
    if (n.responseId != null && (t.responseId = String(n.responseId)), n.fileUrls) {
      if (!Array.isArray(n.fileUrls))
        throw TypeError(".FileURLsResponse.fileUrls: array expected");
      t.fileUrls = [];
      for (let e = 0; e < n.fileUrls.length; ++e) {
        if (typeof n.fileUrls[e] != "object")
          throw TypeError(".FileURLsResponse.fileUrls: object expected");
        t.fileUrls[e] = $root.FileURLs.fromObject(n.fileUrls[e]);
      }
    }
    return n.errorMsg != null && (t.errorMsg = String(n.errorMsg)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.fileUrls = []), t.defaults && (e.responseId = "", e.errorMsg = ""), n.responseId != null && n.hasOwnProperty("responseId") && (e.responseId = n.responseId), n.fileUrls && n.fileUrls.length) {
      e.fileUrls = [];
      for (let o = 0; o < n.fileUrls.length; ++o)
        e.fileUrls[o] = $root.FileURLs.toObject(n.fileUrls[o], t);
    }
    return n.errorMsg != null && n.hasOwnProperty("errorMsg") && (e.errorMsg = n.errorMsg), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/FileURLsResponse";
  }, r;
})();
$root.UploadedFileInfo = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.id = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, r.prototype.name = "", r.prototype.size = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, r.prototype.fileId = "", r.prototype.fileUrls = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.id != null && Object.hasOwnProperty.call(n, "id") && t.uint32(
      /* id 1, wireType 0 =*/
      8
    ).sint64(n.id), n.name != null && Object.hasOwnProperty.call(n, "name") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.name), n.size != null && Object.hasOwnProperty.call(n, "size") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint64(n.size), n.fileId != null && Object.hasOwnProperty.call(n, "fileId") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.fileId), n.fileUrls != null && Object.hasOwnProperty.call(n, "fileUrls") && $root.FileURLs.encode(n.fileUrls, t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.UploadedFileInfo();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.id = n.sint64();
          break;
        }
        case 2: {
          p.name = n.string();
          break;
        }
        case 3: {
          p.size = n.uint64();
          break;
        }
        case 4: {
          p.fileId = n.string();
          break;
        }
        case 5: {
          p.fileUrls = $root.FileURLs.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.id != null && n.hasOwnProperty("id") && !$util.isInteger(n.id) && !(n.id && $util.isInteger(n.id.low) && $util.isInteger(n.id.high)))
      return "id: integer|Long expected";
    if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
      return "name: string expected";
    if (n.size != null && n.hasOwnProperty("size") && !$util.isInteger(n.size) && !(n.size && $util.isInteger(n.size.low) && $util.isInteger(n.size.high)))
      return "size: integer|Long expected";
    if (n.fileId != null && n.hasOwnProperty("fileId") && !$util.isString(n.fileId))
      return "fileId: string expected";
    if (n.fileUrls != null && n.hasOwnProperty("fileUrls")) {
      let t = $root.FileURLs.verify(n.fileUrls);
      if (t)
        return "fileUrls." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.UploadedFileInfo)
      return n;
    let t = new $root.UploadedFileInfo();
    if (n.id != null && ($util.Long ? (t.id = $util.Long.fromValue(n.id)).unsigned = !1 : typeof n.id == "string" ? t.id = parseInt(n.id, 10) : typeof n.id == "number" ? t.id = n.id : typeof n.id == "object" && (t.id = new $util.LongBits(n.id.low >>> 0, n.id.high >>> 0).toNumber())), n.name != null && (t.name = String(n.name)), n.size != null && ($util.Long ? (t.size = $util.Long.fromValue(n.size)).unsigned = !0 : typeof n.size == "string" ? t.size = parseInt(n.size, 10) : typeof n.size == "number" ? t.size = n.size : typeof n.size == "object" && (t.size = new $util.LongBits(n.size.low >>> 0, n.size.high >>> 0).toNumber(!0))), n.fileId != null && (t.fileId = String(n.fileId)), n.fileUrls != null) {
      if (typeof n.fileUrls != "object")
        throw TypeError(".UploadedFileInfo.fileUrls: object expected");
      t.fileUrls = $root.FileURLs.fromObject(n.fileUrls);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if (t.defaults) {
      if ($util.Long) {
        let o = new $util.Long(0, 0, !1);
        e.id = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
      } else
        e.id = t.longs === String ? "0" : 0;
      if (e.name = "", $util.Long) {
        let o = new $util.Long(0, 0, !0);
        e.size = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
      } else
        e.size = t.longs === String ? "0" : 0;
      e.fileId = "", e.fileUrls = null;
    }
    return n.id != null && n.hasOwnProperty("id") && (typeof n.id == "number" ? e.id = t.longs === String ? String(n.id) : n.id : e.id = t.longs === String ? $util.Long.prototype.toString.call(n.id) : t.longs === Number ? new $util.LongBits(n.id.low >>> 0, n.id.high >>> 0).toNumber() : n.id), n.name != null && n.hasOwnProperty("name") && (e.name = n.name), n.size != null && n.hasOwnProperty("size") && (typeof n.size == "number" ? e.size = t.longs === String ? String(n.size) : n.size : e.size = t.longs === String ? $util.Long.prototype.toString.call(n.size) : t.longs === Number ? new $util.LongBits(n.size.low >>> 0, n.size.high >>> 0).toNumber(!0) : n.size), n.fileId != null && n.hasOwnProperty("fileId") && (e.fileId = n.fileId), n.fileUrls != null && n.hasOwnProperty("fileUrls") && (e.fileUrls = $root.FileURLs.toObject(n.fileUrls, t)), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/UploadedFileInfo";
  }, r;
})();
$root.FileUploaderState = (() => {
  function r(c) {
    if (this.uploadedFileInfo = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.maxFileId = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, r.prototype.uploadedFileInfo = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.maxFileId != null && Object.hasOwnProperty.call(n, "maxFileId") && t.uint32(
      /* id 1, wireType 0 =*/
      8
    ).sint64(n.maxFileId), n.uploadedFileInfo != null && n.uploadedFileInfo.length)
      for (let e = 0; e < n.uploadedFileInfo.length; ++e)
        $root.UploadedFileInfo.encode(n.uploadedFileInfo[e], t.uint32(
          /* id 2, wireType 2 =*/
          18
        ).fork()).ldelim();
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.FileUploaderState();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.maxFileId = n.sint64();
          break;
        }
        case 2: {
          p.uploadedFileInfo && p.uploadedFileInfo.length || (p.uploadedFileInfo = []), p.uploadedFileInfo.push($root.UploadedFileInfo.decode(n, n.uint32()));
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.maxFileId != null && n.hasOwnProperty("maxFileId") && !$util.isInteger(n.maxFileId) && !(n.maxFileId && $util.isInteger(n.maxFileId.low) && $util.isInteger(n.maxFileId.high)))
      return "maxFileId: integer|Long expected";
    if (n.uploadedFileInfo != null && n.hasOwnProperty("uploadedFileInfo")) {
      if (!Array.isArray(n.uploadedFileInfo))
        return "uploadedFileInfo: array expected";
      for (let t = 0; t < n.uploadedFileInfo.length; ++t) {
        let e = $root.UploadedFileInfo.verify(n.uploadedFileInfo[t]);
        if (e)
          return "uploadedFileInfo." + e;
      }
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.FileUploaderState)
      return n;
    let t = new $root.FileUploaderState();
    if (n.maxFileId != null && ($util.Long ? (t.maxFileId = $util.Long.fromValue(n.maxFileId)).unsigned = !1 : typeof n.maxFileId == "string" ? t.maxFileId = parseInt(n.maxFileId, 10) : typeof n.maxFileId == "number" ? t.maxFileId = n.maxFileId : typeof n.maxFileId == "object" && (t.maxFileId = new $util.LongBits(n.maxFileId.low >>> 0, n.maxFileId.high >>> 0).toNumber())), n.uploadedFileInfo) {
      if (!Array.isArray(n.uploadedFileInfo))
        throw TypeError(".FileUploaderState.uploadedFileInfo: array expected");
      t.uploadedFileInfo = [];
      for (let e = 0; e < n.uploadedFileInfo.length; ++e) {
        if (typeof n.uploadedFileInfo[e] != "object")
          throw TypeError(".FileUploaderState.uploadedFileInfo: object expected");
        t.uploadedFileInfo[e] = $root.UploadedFileInfo.fromObject(n.uploadedFileInfo[e]);
      }
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.uploadedFileInfo = []), t.defaults)
      if ($util.Long) {
        let o = new $util.Long(0, 0, !1);
        e.maxFileId = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
      } else
        e.maxFileId = t.longs === String ? "0" : 0;
    if (n.maxFileId != null && n.hasOwnProperty("maxFileId") && (typeof n.maxFileId == "number" ? e.maxFileId = t.longs === String ? String(n.maxFileId) : n.maxFileId : e.maxFileId = t.longs === String ? $util.Long.prototype.toString.call(n.maxFileId) : t.longs === Number ? new $util.LongBits(n.maxFileId.low >>> 0, n.maxFileId.high >>> 0).toNumber() : n.maxFileId), n.uploadedFileInfo && n.uploadedFileInfo.length) {
      e.uploadedFileInfo = [];
      for (let o = 0; o < n.uploadedFileInfo.length; ++o)
        e.uploadedFileInfo[o] = $root.UploadedFileInfo.toObject(n.uploadedFileInfo[o], t);
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/FileUploaderState";
  }, r;
})();
$root.ChatInputValue = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.data = null, r.prototype.fileUploaderState = null;
  let c;
  return Object.defineProperty(r.prototype, "_data", {
    get: $util.oneOfGetter(c = ["data"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_fileUploaderState", {
    get: $util.oneOfGetter(c = ["fileUploaderState"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.data != null && Object.hasOwnProperty.call(t, "data") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.data), t.fileUploaderState != null && Object.hasOwnProperty.call(t, "fileUploaderState") && $root.FileUploaderState.encode(t.fileUploaderState, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.ChatInputValue();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.data = t.string();
          break;
        }
        case 2: {
          h.fileUploaderState = $root.FileUploaderState.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.data != null && t.hasOwnProperty("data") && !$util.isString(t.data))
      return "data: string expected";
    if (t.fileUploaderState != null && t.hasOwnProperty("fileUploaderState")) {
      let e = $root.FileUploaderState.verify(t.fileUploaderState);
      if (e)
        return "fileUploaderState." + e;
    }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.ChatInputValue)
      return t;
    let e = new $root.ChatInputValue();
    if (t.data != null && (e.data = String(t.data)), t.fileUploaderState != null) {
      if (typeof t.fileUploaderState != "object")
        throw TypeError(".ChatInputValue.fileUploaderState: object expected");
      e.fileUploaderState = $root.FileUploaderState.fromObject(t.fileUploaderState);
    }
    return e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return t.data != null && t.hasOwnProperty("data") && (o.data = t.data, e.oneofs && (o._data = "data")), t.fileUploaderState != null && t.hasOwnProperty("fileUploaderState") && (o.fileUploaderState = $root.FileUploaderState.toObject(t.fileUploaderState, e), e.oneofs && (o._fileUploaderState = "fileUploaderState")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ChatInputValue";
  }, r;
})();
$root.ComponentInstance = (() => {
  function r(n) {
    if (this.specialArgs = [], n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.id = "", r.prototype.jsonArgs = "", r.prototype.specialArgs = $util.emptyArray, r.prototype.componentName = "", r.prototype.url = "", r.prototype.formId = "", r.prototype.tabIndex = null;
  let c;
  return Object.defineProperty(r.prototype, "_tabIndex", {
    get: $util.oneOfGetter(c = ["tabIndex"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    if (e || (e = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.jsonArgs != null && Object.hasOwnProperty.call(t, "jsonArgs") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.jsonArgs), t.specialArgs != null && t.specialArgs.length)
      for (let o = 0; o < t.specialArgs.length; ++o)
        $root.SpecialArg.encode(t.specialArgs[o], e.uint32(
          /* id 3, wireType 2 =*/
          26
        ).fork()).ldelim();
    return t.componentName != null && Object.hasOwnProperty.call(t, "componentName") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.componentName), t.url != null && Object.hasOwnProperty.call(t, "url") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.url), t.formId != null && Object.hasOwnProperty.call(t, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.formId), t.tabIndex != null && Object.hasOwnProperty.call(t, "tabIndex") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(t.tabIndex), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.ComponentInstance();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.id = t.string();
          break;
        }
        case 2: {
          h.jsonArgs = t.string();
          break;
        }
        case 3: {
          h.specialArgs && h.specialArgs.length || (h.specialArgs = []), h.specialArgs.push($root.SpecialArg.decode(t, t.uint32()));
          break;
        }
        case 4: {
          h.componentName = t.string();
          break;
        }
        case 5: {
          h.url = t.string();
          break;
        }
        case 6: {
          h.formId = t.string();
          break;
        }
        case 7: {
          h.tabIndex = t.int32();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.jsonArgs != null && t.hasOwnProperty("jsonArgs") && !$util.isString(t.jsonArgs))
      return "jsonArgs: string expected";
    if (t.specialArgs != null && t.hasOwnProperty("specialArgs")) {
      if (!Array.isArray(t.specialArgs))
        return "specialArgs: array expected";
      for (let e = 0; e < t.specialArgs.length; ++e) {
        let o = $root.SpecialArg.verify(t.specialArgs[e]);
        if (o)
          return "specialArgs." + o;
      }
    }
    return t.componentName != null && t.hasOwnProperty("componentName") && !$util.isString(t.componentName) ? "componentName: string expected" : t.url != null && t.hasOwnProperty("url") && !$util.isString(t.url) ? "url: string expected" : t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId) ? "formId: string expected" : t.tabIndex != null && t.hasOwnProperty("tabIndex") && !$util.isInteger(t.tabIndex) ? "tabIndex: integer expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.ComponentInstance)
      return t;
    let e = new $root.ComponentInstance();
    if (t.id != null && (e.id = String(t.id)), t.jsonArgs != null && (e.jsonArgs = String(t.jsonArgs)), t.specialArgs) {
      if (!Array.isArray(t.specialArgs))
        throw TypeError(".ComponentInstance.specialArgs: array expected");
      e.specialArgs = [];
      for (let o = 0; o < t.specialArgs.length; ++o) {
        if (typeof t.specialArgs[o] != "object")
          throw TypeError(".ComponentInstance.specialArgs: object expected");
        e.specialArgs[o] = $root.SpecialArg.fromObject(t.specialArgs[o]);
      }
    }
    return t.componentName != null && (e.componentName = String(t.componentName)), t.url != null && (e.url = String(t.url)), t.formId != null && (e.formId = String(t.formId)), t.tabIndex != null && (e.tabIndex = t.tabIndex | 0), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    if ((e.arrays || e.defaults) && (o.specialArgs = []), e.defaults && (o.id = "", o.jsonArgs = "", o.componentName = "", o.url = "", o.formId = ""), t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.jsonArgs != null && t.hasOwnProperty("jsonArgs") && (o.jsonArgs = t.jsonArgs), t.specialArgs && t.specialArgs.length) {
      o.specialArgs = [];
      for (let p = 0; p < t.specialArgs.length; ++p)
        o.specialArgs[p] = $root.SpecialArg.toObject(t.specialArgs[p], e);
    }
    return t.componentName != null && t.hasOwnProperty("componentName") && (o.componentName = t.componentName), t.url != null && t.hasOwnProperty("url") && (o.url = t.url), t.formId != null && t.hasOwnProperty("formId") && (o.formId = t.formId), t.tabIndex != null && t.hasOwnProperty("tabIndex") && (o.tabIndex = t.tabIndex, e.oneofs && (o._tabIndex = "tabIndex")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ComponentInstance";
  }, r;
})();
$root.SpecialArg = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.key = "", r.prototype.arrowDataframe = null, r.prototype.bytes = null;
  let c;
  return Object.defineProperty(r.prototype, "value", {
    get: $util.oneOfGetter(c = ["arrowDataframe", "bytes"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.key != null && Object.hasOwnProperty.call(t, "key") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.key), t.arrowDataframe != null && Object.hasOwnProperty.call(t, "arrowDataframe") && $root.ArrowDataframe.encode(t.arrowDataframe, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), t.bytes != null && Object.hasOwnProperty.call(t, "bytes") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(t.bytes), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.SpecialArg();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.key = t.string();
          break;
        }
        case 2: {
          h.arrowDataframe = $root.ArrowDataframe.decode(t, t.uint32());
          break;
        }
        case 3: {
          h.bytes = t.bytes();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    let e = {};
    if (t.key != null && t.hasOwnProperty("key") && !$util.isString(t.key))
      return "key: string expected";
    if (t.arrowDataframe != null && t.hasOwnProperty("arrowDataframe")) {
      e.value = 1;
      {
        let o = $root.ArrowDataframe.verify(t.arrowDataframe);
        if (o)
          return "arrowDataframe." + o;
      }
    }
    if (t.bytes != null && t.hasOwnProperty("bytes")) {
      if (e.value === 1)
        return "value: multiple values";
      if (e.value = 1, !(t.bytes && typeof t.bytes.length == "number" || $util.isString(t.bytes)))
        return "bytes: buffer expected";
    }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.SpecialArg)
      return t;
    let e = new $root.SpecialArg();
    if (t.key != null && (e.key = String(t.key)), t.arrowDataframe != null) {
      if (typeof t.arrowDataframe != "object")
        throw TypeError(".SpecialArg.arrowDataframe: object expected");
      e.arrowDataframe = $root.ArrowDataframe.fromObject(t.arrowDataframe);
    }
    return t.bytes != null && (typeof t.bytes == "string" ? $util.base64.decode(t.bytes, e.bytes = $util.newBuffer($util.base64.length(t.bytes)), 0) : t.bytes.length >= 0 && (e.bytes = t.bytes)), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.key = ""), t.key != null && t.hasOwnProperty("key") && (o.key = t.key), t.arrowDataframe != null && t.hasOwnProperty("arrowDataframe") && (o.arrowDataframe = $root.ArrowDataframe.toObject(t.arrowDataframe, e), e.oneofs && (o.value = "arrowDataframe")), t.bytes != null && t.hasOwnProperty("bytes") && (o.bytes = e.bytes === String ? $util.base64.encode(t.bytes, 0, t.bytes.length) : e.bytes === Array ? Array.prototype.slice.call(t.bytes) : t.bytes, e.oneofs && (o.value = "bytes")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/SpecialArg";
  }, r;
})();
$root.ArrowDataframe = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.data = null, r.prototype.height = 0, r.prototype.width = 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.data != null && Object.hasOwnProperty.call(n, "data") && $root.ArrowTable.encode(n.data, t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), n.height != null && Object.hasOwnProperty.call(n, "height") && t.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(n.height), n.width != null && Object.hasOwnProperty.call(n, "width") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(n.width), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.ArrowDataframe();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.data = $root.ArrowTable.decode(n, n.uint32());
          break;
        }
        case 2: {
          p.height = n.uint32();
          break;
        }
        case 3: {
          p.width = n.uint32();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      let t = $root.ArrowTable.verify(n.data);
      if (t)
        return "data." + t;
    }
    return n.height != null && n.hasOwnProperty("height") && !$util.isInteger(n.height) ? "height: integer expected" : n.width != null && n.hasOwnProperty("width") && !$util.isInteger(n.width) ? "width: integer expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.ArrowDataframe)
      return n;
    let t = new $root.ArrowDataframe();
    if (n.data != null) {
      if (typeof n.data != "object")
        throw TypeError(".ArrowDataframe.data: object expected");
      t.data = $root.ArrowTable.fromObject(n.data);
    }
    return n.height != null && (t.height = n.height >>> 0), n.width != null && (t.width = n.width >>> 0), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.data = null, e.height = 0, e.width = 0), n.data != null && n.hasOwnProperty("data") && (e.data = $root.ArrowTable.toObject(n.data, t)), n.height != null && n.hasOwnProperty("height") && (e.height = n.height), n.width != null && n.hasOwnProperty("width") && (e.width = n.width), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/ArrowDataframe";
  }, r;
})();
$root.ArrowTable = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.data = $util.newBuffer([]), r.prototype.index = $util.newBuffer([]), r.prototype.columns = $util.newBuffer([]), r.prototype.styler = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.data != null && Object.hasOwnProperty.call(n, "data") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).bytes(n.data), n.index != null && Object.hasOwnProperty.call(n, "index") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).bytes(n.index), n.columns != null && Object.hasOwnProperty.call(n, "columns") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).bytes(n.columns), n.styler != null && Object.hasOwnProperty.call(n, "styler") && $root.ArrowTableStyler.encode(n.styler, t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.ArrowTable();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.data = n.bytes();
          break;
        }
        case 2: {
          p.index = n.bytes();
          break;
        }
        case 3: {
          p.columns = n.bytes();
          break;
        }
        case 5: {
          p.styler = $root.ArrowTableStyler.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.data != null && n.hasOwnProperty("data") && !(n.data && typeof n.data.length == "number" || $util.isString(n.data)))
      return "data: buffer expected";
    if (n.index != null && n.hasOwnProperty("index") && !(n.index && typeof n.index.length == "number" || $util.isString(n.index)))
      return "index: buffer expected";
    if (n.columns != null && n.hasOwnProperty("columns") && !(n.columns && typeof n.columns.length == "number" || $util.isString(n.columns)))
      return "columns: buffer expected";
    if (n.styler != null && n.hasOwnProperty("styler")) {
      let t = $root.ArrowTableStyler.verify(n.styler);
      if (t)
        return "styler." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.ArrowTable)
      return n;
    let t = new $root.ArrowTable();
    if (n.data != null && (typeof n.data == "string" ? $util.base64.decode(n.data, t.data = $util.newBuffer($util.base64.length(n.data)), 0) : n.data.length >= 0 && (t.data = n.data)), n.index != null && (typeof n.index == "string" ? $util.base64.decode(n.index, t.index = $util.newBuffer($util.base64.length(n.index)), 0) : n.index.length >= 0 && (t.index = n.index)), n.columns != null && (typeof n.columns == "string" ? $util.base64.decode(n.columns, t.columns = $util.newBuffer($util.base64.length(n.columns)), 0) : n.columns.length >= 0 && (t.columns = n.columns)), n.styler != null) {
      if (typeof n.styler != "object")
        throw TypeError(".ArrowTable.styler: object expected");
      t.styler = $root.ArrowTableStyler.fromObject(n.styler);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (t.bytes === String ? e.data = "" : (e.data = [], t.bytes !== Array && (e.data = $util.newBuffer(e.data))), t.bytes === String ? e.index = "" : (e.index = [], t.bytes !== Array && (e.index = $util.newBuffer(e.index))), t.bytes === String ? e.columns = "" : (e.columns = [], t.bytes !== Array && (e.columns = $util.newBuffer(e.columns))), e.styler = null), n.data != null && n.hasOwnProperty("data") && (e.data = t.bytes === String ? $util.base64.encode(n.data, 0, n.data.length) : t.bytes === Array ? Array.prototype.slice.call(n.data) : n.data), n.index != null && n.hasOwnProperty("index") && (e.index = t.bytes === String ? $util.base64.encode(n.index, 0, n.index.length) : t.bytes === Array ? Array.prototype.slice.call(n.index) : n.index), n.columns != null && n.hasOwnProperty("columns") && (e.columns = t.bytes === String ? $util.base64.encode(n.columns, 0, n.columns.length) : t.bytes === Array ? Array.prototype.slice.call(n.columns) : n.columns), n.styler != null && n.hasOwnProperty("styler") && (e.styler = $root.ArrowTableStyler.toObject(n.styler, t)), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/ArrowTable";
  }, r;
})();
$root.ArrowTableStyler = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.uuid = "", r.prototype.caption = "", r.prototype.styles = "", r.prototype.displayValues = $util.newBuffer([]), r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.uuid != null && Object.hasOwnProperty.call(n, "uuid") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.uuid), n.caption != null && Object.hasOwnProperty.call(n, "caption") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.caption), n.styles != null && Object.hasOwnProperty.call(n, "styles") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.styles), n.displayValues != null && Object.hasOwnProperty.call(n, "displayValues") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).bytes(n.displayValues), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.ArrowTableStyler();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.uuid = n.string();
          break;
        }
        case 2: {
          p.caption = n.string();
          break;
        }
        case 3: {
          p.styles = n.string();
          break;
        }
        case 4: {
          p.displayValues = n.bytes();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.uuid != null && n.hasOwnProperty("uuid") && !$util.isString(n.uuid) ? "uuid: string expected" : n.caption != null && n.hasOwnProperty("caption") && !$util.isString(n.caption) ? "caption: string expected" : n.styles != null && n.hasOwnProperty("styles") && !$util.isString(n.styles) ? "styles: string expected" : n.displayValues != null && n.hasOwnProperty("displayValues") && !(n.displayValues && typeof n.displayValues.length == "number" || $util.isString(n.displayValues)) ? "displayValues: buffer expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.ArrowTableStyler)
      return n;
    let t = new $root.ArrowTableStyler();
    return n.uuid != null && (t.uuid = String(n.uuid)), n.caption != null && (t.caption = String(n.caption)), n.styles != null && (t.styles = String(n.styles)), n.displayValues != null && (typeof n.displayValues == "string" ? $util.base64.decode(n.displayValues, t.displayValues = $util.newBuffer($util.base64.length(n.displayValues)), 0) : n.displayValues.length >= 0 && (t.displayValues = n.displayValues)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.uuid = "", e.caption = "", e.styles = "", t.bytes === String ? e.displayValues = "" : (e.displayValues = [], t.bytes !== Array && (e.displayValues = $util.newBuffer(e.displayValues)))), n.uuid != null && n.hasOwnProperty("uuid") && (e.uuid = n.uuid), n.caption != null && n.hasOwnProperty("caption") && (e.caption = n.caption), n.styles != null && n.hasOwnProperty("styles") && (e.styles = n.styles), n.displayValues != null && n.hasOwnProperty("displayValues") && (e.displayValues = t.bytes === String ? $util.base64.encode(n.displayValues, 0, n.displayValues.length) : t.bytes === Array ? Array.prototype.slice.call(n.displayValues) : n.displayValues), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/ArrowTableStyler";
  }, r;
})();
$root.Balloons = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.show = !1, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.show != null && Object.hasOwnProperty.call(n, "show") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(n.show), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Balloons();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 3: {
          p.show = n.bool();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.show != null && n.hasOwnProperty("show") && typeof n.show != "boolean" ? "show: boolean expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Balloons)
      return n;
    let t = new $root.Balloons();
    return n.show != null && (t.show = !!n.show), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.show = !1), n.show != null && n.hasOwnProperty("show") && (e.show = n.show), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Balloons";
  }, r;
})();
$root.Block = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.vertical = null, r.prototype.horizontal = null, r.prototype.column = null, r.prototype.expandable = null, r.prototype.form = null, r.prototype.tabContainer = null, r.prototype.tab = null, r.prototype.chatMessage = null, r.prototype.popover = null, r.prototype.dialog = null, r.prototype.flexContainer = null, r.prototype.allowEmpty = !1, r.prototype.id = null, r.prototype.heightConfig = null, r.prototype.widthConfig = null;
  let c;
  return Object.defineProperty(r.prototype, "type", {
    get: $util.oneOfGetter(c = ["vertical", "horizontal", "column", "expandable", "form", "tabContainer", "tab", "chatMessage", "popover", "dialog", "flexContainer"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_id", {
    get: $util.oneOfGetter(c = ["id"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_heightConfig", {
    get: $util.oneOfGetter(c = ["heightConfig"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_widthConfig", {
    get: $util.oneOfGetter(c = ["widthConfig"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.vertical != null && Object.hasOwnProperty.call(t, "vertical") && $root.Block.Vertical.encode(t.vertical, e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), t.horizontal != null && Object.hasOwnProperty.call(t, "horizontal") && $root.Block.Horizontal.encode(t.horizontal, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), t.column != null && Object.hasOwnProperty.call(t, "column") && $root.Block.Column.encode(t.column, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), t.expandable != null && Object.hasOwnProperty.call(t, "expandable") && $root.Block.Expandable.encode(t.expandable, e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), t.form != null && Object.hasOwnProperty.call(t, "form") && $root.Block.Form.encode(t.form, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), t.tabContainer != null && Object.hasOwnProperty.call(t, "tabContainer") && $root.Block.TabContainer.encode(t.tabContainer, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), t.tab != null && Object.hasOwnProperty.call(t, "tab") && $root.Block.Tab.encode(t.tab, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), t.allowEmpty != null && Object.hasOwnProperty.call(t, "allowEmpty") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.allowEmpty), t.chatMessage != null && Object.hasOwnProperty.call(t, "chatMessage") && $root.Block.ChatMessage.encode(t.chatMessage, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), t.popover != null && Object.hasOwnProperty.call(t, "popover") && $root.Block.Popover.encode(t.popover, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), t.dialog != null && Object.hasOwnProperty.call(t, "dialog") && $root.Block.Dialog.encode(t.dialog, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(t.id), t.flexContainer != null && Object.hasOwnProperty.call(t, "flexContainer") && $root.Block.FlexContainer.encode(t.flexContainer, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), t.heightConfig != null && Object.hasOwnProperty.call(t, "heightConfig") && $root.streamlit.HeightConfig.encode(t.heightConfig, e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), t.widthConfig != null && Object.hasOwnProperty.call(t, "widthConfig") && $root.streamlit.WidthConfig.encode(t.widthConfig, e.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.Block();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.vertical = $root.Block.Vertical.decode(t, t.uint32());
          break;
        }
        case 2: {
          h.horizontal = $root.Block.Horizontal.decode(t, t.uint32());
          break;
        }
        case 3: {
          h.column = $root.Block.Column.decode(t, t.uint32());
          break;
        }
        case 4: {
          h.expandable = $root.Block.Expandable.decode(t, t.uint32());
          break;
        }
        case 5: {
          h.form = $root.Block.Form.decode(t, t.uint32());
          break;
        }
        case 6: {
          h.tabContainer = $root.Block.TabContainer.decode(t, t.uint32());
          break;
        }
        case 7: {
          h.tab = $root.Block.Tab.decode(t, t.uint32());
          break;
        }
        case 9: {
          h.chatMessage = $root.Block.ChatMessage.decode(t, t.uint32());
          break;
        }
        case 10: {
          h.popover = $root.Block.Popover.decode(t, t.uint32());
          break;
        }
        case 11: {
          h.dialog = $root.Block.Dialog.decode(t, t.uint32());
          break;
        }
        case 13: {
          h.flexContainer = $root.Block.FlexContainer.decode(t, t.uint32());
          break;
        }
        case 8: {
          h.allowEmpty = t.bool();
          break;
        }
        case 12: {
          h.id = t.string();
          break;
        }
        case 14: {
          h.heightConfig = $root.streamlit.HeightConfig.decode(t, t.uint32());
          break;
        }
        case 15: {
          h.widthConfig = $root.streamlit.WidthConfig.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    let e = {};
    if (t.vertical != null && t.hasOwnProperty("vertical")) {
      e.type = 1;
      {
        let o = $root.Block.Vertical.verify(t.vertical);
        if (o)
          return "vertical." + o;
      }
    }
    if (t.horizontal != null && t.hasOwnProperty("horizontal")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Block.Horizontal.verify(t.horizontal);
        if (o)
          return "horizontal." + o;
      }
    }
    if (t.column != null && t.hasOwnProperty("column")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Block.Column.verify(t.column);
        if (o)
          return "column." + o;
      }
    }
    if (t.expandable != null && t.hasOwnProperty("expandable")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Block.Expandable.verify(t.expandable);
        if (o)
          return "expandable." + o;
      }
    }
    if (t.form != null && t.hasOwnProperty("form")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Block.Form.verify(t.form);
        if (o)
          return "form." + o;
      }
    }
    if (t.tabContainer != null && t.hasOwnProperty("tabContainer")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Block.TabContainer.verify(t.tabContainer);
        if (o)
          return "tabContainer." + o;
      }
    }
    if (t.tab != null && t.hasOwnProperty("tab")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Block.Tab.verify(t.tab);
        if (o)
          return "tab." + o;
      }
    }
    if (t.chatMessage != null && t.hasOwnProperty("chatMessage")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Block.ChatMessage.verify(t.chatMessage);
        if (o)
          return "chatMessage." + o;
      }
    }
    if (t.popover != null && t.hasOwnProperty("popover")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Block.Popover.verify(t.popover);
        if (o)
          return "popover." + o;
      }
    }
    if (t.dialog != null && t.hasOwnProperty("dialog")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Block.Dialog.verify(t.dialog);
        if (o)
          return "dialog." + o;
      }
    }
    if (t.flexContainer != null && t.hasOwnProperty("flexContainer")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Block.FlexContainer.verify(t.flexContainer);
        if (o)
          return "flexContainer." + o;
      }
    }
    if (t.allowEmpty != null && t.hasOwnProperty("allowEmpty") && typeof t.allowEmpty != "boolean")
      return "allowEmpty: boolean expected";
    if (t.id != null && t.hasOwnProperty("id") && (e._id = 1, !$util.isString(t.id)))
      return "id: string expected";
    if (t.heightConfig != null && t.hasOwnProperty("heightConfig")) {
      e._heightConfig = 1;
      {
        let o = $root.streamlit.HeightConfig.verify(t.heightConfig);
        if (o)
          return "heightConfig." + o;
      }
    }
    if (t.widthConfig != null && t.hasOwnProperty("widthConfig")) {
      e._widthConfig = 1;
      {
        let o = $root.streamlit.WidthConfig.verify(t.widthConfig);
        if (o)
          return "widthConfig." + o;
      }
    }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.Block)
      return t;
    let e = new $root.Block();
    if (t.vertical != null) {
      if (typeof t.vertical != "object")
        throw TypeError(".Block.vertical: object expected");
      e.vertical = $root.Block.Vertical.fromObject(t.vertical);
    }
    if (t.horizontal != null) {
      if (typeof t.horizontal != "object")
        throw TypeError(".Block.horizontal: object expected");
      e.horizontal = $root.Block.Horizontal.fromObject(t.horizontal);
    }
    if (t.column != null) {
      if (typeof t.column != "object")
        throw TypeError(".Block.column: object expected");
      e.column = $root.Block.Column.fromObject(t.column);
    }
    if (t.expandable != null) {
      if (typeof t.expandable != "object")
        throw TypeError(".Block.expandable: object expected");
      e.expandable = $root.Block.Expandable.fromObject(t.expandable);
    }
    if (t.form != null) {
      if (typeof t.form != "object")
        throw TypeError(".Block.form: object expected");
      e.form = $root.Block.Form.fromObject(t.form);
    }
    if (t.tabContainer != null) {
      if (typeof t.tabContainer != "object")
        throw TypeError(".Block.tabContainer: object expected");
      e.tabContainer = $root.Block.TabContainer.fromObject(t.tabContainer);
    }
    if (t.tab != null) {
      if (typeof t.tab != "object")
        throw TypeError(".Block.tab: object expected");
      e.tab = $root.Block.Tab.fromObject(t.tab);
    }
    if (t.chatMessage != null) {
      if (typeof t.chatMessage != "object")
        throw TypeError(".Block.chatMessage: object expected");
      e.chatMessage = $root.Block.ChatMessage.fromObject(t.chatMessage);
    }
    if (t.popover != null) {
      if (typeof t.popover != "object")
        throw TypeError(".Block.popover: object expected");
      e.popover = $root.Block.Popover.fromObject(t.popover);
    }
    if (t.dialog != null) {
      if (typeof t.dialog != "object")
        throw TypeError(".Block.dialog: object expected");
      e.dialog = $root.Block.Dialog.fromObject(t.dialog);
    }
    if (t.flexContainer != null) {
      if (typeof t.flexContainer != "object")
        throw TypeError(".Block.flexContainer: object expected");
      e.flexContainer = $root.Block.FlexContainer.fromObject(t.flexContainer);
    }
    if (t.allowEmpty != null && (e.allowEmpty = !!t.allowEmpty), t.id != null && (e.id = String(t.id)), t.heightConfig != null) {
      if (typeof t.heightConfig != "object")
        throw TypeError(".Block.heightConfig: object expected");
      e.heightConfig = $root.streamlit.HeightConfig.fromObject(t.heightConfig);
    }
    if (t.widthConfig != null) {
      if (typeof t.widthConfig != "object")
        throw TypeError(".Block.widthConfig: object expected");
      e.widthConfig = $root.streamlit.WidthConfig.fromObject(t.widthConfig);
    }
    return e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.allowEmpty = !1), t.vertical != null && t.hasOwnProperty("vertical") && (o.vertical = $root.Block.Vertical.toObject(t.vertical, e), e.oneofs && (o.type = "vertical")), t.horizontal != null && t.hasOwnProperty("horizontal") && (o.horizontal = $root.Block.Horizontal.toObject(t.horizontal, e), e.oneofs && (o.type = "horizontal")), t.column != null && t.hasOwnProperty("column") && (o.column = $root.Block.Column.toObject(t.column, e), e.oneofs && (o.type = "column")), t.expandable != null && t.hasOwnProperty("expandable") && (o.expandable = $root.Block.Expandable.toObject(t.expandable, e), e.oneofs && (o.type = "expandable")), t.form != null && t.hasOwnProperty("form") && (o.form = $root.Block.Form.toObject(t.form, e), e.oneofs && (o.type = "form")), t.tabContainer != null && t.hasOwnProperty("tabContainer") && (o.tabContainer = $root.Block.TabContainer.toObject(t.tabContainer, e), e.oneofs && (o.type = "tabContainer")), t.tab != null && t.hasOwnProperty("tab") && (o.tab = $root.Block.Tab.toObject(t.tab, e), e.oneofs && (o.type = "tab")), t.allowEmpty != null && t.hasOwnProperty("allowEmpty") && (o.allowEmpty = t.allowEmpty), t.chatMessage != null && t.hasOwnProperty("chatMessage") && (o.chatMessage = $root.Block.ChatMessage.toObject(t.chatMessage, e), e.oneofs && (o.type = "chatMessage")), t.popover != null && t.hasOwnProperty("popover") && (o.popover = $root.Block.Popover.toObject(t.popover, e), e.oneofs && (o.type = "popover")), t.dialog != null && t.hasOwnProperty("dialog") && (o.dialog = $root.Block.Dialog.toObject(t.dialog, e), e.oneofs && (o.type = "dialog")), t.id != null && t.hasOwnProperty("id") && (o.id = t.id, e.oneofs && (o._id = "id")), t.flexContainer != null && t.hasOwnProperty("flexContainer") && (o.flexContainer = $root.Block.FlexContainer.toObject(t.flexContainer, e), e.oneofs && (o.type = "flexContainer")), t.heightConfig != null && t.hasOwnProperty("heightConfig") && (o.heightConfig = $root.streamlit.HeightConfig.toObject(t.heightConfig, e), e.oneofs && (o._heightConfig = "heightConfig")), t.widthConfig != null && t.hasOwnProperty("widthConfig") && (o.widthConfig = $root.streamlit.WidthConfig.toObject(t.widthConfig, e), e.oneofs && (o._widthConfig = "widthConfig")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Block";
  }, r.Vertical = (function() {
    function n(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    return n.prototype.border = !1, n.prototype.height = 0, n.create = function(e) {
      return new n(e);
    }, n.encode = function(e, o) {
      return o || (o = $Writer.create()), e.border != null && Object.hasOwnProperty.call(e, "border") && o.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.border), e.height != null && Object.hasOwnProperty.call(e, "height") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint32(e.height), o;
    }, n.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, n.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.Block.Vertical();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.border = e.bool();
            break;
          }
          case 2: {
            y.height = e.uint32();
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, n.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, n.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.border != null && e.hasOwnProperty("border") && typeof e.border != "boolean" ? "border: boolean expected" : e.height != null && e.hasOwnProperty("height") && !$util.isInteger(e.height) ? "height: integer expected" : null;
    }, n.fromObject = function(e) {
      if (e instanceof $root.Block.Vertical)
        return e;
      let o = new $root.Block.Vertical();
      return e.border != null && (o.border = !!e.border), e.height != null && (o.height = e.height >>> 0), o;
    }, n.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return o.defaults && (p.border = !1, p.height = 0), e.border != null && e.hasOwnProperty("border") && (p.border = e.border), e.height != null && e.hasOwnProperty("height") && (p.height = e.height), p;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, n.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Vertical";
    }, n;
  })(), r.Horizontal = (function() {
    function n(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    return n.prototype.gap = "", n.create = function(e) {
      return new n(e);
    }, n.encode = function(e, o) {
      return o || (o = $Writer.create()), e.gap != null && Object.hasOwnProperty.call(e, "gap") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.gap), o;
    }, n.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, n.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.Block.Horizontal();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.gap = e.string();
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, n.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, n.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.gap != null && e.hasOwnProperty("gap") && !$util.isString(e.gap) ? "gap: string expected" : null;
    }, n.fromObject = function(e) {
      if (e instanceof $root.Block.Horizontal)
        return e;
      let o = new $root.Block.Horizontal();
      return e.gap != null && (o.gap = String(e.gap)), o;
    }, n.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return o.defaults && (p.gap = ""), e.gap != null && e.hasOwnProperty("gap") && (p.gap = e.gap), p;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, n.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Horizontal";
    }, n;
  })(), r.FlexContainer = (function() {
    function n(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    return n.prototype.border = !1, n.prototype.gapConfig = null, n.prototype.scale = 0, n.prototype.direction = 0, n.prototype.wrap = !1, n.prototype.justify = 0, n.prototype.align = 0, n.create = function(e) {
      return new n(e);
    }, n.encode = function(e, o) {
      return o || (o = $Writer.create()), e.border != null && Object.hasOwnProperty.call(e, "border") && o.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.border), e.gapConfig != null && Object.hasOwnProperty.call(e, "gapConfig") && $root.streamlit.GapConfig.encode(e.gapConfig, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.scale != null && Object.hasOwnProperty.call(e, "scale") && o.uint32(
        /* id 3, wireType 5 =*/
        29
      ).float(e.scale), e.direction != null && Object.hasOwnProperty.call(e, "direction") && o.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(e.direction), e.wrap != null && Object.hasOwnProperty.call(e, "wrap") && o.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(e.wrap), e.justify != null && Object.hasOwnProperty.call(e, "justify") && o.uint32(
        /* id 7, wireType 0 =*/
        56
      ).int32(e.justify), e.align != null && Object.hasOwnProperty.call(e, "align") && o.uint32(
        /* id 8, wireType 0 =*/
        64
      ).int32(e.align), o;
    }, n.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, n.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.Block.FlexContainer();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.border = e.bool();
            break;
          }
          case 2: {
            y.gapConfig = $root.streamlit.GapConfig.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.scale = e.float();
            break;
          }
          case 4: {
            y.direction = e.int32();
            break;
          }
          case 5: {
            y.wrap = e.bool();
            break;
          }
          case 7: {
            y.justify = e.int32();
            break;
          }
          case 8: {
            y.align = e.int32();
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, n.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, n.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.border != null && e.hasOwnProperty("border") && typeof e.border != "boolean")
        return "border: boolean expected";
      if (e.gapConfig != null && e.hasOwnProperty("gapConfig")) {
        let o = $root.streamlit.GapConfig.verify(e.gapConfig);
        if (o)
          return "gapConfig." + o;
      }
      if (e.scale != null && e.hasOwnProperty("scale") && typeof e.scale != "number")
        return "scale: number expected";
      if (e.direction != null && e.hasOwnProperty("direction"))
        switch (e.direction) {
          default:
            return "direction: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (e.wrap != null && e.hasOwnProperty("wrap") && typeof e.wrap != "boolean")
        return "wrap: boolean expected";
      if (e.justify != null && e.hasOwnProperty("justify"))
        switch (e.justify) {
          default:
            return "justify: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      if (e.align != null && e.hasOwnProperty("align"))
        switch (e.align) {
          default:
            return "align: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      return null;
    }, n.fromObject = function(e) {
      if (e instanceof $root.Block.FlexContainer)
        return e;
      let o = new $root.Block.FlexContainer();
      if (e.border != null && (o.border = !!e.border), e.gapConfig != null) {
        if (typeof e.gapConfig != "object")
          throw TypeError(".Block.FlexContainer.gapConfig: object expected");
        o.gapConfig = $root.streamlit.GapConfig.fromObject(e.gapConfig);
      }
      switch (e.scale != null && (o.scale = Number(e.scale)), e.direction) {
        default:
          if (typeof e.direction == "number") {
            o.direction = e.direction;
            break;
          }
          break;
        case "DIRECTION_UNDEFINED":
        case 0:
          o.direction = 0;
          break;
        case "VERTICAL":
        case 1:
          o.direction = 1;
          break;
        case "HORIZONTAL":
        case 2:
          o.direction = 2;
          break;
      }
      switch (e.wrap != null && (o.wrap = !!e.wrap), e.justify) {
        default:
          if (typeof e.justify == "number") {
            o.justify = e.justify;
            break;
          }
          break;
        case "JUSTIFY_UNDEFINED":
        case 0:
          o.justify = 0;
          break;
        case "JUSTIFY_START":
        case 1:
          o.justify = 1;
          break;
        case "JUSTIFY_END":
        case 2:
          o.justify = 2;
          break;
        case "JUSTIFY_CENTER":
        case 3:
          o.justify = 3;
          break;
        case "SPACE_BETWEEN":
        case 4:
          o.justify = 4;
          break;
      }
      switch (e.align) {
        default:
          if (typeof e.align == "number") {
            o.align = e.align;
            break;
          }
          break;
        case "ALIGN_UNDEFINED":
        case 0:
          o.align = 0;
          break;
        case "ALIGN_START":
        case 1:
          o.align = 1;
          break;
        case "ALIGN_END":
        case 2:
          o.align = 2;
          break;
        case "ALIGN_CENTER":
        case 3:
          o.align = 3;
          break;
        case "STRETCH":
        case 4:
          o.align = 4;
          break;
      }
      return o;
    }, n.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return o.defaults && (p.border = !1, p.gapConfig = null, p.scale = 0, p.direction = o.enums === String ? "DIRECTION_UNDEFINED" : 0, p.wrap = !1, p.justify = o.enums === String ? "JUSTIFY_UNDEFINED" : 0, p.align = o.enums === String ? "ALIGN_UNDEFINED" : 0), e.border != null && e.hasOwnProperty("border") && (p.border = e.border), e.gapConfig != null && e.hasOwnProperty("gapConfig") && (p.gapConfig = $root.streamlit.GapConfig.toObject(e.gapConfig, o)), e.scale != null && e.hasOwnProperty("scale") && (p.scale = o.json && !isFinite(e.scale) ? String(e.scale) : e.scale), e.direction != null && e.hasOwnProperty("direction") && (p.direction = o.enums === String ? $root.Block.FlexContainer.Direction[e.direction] === void 0 ? e.direction : $root.Block.FlexContainer.Direction[e.direction] : e.direction), e.wrap != null && e.hasOwnProperty("wrap") && (p.wrap = e.wrap), e.justify != null && e.hasOwnProperty("justify") && (p.justify = o.enums === String ? $root.Block.FlexContainer.Justify[e.justify] === void 0 ? e.justify : $root.Block.FlexContainer.Justify[e.justify] : e.justify), e.align != null && e.hasOwnProperty("align") && (p.align = o.enums === String ? $root.Block.FlexContainer.Align[e.align] === void 0 ? e.align : $root.Block.FlexContainer.Align[e.align] : e.align), p;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, n.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.FlexContainer";
    }, n.Direction = (function() {
      const t = {}, e = Object.create(t);
      return e[t[0] = "DIRECTION_UNDEFINED"] = 0, e[t[1] = "VERTICAL"] = 1, e[t[2] = "HORIZONTAL"] = 2, e;
    })(), n.Justify = (function() {
      const t = {}, e = Object.create(t);
      return e[t[0] = "JUSTIFY_UNDEFINED"] = 0, e[t[1] = "JUSTIFY_START"] = 1, e[t[2] = "JUSTIFY_END"] = 2, e[t[3] = "JUSTIFY_CENTER"] = 3, e[t[4] = "SPACE_BETWEEN"] = 4, e;
    })(), n.Align = (function() {
      const t = {}, e = Object.create(t);
      return e[t[0] = "ALIGN_UNDEFINED"] = 0, e[t[1] = "ALIGN_START"] = 1, e[t[2] = "ALIGN_END"] = 2, e[t[3] = "ALIGN_CENTER"] = 3, e[t[4] = "STRETCH"] = 4, e;
    })(), n;
  })(), r.Column = (function() {
    function n(e) {
      if (e)
        for (let o = Object.keys(e), p = 0; p < o.length; ++p)
          e[o[p]] != null && (this[o[p]] = e[o[p]]);
    }
    n.prototype.weight = 0, n.prototype.gap = "", n.prototype.verticalAlignment = 0, n.prototype.showBorder = !1, n.prototype.gapConfig = null;
    let t;
    return Object.defineProperty(n.prototype, "_gapConfig", {
      get: $util.oneOfGetter(t = ["gapConfig"]),
      set: $util.oneOfSetter(t)
    }), n.create = function(o) {
      return new n(o);
    }, n.encode = function(o, p) {
      return p || (p = $Writer.create()), o.weight != null && Object.hasOwnProperty.call(o, "weight") && p.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(o.weight), o.gap != null && Object.hasOwnProperty.call(o, "gap") && p.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(o.gap), o.verticalAlignment != null && Object.hasOwnProperty.call(o, "verticalAlignment") && p.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(o.verticalAlignment), o.showBorder != null && Object.hasOwnProperty.call(o, "showBorder") && p.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(o.showBorder), o.gapConfig != null && Object.hasOwnProperty.call(o, "gapConfig") && $root.streamlit.GapConfig.encode(o.gapConfig, p.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), p;
    }, n.encodeDelimited = function(o, p) {
      return this.encode(o, p).ldelim();
    }, n.decode = function(o, p, h) {
      o instanceof $Reader || (o = $Reader.create(o));
      let y = p === void 0 ? o.len : o.pos + p, b = new $root.Block.Column();
      for (; o.pos < y; ) {
        let O = o.uint32();
        if (O === h)
          break;
        switch (O >>> 3) {
          case 1: {
            b.weight = o.double();
            break;
          }
          case 2: {
            b.gap = o.string();
            break;
          }
          case 3: {
            b.verticalAlignment = o.int32();
            break;
          }
          case 4: {
            b.showBorder = o.bool();
            break;
          }
          case 5: {
            b.gapConfig = $root.streamlit.GapConfig.decode(o, o.uint32());
            break;
          }
          default:
            o.skipType(O & 7);
            break;
        }
      }
      return b;
    }, n.decodeDelimited = function(o) {
      return o instanceof $Reader || (o = new $Reader(o)), this.decode(o, o.uint32());
    }, n.verify = function(o) {
      if (typeof o != "object" || o === null)
        return "object expected";
      if (o.weight != null && o.hasOwnProperty("weight") && typeof o.weight != "number")
        return "weight: number expected";
      if (o.gap != null && o.hasOwnProperty("gap") && !$util.isString(o.gap))
        return "gap: string expected";
      if (o.verticalAlignment != null && o.hasOwnProperty("verticalAlignment"))
        switch (o.verticalAlignment) {
          default:
            return "verticalAlignment: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      if (o.showBorder != null && o.hasOwnProperty("showBorder") && typeof o.showBorder != "boolean")
        return "showBorder: boolean expected";
      if (o.gapConfig != null && o.hasOwnProperty("gapConfig")) {
        let p = $root.streamlit.GapConfig.verify(o.gapConfig);
        if (p)
          return "gapConfig." + p;
      }
      return null;
    }, n.fromObject = function(o) {
      if (o instanceof $root.Block.Column)
        return o;
      let p = new $root.Block.Column();
      switch (o.weight != null && (p.weight = Number(o.weight)), o.gap != null && (p.gap = String(o.gap)), o.verticalAlignment) {
        default:
          if (typeof o.verticalAlignment == "number") {
            p.verticalAlignment = o.verticalAlignment;
            break;
          }
          break;
        case "TOP":
        case 0:
          p.verticalAlignment = 0;
          break;
        case "CENTER":
        case 1:
          p.verticalAlignment = 1;
          break;
        case "BOTTOM":
        case 2:
          p.verticalAlignment = 2;
          break;
      }
      if (o.showBorder != null && (p.showBorder = !!o.showBorder), o.gapConfig != null) {
        if (typeof o.gapConfig != "object")
          throw TypeError(".Block.Column.gapConfig: object expected");
        p.gapConfig = $root.streamlit.GapConfig.fromObject(o.gapConfig);
      }
      return p;
    }, n.toObject = function(o, p) {
      p || (p = {});
      let h = {};
      return p.defaults && (h.weight = 0, h.gap = "", h.verticalAlignment = p.enums === String ? "TOP" : 0, h.showBorder = !1), o.weight != null && o.hasOwnProperty("weight") && (h.weight = p.json && !isFinite(o.weight) ? String(o.weight) : o.weight), o.gap != null && o.hasOwnProperty("gap") && (h.gap = o.gap), o.verticalAlignment != null && o.hasOwnProperty("verticalAlignment") && (h.verticalAlignment = p.enums === String ? $root.Block.Column.VerticalAlignment[o.verticalAlignment] === void 0 ? o.verticalAlignment : $root.Block.Column.VerticalAlignment[o.verticalAlignment] : o.verticalAlignment), o.showBorder != null && o.hasOwnProperty("showBorder") && (h.showBorder = o.showBorder), o.gapConfig != null && o.hasOwnProperty("gapConfig") && (h.gapConfig = $root.streamlit.GapConfig.toObject(o.gapConfig, p), p.oneofs && (h._gapConfig = "gapConfig")), h;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, n.getTypeUrl = function(o) {
      return o === void 0 && (o = "type.googleapis.com"), o + "/Block.Column";
    }, n.VerticalAlignment = (function() {
      const e = {}, o = Object.create(e);
      return o[e[0] = "TOP"] = 0, o[e[1] = "CENTER"] = 1, o[e[2] = "BOTTOM"] = 2, o;
    })(), n;
  })(), r.Expandable = (function() {
    function n(e) {
      if (e)
        for (let o = Object.keys(e), p = 0; p < o.length; ++p)
          e[o[p]] != null && (this[o[p]] = e[o[p]]);
    }
    n.prototype.label = "", n.prototype.expanded = null, n.prototype.icon = "";
    let t;
    return Object.defineProperty(n.prototype, "_expanded", {
      get: $util.oneOfGetter(t = ["expanded"]),
      set: $util.oneOfSetter(t)
    }), n.create = function(o) {
      return new n(o);
    }, n.encode = function(o, p) {
      return p || (p = $Writer.create()), o.label != null && Object.hasOwnProperty.call(o, "label") && p.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(o.label), o.expanded != null && Object.hasOwnProperty.call(o, "expanded") && p.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(o.expanded), o.icon != null && Object.hasOwnProperty.call(o, "icon") && p.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(o.icon), p;
    }, n.encodeDelimited = function(o, p) {
      return this.encode(o, p).ldelim();
    }, n.decode = function(o, p, h) {
      o instanceof $Reader || (o = $Reader.create(o));
      let y = p === void 0 ? o.len : o.pos + p, b = new $root.Block.Expandable();
      for (; o.pos < y; ) {
        let O = o.uint32();
        if (O === h)
          break;
        switch (O >>> 3) {
          case 1: {
            b.label = o.string();
            break;
          }
          case 2: {
            b.expanded = o.bool();
            break;
          }
          case 3: {
            b.icon = o.string();
            break;
          }
          default:
            o.skipType(O & 7);
            break;
        }
      }
      return b;
    }, n.decodeDelimited = function(o) {
      return o instanceof $Reader || (o = new $Reader(o)), this.decode(o, o.uint32());
    }, n.verify = function(o) {
      return typeof o != "object" || o === null ? "object expected" : o.label != null && o.hasOwnProperty("label") && !$util.isString(o.label) ? "label: string expected" : o.expanded != null && o.hasOwnProperty("expanded") && typeof o.expanded != "boolean" ? "expanded: boolean expected" : o.icon != null && o.hasOwnProperty("icon") && !$util.isString(o.icon) ? "icon: string expected" : null;
    }, n.fromObject = function(o) {
      if (o instanceof $root.Block.Expandable)
        return o;
      let p = new $root.Block.Expandable();
      return o.label != null && (p.label = String(o.label)), o.expanded != null && (p.expanded = !!o.expanded), o.icon != null && (p.icon = String(o.icon)), p;
    }, n.toObject = function(o, p) {
      p || (p = {});
      let h = {};
      return p.defaults && (h.label = "", h.icon = ""), o.label != null && o.hasOwnProperty("label") && (h.label = o.label), o.expanded != null && o.hasOwnProperty("expanded") && (h.expanded = o.expanded, p.oneofs && (h._expanded = "expanded")), o.icon != null && o.hasOwnProperty("icon") && (h.icon = o.icon), h;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, n.getTypeUrl = function(o) {
      return o === void 0 && (o = "type.googleapis.com"), o + "/Block.Expandable";
    }, n;
  })(), r.Dialog = (function() {
    function n(e) {
      if (e)
        for (let o = Object.keys(e), p = 0; p < o.length; ++p)
          e[o[p]] != null && (this[o[p]] = e[o[p]]);
    }
    n.prototype.title = "", n.prototype.dismissible = !1, n.prototype.width = 0, n.prototype.isOpen = null, n.prototype.id = "";
    let t;
    return Object.defineProperty(n.prototype, "_isOpen", {
      get: $util.oneOfGetter(t = ["isOpen"]),
      set: $util.oneOfSetter(t)
    }), n.create = function(o) {
      return new n(o);
    }, n.encode = function(o, p) {
      return p || (p = $Writer.create()), o.title != null && Object.hasOwnProperty.call(o, "title") && p.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(o.title), o.dismissible != null && Object.hasOwnProperty.call(o, "dismissible") && p.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(o.dismissible), o.width != null && Object.hasOwnProperty.call(o, "width") && p.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(o.width), o.isOpen != null && Object.hasOwnProperty.call(o, "isOpen") && p.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(o.isOpen), o.id != null && Object.hasOwnProperty.call(o, "id") && p.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(o.id), p;
    }, n.encodeDelimited = function(o, p) {
      return this.encode(o, p).ldelim();
    }, n.decode = function(o, p, h) {
      o instanceof $Reader || (o = $Reader.create(o));
      let y = p === void 0 ? o.len : o.pos + p, b = new $root.Block.Dialog();
      for (; o.pos < y; ) {
        let O = o.uint32();
        if (O === h)
          break;
        switch (O >>> 3) {
          case 1: {
            b.title = o.string();
            break;
          }
          case 2: {
            b.dismissible = o.bool();
            break;
          }
          case 3: {
            b.width = o.int32();
            break;
          }
          case 4: {
            b.isOpen = o.bool();
            break;
          }
          case 5: {
            b.id = o.string();
            break;
          }
          default:
            o.skipType(O & 7);
            break;
        }
      }
      return b;
    }, n.decodeDelimited = function(o) {
      return o instanceof $Reader || (o = new $Reader(o)), this.decode(o, o.uint32());
    }, n.verify = function(o) {
      if (typeof o != "object" || o === null)
        return "object expected";
      if (o.title != null && o.hasOwnProperty("title") && !$util.isString(o.title))
        return "title: string expected";
      if (o.dismissible != null && o.hasOwnProperty("dismissible") && typeof o.dismissible != "boolean")
        return "dismissible: boolean expected";
      if (o.width != null && o.hasOwnProperty("width"))
        switch (o.width) {
          default:
            return "width: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      return o.isOpen != null && o.hasOwnProperty("isOpen") && typeof o.isOpen != "boolean" ? "isOpen: boolean expected" : o.id != null && o.hasOwnProperty("id") && !$util.isString(o.id) ? "id: string expected" : null;
    }, n.fromObject = function(o) {
      if (o instanceof $root.Block.Dialog)
        return o;
      let p = new $root.Block.Dialog();
      switch (o.title != null && (p.title = String(o.title)), o.dismissible != null && (p.dismissible = !!o.dismissible), o.width) {
        default:
          if (typeof o.width == "number") {
            p.width = o.width;
            break;
          }
          break;
        case "SMALL":
        case 0:
          p.width = 0;
          break;
        case "LARGE":
        case 1:
          p.width = 1;
          break;
        case "MEDIUM":
        case 2:
          p.width = 2;
          break;
      }
      return o.isOpen != null && (p.isOpen = !!o.isOpen), o.id != null && (p.id = String(o.id)), p;
    }, n.toObject = function(o, p) {
      p || (p = {});
      let h = {};
      return p.defaults && (h.title = "", h.dismissible = !1, h.width = p.enums === String ? "SMALL" : 0, h.id = ""), o.title != null && o.hasOwnProperty("title") && (h.title = o.title), o.dismissible != null && o.hasOwnProperty("dismissible") && (h.dismissible = o.dismissible), o.width != null && o.hasOwnProperty("width") && (h.width = p.enums === String ? $root.Block.Dialog.DialogWidth[o.width] === void 0 ? o.width : $root.Block.Dialog.DialogWidth[o.width] : o.width), o.isOpen != null && o.hasOwnProperty("isOpen") && (h.isOpen = o.isOpen, p.oneofs && (h._isOpen = "isOpen")), o.id != null && o.hasOwnProperty("id") && (h.id = o.id), h;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, n.getTypeUrl = function(o) {
      return o === void 0 && (o = "type.googleapis.com"), o + "/Block.Dialog";
    }, n.DialogWidth = (function() {
      const e = {}, o = Object.create(e);
      return o[e[0] = "SMALL"] = 0, o[e[1] = "LARGE"] = 1, o[e[2] = "MEDIUM"] = 2, o;
    })(), n;
  })(), r.Form = (function() {
    function n(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    return n.prototype.formId = "", n.prototype.clearOnSubmit = !1, n.prototype.border = !1, n.prototype.enterToSubmit = !1, n.create = function(e) {
      return new n(e);
    }, n.encode = function(e, o) {
      return o || (o = $Writer.create()), e.formId != null && Object.hasOwnProperty.call(e, "formId") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.formId), e.clearOnSubmit != null && Object.hasOwnProperty.call(e, "clearOnSubmit") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.clearOnSubmit), e.border != null && Object.hasOwnProperty.call(e, "border") && o.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.border), e.enterToSubmit != null && Object.hasOwnProperty.call(e, "enterToSubmit") && o.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.enterToSubmit), o;
    }, n.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, n.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.Block.Form();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.formId = e.string();
            break;
          }
          case 2: {
            y.clearOnSubmit = e.bool();
            break;
          }
          case 3: {
            y.border = e.bool();
            break;
          }
          case 4: {
            y.enterToSubmit = e.bool();
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, n.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, n.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.formId != null && e.hasOwnProperty("formId") && !$util.isString(e.formId) ? "formId: string expected" : e.clearOnSubmit != null && e.hasOwnProperty("clearOnSubmit") && typeof e.clearOnSubmit != "boolean" ? "clearOnSubmit: boolean expected" : e.border != null && e.hasOwnProperty("border") && typeof e.border != "boolean" ? "border: boolean expected" : e.enterToSubmit != null && e.hasOwnProperty("enterToSubmit") && typeof e.enterToSubmit != "boolean" ? "enterToSubmit: boolean expected" : null;
    }, n.fromObject = function(e) {
      if (e instanceof $root.Block.Form)
        return e;
      let o = new $root.Block.Form();
      return e.formId != null && (o.formId = String(e.formId)), e.clearOnSubmit != null && (o.clearOnSubmit = !!e.clearOnSubmit), e.border != null && (o.border = !!e.border), e.enterToSubmit != null && (o.enterToSubmit = !!e.enterToSubmit), o;
    }, n.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return o.defaults && (p.formId = "", p.clearOnSubmit = !1, p.border = !1, p.enterToSubmit = !1), e.formId != null && e.hasOwnProperty("formId") && (p.formId = e.formId), e.clearOnSubmit != null && e.hasOwnProperty("clearOnSubmit") && (p.clearOnSubmit = e.clearOnSubmit), e.border != null && e.hasOwnProperty("border") && (p.border = e.border), e.enterToSubmit != null && e.hasOwnProperty("enterToSubmit") && (p.enterToSubmit = e.enterToSubmit), p;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, n.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Form";
    }, n;
  })(), r.TabContainer = (function() {
    function n(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    return n.prototype.defaultTabIndex = 0, n.create = function(e) {
      return new n(e);
    }, n.encode = function(e, o) {
      return o || (o = $Writer.create()), e.defaultTabIndex != null && Object.hasOwnProperty.call(e, "defaultTabIndex") && o.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.defaultTabIndex), o;
    }, n.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, n.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.Block.TabContainer();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.defaultTabIndex = e.int32();
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, n.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, n.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.defaultTabIndex != null && e.hasOwnProperty("defaultTabIndex") && !$util.isInteger(e.defaultTabIndex) ? "defaultTabIndex: integer expected" : null;
    }, n.fromObject = function(e) {
      if (e instanceof $root.Block.TabContainer)
        return e;
      let o = new $root.Block.TabContainer();
      return e.defaultTabIndex != null && (o.defaultTabIndex = e.defaultTabIndex | 0), o;
    }, n.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return o.defaults && (p.defaultTabIndex = 0), e.defaultTabIndex != null && e.hasOwnProperty("defaultTabIndex") && (p.defaultTabIndex = e.defaultTabIndex), p;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, n.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.TabContainer";
    }, n;
  })(), r.Tab = (function() {
    function n(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    return n.prototype.label = "", n.create = function(e) {
      return new n(e);
    }, n.encode = function(e, o) {
      return o || (o = $Writer.create()), e.label != null && Object.hasOwnProperty.call(e, "label") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.label), o;
    }, n.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, n.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.Block.Tab();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.label = e.string();
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, n.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, n.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.label != null && e.hasOwnProperty("label") && !$util.isString(e.label) ? "label: string expected" : null;
    }, n.fromObject = function(e) {
      if (e instanceof $root.Block.Tab)
        return e;
      let o = new $root.Block.Tab();
      return e.label != null && (o.label = String(e.label)), o;
    }, n.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return o.defaults && (p.label = ""), e.label != null && e.hasOwnProperty("label") && (p.label = e.label), p;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, n.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Tab";
    }, n;
  })(), r.Popover = (function() {
    function n(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    return n.prototype.label = "", n.prototype.useContainerWidth = !1, n.prototype.help = "", n.prototype.disabled = !1, n.prototype.icon = "", n.create = function(e) {
      return new n(e);
    }, n.encode = function(e, o) {
      return o || (o = $Writer.create()), e.label != null && Object.hasOwnProperty.call(e, "label") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.label), e.useContainerWidth != null && Object.hasOwnProperty.call(e, "useContainerWidth") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.useContainerWidth), e.help != null && Object.hasOwnProperty.call(e, "help") && o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.help), e.disabled != null && Object.hasOwnProperty.call(e, "disabled") && o.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.disabled), e.icon != null && Object.hasOwnProperty.call(e, "icon") && o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(e.icon), o;
    }, n.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, n.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.Block.Popover();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.label = e.string();
            break;
          }
          case 2: {
            y.useContainerWidth = e.bool();
            break;
          }
          case 3: {
            y.help = e.string();
            break;
          }
          case 4: {
            y.disabled = e.bool();
            break;
          }
          case 5: {
            y.icon = e.string();
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, n.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, n.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.label != null && e.hasOwnProperty("label") && !$util.isString(e.label) ? "label: string expected" : e.useContainerWidth != null && e.hasOwnProperty("useContainerWidth") && typeof e.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : e.help != null && e.hasOwnProperty("help") && !$util.isString(e.help) ? "help: string expected" : e.disabled != null && e.hasOwnProperty("disabled") && typeof e.disabled != "boolean" ? "disabled: boolean expected" : e.icon != null && e.hasOwnProperty("icon") && !$util.isString(e.icon) ? "icon: string expected" : null;
    }, n.fromObject = function(e) {
      if (e instanceof $root.Block.Popover)
        return e;
      let o = new $root.Block.Popover();
      return e.label != null && (o.label = String(e.label)), e.useContainerWidth != null && (o.useContainerWidth = !!e.useContainerWidth), e.help != null && (o.help = String(e.help)), e.disabled != null && (o.disabled = !!e.disabled), e.icon != null && (o.icon = String(e.icon)), o;
    }, n.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return o.defaults && (p.label = "", p.useContainerWidth = !1, p.help = "", p.disabled = !1, p.icon = ""), e.label != null && e.hasOwnProperty("label") && (p.label = e.label), e.useContainerWidth != null && e.hasOwnProperty("useContainerWidth") && (p.useContainerWidth = e.useContainerWidth), e.help != null && e.hasOwnProperty("help") && (p.help = e.help), e.disabled != null && e.hasOwnProperty("disabled") && (p.disabled = e.disabled), e.icon != null && e.hasOwnProperty("icon") && (p.icon = e.icon), p;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, n.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.Popover";
    }, n;
  })(), r.ChatMessage = (function() {
    function n(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    return n.prototype.name = "", n.prototype.avatar = "", n.prototype.avatarType = 0, n.create = function(e) {
      return new n(e);
    }, n.encode = function(e, o) {
      return o || (o = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), e.avatar != null && Object.hasOwnProperty.call(e, "avatar") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.avatar), e.avatarType != null && Object.hasOwnProperty.call(e, "avatarType") && o.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(e.avatarType), o;
    }, n.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, n.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.Block.ChatMessage();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.name = e.string();
            break;
          }
          case 2: {
            y.avatar = e.string();
            break;
          }
          case 3: {
            y.avatarType = e.int32();
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, n.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, n.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name))
        return "name: string expected";
      if (e.avatar != null && e.hasOwnProperty("avatar") && !$util.isString(e.avatar))
        return "avatar: string expected";
      if (e.avatarType != null && e.hasOwnProperty("avatarType"))
        switch (e.avatarType) {
          default:
            return "avatarType: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      return null;
    }, n.fromObject = function(e) {
      if (e instanceof $root.Block.ChatMessage)
        return e;
      let o = new $root.Block.ChatMessage();
      switch (e.name != null && (o.name = String(e.name)), e.avatar != null && (o.avatar = String(e.avatar)), e.avatarType) {
        default:
          if (typeof e.avatarType == "number") {
            o.avatarType = e.avatarType;
            break;
          }
          break;
        case "IMAGE":
        case 0:
          o.avatarType = 0;
          break;
        case "EMOJI":
        case 1:
          o.avatarType = 1;
          break;
        case "ICON":
        case 2:
          o.avatarType = 2;
          break;
      }
      return o;
    }, n.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return o.defaults && (p.name = "", p.avatar = "", p.avatarType = o.enums === String ? "IMAGE" : 0), e.name != null && e.hasOwnProperty("name") && (p.name = e.name), e.avatar != null && e.hasOwnProperty("avatar") && (p.avatar = e.avatar), e.avatarType != null && e.hasOwnProperty("avatarType") && (p.avatarType = o.enums === String ? $root.Block.ChatMessage.AvatarType[e.avatarType] === void 0 ? e.avatarType : $root.Block.ChatMessage.AvatarType[e.avatarType] : e.avatarType), p;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, n.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/Block.ChatMessage";
    }, n.AvatarType = (function() {
      const t = {}, e = Object.create(t);
      return e[t[0] = "IMAGE"] = 0, e[t[1] = "EMOJI"] = 1, e[t[2] = "ICON"] = 2, e;
    })(), n;
  })(), r;
})();
$root.BokehChart = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.figure = "", r.prototype.useContainerWidth = !1, r.prototype.elementId = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.figure != null && Object.hasOwnProperty.call(n, "figure") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.figure), n.useContainerWidth != null && Object.hasOwnProperty.call(n, "useContainerWidth") && t.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(n.useContainerWidth), n.elementId != null && Object.hasOwnProperty.call(n, "elementId") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.elementId), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.BokehChart();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.figure = n.string();
          break;
        }
        case 2: {
          p.useContainerWidth = n.bool();
          break;
        }
        case 3: {
          p.elementId = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.figure != null && n.hasOwnProperty("figure") && !$util.isString(n.figure) ? "figure: string expected" : n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && typeof n.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : n.elementId != null && n.hasOwnProperty("elementId") && !$util.isString(n.elementId) ? "elementId: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.BokehChart)
      return n;
    let t = new $root.BokehChart();
    return n.figure != null && (t.figure = String(n.figure)), n.useContainerWidth != null && (t.useContainerWidth = !!n.useContainerWidth), n.elementId != null && (t.elementId = String(n.elementId)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.figure = "", e.useContainerWidth = !1, e.elementId = ""), n.figure != null && n.hasOwnProperty("figure") && (e.figure = n.figure), n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = n.useContainerWidth), n.elementId != null && n.hasOwnProperty("elementId") && (e.elementId = n.elementId), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/BokehChart";
  }, r;
})();
$root.Button = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.id = "", r.prototype.label = "", r.prototype.default = !1, r.prototype.help = "", r.prototype.formId = "", r.prototype.isFormSubmitter = !1, r.prototype.type = "", r.prototype.disabled = !1, r.prototype.useContainerWidth = !1, r.prototype.icon = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.id != null && Object.hasOwnProperty.call(n, "id") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.id), n.label != null && Object.hasOwnProperty.call(n, "label") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.label), n.default != null && Object.hasOwnProperty.call(n, "default") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(n.default), n.help != null && Object.hasOwnProperty.call(n, "help") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.help), n.formId != null && Object.hasOwnProperty.call(n, "formId") && t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(n.formId), n.isFormSubmitter != null && Object.hasOwnProperty.call(n, "isFormSubmitter") && t.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(n.isFormSubmitter), n.type != null && Object.hasOwnProperty.call(n, "type") && t.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(n.type), n.disabled != null && Object.hasOwnProperty.call(n, "disabled") && t.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(n.disabled), n.useContainerWidth != null && Object.hasOwnProperty.call(n, "useContainerWidth") && t.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(n.useContainerWidth), n.icon != null && Object.hasOwnProperty.call(n, "icon") && t.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(n.icon), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Button();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.id = n.string();
          break;
        }
        case 2: {
          p.label = n.string();
          break;
        }
        case 3: {
          p.default = n.bool();
          break;
        }
        case 4: {
          p.help = n.string();
          break;
        }
        case 5: {
          p.formId = n.string();
          break;
        }
        case 6: {
          p.isFormSubmitter = n.bool();
          break;
        }
        case 7: {
          p.type = n.string();
          break;
        }
        case 8: {
          p.disabled = n.bool();
          break;
        }
        case 9: {
          p.useContainerWidth = n.bool();
          break;
        }
        case 10: {
          p.icon = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.id != null && n.hasOwnProperty("id") && !$util.isString(n.id) ? "id: string expected" : n.label != null && n.hasOwnProperty("label") && !$util.isString(n.label) ? "label: string expected" : n.default != null && n.hasOwnProperty("default") && typeof n.default != "boolean" ? "default: boolean expected" : n.help != null && n.hasOwnProperty("help") && !$util.isString(n.help) ? "help: string expected" : n.formId != null && n.hasOwnProperty("formId") && !$util.isString(n.formId) ? "formId: string expected" : n.isFormSubmitter != null && n.hasOwnProperty("isFormSubmitter") && typeof n.isFormSubmitter != "boolean" ? "isFormSubmitter: boolean expected" : n.type != null && n.hasOwnProperty("type") && !$util.isString(n.type) ? "type: string expected" : n.disabled != null && n.hasOwnProperty("disabled") && typeof n.disabled != "boolean" ? "disabled: boolean expected" : n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && typeof n.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : n.icon != null && n.hasOwnProperty("icon") && !$util.isString(n.icon) ? "icon: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Button)
      return n;
    let t = new $root.Button();
    return n.id != null && (t.id = String(n.id)), n.label != null && (t.label = String(n.label)), n.default != null && (t.default = !!n.default), n.help != null && (t.help = String(n.help)), n.formId != null && (t.formId = String(n.formId)), n.isFormSubmitter != null && (t.isFormSubmitter = !!n.isFormSubmitter), n.type != null && (t.type = String(n.type)), n.disabled != null && (t.disabled = !!n.disabled), n.useContainerWidth != null && (t.useContainerWidth = !!n.useContainerWidth), n.icon != null && (t.icon = String(n.icon)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.id = "", e.label = "", e.default = !1, e.help = "", e.formId = "", e.isFormSubmitter = !1, e.type = "", e.disabled = !1, e.useContainerWidth = !1, e.icon = ""), n.id != null && n.hasOwnProperty("id") && (e.id = n.id), n.label != null && n.hasOwnProperty("label") && (e.label = n.label), n.default != null && n.hasOwnProperty("default") && (e.default = n.default), n.help != null && n.hasOwnProperty("help") && (e.help = n.help), n.formId != null && n.hasOwnProperty("formId") && (e.formId = n.formId), n.isFormSubmitter != null && n.hasOwnProperty("isFormSubmitter") && (e.isFormSubmitter = n.isFormSubmitter), n.type != null && n.hasOwnProperty("type") && (e.type = n.type), n.disabled != null && n.hasOwnProperty("disabled") && (e.disabled = n.disabled), n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = n.useContainerWidth), n.icon != null && n.hasOwnProperty("icon") && (e.icon = n.icon), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Button";
  }, r;
})();
$root.ButtonGroup = (() => {
  function r(n) {
    if (this.options = [], this.default = [], this.value = [], n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.id = "", r.prototype.options = $util.emptyArray, r.prototype.default = $util.emptyArray, r.prototype.disabled = !1, r.prototype.clickMode = 0, r.prototype.formId = "", r.prototype.value = $util.emptyArray, r.prototype.setValue = !1, r.prototype.selectionVisualization = 0, r.prototype.style = 0, r.prototype.label = "", r.prototype.labelVisibility = null, r.prototype.help = null;
  let c;
  return Object.defineProperty(r.prototype, "_help", {
    get: $util.oneOfGetter(c = ["help"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    if (e || (e = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.options != null && t.options.length)
      for (let o = 0; o < t.options.length; ++o)
        $root.ButtonGroup.Option.encode(t.options[o], e.uint32(
          /* id 2, wireType 2 =*/
          18
        ).fork()).ldelim();
    if (t.default != null && t.default.length) {
      e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let o = 0; o < t.default.length; ++o)
        e.uint32(t.default[o]);
      e.ldelim();
    }
    if (t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(t.disabled), t.clickMode != null && Object.hasOwnProperty.call(t, "clickMode") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(t.clickMode), t.formId != null && Object.hasOwnProperty.call(t, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.formId), t.value != null && t.value.length) {
      e.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork();
      for (let o = 0; o < t.value.length; ++o)
        e.uint32(t.value[o]);
      e.ldelim();
    }
    return t.setValue != null && Object.hasOwnProperty.call(t, "setValue") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.setValue), t.selectionVisualization != null && Object.hasOwnProperty.call(t, "selectionVisualization") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(t.selectionVisualization), t.style != null && Object.hasOwnProperty.call(t, "style") && e.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(t.style), t.label != null && Object.hasOwnProperty.call(t, "label") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(t.label), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), t.help != null && Object.hasOwnProperty.call(t, "help") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(t.help), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.ButtonGroup();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.id = t.string();
          break;
        }
        case 2: {
          h.options && h.options.length || (h.options = []), h.options.push($root.ButtonGroup.Option.decode(t, t.uint32()));
          break;
        }
        case 3: {
          if (h.default && h.default.length || (h.default = []), (y & 7) === 2) {
            let b = t.uint32() + t.pos;
            for (; t.pos < b; )
              h.default.push(t.uint32());
          } else
            h.default.push(t.uint32());
          break;
        }
        case 4: {
          h.disabled = t.bool();
          break;
        }
        case 5: {
          h.clickMode = t.int32();
          break;
        }
        case 6: {
          h.formId = t.string();
          break;
        }
        case 7: {
          if (h.value && h.value.length || (h.value = []), (y & 7) === 2) {
            let b = t.uint32() + t.pos;
            for (; t.pos < b; )
              h.value.push(t.uint32());
          } else
            h.value.push(t.uint32());
          break;
        }
        case 8: {
          h.setValue = t.bool();
          break;
        }
        case 9: {
          h.selectionVisualization = t.int32();
          break;
        }
        case 10: {
          h.style = t.int32();
          break;
        }
        case 11: {
          h.label = t.string();
          break;
        }
        case 12: {
          h.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        case 13: {
          h.help = t.string();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.options != null && t.hasOwnProperty("options")) {
      if (!Array.isArray(t.options))
        return "options: array expected";
      for (let e = 0; e < t.options.length; ++e) {
        let o = $root.ButtonGroup.Option.verify(t.options[e]);
        if (o)
          return "options." + o;
      }
    }
    if (t.default != null && t.hasOwnProperty("default")) {
      if (!Array.isArray(t.default))
        return "default: array expected";
      for (let e = 0; e < t.default.length; ++e)
        if (!$util.isInteger(t.default[e]))
          return "default: integer[] expected";
    }
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean")
      return "disabled: boolean expected";
    if (t.clickMode != null && t.hasOwnProperty("clickMode"))
      switch (t.clickMode) {
        default:
          return "clickMode: enum value expected";
        case 0:
        case 1:
          break;
      }
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId))
      return "formId: string expected";
    if (t.value != null && t.hasOwnProperty("value")) {
      if (!Array.isArray(t.value))
        return "value: array expected";
      for (let e = 0; e < t.value.length; ++e)
        if (!$util.isInteger(t.value[e]))
          return "value: integer[] expected";
    }
    if (t.setValue != null && t.hasOwnProperty("setValue") && typeof t.setValue != "boolean")
      return "setValue: boolean expected";
    if (t.selectionVisualization != null && t.hasOwnProperty("selectionVisualization"))
      switch (t.selectionVisualization) {
        default:
          return "selectionVisualization: enum value expected";
        case 0:
        case 1:
          break;
      }
    if (t.style != null && t.hasOwnProperty("style"))
      switch (t.style) {
        default:
          return "style: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label))
      return "label: string expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let e = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (e)
        return "labelVisibility." + e;
    }
    return t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help) ? "help: string expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.ButtonGroup)
      return t;
    let e = new $root.ButtonGroup();
    if (t.id != null && (e.id = String(t.id)), t.options) {
      if (!Array.isArray(t.options))
        throw TypeError(".ButtonGroup.options: array expected");
      e.options = [];
      for (let o = 0; o < t.options.length; ++o) {
        if (typeof t.options[o] != "object")
          throw TypeError(".ButtonGroup.options: object expected");
        e.options[o] = $root.ButtonGroup.Option.fromObject(t.options[o]);
      }
    }
    if (t.default) {
      if (!Array.isArray(t.default))
        throw TypeError(".ButtonGroup.default: array expected");
      e.default = [];
      for (let o = 0; o < t.default.length; ++o)
        e.default[o] = t.default[o] >>> 0;
    }
    switch (t.disabled != null && (e.disabled = !!t.disabled), t.clickMode) {
      default:
        if (typeof t.clickMode == "number") {
          e.clickMode = t.clickMode;
          break;
        }
        break;
      case "SINGLE_SELECT":
      case 0:
        e.clickMode = 0;
        break;
      case "MULTI_SELECT":
      case 1:
        e.clickMode = 1;
        break;
    }
    if (t.formId != null && (e.formId = String(t.formId)), t.value) {
      if (!Array.isArray(t.value))
        throw TypeError(".ButtonGroup.value: array expected");
      e.value = [];
      for (let o = 0; o < t.value.length; ++o)
        e.value[o] = t.value[o] >>> 0;
    }
    switch (t.setValue != null && (e.setValue = !!t.setValue), t.selectionVisualization) {
      default:
        if (typeof t.selectionVisualization == "number") {
          e.selectionVisualization = t.selectionVisualization;
          break;
        }
        break;
      case "ONLY_SELECTED":
      case 0:
        e.selectionVisualization = 0;
        break;
      case "ALL_UP_TO_SELECTED":
      case 1:
        e.selectionVisualization = 1;
        break;
    }
    switch (t.style) {
      default:
        if (typeof t.style == "number") {
          e.style = t.style;
          break;
        }
        break;
      case "SEGMENTED_CONTROL":
      case 0:
        e.style = 0;
        break;
      case "PILLS":
      case 1:
        e.style = 1;
        break;
      case "BORDERLESS":
      case 2:
        e.style = 2;
        break;
    }
    if (t.label != null && (e.label = String(t.label)), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object")
        throw TypeError(".ButtonGroup.labelVisibility: object expected");
      e.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    return t.help != null && (e.help = String(t.help)), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    if ((e.arrays || e.defaults) && (o.options = [], o.default = [], o.value = []), e.defaults && (o.id = "", o.disabled = !1, o.clickMode = e.enums === String ? "SINGLE_SELECT" : 0, o.formId = "", o.setValue = !1, o.selectionVisualization = e.enums === String ? "ONLY_SELECTED" : 0, o.style = e.enums === String ? "SEGMENTED_CONTROL" : 0, o.label = "", o.labelVisibility = null), t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.options && t.options.length) {
      o.options = [];
      for (let p = 0; p < t.options.length; ++p)
        o.options[p] = $root.ButtonGroup.Option.toObject(t.options[p], e);
    }
    if (t.default && t.default.length) {
      o.default = [];
      for (let p = 0; p < t.default.length; ++p)
        o.default[p] = t.default[p];
    }
    if (t.disabled != null && t.hasOwnProperty("disabled") && (o.disabled = t.disabled), t.clickMode != null && t.hasOwnProperty("clickMode") && (o.clickMode = e.enums === String ? $root.ButtonGroup.ClickMode[t.clickMode] === void 0 ? t.clickMode : $root.ButtonGroup.ClickMode[t.clickMode] : t.clickMode), t.formId != null && t.hasOwnProperty("formId") && (o.formId = t.formId), t.value && t.value.length) {
      o.value = [];
      for (let p = 0; p < t.value.length; ++p)
        o.value[p] = t.value[p];
    }
    return t.setValue != null && t.hasOwnProperty("setValue") && (o.setValue = t.setValue), t.selectionVisualization != null && t.hasOwnProperty("selectionVisualization") && (o.selectionVisualization = e.enums === String ? $root.ButtonGroup.SelectionVisualization[t.selectionVisualization] === void 0 ? t.selectionVisualization : $root.ButtonGroup.SelectionVisualization[t.selectionVisualization] : t.selectionVisualization), t.style != null && t.hasOwnProperty("style") && (o.style = e.enums === String ? $root.ButtonGroup.Style[t.style] === void 0 ? t.style : $root.ButtonGroup.Style[t.style] : t.style), t.label != null && t.hasOwnProperty("label") && (o.label = t.label), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (o.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, e)), t.help != null && t.hasOwnProperty("help") && (o.help = t.help, e.oneofs && (o._help = "help")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ButtonGroup";
  }, r.ClickMode = (function() {
    const n = {}, t = Object.create(n);
    return t[n[0] = "SINGLE_SELECT"] = 0, t[n[1] = "MULTI_SELECT"] = 1, t;
  })(), r.Option = (function() {
    function n(e) {
      if (e)
        for (let o = Object.keys(e), p = 0; p < o.length; ++p)
          e[o[p]] != null && (this[o[p]] = e[o[p]]);
    }
    n.prototype.content = "", n.prototype.selectedContent = null, n.prototype.contentIcon = null, n.prototype.selectedContentIcon = null;
    let t;
    return Object.defineProperty(n.prototype, "_selectedContent", {
      get: $util.oneOfGetter(t = ["selectedContent"]),
      set: $util.oneOfSetter(t)
    }), Object.defineProperty(n.prototype, "_contentIcon", {
      get: $util.oneOfGetter(t = ["contentIcon"]),
      set: $util.oneOfSetter(t)
    }), Object.defineProperty(n.prototype, "_selectedContentIcon", {
      get: $util.oneOfGetter(t = ["selectedContentIcon"]),
      set: $util.oneOfSetter(t)
    }), n.create = function(o) {
      return new n(o);
    }, n.encode = function(o, p) {
      return p || (p = $Writer.create()), o.content != null && Object.hasOwnProperty.call(o, "content") && p.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(o.content), o.selectedContent != null && Object.hasOwnProperty.call(o, "selectedContent") && p.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(o.selectedContent), o.contentIcon != null && Object.hasOwnProperty.call(o, "contentIcon") && p.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(o.contentIcon), o.selectedContentIcon != null && Object.hasOwnProperty.call(o, "selectedContentIcon") && p.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(o.selectedContentIcon), p;
    }, n.encodeDelimited = function(o, p) {
      return this.encode(o, p).ldelim();
    }, n.decode = function(o, p, h) {
      o instanceof $Reader || (o = $Reader.create(o));
      let y = p === void 0 ? o.len : o.pos + p, b = new $root.ButtonGroup.Option();
      for (; o.pos < y; ) {
        let O = o.uint32();
        if (O === h)
          break;
        switch (O >>> 3) {
          case 1: {
            b.content = o.string();
            break;
          }
          case 2: {
            b.selectedContent = o.string();
            break;
          }
          case 3: {
            b.contentIcon = o.string();
            break;
          }
          case 4: {
            b.selectedContentIcon = o.string();
            break;
          }
          default:
            o.skipType(O & 7);
            break;
        }
      }
      return b;
    }, n.decodeDelimited = function(o) {
      return o instanceof $Reader || (o = new $Reader(o)), this.decode(o, o.uint32());
    }, n.verify = function(o) {
      return typeof o != "object" || o === null ? "object expected" : o.content != null && o.hasOwnProperty("content") && !$util.isString(o.content) ? "content: string expected" : o.selectedContent != null && o.hasOwnProperty("selectedContent") && !$util.isString(o.selectedContent) ? "selectedContent: string expected" : o.contentIcon != null && o.hasOwnProperty("contentIcon") && !$util.isString(o.contentIcon) ? "contentIcon: string expected" : o.selectedContentIcon != null && o.hasOwnProperty("selectedContentIcon") && !$util.isString(o.selectedContentIcon) ? "selectedContentIcon: string expected" : null;
    }, n.fromObject = function(o) {
      if (o instanceof $root.ButtonGroup.Option)
        return o;
      let p = new $root.ButtonGroup.Option();
      return o.content != null && (p.content = String(o.content)), o.selectedContent != null && (p.selectedContent = String(o.selectedContent)), o.contentIcon != null && (p.contentIcon = String(o.contentIcon)), o.selectedContentIcon != null && (p.selectedContentIcon = String(o.selectedContentIcon)), p;
    }, n.toObject = function(o, p) {
      p || (p = {});
      let h = {};
      return p.defaults && (h.content = ""), o.content != null && o.hasOwnProperty("content") && (h.content = o.content), o.selectedContent != null && o.hasOwnProperty("selectedContent") && (h.selectedContent = o.selectedContent, p.oneofs && (h._selectedContent = "selectedContent")), o.contentIcon != null && o.hasOwnProperty("contentIcon") && (h.contentIcon = o.contentIcon, p.oneofs && (h._contentIcon = "contentIcon")), o.selectedContentIcon != null && o.hasOwnProperty("selectedContentIcon") && (h.selectedContentIcon = o.selectedContentIcon, p.oneofs && (h._selectedContentIcon = "selectedContentIcon")), h;
    }, n.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, n.getTypeUrl = function(o) {
      return o === void 0 && (o = "type.googleapis.com"), o + "/ButtonGroup.Option";
    }, n;
  })(), r.SelectionVisualization = (function() {
    const n = {}, t = Object.create(n);
    return t[n[0] = "ONLY_SELECTED"] = 0, t[n[1] = "ALL_UP_TO_SELECTED"] = 1, t;
  })(), r.Style = (function() {
    const n = {}, t = Object.create(n);
    return t[n[0] = "SEGMENTED_CONTROL"] = 0, t[n[1] = "PILLS"] = 1, t[n[2] = "BORDERLESS"] = 2, t;
  })(), r;
})();
$root.CameraInput = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.id = "", r.prototype.label = "", r.prototype.help = "", r.prototype.formId = "", r.prototype.disabled = !1, r.prototype.labelVisibility = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.id != null && Object.hasOwnProperty.call(n, "id") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.id), n.label != null && Object.hasOwnProperty.call(n, "label") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.label), n.help != null && Object.hasOwnProperty.call(n, "help") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.help), n.formId != null && Object.hasOwnProperty.call(n, "formId") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.formId), n.disabled != null && Object.hasOwnProperty.call(n, "disabled") && t.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(n.disabled), n.labelVisibility != null && Object.hasOwnProperty.call(n, "labelVisibility") && $root.LabelVisibilityMessage.encode(n.labelVisibility, t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.CameraInput();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.id = n.string();
          break;
        }
        case 2: {
          p.label = n.string();
          break;
        }
        case 3: {
          p.help = n.string();
          break;
        }
        case 4: {
          p.formId = n.string();
          break;
        }
        case 5: {
          p.disabled = n.bool();
          break;
        }
        case 6: {
          p.labelVisibility = $root.LabelVisibilityMessage.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.id != null && n.hasOwnProperty("id") && !$util.isString(n.id))
      return "id: string expected";
    if (n.label != null && n.hasOwnProperty("label") && !$util.isString(n.label))
      return "label: string expected";
    if (n.help != null && n.hasOwnProperty("help") && !$util.isString(n.help))
      return "help: string expected";
    if (n.formId != null && n.hasOwnProperty("formId") && !$util.isString(n.formId))
      return "formId: string expected";
    if (n.disabled != null && n.hasOwnProperty("disabled") && typeof n.disabled != "boolean")
      return "disabled: boolean expected";
    if (n.labelVisibility != null && n.hasOwnProperty("labelVisibility")) {
      let t = $root.LabelVisibilityMessage.verify(n.labelVisibility);
      if (t)
        return "labelVisibility." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.CameraInput)
      return n;
    let t = new $root.CameraInput();
    if (n.id != null && (t.id = String(n.id)), n.label != null && (t.label = String(n.label)), n.help != null && (t.help = String(n.help)), n.formId != null && (t.formId = String(n.formId)), n.disabled != null && (t.disabled = !!n.disabled), n.labelVisibility != null) {
      if (typeof n.labelVisibility != "object")
        throw TypeError(".CameraInput.labelVisibility: object expected");
      t.labelVisibility = $root.LabelVisibilityMessage.fromObject(n.labelVisibility);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.id = "", e.label = "", e.help = "", e.formId = "", e.disabled = !1, e.labelVisibility = null), n.id != null && n.hasOwnProperty("id") && (e.id = n.id), n.label != null && n.hasOwnProperty("label") && (e.label = n.label), n.help != null && n.hasOwnProperty("help") && (e.help = n.help), n.formId != null && n.hasOwnProperty("formId") && (e.formId = n.formId), n.disabled != null && n.hasOwnProperty("disabled") && (e.disabled = n.disabled), n.labelVisibility != null && n.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(n.labelVisibility, t)), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/CameraInput";
  }, r;
})();
$root.ChatInput = (() => {
  function r(c) {
    if (this.fileType = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.id = "", r.prototype.placeholder = "", r.prototype.maxChars = 0, r.prototype.disabled = !1, r.prototype.value = "", r.prototype.setValue = !1, r.prototype.default = "", r.prototype.position = 0, r.prototype.acceptFile = 0, r.prototype.fileType = $util.emptyArray, r.prototype.maxUploadSizeMb = 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.id != null && Object.hasOwnProperty.call(n, "id") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.id), n.placeholder != null && Object.hasOwnProperty.call(n, "placeholder") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.placeholder), n.maxChars != null && Object.hasOwnProperty.call(n, "maxChars") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).uint32(n.maxChars), n.disabled != null && Object.hasOwnProperty.call(n, "disabled") && t.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(n.disabled), n.value != null && Object.hasOwnProperty.call(n, "value") && t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(n.value), n.setValue != null && Object.hasOwnProperty.call(n, "setValue") && t.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(n.setValue), n.default != null && Object.hasOwnProperty.call(n, "default") && t.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(n.default), n.position != null && Object.hasOwnProperty.call(n, "position") && t.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(n.position), n.acceptFile != null && Object.hasOwnProperty.call(n, "acceptFile") && t.uint32(
      /* id 9, wireType 0 =*/
      72
    ).int32(n.acceptFile), n.fileType != null && n.fileType.length)
      for (let e = 0; e < n.fileType.length; ++e)
        t.uint32(
          /* id 10, wireType 2 =*/
          82
        ).string(n.fileType[e]);
    return n.maxUploadSizeMb != null && Object.hasOwnProperty.call(n, "maxUploadSizeMb") && t.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(n.maxUploadSizeMb), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.ChatInput();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.id = n.string();
          break;
        }
        case 2: {
          p.placeholder = n.string();
          break;
        }
        case 3: {
          p.maxChars = n.uint32();
          break;
        }
        case 4: {
          p.disabled = n.bool();
          break;
        }
        case 5: {
          p.value = n.string();
          break;
        }
        case 6: {
          p.setValue = n.bool();
          break;
        }
        case 7: {
          p.default = n.string();
          break;
        }
        case 8: {
          p.position = n.int32();
          break;
        }
        case 9: {
          p.acceptFile = n.int32();
          break;
        }
        case 10: {
          p.fileType && p.fileType.length || (p.fileType = []), p.fileType.push(n.string());
          break;
        }
        case 11: {
          p.maxUploadSizeMb = n.int32();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.id != null && n.hasOwnProperty("id") && !$util.isString(n.id))
      return "id: string expected";
    if (n.placeholder != null && n.hasOwnProperty("placeholder") && !$util.isString(n.placeholder))
      return "placeholder: string expected";
    if (n.maxChars != null && n.hasOwnProperty("maxChars") && !$util.isInteger(n.maxChars))
      return "maxChars: integer expected";
    if (n.disabled != null && n.hasOwnProperty("disabled") && typeof n.disabled != "boolean")
      return "disabled: boolean expected";
    if (n.value != null && n.hasOwnProperty("value") && !$util.isString(n.value))
      return "value: string expected";
    if (n.setValue != null && n.hasOwnProperty("setValue") && typeof n.setValue != "boolean")
      return "setValue: boolean expected";
    if (n.default != null && n.hasOwnProperty("default") && !$util.isString(n.default))
      return "default: string expected";
    if (n.position != null && n.hasOwnProperty("position"))
      switch (n.position) {
        default:
          return "position: enum value expected";
        case 0:
          break;
      }
    if (n.acceptFile != null && n.hasOwnProperty("acceptFile"))
      switch (n.acceptFile) {
        default:
          return "acceptFile: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
          break;
      }
    if (n.fileType != null && n.hasOwnProperty("fileType")) {
      if (!Array.isArray(n.fileType))
        return "fileType: array expected";
      for (let t = 0; t < n.fileType.length; ++t)
        if (!$util.isString(n.fileType[t]))
          return "fileType: string[] expected";
    }
    return n.maxUploadSizeMb != null && n.hasOwnProperty("maxUploadSizeMb") && !$util.isInteger(n.maxUploadSizeMb) ? "maxUploadSizeMb: integer expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.ChatInput)
      return n;
    let t = new $root.ChatInput();
    switch (n.id != null && (t.id = String(n.id)), n.placeholder != null && (t.placeholder = String(n.placeholder)), n.maxChars != null && (t.maxChars = n.maxChars >>> 0), n.disabled != null && (t.disabled = !!n.disabled), n.value != null && (t.value = String(n.value)), n.setValue != null && (t.setValue = !!n.setValue), n.default != null && (t.default = String(n.default)), n.position) {
      default:
        if (typeof n.position == "number") {
          t.position = n.position;
          break;
        }
        break;
      case "BOTTOM":
      case 0:
        t.position = 0;
        break;
    }
    switch (n.acceptFile) {
      default:
        if (typeof n.acceptFile == "number") {
          t.acceptFile = n.acceptFile;
          break;
        }
        break;
      case "NONE":
      case 0:
        t.acceptFile = 0;
        break;
      case "SINGLE":
      case 1:
        t.acceptFile = 1;
        break;
      case "MULTIPLE":
      case 2:
        t.acceptFile = 2;
        break;
      case "DIRECTORY":
      case 3:
        t.acceptFile = 3;
        break;
    }
    if (n.fileType) {
      if (!Array.isArray(n.fileType))
        throw TypeError(".ChatInput.fileType: array expected");
      t.fileType = [];
      for (let e = 0; e < n.fileType.length; ++e)
        t.fileType[e] = String(n.fileType[e]);
    }
    return n.maxUploadSizeMb != null && (t.maxUploadSizeMb = n.maxUploadSizeMb | 0), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.fileType = []), t.defaults && (e.id = "", e.placeholder = "", e.maxChars = 0, e.disabled = !1, e.value = "", e.setValue = !1, e.default = "", e.position = t.enums === String ? "BOTTOM" : 0, e.acceptFile = t.enums === String ? "NONE" : 0, e.maxUploadSizeMb = 0), n.id != null && n.hasOwnProperty("id") && (e.id = n.id), n.placeholder != null && n.hasOwnProperty("placeholder") && (e.placeholder = n.placeholder), n.maxChars != null && n.hasOwnProperty("maxChars") && (e.maxChars = n.maxChars), n.disabled != null && n.hasOwnProperty("disabled") && (e.disabled = n.disabled), n.value != null && n.hasOwnProperty("value") && (e.value = n.value), n.setValue != null && n.hasOwnProperty("setValue") && (e.setValue = n.setValue), n.default != null && n.hasOwnProperty("default") && (e.default = n.default), n.position != null && n.hasOwnProperty("position") && (e.position = t.enums === String ? $root.ChatInput.Position[n.position] === void 0 ? n.position : $root.ChatInput.Position[n.position] : n.position), n.acceptFile != null && n.hasOwnProperty("acceptFile") && (e.acceptFile = t.enums === String ? $root.ChatInput.AcceptFile[n.acceptFile] === void 0 ? n.acceptFile : $root.ChatInput.AcceptFile[n.acceptFile] : n.acceptFile), n.fileType && n.fileType.length) {
      e.fileType = [];
      for (let o = 0; o < n.fileType.length; ++o)
        e.fileType[o] = n.fileType[o];
    }
    return n.maxUploadSizeMb != null && n.hasOwnProperty("maxUploadSizeMb") && (e.maxUploadSizeMb = n.maxUploadSizeMb), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/ChatInput";
  }, r.Position = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "BOTTOM"] = 0, n;
  })(), r.AcceptFile = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "NONE"] = 0, n[c[1] = "SINGLE"] = 1, n[c[2] = "MULTIPLE"] = 2, n[c[3] = "DIRECTORY"] = 3, n;
  })(), r;
})();
$root.Checkbox = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.id = "", r.prototype.label = "", r.prototype.default = !1, r.prototype.help = "", r.prototype.formId = "", r.prototype.value = !1, r.prototype.setValue = !1, r.prototype.disabled = !1, r.prototype.labelVisibility = null, r.prototype.type = 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.id != null && Object.hasOwnProperty.call(n, "id") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.id), n.label != null && Object.hasOwnProperty.call(n, "label") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.label), n.default != null && Object.hasOwnProperty.call(n, "default") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(n.default), n.help != null && Object.hasOwnProperty.call(n, "help") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.help), n.formId != null && Object.hasOwnProperty.call(n, "formId") && t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(n.formId), n.value != null && Object.hasOwnProperty.call(n, "value") && t.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(n.value), n.setValue != null && Object.hasOwnProperty.call(n, "setValue") && t.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(n.setValue), n.disabled != null && Object.hasOwnProperty.call(n, "disabled") && t.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(n.disabled), n.labelVisibility != null && Object.hasOwnProperty.call(n, "labelVisibility") && $root.LabelVisibilityMessage.encode(n.labelVisibility, t.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), n.type != null && Object.hasOwnProperty.call(n, "type") && t.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(n.type), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Checkbox();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.id = n.string();
          break;
        }
        case 2: {
          p.label = n.string();
          break;
        }
        case 3: {
          p.default = n.bool();
          break;
        }
        case 4: {
          p.help = n.string();
          break;
        }
        case 5: {
          p.formId = n.string();
          break;
        }
        case 6: {
          p.value = n.bool();
          break;
        }
        case 7: {
          p.setValue = n.bool();
          break;
        }
        case 8: {
          p.disabled = n.bool();
          break;
        }
        case 9: {
          p.labelVisibility = $root.LabelVisibilityMessage.decode(n, n.uint32());
          break;
        }
        case 10: {
          p.type = n.int32();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.id != null && n.hasOwnProperty("id") && !$util.isString(n.id))
      return "id: string expected";
    if (n.label != null && n.hasOwnProperty("label") && !$util.isString(n.label))
      return "label: string expected";
    if (n.default != null && n.hasOwnProperty("default") && typeof n.default != "boolean")
      return "default: boolean expected";
    if (n.help != null && n.hasOwnProperty("help") && !$util.isString(n.help))
      return "help: string expected";
    if (n.formId != null && n.hasOwnProperty("formId") && !$util.isString(n.formId))
      return "formId: string expected";
    if (n.value != null && n.hasOwnProperty("value") && typeof n.value != "boolean")
      return "value: boolean expected";
    if (n.setValue != null && n.hasOwnProperty("setValue") && typeof n.setValue != "boolean")
      return "setValue: boolean expected";
    if (n.disabled != null && n.hasOwnProperty("disabled") && typeof n.disabled != "boolean")
      return "disabled: boolean expected";
    if (n.labelVisibility != null && n.hasOwnProperty("labelVisibility")) {
      let t = $root.LabelVisibilityMessage.verify(n.labelVisibility);
      if (t)
        return "labelVisibility." + t;
    }
    if (n.type != null && n.hasOwnProperty("type"))
      switch (n.type) {
        default:
          return "type: enum value expected";
        case 0:
        case 1:
          break;
      }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Checkbox)
      return n;
    let t = new $root.Checkbox();
    if (n.id != null && (t.id = String(n.id)), n.label != null && (t.label = String(n.label)), n.default != null && (t.default = !!n.default), n.help != null && (t.help = String(n.help)), n.formId != null && (t.formId = String(n.formId)), n.value != null && (t.value = !!n.value), n.setValue != null && (t.setValue = !!n.setValue), n.disabled != null && (t.disabled = !!n.disabled), n.labelVisibility != null) {
      if (typeof n.labelVisibility != "object")
        throw TypeError(".Checkbox.labelVisibility: object expected");
      t.labelVisibility = $root.LabelVisibilityMessage.fromObject(n.labelVisibility);
    }
    switch (n.type) {
      default:
        if (typeof n.type == "number") {
          t.type = n.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        t.type = 0;
        break;
      case "TOGGLE":
      case 1:
        t.type = 1;
        break;
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.id = "", e.label = "", e.default = !1, e.help = "", e.formId = "", e.value = !1, e.setValue = !1, e.disabled = !1, e.labelVisibility = null, e.type = t.enums === String ? "DEFAULT" : 0), n.id != null && n.hasOwnProperty("id") && (e.id = n.id), n.label != null && n.hasOwnProperty("label") && (e.label = n.label), n.default != null && n.hasOwnProperty("default") && (e.default = n.default), n.help != null && n.hasOwnProperty("help") && (e.help = n.help), n.formId != null && n.hasOwnProperty("formId") && (e.formId = n.formId), n.value != null && n.hasOwnProperty("value") && (e.value = n.value), n.setValue != null && n.hasOwnProperty("setValue") && (e.setValue = n.setValue), n.disabled != null && n.hasOwnProperty("disabled") && (e.disabled = n.disabled), n.labelVisibility != null && n.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(n.labelVisibility, t)), n.type != null && n.hasOwnProperty("type") && (e.type = t.enums === String ? $root.Checkbox.StyleType[n.type] === void 0 ? n.type : $root.Checkbox.StyleType[n.type] : n.type), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Checkbox";
  }, r.StyleType = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "DEFAULT"] = 0, n[c[1] = "TOGGLE"] = 1, n;
  })(), r;
})();
$root.Code = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.codeText = "", r.prototype.language = "", r.prototype.showLineNumbers = !1, r.prototype.wrapLines = !1, r.prototype.height = 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.codeText != null && Object.hasOwnProperty.call(n, "codeText") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.codeText), n.language != null && Object.hasOwnProperty.call(n, "language") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.language), n.showLineNumbers != null && Object.hasOwnProperty.call(n, "showLineNumbers") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(n.showLineNumbers), n.wrapLines != null && Object.hasOwnProperty.call(n, "wrapLines") && t.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(n.wrapLines), n.height != null && Object.hasOwnProperty.call(n, "height") && t.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(n.height), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Code();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.codeText = n.string();
          break;
        }
        case 2: {
          p.language = n.string();
          break;
        }
        case 3: {
          p.showLineNumbers = n.bool();
          break;
        }
        case 4: {
          p.wrapLines = n.bool();
          break;
        }
        case 5: {
          p.height = n.uint32();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.codeText != null && n.hasOwnProperty("codeText") && !$util.isString(n.codeText) ? "codeText: string expected" : n.language != null && n.hasOwnProperty("language") && !$util.isString(n.language) ? "language: string expected" : n.showLineNumbers != null && n.hasOwnProperty("showLineNumbers") && typeof n.showLineNumbers != "boolean" ? "showLineNumbers: boolean expected" : n.wrapLines != null && n.hasOwnProperty("wrapLines") && typeof n.wrapLines != "boolean" ? "wrapLines: boolean expected" : n.height != null && n.hasOwnProperty("height") && !$util.isInteger(n.height) ? "height: integer expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Code)
      return n;
    let t = new $root.Code();
    return n.codeText != null && (t.codeText = String(n.codeText)), n.language != null && (t.language = String(n.language)), n.showLineNumbers != null && (t.showLineNumbers = !!n.showLineNumbers), n.wrapLines != null && (t.wrapLines = !!n.wrapLines), n.height != null && (t.height = n.height >>> 0), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.codeText = "", e.language = "", e.showLineNumbers = !1, e.wrapLines = !1, e.height = 0), n.codeText != null && n.hasOwnProperty("codeText") && (e.codeText = n.codeText), n.language != null && n.hasOwnProperty("language") && (e.language = n.language), n.showLineNumbers != null && n.hasOwnProperty("showLineNumbers") && (e.showLineNumbers = n.showLineNumbers), n.wrapLines != null && n.hasOwnProperty("wrapLines") && (e.wrapLines = n.wrapLines), n.height != null && n.hasOwnProperty("height") && (e.height = n.height), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Code";
  }, r;
})();
$root.ColorPicker = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.id = "", r.prototype.label = "", r.prototype.default = "", r.prototype.help = "", r.prototype.formId = "", r.prototype.value = "", r.prototype.setValue = !1, r.prototype.disabled = !1, r.prototype.labelVisibility = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.id != null && Object.hasOwnProperty.call(n, "id") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.id), n.label != null && Object.hasOwnProperty.call(n, "label") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.label), n.default != null && Object.hasOwnProperty.call(n, "default") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.default), n.help != null && Object.hasOwnProperty.call(n, "help") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.help), n.formId != null && Object.hasOwnProperty.call(n, "formId") && t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(n.formId), n.value != null && Object.hasOwnProperty.call(n, "value") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.value), n.setValue != null && Object.hasOwnProperty.call(n, "setValue") && t.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(n.setValue), n.disabled != null && Object.hasOwnProperty.call(n, "disabled") && t.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(n.disabled), n.labelVisibility != null && Object.hasOwnProperty.call(n, "labelVisibility") && $root.LabelVisibilityMessage.encode(n.labelVisibility, t.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.ColorPicker();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.id = n.string();
          break;
        }
        case 2: {
          p.label = n.string();
          break;
        }
        case 3: {
          p.default = n.string();
          break;
        }
        case 4: {
          p.help = n.string();
          break;
        }
        case 5: {
          p.formId = n.string();
          break;
        }
        case 6: {
          p.value = n.string();
          break;
        }
        case 7: {
          p.setValue = n.bool();
          break;
        }
        case 8: {
          p.disabled = n.bool();
          break;
        }
        case 9: {
          p.labelVisibility = $root.LabelVisibilityMessage.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.id != null && n.hasOwnProperty("id") && !$util.isString(n.id))
      return "id: string expected";
    if (n.label != null && n.hasOwnProperty("label") && !$util.isString(n.label))
      return "label: string expected";
    if (n.default != null && n.hasOwnProperty("default") && !$util.isString(n.default))
      return "default: string expected";
    if (n.help != null && n.hasOwnProperty("help") && !$util.isString(n.help))
      return "help: string expected";
    if (n.formId != null && n.hasOwnProperty("formId") && !$util.isString(n.formId))
      return "formId: string expected";
    if (n.value != null && n.hasOwnProperty("value") && !$util.isString(n.value))
      return "value: string expected";
    if (n.setValue != null && n.hasOwnProperty("setValue") && typeof n.setValue != "boolean")
      return "setValue: boolean expected";
    if (n.disabled != null && n.hasOwnProperty("disabled") && typeof n.disabled != "boolean")
      return "disabled: boolean expected";
    if (n.labelVisibility != null && n.hasOwnProperty("labelVisibility")) {
      let t = $root.LabelVisibilityMessage.verify(n.labelVisibility);
      if (t)
        return "labelVisibility." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.ColorPicker)
      return n;
    let t = new $root.ColorPicker();
    if (n.id != null && (t.id = String(n.id)), n.label != null && (t.label = String(n.label)), n.default != null && (t.default = String(n.default)), n.help != null && (t.help = String(n.help)), n.formId != null && (t.formId = String(n.formId)), n.value != null && (t.value = String(n.value)), n.setValue != null && (t.setValue = !!n.setValue), n.disabled != null && (t.disabled = !!n.disabled), n.labelVisibility != null) {
      if (typeof n.labelVisibility != "object")
        throw TypeError(".ColorPicker.labelVisibility: object expected");
      t.labelVisibility = $root.LabelVisibilityMessage.fromObject(n.labelVisibility);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.id = "", e.label = "", e.default = "", e.help = "", e.formId = "", e.value = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null), n.id != null && n.hasOwnProperty("id") && (e.id = n.id), n.label != null && n.hasOwnProperty("label") && (e.label = n.label), n.default != null && n.hasOwnProperty("default") && (e.default = n.default), n.help != null && n.hasOwnProperty("help") && (e.help = n.help), n.formId != null && n.hasOwnProperty("formId") && (e.formId = n.formId), n.value != null && n.hasOwnProperty("value") && (e.value = n.value), n.setValue != null && n.hasOwnProperty("setValue") && (e.setValue = n.setValue), n.disabled != null && n.hasOwnProperty("disabled") && (e.disabled = n.disabled), n.labelVisibility != null && n.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(n.labelVisibility, t)), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/ColorPicker";
  }, r;
})();
$root.DataFrame = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.data = null, r.prototype.index = null, r.prototype.columns = null, r.prototype.style = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.data != null && Object.hasOwnProperty.call(n, "data") && $root.Table.encode(n.data, t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), n.index != null && Object.hasOwnProperty.call(n, "index") && $root.Index.encode(n.index, t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), n.columns != null && Object.hasOwnProperty.call(n, "columns") && $root.Index.encode(n.columns, t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), n.style != null && Object.hasOwnProperty.call(n, "style") && $root.TableStyle.encode(n.style, t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.DataFrame();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.data = $root.Table.decode(n, n.uint32());
          break;
        }
        case 2: {
          p.index = $root.Index.decode(n, n.uint32());
          break;
        }
        case 3: {
          p.columns = $root.Index.decode(n, n.uint32());
          break;
        }
        case 4: {
          p.style = $root.TableStyle.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      let t = $root.Table.verify(n.data);
      if (t)
        return "data." + t;
    }
    if (n.index != null && n.hasOwnProperty("index")) {
      let t = $root.Index.verify(n.index);
      if (t)
        return "index." + t;
    }
    if (n.columns != null && n.hasOwnProperty("columns")) {
      let t = $root.Index.verify(n.columns);
      if (t)
        return "columns." + t;
    }
    if (n.style != null && n.hasOwnProperty("style")) {
      let t = $root.TableStyle.verify(n.style);
      if (t)
        return "style." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.DataFrame)
      return n;
    let t = new $root.DataFrame();
    if (n.data != null) {
      if (typeof n.data != "object")
        throw TypeError(".DataFrame.data: object expected");
      t.data = $root.Table.fromObject(n.data);
    }
    if (n.index != null) {
      if (typeof n.index != "object")
        throw TypeError(".DataFrame.index: object expected");
      t.index = $root.Index.fromObject(n.index);
    }
    if (n.columns != null) {
      if (typeof n.columns != "object")
        throw TypeError(".DataFrame.columns: object expected");
      t.columns = $root.Index.fromObject(n.columns);
    }
    if (n.style != null) {
      if (typeof n.style != "object")
        throw TypeError(".DataFrame.style: object expected");
      t.style = $root.TableStyle.fromObject(n.style);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.data = null, e.index = null, e.columns = null, e.style = null), n.data != null && n.hasOwnProperty("data") && (e.data = $root.Table.toObject(n.data, t)), n.index != null && n.hasOwnProperty("index") && (e.index = $root.Index.toObject(n.index, t)), n.columns != null && n.hasOwnProperty("columns") && (e.columns = $root.Index.toObject(n.columns, t)), n.style != null && n.hasOwnProperty("style") && (e.style = $root.TableStyle.toObject(n.style, t)), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/DataFrame";
  }, r;
})();
$root.Index = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.plainIndex = null, r.prototype.rangeIndex = null, r.prototype.multiIndex = null, r.prototype.datetimeIndex = null, r.prototype.timedeltaIndex = null, r.prototype.int_64Index = null, r.prototype.float_64Index = null;
  let c;
  return Object.defineProperty(r.prototype, "type", {
    get: $util.oneOfGetter(c = ["plainIndex", "rangeIndex", "multiIndex", "datetimeIndex", "timedeltaIndex", "int_64Index", "float_64Index"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.plainIndex != null && Object.hasOwnProperty.call(t, "plainIndex") && $root.PlainIndex.encode(t.plainIndex, e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), t.rangeIndex != null && Object.hasOwnProperty.call(t, "rangeIndex") && $root.RangeIndex.encode(t.rangeIndex, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), t.multiIndex != null && Object.hasOwnProperty.call(t, "multiIndex") && $root.MultiIndex.encode(t.multiIndex, e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), t.datetimeIndex != null && Object.hasOwnProperty.call(t, "datetimeIndex") && $root.DatetimeIndex.encode(t.datetimeIndex, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), t.timedeltaIndex != null && Object.hasOwnProperty.call(t, "timedeltaIndex") && $root.TimedeltaIndex.encode(t.timedeltaIndex, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), t.int_64Index != null && Object.hasOwnProperty.call(t, "int_64Index") && $root.Int64Index.encode(t.int_64Index, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), t.float_64Index != null && Object.hasOwnProperty.call(t, "float_64Index") && $root.Float64Index.encode(t.float_64Index, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.Index();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.plainIndex = $root.PlainIndex.decode(t, t.uint32());
          break;
        }
        case 2: {
          h.rangeIndex = $root.RangeIndex.decode(t, t.uint32());
          break;
        }
        case 4: {
          h.multiIndex = $root.MultiIndex.decode(t, t.uint32());
          break;
        }
        case 6: {
          h.datetimeIndex = $root.DatetimeIndex.decode(t, t.uint32());
          break;
        }
        case 7: {
          h.timedeltaIndex = $root.TimedeltaIndex.decode(t, t.uint32());
          break;
        }
        case 9: {
          h.int_64Index = $root.Int64Index.decode(t, t.uint32());
          break;
        }
        case 11: {
          h.float_64Index = $root.Float64Index.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    let e = {};
    if (t.plainIndex != null && t.hasOwnProperty("plainIndex")) {
      e.type = 1;
      {
        let o = $root.PlainIndex.verify(t.plainIndex);
        if (o)
          return "plainIndex." + o;
      }
    }
    if (t.rangeIndex != null && t.hasOwnProperty("rangeIndex")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.RangeIndex.verify(t.rangeIndex);
        if (o)
          return "rangeIndex." + o;
      }
    }
    if (t.multiIndex != null && t.hasOwnProperty("multiIndex")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.MultiIndex.verify(t.multiIndex);
        if (o)
          return "multiIndex." + o;
      }
    }
    if (t.datetimeIndex != null && t.hasOwnProperty("datetimeIndex")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.DatetimeIndex.verify(t.datetimeIndex);
        if (o)
          return "datetimeIndex." + o;
      }
    }
    if (t.timedeltaIndex != null && t.hasOwnProperty("timedeltaIndex")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.TimedeltaIndex.verify(t.timedeltaIndex);
        if (o)
          return "timedeltaIndex." + o;
      }
    }
    if (t.int_64Index != null && t.hasOwnProperty("int_64Index")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Int64Index.verify(t.int_64Index);
        if (o)
          return "int_64Index." + o;
      }
    }
    if (t.float_64Index != null && t.hasOwnProperty("float_64Index")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Float64Index.verify(t.float_64Index);
        if (o)
          return "float_64Index." + o;
      }
    }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.Index)
      return t;
    let e = new $root.Index();
    if (t.plainIndex != null) {
      if (typeof t.plainIndex != "object")
        throw TypeError(".Index.plainIndex: object expected");
      e.plainIndex = $root.PlainIndex.fromObject(t.plainIndex);
    }
    if (t.rangeIndex != null) {
      if (typeof t.rangeIndex != "object")
        throw TypeError(".Index.rangeIndex: object expected");
      e.rangeIndex = $root.RangeIndex.fromObject(t.rangeIndex);
    }
    if (t.multiIndex != null) {
      if (typeof t.multiIndex != "object")
        throw TypeError(".Index.multiIndex: object expected");
      e.multiIndex = $root.MultiIndex.fromObject(t.multiIndex);
    }
    if (t.datetimeIndex != null) {
      if (typeof t.datetimeIndex != "object")
        throw TypeError(".Index.datetimeIndex: object expected");
      e.datetimeIndex = $root.DatetimeIndex.fromObject(t.datetimeIndex);
    }
    if (t.timedeltaIndex != null) {
      if (typeof t.timedeltaIndex != "object")
        throw TypeError(".Index.timedeltaIndex: object expected");
      e.timedeltaIndex = $root.TimedeltaIndex.fromObject(t.timedeltaIndex);
    }
    if (t.int_64Index != null) {
      if (typeof t.int_64Index != "object")
        throw TypeError(".Index.int_64Index: object expected");
      e.int_64Index = $root.Int64Index.fromObject(t.int_64Index);
    }
    if (t.float_64Index != null) {
      if (typeof t.float_64Index != "object")
        throw TypeError(".Index.float_64Index: object expected");
      e.float_64Index = $root.Float64Index.fromObject(t.float_64Index);
    }
    return e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return t.plainIndex != null && t.hasOwnProperty("plainIndex") && (o.plainIndex = $root.PlainIndex.toObject(t.plainIndex, e), e.oneofs && (o.type = "plainIndex")), t.rangeIndex != null && t.hasOwnProperty("rangeIndex") && (o.rangeIndex = $root.RangeIndex.toObject(t.rangeIndex, e), e.oneofs && (o.type = "rangeIndex")), t.multiIndex != null && t.hasOwnProperty("multiIndex") && (o.multiIndex = $root.MultiIndex.toObject(t.multiIndex, e), e.oneofs && (o.type = "multiIndex")), t.datetimeIndex != null && t.hasOwnProperty("datetimeIndex") && (o.datetimeIndex = $root.DatetimeIndex.toObject(t.datetimeIndex, e), e.oneofs && (o.type = "datetimeIndex")), t.timedeltaIndex != null && t.hasOwnProperty("timedeltaIndex") && (o.timedeltaIndex = $root.TimedeltaIndex.toObject(t.timedeltaIndex, e), e.oneofs && (o.type = "timedeltaIndex")), t.int_64Index != null && t.hasOwnProperty("int_64Index") && (o.int_64Index = $root.Int64Index.toObject(t.int_64Index, e), e.oneofs && (o.type = "int_64Index")), t.float_64Index != null && t.hasOwnProperty("float_64Index") && (o.float_64Index = $root.Float64Index.toObject(t.float_64Index, e), e.oneofs && (o.type = "float_64Index")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Index";
  }, r;
})();
$root.PlainIndex = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.data = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.data != null && Object.hasOwnProperty.call(n, "data") && $root.AnyArray.encode(n.data, t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.PlainIndex();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.data = $root.AnyArray.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      let t = $root.AnyArray.verify(n.data);
      if (t)
        return "data." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.PlainIndex)
      return n;
    let t = new $root.PlainIndex();
    if (n.data != null) {
      if (typeof n.data != "object")
        throw TypeError(".PlainIndex.data: object expected");
      t.data = $root.AnyArray.fromObject(n.data);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.data = null), n.data != null && n.hasOwnProperty("data") && (e.data = $root.AnyArray.toObject(n.data, t)), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/PlainIndex";
  }, r;
})();
$root.RangeIndex = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.start = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, r.prototype.stop = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.start != null && Object.hasOwnProperty.call(n, "start") && t.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int64(n.start), n.stop != null && Object.hasOwnProperty.call(n, "stop") && t.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(n.stop), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.RangeIndex();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.start = n.int64();
          break;
        }
        case 2: {
          p.stop = n.int64();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.start != null && n.hasOwnProperty("start") && !$util.isInteger(n.start) && !(n.start && $util.isInteger(n.start.low) && $util.isInteger(n.start.high)) ? "start: integer|Long expected" : n.stop != null && n.hasOwnProperty("stop") && !$util.isInteger(n.stop) && !(n.stop && $util.isInteger(n.stop.low) && $util.isInteger(n.stop.high)) ? "stop: integer|Long expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.RangeIndex)
      return n;
    let t = new $root.RangeIndex();
    return n.start != null && ($util.Long ? (t.start = $util.Long.fromValue(n.start)).unsigned = !1 : typeof n.start == "string" ? t.start = parseInt(n.start, 10) : typeof n.start == "number" ? t.start = n.start : typeof n.start == "object" && (t.start = new $util.LongBits(n.start.low >>> 0, n.start.high >>> 0).toNumber())), n.stop != null && ($util.Long ? (t.stop = $util.Long.fromValue(n.stop)).unsigned = !1 : typeof n.stop == "string" ? t.stop = parseInt(n.stop, 10) : typeof n.stop == "number" ? t.stop = n.stop : typeof n.stop == "object" && (t.stop = new $util.LongBits(n.stop.low >>> 0, n.stop.high >>> 0).toNumber())), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if (t.defaults) {
      if ($util.Long) {
        let o = new $util.Long(0, 0, !1);
        e.start = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
      } else
        e.start = t.longs === String ? "0" : 0;
      if ($util.Long) {
        let o = new $util.Long(0, 0, !1);
        e.stop = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
      } else
        e.stop = t.longs === String ? "0" : 0;
    }
    return n.start != null && n.hasOwnProperty("start") && (typeof n.start == "number" ? e.start = t.longs === String ? String(n.start) : n.start : e.start = t.longs === String ? $util.Long.prototype.toString.call(n.start) : t.longs === Number ? new $util.LongBits(n.start.low >>> 0, n.start.high >>> 0).toNumber() : n.start), n.stop != null && n.hasOwnProperty("stop") && (typeof n.stop == "number" ? e.stop = t.longs === String ? String(n.stop) : n.stop : e.stop = t.longs === String ? $util.Long.prototype.toString.call(n.stop) : t.longs === Number ? new $util.LongBits(n.stop.low >>> 0, n.stop.high >>> 0).toNumber() : n.stop), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/RangeIndex";
  }, r;
})();
$root.MultiIndex = (() => {
  function r(c) {
    if (this.levels = [], this.labels = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.levels = $util.emptyArray, r.prototype.labels = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.levels != null && n.levels.length)
      for (let e = 0; e < n.levels.length; ++e)
        $root.Index.encode(n.levels[e], t.uint32(
          /* id 1, wireType 2 =*/
          10
        ).fork()).ldelim();
    if (n.labels != null && n.labels.length)
      for (let e = 0; e < n.labels.length; ++e)
        $root.Int32Array.encode(n.labels[e], t.uint32(
          /* id 2, wireType 2 =*/
          18
        ).fork()).ldelim();
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.MultiIndex();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.levels && p.levels.length || (p.levels = []), p.levels.push($root.Index.decode(n, n.uint32()));
          break;
        }
        case 2: {
          p.labels && p.labels.length || (p.labels = []), p.labels.push($root.Int32Array.decode(n, n.uint32()));
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.levels != null && n.hasOwnProperty("levels")) {
      if (!Array.isArray(n.levels))
        return "levels: array expected";
      for (let t = 0; t < n.levels.length; ++t) {
        let e = $root.Index.verify(n.levels[t]);
        if (e)
          return "levels." + e;
      }
    }
    if (n.labels != null && n.hasOwnProperty("labels")) {
      if (!Array.isArray(n.labels))
        return "labels: array expected";
      for (let t = 0; t < n.labels.length; ++t) {
        let e = $root.Int32Array.verify(n.labels[t]);
        if (e)
          return "labels." + e;
      }
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.MultiIndex)
      return n;
    let t = new $root.MultiIndex();
    if (n.levels) {
      if (!Array.isArray(n.levels))
        throw TypeError(".MultiIndex.levels: array expected");
      t.levels = [];
      for (let e = 0; e < n.levels.length; ++e) {
        if (typeof n.levels[e] != "object")
          throw TypeError(".MultiIndex.levels: object expected");
        t.levels[e] = $root.Index.fromObject(n.levels[e]);
      }
    }
    if (n.labels) {
      if (!Array.isArray(n.labels))
        throw TypeError(".MultiIndex.labels: array expected");
      t.labels = [];
      for (let e = 0; e < n.labels.length; ++e) {
        if (typeof n.labels[e] != "object")
          throw TypeError(".MultiIndex.labels: object expected");
        t.labels[e] = $root.Int32Array.fromObject(n.labels[e]);
      }
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.levels = [], e.labels = []), n.levels && n.levels.length) {
      e.levels = [];
      for (let o = 0; o < n.levels.length; ++o)
        e.levels[o] = $root.Index.toObject(n.levels[o], t);
    }
    if (n.labels && n.labels.length) {
      e.labels = [];
      for (let o = 0; o < n.labels.length; ++o)
        e.labels[o] = $root.Int32Array.toObject(n.labels[o], t);
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/MultiIndex";
  }, r;
})();
$root.DatetimeIndex = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.data = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.data != null && Object.hasOwnProperty.call(n, "data") && $root.StringArray.encode(n.data, t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.DatetimeIndex();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.data = $root.StringArray.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      let t = $root.StringArray.verify(n.data);
      if (t)
        return "data." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.DatetimeIndex)
      return n;
    let t = new $root.DatetimeIndex();
    if (n.data != null) {
      if (typeof n.data != "object")
        throw TypeError(".DatetimeIndex.data: object expected");
      t.data = $root.StringArray.fromObject(n.data);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.data = null), n.data != null && n.hasOwnProperty("data") && (e.data = $root.StringArray.toObject(n.data, t)), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/DatetimeIndex";
  }, r;
})();
$root.TimedeltaIndex = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.data = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.data != null && Object.hasOwnProperty.call(n, "data") && $root.Int64Array.encode(n.data, t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.TimedeltaIndex();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.data = $root.Int64Array.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      let t = $root.Int64Array.verify(n.data);
      if (t)
        return "data." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.TimedeltaIndex)
      return n;
    let t = new $root.TimedeltaIndex();
    if (n.data != null) {
      if (typeof n.data != "object")
        throw TypeError(".TimedeltaIndex.data: object expected");
      t.data = $root.Int64Array.fromObject(n.data);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.data = null), n.data != null && n.hasOwnProperty("data") && (e.data = $root.Int64Array.toObject(n.data, t)), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/TimedeltaIndex";
  }, r;
})();
$root.Int64Index = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.data = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.data != null && Object.hasOwnProperty.call(n, "data") && $root.Int64Array.encode(n.data, t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Int64Index();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.data = $root.Int64Array.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      let t = $root.Int64Array.verify(n.data);
      if (t)
        return "data." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Int64Index)
      return n;
    let t = new $root.Int64Index();
    if (n.data != null) {
      if (typeof n.data != "object")
        throw TypeError(".Int64Index.data: object expected");
      t.data = $root.Int64Array.fromObject(n.data);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.data = null), n.data != null && n.hasOwnProperty("data") && (e.data = $root.Int64Array.toObject(n.data, t)), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Int64Index";
  }, r;
})();
$root.Float64Index = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.data = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.data != null && Object.hasOwnProperty.call(n, "data") && $root.DoubleArray.encode(n.data, t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Float64Index();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.data = $root.DoubleArray.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      let t = $root.DoubleArray.verify(n.data);
      if (t)
        return "data." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Float64Index)
      return n;
    let t = new $root.Float64Index();
    if (n.data != null) {
      if (typeof n.data != "object")
        throw TypeError(".Float64Index.data: object expected");
      t.data = $root.DoubleArray.fromObject(n.data);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.data = null), n.data != null && n.hasOwnProperty("data") && (e.data = $root.DoubleArray.toObject(n.data, t)), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Float64Index";
  }, r;
})();
$root.CSSStyle = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.property = "", r.prototype.value = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.property != null && Object.hasOwnProperty.call(n, "property") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.property), n.value != null && Object.hasOwnProperty.call(n, "value") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.value), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.CSSStyle();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.property = n.string();
          break;
        }
        case 2: {
          p.value = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.property != null && n.hasOwnProperty("property") && !$util.isString(n.property) ? "property: string expected" : n.value != null && n.hasOwnProperty("value") && !$util.isString(n.value) ? "value: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.CSSStyle)
      return n;
    let t = new $root.CSSStyle();
    return n.property != null && (t.property = String(n.property)), n.value != null && (t.value = String(n.value)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.property = "", e.value = ""), n.property != null && n.hasOwnProperty("property") && (e.property = n.property), n.value != null && n.hasOwnProperty("value") && (e.value = n.value), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/CSSStyle";
  }, r;
})();
$root.CellStyle = (() => {
  function r(c) {
    if (this.css = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.css = $util.emptyArray, r.prototype.displayValue = "", r.prototype.hasDisplayValue = !1, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.css != null && n.css.length)
      for (let e = 0; e < n.css.length; ++e)
        $root.CSSStyle.encode(n.css[e], t.uint32(
          /* id 1, wireType 2 =*/
          10
        ).fork()).ldelim();
    return n.displayValue != null && Object.hasOwnProperty.call(n, "displayValue") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.displayValue), n.hasDisplayValue != null && Object.hasOwnProperty.call(n, "hasDisplayValue") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(n.hasDisplayValue), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.CellStyle();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.css && p.css.length || (p.css = []), p.css.push($root.CSSStyle.decode(n, n.uint32()));
          break;
        }
        case 2: {
          p.displayValue = n.string();
          break;
        }
        case 3: {
          p.hasDisplayValue = n.bool();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.css != null && n.hasOwnProperty("css")) {
      if (!Array.isArray(n.css))
        return "css: array expected";
      for (let t = 0; t < n.css.length; ++t) {
        let e = $root.CSSStyle.verify(n.css[t]);
        if (e)
          return "css." + e;
      }
    }
    return n.displayValue != null && n.hasOwnProperty("displayValue") && !$util.isString(n.displayValue) ? "displayValue: string expected" : n.hasDisplayValue != null && n.hasOwnProperty("hasDisplayValue") && typeof n.hasDisplayValue != "boolean" ? "hasDisplayValue: boolean expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.CellStyle)
      return n;
    let t = new $root.CellStyle();
    if (n.css) {
      if (!Array.isArray(n.css))
        throw TypeError(".CellStyle.css: array expected");
      t.css = [];
      for (let e = 0; e < n.css.length; ++e) {
        if (typeof n.css[e] != "object")
          throw TypeError(".CellStyle.css: object expected");
        t.css[e] = $root.CSSStyle.fromObject(n.css[e]);
      }
    }
    return n.displayValue != null && (t.displayValue = String(n.displayValue)), n.hasDisplayValue != null && (t.hasDisplayValue = !!n.hasDisplayValue), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.css = []), t.defaults && (e.displayValue = "", e.hasDisplayValue = !1), n.css && n.css.length) {
      e.css = [];
      for (let o = 0; o < n.css.length; ++o)
        e.css[o] = $root.CSSStyle.toObject(n.css[o], t);
    }
    return n.displayValue != null && n.hasOwnProperty("displayValue") && (e.displayValue = n.displayValue), n.hasDisplayValue != null && n.hasOwnProperty("hasDisplayValue") && (e.hasDisplayValue = n.hasDisplayValue), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/CellStyle";
  }, r;
})();
$root.CellStyleArray = (() => {
  function r(c) {
    if (this.styles = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.styles = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.styles != null && n.styles.length)
      for (let e = 0; e < n.styles.length; ++e)
        $root.CellStyle.encode(n.styles[e], t.uint32(
          /* id 1, wireType 2 =*/
          10
        ).fork()).ldelim();
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.CellStyleArray();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.styles && p.styles.length || (p.styles = []), p.styles.push($root.CellStyle.decode(n, n.uint32()));
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.styles != null && n.hasOwnProperty("styles")) {
      if (!Array.isArray(n.styles))
        return "styles: array expected";
      for (let t = 0; t < n.styles.length; ++t) {
        let e = $root.CellStyle.verify(n.styles[t]);
        if (e)
          return "styles." + e;
      }
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.CellStyleArray)
      return n;
    let t = new $root.CellStyleArray();
    if (n.styles) {
      if (!Array.isArray(n.styles))
        throw TypeError(".CellStyleArray.styles: array expected");
      t.styles = [];
      for (let e = 0; e < n.styles.length; ++e) {
        if (typeof n.styles[e] != "object")
          throw TypeError(".CellStyleArray.styles: object expected");
        t.styles[e] = $root.CellStyle.fromObject(n.styles[e]);
      }
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.styles = []), n.styles && n.styles.length) {
      e.styles = [];
      for (let o = 0; o < n.styles.length; ++o)
        e.styles[o] = $root.CellStyle.toObject(n.styles[o], t);
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/CellStyleArray";
  }, r;
})();
$root.AnyArray = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.strings = null, r.prototype.doubles = null, r.prototype.int64s = null, r.prototype.datetimes = null, r.prototype.timedeltas = null;
  let c;
  return Object.defineProperty(r.prototype, "type", {
    get: $util.oneOfGetter(c = ["strings", "doubles", "int64s", "datetimes", "timedeltas"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.strings != null && Object.hasOwnProperty.call(t, "strings") && $root.StringArray.encode(t.strings, e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), t.doubles != null && Object.hasOwnProperty.call(t, "doubles") && $root.DoubleArray.encode(t.doubles, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), t.int64s != null && Object.hasOwnProperty.call(t, "int64s") && $root.Int64Array.encode(t.int64s, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), t.datetimes != null && Object.hasOwnProperty.call(t, "datetimes") && $root.StringArray.encode(t.datetimes, e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), t.timedeltas != null && Object.hasOwnProperty.call(t, "timedeltas") && $root.Int64Array.encode(t.timedeltas, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.AnyArray();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.strings = $root.StringArray.decode(t, t.uint32());
          break;
        }
        case 2: {
          h.doubles = $root.DoubleArray.decode(t, t.uint32());
          break;
        }
        case 3: {
          h.int64s = $root.Int64Array.decode(t, t.uint32());
          break;
        }
        case 4: {
          h.datetimes = $root.StringArray.decode(t, t.uint32());
          break;
        }
        case 5: {
          h.timedeltas = $root.Int64Array.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    let e = {};
    if (t.strings != null && t.hasOwnProperty("strings")) {
      e.type = 1;
      {
        let o = $root.StringArray.verify(t.strings);
        if (o)
          return "strings." + o;
      }
    }
    if (t.doubles != null && t.hasOwnProperty("doubles")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.DoubleArray.verify(t.doubles);
        if (o)
          return "doubles." + o;
      }
    }
    if (t.int64s != null && t.hasOwnProperty("int64s")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Int64Array.verify(t.int64s);
        if (o)
          return "int64s." + o;
      }
    }
    if (t.datetimes != null && t.hasOwnProperty("datetimes")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.StringArray.verify(t.datetimes);
        if (o)
          return "datetimes." + o;
      }
    }
    if (t.timedeltas != null && t.hasOwnProperty("timedeltas")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Int64Array.verify(t.timedeltas);
        if (o)
          return "timedeltas." + o;
      }
    }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.AnyArray)
      return t;
    let e = new $root.AnyArray();
    if (t.strings != null) {
      if (typeof t.strings != "object")
        throw TypeError(".AnyArray.strings: object expected");
      e.strings = $root.StringArray.fromObject(t.strings);
    }
    if (t.doubles != null) {
      if (typeof t.doubles != "object")
        throw TypeError(".AnyArray.doubles: object expected");
      e.doubles = $root.DoubleArray.fromObject(t.doubles);
    }
    if (t.int64s != null) {
      if (typeof t.int64s != "object")
        throw TypeError(".AnyArray.int64s: object expected");
      e.int64s = $root.Int64Array.fromObject(t.int64s);
    }
    if (t.datetimes != null) {
      if (typeof t.datetimes != "object")
        throw TypeError(".AnyArray.datetimes: object expected");
      e.datetimes = $root.StringArray.fromObject(t.datetimes);
    }
    if (t.timedeltas != null) {
      if (typeof t.timedeltas != "object")
        throw TypeError(".AnyArray.timedeltas: object expected");
      e.timedeltas = $root.Int64Array.fromObject(t.timedeltas);
    }
    return e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return t.strings != null && t.hasOwnProperty("strings") && (o.strings = $root.StringArray.toObject(t.strings, e), e.oneofs && (o.type = "strings")), t.doubles != null && t.hasOwnProperty("doubles") && (o.doubles = $root.DoubleArray.toObject(t.doubles, e), e.oneofs && (o.type = "doubles")), t.int64s != null && t.hasOwnProperty("int64s") && (o.int64s = $root.Int64Array.toObject(t.int64s, e), e.oneofs && (o.type = "int64s")), t.datetimes != null && t.hasOwnProperty("datetimes") && (o.datetimes = $root.StringArray.toObject(t.datetimes, e), e.oneofs && (o.type = "datetimes")), t.timedeltas != null && t.hasOwnProperty("timedeltas") && (o.timedeltas = $root.Int64Array.toObject(t.timedeltas, e), e.oneofs && (o.type = "timedeltas")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/AnyArray";
  }, r;
})();
$root.Table = (() => {
  function r(c) {
    if (this.cols = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.cols = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.cols != null && n.cols.length)
      for (let e = 0; e < n.cols.length; ++e)
        $root.AnyArray.encode(n.cols[e], t.uint32(
          /* id 1, wireType 2 =*/
          10
        ).fork()).ldelim();
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Table();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.cols && p.cols.length || (p.cols = []), p.cols.push($root.AnyArray.decode(n, n.uint32()));
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.cols != null && n.hasOwnProperty("cols")) {
      if (!Array.isArray(n.cols))
        return "cols: array expected";
      for (let t = 0; t < n.cols.length; ++t) {
        let e = $root.AnyArray.verify(n.cols[t]);
        if (e)
          return "cols." + e;
      }
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Table)
      return n;
    let t = new $root.Table();
    if (n.cols) {
      if (!Array.isArray(n.cols))
        throw TypeError(".Table.cols: array expected");
      t.cols = [];
      for (let e = 0; e < n.cols.length; ++e) {
        if (typeof n.cols[e] != "object")
          throw TypeError(".Table.cols: object expected");
        t.cols[e] = $root.AnyArray.fromObject(n.cols[e]);
      }
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.cols = []), n.cols && n.cols.length) {
      e.cols = [];
      for (let o = 0; o < n.cols.length; ++o)
        e.cols[o] = $root.AnyArray.toObject(n.cols[o], t);
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Table";
  }, r;
})();
$root.TableStyle = (() => {
  function r(c) {
    if (this.cols = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.cols = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.cols != null && n.cols.length)
      for (let e = 0; e < n.cols.length; ++e)
        $root.CellStyleArray.encode(n.cols[e], t.uint32(
          /* id 1, wireType 2 =*/
          10
        ).fork()).ldelim();
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.TableStyle();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.cols && p.cols.length || (p.cols = []), p.cols.push($root.CellStyleArray.decode(n, n.uint32()));
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.cols != null && n.hasOwnProperty("cols")) {
      if (!Array.isArray(n.cols))
        return "cols: array expected";
      for (let t = 0; t < n.cols.length; ++t) {
        let e = $root.CellStyleArray.verify(n.cols[t]);
        if (e)
          return "cols." + e;
      }
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.TableStyle)
      return n;
    let t = new $root.TableStyle();
    if (n.cols) {
      if (!Array.isArray(n.cols))
        throw TypeError(".TableStyle.cols: array expected");
      t.cols = [];
      for (let e = 0; e < n.cols.length; ++e) {
        if (typeof n.cols[e] != "object")
          throw TypeError(".TableStyle.cols: object expected");
        t.cols[e] = $root.CellStyleArray.fromObject(n.cols[e]);
      }
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.cols = []), n.cols && n.cols.length) {
      e.cols = [];
      for (let o = 0; o < n.cols.length; ++o)
        e.cols[o] = $root.CellStyleArray.toObject(n.cols[o], t);
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/TableStyle";
  }, r;
})();
$root.DateInput = (() => {
  function r(c) {
    if (this.default = [], this.value = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.id = "", r.prototype.label = "", r.prototype.default = $util.emptyArray, r.prototype.min = "", r.prototype.max = "", r.prototype.isRange = !1, r.prototype.help = "", r.prototype.formId = "", r.prototype.value = $util.emptyArray, r.prototype.setValue = !1, r.prototype.disabled = !1, r.prototype.labelVisibility = null, r.prototype.format = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.id != null && Object.hasOwnProperty.call(n, "id") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.id), n.label != null && Object.hasOwnProperty.call(n, "label") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.label), n.default != null && n.default.length)
      for (let e = 0; e < n.default.length; ++e)
        t.uint32(
          /* id 3, wireType 2 =*/
          26
        ).string(n.default[e]);
    if (n.min != null && Object.hasOwnProperty.call(n, "min") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.min), n.max != null && Object.hasOwnProperty.call(n, "max") && t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(n.max), n.isRange != null && Object.hasOwnProperty.call(n, "isRange") && t.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(n.isRange), n.help != null && Object.hasOwnProperty.call(n, "help") && t.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(n.help), n.formId != null && Object.hasOwnProperty.call(n, "formId") && t.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(n.formId), n.value != null && n.value.length)
      for (let e = 0; e < n.value.length; ++e)
        t.uint32(
          /* id 9, wireType 2 =*/
          74
        ).string(n.value[e]);
    return n.setValue != null && Object.hasOwnProperty.call(n, "setValue") && t.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(n.setValue), n.disabled != null && Object.hasOwnProperty.call(n, "disabled") && t.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(n.disabled), n.labelVisibility != null && Object.hasOwnProperty.call(n, "labelVisibility") && $root.LabelVisibilityMessage.encode(n.labelVisibility, t.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), n.format != null && Object.hasOwnProperty.call(n, "format") && t.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(n.format), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.DateInput();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.id = n.string();
          break;
        }
        case 2: {
          p.label = n.string();
          break;
        }
        case 3: {
          p.default && p.default.length || (p.default = []), p.default.push(n.string());
          break;
        }
        case 4: {
          p.min = n.string();
          break;
        }
        case 5: {
          p.max = n.string();
          break;
        }
        case 6: {
          p.isRange = n.bool();
          break;
        }
        case 7: {
          p.help = n.string();
          break;
        }
        case 8: {
          p.formId = n.string();
          break;
        }
        case 9: {
          p.value && p.value.length || (p.value = []), p.value.push(n.string());
          break;
        }
        case 10: {
          p.setValue = n.bool();
          break;
        }
        case 11: {
          p.disabled = n.bool();
          break;
        }
        case 12: {
          p.labelVisibility = $root.LabelVisibilityMessage.decode(n, n.uint32());
          break;
        }
        case 13: {
          p.format = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.id != null && n.hasOwnProperty("id") && !$util.isString(n.id))
      return "id: string expected";
    if (n.label != null && n.hasOwnProperty("label") && !$util.isString(n.label))
      return "label: string expected";
    if (n.default != null && n.hasOwnProperty("default")) {
      if (!Array.isArray(n.default))
        return "default: array expected";
      for (let t = 0; t < n.default.length; ++t)
        if (!$util.isString(n.default[t]))
          return "default: string[] expected";
    }
    if (n.min != null && n.hasOwnProperty("min") && !$util.isString(n.min))
      return "min: string expected";
    if (n.max != null && n.hasOwnProperty("max") && !$util.isString(n.max))
      return "max: string expected";
    if (n.isRange != null && n.hasOwnProperty("isRange") && typeof n.isRange != "boolean")
      return "isRange: boolean expected";
    if (n.help != null && n.hasOwnProperty("help") && !$util.isString(n.help))
      return "help: string expected";
    if (n.formId != null && n.hasOwnProperty("formId") && !$util.isString(n.formId))
      return "formId: string expected";
    if (n.value != null && n.hasOwnProperty("value")) {
      if (!Array.isArray(n.value))
        return "value: array expected";
      for (let t = 0; t < n.value.length; ++t)
        if (!$util.isString(n.value[t]))
          return "value: string[] expected";
    }
    if (n.setValue != null && n.hasOwnProperty("setValue") && typeof n.setValue != "boolean")
      return "setValue: boolean expected";
    if (n.disabled != null && n.hasOwnProperty("disabled") && typeof n.disabled != "boolean")
      return "disabled: boolean expected";
    if (n.labelVisibility != null && n.hasOwnProperty("labelVisibility")) {
      let t = $root.LabelVisibilityMessage.verify(n.labelVisibility);
      if (t)
        return "labelVisibility." + t;
    }
    return n.format != null && n.hasOwnProperty("format") && !$util.isString(n.format) ? "format: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.DateInput)
      return n;
    let t = new $root.DateInput();
    if (n.id != null && (t.id = String(n.id)), n.label != null && (t.label = String(n.label)), n.default) {
      if (!Array.isArray(n.default))
        throw TypeError(".DateInput.default: array expected");
      t.default = [];
      for (let e = 0; e < n.default.length; ++e)
        t.default[e] = String(n.default[e]);
    }
    if (n.min != null && (t.min = String(n.min)), n.max != null && (t.max = String(n.max)), n.isRange != null && (t.isRange = !!n.isRange), n.help != null && (t.help = String(n.help)), n.formId != null && (t.formId = String(n.formId)), n.value) {
      if (!Array.isArray(n.value))
        throw TypeError(".DateInput.value: array expected");
      t.value = [];
      for (let e = 0; e < n.value.length; ++e)
        t.value[e] = String(n.value[e]);
    }
    if (n.setValue != null && (t.setValue = !!n.setValue), n.disabled != null && (t.disabled = !!n.disabled), n.labelVisibility != null) {
      if (typeof n.labelVisibility != "object")
        throw TypeError(".DateInput.labelVisibility: object expected");
      t.labelVisibility = $root.LabelVisibilityMessage.fromObject(n.labelVisibility);
    }
    return n.format != null && (t.format = String(n.format)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.default = [], e.value = []), t.defaults && (e.id = "", e.label = "", e.min = "", e.max = "", e.isRange = !1, e.help = "", e.formId = "", e.setValue = !1, e.disabled = !1, e.labelVisibility = null, e.format = ""), n.id != null && n.hasOwnProperty("id") && (e.id = n.id), n.label != null && n.hasOwnProperty("label") && (e.label = n.label), n.default && n.default.length) {
      e.default = [];
      for (let o = 0; o < n.default.length; ++o)
        e.default[o] = n.default[o];
    }
    if (n.min != null && n.hasOwnProperty("min") && (e.min = n.min), n.max != null && n.hasOwnProperty("max") && (e.max = n.max), n.isRange != null && n.hasOwnProperty("isRange") && (e.isRange = n.isRange), n.help != null && n.hasOwnProperty("help") && (e.help = n.help), n.formId != null && n.hasOwnProperty("formId") && (e.formId = n.formId), n.value && n.value.length) {
      e.value = [];
      for (let o = 0; o < n.value.length; ++o)
        e.value[o] = n.value[o];
    }
    return n.setValue != null && n.hasOwnProperty("setValue") && (e.setValue = n.setValue), n.disabled != null && n.hasOwnProperty("disabled") && (e.disabled = n.disabled), n.labelVisibility != null && n.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(n.labelVisibility, t)), n.format != null && n.hasOwnProperty("format") && (e.format = n.format), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/DateInput";
  }, r;
})();
$root.DeckGlJsonChart = (() => {
  function r(c) {
    if (this.selectionMode = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.json = "", r.prototype.tooltip = "", r.prototype.useContainerWidth = !1, r.prototype.id = "", r.prototype.mapboxToken = "", r.prototype.width = 0, r.prototype.height = 0, r.prototype.selectionMode = $util.emptyArray, r.prototype.formId = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.json != null && Object.hasOwnProperty.call(n, "json") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.json), n.tooltip != null && Object.hasOwnProperty.call(n, "tooltip") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.tooltip), n.useContainerWidth != null && Object.hasOwnProperty.call(n, "useContainerWidth") && t.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(n.useContainerWidth), n.id != null && Object.hasOwnProperty.call(n, "id") && t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(n.id), n.mapboxToken != null && Object.hasOwnProperty.call(n, "mapboxToken") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.mapboxToken), n.width != null && Object.hasOwnProperty.call(n, "width") && t.uint32(
      /* id 7, wireType 0 =*/
      56
    ).uint32(n.width), n.height != null && Object.hasOwnProperty.call(n, "height") && t.uint32(
      /* id 8, wireType 0 =*/
      64
    ).uint32(n.height), n.selectionMode != null && n.selectionMode.length) {
      t.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let e = 0; e < n.selectionMode.length; ++e)
        t.int32(n.selectionMode[e]);
      t.ldelim();
    }
    return n.formId != null && Object.hasOwnProperty.call(n, "formId") && t.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(n.formId), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.DeckGlJsonChart();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.json = n.string();
          break;
        }
        case 2: {
          p.tooltip = n.string();
          break;
        }
        case 4: {
          p.useContainerWidth = n.bool();
          break;
        }
        case 5: {
          p.id = n.string();
          break;
        }
        case 6: {
          p.mapboxToken = n.string();
          break;
        }
        case 7: {
          p.width = n.uint32();
          break;
        }
        case 8: {
          p.height = n.uint32();
          break;
        }
        case 9: {
          if (p.selectionMode && p.selectionMode.length || (p.selectionMode = []), (h & 7) === 2) {
            let y = n.uint32() + n.pos;
            for (; n.pos < y; )
              p.selectionMode.push(n.int32());
          } else
            p.selectionMode.push(n.int32());
          break;
        }
        case 10: {
          p.formId = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.json != null && n.hasOwnProperty("json") && !$util.isString(n.json))
      return "json: string expected";
    if (n.tooltip != null && n.hasOwnProperty("tooltip") && !$util.isString(n.tooltip))
      return "tooltip: string expected";
    if (n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && typeof n.useContainerWidth != "boolean")
      return "useContainerWidth: boolean expected";
    if (n.id != null && n.hasOwnProperty("id") && !$util.isString(n.id))
      return "id: string expected";
    if (n.mapboxToken != null && n.hasOwnProperty("mapboxToken") && !$util.isString(n.mapboxToken))
      return "mapboxToken: string expected";
    if (n.width != null && n.hasOwnProperty("width") && !$util.isInteger(n.width))
      return "width: integer expected";
    if (n.height != null && n.hasOwnProperty("height") && !$util.isInteger(n.height))
      return "height: integer expected";
    if (n.selectionMode != null && n.hasOwnProperty("selectionMode")) {
      if (!Array.isArray(n.selectionMode))
        return "selectionMode: array expected";
      for (let t = 0; t < n.selectionMode.length; ++t)
        switch (n.selectionMode[t]) {
          default:
            return "selectionMode: enum value[] expected";
          case 0:
          case 1:
            break;
        }
    }
    return n.formId != null && n.hasOwnProperty("formId") && !$util.isString(n.formId) ? "formId: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.DeckGlJsonChart)
      return n;
    let t = new $root.DeckGlJsonChart();
    if (n.json != null && (t.json = String(n.json)), n.tooltip != null && (t.tooltip = String(n.tooltip)), n.useContainerWidth != null && (t.useContainerWidth = !!n.useContainerWidth), n.id != null && (t.id = String(n.id)), n.mapboxToken != null && (t.mapboxToken = String(n.mapboxToken)), n.width != null && (t.width = n.width >>> 0), n.height != null && (t.height = n.height >>> 0), n.selectionMode) {
      if (!Array.isArray(n.selectionMode))
        throw TypeError(".DeckGlJsonChart.selectionMode: array expected");
      t.selectionMode = [];
      for (let e = 0; e < n.selectionMode.length; ++e)
        switch (n.selectionMode[e]) {
          default:
            if (typeof n.selectionMode[e] == "number") {
              t.selectionMode[e] = n.selectionMode[e];
              break;
            }
          case "SINGLE_OBJECT":
          case 0:
            t.selectionMode[e] = 0;
            break;
          case "MULTI_OBJECT":
          case 1:
            t.selectionMode[e] = 1;
            break;
        }
    }
    return n.formId != null && (t.formId = String(n.formId)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.selectionMode = []), t.defaults && (e.json = "", e.tooltip = "", e.useContainerWidth = !1, e.id = "", e.mapboxToken = "", e.width = 0, e.height = 0, e.formId = ""), n.json != null && n.hasOwnProperty("json") && (e.json = n.json), n.tooltip != null && n.hasOwnProperty("tooltip") && (e.tooltip = n.tooltip), n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = n.useContainerWidth), n.id != null && n.hasOwnProperty("id") && (e.id = n.id), n.mapboxToken != null && n.hasOwnProperty("mapboxToken") && (e.mapboxToken = n.mapboxToken), n.width != null && n.hasOwnProperty("width") && (e.width = n.width), n.height != null && n.hasOwnProperty("height") && (e.height = n.height), n.selectionMode && n.selectionMode.length) {
      e.selectionMode = [];
      for (let o = 0; o < n.selectionMode.length; ++o)
        e.selectionMode[o] = t.enums === String ? $root.DeckGlJsonChart.SelectionMode[n.selectionMode[o]] === void 0 ? n.selectionMode[o] : $root.DeckGlJsonChart.SelectionMode[n.selectionMode[o]] : n.selectionMode[o];
    }
    return n.formId != null && n.hasOwnProperty("formId") && (e.formId = n.formId), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/DeckGlJsonChart";
  }, r.SelectionMode = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "SINGLE_OBJECT"] = 0, n[c[1] = "MULTI_OBJECT"] = 1, n;
  })(), r;
})();
$root.Delta = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.newElement = null, r.prototype.addBlock = null, r.prototype.addRows = null, r.prototype.arrowAddRows = null, r.prototype.fragmentId = "";
  let c;
  return Object.defineProperty(r.prototype, "type", {
    get: $util.oneOfGetter(c = ["newElement", "addBlock", "addRows", "arrowAddRows"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.newElement != null && Object.hasOwnProperty.call(t, "newElement") && $root.Element.encode(t.newElement, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), t.addRows != null && Object.hasOwnProperty.call(t, "addRows") && $root.NamedDataSet.encode(t.addRows, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), t.addBlock != null && Object.hasOwnProperty.call(t, "addBlock") && $root.Block.encode(t.addBlock, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), t.arrowAddRows != null && Object.hasOwnProperty.call(t, "arrowAddRows") && $root.ArrowNamedDataSet.encode(t.arrowAddRows, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), t.fragmentId != null && Object.hasOwnProperty.call(t, "fragmentId") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(t.fragmentId), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.Delta();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 3: {
          h.newElement = $root.Element.decode(t, t.uint32());
          break;
        }
        case 6: {
          h.addBlock = $root.Block.decode(t, t.uint32());
          break;
        }
        case 5: {
          h.addRows = $root.NamedDataSet.decode(t, t.uint32());
          break;
        }
        case 7: {
          h.arrowAddRows = $root.ArrowNamedDataSet.decode(t, t.uint32());
          break;
        }
        case 8: {
          h.fragmentId = t.string();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    let e = {};
    if (t.newElement != null && t.hasOwnProperty("newElement")) {
      e.type = 1;
      {
        let o = $root.Element.verify(t.newElement);
        if (o)
          return "newElement." + o;
      }
    }
    if (t.addBlock != null && t.hasOwnProperty("addBlock")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Block.verify(t.addBlock);
        if (o)
          return "addBlock." + o;
      }
    }
    if (t.addRows != null && t.hasOwnProperty("addRows")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.NamedDataSet.verify(t.addRows);
        if (o)
          return "addRows." + o;
      }
    }
    if (t.arrowAddRows != null && t.hasOwnProperty("arrowAddRows")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.ArrowNamedDataSet.verify(t.arrowAddRows);
        if (o)
          return "arrowAddRows." + o;
      }
    }
    return t.fragmentId != null && t.hasOwnProperty("fragmentId") && !$util.isString(t.fragmentId) ? "fragmentId: string expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.Delta)
      return t;
    let e = new $root.Delta();
    if (t.newElement != null) {
      if (typeof t.newElement != "object")
        throw TypeError(".Delta.newElement: object expected");
      e.newElement = $root.Element.fromObject(t.newElement);
    }
    if (t.addBlock != null) {
      if (typeof t.addBlock != "object")
        throw TypeError(".Delta.addBlock: object expected");
      e.addBlock = $root.Block.fromObject(t.addBlock);
    }
    if (t.addRows != null) {
      if (typeof t.addRows != "object")
        throw TypeError(".Delta.addRows: object expected");
      e.addRows = $root.NamedDataSet.fromObject(t.addRows);
    }
    if (t.arrowAddRows != null) {
      if (typeof t.arrowAddRows != "object")
        throw TypeError(".Delta.arrowAddRows: object expected");
      e.arrowAddRows = $root.ArrowNamedDataSet.fromObject(t.arrowAddRows);
    }
    return t.fragmentId != null && (e.fragmentId = String(t.fragmentId)), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.fragmentId = ""), t.newElement != null && t.hasOwnProperty("newElement") && (o.newElement = $root.Element.toObject(t.newElement, e), e.oneofs && (o.type = "newElement")), t.addRows != null && t.hasOwnProperty("addRows") && (o.addRows = $root.NamedDataSet.toObject(t.addRows, e), e.oneofs && (o.type = "addRows")), t.addBlock != null && t.hasOwnProperty("addBlock") && (o.addBlock = $root.Block.toObject(t.addBlock, e), e.oneofs && (o.type = "addBlock")), t.arrowAddRows != null && t.hasOwnProperty("arrowAddRows") && (o.arrowAddRows = $root.ArrowNamedDataSet.toObject(t.arrowAddRows, e), e.oneofs && (o.type = "arrowAddRows")), t.fragmentId != null && t.hasOwnProperty("fragmentId") && (o.fragmentId = t.fragmentId), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Delta";
  }, r;
})();
$root.Element = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.heightConfig = null, r.prototype.widthConfig = null, r.prototype.alert = null, r.prototype.arrowDataFrame = null, r.prototype.arrowTable = null, r.prototype.arrowVegaLiteChart = null, r.prototype.audio = null, r.prototype.audioInput = null, r.prototype.balloons = null, r.prototype.bokehChart = null, r.prototype.button = null, r.prototype.buttonGroup = null, r.prototype.downloadButton = null, r.prototype.cameraInput = null, r.prototype.chatInput = null, r.prototype.checkbox = null, r.prototype.colorPicker = null, r.prototype.componentInstance = null, r.prototype.dataFrame = null, r.prototype.table = null, r.prototype.dateInput = null, r.prototype.deckGlJsonChart = null, r.prototype.docString = null, r.prototype.empty = null, r.prototype.exception = null, r.prototype.favicon = null, r.prototype.fileUploader = null, r.prototype.graphvizChart = null, r.prototype.html = null, r.prototype.iframe = null, r.prototype.imgs = null, r.prototype.json = null, r.prototype.linkButton = null, r.prototype.markdown = null, r.prototype.metric = null, r.prototype.multiselect = null, r.prototype.numberInput = null, r.prototype.pageLink = null, r.prototype.plotlyChart = null, r.prototype.progress = null, r.prototype.radio = null, r.prototype.selectbox = null, r.prototype.skeleton = null, r.prototype.slider = null, r.prototype.snow = null, r.prototype.spinner = null, r.prototype.text = null, r.prototype.textArea = null, r.prototype.textInput = null, r.prototype.timeInput = null, r.prototype.toast = null, r.prototype.vegaLiteChart = null, r.prototype.video = null, r.prototype.heading = null, r.prototype.code = null;
  let c;
  return Object.defineProperty(r.prototype, "_heightConfig", {
    get: $util.oneOfGetter(c = ["heightConfig"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_widthConfig", {
    get: $util.oneOfGetter(c = ["widthConfig"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "type", {
    get: $util.oneOfGetter(c = ["alert", "arrowDataFrame", "arrowTable", "arrowVegaLiteChart", "audio", "audioInput", "balloons", "bokehChart", "button", "buttonGroup", "downloadButton", "cameraInput", "chatInput", "checkbox", "colorPicker", "componentInstance", "dataFrame", "table", "dateInput", "deckGlJsonChart", "docString", "empty", "exception", "favicon", "fileUploader", "graphvizChart", "html", "iframe", "imgs", "json", "linkButton", "markdown", "metric", "multiselect", "numberInput", "pageLink", "plotlyChart", "progress", "radio", "selectbox", "skeleton", "slider", "snow", "spinner", "text", "textArea", "textInput", "timeInput", "toast", "vegaLiteChart", "video", "heading", "code"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.text != null && Object.hasOwnProperty.call(t, "text") && $root.Text.encode(t.text, e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), t.empty != null && Object.hasOwnProperty.call(t, "empty") && $root.Empty.encode(t.empty, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), t.dataFrame != null && Object.hasOwnProperty.call(t, "dataFrame") && $root.DataFrame.encode(t.dataFrame, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), t.progress != null && Object.hasOwnProperty.call(t, "progress") && $root.Progress.encode(t.progress, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), t.imgs != null && Object.hasOwnProperty.call(t, "imgs") && $root.ImageList.encode(t.imgs, e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), t.docString != null && Object.hasOwnProperty.call(t, "docString") && $root.DocString.encode(t.docString, e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), t.exception != null && Object.hasOwnProperty.call(t, "exception") && $root.Exception.encode(t.exception, e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).fork()).ldelim(), t.vegaLiteChart != null && Object.hasOwnProperty.call(t, "vegaLiteChart") && $root.VegaLiteChart.encode(t.vegaLiteChart, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), t.table != null && Object.hasOwnProperty.call(t, "table") && $root.DataFrame.encode(t.table, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), t.balloons != null && Object.hasOwnProperty.call(t, "balloons") && $root.Balloons.encode(t.balloons, e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), t.audio != null && Object.hasOwnProperty.call(t, "audio") && $root.Audio.encode(t.audio, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), t.video != null && Object.hasOwnProperty.call(t, "video") && $root.Video.encode(t.video, e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), t.plotlyChart != null && Object.hasOwnProperty.call(t, "plotlyChart") && $root.PlotlyChart.encode(t.plotlyChart, e.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), t.bokehChart != null && Object.hasOwnProperty.call(t, "bokehChart") && $root.BokehChart.encode(t.bokehChart, e.uint32(
      /* id 17, wireType 2 =*/
      138
    ).fork()).ldelim(), t.graphvizChart != null && Object.hasOwnProperty.call(t, "graphvizChart") && $root.GraphVizChart.encode(t.graphvizChart, e.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), t.button != null && Object.hasOwnProperty.call(t, "button") && $root.Button.encode(t.button, e.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), t.checkbox != null && Object.hasOwnProperty.call(t, "checkbox") && $root.Checkbox.encode(t.checkbox, e.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), t.slider != null && Object.hasOwnProperty.call(t, "slider") && $root.Slider.encode(t.slider, e.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), t.textArea != null && Object.hasOwnProperty.call(t, "textArea") && $root.TextArea.encode(t.textArea, e.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), t.radio != null && Object.hasOwnProperty.call(t, "radio") && $root.Radio.encode(t.radio, e.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), t.textInput != null && Object.hasOwnProperty.call(t, "textInput") && $root.TextInput.encode(t.textInput, e.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), t.selectbox != null && Object.hasOwnProperty.call(t, "selectbox") && $root.Selectbox.encode(t.selectbox, e.uint32(
      /* id 25, wireType 2 =*/
      202
    ).fork()).ldelim(), t.timeInput != null && Object.hasOwnProperty.call(t, "timeInput") && $root.TimeInput.encode(t.timeInput, e.uint32(
      /* id 26, wireType 2 =*/
      210
    ).fork()).ldelim(), t.dateInput != null && Object.hasOwnProperty.call(t, "dateInput") && $root.DateInput.encode(t.dateInput, e.uint32(
      /* id 27, wireType 2 =*/
      218
    ).fork()).ldelim(), t.multiselect != null && Object.hasOwnProperty.call(t, "multiselect") && $root.MultiSelect.encode(t.multiselect, e.uint32(
      /* id 28, wireType 2 =*/
      226
    ).fork()).ldelim(), t.markdown != null && Object.hasOwnProperty.call(t, "markdown") && $root.Markdown.encode(t.markdown, e.uint32(
      /* id 29, wireType 2 =*/
      234
    ).fork()).ldelim(), t.alert != null && Object.hasOwnProperty.call(t, "alert") && $root.Alert.encode(t.alert, e.uint32(
      /* id 30, wireType 2 =*/
      242
    ).fork()).ldelim(), t.json != null && Object.hasOwnProperty.call(t, "json") && $root.Json.encode(t.json, e.uint32(
      /* id 31, wireType 2 =*/
      250
    ).fork()).ldelim(), t.numberInput != null && Object.hasOwnProperty.call(t, "numberInput") && $root.NumberInput.encode(t.numberInput, e.uint32(
      /* id 32, wireType 2 =*/
      258
    ).fork()).ldelim(), t.fileUploader != null && Object.hasOwnProperty.call(t, "fileUploader") && $root.FileUploader.encode(t.fileUploader, e.uint32(
      /* id 33, wireType 2 =*/
      266
    ).fork()).ldelim(), t.deckGlJsonChart != null && Object.hasOwnProperty.call(t, "deckGlJsonChart") && $root.DeckGlJsonChart.encode(t.deckGlJsonChart, e.uint32(
      /* id 34, wireType 2 =*/
      274
    ).fork()).ldelim(), t.colorPicker != null && Object.hasOwnProperty.call(t, "colorPicker") && $root.ColorPicker.encode(t.colorPicker, e.uint32(
      /* id 35, wireType 2 =*/
      282
    ).fork()).ldelim(), t.favicon != null && Object.hasOwnProperty.call(t, "favicon") && $root.Favicon.encode(t.favicon, e.uint32(
      /* id 36, wireType 2 =*/
      290
    ).fork()).ldelim(), t.componentInstance != null && Object.hasOwnProperty.call(t, "componentInstance") && $root.ComponentInstance.encode(t.componentInstance, e.uint32(
      /* id 37, wireType 2 =*/
      298
    ).fork()).ldelim(), t.iframe != null && Object.hasOwnProperty.call(t, "iframe") && $root.IFrame.encode(t.iframe, e.uint32(
      /* id 38, wireType 2 =*/
      306
    ).fork()).ldelim(), t.arrowTable != null && Object.hasOwnProperty.call(t, "arrowTable") && $root.Arrow.encode(t.arrowTable, e.uint32(
      /* id 39, wireType 2 =*/
      314
    ).fork()).ldelim(), t.arrowDataFrame != null && Object.hasOwnProperty.call(t, "arrowDataFrame") && $root.Arrow.encode(t.arrowDataFrame, e.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), t.arrowVegaLiteChart != null && Object.hasOwnProperty.call(t, "arrowVegaLiteChart") && $root.ArrowVegaLiteChart.encode(t.arrowVegaLiteChart, e.uint32(
      /* id 41, wireType 2 =*/
      330
    ).fork()).ldelim(), t.metric != null && Object.hasOwnProperty.call(t, "metric") && $root.Metric.encode(t.metric, e.uint32(
      /* id 42, wireType 2 =*/
      338
    ).fork()).ldelim(), t.downloadButton != null && Object.hasOwnProperty.call(t, "downloadButton") && $root.DownloadButton.encode(t.downloadButton, e.uint32(
      /* id 43, wireType 2 =*/
      346
    ).fork()).ldelim(), t.spinner != null && Object.hasOwnProperty.call(t, "spinner") && $root.Spinner.encode(t.spinner, e.uint32(
      /* id 44, wireType 2 =*/
      354
    ).fork()).ldelim(), t.cameraInput != null && Object.hasOwnProperty.call(t, "cameraInput") && $root.CameraInput.encode(t.cameraInput, e.uint32(
      /* id 45, wireType 2 =*/
      362
    ).fork()).ldelim(), t.snow != null && Object.hasOwnProperty.call(t, "snow") && $root.Snow.encode(t.snow, e.uint32(
      /* id 46, wireType 2 =*/
      370
    ).fork()).ldelim(), t.heading != null && Object.hasOwnProperty.call(t, "heading") && $root.Heading.encode(t.heading, e.uint32(
      /* id 47, wireType 2 =*/
      378
    ).fork()).ldelim(), t.code != null && Object.hasOwnProperty.call(t, "code") && $root.Code.encode(t.code, e.uint32(
      /* id 48, wireType 2 =*/
      386
    ).fork()).ldelim(), t.chatInput != null && Object.hasOwnProperty.call(t, "chatInput") && $root.ChatInput.encode(t.chatInput, e.uint32(
      /* id 49, wireType 2 =*/
      394
    ).fork()).ldelim(), t.toast != null && Object.hasOwnProperty.call(t, "toast") && $root.Toast.encode(t.toast, e.uint32(
      /* id 50, wireType 2 =*/
      402
    ).fork()).ldelim(), t.linkButton != null && Object.hasOwnProperty.call(t, "linkButton") && $root.LinkButton.encode(t.linkButton, e.uint32(
      /* id 51, wireType 2 =*/
      410
    ).fork()).ldelim(), t.skeleton != null && Object.hasOwnProperty.call(t, "skeleton") && $root.Skeleton.encode(t.skeleton, e.uint32(
      /* id 52, wireType 2 =*/
      418
    ).fork()).ldelim(), t.pageLink != null && Object.hasOwnProperty.call(t, "pageLink") && $root.PageLink.encode(t.pageLink, e.uint32(
      /* id 53, wireType 2 =*/
      426
    ).fork()).ldelim(), t.html != null && Object.hasOwnProperty.call(t, "html") && $root.Html.encode(t.html, e.uint32(
      /* id 54, wireType 2 =*/
      434
    ).fork()).ldelim(), t.buttonGroup != null && Object.hasOwnProperty.call(t, "buttonGroup") && $root.ButtonGroup.encode(t.buttonGroup, e.uint32(
      /* id 55, wireType 2 =*/
      442
    ).fork()).ldelim(), t.audioInput != null && Object.hasOwnProperty.call(t, "audioInput") && $root.AudioInput.encode(t.audioInput, e.uint32(
      /* id 56, wireType 2 =*/
      450
    ).fork()).ldelim(), t.heightConfig != null && Object.hasOwnProperty.call(t, "heightConfig") && $root.streamlit.HeightConfig.encode(t.heightConfig, e.uint32(
      /* id 57, wireType 2 =*/
      458
    ).fork()).ldelim(), t.widthConfig != null && Object.hasOwnProperty.call(t, "widthConfig") && $root.streamlit.WidthConfig.encode(t.widthConfig, e.uint32(
      /* id 58, wireType 2 =*/
      466
    ).fork()).ldelim(), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.Element();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 57: {
          h.heightConfig = $root.streamlit.HeightConfig.decode(t, t.uint32());
          break;
        }
        case 58: {
          h.widthConfig = $root.streamlit.WidthConfig.decode(t, t.uint32());
          break;
        }
        case 30: {
          h.alert = $root.Alert.decode(t, t.uint32());
          break;
        }
        case 40: {
          h.arrowDataFrame = $root.Arrow.decode(t, t.uint32());
          break;
        }
        case 39: {
          h.arrowTable = $root.Arrow.decode(t, t.uint32());
          break;
        }
        case 41: {
          h.arrowVegaLiteChart = $root.ArrowVegaLiteChart.decode(t, t.uint32());
          break;
        }
        case 13: {
          h.audio = $root.Audio.decode(t, t.uint32());
          break;
        }
        case 56: {
          h.audioInput = $root.AudioInput.decode(t, t.uint32());
          break;
        }
        case 12: {
          h.balloons = $root.Balloons.decode(t, t.uint32());
          break;
        }
        case 17: {
          h.bokehChart = $root.BokehChart.decode(t, t.uint32());
          break;
        }
        case 19: {
          h.button = $root.Button.decode(t, t.uint32());
          break;
        }
        case 55: {
          h.buttonGroup = $root.ButtonGroup.decode(t, t.uint32());
          break;
        }
        case 43: {
          h.downloadButton = $root.DownloadButton.decode(t, t.uint32());
          break;
        }
        case 45: {
          h.cameraInput = $root.CameraInput.decode(t, t.uint32());
          break;
        }
        case 49: {
          h.chatInput = $root.ChatInput.decode(t, t.uint32());
          break;
        }
        case 20: {
          h.checkbox = $root.Checkbox.decode(t, t.uint32());
          break;
        }
        case 35: {
          h.colorPicker = $root.ColorPicker.decode(t, t.uint32());
          break;
        }
        case 37: {
          h.componentInstance = $root.ComponentInstance.decode(t, t.uint32());
          break;
        }
        case 3: {
          h.dataFrame = $root.DataFrame.decode(t, t.uint32());
          break;
        }
        case 11: {
          h.table = $root.DataFrame.decode(t, t.uint32());
          break;
        }
        case 27: {
          h.dateInput = $root.DateInput.decode(t, t.uint32());
          break;
        }
        case 34: {
          h.deckGlJsonChart = $root.DeckGlJsonChart.decode(t, t.uint32());
          break;
        }
        case 7: {
          h.docString = $root.DocString.decode(t, t.uint32());
          break;
        }
        case 2: {
          h.empty = $root.Empty.decode(t, t.uint32());
          break;
        }
        case 8: {
          h.exception = $root.Exception.decode(t, t.uint32());
          break;
        }
        case 36: {
          h.favicon = $root.Favicon.decode(t, t.uint32());
          break;
        }
        case 33: {
          h.fileUploader = $root.FileUploader.decode(t, t.uint32());
          break;
        }
        case 18: {
          h.graphvizChart = $root.GraphVizChart.decode(t, t.uint32());
          break;
        }
        case 54: {
          h.html = $root.Html.decode(t, t.uint32());
          break;
        }
        case 38: {
          h.iframe = $root.IFrame.decode(t, t.uint32());
          break;
        }
        case 6: {
          h.imgs = $root.ImageList.decode(t, t.uint32());
          break;
        }
        case 31: {
          h.json = $root.Json.decode(t, t.uint32());
          break;
        }
        case 51: {
          h.linkButton = $root.LinkButton.decode(t, t.uint32());
          break;
        }
        case 29: {
          h.markdown = $root.Markdown.decode(t, t.uint32());
          break;
        }
        case 42: {
          h.metric = $root.Metric.decode(t, t.uint32());
          break;
        }
        case 28: {
          h.multiselect = $root.MultiSelect.decode(t, t.uint32());
          break;
        }
        case 32: {
          h.numberInput = $root.NumberInput.decode(t, t.uint32());
          break;
        }
        case 53: {
          h.pageLink = $root.PageLink.decode(t, t.uint32());
          break;
        }
        case 16: {
          h.plotlyChart = $root.PlotlyChart.decode(t, t.uint32());
          break;
        }
        case 5: {
          h.progress = $root.Progress.decode(t, t.uint32());
          break;
        }
        case 23: {
          h.radio = $root.Radio.decode(t, t.uint32());
          break;
        }
        case 25: {
          h.selectbox = $root.Selectbox.decode(t, t.uint32());
          break;
        }
        case 52: {
          h.skeleton = $root.Skeleton.decode(t, t.uint32());
          break;
        }
        case 21: {
          h.slider = $root.Slider.decode(t, t.uint32());
          break;
        }
        case 46: {
          h.snow = $root.Snow.decode(t, t.uint32());
          break;
        }
        case 44: {
          h.spinner = $root.Spinner.decode(t, t.uint32());
          break;
        }
        case 1: {
          h.text = $root.Text.decode(t, t.uint32());
          break;
        }
        case 22: {
          h.textArea = $root.TextArea.decode(t, t.uint32());
          break;
        }
        case 24: {
          h.textInput = $root.TextInput.decode(t, t.uint32());
          break;
        }
        case 26: {
          h.timeInput = $root.TimeInput.decode(t, t.uint32());
          break;
        }
        case 50: {
          h.toast = $root.Toast.decode(t, t.uint32());
          break;
        }
        case 10: {
          h.vegaLiteChart = $root.VegaLiteChart.decode(t, t.uint32());
          break;
        }
        case 14: {
          h.video = $root.Video.decode(t, t.uint32());
          break;
        }
        case 47: {
          h.heading = $root.Heading.decode(t, t.uint32());
          break;
        }
        case 48: {
          h.code = $root.Code.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    let e = {};
    if (t.heightConfig != null && t.hasOwnProperty("heightConfig")) {
      e._heightConfig = 1;
      {
        let o = $root.streamlit.HeightConfig.verify(t.heightConfig);
        if (o)
          return "heightConfig." + o;
      }
    }
    if (t.widthConfig != null && t.hasOwnProperty("widthConfig")) {
      e._widthConfig = 1;
      {
        let o = $root.streamlit.WidthConfig.verify(t.widthConfig);
        if (o)
          return "widthConfig." + o;
      }
    }
    if (t.alert != null && t.hasOwnProperty("alert")) {
      e.type = 1;
      {
        let o = $root.Alert.verify(t.alert);
        if (o)
          return "alert." + o;
      }
    }
    if (t.arrowDataFrame != null && t.hasOwnProperty("arrowDataFrame")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Arrow.verify(t.arrowDataFrame);
        if (o)
          return "arrowDataFrame." + o;
      }
    }
    if (t.arrowTable != null && t.hasOwnProperty("arrowTable")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Arrow.verify(t.arrowTable);
        if (o)
          return "arrowTable." + o;
      }
    }
    if (t.arrowVegaLiteChart != null && t.hasOwnProperty("arrowVegaLiteChart")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.ArrowVegaLiteChart.verify(t.arrowVegaLiteChart);
        if (o)
          return "arrowVegaLiteChart." + o;
      }
    }
    if (t.audio != null && t.hasOwnProperty("audio")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Audio.verify(t.audio);
        if (o)
          return "audio." + o;
      }
    }
    if (t.audioInput != null && t.hasOwnProperty("audioInput")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.AudioInput.verify(t.audioInput);
        if (o)
          return "audioInput." + o;
      }
    }
    if (t.balloons != null && t.hasOwnProperty("balloons")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Balloons.verify(t.balloons);
        if (o)
          return "balloons." + o;
      }
    }
    if (t.bokehChart != null && t.hasOwnProperty("bokehChart")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.BokehChart.verify(t.bokehChart);
        if (o)
          return "bokehChart." + o;
      }
    }
    if (t.button != null && t.hasOwnProperty("button")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Button.verify(t.button);
        if (o)
          return "button." + o;
      }
    }
    if (t.buttonGroup != null && t.hasOwnProperty("buttonGroup")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.ButtonGroup.verify(t.buttonGroup);
        if (o)
          return "buttonGroup." + o;
      }
    }
    if (t.downloadButton != null && t.hasOwnProperty("downloadButton")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.DownloadButton.verify(t.downloadButton);
        if (o)
          return "downloadButton." + o;
      }
    }
    if (t.cameraInput != null && t.hasOwnProperty("cameraInput")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.CameraInput.verify(t.cameraInput);
        if (o)
          return "cameraInput." + o;
      }
    }
    if (t.chatInput != null && t.hasOwnProperty("chatInput")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.ChatInput.verify(t.chatInput);
        if (o)
          return "chatInput." + o;
      }
    }
    if (t.checkbox != null && t.hasOwnProperty("checkbox")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Checkbox.verify(t.checkbox);
        if (o)
          return "checkbox." + o;
      }
    }
    if (t.colorPicker != null && t.hasOwnProperty("colorPicker")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.ColorPicker.verify(t.colorPicker);
        if (o)
          return "colorPicker." + o;
      }
    }
    if (t.componentInstance != null && t.hasOwnProperty("componentInstance")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.ComponentInstance.verify(t.componentInstance);
        if (o)
          return "componentInstance." + o;
      }
    }
    if (t.dataFrame != null && t.hasOwnProperty("dataFrame")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.DataFrame.verify(t.dataFrame);
        if (o)
          return "dataFrame." + o;
      }
    }
    if (t.table != null && t.hasOwnProperty("table")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.DataFrame.verify(t.table);
        if (o)
          return "table." + o;
      }
    }
    if (t.dateInput != null && t.hasOwnProperty("dateInput")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.DateInput.verify(t.dateInput);
        if (o)
          return "dateInput." + o;
      }
    }
    if (t.deckGlJsonChart != null && t.hasOwnProperty("deckGlJsonChart")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.DeckGlJsonChart.verify(t.deckGlJsonChart);
        if (o)
          return "deckGlJsonChart." + o;
      }
    }
    if (t.docString != null && t.hasOwnProperty("docString")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.DocString.verify(t.docString);
        if (o)
          return "docString." + o;
      }
    }
    if (t.empty != null && t.hasOwnProperty("empty")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Empty.verify(t.empty);
        if (o)
          return "empty." + o;
      }
    }
    if (t.exception != null && t.hasOwnProperty("exception")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Exception.verify(t.exception);
        if (o)
          return "exception." + o;
      }
    }
    if (t.favicon != null && t.hasOwnProperty("favicon")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Favicon.verify(t.favicon);
        if (o)
          return "favicon." + o;
      }
    }
    if (t.fileUploader != null && t.hasOwnProperty("fileUploader")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.FileUploader.verify(t.fileUploader);
        if (o)
          return "fileUploader." + o;
      }
    }
    if (t.graphvizChart != null && t.hasOwnProperty("graphvizChart")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.GraphVizChart.verify(t.graphvizChart);
        if (o)
          return "graphvizChart." + o;
      }
    }
    if (t.html != null && t.hasOwnProperty("html")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Html.verify(t.html);
        if (o)
          return "html." + o;
      }
    }
    if (t.iframe != null && t.hasOwnProperty("iframe")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.IFrame.verify(t.iframe);
        if (o)
          return "iframe." + o;
      }
    }
    if (t.imgs != null && t.hasOwnProperty("imgs")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.ImageList.verify(t.imgs);
        if (o)
          return "imgs." + o;
      }
    }
    if (t.json != null && t.hasOwnProperty("json")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Json.verify(t.json);
        if (o)
          return "json." + o;
      }
    }
    if (t.linkButton != null && t.hasOwnProperty("linkButton")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.LinkButton.verify(t.linkButton);
        if (o)
          return "linkButton." + o;
      }
    }
    if (t.markdown != null && t.hasOwnProperty("markdown")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Markdown.verify(t.markdown);
        if (o)
          return "markdown." + o;
      }
    }
    if (t.metric != null && t.hasOwnProperty("metric")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Metric.verify(t.metric);
        if (o)
          return "metric." + o;
      }
    }
    if (t.multiselect != null && t.hasOwnProperty("multiselect")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.MultiSelect.verify(t.multiselect);
        if (o)
          return "multiselect." + o;
      }
    }
    if (t.numberInput != null && t.hasOwnProperty("numberInput")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.NumberInput.verify(t.numberInput);
        if (o)
          return "numberInput." + o;
      }
    }
    if (t.pageLink != null && t.hasOwnProperty("pageLink")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.PageLink.verify(t.pageLink);
        if (o)
          return "pageLink." + o;
      }
    }
    if (t.plotlyChart != null && t.hasOwnProperty("plotlyChart")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.PlotlyChart.verify(t.plotlyChart);
        if (o)
          return "plotlyChart." + o;
      }
    }
    if (t.progress != null && t.hasOwnProperty("progress")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Progress.verify(t.progress);
        if (o)
          return "progress." + o;
      }
    }
    if (t.radio != null && t.hasOwnProperty("radio")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Radio.verify(t.radio);
        if (o)
          return "radio." + o;
      }
    }
    if (t.selectbox != null && t.hasOwnProperty("selectbox")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Selectbox.verify(t.selectbox);
        if (o)
          return "selectbox." + o;
      }
    }
    if (t.skeleton != null && t.hasOwnProperty("skeleton")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Skeleton.verify(t.skeleton);
        if (o)
          return "skeleton." + o;
      }
    }
    if (t.slider != null && t.hasOwnProperty("slider")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Slider.verify(t.slider);
        if (o)
          return "slider." + o;
      }
    }
    if (t.snow != null && t.hasOwnProperty("snow")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Snow.verify(t.snow);
        if (o)
          return "snow." + o;
      }
    }
    if (t.spinner != null && t.hasOwnProperty("spinner")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Spinner.verify(t.spinner);
        if (o)
          return "spinner." + o;
      }
    }
    if (t.text != null && t.hasOwnProperty("text")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Text.verify(t.text);
        if (o)
          return "text." + o;
      }
    }
    if (t.textArea != null && t.hasOwnProperty("textArea")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.TextArea.verify(t.textArea);
        if (o)
          return "textArea." + o;
      }
    }
    if (t.textInput != null && t.hasOwnProperty("textInput")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.TextInput.verify(t.textInput);
        if (o)
          return "textInput." + o;
      }
    }
    if (t.timeInput != null && t.hasOwnProperty("timeInput")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.TimeInput.verify(t.timeInput);
        if (o)
          return "timeInput." + o;
      }
    }
    if (t.toast != null && t.hasOwnProperty("toast")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Toast.verify(t.toast);
        if (o)
          return "toast." + o;
      }
    }
    if (t.vegaLiteChart != null && t.hasOwnProperty("vegaLiteChart")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.VegaLiteChart.verify(t.vegaLiteChart);
        if (o)
          return "vegaLiteChart." + o;
      }
    }
    if (t.video != null && t.hasOwnProperty("video")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Video.verify(t.video);
        if (o)
          return "video." + o;
      }
    }
    if (t.heading != null && t.hasOwnProperty("heading")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Heading.verify(t.heading);
        if (o)
          return "heading." + o;
      }
    }
    if (t.code != null && t.hasOwnProperty("code")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Code.verify(t.code);
        if (o)
          return "code." + o;
      }
    }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.Element)
      return t;
    let e = new $root.Element();
    if (t.heightConfig != null) {
      if (typeof t.heightConfig != "object")
        throw TypeError(".Element.heightConfig: object expected");
      e.heightConfig = $root.streamlit.HeightConfig.fromObject(t.heightConfig);
    }
    if (t.widthConfig != null) {
      if (typeof t.widthConfig != "object")
        throw TypeError(".Element.widthConfig: object expected");
      e.widthConfig = $root.streamlit.WidthConfig.fromObject(t.widthConfig);
    }
    if (t.alert != null) {
      if (typeof t.alert != "object")
        throw TypeError(".Element.alert: object expected");
      e.alert = $root.Alert.fromObject(t.alert);
    }
    if (t.arrowDataFrame != null) {
      if (typeof t.arrowDataFrame != "object")
        throw TypeError(".Element.arrowDataFrame: object expected");
      e.arrowDataFrame = $root.Arrow.fromObject(t.arrowDataFrame);
    }
    if (t.arrowTable != null) {
      if (typeof t.arrowTable != "object")
        throw TypeError(".Element.arrowTable: object expected");
      e.arrowTable = $root.Arrow.fromObject(t.arrowTable);
    }
    if (t.arrowVegaLiteChart != null) {
      if (typeof t.arrowVegaLiteChart != "object")
        throw TypeError(".Element.arrowVegaLiteChart: object expected");
      e.arrowVegaLiteChart = $root.ArrowVegaLiteChart.fromObject(t.arrowVegaLiteChart);
    }
    if (t.audio != null) {
      if (typeof t.audio != "object")
        throw TypeError(".Element.audio: object expected");
      e.audio = $root.Audio.fromObject(t.audio);
    }
    if (t.audioInput != null) {
      if (typeof t.audioInput != "object")
        throw TypeError(".Element.audioInput: object expected");
      e.audioInput = $root.AudioInput.fromObject(t.audioInput);
    }
    if (t.balloons != null) {
      if (typeof t.balloons != "object")
        throw TypeError(".Element.balloons: object expected");
      e.balloons = $root.Balloons.fromObject(t.balloons);
    }
    if (t.bokehChart != null) {
      if (typeof t.bokehChart != "object")
        throw TypeError(".Element.bokehChart: object expected");
      e.bokehChart = $root.BokehChart.fromObject(t.bokehChart);
    }
    if (t.button != null) {
      if (typeof t.button != "object")
        throw TypeError(".Element.button: object expected");
      e.button = $root.Button.fromObject(t.button);
    }
    if (t.buttonGroup != null) {
      if (typeof t.buttonGroup != "object")
        throw TypeError(".Element.buttonGroup: object expected");
      e.buttonGroup = $root.ButtonGroup.fromObject(t.buttonGroup);
    }
    if (t.downloadButton != null) {
      if (typeof t.downloadButton != "object")
        throw TypeError(".Element.downloadButton: object expected");
      e.downloadButton = $root.DownloadButton.fromObject(t.downloadButton);
    }
    if (t.cameraInput != null) {
      if (typeof t.cameraInput != "object")
        throw TypeError(".Element.cameraInput: object expected");
      e.cameraInput = $root.CameraInput.fromObject(t.cameraInput);
    }
    if (t.chatInput != null) {
      if (typeof t.chatInput != "object")
        throw TypeError(".Element.chatInput: object expected");
      e.chatInput = $root.ChatInput.fromObject(t.chatInput);
    }
    if (t.checkbox != null) {
      if (typeof t.checkbox != "object")
        throw TypeError(".Element.checkbox: object expected");
      e.checkbox = $root.Checkbox.fromObject(t.checkbox);
    }
    if (t.colorPicker != null) {
      if (typeof t.colorPicker != "object")
        throw TypeError(".Element.colorPicker: object expected");
      e.colorPicker = $root.ColorPicker.fromObject(t.colorPicker);
    }
    if (t.componentInstance != null) {
      if (typeof t.componentInstance != "object")
        throw TypeError(".Element.componentInstance: object expected");
      e.componentInstance = $root.ComponentInstance.fromObject(t.componentInstance);
    }
    if (t.dataFrame != null) {
      if (typeof t.dataFrame != "object")
        throw TypeError(".Element.dataFrame: object expected");
      e.dataFrame = $root.DataFrame.fromObject(t.dataFrame);
    }
    if (t.table != null) {
      if (typeof t.table != "object")
        throw TypeError(".Element.table: object expected");
      e.table = $root.DataFrame.fromObject(t.table);
    }
    if (t.dateInput != null) {
      if (typeof t.dateInput != "object")
        throw TypeError(".Element.dateInput: object expected");
      e.dateInput = $root.DateInput.fromObject(t.dateInput);
    }
    if (t.deckGlJsonChart != null) {
      if (typeof t.deckGlJsonChart != "object")
        throw TypeError(".Element.deckGlJsonChart: object expected");
      e.deckGlJsonChart = $root.DeckGlJsonChart.fromObject(t.deckGlJsonChart);
    }
    if (t.docString != null) {
      if (typeof t.docString != "object")
        throw TypeError(".Element.docString: object expected");
      e.docString = $root.DocString.fromObject(t.docString);
    }
    if (t.empty != null) {
      if (typeof t.empty != "object")
        throw TypeError(".Element.empty: object expected");
      e.empty = $root.Empty.fromObject(t.empty);
    }
    if (t.exception != null) {
      if (typeof t.exception != "object")
        throw TypeError(".Element.exception: object expected");
      e.exception = $root.Exception.fromObject(t.exception);
    }
    if (t.favicon != null) {
      if (typeof t.favicon != "object")
        throw TypeError(".Element.favicon: object expected");
      e.favicon = $root.Favicon.fromObject(t.favicon);
    }
    if (t.fileUploader != null) {
      if (typeof t.fileUploader != "object")
        throw TypeError(".Element.fileUploader: object expected");
      e.fileUploader = $root.FileUploader.fromObject(t.fileUploader);
    }
    if (t.graphvizChart != null) {
      if (typeof t.graphvizChart != "object")
        throw TypeError(".Element.graphvizChart: object expected");
      e.graphvizChart = $root.GraphVizChart.fromObject(t.graphvizChart);
    }
    if (t.html != null) {
      if (typeof t.html != "object")
        throw TypeError(".Element.html: object expected");
      e.html = $root.Html.fromObject(t.html);
    }
    if (t.iframe != null) {
      if (typeof t.iframe != "object")
        throw TypeError(".Element.iframe: object expected");
      e.iframe = $root.IFrame.fromObject(t.iframe);
    }
    if (t.imgs != null) {
      if (typeof t.imgs != "object")
        throw TypeError(".Element.imgs: object expected");
      e.imgs = $root.ImageList.fromObject(t.imgs);
    }
    if (t.json != null) {
      if (typeof t.json != "object")
        throw TypeError(".Element.json: object expected");
      e.json = $root.Json.fromObject(t.json);
    }
    if (t.linkButton != null) {
      if (typeof t.linkButton != "object")
        throw TypeError(".Element.linkButton: object expected");
      e.linkButton = $root.LinkButton.fromObject(t.linkButton);
    }
    if (t.markdown != null) {
      if (typeof t.markdown != "object")
        throw TypeError(".Element.markdown: object expected");
      e.markdown = $root.Markdown.fromObject(t.markdown);
    }
    if (t.metric != null) {
      if (typeof t.metric != "object")
        throw TypeError(".Element.metric: object expected");
      e.metric = $root.Metric.fromObject(t.metric);
    }
    if (t.multiselect != null) {
      if (typeof t.multiselect != "object")
        throw TypeError(".Element.multiselect: object expected");
      e.multiselect = $root.MultiSelect.fromObject(t.multiselect);
    }
    if (t.numberInput != null) {
      if (typeof t.numberInput != "object")
        throw TypeError(".Element.numberInput: object expected");
      e.numberInput = $root.NumberInput.fromObject(t.numberInput);
    }
    if (t.pageLink != null) {
      if (typeof t.pageLink != "object")
        throw TypeError(".Element.pageLink: object expected");
      e.pageLink = $root.PageLink.fromObject(t.pageLink);
    }
    if (t.plotlyChart != null) {
      if (typeof t.plotlyChart != "object")
        throw TypeError(".Element.plotlyChart: object expected");
      e.plotlyChart = $root.PlotlyChart.fromObject(t.plotlyChart);
    }
    if (t.progress != null) {
      if (typeof t.progress != "object")
        throw TypeError(".Element.progress: object expected");
      e.progress = $root.Progress.fromObject(t.progress);
    }
    if (t.radio != null) {
      if (typeof t.radio != "object")
        throw TypeError(".Element.radio: object expected");
      e.radio = $root.Radio.fromObject(t.radio);
    }
    if (t.selectbox != null) {
      if (typeof t.selectbox != "object")
        throw TypeError(".Element.selectbox: object expected");
      e.selectbox = $root.Selectbox.fromObject(t.selectbox);
    }
    if (t.skeleton != null) {
      if (typeof t.skeleton != "object")
        throw TypeError(".Element.skeleton: object expected");
      e.skeleton = $root.Skeleton.fromObject(t.skeleton);
    }
    if (t.slider != null) {
      if (typeof t.slider != "object")
        throw TypeError(".Element.slider: object expected");
      e.slider = $root.Slider.fromObject(t.slider);
    }
    if (t.snow != null) {
      if (typeof t.snow != "object")
        throw TypeError(".Element.snow: object expected");
      e.snow = $root.Snow.fromObject(t.snow);
    }
    if (t.spinner != null) {
      if (typeof t.spinner != "object")
        throw TypeError(".Element.spinner: object expected");
      e.spinner = $root.Spinner.fromObject(t.spinner);
    }
    if (t.text != null) {
      if (typeof t.text != "object")
        throw TypeError(".Element.text: object expected");
      e.text = $root.Text.fromObject(t.text);
    }
    if (t.textArea != null) {
      if (typeof t.textArea != "object")
        throw TypeError(".Element.textArea: object expected");
      e.textArea = $root.TextArea.fromObject(t.textArea);
    }
    if (t.textInput != null) {
      if (typeof t.textInput != "object")
        throw TypeError(".Element.textInput: object expected");
      e.textInput = $root.TextInput.fromObject(t.textInput);
    }
    if (t.timeInput != null) {
      if (typeof t.timeInput != "object")
        throw TypeError(".Element.timeInput: object expected");
      e.timeInput = $root.TimeInput.fromObject(t.timeInput);
    }
    if (t.toast != null) {
      if (typeof t.toast != "object")
        throw TypeError(".Element.toast: object expected");
      e.toast = $root.Toast.fromObject(t.toast);
    }
    if (t.vegaLiteChart != null) {
      if (typeof t.vegaLiteChart != "object")
        throw TypeError(".Element.vegaLiteChart: object expected");
      e.vegaLiteChart = $root.VegaLiteChart.fromObject(t.vegaLiteChart);
    }
    if (t.video != null) {
      if (typeof t.video != "object")
        throw TypeError(".Element.video: object expected");
      e.video = $root.Video.fromObject(t.video);
    }
    if (t.heading != null) {
      if (typeof t.heading != "object")
        throw TypeError(".Element.heading: object expected");
      e.heading = $root.Heading.fromObject(t.heading);
    }
    if (t.code != null) {
      if (typeof t.code != "object")
        throw TypeError(".Element.code: object expected");
      e.code = $root.Code.fromObject(t.code);
    }
    return e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return t.text != null && t.hasOwnProperty("text") && (o.text = $root.Text.toObject(t.text, e), e.oneofs && (o.type = "text")), t.empty != null && t.hasOwnProperty("empty") && (o.empty = $root.Empty.toObject(t.empty, e), e.oneofs && (o.type = "empty")), t.dataFrame != null && t.hasOwnProperty("dataFrame") && (o.dataFrame = $root.DataFrame.toObject(t.dataFrame, e), e.oneofs && (o.type = "dataFrame")), t.progress != null && t.hasOwnProperty("progress") && (o.progress = $root.Progress.toObject(t.progress, e), e.oneofs && (o.type = "progress")), t.imgs != null && t.hasOwnProperty("imgs") && (o.imgs = $root.ImageList.toObject(t.imgs, e), e.oneofs && (o.type = "imgs")), t.docString != null && t.hasOwnProperty("docString") && (o.docString = $root.DocString.toObject(t.docString, e), e.oneofs && (o.type = "docString")), t.exception != null && t.hasOwnProperty("exception") && (o.exception = $root.Exception.toObject(t.exception, e), e.oneofs && (o.type = "exception")), t.vegaLiteChart != null && t.hasOwnProperty("vegaLiteChart") && (o.vegaLiteChart = $root.VegaLiteChart.toObject(t.vegaLiteChart, e), e.oneofs && (o.type = "vegaLiteChart")), t.table != null && t.hasOwnProperty("table") && (o.table = $root.DataFrame.toObject(t.table, e), e.oneofs && (o.type = "table")), t.balloons != null && t.hasOwnProperty("balloons") && (o.balloons = $root.Balloons.toObject(t.balloons, e), e.oneofs && (o.type = "balloons")), t.audio != null && t.hasOwnProperty("audio") && (o.audio = $root.Audio.toObject(t.audio, e), e.oneofs && (o.type = "audio")), t.video != null && t.hasOwnProperty("video") && (o.video = $root.Video.toObject(t.video, e), e.oneofs && (o.type = "video")), t.plotlyChart != null && t.hasOwnProperty("plotlyChart") && (o.plotlyChart = $root.PlotlyChart.toObject(t.plotlyChart, e), e.oneofs && (o.type = "plotlyChart")), t.bokehChart != null && t.hasOwnProperty("bokehChart") && (o.bokehChart = $root.BokehChart.toObject(t.bokehChart, e), e.oneofs && (o.type = "bokehChart")), t.graphvizChart != null && t.hasOwnProperty("graphvizChart") && (o.graphvizChart = $root.GraphVizChart.toObject(t.graphvizChart, e), e.oneofs && (o.type = "graphvizChart")), t.button != null && t.hasOwnProperty("button") && (o.button = $root.Button.toObject(t.button, e), e.oneofs && (o.type = "button")), t.checkbox != null && t.hasOwnProperty("checkbox") && (o.checkbox = $root.Checkbox.toObject(t.checkbox, e), e.oneofs && (o.type = "checkbox")), t.slider != null && t.hasOwnProperty("slider") && (o.slider = $root.Slider.toObject(t.slider, e), e.oneofs && (o.type = "slider")), t.textArea != null && t.hasOwnProperty("textArea") && (o.textArea = $root.TextArea.toObject(t.textArea, e), e.oneofs && (o.type = "textArea")), t.radio != null && t.hasOwnProperty("radio") && (o.radio = $root.Radio.toObject(t.radio, e), e.oneofs && (o.type = "radio")), t.textInput != null && t.hasOwnProperty("textInput") && (o.textInput = $root.TextInput.toObject(t.textInput, e), e.oneofs && (o.type = "textInput")), t.selectbox != null && t.hasOwnProperty("selectbox") && (o.selectbox = $root.Selectbox.toObject(t.selectbox, e), e.oneofs && (o.type = "selectbox")), t.timeInput != null && t.hasOwnProperty("timeInput") && (o.timeInput = $root.TimeInput.toObject(t.timeInput, e), e.oneofs && (o.type = "timeInput")), t.dateInput != null && t.hasOwnProperty("dateInput") && (o.dateInput = $root.DateInput.toObject(t.dateInput, e), e.oneofs && (o.type = "dateInput")), t.multiselect != null && t.hasOwnProperty("multiselect") && (o.multiselect = $root.MultiSelect.toObject(t.multiselect, e), e.oneofs && (o.type = "multiselect")), t.markdown != null && t.hasOwnProperty("markdown") && (o.markdown = $root.Markdown.toObject(t.markdown, e), e.oneofs && (o.type = "markdown")), t.alert != null && t.hasOwnProperty("alert") && (o.alert = $root.Alert.toObject(t.alert, e), e.oneofs && (o.type = "alert")), t.json != null && t.hasOwnProperty("json") && (o.json = $root.Json.toObject(t.json, e), e.oneofs && (o.type = "json")), t.numberInput != null && t.hasOwnProperty("numberInput") && (o.numberInput = $root.NumberInput.toObject(t.numberInput, e), e.oneofs && (o.type = "numberInput")), t.fileUploader != null && t.hasOwnProperty("fileUploader") && (o.fileUploader = $root.FileUploader.toObject(t.fileUploader, e), e.oneofs && (o.type = "fileUploader")), t.deckGlJsonChart != null && t.hasOwnProperty("deckGlJsonChart") && (o.deckGlJsonChart = $root.DeckGlJsonChart.toObject(t.deckGlJsonChart, e), e.oneofs && (o.type = "deckGlJsonChart")), t.colorPicker != null && t.hasOwnProperty("colorPicker") && (o.colorPicker = $root.ColorPicker.toObject(t.colorPicker, e), e.oneofs && (o.type = "colorPicker")), t.favicon != null && t.hasOwnProperty("favicon") && (o.favicon = $root.Favicon.toObject(t.favicon, e), e.oneofs && (o.type = "favicon")), t.componentInstance != null && t.hasOwnProperty("componentInstance") && (o.componentInstance = $root.ComponentInstance.toObject(t.componentInstance, e), e.oneofs && (o.type = "componentInstance")), t.iframe != null && t.hasOwnProperty("iframe") && (o.iframe = $root.IFrame.toObject(t.iframe, e), e.oneofs && (o.type = "iframe")), t.arrowTable != null && t.hasOwnProperty("arrowTable") && (o.arrowTable = $root.Arrow.toObject(t.arrowTable, e), e.oneofs && (o.type = "arrowTable")), t.arrowDataFrame != null && t.hasOwnProperty("arrowDataFrame") && (o.arrowDataFrame = $root.Arrow.toObject(t.arrowDataFrame, e), e.oneofs && (o.type = "arrowDataFrame")), t.arrowVegaLiteChart != null && t.hasOwnProperty("arrowVegaLiteChart") && (o.arrowVegaLiteChart = $root.ArrowVegaLiteChart.toObject(t.arrowVegaLiteChart, e), e.oneofs && (o.type = "arrowVegaLiteChart")), t.metric != null && t.hasOwnProperty("metric") && (o.metric = $root.Metric.toObject(t.metric, e), e.oneofs && (o.type = "metric")), t.downloadButton != null && t.hasOwnProperty("downloadButton") && (o.downloadButton = $root.DownloadButton.toObject(t.downloadButton, e), e.oneofs && (o.type = "downloadButton")), t.spinner != null && t.hasOwnProperty("spinner") && (o.spinner = $root.Spinner.toObject(t.spinner, e), e.oneofs && (o.type = "spinner")), t.cameraInput != null && t.hasOwnProperty("cameraInput") && (o.cameraInput = $root.CameraInput.toObject(t.cameraInput, e), e.oneofs && (o.type = "cameraInput")), t.snow != null && t.hasOwnProperty("snow") && (o.snow = $root.Snow.toObject(t.snow, e), e.oneofs && (o.type = "snow")), t.heading != null && t.hasOwnProperty("heading") && (o.heading = $root.Heading.toObject(t.heading, e), e.oneofs && (o.type = "heading")), t.code != null && t.hasOwnProperty("code") && (o.code = $root.Code.toObject(t.code, e), e.oneofs && (o.type = "code")), t.chatInput != null && t.hasOwnProperty("chatInput") && (o.chatInput = $root.ChatInput.toObject(t.chatInput, e), e.oneofs && (o.type = "chatInput")), t.toast != null && t.hasOwnProperty("toast") && (o.toast = $root.Toast.toObject(t.toast, e), e.oneofs && (o.type = "toast")), t.linkButton != null && t.hasOwnProperty("linkButton") && (o.linkButton = $root.LinkButton.toObject(t.linkButton, e), e.oneofs && (o.type = "linkButton")), t.skeleton != null && t.hasOwnProperty("skeleton") && (o.skeleton = $root.Skeleton.toObject(t.skeleton, e), e.oneofs && (o.type = "skeleton")), t.pageLink != null && t.hasOwnProperty("pageLink") && (o.pageLink = $root.PageLink.toObject(t.pageLink, e), e.oneofs && (o.type = "pageLink")), t.html != null && t.hasOwnProperty("html") && (o.html = $root.Html.toObject(t.html, e), e.oneofs && (o.type = "html")), t.buttonGroup != null && t.hasOwnProperty("buttonGroup") && (o.buttonGroup = $root.ButtonGroup.toObject(t.buttonGroup, e), e.oneofs && (o.type = "buttonGroup")), t.audioInput != null && t.hasOwnProperty("audioInput") && (o.audioInput = $root.AudioInput.toObject(t.audioInput, e), e.oneofs && (o.type = "audioInput")), t.heightConfig != null && t.hasOwnProperty("heightConfig") && (o.heightConfig = $root.streamlit.HeightConfig.toObject(t.heightConfig, e), e.oneofs && (o._heightConfig = "heightConfig")), t.widthConfig != null && t.hasOwnProperty("widthConfig") && (o.widthConfig = $root.streamlit.WidthConfig.toObject(t.widthConfig, e), e.oneofs && (o._widthConfig = "widthConfig")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Element";
  }, r;
})();
$root.DownloadButton = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.id = "", r.prototype.label = "", r.prototype.default = !1, r.prototype.help = "", r.prototype.formId = "", r.prototype.url = "", r.prototype.disabled = !1, r.prototype.useContainerWidth = !1, r.prototype.type = "", r.prototype.icon = "", r.prototype.ignoreRerun = !1, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.id != null && Object.hasOwnProperty.call(n, "id") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.id), n.label != null && Object.hasOwnProperty.call(n, "label") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.label), n.default != null && Object.hasOwnProperty.call(n, "default") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(n.default), n.help != null && Object.hasOwnProperty.call(n, "help") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.help), n.formId != null && Object.hasOwnProperty.call(n, "formId") && t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(n.formId), n.url != null && Object.hasOwnProperty.call(n, "url") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.url), n.disabled != null && Object.hasOwnProperty.call(n, "disabled") && t.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(n.disabled), n.useContainerWidth != null && Object.hasOwnProperty.call(n, "useContainerWidth") && t.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(n.useContainerWidth), n.type != null && Object.hasOwnProperty.call(n, "type") && t.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(n.type), n.icon != null && Object.hasOwnProperty.call(n, "icon") && t.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(n.icon), n.ignoreRerun != null && Object.hasOwnProperty.call(n, "ignoreRerun") && t.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(n.ignoreRerun), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.DownloadButton();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.id = n.string();
          break;
        }
        case 2: {
          p.label = n.string();
          break;
        }
        case 3: {
          p.default = n.bool();
          break;
        }
        case 4: {
          p.help = n.string();
          break;
        }
        case 5: {
          p.formId = n.string();
          break;
        }
        case 6: {
          p.url = n.string();
          break;
        }
        case 7: {
          p.disabled = n.bool();
          break;
        }
        case 8: {
          p.useContainerWidth = n.bool();
          break;
        }
        case 9: {
          p.type = n.string();
          break;
        }
        case 10: {
          p.icon = n.string();
          break;
        }
        case 11: {
          p.ignoreRerun = n.bool();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.id != null && n.hasOwnProperty("id") && !$util.isString(n.id) ? "id: string expected" : n.label != null && n.hasOwnProperty("label") && !$util.isString(n.label) ? "label: string expected" : n.default != null && n.hasOwnProperty("default") && typeof n.default != "boolean" ? "default: boolean expected" : n.help != null && n.hasOwnProperty("help") && !$util.isString(n.help) ? "help: string expected" : n.formId != null && n.hasOwnProperty("formId") && !$util.isString(n.formId) ? "formId: string expected" : n.url != null && n.hasOwnProperty("url") && !$util.isString(n.url) ? "url: string expected" : n.disabled != null && n.hasOwnProperty("disabled") && typeof n.disabled != "boolean" ? "disabled: boolean expected" : n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && typeof n.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : n.type != null && n.hasOwnProperty("type") && !$util.isString(n.type) ? "type: string expected" : n.icon != null && n.hasOwnProperty("icon") && !$util.isString(n.icon) ? "icon: string expected" : n.ignoreRerun != null && n.hasOwnProperty("ignoreRerun") && typeof n.ignoreRerun != "boolean" ? "ignoreRerun: boolean expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.DownloadButton)
      return n;
    let t = new $root.DownloadButton();
    return n.id != null && (t.id = String(n.id)), n.label != null && (t.label = String(n.label)), n.default != null && (t.default = !!n.default), n.help != null && (t.help = String(n.help)), n.formId != null && (t.formId = String(n.formId)), n.url != null && (t.url = String(n.url)), n.disabled != null && (t.disabled = !!n.disabled), n.useContainerWidth != null && (t.useContainerWidth = !!n.useContainerWidth), n.type != null && (t.type = String(n.type)), n.icon != null && (t.icon = String(n.icon)), n.ignoreRerun != null && (t.ignoreRerun = !!n.ignoreRerun), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.id = "", e.label = "", e.default = !1, e.help = "", e.formId = "", e.url = "", e.disabled = !1, e.useContainerWidth = !1, e.type = "", e.icon = "", e.ignoreRerun = !1), n.id != null && n.hasOwnProperty("id") && (e.id = n.id), n.label != null && n.hasOwnProperty("label") && (e.label = n.label), n.default != null && n.hasOwnProperty("default") && (e.default = n.default), n.help != null && n.hasOwnProperty("help") && (e.help = n.help), n.formId != null && n.hasOwnProperty("formId") && (e.formId = n.formId), n.url != null && n.hasOwnProperty("url") && (e.url = n.url), n.disabled != null && n.hasOwnProperty("disabled") && (e.disabled = n.disabled), n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = n.useContainerWidth), n.type != null && n.hasOwnProperty("type") && (e.type = n.type), n.icon != null && n.hasOwnProperty("icon") && (e.icon = n.icon), n.ignoreRerun != null && n.hasOwnProperty("ignoreRerun") && (e.ignoreRerun = n.ignoreRerun), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/DownloadButton";
  }, r;
})();
$root.DocString = (() => {
  function r(c) {
    if (this.members = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.docString = "", r.prototype.type = "", r.prototype.name = "", r.prototype.value = "", r.prototype.members = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.docString != null && Object.hasOwnProperty.call(n, "docString") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.docString), n.type != null && Object.hasOwnProperty.call(n, "type") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.type), n.name != null && Object.hasOwnProperty.call(n, "name") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.name), n.value != null && Object.hasOwnProperty.call(n, "value") && t.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(n.value), n.members != null && n.members.length)
      for (let e = 0; e < n.members.length; ++e)
        $root.Member.encode(n.members[e], t.uint32(
          /* id 8, wireType 2 =*/
          66
        ).fork()).ldelim();
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.DocString();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 3: {
          p.docString = n.string();
          break;
        }
        case 4: {
          p.type = n.string();
          break;
        }
        case 6: {
          p.name = n.string();
          break;
        }
        case 7: {
          p.value = n.string();
          break;
        }
        case 8: {
          p.members && p.members.length || (p.members = []), p.members.push($root.Member.decode(n, n.uint32()));
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.docString != null && n.hasOwnProperty("docString") && !$util.isString(n.docString))
      return "docString: string expected";
    if (n.type != null && n.hasOwnProperty("type") && !$util.isString(n.type))
      return "type: string expected";
    if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
      return "name: string expected";
    if (n.value != null && n.hasOwnProperty("value") && !$util.isString(n.value))
      return "value: string expected";
    if (n.members != null && n.hasOwnProperty("members")) {
      if (!Array.isArray(n.members))
        return "members: array expected";
      for (let t = 0; t < n.members.length; ++t) {
        let e = $root.Member.verify(n.members[t]);
        if (e)
          return "members." + e;
      }
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.DocString)
      return n;
    let t = new $root.DocString();
    if (n.docString != null && (t.docString = String(n.docString)), n.type != null && (t.type = String(n.type)), n.name != null && (t.name = String(n.name)), n.value != null && (t.value = String(n.value)), n.members) {
      if (!Array.isArray(n.members))
        throw TypeError(".DocString.members: array expected");
      t.members = [];
      for (let e = 0; e < n.members.length; ++e) {
        if (typeof n.members[e] != "object")
          throw TypeError(".DocString.members: object expected");
        t.members[e] = $root.Member.fromObject(n.members[e]);
      }
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.members = []), t.defaults && (e.docString = "", e.type = "", e.name = "", e.value = ""), n.docString != null && n.hasOwnProperty("docString") && (e.docString = n.docString), n.type != null && n.hasOwnProperty("type") && (e.type = n.type), n.name != null && n.hasOwnProperty("name") && (e.name = n.name), n.value != null && n.hasOwnProperty("value") && (e.value = n.value), n.members && n.members.length) {
      e.members = [];
      for (let o = 0; o < n.members.length; ++o)
        e.members[o] = $root.Member.toObject(n.members[o], t);
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/DocString";
  }, r;
})();
$root.Member = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.name = "", r.prototype.type = "", r.prototype.value = null, r.prototype.docString = null;
  let c;
  return Object.defineProperty(r.prototype, "contents", {
    get: $util.oneOfGetter(c = ["value", "docString"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.name != null && Object.hasOwnProperty.call(t, "name") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.name), t.type != null && Object.hasOwnProperty.call(t, "type") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.type), t.value != null && Object.hasOwnProperty.call(t, "value") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.value), t.docString != null && Object.hasOwnProperty.call(t, "docString") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.docString), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.Member();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.name = t.string();
          break;
        }
        case 2: {
          h.type = t.string();
          break;
        }
        case 3: {
          h.value = t.string();
          break;
        }
        case 4: {
          h.docString = t.string();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    let e = {};
    if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name))
      return "name: string expected";
    if (t.type != null && t.hasOwnProperty("type") && !$util.isString(t.type))
      return "type: string expected";
    if (t.value != null && t.hasOwnProperty("value") && (e.contents = 1, !$util.isString(t.value)))
      return "value: string expected";
    if (t.docString != null && t.hasOwnProperty("docString")) {
      if (e.contents === 1)
        return "contents: multiple values";
      if (e.contents = 1, !$util.isString(t.docString))
        return "docString: string expected";
    }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.Member)
      return t;
    let e = new $root.Member();
    return t.name != null && (e.name = String(t.name)), t.type != null && (e.type = String(t.type)), t.value != null && (e.value = String(t.value)), t.docString != null && (e.docString = String(t.docString)), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.name = "", o.type = ""), t.name != null && t.hasOwnProperty("name") && (o.name = t.name), t.type != null && t.hasOwnProperty("type") && (o.type = t.type), t.value != null && t.hasOwnProperty("value") && (o.value = t.value, e.oneofs && (o.contents = "value")), t.docString != null && t.hasOwnProperty("docString") && (o.docString = t.docString, e.oneofs && (o.contents = "docString")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Member";
  }, r;
})();
$root.Empty = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Empty();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : null;
  }, r.fromObject = function(n) {
    return n instanceof $root.Empty ? n : new $root.Empty();
  }, r.toObject = function() {
    return {};
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Empty";
  }, r;
})();
$root.Exception = (() => {
  function r(c) {
    if (this.stackTrace = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.type = "", r.prototype.message = "", r.prototype.messageIsMarkdown = !1, r.prototype.stackTrace = $util.emptyArray, r.prototype.isWarning = !1, r.prototype.widthConfig = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.type != null && Object.hasOwnProperty.call(n, "type") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.type), n.message != null && Object.hasOwnProperty.call(n, "message") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.message), n.stackTrace != null && n.stackTrace.length)
      for (let e = 0; e < n.stackTrace.length; ++e)
        t.uint32(
          /* id 3, wireType 2 =*/
          26
        ).string(n.stackTrace[e]);
    return n.messageIsMarkdown != null && Object.hasOwnProperty.call(n, "messageIsMarkdown") && t.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(n.messageIsMarkdown), n.isWarning != null && Object.hasOwnProperty.call(n, "isWarning") && t.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(n.isWarning), n.widthConfig != null && Object.hasOwnProperty.call(n, "widthConfig") && $root.streamlit.WidthConfig.encode(n.widthConfig, t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Exception();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.type = n.string();
          break;
        }
        case 2: {
          p.message = n.string();
          break;
        }
        case 4: {
          p.messageIsMarkdown = n.bool();
          break;
        }
        case 3: {
          p.stackTrace && p.stackTrace.length || (p.stackTrace = []), p.stackTrace.push(n.string());
          break;
        }
        case 5: {
          p.isWarning = n.bool();
          break;
        }
        case 6: {
          p.widthConfig = $root.streamlit.WidthConfig.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.type != null && n.hasOwnProperty("type") && !$util.isString(n.type))
      return "type: string expected";
    if (n.message != null && n.hasOwnProperty("message") && !$util.isString(n.message))
      return "message: string expected";
    if (n.messageIsMarkdown != null && n.hasOwnProperty("messageIsMarkdown") && typeof n.messageIsMarkdown != "boolean")
      return "messageIsMarkdown: boolean expected";
    if (n.stackTrace != null && n.hasOwnProperty("stackTrace")) {
      if (!Array.isArray(n.stackTrace))
        return "stackTrace: array expected";
      for (let t = 0; t < n.stackTrace.length; ++t)
        if (!$util.isString(n.stackTrace[t]))
          return "stackTrace: string[] expected";
    }
    if (n.isWarning != null && n.hasOwnProperty("isWarning") && typeof n.isWarning != "boolean")
      return "isWarning: boolean expected";
    if (n.widthConfig != null && n.hasOwnProperty("widthConfig")) {
      let t = $root.streamlit.WidthConfig.verify(n.widthConfig);
      if (t)
        return "widthConfig." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Exception)
      return n;
    let t = new $root.Exception();
    if (n.type != null && (t.type = String(n.type)), n.message != null && (t.message = String(n.message)), n.messageIsMarkdown != null && (t.messageIsMarkdown = !!n.messageIsMarkdown), n.stackTrace) {
      if (!Array.isArray(n.stackTrace))
        throw TypeError(".Exception.stackTrace: array expected");
      t.stackTrace = [];
      for (let e = 0; e < n.stackTrace.length; ++e)
        t.stackTrace[e] = String(n.stackTrace[e]);
    }
    if (n.isWarning != null && (t.isWarning = !!n.isWarning), n.widthConfig != null) {
      if (typeof n.widthConfig != "object")
        throw TypeError(".Exception.widthConfig: object expected");
      t.widthConfig = $root.streamlit.WidthConfig.fromObject(n.widthConfig);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.stackTrace = []), t.defaults && (e.type = "", e.message = "", e.messageIsMarkdown = !1, e.isWarning = !1, e.widthConfig = null), n.type != null && n.hasOwnProperty("type") && (e.type = n.type), n.message != null && n.hasOwnProperty("message") && (e.message = n.message), n.stackTrace && n.stackTrace.length) {
      e.stackTrace = [];
      for (let o = 0; o < n.stackTrace.length; ++o)
        e.stackTrace[o] = n.stackTrace[o];
    }
    return n.messageIsMarkdown != null && n.hasOwnProperty("messageIsMarkdown") && (e.messageIsMarkdown = n.messageIsMarkdown), n.isWarning != null && n.hasOwnProperty("isWarning") && (e.isWarning = n.isWarning), n.widthConfig != null && n.hasOwnProperty("widthConfig") && (e.widthConfig = $root.streamlit.WidthConfig.toObject(n.widthConfig, t)), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Exception";
  }, r;
})();
$root.Favicon = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.url = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.url != null && Object.hasOwnProperty.call(n, "url") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.url), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Favicon();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.url = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.url != null && n.hasOwnProperty("url") && !$util.isString(n.url) ? "url: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Favicon)
      return n;
    let t = new $root.Favicon();
    return n.url != null && (t.url = String(n.url)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.url = ""), n.url != null && n.hasOwnProperty("url") && (e.url = n.url), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Favicon";
  }, r;
})();
$root.FileUploader = (() => {
  function r(c) {
    if (this.type = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.id = "", r.prototype.label = "", r.prototype.type = $util.emptyArray, r.prototype.maxUploadSizeMb = 0, r.prototype.multipleFiles = !1, r.prototype.help = "", r.prototype.formId = "", r.prototype.disabled = !1, r.prototype.labelVisibility = null, r.prototype.acceptDirectory = !1, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.id != null && Object.hasOwnProperty.call(n, "id") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.id), n.label != null && Object.hasOwnProperty.call(n, "label") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.label), n.type != null && n.type.length)
      for (let e = 0; e < n.type.length; ++e)
        t.uint32(
          /* id 3, wireType 2 =*/
          26
        ).string(n.type[e]);
    return n.maxUploadSizeMb != null && Object.hasOwnProperty.call(n, "maxUploadSizeMb") && t.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(n.maxUploadSizeMb), n.multipleFiles != null && Object.hasOwnProperty.call(n, "multipleFiles") && t.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(n.multipleFiles), n.help != null && Object.hasOwnProperty.call(n, "help") && t.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(n.help), n.formId != null && Object.hasOwnProperty.call(n, "formId") && t.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(n.formId), n.disabled != null && Object.hasOwnProperty.call(n, "disabled") && t.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(n.disabled), n.labelVisibility != null && Object.hasOwnProperty.call(n, "labelVisibility") && $root.LabelVisibilityMessage.encode(n.labelVisibility, t.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), n.acceptDirectory != null && Object.hasOwnProperty.call(n, "acceptDirectory") && t.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(n.acceptDirectory), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.FileUploader();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.id = n.string();
          break;
        }
        case 2: {
          p.label = n.string();
          break;
        }
        case 3: {
          p.type && p.type.length || (p.type = []), p.type.push(n.string());
          break;
        }
        case 4: {
          p.maxUploadSizeMb = n.int32();
          break;
        }
        case 6: {
          p.multipleFiles = n.bool();
          break;
        }
        case 7: {
          p.help = n.string();
          break;
        }
        case 8: {
          p.formId = n.string();
          break;
        }
        case 9: {
          p.disabled = n.bool();
          break;
        }
        case 10: {
          p.labelVisibility = $root.LabelVisibilityMessage.decode(n, n.uint32());
          break;
        }
        case 11: {
          p.acceptDirectory = n.bool();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.id != null && n.hasOwnProperty("id") && !$util.isString(n.id))
      return "id: string expected";
    if (n.label != null && n.hasOwnProperty("label") && !$util.isString(n.label))
      return "label: string expected";
    if (n.type != null && n.hasOwnProperty("type")) {
      if (!Array.isArray(n.type))
        return "type: array expected";
      for (let t = 0; t < n.type.length; ++t)
        if (!$util.isString(n.type[t]))
          return "type: string[] expected";
    }
    if (n.maxUploadSizeMb != null && n.hasOwnProperty("maxUploadSizeMb") && !$util.isInteger(n.maxUploadSizeMb))
      return "maxUploadSizeMb: integer expected";
    if (n.multipleFiles != null && n.hasOwnProperty("multipleFiles") && typeof n.multipleFiles != "boolean")
      return "multipleFiles: boolean expected";
    if (n.help != null && n.hasOwnProperty("help") && !$util.isString(n.help))
      return "help: string expected";
    if (n.formId != null && n.hasOwnProperty("formId") && !$util.isString(n.formId))
      return "formId: string expected";
    if (n.disabled != null && n.hasOwnProperty("disabled") && typeof n.disabled != "boolean")
      return "disabled: boolean expected";
    if (n.labelVisibility != null && n.hasOwnProperty("labelVisibility")) {
      let t = $root.LabelVisibilityMessage.verify(n.labelVisibility);
      if (t)
        return "labelVisibility." + t;
    }
    return n.acceptDirectory != null && n.hasOwnProperty("acceptDirectory") && typeof n.acceptDirectory != "boolean" ? "acceptDirectory: boolean expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.FileUploader)
      return n;
    let t = new $root.FileUploader();
    if (n.id != null && (t.id = String(n.id)), n.label != null && (t.label = String(n.label)), n.type) {
      if (!Array.isArray(n.type))
        throw TypeError(".FileUploader.type: array expected");
      t.type = [];
      for (let e = 0; e < n.type.length; ++e)
        t.type[e] = String(n.type[e]);
    }
    if (n.maxUploadSizeMb != null && (t.maxUploadSizeMb = n.maxUploadSizeMb | 0), n.multipleFiles != null && (t.multipleFiles = !!n.multipleFiles), n.help != null && (t.help = String(n.help)), n.formId != null && (t.formId = String(n.formId)), n.disabled != null && (t.disabled = !!n.disabled), n.labelVisibility != null) {
      if (typeof n.labelVisibility != "object")
        throw TypeError(".FileUploader.labelVisibility: object expected");
      t.labelVisibility = $root.LabelVisibilityMessage.fromObject(n.labelVisibility);
    }
    return n.acceptDirectory != null && (t.acceptDirectory = !!n.acceptDirectory), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.type = []), t.defaults && (e.id = "", e.label = "", e.maxUploadSizeMb = 0, e.multipleFiles = !1, e.help = "", e.formId = "", e.disabled = !1, e.labelVisibility = null, e.acceptDirectory = !1), n.id != null && n.hasOwnProperty("id") && (e.id = n.id), n.label != null && n.hasOwnProperty("label") && (e.label = n.label), n.type && n.type.length) {
      e.type = [];
      for (let o = 0; o < n.type.length; ++o)
        e.type[o] = n.type[o];
    }
    return n.maxUploadSizeMb != null && n.hasOwnProperty("maxUploadSizeMb") && (e.maxUploadSizeMb = n.maxUploadSizeMb), n.multipleFiles != null && n.hasOwnProperty("multipleFiles") && (e.multipleFiles = n.multipleFiles), n.help != null && n.hasOwnProperty("help") && (e.help = n.help), n.formId != null && n.hasOwnProperty("formId") && (e.formId = n.formId), n.disabled != null && n.hasOwnProperty("disabled") && (e.disabled = n.disabled), n.labelVisibility != null && n.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(n.labelVisibility, t)), n.acceptDirectory != null && n.hasOwnProperty("acceptDirectory") && (e.acceptDirectory = n.acceptDirectory), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/FileUploader";
  }, r;
})();
$root.GraphVizChart = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.spec = "", r.prototype.useContainerWidth = !1, r.prototype.elementId = "", r.prototype.engine = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.spec != null && Object.hasOwnProperty.call(n, "spec") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.spec), n.useContainerWidth != null && Object.hasOwnProperty.call(n, "useContainerWidth") && t.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(n.useContainerWidth), n.elementId != null && Object.hasOwnProperty.call(n, "elementId") && t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(n.elementId), n.engine != null && Object.hasOwnProperty.call(n, "engine") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.engine), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.GraphVizChart();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.spec = n.string();
          break;
        }
        case 4: {
          p.useContainerWidth = n.bool();
          break;
        }
        case 5: {
          p.elementId = n.string();
          break;
        }
        case 6: {
          p.engine = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.spec != null && n.hasOwnProperty("spec") && !$util.isString(n.spec) ? "spec: string expected" : n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && typeof n.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : n.elementId != null && n.hasOwnProperty("elementId") && !$util.isString(n.elementId) ? "elementId: string expected" : n.engine != null && n.hasOwnProperty("engine") && !$util.isString(n.engine) ? "engine: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.GraphVizChart)
      return n;
    let t = new $root.GraphVizChart();
    return n.spec != null && (t.spec = String(n.spec)), n.useContainerWidth != null && (t.useContainerWidth = !!n.useContainerWidth), n.elementId != null && (t.elementId = String(n.elementId)), n.engine != null && (t.engine = String(n.engine)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.spec = "", e.useContainerWidth = !1, e.elementId = "", e.engine = ""), n.spec != null && n.hasOwnProperty("spec") && (e.spec = n.spec), n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = n.useContainerWidth), n.elementId != null && n.hasOwnProperty("elementId") && (e.elementId = n.elementId), n.engine != null && n.hasOwnProperty("engine") && (e.engine = n.engine), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/GraphVizChart";
  }, r;
})();
$root.Html = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.body = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.body != null && Object.hasOwnProperty.call(n, "body") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.body), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Html();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.body = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.body != null && n.hasOwnProperty("body") && !$util.isString(n.body) ? "body: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Html)
      return n;
    let t = new $root.Html();
    return n.body != null && (t.body = String(n.body)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.body = ""), n.body != null && n.hasOwnProperty("body") && (e.body = n.body), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Html";
  }, r;
})();
$root.IFrame = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.src = null, r.prototype.srcdoc = null, r.prototype.width = 0, r.prototype.hasWidth = !1, r.prototype.height = 0, r.prototype.scrolling = !1, r.prototype.tabIndex = null;
  let c;
  return Object.defineProperty(r.prototype, "type", {
    get: $util.oneOfGetter(c = ["src", "srcdoc"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_tabIndex", {
    get: $util.oneOfGetter(c = ["tabIndex"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.src != null && Object.hasOwnProperty.call(t, "src") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.src), t.srcdoc != null && Object.hasOwnProperty.call(t, "srcdoc") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.srcdoc), t.width != null && Object.hasOwnProperty.call(t, "width") && e.uint32(
      /* id 3, wireType 5 =*/
      29
    ).float(t.width), t.hasWidth != null && Object.hasOwnProperty.call(t, "hasWidth") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(t.hasWidth), t.height != null && Object.hasOwnProperty.call(t, "height") && e.uint32(
      /* id 5, wireType 5 =*/
      45
    ).float(t.height), t.scrolling != null && Object.hasOwnProperty.call(t, "scrolling") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(t.scrolling), t.tabIndex != null && Object.hasOwnProperty.call(t, "tabIndex") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(t.tabIndex), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.IFrame();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.src = t.string();
          break;
        }
        case 2: {
          h.srcdoc = t.string();
          break;
        }
        case 3: {
          h.width = t.float();
          break;
        }
        case 4: {
          h.hasWidth = t.bool();
          break;
        }
        case 5: {
          h.height = t.float();
          break;
        }
        case 7: {
          h.scrolling = t.bool();
          break;
        }
        case 8: {
          h.tabIndex = t.int32();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    let e = {};
    if (t.src != null && t.hasOwnProperty("src") && (e.type = 1, !$util.isString(t.src)))
      return "src: string expected";
    if (t.srcdoc != null && t.hasOwnProperty("srcdoc")) {
      if (e.type === 1)
        return "type: multiple values";
      if (e.type = 1, !$util.isString(t.srcdoc))
        return "srcdoc: string expected";
    }
    return t.width != null && t.hasOwnProperty("width") && typeof t.width != "number" ? "width: number expected" : t.hasWidth != null && t.hasOwnProperty("hasWidth") && typeof t.hasWidth != "boolean" ? "hasWidth: boolean expected" : t.height != null && t.hasOwnProperty("height") && typeof t.height != "number" ? "height: number expected" : t.scrolling != null && t.hasOwnProperty("scrolling") && typeof t.scrolling != "boolean" ? "scrolling: boolean expected" : t.tabIndex != null && t.hasOwnProperty("tabIndex") && (e._tabIndex = 1, !$util.isInteger(t.tabIndex)) ? "tabIndex: integer expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.IFrame)
      return t;
    let e = new $root.IFrame();
    return t.src != null && (e.src = String(t.src)), t.srcdoc != null && (e.srcdoc = String(t.srcdoc)), t.width != null && (e.width = Number(t.width)), t.hasWidth != null && (e.hasWidth = !!t.hasWidth), t.height != null && (e.height = Number(t.height)), t.scrolling != null && (e.scrolling = !!t.scrolling), t.tabIndex != null && (e.tabIndex = t.tabIndex | 0), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.width = 0, o.hasWidth = !1, o.height = 0, o.scrolling = !1), t.src != null && t.hasOwnProperty("src") && (o.src = t.src, e.oneofs && (o.type = "src")), t.srcdoc != null && t.hasOwnProperty("srcdoc") && (o.srcdoc = t.srcdoc, e.oneofs && (o.type = "srcdoc")), t.width != null && t.hasOwnProperty("width") && (o.width = e.json && !isFinite(t.width) ? String(t.width) : t.width), t.hasWidth != null && t.hasOwnProperty("hasWidth") && (o.hasWidth = t.hasWidth), t.height != null && t.hasOwnProperty("height") && (o.height = e.json && !isFinite(t.height) ? String(t.height) : t.height), t.scrolling != null && t.hasOwnProperty("scrolling") && (o.scrolling = t.scrolling), t.tabIndex != null && t.hasOwnProperty("tabIndex") && (o.tabIndex = t.tabIndex, e.oneofs && (o._tabIndex = "tabIndex")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/IFrame";
  }, r;
})();
$root.Image = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.url = "", r.prototype.caption = "", r.prototype.markup = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.caption != null && Object.hasOwnProperty.call(n, "caption") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.caption), n.url != null && Object.hasOwnProperty.call(n, "url") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.url), n.markup != null && Object.hasOwnProperty.call(n, "markup") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.markup), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Image();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 3: {
          p.url = n.string();
          break;
        }
        case 2: {
          p.caption = n.string();
          break;
        }
        case 4: {
          p.markup = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.url != null && n.hasOwnProperty("url") && !$util.isString(n.url) ? "url: string expected" : n.caption != null && n.hasOwnProperty("caption") && !$util.isString(n.caption) ? "caption: string expected" : n.markup != null && n.hasOwnProperty("markup") && !$util.isString(n.markup) ? "markup: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Image)
      return n;
    let t = new $root.Image();
    return n.url != null && (t.url = String(n.url)), n.caption != null && (t.caption = String(n.caption)), n.markup != null && (t.markup = String(n.markup)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.caption = "", e.url = "", e.markup = ""), n.caption != null && n.hasOwnProperty("caption") && (e.caption = n.caption), n.url != null && n.hasOwnProperty("url") && (e.url = n.url), n.markup != null && n.hasOwnProperty("markup") && (e.markup = n.markup), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Image";
  }, r;
})();
$root.ImageList = (() => {
  function r(c) {
    if (this.imgs = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.imgs = $util.emptyArray, r.prototype.width = 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.imgs != null && n.imgs.length)
      for (let e = 0; e < n.imgs.length; ++e)
        $root.Image.encode(n.imgs[e], t.uint32(
          /* id 1, wireType 2 =*/
          10
        ).fork()).ldelim();
    return n.width != null && Object.hasOwnProperty.call(n, "width") && t.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(n.width), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.ImageList();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.imgs && p.imgs.length || (p.imgs = []), p.imgs.push($root.Image.decode(n, n.uint32()));
          break;
        }
        case 2: {
          p.width = n.int32();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.imgs != null && n.hasOwnProperty("imgs")) {
      if (!Array.isArray(n.imgs))
        return "imgs: array expected";
      for (let t = 0; t < n.imgs.length; ++t) {
        let e = $root.Image.verify(n.imgs[t]);
        if (e)
          return "imgs." + e;
      }
    }
    return n.width != null && n.hasOwnProperty("width") && !$util.isInteger(n.width) ? "width: integer expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.ImageList)
      return n;
    let t = new $root.ImageList();
    if (n.imgs) {
      if (!Array.isArray(n.imgs))
        throw TypeError(".ImageList.imgs: array expected");
      t.imgs = [];
      for (let e = 0; e < n.imgs.length; ++e) {
        if (typeof n.imgs[e] != "object")
          throw TypeError(".ImageList.imgs: object expected");
        t.imgs[e] = $root.Image.fromObject(n.imgs[e]);
      }
    }
    return n.width != null && (t.width = n.width | 0), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.imgs = []), t.defaults && (e.width = 0), n.imgs && n.imgs.length) {
      e.imgs = [];
      for (let o = 0; o < n.imgs.length; ++o)
        e.imgs[o] = $root.Image.toObject(n.imgs[o], t);
    }
    return n.width != null && n.hasOwnProperty("width") && (e.width = n.width), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/ImageList";
  }, r;
})();
$root.Json = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.body = "", r.prototype.expanded = !1, r.prototype.maxExpandDepth = null;
  let c;
  return Object.defineProperty(r.prototype, "_maxExpandDepth", {
    get: $util.oneOfGetter(c = ["maxExpandDepth"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.body != null && Object.hasOwnProperty.call(t, "body") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.body), t.expanded != null && Object.hasOwnProperty.call(t, "expanded") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(t.expanded), t.maxExpandDepth != null && Object.hasOwnProperty.call(t, "maxExpandDepth") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(t.maxExpandDepth), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.Json();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.body = t.string();
          break;
        }
        case 2: {
          h.expanded = t.bool();
          break;
        }
        case 3: {
          h.maxExpandDepth = t.int32();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.body != null && t.hasOwnProperty("body") && !$util.isString(t.body) ? "body: string expected" : t.expanded != null && t.hasOwnProperty("expanded") && typeof t.expanded != "boolean" ? "expanded: boolean expected" : t.maxExpandDepth != null && t.hasOwnProperty("maxExpandDepth") && !$util.isInteger(t.maxExpandDepth) ? "maxExpandDepth: integer expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.Json)
      return t;
    let e = new $root.Json();
    return t.body != null && (e.body = String(t.body)), t.expanded != null && (e.expanded = !!t.expanded), t.maxExpandDepth != null && (e.maxExpandDepth = t.maxExpandDepth | 0), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.body = "", o.expanded = !1), t.body != null && t.hasOwnProperty("body") && (o.body = t.body), t.expanded != null && t.hasOwnProperty("expanded") && (o.expanded = t.expanded), t.maxExpandDepth != null && t.hasOwnProperty("maxExpandDepth") && (o.maxExpandDepth = t.maxExpandDepth, e.oneofs && (o._maxExpandDepth = "maxExpandDepth")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Json";
  }, r;
})();
$root.LinkButton = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.label = "", r.prototype.help = "", r.prototype.url = "", r.prototype.disabled = !1, r.prototype.useContainerWidth = !1, r.prototype.type = "", r.prototype.icon = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.label != null && Object.hasOwnProperty.call(n, "label") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.label), n.help != null && Object.hasOwnProperty.call(n, "help") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.help), n.url != null && Object.hasOwnProperty.call(n, "url") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.url), n.disabled != null && Object.hasOwnProperty.call(n, "disabled") && t.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(n.disabled), n.useContainerWidth != null && Object.hasOwnProperty.call(n, "useContainerWidth") && t.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(n.useContainerWidth), n.type != null && Object.hasOwnProperty.call(n, "type") && t.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(n.type), n.icon != null && Object.hasOwnProperty.call(n, "icon") && t.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(n.icon), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.LinkButton();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 2: {
          p.label = n.string();
          break;
        }
        case 4: {
          p.help = n.string();
          break;
        }
        case 6: {
          p.url = n.string();
          break;
        }
        case 7: {
          p.disabled = n.bool();
          break;
        }
        case 8: {
          p.useContainerWidth = n.bool();
          break;
        }
        case 9: {
          p.type = n.string();
          break;
        }
        case 10: {
          p.icon = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.label != null && n.hasOwnProperty("label") && !$util.isString(n.label) ? "label: string expected" : n.help != null && n.hasOwnProperty("help") && !$util.isString(n.help) ? "help: string expected" : n.url != null && n.hasOwnProperty("url") && !$util.isString(n.url) ? "url: string expected" : n.disabled != null && n.hasOwnProperty("disabled") && typeof n.disabled != "boolean" ? "disabled: boolean expected" : n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && typeof n.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : n.type != null && n.hasOwnProperty("type") && !$util.isString(n.type) ? "type: string expected" : n.icon != null && n.hasOwnProperty("icon") && !$util.isString(n.icon) ? "icon: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.LinkButton)
      return n;
    let t = new $root.LinkButton();
    return n.label != null && (t.label = String(n.label)), n.help != null && (t.help = String(n.help)), n.url != null && (t.url = String(n.url)), n.disabled != null && (t.disabled = !!n.disabled), n.useContainerWidth != null && (t.useContainerWidth = !!n.useContainerWidth), n.type != null && (t.type = String(n.type)), n.icon != null && (t.icon = String(n.icon)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.label = "", e.help = "", e.url = "", e.disabled = !1, e.useContainerWidth = !1, e.type = "", e.icon = ""), n.label != null && n.hasOwnProperty("label") && (e.label = n.label), n.help != null && n.hasOwnProperty("help") && (e.help = n.help), n.url != null && n.hasOwnProperty("url") && (e.url = n.url), n.disabled != null && n.hasOwnProperty("disabled") && (e.disabled = n.disabled), n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = n.useContainerWidth), n.type != null && n.hasOwnProperty("type") && (e.type = n.type), n.icon != null && n.hasOwnProperty("icon") && (e.icon = n.icon), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/LinkButton";
  }, r;
})();
$root.NumberInput = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.id = "", r.prototype.label = "", r.prototype.formId = "", r.prototype.format = "", r.prototype.hasMin = !1, r.prototype.hasMax = !1, r.prototype.dataType = 0, r.prototype.default = null, r.prototype.step = 0, r.prototype.min = 0, r.prototype.max = 0, r.prototype.help = "", r.prototype.value = null, r.prototype.setValue = !1, r.prototype.disabled = !1, r.prototype.labelVisibility = null, r.prototype.placeholder = "", r.prototype.icon = "";
  let c;
  return Object.defineProperty(r.prototype, "_default", {
    get: $util.oneOfGetter(c = ["default"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_value", {
    get: $util.oneOfGetter(c = ["value"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.formId != null && Object.hasOwnProperty.call(t, "formId") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.formId), t.format != null && Object.hasOwnProperty.call(t, "format") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(t.format), t.hasMin != null && Object.hasOwnProperty.call(t, "hasMin") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(t.hasMin), t.hasMax != null && Object.hasOwnProperty.call(t, "hasMax") && e.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(t.hasMax), t.dataType != null && Object.hasOwnProperty.call(t, "dataType") && e.uint32(
      /* id 13, wireType 0 =*/
      104
    ).int32(t.dataType), t.default != null && Object.hasOwnProperty.call(t, "default") && e.uint32(
      /* id 14, wireType 1 =*/
      113
    ).double(t.default), t.step != null && Object.hasOwnProperty.call(t, "step") && e.uint32(
      /* id 15, wireType 1 =*/
      121
    ).double(t.step), t.min != null && Object.hasOwnProperty.call(t, "min") && e.uint32(
      /* id 16, wireType 1 =*/
      129
    ).double(t.min), t.max != null && Object.hasOwnProperty.call(t, "max") && e.uint32(
      /* id 17, wireType 1 =*/
      137
    ).double(t.max), t.help != null && Object.hasOwnProperty.call(t, "help") && e.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(t.help), t.value != null && Object.hasOwnProperty.call(t, "value") && e.uint32(
      /* id 19, wireType 1 =*/
      153
    ).double(t.value), t.setValue != null && Object.hasOwnProperty.call(t, "setValue") && e.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(t.setValue), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && e.uint32(
      /* id 21, wireType 0 =*/
      168
    ).bool(t.disabled), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, e.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), t.placeholder != null && Object.hasOwnProperty.call(t, "placeholder") && e.uint32(
      /* id 23, wireType 2 =*/
      186
    ).string(t.placeholder), t.icon != null && Object.hasOwnProperty.call(t, "icon") && e.uint32(
      /* id 24, wireType 2 =*/
      194
    ).string(t.icon), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.NumberInput();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.id = t.string();
          break;
        }
        case 2: {
          h.label = t.string();
          break;
        }
        case 3: {
          h.formId = t.string();
          break;
        }
        case 8: {
          h.format = t.string();
          break;
        }
        case 11: {
          h.hasMin = t.bool();
          break;
        }
        case 12: {
          h.hasMax = t.bool();
          break;
        }
        case 13: {
          h.dataType = t.int32();
          break;
        }
        case 14: {
          h.default = t.double();
          break;
        }
        case 15: {
          h.step = t.double();
          break;
        }
        case 16: {
          h.min = t.double();
          break;
        }
        case 17: {
          h.max = t.double();
          break;
        }
        case 18: {
          h.help = t.string();
          break;
        }
        case 19: {
          h.value = t.double();
          break;
        }
        case 20: {
          h.setValue = t.bool();
          break;
        }
        case 21: {
          h.disabled = t.bool();
          break;
        }
        case 22: {
          h.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        case 23: {
          h.placeholder = t.string();
          break;
        }
        case 24: {
          h.icon = t.string();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label))
      return "label: string expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId))
      return "formId: string expected";
    if (t.format != null && t.hasOwnProperty("format") && !$util.isString(t.format))
      return "format: string expected";
    if (t.hasMin != null && t.hasOwnProperty("hasMin") && typeof t.hasMin != "boolean")
      return "hasMin: boolean expected";
    if (t.hasMax != null && t.hasOwnProperty("hasMax") && typeof t.hasMax != "boolean")
      return "hasMax: boolean expected";
    if (t.dataType != null && t.hasOwnProperty("dataType"))
      switch (t.dataType) {
        default:
          return "dataType: enum value expected";
        case 0:
        case 1:
          break;
      }
    if (t.default != null && t.hasOwnProperty("default") && typeof t.default != "number")
      return "default: number expected";
    if (t.step != null && t.hasOwnProperty("step") && typeof t.step != "number")
      return "step: number expected";
    if (t.min != null && t.hasOwnProperty("min") && typeof t.min != "number")
      return "min: number expected";
    if (t.max != null && t.hasOwnProperty("max") && typeof t.max != "number")
      return "max: number expected";
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help))
      return "help: string expected";
    if (t.value != null && t.hasOwnProperty("value") && typeof t.value != "number")
      return "value: number expected";
    if (t.setValue != null && t.hasOwnProperty("setValue") && typeof t.setValue != "boolean")
      return "setValue: boolean expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean")
      return "disabled: boolean expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let e = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (e)
        return "labelVisibility." + e;
    }
    return t.placeholder != null && t.hasOwnProperty("placeholder") && !$util.isString(t.placeholder) ? "placeholder: string expected" : t.icon != null && t.hasOwnProperty("icon") && !$util.isString(t.icon) ? "icon: string expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.NumberInput)
      return t;
    let e = new $root.NumberInput();
    switch (t.id != null && (e.id = String(t.id)), t.label != null && (e.label = String(t.label)), t.formId != null && (e.formId = String(t.formId)), t.format != null && (e.format = String(t.format)), t.hasMin != null && (e.hasMin = !!t.hasMin), t.hasMax != null && (e.hasMax = !!t.hasMax), t.dataType) {
      default:
        if (typeof t.dataType == "number") {
          e.dataType = t.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        e.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        e.dataType = 1;
        break;
    }
    if (t.default != null && (e.default = Number(t.default)), t.step != null && (e.step = Number(t.step)), t.min != null && (e.min = Number(t.min)), t.max != null && (e.max = Number(t.max)), t.help != null && (e.help = String(t.help)), t.value != null && (e.value = Number(t.value)), t.setValue != null && (e.setValue = !!t.setValue), t.disabled != null && (e.disabled = !!t.disabled), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object")
        throw TypeError(".NumberInput.labelVisibility: object expected");
      e.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    return t.placeholder != null && (e.placeholder = String(t.placeholder)), t.icon != null && (e.icon = String(t.icon)), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.id = "", o.label = "", o.formId = "", o.format = "", o.hasMin = !1, o.hasMax = !1, o.dataType = e.enums === String ? "INT" : 0, o.step = 0, o.min = 0, o.max = 0, o.help = "", o.setValue = !1, o.disabled = !1, o.labelVisibility = null, o.placeholder = "", o.icon = ""), t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.label != null && t.hasOwnProperty("label") && (o.label = t.label), t.formId != null && t.hasOwnProperty("formId") && (o.formId = t.formId), t.format != null && t.hasOwnProperty("format") && (o.format = t.format), t.hasMin != null && t.hasOwnProperty("hasMin") && (o.hasMin = t.hasMin), t.hasMax != null && t.hasOwnProperty("hasMax") && (o.hasMax = t.hasMax), t.dataType != null && t.hasOwnProperty("dataType") && (o.dataType = e.enums === String ? $root.NumberInput.DataType[t.dataType] === void 0 ? t.dataType : $root.NumberInput.DataType[t.dataType] : t.dataType), t.default != null && t.hasOwnProperty("default") && (o.default = e.json && !isFinite(t.default) ? String(t.default) : t.default, e.oneofs && (o._default = "default")), t.step != null && t.hasOwnProperty("step") && (o.step = e.json && !isFinite(t.step) ? String(t.step) : t.step), t.min != null && t.hasOwnProperty("min") && (o.min = e.json && !isFinite(t.min) ? String(t.min) : t.min), t.max != null && t.hasOwnProperty("max") && (o.max = e.json && !isFinite(t.max) ? String(t.max) : t.max), t.help != null && t.hasOwnProperty("help") && (o.help = t.help), t.value != null && t.hasOwnProperty("value") && (o.value = e.json && !isFinite(t.value) ? String(t.value) : t.value, e.oneofs && (o._value = "value")), t.setValue != null && t.hasOwnProperty("setValue") && (o.setValue = t.setValue), t.disabled != null && t.hasOwnProperty("disabled") && (o.disabled = t.disabled), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (o.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, e)), t.placeholder != null && t.hasOwnProperty("placeholder") && (o.placeholder = t.placeholder), t.icon != null && t.hasOwnProperty("icon") && (o.icon = t.icon), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/NumberInput";
  }, r.DataType = (function() {
    const n = {}, t = Object.create(n);
    return t[n[0] = "INT"] = 0, t[n[1] = "FLOAT"] = 1, t;
  })(), r;
})();
$root.Markdown = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.body = "", r.prototype.allowHtml = !1, r.prototype.isCaption = !1, r.prototype.elementType = 0, r.prototype.help = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.body != null && Object.hasOwnProperty.call(n, "body") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.body), n.allowHtml != null && Object.hasOwnProperty.call(n, "allowHtml") && t.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(n.allowHtml), n.isCaption != null && Object.hasOwnProperty.call(n, "isCaption") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(n.isCaption), n.elementType != null && Object.hasOwnProperty.call(n, "elementType") && t.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(n.elementType), n.help != null && Object.hasOwnProperty.call(n, "help") && t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(n.help), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Markdown();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.body = n.string();
          break;
        }
        case 2: {
          p.allowHtml = n.bool();
          break;
        }
        case 3: {
          p.isCaption = n.bool();
          break;
        }
        case 4: {
          p.elementType = n.int32();
          break;
        }
        case 5: {
          p.help = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.body != null && n.hasOwnProperty("body") && !$util.isString(n.body))
      return "body: string expected";
    if (n.allowHtml != null && n.hasOwnProperty("allowHtml") && typeof n.allowHtml != "boolean")
      return "allowHtml: boolean expected";
    if (n.isCaption != null && n.hasOwnProperty("isCaption") && typeof n.isCaption != "boolean")
      return "isCaption: boolean expected";
    if (n.elementType != null && n.hasOwnProperty("elementType"))
      switch (n.elementType) {
        default:
          return "elementType: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
      }
    return n.help != null && n.hasOwnProperty("help") && !$util.isString(n.help) ? "help: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Markdown)
      return n;
    let t = new $root.Markdown();
    switch (n.body != null && (t.body = String(n.body)), n.allowHtml != null && (t.allowHtml = !!n.allowHtml), n.isCaption != null && (t.isCaption = !!n.isCaption), n.elementType) {
      default:
        if (typeof n.elementType == "number") {
          t.elementType = n.elementType;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        t.elementType = 0;
        break;
      case "NATIVE":
      case 1:
        t.elementType = 1;
        break;
      case "CAPTION":
      case 2:
        t.elementType = 2;
        break;
      case "CODE":
      case 3:
        t.elementType = 3;
        break;
      case "LATEX":
      case 4:
        t.elementType = 4;
        break;
      case "DIVIDER":
      case 5:
        t.elementType = 5;
        break;
    }
    return n.help != null && (t.help = String(n.help)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.body = "", e.allowHtml = !1, e.isCaption = !1, e.elementType = t.enums === String ? "UNSPECIFIED" : 0, e.help = ""), n.body != null && n.hasOwnProperty("body") && (e.body = n.body), n.allowHtml != null && n.hasOwnProperty("allowHtml") && (e.allowHtml = n.allowHtml), n.isCaption != null && n.hasOwnProperty("isCaption") && (e.isCaption = n.isCaption), n.elementType != null && n.hasOwnProperty("elementType") && (e.elementType = t.enums === String ? $root.Markdown.Type[n.elementType] === void 0 ? n.elementType : $root.Markdown.Type[n.elementType] : n.elementType), n.help != null && n.hasOwnProperty("help") && (e.help = n.help), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Markdown";
  }, r.Type = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "UNSPECIFIED"] = 0, n[c[1] = "NATIVE"] = 1, n[c[2] = "CAPTION"] = 2, n[c[3] = "CODE"] = 3, n[c[4] = "LATEX"] = 4, n[c[5] = "DIVIDER"] = 5, n;
  })(), r;
})();
$root.Metric = (() => {
  function r(c) {
    if (this.chartData = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.label = "", r.prototype.body = "", r.prototype.delta = "", r.prototype.direction = 0, r.prototype.color = 0, r.prototype.help = "", r.prototype.labelVisibility = null, r.prototype.showBorder = !1, r.prototype.chartData = $util.emptyArray, r.prototype.chartType = 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.label != null && Object.hasOwnProperty.call(n, "label") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.label), n.body != null && Object.hasOwnProperty.call(n, "body") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.body), n.delta != null && Object.hasOwnProperty.call(n, "delta") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.delta), n.direction != null && Object.hasOwnProperty.call(n, "direction") && t.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(n.direction), n.color != null && Object.hasOwnProperty.call(n, "color") && t.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(n.color), n.help != null && Object.hasOwnProperty.call(n, "help") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.help), n.labelVisibility != null && Object.hasOwnProperty.call(n, "labelVisibility") && $root.LabelVisibilityMessage.encode(n.labelVisibility, t.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), n.showBorder != null && Object.hasOwnProperty.call(n, "showBorder") && t.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(n.showBorder), n.chartData != null && n.chartData.length) {
      t.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork();
      for (let e = 0; e < n.chartData.length; ++e)
        t.double(n.chartData[e]);
      t.ldelim();
    }
    return n.chartType != null && Object.hasOwnProperty.call(n, "chartType") && t.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int32(n.chartType), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Metric();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.label = n.string();
          break;
        }
        case 2: {
          p.body = n.string();
          break;
        }
        case 3: {
          p.delta = n.string();
          break;
        }
        case 4: {
          p.direction = n.int32();
          break;
        }
        case 5: {
          p.color = n.int32();
          break;
        }
        case 6: {
          p.help = n.string();
          break;
        }
        case 7: {
          p.labelVisibility = $root.LabelVisibilityMessage.decode(n, n.uint32());
          break;
        }
        case 8: {
          p.showBorder = n.bool();
          break;
        }
        case 9: {
          if (p.chartData && p.chartData.length || (p.chartData = []), (h & 7) === 2) {
            let y = n.uint32() + n.pos;
            for (; n.pos < y; )
              p.chartData.push(n.double());
          } else
            p.chartData.push(n.double());
          break;
        }
        case 10: {
          p.chartType = n.int32();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.label != null && n.hasOwnProperty("label") && !$util.isString(n.label))
      return "label: string expected";
    if (n.body != null && n.hasOwnProperty("body") && !$util.isString(n.body))
      return "body: string expected";
    if (n.delta != null && n.hasOwnProperty("delta") && !$util.isString(n.delta))
      return "delta: string expected";
    if (n.direction != null && n.hasOwnProperty("direction"))
      switch (n.direction) {
        default:
          return "direction: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    if (n.color != null && n.hasOwnProperty("color"))
      switch (n.color) {
        default:
          return "color: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    if (n.help != null && n.hasOwnProperty("help") && !$util.isString(n.help))
      return "help: string expected";
    if (n.labelVisibility != null && n.hasOwnProperty("labelVisibility")) {
      let t = $root.LabelVisibilityMessage.verify(n.labelVisibility);
      if (t)
        return "labelVisibility." + t;
    }
    if (n.showBorder != null && n.hasOwnProperty("showBorder") && typeof n.showBorder != "boolean")
      return "showBorder: boolean expected";
    if (n.chartData != null && n.hasOwnProperty("chartData")) {
      if (!Array.isArray(n.chartData))
        return "chartData: array expected";
      for (let t = 0; t < n.chartData.length; ++t)
        if (typeof n.chartData[t] != "number")
          return "chartData: number[] expected";
    }
    if (n.chartType != null && n.hasOwnProperty("chartType"))
      switch (n.chartType) {
        default:
          return "chartType: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Metric)
      return n;
    let t = new $root.Metric();
    switch (n.label != null && (t.label = String(n.label)), n.body != null && (t.body = String(n.body)), n.delta != null && (t.delta = String(n.delta)), n.direction) {
      default:
        if (typeof n.direction == "number") {
          t.direction = n.direction;
          break;
        }
        break;
      case "DOWN":
      case 0:
        t.direction = 0;
        break;
      case "UP":
      case 1:
        t.direction = 1;
        break;
      case "NONE":
      case 2:
        t.direction = 2;
        break;
    }
    switch (n.color) {
      default:
        if (typeof n.color == "number") {
          t.color = n.color;
          break;
        }
        break;
      case "RED":
      case 0:
        t.color = 0;
        break;
      case "GREEN":
      case 1:
        t.color = 1;
        break;
      case "GRAY":
      case 2:
        t.color = 2;
        break;
    }
    if (n.help != null && (t.help = String(n.help)), n.labelVisibility != null) {
      if (typeof n.labelVisibility != "object")
        throw TypeError(".Metric.labelVisibility: object expected");
      t.labelVisibility = $root.LabelVisibilityMessage.fromObject(n.labelVisibility);
    }
    if (n.showBorder != null && (t.showBorder = !!n.showBorder), n.chartData) {
      if (!Array.isArray(n.chartData))
        throw TypeError(".Metric.chartData: array expected");
      t.chartData = [];
      for (let e = 0; e < n.chartData.length; ++e)
        t.chartData[e] = Number(n.chartData[e]);
    }
    switch (n.chartType) {
      default:
        if (typeof n.chartType == "number") {
          t.chartType = n.chartType;
          break;
        }
        break;
      case "LINE":
      case 0:
        t.chartType = 0;
        break;
      case "BAR":
      case 1:
        t.chartType = 1;
        break;
      case "AREA":
      case 2:
        t.chartType = 2;
        break;
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.chartData = []), t.defaults && (e.label = "", e.body = "", e.delta = "", e.direction = t.enums === String ? "DOWN" : 0, e.color = t.enums === String ? "RED" : 0, e.help = "", e.labelVisibility = null, e.showBorder = !1, e.chartType = t.enums === String ? "LINE" : 0), n.label != null && n.hasOwnProperty("label") && (e.label = n.label), n.body != null && n.hasOwnProperty("body") && (e.body = n.body), n.delta != null && n.hasOwnProperty("delta") && (e.delta = n.delta), n.direction != null && n.hasOwnProperty("direction") && (e.direction = t.enums === String ? $root.Metric.MetricDirection[n.direction] === void 0 ? n.direction : $root.Metric.MetricDirection[n.direction] : n.direction), n.color != null && n.hasOwnProperty("color") && (e.color = t.enums === String ? $root.Metric.MetricColor[n.color] === void 0 ? n.color : $root.Metric.MetricColor[n.color] : n.color), n.help != null && n.hasOwnProperty("help") && (e.help = n.help), n.labelVisibility != null && n.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(n.labelVisibility, t)), n.showBorder != null && n.hasOwnProperty("showBorder") && (e.showBorder = n.showBorder), n.chartData && n.chartData.length) {
      e.chartData = [];
      for (let o = 0; o < n.chartData.length; ++o)
        e.chartData[o] = t.json && !isFinite(n.chartData[o]) ? String(n.chartData[o]) : n.chartData[o];
    }
    return n.chartType != null && n.hasOwnProperty("chartType") && (e.chartType = t.enums === String ? $root.Metric.ChartType[n.chartType] === void 0 ? n.chartType : $root.Metric.ChartType[n.chartType] : n.chartType), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Metric";
  }, r.MetricDirection = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "DOWN"] = 0, n[c[1] = "UP"] = 1, n[c[2] = "NONE"] = 2, n;
  })(), r.MetricColor = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "RED"] = 0, n[c[1] = "GREEN"] = 1, n[c[2] = "GRAY"] = 2, n;
  })(), r.ChartType = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "LINE"] = 0, n[c[1] = "BAR"] = 1, n[c[2] = "AREA"] = 2, n;
  })(), r;
})();
$root.MultiSelect = (() => {
  function r(n) {
    if (this.default = [], this.options = [], this.value = [], this.rawValues = [], n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.id = "", r.prototype.label = "", r.prototype.default = $util.emptyArray, r.prototype.options = $util.emptyArray, r.prototype.help = "", r.prototype.formId = "", r.prototype.value = $util.emptyArray, r.prototype.rawValues = $util.emptyArray, r.prototype.setValue = !1, r.prototype.disabled = !1, r.prototype.labelVisibility = null, r.prototype.maxSelections = 0, r.prototype.placeholder = "", r.prototype.acceptNewOptions = null;
  let c;
  return Object.defineProperty(r.prototype, "_acceptNewOptions", {
    get: $util.oneOfGetter(c = ["acceptNewOptions"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    if (e || (e = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.default != null && t.default.length) {
      e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork();
      for (let o = 0; o < t.default.length; ++o)
        e.int32(t.default[o]);
      e.ldelim();
    }
    if (t.options != null && t.options.length)
      for (let o = 0; o < t.options.length; ++o)
        e.uint32(
          /* id 4, wireType 2 =*/
          34
        ).string(t.options[o]);
    if (t.help != null && Object.hasOwnProperty.call(t, "help") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.help), t.formId != null && Object.hasOwnProperty.call(t, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.formId), t.value != null && t.value.length) {
      e.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork();
      for (let o = 0; o < t.value.length; ++o)
        e.int32(t.value[o]);
      e.ldelim();
    }
    if (t.setValue != null && Object.hasOwnProperty.call(t, "setValue") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.setValue), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(t.disabled), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), t.maxSelections != null && Object.hasOwnProperty.call(t, "maxSelections") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).int32(t.maxSelections), t.placeholder != null && Object.hasOwnProperty.call(t, "placeholder") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(t.placeholder), t.acceptNewOptions != null && Object.hasOwnProperty.call(t, "acceptNewOptions") && e.uint32(
      /* id 13, wireType 0 =*/
      104
    ).bool(t.acceptNewOptions), t.rawValues != null && t.rawValues.length)
      for (let o = 0; o < t.rawValues.length; ++o)
        e.uint32(
          /* id 14, wireType 2 =*/
          114
        ).string(t.rawValues[o]);
    return e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.MultiSelect();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.id = t.string();
          break;
        }
        case 2: {
          h.label = t.string();
          break;
        }
        case 3: {
          if (h.default && h.default.length || (h.default = []), (y & 7) === 2) {
            let b = t.uint32() + t.pos;
            for (; t.pos < b; )
              h.default.push(t.int32());
          } else
            h.default.push(t.int32());
          break;
        }
        case 4: {
          h.options && h.options.length || (h.options = []), h.options.push(t.string());
          break;
        }
        case 5: {
          h.help = t.string();
          break;
        }
        case 6: {
          h.formId = t.string();
          break;
        }
        case 7: {
          if (h.value && h.value.length || (h.value = []), (y & 7) === 2) {
            let b = t.uint32() + t.pos;
            for (; t.pos < b; )
              h.value.push(t.int32());
          } else
            h.value.push(t.int32());
          break;
        }
        case 14: {
          h.rawValues && h.rawValues.length || (h.rawValues = []), h.rawValues.push(t.string());
          break;
        }
        case 8: {
          h.setValue = t.bool();
          break;
        }
        case 9: {
          h.disabled = t.bool();
          break;
        }
        case 10: {
          h.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        case 11: {
          h.maxSelections = t.int32();
          break;
        }
        case 12: {
          h.placeholder = t.string();
          break;
        }
        case 13: {
          h.acceptNewOptions = t.bool();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label))
      return "label: string expected";
    if (t.default != null && t.hasOwnProperty("default")) {
      if (!Array.isArray(t.default))
        return "default: array expected";
      for (let e = 0; e < t.default.length; ++e)
        if (!$util.isInteger(t.default[e]))
          return "default: integer[] expected";
    }
    if (t.options != null && t.hasOwnProperty("options")) {
      if (!Array.isArray(t.options))
        return "options: array expected";
      for (let e = 0; e < t.options.length; ++e)
        if (!$util.isString(t.options[e]))
          return "options: string[] expected";
    }
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help))
      return "help: string expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId))
      return "formId: string expected";
    if (t.value != null && t.hasOwnProperty("value")) {
      if (!Array.isArray(t.value))
        return "value: array expected";
      for (let e = 0; e < t.value.length; ++e)
        if (!$util.isInteger(t.value[e]))
          return "value: integer[] expected";
    }
    if (t.rawValues != null && t.hasOwnProperty("rawValues")) {
      if (!Array.isArray(t.rawValues))
        return "rawValues: array expected";
      for (let e = 0; e < t.rawValues.length; ++e)
        if (!$util.isString(t.rawValues[e]))
          return "rawValues: string[] expected";
    }
    if (t.setValue != null && t.hasOwnProperty("setValue") && typeof t.setValue != "boolean")
      return "setValue: boolean expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean")
      return "disabled: boolean expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let e = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (e)
        return "labelVisibility." + e;
    }
    return t.maxSelections != null && t.hasOwnProperty("maxSelections") && !$util.isInteger(t.maxSelections) ? "maxSelections: integer expected" : t.placeholder != null && t.hasOwnProperty("placeholder") && !$util.isString(t.placeholder) ? "placeholder: string expected" : t.acceptNewOptions != null && t.hasOwnProperty("acceptNewOptions") && typeof t.acceptNewOptions != "boolean" ? "acceptNewOptions: boolean expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.MultiSelect)
      return t;
    let e = new $root.MultiSelect();
    if (t.id != null && (e.id = String(t.id)), t.label != null && (e.label = String(t.label)), t.default) {
      if (!Array.isArray(t.default))
        throw TypeError(".MultiSelect.default: array expected");
      e.default = [];
      for (let o = 0; o < t.default.length; ++o)
        e.default[o] = t.default[o] | 0;
    }
    if (t.options) {
      if (!Array.isArray(t.options))
        throw TypeError(".MultiSelect.options: array expected");
      e.options = [];
      for (let o = 0; o < t.options.length; ++o)
        e.options[o] = String(t.options[o]);
    }
    if (t.help != null && (e.help = String(t.help)), t.formId != null && (e.formId = String(t.formId)), t.value) {
      if (!Array.isArray(t.value))
        throw TypeError(".MultiSelect.value: array expected");
      e.value = [];
      for (let o = 0; o < t.value.length; ++o)
        e.value[o] = t.value[o] | 0;
    }
    if (t.rawValues) {
      if (!Array.isArray(t.rawValues))
        throw TypeError(".MultiSelect.rawValues: array expected");
      e.rawValues = [];
      for (let o = 0; o < t.rawValues.length; ++o)
        e.rawValues[o] = String(t.rawValues[o]);
    }
    if (t.setValue != null && (e.setValue = !!t.setValue), t.disabled != null && (e.disabled = !!t.disabled), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object")
        throw TypeError(".MultiSelect.labelVisibility: object expected");
      e.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    return t.maxSelections != null && (e.maxSelections = t.maxSelections | 0), t.placeholder != null && (e.placeholder = String(t.placeholder)), t.acceptNewOptions != null && (e.acceptNewOptions = !!t.acceptNewOptions), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    if ((e.arrays || e.defaults) && (o.default = [], o.options = [], o.value = [], o.rawValues = []), e.defaults && (o.id = "", o.label = "", o.help = "", o.formId = "", o.setValue = !1, o.disabled = !1, o.labelVisibility = null, o.maxSelections = 0, o.placeholder = ""), t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.label != null && t.hasOwnProperty("label") && (o.label = t.label), t.default && t.default.length) {
      o.default = [];
      for (let p = 0; p < t.default.length; ++p)
        o.default[p] = t.default[p];
    }
    if (t.options && t.options.length) {
      o.options = [];
      for (let p = 0; p < t.options.length; ++p)
        o.options[p] = t.options[p];
    }
    if (t.help != null && t.hasOwnProperty("help") && (o.help = t.help), t.formId != null && t.hasOwnProperty("formId") && (o.formId = t.formId), t.value && t.value.length) {
      o.value = [];
      for (let p = 0; p < t.value.length; ++p)
        o.value[p] = t.value[p];
    }
    if (t.setValue != null && t.hasOwnProperty("setValue") && (o.setValue = t.setValue), t.disabled != null && t.hasOwnProperty("disabled") && (o.disabled = t.disabled), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (o.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, e)), t.maxSelections != null && t.hasOwnProperty("maxSelections") && (o.maxSelections = t.maxSelections), t.placeholder != null && t.hasOwnProperty("placeholder") && (o.placeholder = t.placeholder), t.acceptNewOptions != null && t.hasOwnProperty("acceptNewOptions") && (o.acceptNewOptions = t.acceptNewOptions, e.oneofs && (o._acceptNewOptions = "acceptNewOptions")), t.rawValues && t.rawValues.length) {
      o.rawValues = [];
      for (let p = 0; p < t.rawValues.length; ++p)
        o.rawValues[p] = t.rawValues[p];
    }
    return o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/MultiSelect";
  }, r;
})();
$root.PageLink = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.page = "", r.prototype.label = "", r.prototype.icon = "", r.prototype.pageScriptHash = "", r.prototype.help = "", r.prototype.useContainerWidth = null, r.prototype.disabled = !1, r.prototype.external = !1;
  let c;
  return Object.defineProperty(r.prototype, "_useContainerWidth", {
    get: $util.oneOfGetter(c = ["useContainerWidth"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.page != null && Object.hasOwnProperty.call(t, "page") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.page), t.label != null && Object.hasOwnProperty.call(t, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.icon != null && Object.hasOwnProperty.call(t, "icon") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.icon), t.pageScriptHash != null && Object.hasOwnProperty.call(t, "pageScriptHash") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.pageScriptHash), t.help != null && Object.hasOwnProperty.call(t, "help") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.help), t.useContainerWidth != null && Object.hasOwnProperty.call(t, "useContainerWidth") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(t.useContainerWidth), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(t.disabled), t.external != null && Object.hasOwnProperty.call(t, "external") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.external), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.PageLink();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.page = t.string();
          break;
        }
        case 2: {
          h.label = t.string();
          break;
        }
        case 3: {
          h.icon = t.string();
          break;
        }
        case 4: {
          h.pageScriptHash = t.string();
          break;
        }
        case 5: {
          h.help = t.string();
          break;
        }
        case 6: {
          h.useContainerWidth = t.bool();
          break;
        }
        case 7: {
          h.disabled = t.bool();
          break;
        }
        case 8: {
          h.external = t.bool();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.page != null && t.hasOwnProperty("page") && !$util.isString(t.page) ? "page: string expected" : t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label) ? "label: string expected" : t.icon != null && t.hasOwnProperty("icon") && !$util.isString(t.icon) ? "icon: string expected" : t.pageScriptHash != null && t.hasOwnProperty("pageScriptHash") && !$util.isString(t.pageScriptHash) ? "pageScriptHash: string expected" : t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help) ? "help: string expected" : t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && typeof t.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean" ? "disabled: boolean expected" : t.external != null && t.hasOwnProperty("external") && typeof t.external != "boolean" ? "external: boolean expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.PageLink)
      return t;
    let e = new $root.PageLink();
    return t.page != null && (e.page = String(t.page)), t.label != null && (e.label = String(t.label)), t.icon != null && (e.icon = String(t.icon)), t.pageScriptHash != null && (e.pageScriptHash = String(t.pageScriptHash)), t.help != null && (e.help = String(t.help)), t.useContainerWidth != null && (e.useContainerWidth = !!t.useContainerWidth), t.disabled != null && (e.disabled = !!t.disabled), t.external != null && (e.external = !!t.external), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.page = "", o.label = "", o.icon = "", o.pageScriptHash = "", o.help = "", o.disabled = !1, o.external = !1), t.page != null && t.hasOwnProperty("page") && (o.page = t.page), t.label != null && t.hasOwnProperty("label") && (o.label = t.label), t.icon != null && t.hasOwnProperty("icon") && (o.icon = t.icon), t.pageScriptHash != null && t.hasOwnProperty("pageScriptHash") && (o.pageScriptHash = t.pageScriptHash), t.help != null && t.hasOwnProperty("help") && (o.help = t.help), t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && (o.useContainerWidth = t.useContainerWidth, e.oneofs && (o._useContainerWidth = "useContainerWidth")), t.disabled != null && t.hasOwnProperty("disabled") && (o.disabled = t.disabled), t.external != null && t.hasOwnProperty("external") && (o.external = t.external), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/PageLink";
  }, r;
})();
$root.PlotlyChart = (() => {
  function r(n) {
    if (this.selectionMode = [], n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.useContainerWidth = !1, r.prototype.theme = "", r.prototype.id = "", r.prototype.selectionMode = $util.emptyArray, r.prototype.formId = "", r.prototype.spec = "", r.prototype.config = "", r.prototype.url = null, r.prototype.figure = null;
  let c;
  return Object.defineProperty(r.prototype, "chart", {
    get: $util.oneOfGetter(c = ["url", "figure"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    if (e || (e = $Writer.create()), t.url != null && Object.hasOwnProperty.call(t, "url") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.url), t.figure != null && Object.hasOwnProperty.call(t, "figure") && $root.Figure.encode(t.figure, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), t.useContainerWidth != null && Object.hasOwnProperty.call(t, "useContainerWidth") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(t.useContainerWidth), t.theme != null && Object.hasOwnProperty.call(t, "theme") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.theme), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(t.id), t.selectionMode != null && t.selectionMode.length) {
      e.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork();
      for (let o = 0; o < t.selectionMode.length; ++o)
        e.int32(t.selectionMode[o]);
      e.ldelim();
    }
    return t.formId != null && Object.hasOwnProperty.call(t, "formId") && e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(t.formId), t.spec != null && Object.hasOwnProperty.call(t, "spec") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(t.spec), t.config != null && Object.hasOwnProperty.call(t, "config") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(t.config), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.PlotlyChart();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 5: {
          h.useContainerWidth = t.bool();
          break;
        }
        case 6: {
          h.theme = t.string();
          break;
        }
        case 7: {
          h.id = t.string();
          break;
        }
        case 8: {
          if (h.selectionMode && h.selectionMode.length || (h.selectionMode = []), (y & 7) === 2) {
            let b = t.uint32() + t.pos;
            for (; t.pos < b; )
              h.selectionMode.push(t.int32());
          } else
            h.selectionMode.push(t.int32());
          break;
        }
        case 9: {
          h.formId = t.string();
          break;
        }
        case 10: {
          h.spec = t.string();
          break;
        }
        case 11: {
          h.config = t.string();
          break;
        }
        case 1: {
          h.url = t.string();
          break;
        }
        case 2: {
          h.figure = $root.Figure.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    let e = {};
    if (t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && typeof t.useContainerWidth != "boolean")
      return "useContainerWidth: boolean expected";
    if (t.theme != null && t.hasOwnProperty("theme") && !$util.isString(t.theme))
      return "theme: string expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.selectionMode != null && t.hasOwnProperty("selectionMode")) {
      if (!Array.isArray(t.selectionMode))
        return "selectionMode: array expected";
      for (let o = 0; o < t.selectionMode.length; ++o)
        switch (t.selectionMode[o]) {
          default:
            return "selectionMode: enum value[] expected";
          case 0:
          case 1:
          case 2:
            break;
        }
    }
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId))
      return "formId: string expected";
    if (t.spec != null && t.hasOwnProperty("spec") && !$util.isString(t.spec))
      return "spec: string expected";
    if (t.config != null && t.hasOwnProperty("config") && !$util.isString(t.config))
      return "config: string expected";
    if (t.url != null && t.hasOwnProperty("url") && (e.chart = 1, !$util.isString(t.url)))
      return "url: string expected";
    if (t.figure != null && t.hasOwnProperty("figure")) {
      if (e.chart === 1)
        return "chart: multiple values";
      e.chart = 1;
      {
        let o = $root.Figure.verify(t.figure);
        if (o)
          return "figure." + o;
      }
    }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.PlotlyChart)
      return t;
    let e = new $root.PlotlyChart();
    if (t.useContainerWidth != null && (e.useContainerWidth = !!t.useContainerWidth), t.theme != null && (e.theme = String(t.theme)), t.id != null && (e.id = String(t.id)), t.selectionMode) {
      if (!Array.isArray(t.selectionMode))
        throw TypeError(".PlotlyChart.selectionMode: array expected");
      e.selectionMode = [];
      for (let o = 0; o < t.selectionMode.length; ++o)
        switch (t.selectionMode[o]) {
          default:
            if (typeof t.selectionMode[o] == "number") {
              e.selectionMode[o] = t.selectionMode[o];
              break;
            }
          case "POINTS":
          case 0:
            e.selectionMode[o] = 0;
            break;
          case "BOX":
          case 1:
            e.selectionMode[o] = 1;
            break;
          case "LASSO":
          case 2:
            e.selectionMode[o] = 2;
            break;
        }
    }
    if (t.formId != null && (e.formId = String(t.formId)), t.spec != null && (e.spec = String(t.spec)), t.config != null && (e.config = String(t.config)), t.url != null && (e.url = String(t.url)), t.figure != null) {
      if (typeof t.figure != "object")
        throw TypeError(".PlotlyChart.figure: object expected");
      e.figure = $root.Figure.fromObject(t.figure);
    }
    return e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    if ((e.arrays || e.defaults) && (o.selectionMode = []), e.defaults && (o.useContainerWidth = !1, o.theme = "", o.id = "", o.formId = "", o.spec = "", o.config = ""), t.url != null && t.hasOwnProperty("url") && (o.url = t.url, e.oneofs && (o.chart = "url")), t.figure != null && t.hasOwnProperty("figure") && (o.figure = $root.Figure.toObject(t.figure, e), e.oneofs && (o.chart = "figure")), t.useContainerWidth != null && t.hasOwnProperty("useContainerWidth") && (o.useContainerWidth = t.useContainerWidth), t.theme != null && t.hasOwnProperty("theme") && (o.theme = t.theme), t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.selectionMode && t.selectionMode.length) {
      o.selectionMode = [];
      for (let p = 0; p < t.selectionMode.length; ++p)
        o.selectionMode[p] = e.enums === String ? $root.PlotlyChart.SelectionMode[t.selectionMode[p]] === void 0 ? t.selectionMode[p] : $root.PlotlyChart.SelectionMode[t.selectionMode[p]] : t.selectionMode[p];
    }
    return t.formId != null && t.hasOwnProperty("formId") && (o.formId = t.formId), t.spec != null && t.hasOwnProperty("spec") && (o.spec = t.spec), t.config != null && t.hasOwnProperty("config") && (o.config = t.config), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/PlotlyChart";
  }, r.SelectionMode = (function() {
    const n = {}, t = Object.create(n);
    return t[n[0] = "POINTS"] = 0, t[n[1] = "BOX"] = 1, t[n[2] = "LASSO"] = 2, t;
  })(), r;
})();
$root.Figure = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.spec = "", r.prototype.config = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.spec != null && Object.hasOwnProperty.call(n, "spec") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.spec), n.config != null && Object.hasOwnProperty.call(n, "config") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.config), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Figure();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.spec = n.string();
          break;
        }
        case 2: {
          p.config = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.spec != null && n.hasOwnProperty("spec") && !$util.isString(n.spec) ? "spec: string expected" : n.config != null && n.hasOwnProperty("config") && !$util.isString(n.config) ? "config: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Figure)
      return n;
    let t = new $root.Figure();
    return n.spec != null && (t.spec = String(n.spec)), n.config != null && (t.config = String(n.config)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.spec = "", e.config = ""), n.spec != null && n.hasOwnProperty("spec") && (e.spec = n.spec), n.config != null && n.hasOwnProperty("config") && (e.config = n.config), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Figure";
  }, r;
})();
$root.Progress = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.value = 0, r.prototype.text = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.value != null && Object.hasOwnProperty.call(n, "value") && t.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(n.value), n.text != null && Object.hasOwnProperty.call(n, "text") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.text), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Progress();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.value = n.uint32();
          break;
        }
        case 2: {
          p.text = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.value != null && n.hasOwnProperty("value") && !$util.isInteger(n.value) ? "value: integer expected" : n.text != null && n.hasOwnProperty("text") && !$util.isString(n.text) ? "text: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Progress)
      return n;
    let t = new $root.Progress();
    return n.value != null && (t.value = n.value >>> 0), n.text != null && (t.text = String(n.text)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.value = 0, e.text = ""), n.value != null && n.hasOwnProperty("value") && (e.value = n.value), n.text != null && n.hasOwnProperty("text") && (e.text = n.text), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Progress";
  }, r;
})();
$root.Snow = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.show = !1, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.show != null && Object.hasOwnProperty.call(n, "show") && t.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(n.show), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Snow();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.show = n.bool();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.show != null && n.hasOwnProperty("show") && typeof n.show != "boolean" ? "show: boolean expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Snow)
      return n;
    let t = new $root.Snow();
    return n.show != null && (t.show = !!n.show), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.show = !1), n.show != null && n.hasOwnProperty("show") && (e.show = n.show), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Snow";
  }, r;
})();
$root.Spinner = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.text = "", r.prototype.cache = !1, r.prototype.showTime = !1, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.text != null && Object.hasOwnProperty.call(n, "text") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.text), n.cache != null && Object.hasOwnProperty.call(n, "cache") && t.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(n.cache), n.showTime != null && Object.hasOwnProperty.call(n, "showTime") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(n.showTime), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Spinner();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.text = n.string();
          break;
        }
        case 2: {
          p.cache = n.bool();
          break;
        }
        case 3: {
          p.showTime = n.bool();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.text != null && n.hasOwnProperty("text") && !$util.isString(n.text) ? "text: string expected" : n.cache != null && n.hasOwnProperty("cache") && typeof n.cache != "boolean" ? "cache: boolean expected" : n.showTime != null && n.hasOwnProperty("showTime") && typeof n.showTime != "boolean" ? "showTime: boolean expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Spinner)
      return n;
    let t = new $root.Spinner();
    return n.text != null && (t.text = String(n.text)), n.cache != null && (t.cache = !!n.cache), n.showTime != null && (t.showTime = !!n.showTime), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.text = "", e.cache = !1, e.showTime = !1), n.text != null && n.hasOwnProperty("text") && (e.text = n.text), n.cache != null && n.hasOwnProperty("cache") && (e.cache = n.cache), n.showTime != null && n.hasOwnProperty("showTime") && (e.showTime = n.showTime), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Spinner";
  }, r;
})();
$root.Radio = (() => {
  function r(n) {
    if (this.options = [], this.captions = [], n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.id = "", r.prototype.label = "", r.prototype.default = null, r.prototype.options = $util.emptyArray, r.prototype.help = "", r.prototype.formId = "", r.prototype.value = null, r.prototype.setValue = !1, r.prototype.disabled = !1, r.prototype.horizontal = !1, r.prototype.labelVisibility = null, r.prototype.captions = $util.emptyArray;
  let c;
  return Object.defineProperty(r.prototype, "_default", {
    get: $util.oneOfGetter(c = ["default"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_value", {
    get: $util.oneOfGetter(c = ["value"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    if (e || (e = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.default != null && Object.hasOwnProperty.call(t, "default") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(t.default), t.options != null && t.options.length)
      for (let o = 0; o < t.options.length; ++o)
        e.uint32(
          /* id 4, wireType 2 =*/
          34
        ).string(t.options[o]);
    if (t.help != null && Object.hasOwnProperty.call(t, "help") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.help), t.formId != null && Object.hasOwnProperty.call(t, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.formId), t.value != null && Object.hasOwnProperty.call(t, "value") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(t.value), t.setValue != null && Object.hasOwnProperty.call(t, "setValue") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.setValue), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(t.disabled), t.horizontal != null && Object.hasOwnProperty.call(t, "horizontal") && e.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(t.horizontal), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).fork()).ldelim(), t.captions != null && t.captions.length)
      for (let o = 0; o < t.captions.length; ++o)
        e.uint32(
          /* id 12, wireType 2 =*/
          98
        ).string(t.captions[o]);
    return e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.Radio();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.id = t.string();
          break;
        }
        case 2: {
          h.label = t.string();
          break;
        }
        case 3: {
          h.default = t.int32();
          break;
        }
        case 4: {
          h.options && h.options.length || (h.options = []), h.options.push(t.string());
          break;
        }
        case 5: {
          h.help = t.string();
          break;
        }
        case 6: {
          h.formId = t.string();
          break;
        }
        case 7: {
          h.value = t.int32();
          break;
        }
        case 8: {
          h.setValue = t.bool();
          break;
        }
        case 9: {
          h.disabled = t.bool();
          break;
        }
        case 10: {
          h.horizontal = t.bool();
          break;
        }
        case 11: {
          h.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        case 12: {
          h.captions && h.captions.length || (h.captions = []), h.captions.push(t.string());
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label))
      return "label: string expected";
    if (t.default != null && t.hasOwnProperty("default") && !$util.isInteger(t.default))
      return "default: integer expected";
    if (t.options != null && t.hasOwnProperty("options")) {
      if (!Array.isArray(t.options))
        return "options: array expected";
      for (let e = 0; e < t.options.length; ++e)
        if (!$util.isString(t.options[e]))
          return "options: string[] expected";
    }
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help))
      return "help: string expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId))
      return "formId: string expected";
    if (t.value != null && t.hasOwnProperty("value") && !$util.isInteger(t.value))
      return "value: integer expected";
    if (t.setValue != null && t.hasOwnProperty("setValue") && typeof t.setValue != "boolean")
      return "setValue: boolean expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean")
      return "disabled: boolean expected";
    if (t.horizontal != null && t.hasOwnProperty("horizontal") && typeof t.horizontal != "boolean")
      return "horizontal: boolean expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let e = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (e)
        return "labelVisibility." + e;
    }
    if (t.captions != null && t.hasOwnProperty("captions")) {
      if (!Array.isArray(t.captions))
        return "captions: array expected";
      for (let e = 0; e < t.captions.length; ++e)
        if (!$util.isString(t.captions[e]))
          return "captions: string[] expected";
    }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.Radio)
      return t;
    let e = new $root.Radio();
    if (t.id != null && (e.id = String(t.id)), t.label != null && (e.label = String(t.label)), t.default != null && (e.default = t.default | 0), t.options) {
      if (!Array.isArray(t.options))
        throw TypeError(".Radio.options: array expected");
      e.options = [];
      for (let o = 0; o < t.options.length; ++o)
        e.options[o] = String(t.options[o]);
    }
    if (t.help != null && (e.help = String(t.help)), t.formId != null && (e.formId = String(t.formId)), t.value != null && (e.value = t.value | 0), t.setValue != null && (e.setValue = !!t.setValue), t.disabled != null && (e.disabled = !!t.disabled), t.horizontal != null && (e.horizontal = !!t.horizontal), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object")
        throw TypeError(".Radio.labelVisibility: object expected");
      e.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    if (t.captions) {
      if (!Array.isArray(t.captions))
        throw TypeError(".Radio.captions: array expected");
      e.captions = [];
      for (let o = 0; o < t.captions.length; ++o)
        e.captions[o] = String(t.captions[o]);
    }
    return e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    if ((e.arrays || e.defaults) && (o.options = [], o.captions = []), e.defaults && (o.id = "", o.label = "", o.help = "", o.formId = "", o.setValue = !1, o.disabled = !1, o.horizontal = !1, o.labelVisibility = null), t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.label != null && t.hasOwnProperty("label") && (o.label = t.label), t.default != null && t.hasOwnProperty("default") && (o.default = t.default, e.oneofs && (o._default = "default")), t.options && t.options.length) {
      o.options = [];
      for (let p = 0; p < t.options.length; ++p)
        o.options[p] = t.options[p];
    }
    if (t.help != null && t.hasOwnProperty("help") && (o.help = t.help), t.formId != null && t.hasOwnProperty("formId") && (o.formId = t.formId), t.value != null && t.hasOwnProperty("value") && (o.value = t.value, e.oneofs && (o._value = "value")), t.setValue != null && t.hasOwnProperty("setValue") && (o.setValue = t.setValue), t.disabled != null && t.hasOwnProperty("disabled") && (o.disabled = t.disabled), t.horizontal != null && t.hasOwnProperty("horizontal") && (o.horizontal = t.horizontal), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (o.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, e)), t.captions && t.captions.length) {
      o.captions = [];
      for (let p = 0; p < t.captions.length; ++p)
        o.captions[p] = t.captions[p];
    }
    return o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Radio";
  }, r;
})();
$root.Selectbox = (() => {
  function r(n) {
    if (this.options = [], n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.id = "", r.prototype.label = "", r.prototype.default = null, r.prototype.options = $util.emptyArray, r.prototype.help = "", r.prototype.formId = "", r.prototype.value = null, r.prototype.rawValue = null, r.prototype.setValue = !1, r.prototype.disabled = !1, r.prototype.labelVisibility = null, r.prototype.placeholder = "", r.prototype.acceptNewOptions = null;
  let c;
  return Object.defineProperty(r.prototype, "_default", {
    get: $util.oneOfGetter(c = ["default"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_value", {
    get: $util.oneOfGetter(c = ["value"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_rawValue", {
    get: $util.oneOfGetter(c = ["rawValue"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_acceptNewOptions", {
    get: $util.oneOfGetter(c = ["acceptNewOptions"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    if (e || (e = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.default != null && Object.hasOwnProperty.call(t, "default") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(t.default), t.options != null && t.options.length)
      for (let o = 0; o < t.options.length; ++o)
        e.uint32(
          /* id 4, wireType 2 =*/
          34
        ).string(t.options[o]);
    return t.help != null && Object.hasOwnProperty.call(t, "help") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.help), t.formId != null && Object.hasOwnProperty.call(t, "formId") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.formId), t.value != null && Object.hasOwnProperty.call(t, "value") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).int32(t.value), t.setValue != null && Object.hasOwnProperty.call(t, "setValue") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.setValue), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(t.disabled), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), t.placeholder != null && Object.hasOwnProperty.call(t, "placeholder") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(t.placeholder), t.acceptNewOptions != null && Object.hasOwnProperty.call(t, "acceptNewOptions") && e.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(t.acceptNewOptions), t.rawValue != null && Object.hasOwnProperty.call(t, "rawValue") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(t.rawValue), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.Selectbox();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.id = t.string();
          break;
        }
        case 2: {
          h.label = t.string();
          break;
        }
        case 3: {
          h.default = t.int32();
          break;
        }
        case 4: {
          h.options && h.options.length || (h.options = []), h.options.push(t.string());
          break;
        }
        case 5: {
          h.help = t.string();
          break;
        }
        case 6: {
          h.formId = t.string();
          break;
        }
        case 7: {
          h.value = t.int32();
          break;
        }
        case 13: {
          h.rawValue = t.string();
          break;
        }
        case 8: {
          h.setValue = t.bool();
          break;
        }
        case 9: {
          h.disabled = t.bool();
          break;
        }
        case 10: {
          h.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        case 11: {
          h.placeholder = t.string();
          break;
        }
        case 12: {
          h.acceptNewOptions = t.bool();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label))
      return "label: string expected";
    if (t.default != null && t.hasOwnProperty("default") && !$util.isInteger(t.default))
      return "default: integer expected";
    if (t.options != null && t.hasOwnProperty("options")) {
      if (!Array.isArray(t.options))
        return "options: array expected";
      for (let e = 0; e < t.options.length; ++e)
        if (!$util.isString(t.options[e]))
          return "options: string[] expected";
    }
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help))
      return "help: string expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId))
      return "formId: string expected";
    if (t.value != null && t.hasOwnProperty("value") && !$util.isInteger(t.value))
      return "value: integer expected";
    if (t.rawValue != null && t.hasOwnProperty("rawValue") && !$util.isString(t.rawValue))
      return "rawValue: string expected";
    if (t.setValue != null && t.hasOwnProperty("setValue") && typeof t.setValue != "boolean")
      return "setValue: boolean expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean")
      return "disabled: boolean expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let e = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (e)
        return "labelVisibility." + e;
    }
    return t.placeholder != null && t.hasOwnProperty("placeholder") && !$util.isString(t.placeholder) ? "placeholder: string expected" : t.acceptNewOptions != null && t.hasOwnProperty("acceptNewOptions") && typeof t.acceptNewOptions != "boolean" ? "acceptNewOptions: boolean expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.Selectbox)
      return t;
    let e = new $root.Selectbox();
    if (t.id != null && (e.id = String(t.id)), t.label != null && (e.label = String(t.label)), t.default != null && (e.default = t.default | 0), t.options) {
      if (!Array.isArray(t.options))
        throw TypeError(".Selectbox.options: array expected");
      e.options = [];
      for (let o = 0; o < t.options.length; ++o)
        e.options[o] = String(t.options[o]);
    }
    if (t.help != null && (e.help = String(t.help)), t.formId != null && (e.formId = String(t.formId)), t.value != null && (e.value = t.value | 0), t.rawValue != null && (e.rawValue = String(t.rawValue)), t.setValue != null && (e.setValue = !!t.setValue), t.disabled != null && (e.disabled = !!t.disabled), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object")
        throw TypeError(".Selectbox.labelVisibility: object expected");
      e.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    return t.placeholder != null && (e.placeholder = String(t.placeholder)), t.acceptNewOptions != null && (e.acceptNewOptions = !!t.acceptNewOptions), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    if ((e.arrays || e.defaults) && (o.options = []), e.defaults && (o.id = "", o.label = "", o.help = "", o.formId = "", o.setValue = !1, o.disabled = !1, o.labelVisibility = null, o.placeholder = ""), t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.label != null && t.hasOwnProperty("label") && (o.label = t.label), t.default != null && t.hasOwnProperty("default") && (o.default = t.default, e.oneofs && (o._default = "default")), t.options && t.options.length) {
      o.options = [];
      for (let p = 0; p < t.options.length; ++p)
        o.options[p] = t.options[p];
    }
    return t.help != null && t.hasOwnProperty("help") && (o.help = t.help), t.formId != null && t.hasOwnProperty("formId") && (o.formId = t.formId), t.value != null && t.hasOwnProperty("value") && (o.value = t.value, e.oneofs && (o._value = "value")), t.setValue != null && t.hasOwnProperty("setValue") && (o.setValue = t.setValue), t.disabled != null && t.hasOwnProperty("disabled") && (o.disabled = t.disabled), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (o.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, e)), t.placeholder != null && t.hasOwnProperty("placeholder") && (o.placeholder = t.placeholder), t.acceptNewOptions != null && t.hasOwnProperty("acceptNewOptions") && (o.acceptNewOptions = t.acceptNewOptions, e.oneofs && (o._acceptNewOptions = "acceptNewOptions")), t.rawValue != null && t.hasOwnProperty("rawValue") && (o.rawValue = t.rawValue, e.oneofs && (o._rawValue = "rawValue")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Selectbox";
  }, r;
})();
$root.Skeleton = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.style = 0, r.prototype.height = null;
  let c;
  return Object.defineProperty(r.prototype, "_height", {
    get: $util.oneOfGetter(c = ["height"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.style != null && Object.hasOwnProperty.call(t, "style") && e.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(t.style), t.height != null && Object.hasOwnProperty.call(t, "height") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(t.height), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.Skeleton();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.style = t.int32();
          break;
        }
        case 2: {
          h.height = t.int32();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.style != null && t.hasOwnProperty("style"))
      switch (t.style) {
        default:
          return "style: enum value expected";
        case 0:
        case 1:
          break;
      }
    return t.height != null && t.hasOwnProperty("height") && !$util.isInteger(t.height) ? "height: integer expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.Skeleton)
      return t;
    let e = new $root.Skeleton();
    switch (t.style) {
      default:
        if (typeof t.style == "number") {
          e.style = t.style;
          break;
        }
        break;
      case "ELEMENT":
      case 0:
        e.style = 0;
        break;
      case "APP":
      case 1:
        e.style = 1;
        break;
    }
    return t.height != null && (e.height = t.height | 0), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.style = e.enums === String ? "ELEMENT" : 0), t.style != null && t.hasOwnProperty("style") && (o.style = e.enums === String ? $root.Skeleton.SkeletonStyle[t.style] === void 0 ? t.style : $root.Skeleton.SkeletonStyle[t.style] : t.style), t.height != null && t.hasOwnProperty("height") && (o.height = t.height, e.oneofs && (o._height = "height")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Skeleton";
  }, r.SkeletonStyle = (function() {
    const n = {}, t = Object.create(n);
    return t[n[0] = "ELEMENT"] = 0, t[n[1] = "APP"] = 1, t;
  })(), r;
})();
$root.Slider = (() => {
  function r(c) {
    if (this.default = [], this.value = [], this.options = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.id = "", r.prototype.formId = "", r.prototype.label = "", r.prototype.format = "", r.prototype.dataType = 0, r.prototype.default = $util.emptyArray, r.prototype.min = 0, r.prototype.max = 0, r.prototype.step = 0, r.prototype.value = $util.emptyArray, r.prototype.setValue = !1, r.prototype.options = $util.emptyArray, r.prototype.help = "", r.prototype.disabled = !1, r.prototype.labelVisibility = null, r.prototype.type = 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.id != null && Object.hasOwnProperty.call(n, "id") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.id), n.formId != null && Object.hasOwnProperty.call(n, "formId") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.formId), n.label != null && Object.hasOwnProperty.call(n, "label") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.label), n.format != null && Object.hasOwnProperty.call(n, "format") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.format), n.dataType != null && Object.hasOwnProperty.call(n, "dataType") && t.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(n.dataType), n.default != null && n.default.length) {
      t.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork();
      for (let e = 0; e < n.default.length; ++e)
        t.double(n.default[e]);
      t.ldelim();
    }
    if (n.min != null && Object.hasOwnProperty.call(n, "min") && t.uint32(
      /* id 7, wireType 1 =*/
      57
    ).double(n.min), n.max != null && Object.hasOwnProperty.call(n, "max") && t.uint32(
      /* id 8, wireType 1 =*/
      65
    ).double(n.max), n.step != null && Object.hasOwnProperty.call(n, "step") && t.uint32(
      /* id 9, wireType 1 =*/
      73
    ).double(n.step), n.value != null && n.value.length) {
      t.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork();
      for (let e = 0; e < n.value.length; ++e)
        t.double(n.value[e]);
      t.ldelim();
    }
    if (n.setValue != null && Object.hasOwnProperty.call(n, "setValue") && t.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(n.setValue), n.options != null && n.options.length)
      for (let e = 0; e < n.options.length; ++e)
        t.uint32(
          /* id 13, wireType 2 =*/
          106
        ).string(n.options[e]);
    return n.help != null && Object.hasOwnProperty.call(n, "help") && t.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(n.help), n.disabled != null && Object.hasOwnProperty.call(n, "disabled") && t.uint32(
      /* id 15, wireType 0 =*/
      120
    ).bool(n.disabled), n.labelVisibility != null && Object.hasOwnProperty.call(n, "labelVisibility") && $root.LabelVisibilityMessage.encode(n.labelVisibility, t.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), n.type != null && Object.hasOwnProperty.call(n, "type") && t.uint32(
      /* id 17, wireType 0 =*/
      136
    ).int32(n.type), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Slider();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.id = n.string();
          break;
        }
        case 2: {
          p.formId = n.string();
          break;
        }
        case 3: {
          p.label = n.string();
          break;
        }
        case 4: {
          p.format = n.string();
          break;
        }
        case 5: {
          p.dataType = n.int32();
          break;
        }
        case 6: {
          if (p.default && p.default.length || (p.default = []), (h & 7) === 2) {
            let y = n.uint32() + n.pos;
            for (; n.pos < y; )
              p.default.push(n.double());
          } else
            p.default.push(n.double());
          break;
        }
        case 7: {
          p.min = n.double();
          break;
        }
        case 8: {
          p.max = n.double();
          break;
        }
        case 9: {
          p.step = n.double();
          break;
        }
        case 10: {
          if (p.value && p.value.length || (p.value = []), (h & 7) === 2) {
            let y = n.uint32() + n.pos;
            for (; n.pos < y; )
              p.value.push(n.double());
          } else
            p.value.push(n.double());
          break;
        }
        case 11: {
          p.setValue = n.bool();
          break;
        }
        case 13: {
          p.options && p.options.length || (p.options = []), p.options.push(n.string());
          break;
        }
        case 14: {
          p.help = n.string();
          break;
        }
        case 15: {
          p.disabled = n.bool();
          break;
        }
        case 16: {
          p.labelVisibility = $root.LabelVisibilityMessage.decode(n, n.uint32());
          break;
        }
        case 17: {
          p.type = n.int32();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.id != null && n.hasOwnProperty("id") && !$util.isString(n.id))
      return "id: string expected";
    if (n.formId != null && n.hasOwnProperty("formId") && !$util.isString(n.formId))
      return "formId: string expected";
    if (n.label != null && n.hasOwnProperty("label") && !$util.isString(n.label))
      return "label: string expected";
    if (n.format != null && n.hasOwnProperty("format") && !$util.isString(n.format))
      return "format: string expected";
    if (n.dataType != null && n.hasOwnProperty("dataType"))
      switch (n.dataType) {
        default:
          return "dataType: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
          break;
      }
    if (n.default != null && n.hasOwnProperty("default")) {
      if (!Array.isArray(n.default))
        return "default: array expected";
      for (let t = 0; t < n.default.length; ++t)
        if (typeof n.default[t] != "number")
          return "default: number[] expected";
    }
    if (n.min != null && n.hasOwnProperty("min") && typeof n.min != "number")
      return "min: number expected";
    if (n.max != null && n.hasOwnProperty("max") && typeof n.max != "number")
      return "max: number expected";
    if (n.step != null && n.hasOwnProperty("step") && typeof n.step != "number")
      return "step: number expected";
    if (n.value != null && n.hasOwnProperty("value")) {
      if (!Array.isArray(n.value))
        return "value: array expected";
      for (let t = 0; t < n.value.length; ++t)
        if (typeof n.value[t] != "number")
          return "value: number[] expected";
    }
    if (n.setValue != null && n.hasOwnProperty("setValue") && typeof n.setValue != "boolean")
      return "setValue: boolean expected";
    if (n.options != null && n.hasOwnProperty("options")) {
      if (!Array.isArray(n.options))
        return "options: array expected";
      for (let t = 0; t < n.options.length; ++t)
        if (!$util.isString(n.options[t]))
          return "options: string[] expected";
    }
    if (n.help != null && n.hasOwnProperty("help") && !$util.isString(n.help))
      return "help: string expected";
    if (n.disabled != null && n.hasOwnProperty("disabled") && typeof n.disabled != "boolean")
      return "disabled: boolean expected";
    if (n.labelVisibility != null && n.hasOwnProperty("labelVisibility")) {
      let t = $root.LabelVisibilityMessage.verify(n.labelVisibility);
      if (t)
        return "labelVisibility." + t;
    }
    if (n.type != null && n.hasOwnProperty("type"))
      switch (n.type) {
        default:
          return "type: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Slider)
      return n;
    let t = new $root.Slider();
    switch (n.id != null && (t.id = String(n.id)), n.formId != null && (t.formId = String(n.formId)), n.label != null && (t.label = String(n.label)), n.format != null && (t.format = String(n.format)), n.dataType) {
      default:
        if (typeof n.dataType == "number") {
          t.dataType = n.dataType;
          break;
        }
        break;
      case "INT":
      case 0:
        t.dataType = 0;
        break;
      case "FLOAT":
      case 1:
        t.dataType = 1;
        break;
      case "DATETIME":
      case 2:
        t.dataType = 2;
        break;
      case "DATE":
      case 3:
        t.dataType = 3;
        break;
      case "TIME":
      case 4:
        t.dataType = 4;
        break;
    }
    if (n.default) {
      if (!Array.isArray(n.default))
        throw TypeError(".Slider.default: array expected");
      t.default = [];
      for (let e = 0; e < n.default.length; ++e)
        t.default[e] = Number(n.default[e]);
    }
    if (n.min != null && (t.min = Number(n.min)), n.max != null && (t.max = Number(n.max)), n.step != null && (t.step = Number(n.step)), n.value) {
      if (!Array.isArray(n.value))
        throw TypeError(".Slider.value: array expected");
      t.value = [];
      for (let e = 0; e < n.value.length; ++e)
        t.value[e] = Number(n.value[e]);
    }
    if (n.setValue != null && (t.setValue = !!n.setValue), n.options) {
      if (!Array.isArray(n.options))
        throw TypeError(".Slider.options: array expected");
      t.options = [];
      for (let e = 0; e < n.options.length; ++e)
        t.options[e] = String(n.options[e]);
    }
    if (n.help != null && (t.help = String(n.help)), n.disabled != null && (t.disabled = !!n.disabled), n.labelVisibility != null) {
      if (typeof n.labelVisibility != "object")
        throw TypeError(".Slider.labelVisibility: object expected");
      t.labelVisibility = $root.LabelVisibilityMessage.fromObject(n.labelVisibility);
    }
    switch (n.type) {
      default:
        if (typeof n.type == "number") {
          t.type = n.type;
          break;
        }
        break;
      case "UNSPECIFIED":
      case 0:
        t.type = 0;
        break;
      case "SLIDER":
      case 1:
        t.type = 1;
        break;
      case "SELECT_SLIDER":
      case 2:
        t.type = 2;
        break;
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.default = [], e.value = [], e.options = []), t.defaults && (e.id = "", e.formId = "", e.label = "", e.format = "", e.dataType = t.enums === String ? "INT" : 0, e.min = 0, e.max = 0, e.step = 0, e.setValue = !1, e.help = "", e.disabled = !1, e.labelVisibility = null, e.type = t.enums === String ? "UNSPECIFIED" : 0), n.id != null && n.hasOwnProperty("id") && (e.id = n.id), n.formId != null && n.hasOwnProperty("formId") && (e.formId = n.formId), n.label != null && n.hasOwnProperty("label") && (e.label = n.label), n.format != null && n.hasOwnProperty("format") && (e.format = n.format), n.dataType != null && n.hasOwnProperty("dataType") && (e.dataType = t.enums === String ? $root.Slider.DataType[n.dataType] === void 0 ? n.dataType : $root.Slider.DataType[n.dataType] : n.dataType), n.default && n.default.length) {
      e.default = [];
      for (let o = 0; o < n.default.length; ++o)
        e.default[o] = t.json && !isFinite(n.default[o]) ? String(n.default[o]) : n.default[o];
    }
    if (n.min != null && n.hasOwnProperty("min") && (e.min = t.json && !isFinite(n.min) ? String(n.min) : n.min), n.max != null && n.hasOwnProperty("max") && (e.max = t.json && !isFinite(n.max) ? String(n.max) : n.max), n.step != null && n.hasOwnProperty("step") && (e.step = t.json && !isFinite(n.step) ? String(n.step) : n.step), n.value && n.value.length) {
      e.value = [];
      for (let o = 0; o < n.value.length; ++o)
        e.value[o] = t.json && !isFinite(n.value[o]) ? String(n.value[o]) : n.value[o];
    }
    if (n.setValue != null && n.hasOwnProperty("setValue") && (e.setValue = n.setValue), n.options && n.options.length) {
      e.options = [];
      for (let o = 0; o < n.options.length; ++o)
        e.options[o] = n.options[o];
    }
    return n.help != null && n.hasOwnProperty("help") && (e.help = n.help), n.disabled != null && n.hasOwnProperty("disabled") && (e.disabled = n.disabled), n.labelVisibility != null && n.hasOwnProperty("labelVisibility") && (e.labelVisibility = $root.LabelVisibilityMessage.toObject(n.labelVisibility, t)), n.type != null && n.hasOwnProperty("type") && (e.type = t.enums === String ? $root.Slider.Type[n.type] === void 0 ? n.type : $root.Slider.Type[n.type] : n.type), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Slider";
  }, r.DataType = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "INT"] = 0, n[c[1] = "FLOAT"] = 1, n[c[2] = "DATETIME"] = 2, n[c[3] = "DATE"] = 3, n[c[4] = "TIME"] = 4, n;
  })(), r.Type = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "UNSPECIFIED"] = 0, n[c[1] = "SLIDER"] = 1, n[c[2] = "SELECT_SLIDER"] = 2, n;
  })(), r;
})();
$root.Text = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.body = "", r.prototype.help = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.body != null && Object.hasOwnProperty.call(n, "body") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.body), n.help != null && Object.hasOwnProperty.call(n, "help") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.help), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Text();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.body = n.string();
          break;
        }
        case 2: {
          p.help = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.body != null && n.hasOwnProperty("body") && !$util.isString(n.body) ? "body: string expected" : n.help != null && n.hasOwnProperty("help") && !$util.isString(n.help) ? "help: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Text)
      return n;
    let t = new $root.Text();
    return n.body != null && (t.body = String(n.body)), n.help != null && (t.help = String(n.help)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.body = "", e.help = ""), n.body != null && n.hasOwnProperty("body") && (e.body = n.body), n.help != null && n.hasOwnProperty("help") && (e.help = n.help), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Text";
  }, r;
})();
$root.TextArea = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.id = "", r.prototype.label = "", r.prototype.default = null, r.prototype.height = 0, r.prototype.maxChars = 0, r.prototype.help = "", r.prototype.formId = "", r.prototype.value = null, r.prototype.setValue = !1, r.prototype.placeholder = "", r.prototype.disabled = !1, r.prototype.labelVisibility = null;
  let c;
  return Object.defineProperty(r.prototype, "_default", {
    get: $util.oneOfGetter(c = ["default"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_value", {
    get: $util.oneOfGetter(c = ["value"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.default != null && Object.hasOwnProperty.call(t, "default") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.default), t.height != null && Object.hasOwnProperty.call(t, "height") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).uint32(t.height), t.maxChars != null && Object.hasOwnProperty.call(t, "maxChars") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(t.maxChars), t.help != null && Object.hasOwnProperty.call(t, "help") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.help), t.formId != null && Object.hasOwnProperty.call(t, "formId") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(t.formId), t.value != null && Object.hasOwnProperty.call(t, "value") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(t.value), t.setValue != null && Object.hasOwnProperty.call(t, "setValue") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(t.setValue), t.placeholder != null && Object.hasOwnProperty.call(t, "placeholder") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(t.placeholder), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(t.disabled), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.TextArea();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.id = t.string();
          break;
        }
        case 2: {
          h.label = t.string();
          break;
        }
        case 3: {
          h.default = t.string();
          break;
        }
        case 4: {
          h.height = t.uint32();
          break;
        }
        case 5: {
          h.maxChars = t.uint32();
          break;
        }
        case 6: {
          h.help = t.string();
          break;
        }
        case 7: {
          h.formId = t.string();
          break;
        }
        case 8: {
          h.value = t.string();
          break;
        }
        case 9: {
          h.setValue = t.bool();
          break;
        }
        case 10: {
          h.placeholder = t.string();
          break;
        }
        case 11: {
          h.disabled = t.bool();
          break;
        }
        case 12: {
          h.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label))
      return "label: string expected";
    if (t.default != null && t.hasOwnProperty("default") && !$util.isString(t.default))
      return "default: string expected";
    if (t.height != null && t.hasOwnProperty("height") && !$util.isInteger(t.height))
      return "height: integer expected";
    if (t.maxChars != null && t.hasOwnProperty("maxChars") && !$util.isInteger(t.maxChars))
      return "maxChars: integer expected";
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help))
      return "help: string expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId))
      return "formId: string expected";
    if (t.value != null && t.hasOwnProperty("value") && !$util.isString(t.value))
      return "value: string expected";
    if (t.setValue != null && t.hasOwnProperty("setValue") && typeof t.setValue != "boolean")
      return "setValue: boolean expected";
    if (t.placeholder != null && t.hasOwnProperty("placeholder") && !$util.isString(t.placeholder))
      return "placeholder: string expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean")
      return "disabled: boolean expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let e = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (e)
        return "labelVisibility." + e;
    }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.TextArea)
      return t;
    let e = new $root.TextArea();
    if (t.id != null && (e.id = String(t.id)), t.label != null && (e.label = String(t.label)), t.default != null && (e.default = String(t.default)), t.height != null && (e.height = t.height >>> 0), t.maxChars != null && (e.maxChars = t.maxChars >>> 0), t.help != null && (e.help = String(t.help)), t.formId != null && (e.formId = String(t.formId)), t.value != null && (e.value = String(t.value)), t.setValue != null && (e.setValue = !!t.setValue), t.placeholder != null && (e.placeholder = String(t.placeholder)), t.disabled != null && (e.disabled = !!t.disabled), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object")
        throw TypeError(".TextArea.labelVisibility: object expected");
      e.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    return e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.id = "", o.label = "", o.height = 0, o.maxChars = 0, o.help = "", o.formId = "", o.setValue = !1, o.placeholder = "", o.disabled = !1, o.labelVisibility = null), t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.label != null && t.hasOwnProperty("label") && (o.label = t.label), t.default != null && t.hasOwnProperty("default") && (o.default = t.default, e.oneofs && (o._default = "default")), t.height != null && t.hasOwnProperty("height") && (o.height = t.height), t.maxChars != null && t.hasOwnProperty("maxChars") && (o.maxChars = t.maxChars), t.help != null && t.hasOwnProperty("help") && (o.help = t.help), t.formId != null && t.hasOwnProperty("formId") && (o.formId = t.formId), t.value != null && t.hasOwnProperty("value") && (o.value = t.value, e.oneofs && (o._value = "value")), t.setValue != null && t.hasOwnProperty("setValue") && (o.setValue = t.setValue), t.placeholder != null && t.hasOwnProperty("placeholder") && (o.placeholder = t.placeholder), t.disabled != null && t.hasOwnProperty("disabled") && (o.disabled = t.disabled), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (o.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, e)), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/TextArea";
  }, r;
})();
$root.TextInput = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.id = "", r.prototype.label = "", r.prototype.default = null, r.prototype.type = 0, r.prototype.maxChars = 0, r.prototype.help = "", r.prototype.formId = "", r.prototype.value = null, r.prototype.setValue = !1, r.prototype.autocomplete = "", r.prototype.placeholder = "", r.prototype.disabled = !1, r.prototype.labelVisibility = null, r.prototype.icon = "";
  let c;
  return Object.defineProperty(r.prototype, "_default", {
    get: $util.oneOfGetter(c = ["default"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_value", {
    get: $util.oneOfGetter(c = ["value"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.default != null && Object.hasOwnProperty.call(t, "default") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.default), t.type != null && Object.hasOwnProperty.call(t, "type") && e.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(t.type), t.maxChars != null && Object.hasOwnProperty.call(t, "maxChars") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).uint32(t.maxChars), t.help != null && Object.hasOwnProperty.call(t, "help") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.help), t.formId != null && Object.hasOwnProperty.call(t, "formId") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(t.formId), t.value != null && Object.hasOwnProperty.call(t, "value") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(t.value), t.setValue != null && Object.hasOwnProperty.call(t, "setValue") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(t.setValue), t.autocomplete != null && Object.hasOwnProperty.call(t, "autocomplete") && e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(t.autocomplete), t.placeholder != null && Object.hasOwnProperty.call(t, "placeholder") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(t.placeholder), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && e.uint32(
      /* id 12, wireType 0 =*/
      96
    ).bool(t.disabled), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), t.icon != null && Object.hasOwnProperty.call(t, "icon") && e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(t.icon), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.TextInput();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.id = t.string();
          break;
        }
        case 2: {
          h.label = t.string();
          break;
        }
        case 3: {
          h.default = t.string();
          break;
        }
        case 4: {
          h.type = t.int32();
          break;
        }
        case 5: {
          h.maxChars = t.uint32();
          break;
        }
        case 6: {
          h.help = t.string();
          break;
        }
        case 7: {
          h.formId = t.string();
          break;
        }
        case 8: {
          h.value = t.string();
          break;
        }
        case 9: {
          h.setValue = t.bool();
          break;
        }
        case 10: {
          h.autocomplete = t.string();
          break;
        }
        case 11: {
          h.placeholder = t.string();
          break;
        }
        case 12: {
          h.disabled = t.bool();
          break;
        }
        case 13: {
          h.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        case 14: {
          h.icon = t.string();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label))
      return "label: string expected";
    if (t.default != null && t.hasOwnProperty("default") && !$util.isString(t.default))
      return "default: string expected";
    if (t.type != null && t.hasOwnProperty("type"))
      switch (t.type) {
        default:
          return "type: enum value expected";
        case 0:
        case 1:
          break;
      }
    if (t.maxChars != null && t.hasOwnProperty("maxChars") && !$util.isInteger(t.maxChars))
      return "maxChars: integer expected";
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help))
      return "help: string expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId))
      return "formId: string expected";
    if (t.value != null && t.hasOwnProperty("value") && !$util.isString(t.value))
      return "value: string expected";
    if (t.setValue != null && t.hasOwnProperty("setValue") && typeof t.setValue != "boolean")
      return "setValue: boolean expected";
    if (t.autocomplete != null && t.hasOwnProperty("autocomplete") && !$util.isString(t.autocomplete))
      return "autocomplete: string expected";
    if (t.placeholder != null && t.hasOwnProperty("placeholder") && !$util.isString(t.placeholder))
      return "placeholder: string expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean")
      return "disabled: boolean expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let e = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (e)
        return "labelVisibility." + e;
    }
    return t.icon != null && t.hasOwnProperty("icon") && !$util.isString(t.icon) ? "icon: string expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.TextInput)
      return t;
    let e = new $root.TextInput();
    switch (t.id != null && (e.id = String(t.id)), t.label != null && (e.label = String(t.label)), t.default != null && (e.default = String(t.default)), t.type) {
      default:
        if (typeof t.type == "number") {
          e.type = t.type;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        e.type = 0;
        break;
      case "PASSWORD":
      case 1:
        e.type = 1;
        break;
    }
    if (t.maxChars != null && (e.maxChars = t.maxChars >>> 0), t.help != null && (e.help = String(t.help)), t.formId != null && (e.formId = String(t.formId)), t.value != null && (e.value = String(t.value)), t.setValue != null && (e.setValue = !!t.setValue), t.autocomplete != null && (e.autocomplete = String(t.autocomplete)), t.placeholder != null && (e.placeholder = String(t.placeholder)), t.disabled != null && (e.disabled = !!t.disabled), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object")
        throw TypeError(".TextInput.labelVisibility: object expected");
      e.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    return t.icon != null && (e.icon = String(t.icon)), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.id = "", o.label = "", o.type = e.enums === String ? "DEFAULT" : 0, o.maxChars = 0, o.help = "", o.formId = "", o.setValue = !1, o.autocomplete = "", o.placeholder = "", o.disabled = !1, o.labelVisibility = null, o.icon = ""), t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.label != null && t.hasOwnProperty("label") && (o.label = t.label), t.default != null && t.hasOwnProperty("default") && (o.default = t.default, e.oneofs && (o._default = "default")), t.type != null && t.hasOwnProperty("type") && (o.type = e.enums === String ? $root.TextInput.Type[t.type] === void 0 ? t.type : $root.TextInput.Type[t.type] : t.type), t.maxChars != null && t.hasOwnProperty("maxChars") && (o.maxChars = t.maxChars), t.help != null && t.hasOwnProperty("help") && (o.help = t.help), t.formId != null && t.hasOwnProperty("formId") && (o.formId = t.formId), t.value != null && t.hasOwnProperty("value") && (o.value = t.value, e.oneofs && (o._value = "value")), t.setValue != null && t.hasOwnProperty("setValue") && (o.setValue = t.setValue), t.autocomplete != null && t.hasOwnProperty("autocomplete") && (o.autocomplete = t.autocomplete), t.placeholder != null && t.hasOwnProperty("placeholder") && (o.placeholder = t.placeholder), t.disabled != null && t.hasOwnProperty("disabled") && (o.disabled = t.disabled), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (o.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, e)), t.icon != null && t.hasOwnProperty("icon") && (o.icon = t.icon), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/TextInput";
  }, r.Type = (function() {
    const n = {}, t = Object.create(n);
    return t[n[0] = "DEFAULT"] = 0, t[n[1] = "PASSWORD"] = 1, t;
  })(), r;
})();
$root.TimeInput = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.id = "", r.prototype.label = "", r.prototype.default = null, r.prototype.help = "", r.prototype.formId = "", r.prototype.value = null, r.prototype.setValue = !1, r.prototype.disabled = !1, r.prototype.labelVisibility = null, r.prototype.step = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0;
  let c;
  return Object.defineProperty(r.prototype, "_default", {
    get: $util.oneOfGetter(c = ["default"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_value", {
    get: $util.oneOfGetter(c = ["value"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.id), t.label != null && Object.hasOwnProperty.call(t, "label") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.label), t.default != null && Object.hasOwnProperty.call(t, "default") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.default), t.help != null && Object.hasOwnProperty.call(t, "help") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.help), t.formId != null && Object.hasOwnProperty.call(t, "formId") && e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(t.formId), t.value != null && Object.hasOwnProperty.call(t, "value") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.value), t.setValue != null && Object.hasOwnProperty.call(t, "setValue") && e.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(t.setValue), t.disabled != null && Object.hasOwnProperty.call(t, "disabled") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(t.disabled), t.labelVisibility != null && Object.hasOwnProperty.call(t, "labelVisibility") && $root.LabelVisibilityMessage.encode(t.labelVisibility, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), t.step != null && Object.hasOwnProperty.call(t, "step") && e.uint32(
      /* id 10, wireType 0 =*/
      80
    ).int64(t.step), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.TimeInput();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.id = t.string();
          break;
        }
        case 2: {
          h.label = t.string();
          break;
        }
        case 3: {
          h.default = t.string();
          break;
        }
        case 4: {
          h.help = t.string();
          break;
        }
        case 5: {
          h.formId = t.string();
          break;
        }
        case 6: {
          h.value = t.string();
          break;
        }
        case 7: {
          h.setValue = t.bool();
          break;
        }
        case 8: {
          h.disabled = t.bool();
          break;
        }
        case 9: {
          h.labelVisibility = $root.LabelVisibilityMessage.decode(t, t.uint32());
          break;
        }
        case 10: {
          h.step = t.int64();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.label != null && t.hasOwnProperty("label") && !$util.isString(t.label))
      return "label: string expected";
    if (t.default != null && t.hasOwnProperty("default") && !$util.isString(t.default))
      return "default: string expected";
    if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help))
      return "help: string expected";
    if (t.formId != null && t.hasOwnProperty("formId") && !$util.isString(t.formId))
      return "formId: string expected";
    if (t.value != null && t.hasOwnProperty("value") && !$util.isString(t.value))
      return "value: string expected";
    if (t.setValue != null && t.hasOwnProperty("setValue") && typeof t.setValue != "boolean")
      return "setValue: boolean expected";
    if (t.disabled != null && t.hasOwnProperty("disabled") && typeof t.disabled != "boolean")
      return "disabled: boolean expected";
    if (t.labelVisibility != null && t.hasOwnProperty("labelVisibility")) {
      let e = $root.LabelVisibilityMessage.verify(t.labelVisibility);
      if (e)
        return "labelVisibility." + e;
    }
    return t.step != null && t.hasOwnProperty("step") && !$util.isInteger(t.step) && !(t.step && $util.isInteger(t.step.low) && $util.isInteger(t.step.high)) ? "step: integer|Long expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.TimeInput)
      return t;
    let e = new $root.TimeInput();
    if (t.id != null && (e.id = String(t.id)), t.label != null && (e.label = String(t.label)), t.default != null && (e.default = String(t.default)), t.help != null && (e.help = String(t.help)), t.formId != null && (e.formId = String(t.formId)), t.value != null && (e.value = String(t.value)), t.setValue != null && (e.setValue = !!t.setValue), t.disabled != null && (e.disabled = !!t.disabled), t.labelVisibility != null) {
      if (typeof t.labelVisibility != "object")
        throw TypeError(".TimeInput.labelVisibility: object expected");
      e.labelVisibility = $root.LabelVisibilityMessage.fromObject(t.labelVisibility);
    }
    return t.step != null && ($util.Long ? (e.step = $util.Long.fromValue(t.step)).unsigned = !1 : typeof t.step == "string" ? e.step = parseInt(t.step, 10) : typeof t.step == "number" ? e.step = t.step : typeof t.step == "object" && (e.step = new $util.LongBits(t.step.low >>> 0, t.step.high >>> 0).toNumber())), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    if (e.defaults)
      if (o.id = "", o.label = "", o.help = "", o.formId = "", o.setValue = !1, o.disabled = !1, o.labelVisibility = null, $util.Long) {
        let p = new $util.Long(0, 0, !1);
        o.step = e.longs === String ? p.toString() : e.longs === Number ? p.toNumber() : p;
      } else
        o.step = e.longs === String ? "0" : 0;
    return t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.label != null && t.hasOwnProperty("label") && (o.label = t.label), t.default != null && t.hasOwnProperty("default") && (o.default = t.default, e.oneofs && (o._default = "default")), t.help != null && t.hasOwnProperty("help") && (o.help = t.help), t.formId != null && t.hasOwnProperty("formId") && (o.formId = t.formId), t.value != null && t.hasOwnProperty("value") && (o.value = t.value, e.oneofs && (o._value = "value")), t.setValue != null && t.hasOwnProperty("setValue") && (o.setValue = t.setValue), t.disabled != null && t.hasOwnProperty("disabled") && (o.disabled = t.disabled), t.labelVisibility != null && t.hasOwnProperty("labelVisibility") && (o.labelVisibility = $root.LabelVisibilityMessage.toObject(t.labelVisibility, e)), t.step != null && t.hasOwnProperty("step") && (typeof t.step == "number" ? o.step = e.longs === String ? String(t.step) : t.step : o.step = e.longs === String ? $util.Long.prototype.toString.call(t.step) : e.longs === Number ? new $util.LongBits(t.step.low >>> 0, t.step.high >>> 0).toNumber() : t.step), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/TimeInput";
  }, r;
})();
$root.Toast = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.body = "", r.prototype.icon = "", r.prototype.duration = null;
  let c;
  return Object.defineProperty(r.prototype, "_duration", {
    get: $util.oneOfGetter(c = ["duration"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.body != null && Object.hasOwnProperty.call(t, "body") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.body), t.icon != null && Object.hasOwnProperty.call(t, "icon") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.icon), t.duration != null && Object.hasOwnProperty.call(t, "duration") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(t.duration), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.Toast();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.body = t.string();
          break;
        }
        case 2: {
          h.icon = t.string();
          break;
        }
        case 3: {
          h.duration = t.int32();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    return typeof t != "object" || t === null ? "object expected" : t.body != null && t.hasOwnProperty("body") && !$util.isString(t.body) ? "body: string expected" : t.icon != null && t.hasOwnProperty("icon") && !$util.isString(t.icon) ? "icon: string expected" : t.duration != null && t.hasOwnProperty("duration") && !$util.isInteger(t.duration) ? "duration: integer expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.Toast)
      return t;
    let e = new $root.Toast();
    return t.body != null && (e.body = String(t.body)), t.icon != null && (e.icon = String(t.icon)), t.duration != null && (e.duration = t.duration | 0), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.body = "", o.icon = ""), t.body != null && t.hasOwnProperty("body") && (o.body = t.body), t.icon != null && t.hasOwnProperty("icon") && (o.icon = t.icon), t.duration != null && t.hasOwnProperty("duration") && (o.duration = t.duration, e.oneofs && (o._duration = "duration")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Toast";
  }, r;
})();
$root.VegaLiteChart = (() => {
  function r(c) {
    if (this.datasets = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.spec = "", r.prototype.data = null, r.prototype.datasets = $util.emptyArray, r.prototype.useContainerWidth = !1, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.spec != null && Object.hasOwnProperty.call(n, "spec") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.spec), n.data != null && Object.hasOwnProperty.call(n, "data") && $root.DataFrame.encode(n.data, t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), n.datasets != null && n.datasets.length)
      for (let e = 0; e < n.datasets.length; ++e)
        $root.NamedDataSet.encode(n.datasets[e], t.uint32(
          /* id 4, wireType 2 =*/
          34
        ).fork()).ldelim();
    return n.useContainerWidth != null && Object.hasOwnProperty.call(n, "useContainerWidth") && t.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(n.useContainerWidth), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.VegaLiteChart();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.spec = n.string();
          break;
        }
        case 2: {
          p.data = $root.DataFrame.decode(n, n.uint32());
          break;
        }
        case 4: {
          p.datasets && p.datasets.length || (p.datasets = []), p.datasets.push($root.NamedDataSet.decode(n, n.uint32()));
          break;
        }
        case 5: {
          p.useContainerWidth = n.bool();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.spec != null && n.hasOwnProperty("spec") && !$util.isString(n.spec))
      return "spec: string expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      let t = $root.DataFrame.verify(n.data);
      if (t)
        return "data." + t;
    }
    if (n.datasets != null && n.hasOwnProperty("datasets")) {
      if (!Array.isArray(n.datasets))
        return "datasets: array expected";
      for (let t = 0; t < n.datasets.length; ++t) {
        let e = $root.NamedDataSet.verify(n.datasets[t]);
        if (e)
          return "datasets." + e;
      }
    }
    return n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && typeof n.useContainerWidth != "boolean" ? "useContainerWidth: boolean expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.VegaLiteChart)
      return n;
    let t = new $root.VegaLiteChart();
    if (n.spec != null && (t.spec = String(n.spec)), n.data != null) {
      if (typeof n.data != "object")
        throw TypeError(".VegaLiteChart.data: object expected");
      t.data = $root.DataFrame.fromObject(n.data);
    }
    if (n.datasets) {
      if (!Array.isArray(n.datasets))
        throw TypeError(".VegaLiteChart.datasets: array expected");
      t.datasets = [];
      for (let e = 0; e < n.datasets.length; ++e) {
        if (typeof n.datasets[e] != "object")
          throw TypeError(".VegaLiteChart.datasets: object expected");
        t.datasets[e] = $root.NamedDataSet.fromObject(n.datasets[e]);
      }
    }
    return n.useContainerWidth != null && (t.useContainerWidth = !!n.useContainerWidth), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.datasets = []), t.defaults && (e.spec = "", e.data = null, e.useContainerWidth = !1), n.spec != null && n.hasOwnProperty("spec") && (e.spec = n.spec), n.data != null && n.hasOwnProperty("data") && (e.data = $root.DataFrame.toObject(n.data, t)), n.datasets && n.datasets.length) {
      e.datasets = [];
      for (let o = 0; o < n.datasets.length; ++o)
        e.datasets[o] = $root.NamedDataSet.toObject(n.datasets[o], t);
    }
    return n.useContainerWidth != null && n.hasOwnProperty("useContainerWidth") && (e.useContainerWidth = n.useContainerWidth), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/VegaLiteChart";
  }, r;
})();
$root.NamedDataSet = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.name = "", r.prototype.hasName = !1, r.prototype.data = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.name != null && Object.hasOwnProperty.call(n, "name") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.name), n.data != null && Object.hasOwnProperty.call(n, "data") && $root.DataFrame.encode(n.data, t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), n.hasName != null && Object.hasOwnProperty.call(n, "hasName") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).bool(n.hasName), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.NamedDataSet();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.name = n.string();
          break;
        }
        case 3: {
          p.hasName = n.bool();
          break;
        }
        case 2: {
          p.data = $root.DataFrame.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
      return "name: string expected";
    if (n.hasName != null && n.hasOwnProperty("hasName") && typeof n.hasName != "boolean")
      return "hasName: boolean expected";
    if (n.data != null && n.hasOwnProperty("data")) {
      let t = $root.DataFrame.verify(n.data);
      if (t)
        return "data." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.NamedDataSet)
      return n;
    let t = new $root.NamedDataSet();
    if (n.name != null && (t.name = String(n.name)), n.hasName != null && (t.hasName = !!n.hasName), n.data != null) {
      if (typeof n.data != "object")
        throw TypeError(".NamedDataSet.data: object expected");
      t.data = $root.DataFrame.fromObject(n.data);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.name = "", e.data = null, e.hasName = !1), n.name != null && n.hasOwnProperty("name") && (e.name = n.name), n.data != null && n.hasOwnProperty("data") && (e.data = $root.DataFrame.toObject(n.data, t)), n.hasName != null && n.hasOwnProperty("hasName") && (e.hasName = n.hasName), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/NamedDataSet";
  }, r;
})();
$root.SubtitleTrack = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.label = "", r.prototype.url = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.label != null && Object.hasOwnProperty.call(n, "label") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.label), n.url != null && Object.hasOwnProperty.call(n, "url") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.url), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.SubtitleTrack();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.label = n.string();
          break;
        }
        case 2: {
          p.url = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.label != null && n.hasOwnProperty("label") && !$util.isString(n.label) ? "label: string expected" : n.url != null && n.hasOwnProperty("url") && !$util.isString(n.url) ? "url: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.SubtitleTrack)
      return n;
    let t = new $root.SubtitleTrack();
    return n.label != null && (t.label = String(n.label)), n.url != null && (t.url = String(n.url)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.label = "", e.url = ""), n.label != null && n.hasOwnProperty("label") && (e.label = n.label), n.url != null && n.hasOwnProperty("url") && (e.url = n.url), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/SubtitleTrack";
  }, r;
})();
$root.Video = (() => {
  function r(n) {
    if (this.subtitles = [], n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.url = "", r.prototype.startTime = 0, r.prototype.type = 0, r.prototype.subtitles = $util.emptyArray, r.prototype.endTime = 0, r.prototype.loop = !1, r.prototype.autoplay = !1, r.prototype.muted = !1, r.prototype.id = "", r.prototype.widthConfig = null;
  let c;
  return Object.defineProperty(r.prototype, "_widthConfig", {
    get: $util.oneOfGetter(c = ["widthConfig"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    if (e || (e = $Writer.create()), t.startTime != null && Object.hasOwnProperty.call(t, "startTime") && e.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(t.startTime), t.type != null && Object.hasOwnProperty.call(t, "type") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(t.type), t.url != null && Object.hasOwnProperty.call(t, "url") && e.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(t.url), t.subtitles != null && t.subtitles.length)
      for (let o = 0; o < t.subtitles.length; ++o)
        $root.SubtitleTrack.encode(t.subtitles[o], e.uint32(
          /* id 7, wireType 2 =*/
          58
        ).fork()).ldelim();
    return t.endTime != null && Object.hasOwnProperty.call(t, "endTime") && e.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(t.endTime), t.loop != null && Object.hasOwnProperty.call(t, "loop") && e.uint32(
      /* id 9, wireType 0 =*/
      72
    ).bool(t.loop), t.autoplay != null && Object.hasOwnProperty.call(t, "autoplay") && e.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(t.autoplay), t.muted != null && Object.hasOwnProperty.call(t, "muted") && e.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(t.muted), t.id != null && Object.hasOwnProperty.call(t, "id") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(t.id), t.widthConfig != null && Object.hasOwnProperty.call(t, "widthConfig") && $root.streamlit.WidthConfig.encode(t.widthConfig, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.Video();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 6: {
          h.url = t.string();
          break;
        }
        case 3: {
          h.startTime = t.int32();
          break;
        }
        case 5: {
          h.type = t.int32();
          break;
        }
        case 7: {
          h.subtitles && h.subtitles.length || (h.subtitles = []), h.subtitles.push($root.SubtitleTrack.decode(t, t.uint32()));
          break;
        }
        case 8: {
          h.endTime = t.int32();
          break;
        }
        case 9: {
          h.loop = t.bool();
          break;
        }
        case 10: {
          h.autoplay = t.bool();
          break;
        }
        case 11: {
          h.muted = t.bool();
          break;
        }
        case 12: {
          h.id = t.string();
          break;
        }
        case 13: {
          h.widthConfig = $root.streamlit.WidthConfig.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.url != null && t.hasOwnProperty("url") && !$util.isString(t.url))
      return "url: string expected";
    if (t.startTime != null && t.hasOwnProperty("startTime") && !$util.isInteger(t.startTime))
      return "startTime: integer expected";
    if (t.type != null && t.hasOwnProperty("type"))
      switch (t.type) {
        default:
          return "type: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    if (t.subtitles != null && t.hasOwnProperty("subtitles")) {
      if (!Array.isArray(t.subtitles))
        return "subtitles: array expected";
      for (let e = 0; e < t.subtitles.length; ++e) {
        let o = $root.SubtitleTrack.verify(t.subtitles[e]);
        if (o)
          return "subtitles." + o;
      }
    }
    if (t.endTime != null && t.hasOwnProperty("endTime") && !$util.isInteger(t.endTime))
      return "endTime: integer expected";
    if (t.loop != null && t.hasOwnProperty("loop") && typeof t.loop != "boolean")
      return "loop: boolean expected";
    if (t.autoplay != null && t.hasOwnProperty("autoplay") && typeof t.autoplay != "boolean")
      return "autoplay: boolean expected";
    if (t.muted != null && t.hasOwnProperty("muted") && typeof t.muted != "boolean")
      return "muted: boolean expected";
    if (t.id != null && t.hasOwnProperty("id") && !$util.isString(t.id))
      return "id: string expected";
    if (t.widthConfig != null && t.hasOwnProperty("widthConfig")) {
      let e = $root.streamlit.WidthConfig.verify(t.widthConfig);
      if (e)
        return "widthConfig." + e;
    }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.Video)
      return t;
    let e = new $root.Video();
    switch (t.url != null && (e.url = String(t.url)), t.startTime != null && (e.startTime = t.startTime | 0), t.type) {
      default:
        if (typeof t.type == "number") {
          e.type = t.type;
          break;
        }
        break;
      case "UNUSED":
      case 0:
        e.type = 0;
        break;
      case "NATIVE":
      case 1:
        e.type = 1;
        break;
      case "YOUTUBE_IFRAME":
      case 2:
        e.type = 2;
        break;
    }
    if (t.subtitles) {
      if (!Array.isArray(t.subtitles))
        throw TypeError(".Video.subtitles: array expected");
      e.subtitles = [];
      for (let o = 0; o < t.subtitles.length; ++o) {
        if (typeof t.subtitles[o] != "object")
          throw TypeError(".Video.subtitles: object expected");
        e.subtitles[o] = $root.SubtitleTrack.fromObject(t.subtitles[o]);
      }
    }
    if (t.endTime != null && (e.endTime = t.endTime | 0), t.loop != null && (e.loop = !!t.loop), t.autoplay != null && (e.autoplay = !!t.autoplay), t.muted != null && (e.muted = !!t.muted), t.id != null && (e.id = String(t.id)), t.widthConfig != null) {
      if (typeof t.widthConfig != "object")
        throw TypeError(".Video.widthConfig: object expected");
      e.widthConfig = $root.streamlit.WidthConfig.fromObject(t.widthConfig);
    }
    return e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    if ((e.arrays || e.defaults) && (o.subtitles = []), e.defaults && (o.startTime = 0, o.type = e.enums === String ? "UNUSED" : 0, o.url = "", o.endTime = 0, o.loop = !1, o.autoplay = !1, o.muted = !1, o.id = ""), t.startTime != null && t.hasOwnProperty("startTime") && (o.startTime = t.startTime), t.type != null && t.hasOwnProperty("type") && (o.type = e.enums === String ? $root.Video.Type[t.type] === void 0 ? t.type : $root.Video.Type[t.type] : t.type), t.url != null && t.hasOwnProperty("url") && (o.url = t.url), t.subtitles && t.subtitles.length) {
      o.subtitles = [];
      for (let p = 0; p < t.subtitles.length; ++p)
        o.subtitles[p] = $root.SubtitleTrack.toObject(t.subtitles[p], e);
    }
    return t.endTime != null && t.hasOwnProperty("endTime") && (o.endTime = t.endTime), t.loop != null && t.hasOwnProperty("loop") && (o.loop = t.loop), t.autoplay != null && t.hasOwnProperty("autoplay") && (o.autoplay = t.autoplay), t.muted != null && t.hasOwnProperty("muted") && (o.muted = t.muted), t.id != null && t.hasOwnProperty("id") && (o.id = t.id), t.widthConfig != null && t.hasOwnProperty("widthConfig") && (o.widthConfig = $root.streamlit.WidthConfig.toObject(t.widthConfig, e), e.oneofs && (o._widthConfig = "widthConfig")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/Video";
  }, r.Type = (function() {
    const n = {}, t = Object.create(n);
    return t[n[0] = "UNUSED"] = 0, t[n[1] = "NATIVE"] = 1, t[n[2] = "YOUTUBE_IFRAME"] = 2, t;
  })(), r;
})();
$root.Heading = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.tag = "", r.prototype.anchor = "", r.prototype.body = "", r.prototype.help = "", r.prototype.hideAnchor = !1, r.prototype.divider = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.tag != null && Object.hasOwnProperty.call(n, "tag") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.tag), n.anchor != null && Object.hasOwnProperty.call(n, "anchor") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.anchor), n.body != null && Object.hasOwnProperty.call(n, "body") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.body), n.help != null && Object.hasOwnProperty.call(n, "help") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.help), n.hideAnchor != null && Object.hasOwnProperty.call(n, "hideAnchor") && t.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(n.hideAnchor), n.divider != null && Object.hasOwnProperty.call(n, "divider") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.divider), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Heading();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.tag = n.string();
          break;
        }
        case 2: {
          p.anchor = n.string();
          break;
        }
        case 3: {
          p.body = n.string();
          break;
        }
        case 4: {
          p.help = n.string();
          break;
        }
        case 5: {
          p.hideAnchor = n.bool();
          break;
        }
        case 6: {
          p.divider = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.tag != null && n.hasOwnProperty("tag") && !$util.isString(n.tag) ? "tag: string expected" : n.anchor != null && n.hasOwnProperty("anchor") && !$util.isString(n.anchor) ? "anchor: string expected" : n.body != null && n.hasOwnProperty("body") && !$util.isString(n.body) ? "body: string expected" : n.help != null && n.hasOwnProperty("help") && !$util.isString(n.help) ? "help: string expected" : n.hideAnchor != null && n.hasOwnProperty("hideAnchor") && typeof n.hideAnchor != "boolean" ? "hideAnchor: boolean expected" : n.divider != null && n.hasOwnProperty("divider") && !$util.isString(n.divider) ? "divider: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Heading)
      return n;
    let t = new $root.Heading();
    return n.tag != null && (t.tag = String(n.tag)), n.anchor != null && (t.anchor = String(n.anchor)), n.body != null && (t.body = String(n.body)), n.help != null && (t.help = String(n.help)), n.hideAnchor != null && (t.hideAnchor = !!n.hideAnchor), n.divider != null && (t.divider = String(n.divider)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.tag = "", e.anchor = "", e.body = "", e.help = "", e.hideAnchor = !1, e.divider = ""), n.tag != null && n.hasOwnProperty("tag") && (e.tag = n.tag), n.anchor != null && n.hasOwnProperty("anchor") && (e.anchor = n.anchor), n.body != null && n.hasOwnProperty("body") && (e.body = n.body), n.help != null && n.hasOwnProperty("help") && (e.help = n.help), n.hideAnchor != null && n.hasOwnProperty("hideAnchor") && (e.hideAnchor = n.hideAnchor), n.divider != null && n.hasOwnProperty("divider") && (e.divider = n.divider), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Heading";
  }, r;
})();
const ForwardMsg = $root.ForwardMsg = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.hash = "", r.prototype.metadata = null, r.prototype.newSession = null, r.prototype.delta = null, r.prototype.pageInfoChanged = null, r.prototype.pageConfigChanged = null, r.prototype.scriptFinished = null, r.prototype.gitInfoChanged = null, r.prototype.pageProfile = null, r.prototype.sessionStatusChanged = null, r.prototype.sessionEvent = null, r.prototype.navigation = null, r.prototype.pageNotFound = null, r.prototype.pagesChanged = null, r.prototype.fileUrlsResponse = null, r.prototype.autoRerun = null, r.prototype.logo = null, r.prototype.authRedirect = null, r.prototype.parentMessage = null, r.prototype.refHash = null, r.prototype.debugLastBackmsgId = "";
  let c;
  return Object.defineProperty(r.prototype, "type", {
    get: $util.oneOfGetter(c = ["newSession", "delta", "pageInfoChanged", "pageConfigChanged", "scriptFinished", "gitInfoChanged", "pageProfile", "sessionStatusChanged", "sessionEvent", "navigation", "pageNotFound", "pagesChanged", "fileUrlsResponse", "autoRerun", "logo", "authRedirect", "parentMessage", "refHash"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.hash != null && Object.hasOwnProperty.call(t, "hash") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.hash), t.metadata != null && Object.hasOwnProperty.call(t, "metadata") && $root.ForwardMsgMetadata.encode(t.metadata, e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).fork()).ldelim(), t.newSession != null && Object.hasOwnProperty.call(t, "newSession") && $root.NewSession.encode(t.newSession, e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), t.delta != null && Object.hasOwnProperty.call(t, "delta") && $root.Delta.encode(t.delta, e.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), t.scriptFinished != null && Object.hasOwnProperty.call(t, "scriptFinished") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(t.scriptFinished), t.sessionStatusChanged != null && Object.hasOwnProperty.call(t, "sessionStatusChanged") && $root.SessionStatus.encode(t.sessionStatusChanged, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), t.sessionEvent != null && Object.hasOwnProperty.call(t, "sessionEvent") && $root.SessionEvent.encode(t.sessionEvent, e.uint32(
      /* id 10, wireType 2 =*/
      82
    ).fork()).ldelim(), t.refHash != null && Object.hasOwnProperty.call(t, "refHash") && e.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(t.refHash), t.pageInfoChanged != null && Object.hasOwnProperty.call(t, "pageInfoChanged") && $root.PageInfo.encode(t.pageInfoChanged, e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).fork()).ldelim(), t.pageConfigChanged != null && Object.hasOwnProperty.call(t, "pageConfigChanged") && $root.PageConfig.encode(t.pageConfigChanged, e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).fork()).ldelim(), t.gitInfoChanged != null && Object.hasOwnProperty.call(t, "gitInfoChanged") && $root.GitInfo.encode(t.gitInfoChanged, e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).fork()).ldelim(), t.pageNotFound != null && Object.hasOwnProperty.call(t, "pageNotFound") && $root.PageNotFound.encode(t.pageNotFound, e.uint32(
      /* id 15, wireType 2 =*/
      122
    ).fork()).ldelim(), t.pagesChanged != null && Object.hasOwnProperty.call(t, "pagesChanged") && $root.PagesChanged.encode(t.pagesChanged, e.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), t.debugLastBackmsgId != null && Object.hasOwnProperty.call(t, "debugLastBackmsgId") && e.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(t.debugLastBackmsgId), t.pageProfile != null && Object.hasOwnProperty.call(t, "pageProfile") && $root.PageProfile.encode(t.pageProfile, e.uint32(
      /* id 18, wireType 2 =*/
      146
    ).fork()).ldelim(), t.fileUrlsResponse != null && Object.hasOwnProperty.call(t, "fileUrlsResponse") && $root.FileURLsResponse.encode(t.fileUrlsResponse, e.uint32(
      /* id 19, wireType 2 =*/
      154
    ).fork()).ldelim(), t.parentMessage != null && Object.hasOwnProperty.call(t, "parentMessage") && $root.ParentMessage.encode(t.parentMessage, e.uint32(
      /* id 20, wireType 2 =*/
      162
    ).fork()).ldelim(), t.autoRerun != null && Object.hasOwnProperty.call(t, "autoRerun") && $root.AutoRerun.encode(t.autoRerun, e.uint32(
      /* id 21, wireType 2 =*/
      170
    ).fork()).ldelim(), t.logo != null && Object.hasOwnProperty.call(t, "logo") && $root.Logo.encode(t.logo, e.uint32(
      /* id 22, wireType 2 =*/
      178
    ).fork()).ldelim(), t.navigation != null && Object.hasOwnProperty.call(t, "navigation") && $root.Navigation.encode(t.navigation, e.uint32(
      /* id 23, wireType 2 =*/
      186
    ).fork()).ldelim(), t.authRedirect != null && Object.hasOwnProperty.call(t, "authRedirect") && $root.AuthRedirect.encode(t.authRedirect, e.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.ForwardMsg();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.hash = t.string();
          break;
        }
        case 2: {
          h.metadata = $root.ForwardMsgMetadata.decode(t, t.uint32());
          break;
        }
        case 4: {
          h.newSession = $root.NewSession.decode(t, t.uint32());
          break;
        }
        case 5: {
          h.delta = $root.Delta.decode(t, t.uint32());
          break;
        }
        case 12: {
          h.pageInfoChanged = $root.PageInfo.decode(t, t.uint32());
          break;
        }
        case 13: {
          h.pageConfigChanged = $root.PageConfig.decode(t, t.uint32());
          break;
        }
        case 6: {
          h.scriptFinished = t.int32();
          break;
        }
        case 14: {
          h.gitInfoChanged = $root.GitInfo.decode(t, t.uint32());
          break;
        }
        case 18: {
          h.pageProfile = $root.PageProfile.decode(t, t.uint32());
          break;
        }
        case 9: {
          h.sessionStatusChanged = $root.SessionStatus.decode(t, t.uint32());
          break;
        }
        case 10: {
          h.sessionEvent = $root.SessionEvent.decode(t, t.uint32());
          break;
        }
        case 23: {
          h.navigation = $root.Navigation.decode(t, t.uint32());
          break;
        }
        case 15: {
          h.pageNotFound = $root.PageNotFound.decode(t, t.uint32());
          break;
        }
        case 16: {
          h.pagesChanged = $root.PagesChanged.decode(t, t.uint32());
          break;
        }
        case 19: {
          h.fileUrlsResponse = $root.FileURLsResponse.decode(t, t.uint32());
          break;
        }
        case 21: {
          h.autoRerun = $root.AutoRerun.decode(t, t.uint32());
          break;
        }
        case 22: {
          h.logo = $root.Logo.decode(t, t.uint32());
          break;
        }
        case 24: {
          h.authRedirect = $root.AuthRedirect.decode(t, t.uint32());
          break;
        }
        case 20: {
          h.parentMessage = $root.ParentMessage.decode(t, t.uint32());
          break;
        }
        case 11: {
          h.refHash = t.string();
          break;
        }
        case 17: {
          h.debugLastBackmsgId = t.string();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    let e = {};
    if (t.hash != null && t.hasOwnProperty("hash") && !$util.isString(t.hash))
      return "hash: string expected";
    if (t.metadata != null && t.hasOwnProperty("metadata")) {
      let o = $root.ForwardMsgMetadata.verify(t.metadata);
      if (o)
        return "metadata." + o;
    }
    if (t.newSession != null && t.hasOwnProperty("newSession")) {
      e.type = 1;
      {
        let o = $root.NewSession.verify(t.newSession);
        if (o)
          return "newSession." + o;
      }
    }
    if (t.delta != null && t.hasOwnProperty("delta")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Delta.verify(t.delta);
        if (o)
          return "delta." + o;
      }
    }
    if (t.pageInfoChanged != null && t.hasOwnProperty("pageInfoChanged")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.PageInfo.verify(t.pageInfoChanged);
        if (o)
          return "pageInfoChanged." + o;
      }
    }
    if (t.pageConfigChanged != null && t.hasOwnProperty("pageConfigChanged")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.PageConfig.verify(t.pageConfigChanged);
        if (o)
          return "pageConfigChanged." + o;
      }
    }
    if (t.scriptFinished != null && t.hasOwnProperty("scriptFinished")) {
      if (e.type === 1)
        return "type: multiple values";
      switch (e.type = 1, t.scriptFinished) {
        default:
          return "scriptFinished: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
          break;
      }
    }
    if (t.gitInfoChanged != null && t.hasOwnProperty("gitInfoChanged")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.GitInfo.verify(t.gitInfoChanged);
        if (o)
          return "gitInfoChanged." + o;
      }
    }
    if (t.pageProfile != null && t.hasOwnProperty("pageProfile")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.PageProfile.verify(t.pageProfile);
        if (o)
          return "pageProfile." + o;
      }
    }
    if (t.sessionStatusChanged != null && t.hasOwnProperty("sessionStatusChanged")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.SessionStatus.verify(t.sessionStatusChanged);
        if (o)
          return "sessionStatusChanged." + o;
      }
    }
    if (t.sessionEvent != null && t.hasOwnProperty("sessionEvent")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.SessionEvent.verify(t.sessionEvent);
        if (o)
          return "sessionEvent." + o;
      }
    }
    if (t.navigation != null && t.hasOwnProperty("navigation")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Navigation.verify(t.navigation);
        if (o)
          return "navigation." + o;
      }
    }
    if (t.pageNotFound != null && t.hasOwnProperty("pageNotFound")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.PageNotFound.verify(t.pageNotFound);
        if (o)
          return "pageNotFound." + o;
      }
    }
    if (t.pagesChanged != null && t.hasOwnProperty("pagesChanged")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.PagesChanged.verify(t.pagesChanged);
        if (o)
          return "pagesChanged." + o;
      }
    }
    if (t.fileUrlsResponse != null && t.hasOwnProperty("fileUrlsResponse")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.FileURLsResponse.verify(t.fileUrlsResponse);
        if (o)
          return "fileUrlsResponse." + o;
      }
    }
    if (t.autoRerun != null && t.hasOwnProperty("autoRerun")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.AutoRerun.verify(t.autoRerun);
        if (o)
          return "autoRerun." + o;
      }
    }
    if (t.logo != null && t.hasOwnProperty("logo")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Logo.verify(t.logo);
        if (o)
          return "logo." + o;
      }
    }
    if (t.authRedirect != null && t.hasOwnProperty("authRedirect")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.AuthRedirect.verify(t.authRedirect);
        if (o)
          return "authRedirect." + o;
      }
    }
    if (t.parentMessage != null && t.hasOwnProperty("parentMessage")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.ParentMessage.verify(t.parentMessage);
        if (o)
          return "parentMessage." + o;
      }
    }
    if (t.refHash != null && t.hasOwnProperty("refHash")) {
      if (e.type === 1)
        return "type: multiple values";
      if (e.type = 1, !$util.isString(t.refHash))
        return "refHash: string expected";
    }
    return t.debugLastBackmsgId != null && t.hasOwnProperty("debugLastBackmsgId") && !$util.isString(t.debugLastBackmsgId) ? "debugLastBackmsgId: string expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.ForwardMsg)
      return t;
    let e = new $root.ForwardMsg();
    if (t.hash != null && (e.hash = String(t.hash)), t.metadata != null) {
      if (typeof t.metadata != "object")
        throw TypeError(".ForwardMsg.metadata: object expected");
      e.metadata = $root.ForwardMsgMetadata.fromObject(t.metadata);
    }
    if (t.newSession != null) {
      if (typeof t.newSession != "object")
        throw TypeError(".ForwardMsg.newSession: object expected");
      e.newSession = $root.NewSession.fromObject(t.newSession);
    }
    if (t.delta != null) {
      if (typeof t.delta != "object")
        throw TypeError(".ForwardMsg.delta: object expected");
      e.delta = $root.Delta.fromObject(t.delta);
    }
    if (t.pageInfoChanged != null) {
      if (typeof t.pageInfoChanged != "object")
        throw TypeError(".ForwardMsg.pageInfoChanged: object expected");
      e.pageInfoChanged = $root.PageInfo.fromObject(t.pageInfoChanged);
    }
    if (t.pageConfigChanged != null) {
      if (typeof t.pageConfigChanged != "object")
        throw TypeError(".ForwardMsg.pageConfigChanged: object expected");
      e.pageConfigChanged = $root.PageConfig.fromObject(t.pageConfigChanged);
    }
    switch (t.scriptFinished) {
      default:
        if (typeof t.scriptFinished == "number") {
          e.scriptFinished = t.scriptFinished;
          break;
        }
        break;
      case "FINISHED_SUCCESSFULLY":
      case 0:
        e.scriptFinished = 0;
        break;
      case "FINISHED_WITH_COMPILE_ERROR":
      case 1:
        e.scriptFinished = 1;
        break;
      case "FINISHED_EARLY_FOR_RERUN":
      case 2:
        e.scriptFinished = 2;
        break;
      case "FINISHED_FRAGMENT_RUN_SUCCESSFULLY":
      case 3:
        e.scriptFinished = 3;
        break;
    }
    if (t.gitInfoChanged != null) {
      if (typeof t.gitInfoChanged != "object")
        throw TypeError(".ForwardMsg.gitInfoChanged: object expected");
      e.gitInfoChanged = $root.GitInfo.fromObject(t.gitInfoChanged);
    }
    if (t.pageProfile != null) {
      if (typeof t.pageProfile != "object")
        throw TypeError(".ForwardMsg.pageProfile: object expected");
      e.pageProfile = $root.PageProfile.fromObject(t.pageProfile);
    }
    if (t.sessionStatusChanged != null) {
      if (typeof t.sessionStatusChanged != "object")
        throw TypeError(".ForwardMsg.sessionStatusChanged: object expected");
      e.sessionStatusChanged = $root.SessionStatus.fromObject(t.sessionStatusChanged);
    }
    if (t.sessionEvent != null) {
      if (typeof t.sessionEvent != "object")
        throw TypeError(".ForwardMsg.sessionEvent: object expected");
      e.sessionEvent = $root.SessionEvent.fromObject(t.sessionEvent);
    }
    if (t.navigation != null) {
      if (typeof t.navigation != "object")
        throw TypeError(".ForwardMsg.navigation: object expected");
      e.navigation = $root.Navigation.fromObject(t.navigation);
    }
    if (t.pageNotFound != null) {
      if (typeof t.pageNotFound != "object")
        throw TypeError(".ForwardMsg.pageNotFound: object expected");
      e.pageNotFound = $root.PageNotFound.fromObject(t.pageNotFound);
    }
    if (t.pagesChanged != null) {
      if (typeof t.pagesChanged != "object")
        throw TypeError(".ForwardMsg.pagesChanged: object expected");
      e.pagesChanged = $root.PagesChanged.fromObject(t.pagesChanged);
    }
    if (t.fileUrlsResponse != null) {
      if (typeof t.fileUrlsResponse != "object")
        throw TypeError(".ForwardMsg.fileUrlsResponse: object expected");
      e.fileUrlsResponse = $root.FileURLsResponse.fromObject(t.fileUrlsResponse);
    }
    if (t.autoRerun != null) {
      if (typeof t.autoRerun != "object")
        throw TypeError(".ForwardMsg.autoRerun: object expected");
      e.autoRerun = $root.AutoRerun.fromObject(t.autoRerun);
    }
    if (t.logo != null) {
      if (typeof t.logo != "object")
        throw TypeError(".ForwardMsg.logo: object expected");
      e.logo = $root.Logo.fromObject(t.logo);
    }
    if (t.authRedirect != null) {
      if (typeof t.authRedirect != "object")
        throw TypeError(".ForwardMsg.authRedirect: object expected");
      e.authRedirect = $root.AuthRedirect.fromObject(t.authRedirect);
    }
    if (t.parentMessage != null) {
      if (typeof t.parentMessage != "object")
        throw TypeError(".ForwardMsg.parentMessage: object expected");
      e.parentMessage = $root.ParentMessage.fromObject(t.parentMessage);
    }
    return t.refHash != null && (e.refHash = String(t.refHash)), t.debugLastBackmsgId != null && (e.debugLastBackmsgId = String(t.debugLastBackmsgId)), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return e.defaults && (o.hash = "", o.metadata = null, o.debugLastBackmsgId = ""), t.hash != null && t.hasOwnProperty("hash") && (o.hash = t.hash), t.metadata != null && t.hasOwnProperty("metadata") && (o.metadata = $root.ForwardMsgMetadata.toObject(t.metadata, e)), t.newSession != null && t.hasOwnProperty("newSession") && (o.newSession = $root.NewSession.toObject(t.newSession, e), e.oneofs && (o.type = "newSession")), t.delta != null && t.hasOwnProperty("delta") && (o.delta = $root.Delta.toObject(t.delta, e), e.oneofs && (o.type = "delta")), t.scriptFinished != null && t.hasOwnProperty("scriptFinished") && (o.scriptFinished = e.enums === String ? $root.ForwardMsg.ScriptFinishedStatus[t.scriptFinished] === void 0 ? t.scriptFinished : $root.ForwardMsg.ScriptFinishedStatus[t.scriptFinished] : t.scriptFinished, e.oneofs && (o.type = "scriptFinished")), t.sessionStatusChanged != null && t.hasOwnProperty("sessionStatusChanged") && (o.sessionStatusChanged = $root.SessionStatus.toObject(t.sessionStatusChanged, e), e.oneofs && (o.type = "sessionStatusChanged")), t.sessionEvent != null && t.hasOwnProperty("sessionEvent") && (o.sessionEvent = $root.SessionEvent.toObject(t.sessionEvent, e), e.oneofs && (o.type = "sessionEvent")), t.refHash != null && t.hasOwnProperty("refHash") && (o.refHash = t.refHash, e.oneofs && (o.type = "refHash")), t.pageInfoChanged != null && t.hasOwnProperty("pageInfoChanged") && (o.pageInfoChanged = $root.PageInfo.toObject(t.pageInfoChanged, e), e.oneofs && (o.type = "pageInfoChanged")), t.pageConfigChanged != null && t.hasOwnProperty("pageConfigChanged") && (o.pageConfigChanged = $root.PageConfig.toObject(t.pageConfigChanged, e), e.oneofs && (o.type = "pageConfigChanged")), t.gitInfoChanged != null && t.hasOwnProperty("gitInfoChanged") && (o.gitInfoChanged = $root.GitInfo.toObject(t.gitInfoChanged, e), e.oneofs && (o.type = "gitInfoChanged")), t.pageNotFound != null && t.hasOwnProperty("pageNotFound") && (o.pageNotFound = $root.PageNotFound.toObject(t.pageNotFound, e), e.oneofs && (o.type = "pageNotFound")), t.pagesChanged != null && t.hasOwnProperty("pagesChanged") && (o.pagesChanged = $root.PagesChanged.toObject(t.pagesChanged, e), e.oneofs && (o.type = "pagesChanged")), t.debugLastBackmsgId != null && t.hasOwnProperty("debugLastBackmsgId") && (o.debugLastBackmsgId = t.debugLastBackmsgId), t.pageProfile != null && t.hasOwnProperty("pageProfile") && (o.pageProfile = $root.PageProfile.toObject(t.pageProfile, e), e.oneofs && (o.type = "pageProfile")), t.fileUrlsResponse != null && t.hasOwnProperty("fileUrlsResponse") && (o.fileUrlsResponse = $root.FileURLsResponse.toObject(t.fileUrlsResponse, e), e.oneofs && (o.type = "fileUrlsResponse")), t.parentMessage != null && t.hasOwnProperty("parentMessage") && (o.parentMessage = $root.ParentMessage.toObject(t.parentMessage, e), e.oneofs && (o.type = "parentMessage")), t.autoRerun != null && t.hasOwnProperty("autoRerun") && (o.autoRerun = $root.AutoRerun.toObject(t.autoRerun, e), e.oneofs && (o.type = "autoRerun")), t.logo != null && t.hasOwnProperty("logo") && (o.logo = $root.Logo.toObject(t.logo, e), e.oneofs && (o.type = "logo")), t.navigation != null && t.hasOwnProperty("navigation") && (o.navigation = $root.Navigation.toObject(t.navigation, e), e.oneofs && (o.type = "navigation")), t.authRedirect != null && t.hasOwnProperty("authRedirect") && (o.authRedirect = $root.AuthRedirect.toObject(t.authRedirect, e), e.oneofs && (o.type = "authRedirect")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/ForwardMsg";
  }, r.ScriptFinishedStatus = (function() {
    const n = {}, t = Object.create(n);
    return t[n[0] = "FINISHED_SUCCESSFULLY"] = 0, t[n[1] = "FINISHED_WITH_COMPILE_ERROR"] = 1, t[n[2] = "FINISHED_EARLY_FOR_RERUN"] = 2, t[n[3] = "FINISHED_FRAGMENT_RUN_SUCCESSFULLY"] = 3, t;
  })(), r;
})();
$root.ForwardMsgMetadata = (() => {
  function r(c) {
    if (this.deltaPath = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.cacheable = !1, r.prototype.deltaPath = $util.emptyArray, r.prototype.elementDimensionSpec = null, r.prototype.activeScriptHash = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.cacheable != null && Object.hasOwnProperty.call(n, "cacheable") && t.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(n.cacheable), n.deltaPath != null && n.deltaPath.length) {
      t.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork();
      for (let e = 0; e < n.deltaPath.length; ++e)
        t.uint32(n.deltaPath[e]);
      t.ldelim();
    }
    return n.elementDimensionSpec != null && Object.hasOwnProperty.call(n, "elementDimensionSpec") && $root.ElementDimensionSpec.encode(n.elementDimensionSpec, t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), n.activeScriptHash != null && Object.hasOwnProperty.call(n, "activeScriptHash") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.activeScriptHash), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.ForwardMsgMetadata();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.cacheable = n.bool();
          break;
        }
        case 2: {
          if (p.deltaPath && p.deltaPath.length || (p.deltaPath = []), (h & 7) === 2) {
            let y = n.uint32() + n.pos;
            for (; n.pos < y; )
              p.deltaPath.push(n.uint32());
          } else
            p.deltaPath.push(n.uint32());
          break;
        }
        case 3: {
          p.elementDimensionSpec = $root.ElementDimensionSpec.decode(n, n.uint32());
          break;
        }
        case 4: {
          p.activeScriptHash = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.cacheable != null && n.hasOwnProperty("cacheable") && typeof n.cacheable != "boolean")
      return "cacheable: boolean expected";
    if (n.deltaPath != null && n.hasOwnProperty("deltaPath")) {
      if (!Array.isArray(n.deltaPath))
        return "deltaPath: array expected";
      for (let t = 0; t < n.deltaPath.length; ++t)
        if (!$util.isInteger(n.deltaPath[t]))
          return "deltaPath: integer[] expected";
    }
    if (n.elementDimensionSpec != null && n.hasOwnProperty("elementDimensionSpec")) {
      let t = $root.ElementDimensionSpec.verify(n.elementDimensionSpec);
      if (t)
        return "elementDimensionSpec." + t;
    }
    return n.activeScriptHash != null && n.hasOwnProperty("activeScriptHash") && !$util.isString(n.activeScriptHash) ? "activeScriptHash: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.ForwardMsgMetadata)
      return n;
    let t = new $root.ForwardMsgMetadata();
    if (n.cacheable != null && (t.cacheable = !!n.cacheable), n.deltaPath) {
      if (!Array.isArray(n.deltaPath))
        throw TypeError(".ForwardMsgMetadata.deltaPath: array expected");
      t.deltaPath = [];
      for (let e = 0; e < n.deltaPath.length; ++e)
        t.deltaPath[e] = n.deltaPath[e] >>> 0;
    }
    if (n.elementDimensionSpec != null) {
      if (typeof n.elementDimensionSpec != "object")
        throw TypeError(".ForwardMsgMetadata.elementDimensionSpec: object expected");
      t.elementDimensionSpec = $root.ElementDimensionSpec.fromObject(n.elementDimensionSpec);
    }
    return n.activeScriptHash != null && (t.activeScriptHash = String(n.activeScriptHash)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.deltaPath = []), t.defaults && (e.cacheable = !1, e.elementDimensionSpec = null, e.activeScriptHash = ""), n.cacheable != null && n.hasOwnProperty("cacheable") && (e.cacheable = n.cacheable), n.deltaPath && n.deltaPath.length) {
      e.deltaPath = [];
      for (let o = 0; o < n.deltaPath.length; ++o)
        e.deltaPath[o] = n.deltaPath[o];
    }
    return n.elementDimensionSpec != null && n.hasOwnProperty("elementDimensionSpec") && (e.elementDimensionSpec = $root.ElementDimensionSpec.toObject(n.elementDimensionSpec, t)), n.activeScriptHash != null && n.hasOwnProperty("activeScriptHash") && (e.activeScriptHash = n.activeScriptHash), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/ForwardMsgMetadata";
  }, r;
})();
$root.ElementDimensionSpec = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.width = 0, r.prototype.height = 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.width != null && Object.hasOwnProperty.call(n, "width") && t.uint32(
      /* id 1, wireType 0 =*/
      8
    ).uint32(n.width), n.height != null && Object.hasOwnProperty.call(n, "height") && t.uint32(
      /* id 2, wireType 0 =*/
      16
    ).uint32(n.height), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.ElementDimensionSpec();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.width = n.uint32();
          break;
        }
        case 2: {
          p.height = n.uint32();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.width != null && n.hasOwnProperty("width") && !$util.isInteger(n.width) ? "width: integer expected" : n.height != null && n.hasOwnProperty("height") && !$util.isInteger(n.height) ? "height: integer expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.ElementDimensionSpec)
      return n;
    let t = new $root.ElementDimensionSpec();
    return n.width != null && (t.width = n.width >>> 0), n.height != null && (t.height = n.height >>> 0), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.width = 0, e.height = 0), n.width != null && n.hasOwnProperty("width") && (e.width = n.width), n.height != null && n.hasOwnProperty("height") && (e.height = n.height), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/ElementDimensionSpec";
  }, r;
})();
const ForwardMsgList = $root.ForwardMsgList = (() => {
  function r(c) {
    if (this.messages = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.messages = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.messages != null && n.messages.length)
      for (let e = 0; e < n.messages.length; ++e)
        $root.ForwardMsg.encode(n.messages[e], t.uint32(
          /* id 1, wireType 2 =*/
          10
        ).fork()).ldelim();
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.ForwardMsgList();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.messages && p.messages.length || (p.messages = []), p.messages.push($root.ForwardMsg.decode(n, n.uint32()));
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.messages != null && n.hasOwnProperty("messages")) {
      if (!Array.isArray(n.messages))
        return "messages: array expected";
      for (let t = 0; t < n.messages.length; ++t) {
        let e = $root.ForwardMsg.verify(n.messages[t]);
        if (e)
          return "messages." + e;
      }
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.ForwardMsgList)
      return n;
    let t = new $root.ForwardMsgList();
    if (n.messages) {
      if (!Array.isArray(n.messages))
        throw TypeError(".ForwardMsgList.messages: array expected");
      t.messages = [];
      for (let e = 0; e < n.messages.length; ++e) {
        if (typeof n.messages[e] != "object")
          throw TypeError(".ForwardMsgList.messages: object expected");
        t.messages[e] = $root.ForwardMsg.fromObject(n.messages[e]);
      }
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.messages = []), n.messages && n.messages.length) {
      e.messages = [];
      for (let o = 0; o < n.messages.length; ++o)
        e.messages[o] = $root.ForwardMsg.toObject(n.messages[o], t);
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/ForwardMsgList";
  }, r;
})();
$root.GitInfo = (() => {
  function r(c) {
    if (this.untrackedFiles = [], this.uncommittedFiles = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.repository = "", r.prototype.branch = "", r.prototype.module = "", r.prototype.untrackedFiles = $util.emptyArray, r.prototype.uncommittedFiles = $util.emptyArray, r.prototype.state = 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.repository != null && Object.hasOwnProperty.call(n, "repository") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.repository), n.branch != null && Object.hasOwnProperty.call(n, "branch") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.branch), n.module != null && Object.hasOwnProperty.call(n, "module") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.module), n.untrackedFiles != null && n.untrackedFiles.length)
      for (let e = 0; e < n.untrackedFiles.length; ++e)
        t.uint32(
          /* id 4, wireType 2 =*/
          34
        ).string(n.untrackedFiles[e]);
    if (n.uncommittedFiles != null && n.uncommittedFiles.length)
      for (let e = 0; e < n.uncommittedFiles.length; ++e)
        t.uint32(
          /* id 5, wireType 2 =*/
          42
        ).string(n.uncommittedFiles[e]);
    return n.state != null && Object.hasOwnProperty.call(n, "state") && t.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(n.state), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.GitInfo();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.repository = n.string();
          break;
        }
        case 2: {
          p.branch = n.string();
          break;
        }
        case 3: {
          p.module = n.string();
          break;
        }
        case 4: {
          p.untrackedFiles && p.untrackedFiles.length || (p.untrackedFiles = []), p.untrackedFiles.push(n.string());
          break;
        }
        case 5: {
          p.uncommittedFiles && p.uncommittedFiles.length || (p.uncommittedFiles = []), p.uncommittedFiles.push(n.string());
          break;
        }
        case 6: {
          p.state = n.int32();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.repository != null && n.hasOwnProperty("repository") && !$util.isString(n.repository))
      return "repository: string expected";
    if (n.branch != null && n.hasOwnProperty("branch") && !$util.isString(n.branch))
      return "branch: string expected";
    if (n.module != null && n.hasOwnProperty("module") && !$util.isString(n.module))
      return "module: string expected";
    if (n.untrackedFiles != null && n.hasOwnProperty("untrackedFiles")) {
      if (!Array.isArray(n.untrackedFiles))
        return "untrackedFiles: array expected";
      for (let t = 0; t < n.untrackedFiles.length; ++t)
        if (!$util.isString(n.untrackedFiles[t]))
          return "untrackedFiles: string[] expected";
    }
    if (n.uncommittedFiles != null && n.hasOwnProperty("uncommittedFiles")) {
      if (!Array.isArray(n.uncommittedFiles))
        return "uncommittedFiles: array expected";
      for (let t = 0; t < n.uncommittedFiles.length; ++t)
        if (!$util.isString(n.uncommittedFiles[t]))
          return "uncommittedFiles: string[] expected";
    }
    if (n.state != null && n.hasOwnProperty("state"))
      switch (n.state) {
        default:
          return "state: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.GitInfo)
      return n;
    let t = new $root.GitInfo();
    if (n.repository != null && (t.repository = String(n.repository)), n.branch != null && (t.branch = String(n.branch)), n.module != null && (t.module = String(n.module)), n.untrackedFiles) {
      if (!Array.isArray(n.untrackedFiles))
        throw TypeError(".GitInfo.untrackedFiles: array expected");
      t.untrackedFiles = [];
      for (let e = 0; e < n.untrackedFiles.length; ++e)
        t.untrackedFiles[e] = String(n.untrackedFiles[e]);
    }
    if (n.uncommittedFiles) {
      if (!Array.isArray(n.uncommittedFiles))
        throw TypeError(".GitInfo.uncommittedFiles: array expected");
      t.uncommittedFiles = [];
      for (let e = 0; e < n.uncommittedFiles.length; ++e)
        t.uncommittedFiles[e] = String(n.uncommittedFiles[e]);
    }
    switch (n.state) {
      default:
        if (typeof n.state == "number") {
          t.state = n.state;
          break;
        }
        break;
      case "DEFAULT":
      case 0:
        t.state = 0;
        break;
      case "HEAD_DETACHED":
      case 1:
        t.state = 1;
        break;
      case "AHEAD_OF_REMOTE":
      case 2:
        t.state = 2;
        break;
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.untrackedFiles = [], e.uncommittedFiles = []), t.defaults && (e.repository = "", e.branch = "", e.module = "", e.state = t.enums === String ? "DEFAULT" : 0), n.repository != null && n.hasOwnProperty("repository") && (e.repository = n.repository), n.branch != null && n.hasOwnProperty("branch") && (e.branch = n.branch), n.module != null && n.hasOwnProperty("module") && (e.module = n.module), n.untrackedFiles && n.untrackedFiles.length) {
      e.untrackedFiles = [];
      for (let o = 0; o < n.untrackedFiles.length; ++o)
        e.untrackedFiles[o] = n.untrackedFiles[o];
    }
    if (n.uncommittedFiles && n.uncommittedFiles.length) {
      e.uncommittedFiles = [];
      for (let o = 0; o < n.uncommittedFiles.length; ++o)
        e.uncommittedFiles[o] = n.uncommittedFiles[o];
    }
    return n.state != null && n.hasOwnProperty("state") && (e.state = t.enums === String ? $root.GitInfo.GitStates[n.state] === void 0 ? n.state : $root.GitInfo.GitStates[n.state] : n.state), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/GitInfo";
  }, r.GitStates = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "DEFAULT"] = 0, n[c[1] = "HEAD_DETACHED"] = 1, n[c[2] = "AHEAD_OF_REMOTE"] = 2, n;
  })(), r;
})();
$root.Logo = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.image = "", r.prototype.link = "", r.prototype.iconImage = "", r.prototype.size = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.image != null && Object.hasOwnProperty.call(n, "image") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.image), n.link != null && Object.hasOwnProperty.call(n, "link") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.link), n.iconImage != null && Object.hasOwnProperty.call(n, "iconImage") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.iconImage), n.size != null && Object.hasOwnProperty.call(n, "size") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.size), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Logo();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.image = n.string();
          break;
        }
        case 2: {
          p.link = n.string();
          break;
        }
        case 3: {
          p.iconImage = n.string();
          break;
        }
        case 4: {
          p.size = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.image != null && n.hasOwnProperty("image") && !$util.isString(n.image) ? "image: string expected" : n.link != null && n.hasOwnProperty("link") && !$util.isString(n.link) ? "link: string expected" : n.iconImage != null && n.hasOwnProperty("iconImage") && !$util.isString(n.iconImage) ? "iconImage: string expected" : n.size != null && n.hasOwnProperty("size") && !$util.isString(n.size) ? "size: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Logo)
      return n;
    let t = new $root.Logo();
    return n.image != null && (t.image = String(n.image)), n.link != null && (t.link = String(n.link)), n.iconImage != null && (t.iconImage = String(n.iconImage)), n.size != null && (t.size = String(n.size)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.image = "", e.link = "", e.iconImage = "", e.size = ""), n.image != null && n.hasOwnProperty("image") && (e.image = n.image), n.link != null && n.hasOwnProperty("link") && (e.link = n.link), n.iconImage != null && n.hasOwnProperty("iconImage") && (e.iconImage = n.iconImage), n.size != null && n.hasOwnProperty("size") && (e.size = n.size), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Logo";
  }, r;
})();
$root.Navigation = (() => {
  function r(c) {
    if (this.sections = [], this.appPages = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.sections = $util.emptyArray, r.prototype.appPages = $util.emptyArray, r.prototype.position = 0, r.prototype.pageScriptHash = "", r.prototype.expanded = !1, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.sections != null && n.sections.length)
      for (let e = 0; e < n.sections.length; ++e)
        t.uint32(
          /* id 1, wireType 2 =*/
          10
        ).string(n.sections[e]);
    if (n.appPages != null && n.appPages.length)
      for (let e = 0; e < n.appPages.length; ++e)
        $root.AppPage.encode(n.appPages[e], t.uint32(
          /* id 2, wireType 2 =*/
          18
        ).fork()).ldelim();
    return n.position != null && Object.hasOwnProperty.call(n, "position") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(n.position), n.pageScriptHash != null && Object.hasOwnProperty.call(n, "pageScriptHash") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.pageScriptHash), n.expanded != null && Object.hasOwnProperty.call(n, "expanded") && t.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(n.expanded), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Navigation();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.sections && p.sections.length || (p.sections = []), p.sections.push(n.string());
          break;
        }
        case 2: {
          p.appPages && p.appPages.length || (p.appPages = []), p.appPages.push($root.AppPage.decode(n, n.uint32()));
          break;
        }
        case 3: {
          p.position = n.int32();
          break;
        }
        case 4: {
          p.pageScriptHash = n.string();
          break;
        }
        case 5: {
          p.expanded = n.bool();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.sections != null && n.hasOwnProperty("sections")) {
      if (!Array.isArray(n.sections))
        return "sections: array expected";
      for (let t = 0; t < n.sections.length; ++t)
        if (!$util.isString(n.sections[t]))
          return "sections: string[] expected";
    }
    if (n.appPages != null && n.hasOwnProperty("appPages")) {
      if (!Array.isArray(n.appPages))
        return "appPages: array expected";
      for (let t = 0; t < n.appPages.length; ++t) {
        let e = $root.AppPage.verify(n.appPages[t]);
        if (e)
          return "appPages." + e;
      }
    }
    if (n.position != null && n.hasOwnProperty("position"))
      switch (n.position) {
        default:
          return "position: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    return n.pageScriptHash != null && n.hasOwnProperty("pageScriptHash") && !$util.isString(n.pageScriptHash) ? "pageScriptHash: string expected" : n.expanded != null && n.hasOwnProperty("expanded") && typeof n.expanded != "boolean" ? "expanded: boolean expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Navigation)
      return n;
    let t = new $root.Navigation();
    if (n.sections) {
      if (!Array.isArray(n.sections))
        throw TypeError(".Navigation.sections: array expected");
      t.sections = [];
      for (let e = 0; e < n.sections.length; ++e)
        t.sections[e] = String(n.sections[e]);
    }
    if (n.appPages) {
      if (!Array.isArray(n.appPages))
        throw TypeError(".Navigation.appPages: array expected");
      t.appPages = [];
      for (let e = 0; e < n.appPages.length; ++e) {
        if (typeof n.appPages[e] != "object")
          throw TypeError(".Navigation.appPages: object expected");
        t.appPages[e] = $root.AppPage.fromObject(n.appPages[e]);
      }
    }
    switch (n.position) {
      default:
        if (typeof n.position == "number") {
          t.position = n.position;
          break;
        }
        break;
      case "HIDDEN":
      case 0:
        t.position = 0;
        break;
      case "SIDEBAR":
      case 1:
        t.position = 1;
        break;
      case "TOP":
      case 2:
        t.position = 2;
        break;
    }
    return n.pageScriptHash != null && (t.pageScriptHash = String(n.pageScriptHash)), n.expanded != null && (t.expanded = !!n.expanded), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.sections = [], e.appPages = []), t.defaults && (e.position = t.enums === String ? "HIDDEN" : 0, e.pageScriptHash = "", e.expanded = !1), n.sections && n.sections.length) {
      e.sections = [];
      for (let o = 0; o < n.sections.length; ++o)
        e.sections[o] = n.sections[o];
    }
    if (n.appPages && n.appPages.length) {
      e.appPages = [];
      for (let o = 0; o < n.appPages.length; ++o)
        e.appPages[o] = $root.AppPage.toObject(n.appPages[o], t);
    }
    return n.position != null && n.hasOwnProperty("position") && (e.position = t.enums === String ? $root.Navigation.Position[n.position] === void 0 ? n.position : $root.Navigation.Position[n.position] : n.position), n.pageScriptHash != null && n.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = n.pageScriptHash), n.expanded != null && n.hasOwnProperty("expanded") && (e.expanded = n.expanded), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Navigation";
  }, r.Position = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "HIDDEN"] = 0, n[c[1] = "SIDEBAR"] = 1, n[c[2] = "TOP"] = 2, n;
  })(), r;
})();
$root.NewSession = (() => {
  function r(c) {
    if (this.appPages = [], this.fragmentIdsThisRun = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.initialize = null, r.prototype.scriptRunId = "", r.prototype.name = "", r.prototype.mainScriptPath = "", r.prototype.config = null, r.prototype.customTheme = null, r.prototype.appPages = $util.emptyArray, r.prototype.pageScriptHash = "", r.prototype.fragmentIdsThisRun = $util.emptyArray, r.prototype.mainScriptHash = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.initialize != null && Object.hasOwnProperty.call(n, "initialize") && $root.Initialize.encode(n.initialize, t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), n.scriptRunId != null && Object.hasOwnProperty.call(n, "scriptRunId") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.scriptRunId), n.name != null && Object.hasOwnProperty.call(n, "name") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.name), n.mainScriptPath != null && Object.hasOwnProperty.call(n, "mainScriptPath") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.mainScriptPath), n.config != null && Object.hasOwnProperty.call(n, "config") && $root.Config.encode(n.config, t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).fork()).ldelim(), n.customTheme != null && Object.hasOwnProperty.call(n, "customTheme") && $root.CustomThemeConfig.encode(n.customTheme, t.uint32(
      /* id 7, wireType 2 =*/
      58
    ).fork()).ldelim(), n.appPages != null && n.appPages.length)
      for (let e = 0; e < n.appPages.length; ++e)
        $root.AppPage.encode(n.appPages[e], t.uint32(
          /* id 8, wireType 2 =*/
          66
        ).fork()).ldelim();
    if (n.pageScriptHash != null && Object.hasOwnProperty.call(n, "pageScriptHash") && t.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(n.pageScriptHash), n.fragmentIdsThisRun != null && n.fragmentIdsThisRun.length)
      for (let e = 0; e < n.fragmentIdsThisRun.length; ++e)
        t.uint32(
          /* id 10, wireType 2 =*/
          82
        ).string(n.fragmentIdsThisRun[e]);
    return n.mainScriptHash != null && Object.hasOwnProperty.call(n, "mainScriptHash") && t.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(n.mainScriptHash), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.NewSession();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.initialize = $root.Initialize.decode(n, n.uint32());
          break;
        }
        case 2: {
          p.scriptRunId = n.string();
          break;
        }
        case 3: {
          p.name = n.string();
          break;
        }
        case 4: {
          p.mainScriptPath = n.string();
          break;
        }
        case 6: {
          p.config = $root.Config.decode(n, n.uint32());
          break;
        }
        case 7: {
          p.customTheme = $root.CustomThemeConfig.decode(n, n.uint32());
          break;
        }
        case 8: {
          p.appPages && p.appPages.length || (p.appPages = []), p.appPages.push($root.AppPage.decode(n, n.uint32()));
          break;
        }
        case 9: {
          p.pageScriptHash = n.string();
          break;
        }
        case 10: {
          p.fragmentIdsThisRun && p.fragmentIdsThisRun.length || (p.fragmentIdsThisRun = []), p.fragmentIdsThisRun.push(n.string());
          break;
        }
        case 11: {
          p.mainScriptHash = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.initialize != null && n.hasOwnProperty("initialize")) {
      let t = $root.Initialize.verify(n.initialize);
      if (t)
        return "initialize." + t;
    }
    if (n.scriptRunId != null && n.hasOwnProperty("scriptRunId") && !$util.isString(n.scriptRunId))
      return "scriptRunId: string expected";
    if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
      return "name: string expected";
    if (n.mainScriptPath != null && n.hasOwnProperty("mainScriptPath") && !$util.isString(n.mainScriptPath))
      return "mainScriptPath: string expected";
    if (n.config != null && n.hasOwnProperty("config")) {
      let t = $root.Config.verify(n.config);
      if (t)
        return "config." + t;
    }
    if (n.customTheme != null && n.hasOwnProperty("customTheme")) {
      let t = $root.CustomThemeConfig.verify(n.customTheme);
      if (t)
        return "customTheme." + t;
    }
    if (n.appPages != null && n.hasOwnProperty("appPages")) {
      if (!Array.isArray(n.appPages))
        return "appPages: array expected";
      for (let t = 0; t < n.appPages.length; ++t) {
        let e = $root.AppPage.verify(n.appPages[t]);
        if (e)
          return "appPages." + e;
      }
    }
    if (n.pageScriptHash != null && n.hasOwnProperty("pageScriptHash") && !$util.isString(n.pageScriptHash))
      return "pageScriptHash: string expected";
    if (n.fragmentIdsThisRun != null && n.hasOwnProperty("fragmentIdsThisRun")) {
      if (!Array.isArray(n.fragmentIdsThisRun))
        return "fragmentIdsThisRun: array expected";
      for (let t = 0; t < n.fragmentIdsThisRun.length; ++t)
        if (!$util.isString(n.fragmentIdsThisRun[t]))
          return "fragmentIdsThisRun: string[] expected";
    }
    return n.mainScriptHash != null && n.hasOwnProperty("mainScriptHash") && !$util.isString(n.mainScriptHash) ? "mainScriptHash: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.NewSession)
      return n;
    let t = new $root.NewSession();
    if (n.initialize != null) {
      if (typeof n.initialize != "object")
        throw TypeError(".NewSession.initialize: object expected");
      t.initialize = $root.Initialize.fromObject(n.initialize);
    }
    if (n.scriptRunId != null && (t.scriptRunId = String(n.scriptRunId)), n.name != null && (t.name = String(n.name)), n.mainScriptPath != null && (t.mainScriptPath = String(n.mainScriptPath)), n.config != null) {
      if (typeof n.config != "object")
        throw TypeError(".NewSession.config: object expected");
      t.config = $root.Config.fromObject(n.config);
    }
    if (n.customTheme != null) {
      if (typeof n.customTheme != "object")
        throw TypeError(".NewSession.customTheme: object expected");
      t.customTheme = $root.CustomThemeConfig.fromObject(n.customTheme);
    }
    if (n.appPages) {
      if (!Array.isArray(n.appPages))
        throw TypeError(".NewSession.appPages: array expected");
      t.appPages = [];
      for (let e = 0; e < n.appPages.length; ++e) {
        if (typeof n.appPages[e] != "object")
          throw TypeError(".NewSession.appPages: object expected");
        t.appPages[e] = $root.AppPage.fromObject(n.appPages[e]);
      }
    }
    if (n.pageScriptHash != null && (t.pageScriptHash = String(n.pageScriptHash)), n.fragmentIdsThisRun) {
      if (!Array.isArray(n.fragmentIdsThisRun))
        throw TypeError(".NewSession.fragmentIdsThisRun: array expected");
      t.fragmentIdsThisRun = [];
      for (let e = 0; e < n.fragmentIdsThisRun.length; ++e)
        t.fragmentIdsThisRun[e] = String(n.fragmentIdsThisRun[e]);
    }
    return n.mainScriptHash != null && (t.mainScriptHash = String(n.mainScriptHash)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.appPages = [], e.fragmentIdsThisRun = []), t.defaults && (e.initialize = null, e.scriptRunId = "", e.name = "", e.mainScriptPath = "", e.config = null, e.customTheme = null, e.pageScriptHash = "", e.mainScriptHash = ""), n.initialize != null && n.hasOwnProperty("initialize") && (e.initialize = $root.Initialize.toObject(n.initialize, t)), n.scriptRunId != null && n.hasOwnProperty("scriptRunId") && (e.scriptRunId = n.scriptRunId), n.name != null && n.hasOwnProperty("name") && (e.name = n.name), n.mainScriptPath != null && n.hasOwnProperty("mainScriptPath") && (e.mainScriptPath = n.mainScriptPath), n.config != null && n.hasOwnProperty("config") && (e.config = $root.Config.toObject(n.config, t)), n.customTheme != null && n.hasOwnProperty("customTheme") && (e.customTheme = $root.CustomThemeConfig.toObject(n.customTheme, t)), n.appPages && n.appPages.length) {
      e.appPages = [];
      for (let o = 0; o < n.appPages.length; ++o)
        e.appPages[o] = $root.AppPage.toObject(n.appPages[o], t);
    }
    if (n.pageScriptHash != null && n.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = n.pageScriptHash), n.fragmentIdsThisRun && n.fragmentIdsThisRun.length) {
      e.fragmentIdsThisRun = [];
      for (let o = 0; o < n.fragmentIdsThisRun.length; ++o)
        e.fragmentIdsThisRun[o] = n.fragmentIdsThisRun[o];
    }
    return n.mainScriptHash != null && n.hasOwnProperty("mainScriptHash") && (e.mainScriptHash = n.mainScriptHash), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/NewSession";
  }, r;
})();
$root.Initialize = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.userInfo = null, r.prototype.environmentInfo = null, r.prototype.sessionStatus = null, r.prototype.commandLine = "", r.prototype.sessionId = "", r.prototype.isHello = !1, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.userInfo != null && Object.hasOwnProperty.call(n, "userInfo") && $root.UserInfo.encode(n.userInfo, t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).fork()).ldelim(), n.environmentInfo != null && Object.hasOwnProperty.call(n, "environmentInfo") && $root.EnvironmentInfo.encode(n.environmentInfo, t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), n.sessionStatus != null && Object.hasOwnProperty.call(n, "sessionStatus") && $root.SessionStatus.encode(n.sessionStatus, t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).fork()).ldelim(), n.commandLine != null && Object.hasOwnProperty.call(n, "commandLine") && t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(n.commandLine), n.sessionId != null && Object.hasOwnProperty.call(n, "sessionId") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.sessionId), n.isHello != null && Object.hasOwnProperty.call(n, "isHello") && t.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(n.isHello), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Initialize();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.userInfo = $root.UserInfo.decode(n, n.uint32());
          break;
        }
        case 3: {
          p.environmentInfo = $root.EnvironmentInfo.decode(n, n.uint32());
          break;
        }
        case 4: {
          p.sessionStatus = $root.SessionStatus.decode(n, n.uint32());
          break;
        }
        case 5: {
          p.commandLine = n.string();
          break;
        }
        case 6: {
          p.sessionId = n.string();
          break;
        }
        case 7: {
          p.isHello = n.bool();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.userInfo != null && n.hasOwnProperty("userInfo")) {
      let t = $root.UserInfo.verify(n.userInfo);
      if (t)
        return "userInfo." + t;
    }
    if (n.environmentInfo != null && n.hasOwnProperty("environmentInfo")) {
      let t = $root.EnvironmentInfo.verify(n.environmentInfo);
      if (t)
        return "environmentInfo." + t;
    }
    if (n.sessionStatus != null && n.hasOwnProperty("sessionStatus")) {
      let t = $root.SessionStatus.verify(n.sessionStatus);
      if (t)
        return "sessionStatus." + t;
    }
    return n.commandLine != null && n.hasOwnProperty("commandLine") && !$util.isString(n.commandLine) ? "commandLine: string expected" : n.sessionId != null && n.hasOwnProperty("sessionId") && !$util.isString(n.sessionId) ? "sessionId: string expected" : n.isHello != null && n.hasOwnProperty("isHello") && typeof n.isHello != "boolean" ? "isHello: boolean expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Initialize)
      return n;
    let t = new $root.Initialize();
    if (n.userInfo != null) {
      if (typeof n.userInfo != "object")
        throw TypeError(".Initialize.userInfo: object expected");
      t.userInfo = $root.UserInfo.fromObject(n.userInfo);
    }
    if (n.environmentInfo != null) {
      if (typeof n.environmentInfo != "object")
        throw TypeError(".Initialize.environmentInfo: object expected");
      t.environmentInfo = $root.EnvironmentInfo.fromObject(n.environmentInfo);
    }
    if (n.sessionStatus != null) {
      if (typeof n.sessionStatus != "object")
        throw TypeError(".Initialize.sessionStatus: object expected");
      t.sessionStatus = $root.SessionStatus.fromObject(n.sessionStatus);
    }
    return n.commandLine != null && (t.commandLine = String(n.commandLine)), n.sessionId != null && (t.sessionId = String(n.sessionId)), n.isHello != null && (t.isHello = !!n.isHello), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.userInfo = null, e.environmentInfo = null, e.sessionStatus = null, e.commandLine = "", e.sessionId = "", e.isHello = !1), n.userInfo != null && n.hasOwnProperty("userInfo") && (e.userInfo = $root.UserInfo.toObject(n.userInfo, t)), n.environmentInfo != null && n.hasOwnProperty("environmentInfo") && (e.environmentInfo = $root.EnvironmentInfo.toObject(n.environmentInfo, t)), n.sessionStatus != null && n.hasOwnProperty("sessionStatus") && (e.sessionStatus = $root.SessionStatus.toObject(n.sessionStatus, t)), n.commandLine != null && n.hasOwnProperty("commandLine") && (e.commandLine = n.commandLine), n.sessionId != null && n.hasOwnProperty("sessionId") && (e.sessionId = n.sessionId), n.isHello != null && n.hasOwnProperty("isHello") && (e.isHello = n.isHello), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Initialize";
  }, r;
})();
$root.Config = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.gatherUsageStats = !1, r.prototype.maxCachedMessageAge = 0, r.prototype.mapboxToken = "", r.prototype.allowRunOnSave = !1, r.prototype.hideTopBar = !1, r.prototype.hideSidebarNav = !1, r.prototype.toolbarMode = 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.gatherUsageStats != null && Object.hasOwnProperty.call(n, "gatherUsageStats") && t.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(n.gatherUsageStats), n.maxCachedMessageAge != null && Object.hasOwnProperty.call(n, "maxCachedMessageAge") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(n.maxCachedMessageAge), n.mapboxToken != null && Object.hasOwnProperty.call(n, "mapboxToken") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.mapboxToken), n.allowRunOnSave != null && Object.hasOwnProperty.call(n, "allowRunOnSave") && t.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(n.allowRunOnSave), n.hideTopBar != null && Object.hasOwnProperty.call(n, "hideTopBar") && t.uint32(
      /* id 6, wireType 0 =*/
      48
    ).bool(n.hideTopBar), n.hideSidebarNav != null && Object.hasOwnProperty.call(n, "hideSidebarNav") && t.uint32(
      /* id 7, wireType 0 =*/
      56
    ).bool(n.hideSidebarNav), n.toolbarMode != null && Object.hasOwnProperty.call(n, "toolbarMode") && t.uint32(
      /* id 8, wireType 0 =*/
      64
    ).int32(n.toolbarMode), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Config();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 2: {
          p.gatherUsageStats = n.bool();
          break;
        }
        case 3: {
          p.maxCachedMessageAge = n.int32();
          break;
        }
        case 4: {
          p.mapboxToken = n.string();
          break;
        }
        case 5: {
          p.allowRunOnSave = n.bool();
          break;
        }
        case 6: {
          p.hideTopBar = n.bool();
          break;
        }
        case 7: {
          p.hideSidebarNav = n.bool();
          break;
        }
        case 8: {
          p.toolbarMode = n.int32();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.gatherUsageStats != null && n.hasOwnProperty("gatherUsageStats") && typeof n.gatherUsageStats != "boolean")
      return "gatherUsageStats: boolean expected";
    if (n.maxCachedMessageAge != null && n.hasOwnProperty("maxCachedMessageAge") && !$util.isInteger(n.maxCachedMessageAge))
      return "maxCachedMessageAge: integer expected";
    if (n.mapboxToken != null && n.hasOwnProperty("mapboxToken") && !$util.isString(n.mapboxToken))
      return "mapboxToken: string expected";
    if (n.allowRunOnSave != null && n.hasOwnProperty("allowRunOnSave") && typeof n.allowRunOnSave != "boolean")
      return "allowRunOnSave: boolean expected";
    if (n.hideTopBar != null && n.hasOwnProperty("hideTopBar") && typeof n.hideTopBar != "boolean")
      return "hideTopBar: boolean expected";
    if (n.hideSidebarNav != null && n.hasOwnProperty("hideSidebarNav") && typeof n.hideSidebarNav != "boolean")
      return "hideSidebarNav: boolean expected";
    if (n.toolbarMode != null && n.hasOwnProperty("toolbarMode"))
      switch (n.toolbarMode) {
        default:
          return "toolbarMode: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
          break;
      }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Config)
      return n;
    let t = new $root.Config();
    switch (n.gatherUsageStats != null && (t.gatherUsageStats = !!n.gatherUsageStats), n.maxCachedMessageAge != null && (t.maxCachedMessageAge = n.maxCachedMessageAge | 0), n.mapboxToken != null && (t.mapboxToken = String(n.mapboxToken)), n.allowRunOnSave != null && (t.allowRunOnSave = !!n.allowRunOnSave), n.hideTopBar != null && (t.hideTopBar = !!n.hideTopBar), n.hideSidebarNav != null && (t.hideSidebarNav = !!n.hideSidebarNav), n.toolbarMode) {
      default:
        if (typeof n.toolbarMode == "number") {
          t.toolbarMode = n.toolbarMode;
          break;
        }
        break;
      case "AUTO":
      case 0:
        t.toolbarMode = 0;
        break;
      case "DEVELOPER":
      case 1:
        t.toolbarMode = 1;
        break;
      case "VIEWER":
      case 2:
        t.toolbarMode = 2;
        break;
      case "MINIMAL":
      case 3:
        t.toolbarMode = 3;
        break;
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.gatherUsageStats = !1, e.maxCachedMessageAge = 0, e.mapboxToken = "", e.allowRunOnSave = !1, e.hideTopBar = !1, e.hideSidebarNav = !1, e.toolbarMode = t.enums === String ? "AUTO" : 0), n.gatherUsageStats != null && n.hasOwnProperty("gatherUsageStats") && (e.gatherUsageStats = n.gatherUsageStats), n.maxCachedMessageAge != null && n.hasOwnProperty("maxCachedMessageAge") && (e.maxCachedMessageAge = n.maxCachedMessageAge), n.mapboxToken != null && n.hasOwnProperty("mapboxToken") && (e.mapboxToken = n.mapboxToken), n.allowRunOnSave != null && n.hasOwnProperty("allowRunOnSave") && (e.allowRunOnSave = n.allowRunOnSave), n.hideTopBar != null && n.hasOwnProperty("hideTopBar") && (e.hideTopBar = n.hideTopBar), n.hideSidebarNav != null && n.hasOwnProperty("hideSidebarNav") && (e.hideSidebarNav = n.hideSidebarNav), n.toolbarMode != null && n.hasOwnProperty("toolbarMode") && (e.toolbarMode = t.enums === String ? $root.Config.ToolbarMode[n.toolbarMode] === void 0 ? n.toolbarMode : $root.Config.ToolbarMode[n.toolbarMode] : n.toolbarMode), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Config";
  }, r.ToolbarMode = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "AUTO"] = 0, n[c[1] = "DEVELOPER"] = 1, n[c[2] = "VIEWER"] = 2, n[c[3] = "MINIMAL"] = 3, n;
  })(), r;
})();
$root.CustomThemeConfig = (() => {
  function r(n) {
    if (this.fontFaces = [], this.fontSources = [], this.headingFontSizes = [], this.headingFontWeights = [], this.chartCategoricalColors = [], this.chartSequentialColors = [], n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.primaryColor = "", r.prototype.secondaryBackgroundColor = "", r.prototype.backgroundColor = "", r.prototype.textColor = "", r.prototype.font = 0, r.prototype.base = 0, r.prototype.widgetBackgroundColor = "", r.prototype.widgetBorderColor = "", r.prototype.radii = null, r.prototype.headingFont = "", r.prototype.bodyFont = "", r.prototype.codeFont = "", r.prototype.fontFaces = $util.emptyArray, r.prototype.fontSources = $util.emptyArray, r.prototype.fontSizes = null, r.prototype.skeletonBackgroundColor = "", r.prototype.baseRadius = null, r.prototype.buttonRadius = null, r.prototype.borderColor = null, r.prototype.dataframeBorderColor = null, r.prototype.showWidgetBorder = null, r.prototype.linkColor = null, r.prototype.linkUnderline = null, r.prototype.baseFontSize = null, r.prototype.baseFontWeight = null, r.prototype.codeFontWeight = null, r.prototype.codeFontSize = null, r.prototype.headingFontSizes = $util.emptyArray, r.prototype.headingFontWeights = $util.emptyArray, r.prototype.showSidebarBorder = null, r.prototype.sidebar = null, r.prototype.codeBackgroundColor = null, r.prototype.dataframeHeaderBackgroundColor = null, r.prototype.chartCategoricalColors = $util.emptyArray, r.prototype.chartSequentialColors = $util.emptyArray, r.prototype.redColor = null, r.prototype.orangeColor = null, r.prototype.yellowColor = null, r.prototype.blueColor = null, r.prototype.greenColor = null, r.prototype.violetColor = null, r.prototype.grayColor = null, r.prototype.redBackgroundColor = null, r.prototype.orangeBackgroundColor = null, r.prototype.yellowBackgroundColor = null, r.prototype.blueBackgroundColor = null, r.prototype.greenBackgroundColor = null, r.prototype.violetBackgroundColor = null, r.prototype.grayBackgroundColor = null, r.prototype.redTextColor = null, r.prototype.orangeTextColor = null, r.prototype.yellowTextColor = null, r.prototype.blueTextColor = null, r.prototype.greenTextColor = null, r.prototype.violetTextColor = null, r.prototype.grayTextColor = null;
  let c;
  return Object.defineProperty(r.prototype, "_baseRadius", {
    get: $util.oneOfGetter(c = ["baseRadius"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_buttonRadius", {
    get: $util.oneOfGetter(c = ["buttonRadius"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_borderColor", {
    get: $util.oneOfGetter(c = ["borderColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_dataframeBorderColor", {
    get: $util.oneOfGetter(c = ["dataframeBorderColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_showWidgetBorder", {
    get: $util.oneOfGetter(c = ["showWidgetBorder"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_linkColor", {
    get: $util.oneOfGetter(c = ["linkColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_linkUnderline", {
    get: $util.oneOfGetter(c = ["linkUnderline"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_baseFontSize", {
    get: $util.oneOfGetter(c = ["baseFontSize"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_baseFontWeight", {
    get: $util.oneOfGetter(c = ["baseFontWeight"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_codeFontWeight", {
    get: $util.oneOfGetter(c = ["codeFontWeight"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_codeFontSize", {
    get: $util.oneOfGetter(c = ["codeFontSize"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_showSidebarBorder", {
    get: $util.oneOfGetter(c = ["showSidebarBorder"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_sidebar", {
    get: $util.oneOfGetter(c = ["sidebar"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_codeBackgroundColor", {
    get: $util.oneOfGetter(c = ["codeBackgroundColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_dataframeHeaderBackgroundColor", {
    get: $util.oneOfGetter(c = ["dataframeHeaderBackgroundColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_redColor", {
    get: $util.oneOfGetter(c = ["redColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_orangeColor", {
    get: $util.oneOfGetter(c = ["orangeColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_yellowColor", {
    get: $util.oneOfGetter(c = ["yellowColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_blueColor", {
    get: $util.oneOfGetter(c = ["blueColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_greenColor", {
    get: $util.oneOfGetter(c = ["greenColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_violetColor", {
    get: $util.oneOfGetter(c = ["violetColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_grayColor", {
    get: $util.oneOfGetter(c = ["grayColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_redBackgroundColor", {
    get: $util.oneOfGetter(c = ["redBackgroundColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_orangeBackgroundColor", {
    get: $util.oneOfGetter(c = ["orangeBackgroundColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_yellowBackgroundColor", {
    get: $util.oneOfGetter(c = ["yellowBackgroundColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_blueBackgroundColor", {
    get: $util.oneOfGetter(c = ["blueBackgroundColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_greenBackgroundColor", {
    get: $util.oneOfGetter(c = ["greenBackgroundColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_violetBackgroundColor", {
    get: $util.oneOfGetter(c = ["violetBackgroundColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_grayBackgroundColor", {
    get: $util.oneOfGetter(c = ["grayBackgroundColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_redTextColor", {
    get: $util.oneOfGetter(c = ["redTextColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_orangeTextColor", {
    get: $util.oneOfGetter(c = ["orangeTextColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_yellowTextColor", {
    get: $util.oneOfGetter(c = ["yellowTextColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_blueTextColor", {
    get: $util.oneOfGetter(c = ["blueTextColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_greenTextColor", {
    get: $util.oneOfGetter(c = ["greenTextColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_violetTextColor", {
    get: $util.oneOfGetter(c = ["violetTextColor"]),
    set: $util.oneOfSetter(c)
  }), Object.defineProperty(r.prototype, "_grayTextColor", {
    get: $util.oneOfGetter(c = ["grayTextColor"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    if (e || (e = $Writer.create()), t.primaryColor != null && Object.hasOwnProperty.call(t, "primaryColor") && e.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(t.primaryColor), t.secondaryBackgroundColor != null && Object.hasOwnProperty.call(t, "secondaryBackgroundColor") && e.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(t.secondaryBackgroundColor), t.backgroundColor != null && Object.hasOwnProperty.call(t, "backgroundColor") && e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(t.backgroundColor), t.textColor != null && Object.hasOwnProperty.call(t, "textColor") && e.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(t.textColor), t.font != null && Object.hasOwnProperty.call(t, "font") && e.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(t.font), t.base != null && Object.hasOwnProperty.call(t, "base") && e.uint32(
      /* id 6, wireType 0 =*/
      48
    ).int32(t.base), t.widgetBackgroundColor != null && Object.hasOwnProperty.call(t, "widgetBackgroundColor") && e.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(t.widgetBackgroundColor), t.widgetBorderColor != null && Object.hasOwnProperty.call(t, "widgetBorderColor") && e.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(t.widgetBorderColor), t.radii != null && Object.hasOwnProperty.call(t, "radii") && $root.Radii.encode(t.radii, e.uint32(
      /* id 9, wireType 2 =*/
      74
    ).fork()).ldelim(), t.headingFont != null && Object.hasOwnProperty.call(t, "headingFont") && e.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(t.headingFont), t.bodyFont != null && Object.hasOwnProperty.call(t, "bodyFont") && e.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(t.bodyFont), t.codeFont != null && Object.hasOwnProperty.call(t, "codeFont") && e.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(t.codeFont), t.fontFaces != null && t.fontFaces.length)
      for (let o = 0; o < t.fontFaces.length; ++o)
        $root.FontFace.encode(t.fontFaces[o], e.uint32(
          /* id 15, wireType 2 =*/
          122
        ).fork()).ldelim();
    if (t.fontSizes != null && Object.hasOwnProperty.call(t, "fontSizes") && $root.FontSizes.encode(t.fontSizes, e.uint32(
      /* id 16, wireType 2 =*/
      130
    ).fork()).ldelim(), t.skeletonBackgroundColor != null && Object.hasOwnProperty.call(t, "skeletonBackgroundColor") && e.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(t.skeletonBackgroundColor), t.baseRadius != null && Object.hasOwnProperty.call(t, "baseRadius") && e.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(t.baseRadius), t.borderColor != null && Object.hasOwnProperty.call(t, "borderColor") && e.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(t.borderColor), t.showWidgetBorder != null && Object.hasOwnProperty.call(t, "showWidgetBorder") && e.uint32(
      /* id 20, wireType 0 =*/
      160
    ).bool(t.showWidgetBorder), t.linkColor != null && Object.hasOwnProperty.call(t, "linkColor") && e.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(t.linkColor), t.baseFontSize != null && Object.hasOwnProperty.call(t, "baseFontSize") && e.uint32(
      /* id 22, wireType 0 =*/
      176
    ).int32(t.baseFontSize), t.showSidebarBorder != null && Object.hasOwnProperty.call(t, "showSidebarBorder") && e.uint32(
      /* id 23, wireType 0 =*/
      184
    ).bool(t.showSidebarBorder), t.sidebar != null && Object.hasOwnProperty.call(t, "sidebar") && $root.CustomThemeConfig.encode(t.sidebar, e.uint32(
      /* id 24, wireType 2 =*/
      194
    ).fork()).ldelim(), t.codeBackgroundColor != null && Object.hasOwnProperty.call(t, "codeBackgroundColor") && e.uint32(
      /* id 25, wireType 2 =*/
      202
    ).string(t.codeBackgroundColor), t.buttonRadius != null && Object.hasOwnProperty.call(t, "buttonRadius") && e.uint32(
      /* id 26, wireType 2 =*/
      210
    ).string(t.buttonRadius), t.dataframeBorderColor != null && Object.hasOwnProperty.call(t, "dataframeBorderColor") && e.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(t.dataframeBorderColor), t.codeFontSize != null && Object.hasOwnProperty.call(t, "codeFontSize") && e.uint32(
      /* id 28, wireType 2 =*/
      226
    ).string(t.codeFontSize), t.linkUnderline != null && Object.hasOwnProperty.call(t, "linkUnderline") && e.uint32(
      /* id 29, wireType 0 =*/
      232
    ).bool(t.linkUnderline), t.baseFontWeight != null && Object.hasOwnProperty.call(t, "baseFontWeight") && e.uint32(
      /* id 30, wireType 0 =*/
      240
    ).int32(t.baseFontWeight), t.dataframeHeaderBackgroundColor != null && Object.hasOwnProperty.call(t, "dataframeHeaderBackgroundColor") && e.uint32(
      /* id 31, wireType 2 =*/
      250
    ).string(t.dataframeHeaderBackgroundColor), t.codeFontWeight != null && Object.hasOwnProperty.call(t, "codeFontWeight") && e.uint32(
      /* id 32, wireType 0 =*/
      256
    ).int32(t.codeFontWeight), t.chartCategoricalColors != null && t.chartCategoricalColors.length)
      for (let o = 0; o < t.chartCategoricalColors.length; ++o)
        e.uint32(
          /* id 33, wireType 2 =*/
          266
        ).string(t.chartCategoricalColors[o]);
    if (t.headingFontWeights != null && t.headingFontWeights.length) {
      e.uint32(
        /* id 34, wireType 2 =*/
        274
      ).fork();
      for (let o = 0; o < t.headingFontWeights.length; ++o)
        e.int32(t.headingFontWeights[o]);
      e.ldelim();
    }
    if (t.headingFontSizes != null && t.headingFontSizes.length)
      for (let o = 0; o < t.headingFontSizes.length; ++o)
        e.uint32(
          /* id 35, wireType 2 =*/
          282
        ).string(t.headingFontSizes[o]);
    if (t.chartSequentialColors != null && t.chartSequentialColors.length)
      for (let o = 0; o < t.chartSequentialColors.length; ++o)
        e.uint32(
          /* id 36, wireType 2 =*/
          290
        ).string(t.chartSequentialColors[o]);
    if (t.fontSources != null && t.fontSources.length)
      for (let o = 0; o < t.fontSources.length; ++o)
        $root.FontSource.encode(t.fontSources[o], e.uint32(
          /* id 37, wireType 2 =*/
          298
        ).fork()).ldelim();
    return t.redColor != null && Object.hasOwnProperty.call(t, "redColor") && e.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(t.redColor), t.orangeColor != null && Object.hasOwnProperty.call(t, "orangeColor") && e.uint32(
      /* id 39, wireType 2 =*/
      314
    ).string(t.orangeColor), t.yellowColor != null && Object.hasOwnProperty.call(t, "yellowColor") && e.uint32(
      /* id 40, wireType 2 =*/
      322
    ).string(t.yellowColor), t.blueColor != null && Object.hasOwnProperty.call(t, "blueColor") && e.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(t.blueColor), t.greenColor != null && Object.hasOwnProperty.call(t, "greenColor") && e.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(t.greenColor), t.violetColor != null && Object.hasOwnProperty.call(t, "violetColor") && e.uint32(
      /* id 43, wireType 2 =*/
      346
    ).string(t.violetColor), t.grayColor != null && Object.hasOwnProperty.call(t, "grayColor") && e.uint32(
      /* id 44, wireType 2 =*/
      354
    ).string(t.grayColor), t.redBackgroundColor != null && Object.hasOwnProperty.call(t, "redBackgroundColor") && e.uint32(
      /* id 45, wireType 2 =*/
      362
    ).string(t.redBackgroundColor), t.orangeBackgroundColor != null && Object.hasOwnProperty.call(t, "orangeBackgroundColor") && e.uint32(
      /* id 46, wireType 2 =*/
      370
    ).string(t.orangeBackgroundColor), t.yellowBackgroundColor != null && Object.hasOwnProperty.call(t, "yellowBackgroundColor") && e.uint32(
      /* id 47, wireType 2 =*/
      378
    ).string(t.yellowBackgroundColor), t.blueBackgroundColor != null && Object.hasOwnProperty.call(t, "blueBackgroundColor") && e.uint32(
      /* id 48, wireType 2 =*/
      386
    ).string(t.blueBackgroundColor), t.greenBackgroundColor != null && Object.hasOwnProperty.call(t, "greenBackgroundColor") && e.uint32(
      /* id 49, wireType 2 =*/
      394
    ).string(t.greenBackgroundColor), t.violetBackgroundColor != null && Object.hasOwnProperty.call(t, "violetBackgroundColor") && e.uint32(
      /* id 50, wireType 2 =*/
      402
    ).string(t.violetBackgroundColor), t.grayBackgroundColor != null && Object.hasOwnProperty.call(t, "grayBackgroundColor") && e.uint32(
      /* id 51, wireType 2 =*/
      410
    ).string(t.grayBackgroundColor), t.redTextColor != null && Object.hasOwnProperty.call(t, "redTextColor") && e.uint32(
      /* id 52, wireType 2 =*/
      418
    ).string(t.redTextColor), t.orangeTextColor != null && Object.hasOwnProperty.call(t, "orangeTextColor") && e.uint32(
      /* id 53, wireType 2 =*/
      426
    ).string(t.orangeTextColor), t.yellowTextColor != null && Object.hasOwnProperty.call(t, "yellowTextColor") && e.uint32(
      /* id 54, wireType 2 =*/
      434
    ).string(t.yellowTextColor), t.blueTextColor != null && Object.hasOwnProperty.call(t, "blueTextColor") && e.uint32(
      /* id 55, wireType 2 =*/
      442
    ).string(t.blueTextColor), t.greenTextColor != null && Object.hasOwnProperty.call(t, "greenTextColor") && e.uint32(
      /* id 56, wireType 2 =*/
      450
    ).string(t.greenTextColor), t.violetTextColor != null && Object.hasOwnProperty.call(t, "violetTextColor") && e.uint32(
      /* id 57, wireType 2 =*/
      458
    ).string(t.violetTextColor), t.grayTextColor != null && Object.hasOwnProperty.call(t, "grayTextColor") && e.uint32(
      /* id 58, wireType 2 =*/
      466
    ).string(t.grayTextColor), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.CustomThemeConfig();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.primaryColor = t.string();
          break;
        }
        case 2: {
          h.secondaryBackgroundColor = t.string();
          break;
        }
        case 3: {
          h.backgroundColor = t.string();
          break;
        }
        case 4: {
          h.textColor = t.string();
          break;
        }
        case 5: {
          h.font = t.int32();
          break;
        }
        case 6: {
          h.base = t.int32();
          break;
        }
        case 7: {
          h.widgetBackgroundColor = t.string();
          break;
        }
        case 8: {
          h.widgetBorderColor = t.string();
          break;
        }
        case 9: {
          h.radii = $root.Radii.decode(t, t.uint32());
          break;
        }
        case 12: {
          h.headingFont = t.string();
          break;
        }
        case 13: {
          h.bodyFont = t.string();
          break;
        }
        case 14: {
          h.codeFont = t.string();
          break;
        }
        case 15: {
          h.fontFaces && h.fontFaces.length || (h.fontFaces = []), h.fontFaces.push($root.FontFace.decode(t, t.uint32()));
          break;
        }
        case 37: {
          h.fontSources && h.fontSources.length || (h.fontSources = []), h.fontSources.push($root.FontSource.decode(t, t.uint32()));
          break;
        }
        case 16: {
          h.fontSizes = $root.FontSizes.decode(t, t.uint32());
          break;
        }
        case 17: {
          h.skeletonBackgroundColor = t.string();
          break;
        }
        case 18: {
          h.baseRadius = t.string();
          break;
        }
        case 26: {
          h.buttonRadius = t.string();
          break;
        }
        case 19: {
          h.borderColor = t.string();
          break;
        }
        case 27: {
          h.dataframeBorderColor = t.string();
          break;
        }
        case 20: {
          h.showWidgetBorder = t.bool();
          break;
        }
        case 21: {
          h.linkColor = t.string();
          break;
        }
        case 29: {
          h.linkUnderline = t.bool();
          break;
        }
        case 22: {
          h.baseFontSize = t.int32();
          break;
        }
        case 30: {
          h.baseFontWeight = t.int32();
          break;
        }
        case 32: {
          h.codeFontWeight = t.int32();
          break;
        }
        case 28: {
          h.codeFontSize = t.string();
          break;
        }
        case 35: {
          h.headingFontSizes && h.headingFontSizes.length || (h.headingFontSizes = []), h.headingFontSizes.push(t.string());
          break;
        }
        case 34: {
          if (h.headingFontWeights && h.headingFontWeights.length || (h.headingFontWeights = []), (y & 7) === 2) {
            let b = t.uint32() + t.pos;
            for (; t.pos < b; )
              h.headingFontWeights.push(t.int32());
          } else
            h.headingFontWeights.push(t.int32());
          break;
        }
        case 23: {
          h.showSidebarBorder = t.bool();
          break;
        }
        case 24: {
          h.sidebar = $root.CustomThemeConfig.decode(t, t.uint32());
          break;
        }
        case 25: {
          h.codeBackgroundColor = t.string();
          break;
        }
        case 31: {
          h.dataframeHeaderBackgroundColor = t.string();
          break;
        }
        case 33: {
          h.chartCategoricalColors && h.chartCategoricalColors.length || (h.chartCategoricalColors = []), h.chartCategoricalColors.push(t.string());
          break;
        }
        case 36: {
          h.chartSequentialColors && h.chartSequentialColors.length || (h.chartSequentialColors = []), h.chartSequentialColors.push(t.string());
          break;
        }
        case 38: {
          h.redColor = t.string();
          break;
        }
        case 39: {
          h.orangeColor = t.string();
          break;
        }
        case 40: {
          h.yellowColor = t.string();
          break;
        }
        case 41: {
          h.blueColor = t.string();
          break;
        }
        case 42: {
          h.greenColor = t.string();
          break;
        }
        case 43: {
          h.violetColor = t.string();
          break;
        }
        case 44: {
          h.grayColor = t.string();
          break;
        }
        case 45: {
          h.redBackgroundColor = t.string();
          break;
        }
        case 46: {
          h.orangeBackgroundColor = t.string();
          break;
        }
        case 47: {
          h.yellowBackgroundColor = t.string();
          break;
        }
        case 48: {
          h.blueBackgroundColor = t.string();
          break;
        }
        case 49: {
          h.greenBackgroundColor = t.string();
          break;
        }
        case 50: {
          h.violetBackgroundColor = t.string();
          break;
        }
        case 51: {
          h.grayBackgroundColor = t.string();
          break;
        }
        case 52: {
          h.redTextColor = t.string();
          break;
        }
        case 53: {
          h.orangeTextColor = t.string();
          break;
        }
        case 54: {
          h.yellowTextColor = t.string();
          break;
        }
        case 55: {
          h.blueTextColor = t.string();
          break;
        }
        case 56: {
          h.greenTextColor = t.string();
          break;
        }
        case 57: {
          h.violetTextColor = t.string();
          break;
        }
        case 58: {
          h.grayTextColor = t.string();
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    if (t.primaryColor != null && t.hasOwnProperty("primaryColor") && !$util.isString(t.primaryColor))
      return "primaryColor: string expected";
    if (t.secondaryBackgroundColor != null && t.hasOwnProperty("secondaryBackgroundColor") && !$util.isString(t.secondaryBackgroundColor))
      return "secondaryBackgroundColor: string expected";
    if (t.backgroundColor != null && t.hasOwnProperty("backgroundColor") && !$util.isString(t.backgroundColor))
      return "backgroundColor: string expected";
    if (t.textColor != null && t.hasOwnProperty("textColor") && !$util.isString(t.textColor))
      return "textColor: string expected";
    if (t.font != null && t.hasOwnProperty("font"))
      switch (t.font) {
        default:
          return "font: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    if (t.base != null && t.hasOwnProperty("base"))
      switch (t.base) {
        default:
          return "base: enum value expected";
        case 0:
        case 1:
          break;
      }
    if (t.widgetBackgroundColor != null && t.hasOwnProperty("widgetBackgroundColor") && !$util.isString(t.widgetBackgroundColor))
      return "widgetBackgroundColor: string expected";
    if (t.widgetBorderColor != null && t.hasOwnProperty("widgetBorderColor") && !$util.isString(t.widgetBorderColor))
      return "widgetBorderColor: string expected";
    if (t.radii != null && t.hasOwnProperty("radii")) {
      let e = $root.Radii.verify(t.radii);
      if (e)
        return "radii." + e;
    }
    if (t.headingFont != null && t.hasOwnProperty("headingFont") && !$util.isString(t.headingFont))
      return "headingFont: string expected";
    if (t.bodyFont != null && t.hasOwnProperty("bodyFont") && !$util.isString(t.bodyFont))
      return "bodyFont: string expected";
    if (t.codeFont != null && t.hasOwnProperty("codeFont") && !$util.isString(t.codeFont))
      return "codeFont: string expected";
    if (t.fontFaces != null && t.hasOwnProperty("fontFaces")) {
      if (!Array.isArray(t.fontFaces))
        return "fontFaces: array expected";
      for (let e = 0; e < t.fontFaces.length; ++e) {
        let o = $root.FontFace.verify(t.fontFaces[e]);
        if (o)
          return "fontFaces." + o;
      }
    }
    if (t.fontSources != null && t.hasOwnProperty("fontSources")) {
      if (!Array.isArray(t.fontSources))
        return "fontSources: array expected";
      for (let e = 0; e < t.fontSources.length; ++e) {
        let o = $root.FontSource.verify(t.fontSources[e]);
        if (o)
          return "fontSources." + o;
      }
    }
    if (t.fontSizes != null && t.hasOwnProperty("fontSizes")) {
      let e = $root.FontSizes.verify(t.fontSizes);
      if (e)
        return "fontSizes." + e;
    }
    if (t.skeletonBackgroundColor != null && t.hasOwnProperty("skeletonBackgroundColor") && !$util.isString(t.skeletonBackgroundColor))
      return "skeletonBackgroundColor: string expected";
    if (t.baseRadius != null && t.hasOwnProperty("baseRadius") && !$util.isString(t.baseRadius))
      return "baseRadius: string expected";
    if (t.buttonRadius != null && t.hasOwnProperty("buttonRadius") && !$util.isString(t.buttonRadius))
      return "buttonRadius: string expected";
    if (t.borderColor != null && t.hasOwnProperty("borderColor") && !$util.isString(t.borderColor))
      return "borderColor: string expected";
    if (t.dataframeBorderColor != null && t.hasOwnProperty("dataframeBorderColor") && !$util.isString(t.dataframeBorderColor))
      return "dataframeBorderColor: string expected";
    if (t.showWidgetBorder != null && t.hasOwnProperty("showWidgetBorder") && typeof t.showWidgetBorder != "boolean")
      return "showWidgetBorder: boolean expected";
    if (t.linkColor != null && t.hasOwnProperty("linkColor") && !$util.isString(t.linkColor))
      return "linkColor: string expected";
    if (t.linkUnderline != null && t.hasOwnProperty("linkUnderline") && typeof t.linkUnderline != "boolean")
      return "linkUnderline: boolean expected";
    if (t.baseFontSize != null && t.hasOwnProperty("baseFontSize") && !$util.isInteger(t.baseFontSize))
      return "baseFontSize: integer expected";
    if (t.baseFontWeight != null && t.hasOwnProperty("baseFontWeight") && !$util.isInteger(t.baseFontWeight))
      return "baseFontWeight: integer expected";
    if (t.codeFontWeight != null && t.hasOwnProperty("codeFontWeight") && !$util.isInteger(t.codeFontWeight))
      return "codeFontWeight: integer expected";
    if (t.codeFontSize != null && t.hasOwnProperty("codeFontSize") && !$util.isString(t.codeFontSize))
      return "codeFontSize: string expected";
    if (t.headingFontSizes != null && t.hasOwnProperty("headingFontSizes")) {
      if (!Array.isArray(t.headingFontSizes))
        return "headingFontSizes: array expected";
      for (let e = 0; e < t.headingFontSizes.length; ++e)
        if (!$util.isString(t.headingFontSizes[e]))
          return "headingFontSizes: string[] expected";
    }
    if (t.headingFontWeights != null && t.hasOwnProperty("headingFontWeights")) {
      if (!Array.isArray(t.headingFontWeights))
        return "headingFontWeights: array expected";
      for (let e = 0; e < t.headingFontWeights.length; ++e)
        if (!$util.isInteger(t.headingFontWeights[e]))
          return "headingFontWeights: integer[] expected";
    }
    if (t.showSidebarBorder != null && t.hasOwnProperty("showSidebarBorder") && typeof t.showSidebarBorder != "boolean")
      return "showSidebarBorder: boolean expected";
    if (t.sidebar != null && t.hasOwnProperty("sidebar")) {
      let e = $root.CustomThemeConfig.verify(t.sidebar);
      if (e)
        return "sidebar." + e;
    }
    if (t.codeBackgroundColor != null && t.hasOwnProperty("codeBackgroundColor") && !$util.isString(t.codeBackgroundColor))
      return "codeBackgroundColor: string expected";
    if (t.dataframeHeaderBackgroundColor != null && t.hasOwnProperty("dataframeHeaderBackgroundColor") && !$util.isString(t.dataframeHeaderBackgroundColor))
      return "dataframeHeaderBackgroundColor: string expected";
    if (t.chartCategoricalColors != null && t.hasOwnProperty("chartCategoricalColors")) {
      if (!Array.isArray(t.chartCategoricalColors))
        return "chartCategoricalColors: array expected";
      for (let e = 0; e < t.chartCategoricalColors.length; ++e)
        if (!$util.isString(t.chartCategoricalColors[e]))
          return "chartCategoricalColors: string[] expected";
    }
    if (t.chartSequentialColors != null && t.hasOwnProperty("chartSequentialColors")) {
      if (!Array.isArray(t.chartSequentialColors))
        return "chartSequentialColors: array expected";
      for (let e = 0; e < t.chartSequentialColors.length; ++e)
        if (!$util.isString(t.chartSequentialColors[e]))
          return "chartSequentialColors: string[] expected";
    }
    return t.redColor != null && t.hasOwnProperty("redColor") && !$util.isString(t.redColor) ? "redColor: string expected" : t.orangeColor != null && t.hasOwnProperty("orangeColor") && !$util.isString(t.orangeColor) ? "orangeColor: string expected" : t.yellowColor != null && t.hasOwnProperty("yellowColor") && !$util.isString(t.yellowColor) ? "yellowColor: string expected" : t.blueColor != null && t.hasOwnProperty("blueColor") && !$util.isString(t.blueColor) ? "blueColor: string expected" : t.greenColor != null && t.hasOwnProperty("greenColor") && !$util.isString(t.greenColor) ? "greenColor: string expected" : t.violetColor != null && t.hasOwnProperty("violetColor") && !$util.isString(t.violetColor) ? "violetColor: string expected" : t.grayColor != null && t.hasOwnProperty("grayColor") && !$util.isString(t.grayColor) ? "grayColor: string expected" : t.redBackgroundColor != null && t.hasOwnProperty("redBackgroundColor") && !$util.isString(t.redBackgroundColor) ? "redBackgroundColor: string expected" : t.orangeBackgroundColor != null && t.hasOwnProperty("orangeBackgroundColor") && !$util.isString(t.orangeBackgroundColor) ? "orangeBackgroundColor: string expected" : t.yellowBackgroundColor != null && t.hasOwnProperty("yellowBackgroundColor") && !$util.isString(t.yellowBackgroundColor) ? "yellowBackgroundColor: string expected" : t.blueBackgroundColor != null && t.hasOwnProperty("blueBackgroundColor") && !$util.isString(t.blueBackgroundColor) ? "blueBackgroundColor: string expected" : t.greenBackgroundColor != null && t.hasOwnProperty("greenBackgroundColor") && !$util.isString(t.greenBackgroundColor) ? "greenBackgroundColor: string expected" : t.violetBackgroundColor != null && t.hasOwnProperty("violetBackgroundColor") && !$util.isString(t.violetBackgroundColor) ? "violetBackgroundColor: string expected" : t.grayBackgroundColor != null && t.hasOwnProperty("grayBackgroundColor") && !$util.isString(t.grayBackgroundColor) ? "grayBackgroundColor: string expected" : t.redTextColor != null && t.hasOwnProperty("redTextColor") && !$util.isString(t.redTextColor) ? "redTextColor: string expected" : t.orangeTextColor != null && t.hasOwnProperty("orangeTextColor") && !$util.isString(t.orangeTextColor) ? "orangeTextColor: string expected" : t.yellowTextColor != null && t.hasOwnProperty("yellowTextColor") && !$util.isString(t.yellowTextColor) ? "yellowTextColor: string expected" : t.blueTextColor != null && t.hasOwnProperty("blueTextColor") && !$util.isString(t.blueTextColor) ? "blueTextColor: string expected" : t.greenTextColor != null && t.hasOwnProperty("greenTextColor") && !$util.isString(t.greenTextColor) ? "greenTextColor: string expected" : t.violetTextColor != null && t.hasOwnProperty("violetTextColor") && !$util.isString(t.violetTextColor) ? "violetTextColor: string expected" : t.grayTextColor != null && t.hasOwnProperty("grayTextColor") && !$util.isString(t.grayTextColor) ? "grayTextColor: string expected" : null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.CustomThemeConfig)
      return t;
    let e = new $root.CustomThemeConfig();
    switch (t.primaryColor != null && (e.primaryColor = String(t.primaryColor)), t.secondaryBackgroundColor != null && (e.secondaryBackgroundColor = String(t.secondaryBackgroundColor)), t.backgroundColor != null && (e.backgroundColor = String(t.backgroundColor)), t.textColor != null && (e.textColor = String(t.textColor)), t.font) {
      default:
        if (typeof t.font == "number") {
          e.font = t.font;
          break;
        }
        break;
      case "SANS_SERIF":
      case 0:
        e.font = 0;
        break;
      case "SERIF":
      case 1:
        e.font = 1;
        break;
      case "MONOSPACE":
      case 2:
        e.font = 2;
        break;
    }
    switch (t.base) {
      default:
        if (typeof t.base == "number") {
          e.base = t.base;
          break;
        }
        break;
      case "LIGHT":
      case 0:
        e.base = 0;
        break;
      case "DARK":
      case 1:
        e.base = 1;
        break;
    }
    if (t.widgetBackgroundColor != null && (e.widgetBackgroundColor = String(t.widgetBackgroundColor)), t.widgetBorderColor != null && (e.widgetBorderColor = String(t.widgetBorderColor)), t.radii != null) {
      if (typeof t.radii != "object")
        throw TypeError(".CustomThemeConfig.radii: object expected");
      e.radii = $root.Radii.fromObject(t.radii);
    }
    if (t.headingFont != null && (e.headingFont = String(t.headingFont)), t.bodyFont != null && (e.bodyFont = String(t.bodyFont)), t.codeFont != null && (e.codeFont = String(t.codeFont)), t.fontFaces) {
      if (!Array.isArray(t.fontFaces))
        throw TypeError(".CustomThemeConfig.fontFaces: array expected");
      e.fontFaces = [];
      for (let o = 0; o < t.fontFaces.length; ++o) {
        if (typeof t.fontFaces[o] != "object")
          throw TypeError(".CustomThemeConfig.fontFaces: object expected");
        e.fontFaces[o] = $root.FontFace.fromObject(t.fontFaces[o]);
      }
    }
    if (t.fontSources) {
      if (!Array.isArray(t.fontSources))
        throw TypeError(".CustomThemeConfig.fontSources: array expected");
      e.fontSources = [];
      for (let o = 0; o < t.fontSources.length; ++o) {
        if (typeof t.fontSources[o] != "object")
          throw TypeError(".CustomThemeConfig.fontSources: object expected");
        e.fontSources[o] = $root.FontSource.fromObject(t.fontSources[o]);
      }
    }
    if (t.fontSizes != null) {
      if (typeof t.fontSizes != "object")
        throw TypeError(".CustomThemeConfig.fontSizes: object expected");
      e.fontSizes = $root.FontSizes.fromObject(t.fontSizes);
    }
    if (t.skeletonBackgroundColor != null && (e.skeletonBackgroundColor = String(t.skeletonBackgroundColor)), t.baseRadius != null && (e.baseRadius = String(t.baseRadius)), t.buttonRadius != null && (e.buttonRadius = String(t.buttonRadius)), t.borderColor != null && (e.borderColor = String(t.borderColor)), t.dataframeBorderColor != null && (e.dataframeBorderColor = String(t.dataframeBorderColor)), t.showWidgetBorder != null && (e.showWidgetBorder = !!t.showWidgetBorder), t.linkColor != null && (e.linkColor = String(t.linkColor)), t.linkUnderline != null && (e.linkUnderline = !!t.linkUnderline), t.baseFontSize != null && (e.baseFontSize = t.baseFontSize | 0), t.baseFontWeight != null && (e.baseFontWeight = t.baseFontWeight | 0), t.codeFontWeight != null && (e.codeFontWeight = t.codeFontWeight | 0), t.codeFontSize != null && (e.codeFontSize = String(t.codeFontSize)), t.headingFontSizes) {
      if (!Array.isArray(t.headingFontSizes))
        throw TypeError(".CustomThemeConfig.headingFontSizes: array expected");
      e.headingFontSizes = [];
      for (let o = 0; o < t.headingFontSizes.length; ++o)
        e.headingFontSizes[o] = String(t.headingFontSizes[o]);
    }
    if (t.headingFontWeights) {
      if (!Array.isArray(t.headingFontWeights))
        throw TypeError(".CustomThemeConfig.headingFontWeights: array expected");
      e.headingFontWeights = [];
      for (let o = 0; o < t.headingFontWeights.length; ++o)
        e.headingFontWeights[o] = t.headingFontWeights[o] | 0;
    }
    if (t.showSidebarBorder != null && (e.showSidebarBorder = !!t.showSidebarBorder), t.sidebar != null) {
      if (typeof t.sidebar != "object")
        throw TypeError(".CustomThemeConfig.sidebar: object expected");
      e.sidebar = $root.CustomThemeConfig.fromObject(t.sidebar);
    }
    if (t.codeBackgroundColor != null && (e.codeBackgroundColor = String(t.codeBackgroundColor)), t.dataframeHeaderBackgroundColor != null && (e.dataframeHeaderBackgroundColor = String(t.dataframeHeaderBackgroundColor)), t.chartCategoricalColors) {
      if (!Array.isArray(t.chartCategoricalColors))
        throw TypeError(".CustomThemeConfig.chartCategoricalColors: array expected");
      e.chartCategoricalColors = [];
      for (let o = 0; o < t.chartCategoricalColors.length; ++o)
        e.chartCategoricalColors[o] = String(t.chartCategoricalColors[o]);
    }
    if (t.chartSequentialColors) {
      if (!Array.isArray(t.chartSequentialColors))
        throw TypeError(".CustomThemeConfig.chartSequentialColors: array expected");
      e.chartSequentialColors = [];
      for (let o = 0; o < t.chartSequentialColors.length; ++o)
        e.chartSequentialColors[o] = String(t.chartSequentialColors[o]);
    }
    return t.redColor != null && (e.redColor = String(t.redColor)), t.orangeColor != null && (e.orangeColor = String(t.orangeColor)), t.yellowColor != null && (e.yellowColor = String(t.yellowColor)), t.blueColor != null && (e.blueColor = String(t.blueColor)), t.greenColor != null && (e.greenColor = String(t.greenColor)), t.violetColor != null && (e.violetColor = String(t.violetColor)), t.grayColor != null && (e.grayColor = String(t.grayColor)), t.redBackgroundColor != null && (e.redBackgroundColor = String(t.redBackgroundColor)), t.orangeBackgroundColor != null && (e.orangeBackgroundColor = String(t.orangeBackgroundColor)), t.yellowBackgroundColor != null && (e.yellowBackgroundColor = String(t.yellowBackgroundColor)), t.blueBackgroundColor != null && (e.blueBackgroundColor = String(t.blueBackgroundColor)), t.greenBackgroundColor != null && (e.greenBackgroundColor = String(t.greenBackgroundColor)), t.violetBackgroundColor != null && (e.violetBackgroundColor = String(t.violetBackgroundColor)), t.grayBackgroundColor != null && (e.grayBackgroundColor = String(t.grayBackgroundColor)), t.redTextColor != null && (e.redTextColor = String(t.redTextColor)), t.orangeTextColor != null && (e.orangeTextColor = String(t.orangeTextColor)), t.yellowTextColor != null && (e.yellowTextColor = String(t.yellowTextColor)), t.blueTextColor != null && (e.blueTextColor = String(t.blueTextColor)), t.greenTextColor != null && (e.greenTextColor = String(t.greenTextColor)), t.violetTextColor != null && (e.violetTextColor = String(t.violetTextColor)), t.grayTextColor != null && (e.grayTextColor = String(t.grayTextColor)), e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    if ((e.arrays || e.defaults) && (o.fontFaces = [], o.chartCategoricalColors = [], o.headingFontWeights = [], o.headingFontSizes = [], o.chartSequentialColors = [], o.fontSources = []), e.defaults && (o.primaryColor = "", o.secondaryBackgroundColor = "", o.backgroundColor = "", o.textColor = "", o.font = e.enums === String ? "SANS_SERIF" : 0, o.base = e.enums === String ? "LIGHT" : 0, o.widgetBackgroundColor = "", o.widgetBorderColor = "", o.radii = null, o.headingFont = "", o.bodyFont = "", o.codeFont = "", o.fontSizes = null, o.skeletonBackgroundColor = ""), t.primaryColor != null && t.hasOwnProperty("primaryColor") && (o.primaryColor = t.primaryColor), t.secondaryBackgroundColor != null && t.hasOwnProperty("secondaryBackgroundColor") && (o.secondaryBackgroundColor = t.secondaryBackgroundColor), t.backgroundColor != null && t.hasOwnProperty("backgroundColor") && (o.backgroundColor = t.backgroundColor), t.textColor != null && t.hasOwnProperty("textColor") && (o.textColor = t.textColor), t.font != null && t.hasOwnProperty("font") && (o.font = e.enums === String ? $root.CustomThemeConfig.FontFamily[t.font] === void 0 ? t.font : $root.CustomThemeConfig.FontFamily[t.font] : t.font), t.base != null && t.hasOwnProperty("base") && (o.base = e.enums === String ? $root.CustomThemeConfig.BaseTheme[t.base] === void 0 ? t.base : $root.CustomThemeConfig.BaseTheme[t.base] : t.base), t.widgetBackgroundColor != null && t.hasOwnProperty("widgetBackgroundColor") && (o.widgetBackgroundColor = t.widgetBackgroundColor), t.widgetBorderColor != null && t.hasOwnProperty("widgetBorderColor") && (o.widgetBorderColor = t.widgetBorderColor), t.radii != null && t.hasOwnProperty("radii") && (o.radii = $root.Radii.toObject(t.radii, e)), t.headingFont != null && t.hasOwnProperty("headingFont") && (o.headingFont = t.headingFont), t.bodyFont != null && t.hasOwnProperty("bodyFont") && (o.bodyFont = t.bodyFont), t.codeFont != null && t.hasOwnProperty("codeFont") && (o.codeFont = t.codeFont), t.fontFaces && t.fontFaces.length) {
      o.fontFaces = [];
      for (let p = 0; p < t.fontFaces.length; ++p)
        o.fontFaces[p] = $root.FontFace.toObject(t.fontFaces[p], e);
    }
    if (t.fontSizes != null && t.hasOwnProperty("fontSizes") && (o.fontSizes = $root.FontSizes.toObject(t.fontSizes, e)), t.skeletonBackgroundColor != null && t.hasOwnProperty("skeletonBackgroundColor") && (o.skeletonBackgroundColor = t.skeletonBackgroundColor), t.baseRadius != null && t.hasOwnProperty("baseRadius") && (o.baseRadius = t.baseRadius, e.oneofs && (o._baseRadius = "baseRadius")), t.borderColor != null && t.hasOwnProperty("borderColor") && (o.borderColor = t.borderColor, e.oneofs && (o._borderColor = "borderColor")), t.showWidgetBorder != null && t.hasOwnProperty("showWidgetBorder") && (o.showWidgetBorder = t.showWidgetBorder, e.oneofs && (o._showWidgetBorder = "showWidgetBorder")), t.linkColor != null && t.hasOwnProperty("linkColor") && (o.linkColor = t.linkColor, e.oneofs && (o._linkColor = "linkColor")), t.baseFontSize != null && t.hasOwnProperty("baseFontSize") && (o.baseFontSize = t.baseFontSize, e.oneofs && (o._baseFontSize = "baseFontSize")), t.showSidebarBorder != null && t.hasOwnProperty("showSidebarBorder") && (o.showSidebarBorder = t.showSidebarBorder, e.oneofs && (o._showSidebarBorder = "showSidebarBorder")), t.sidebar != null && t.hasOwnProperty("sidebar") && (o.sidebar = $root.CustomThemeConfig.toObject(t.sidebar, e), e.oneofs && (o._sidebar = "sidebar")), t.codeBackgroundColor != null && t.hasOwnProperty("codeBackgroundColor") && (o.codeBackgroundColor = t.codeBackgroundColor, e.oneofs && (o._codeBackgroundColor = "codeBackgroundColor")), t.buttonRadius != null && t.hasOwnProperty("buttonRadius") && (o.buttonRadius = t.buttonRadius, e.oneofs && (o._buttonRadius = "buttonRadius")), t.dataframeBorderColor != null && t.hasOwnProperty("dataframeBorderColor") && (o.dataframeBorderColor = t.dataframeBorderColor, e.oneofs && (o._dataframeBorderColor = "dataframeBorderColor")), t.codeFontSize != null && t.hasOwnProperty("codeFontSize") && (o.codeFontSize = t.codeFontSize, e.oneofs && (o._codeFontSize = "codeFontSize")), t.linkUnderline != null && t.hasOwnProperty("linkUnderline") && (o.linkUnderline = t.linkUnderline, e.oneofs && (o._linkUnderline = "linkUnderline")), t.baseFontWeight != null && t.hasOwnProperty("baseFontWeight") && (o.baseFontWeight = t.baseFontWeight, e.oneofs && (o._baseFontWeight = "baseFontWeight")), t.dataframeHeaderBackgroundColor != null && t.hasOwnProperty("dataframeHeaderBackgroundColor") && (o.dataframeHeaderBackgroundColor = t.dataframeHeaderBackgroundColor, e.oneofs && (o._dataframeHeaderBackgroundColor = "dataframeHeaderBackgroundColor")), t.codeFontWeight != null && t.hasOwnProperty("codeFontWeight") && (o.codeFontWeight = t.codeFontWeight, e.oneofs && (o._codeFontWeight = "codeFontWeight")), t.chartCategoricalColors && t.chartCategoricalColors.length) {
      o.chartCategoricalColors = [];
      for (let p = 0; p < t.chartCategoricalColors.length; ++p)
        o.chartCategoricalColors[p] = t.chartCategoricalColors[p];
    }
    if (t.headingFontWeights && t.headingFontWeights.length) {
      o.headingFontWeights = [];
      for (let p = 0; p < t.headingFontWeights.length; ++p)
        o.headingFontWeights[p] = t.headingFontWeights[p];
    }
    if (t.headingFontSizes && t.headingFontSizes.length) {
      o.headingFontSizes = [];
      for (let p = 0; p < t.headingFontSizes.length; ++p)
        o.headingFontSizes[p] = t.headingFontSizes[p];
    }
    if (t.chartSequentialColors && t.chartSequentialColors.length) {
      o.chartSequentialColors = [];
      for (let p = 0; p < t.chartSequentialColors.length; ++p)
        o.chartSequentialColors[p] = t.chartSequentialColors[p];
    }
    if (t.fontSources && t.fontSources.length) {
      o.fontSources = [];
      for (let p = 0; p < t.fontSources.length; ++p)
        o.fontSources[p] = $root.FontSource.toObject(t.fontSources[p], e);
    }
    return t.redColor != null && t.hasOwnProperty("redColor") && (o.redColor = t.redColor, e.oneofs && (o._redColor = "redColor")), t.orangeColor != null && t.hasOwnProperty("orangeColor") && (o.orangeColor = t.orangeColor, e.oneofs && (o._orangeColor = "orangeColor")), t.yellowColor != null && t.hasOwnProperty("yellowColor") && (o.yellowColor = t.yellowColor, e.oneofs && (o._yellowColor = "yellowColor")), t.blueColor != null && t.hasOwnProperty("blueColor") && (o.blueColor = t.blueColor, e.oneofs && (o._blueColor = "blueColor")), t.greenColor != null && t.hasOwnProperty("greenColor") && (o.greenColor = t.greenColor, e.oneofs && (o._greenColor = "greenColor")), t.violetColor != null && t.hasOwnProperty("violetColor") && (o.violetColor = t.violetColor, e.oneofs && (o._violetColor = "violetColor")), t.grayColor != null && t.hasOwnProperty("grayColor") && (o.grayColor = t.grayColor, e.oneofs && (o._grayColor = "grayColor")), t.redBackgroundColor != null && t.hasOwnProperty("redBackgroundColor") && (o.redBackgroundColor = t.redBackgroundColor, e.oneofs && (o._redBackgroundColor = "redBackgroundColor")), t.orangeBackgroundColor != null && t.hasOwnProperty("orangeBackgroundColor") && (o.orangeBackgroundColor = t.orangeBackgroundColor, e.oneofs && (o._orangeBackgroundColor = "orangeBackgroundColor")), t.yellowBackgroundColor != null && t.hasOwnProperty("yellowBackgroundColor") && (o.yellowBackgroundColor = t.yellowBackgroundColor, e.oneofs && (o._yellowBackgroundColor = "yellowBackgroundColor")), t.blueBackgroundColor != null && t.hasOwnProperty("blueBackgroundColor") && (o.blueBackgroundColor = t.blueBackgroundColor, e.oneofs && (o._blueBackgroundColor = "blueBackgroundColor")), t.greenBackgroundColor != null && t.hasOwnProperty("greenBackgroundColor") && (o.greenBackgroundColor = t.greenBackgroundColor, e.oneofs && (o._greenBackgroundColor = "greenBackgroundColor")), t.violetBackgroundColor != null && t.hasOwnProperty("violetBackgroundColor") && (o.violetBackgroundColor = t.violetBackgroundColor, e.oneofs && (o._violetBackgroundColor = "violetBackgroundColor")), t.grayBackgroundColor != null && t.hasOwnProperty("grayBackgroundColor") && (o.grayBackgroundColor = t.grayBackgroundColor, e.oneofs && (o._grayBackgroundColor = "grayBackgroundColor")), t.redTextColor != null && t.hasOwnProperty("redTextColor") && (o.redTextColor = t.redTextColor, e.oneofs && (o._redTextColor = "redTextColor")), t.orangeTextColor != null && t.hasOwnProperty("orangeTextColor") && (o.orangeTextColor = t.orangeTextColor, e.oneofs && (o._orangeTextColor = "orangeTextColor")), t.yellowTextColor != null && t.hasOwnProperty("yellowTextColor") && (o.yellowTextColor = t.yellowTextColor, e.oneofs && (o._yellowTextColor = "yellowTextColor")), t.blueTextColor != null && t.hasOwnProperty("blueTextColor") && (o.blueTextColor = t.blueTextColor, e.oneofs && (o._blueTextColor = "blueTextColor")), t.greenTextColor != null && t.hasOwnProperty("greenTextColor") && (o.greenTextColor = t.greenTextColor, e.oneofs && (o._greenTextColor = "greenTextColor")), t.violetTextColor != null && t.hasOwnProperty("violetTextColor") && (o.violetTextColor = t.violetTextColor, e.oneofs && (o._violetTextColor = "violetTextColor")), t.grayTextColor != null && t.hasOwnProperty("grayTextColor") && (o.grayTextColor = t.grayTextColor, e.oneofs && (o._grayTextColor = "grayTextColor")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/CustomThemeConfig";
  }, r.BaseTheme = (function() {
    const n = {}, t = Object.create(n);
    return t[n[0] = "LIGHT"] = 0, t[n[1] = "DARK"] = 1, t;
  })(), r.FontFamily = (function() {
    const n = {}, t = Object.create(n);
    return t[n[0] = "SANS_SERIF"] = 0, t[n[1] = "SERIF"] = 1, t[n[2] = "MONOSPACE"] = 2, t;
  })(), r;
})();
$root.FontFace = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.url = "", r.prototype.family = "", r.prototype.weight = 0, r.prototype.weightRange = "", r.prototype.style = "", r.prototype.unicodeRange = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.url != null && Object.hasOwnProperty.call(n, "url") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.url), n.family != null && Object.hasOwnProperty.call(n, "family") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.family), n.weight != null && Object.hasOwnProperty.call(n, "weight") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(n.weight), n.style != null && Object.hasOwnProperty.call(n, "style") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.style), n.weightRange != null && Object.hasOwnProperty.call(n, "weightRange") && t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(n.weightRange), n.unicodeRange != null && Object.hasOwnProperty.call(n, "unicodeRange") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.unicodeRange), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.FontFace();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.url = n.string();
          break;
        }
        case 2: {
          p.family = n.string();
          break;
        }
        case 3: {
          p.weight = n.int32();
          break;
        }
        case 5: {
          p.weightRange = n.string();
          break;
        }
        case 4: {
          p.style = n.string();
          break;
        }
        case 6: {
          p.unicodeRange = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.url != null && n.hasOwnProperty("url") && !$util.isString(n.url) ? "url: string expected" : n.family != null && n.hasOwnProperty("family") && !$util.isString(n.family) ? "family: string expected" : n.weight != null && n.hasOwnProperty("weight") && !$util.isInteger(n.weight) ? "weight: integer expected" : n.weightRange != null && n.hasOwnProperty("weightRange") && !$util.isString(n.weightRange) ? "weightRange: string expected" : n.style != null && n.hasOwnProperty("style") && !$util.isString(n.style) ? "style: string expected" : n.unicodeRange != null && n.hasOwnProperty("unicodeRange") && !$util.isString(n.unicodeRange) ? "unicodeRange: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.FontFace)
      return n;
    let t = new $root.FontFace();
    return n.url != null && (t.url = String(n.url)), n.family != null && (t.family = String(n.family)), n.weight != null && (t.weight = n.weight | 0), n.weightRange != null && (t.weightRange = String(n.weightRange)), n.style != null && (t.style = String(n.style)), n.unicodeRange != null && (t.unicodeRange = String(n.unicodeRange)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.url = "", e.family = "", e.weight = 0, e.style = "", e.weightRange = "", e.unicodeRange = ""), n.url != null && n.hasOwnProperty("url") && (e.url = n.url), n.family != null && n.hasOwnProperty("family") && (e.family = n.family), n.weight != null && n.hasOwnProperty("weight") && (e.weight = n.weight), n.style != null && n.hasOwnProperty("style") && (e.style = n.style), n.weightRange != null && n.hasOwnProperty("weightRange") && (e.weightRange = n.weightRange), n.unicodeRange != null && n.hasOwnProperty("unicodeRange") && (e.unicodeRange = n.unicodeRange), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/FontFace";
  }, r;
})();
$root.FontSource = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.configName = "", r.prototype.sourceUrl = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.configName != null && Object.hasOwnProperty.call(n, "configName") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.configName), n.sourceUrl != null && Object.hasOwnProperty.call(n, "sourceUrl") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.sourceUrl), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.FontSource();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.configName = n.string();
          break;
        }
        case 2: {
          p.sourceUrl = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.configName != null && n.hasOwnProperty("configName") && !$util.isString(n.configName) ? "configName: string expected" : n.sourceUrl != null && n.hasOwnProperty("sourceUrl") && !$util.isString(n.sourceUrl) ? "sourceUrl: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.FontSource)
      return n;
    let t = new $root.FontSource();
    return n.configName != null && (t.configName = String(n.configName)), n.sourceUrl != null && (t.sourceUrl = String(n.sourceUrl)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.configName = "", e.sourceUrl = ""), n.configName != null && n.hasOwnProperty("configName") && (e.configName = n.configName), n.sourceUrl != null && n.hasOwnProperty("sourceUrl") && (e.sourceUrl = n.sourceUrl), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/FontSource";
  }, r;
})();
$root.Radii = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.baseWidgetRadius = 0, r.prototype.checkboxRadius = 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.baseWidgetRadius != null && Object.hasOwnProperty.call(n, "baseWidgetRadius") && t.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(n.baseWidgetRadius), n.checkboxRadius != null && Object.hasOwnProperty.call(n, "checkboxRadius") && t.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(n.checkboxRadius), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Radii();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.baseWidgetRadius = n.int32();
          break;
        }
        case 2: {
          p.checkboxRadius = n.int32();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.baseWidgetRadius != null && n.hasOwnProperty("baseWidgetRadius") && !$util.isInteger(n.baseWidgetRadius) ? "baseWidgetRadius: integer expected" : n.checkboxRadius != null && n.hasOwnProperty("checkboxRadius") && !$util.isInteger(n.checkboxRadius) ? "checkboxRadius: integer expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Radii)
      return n;
    let t = new $root.Radii();
    return n.baseWidgetRadius != null && (t.baseWidgetRadius = n.baseWidgetRadius | 0), n.checkboxRadius != null && (t.checkboxRadius = n.checkboxRadius | 0), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.baseWidgetRadius = 0, e.checkboxRadius = 0), n.baseWidgetRadius != null && n.hasOwnProperty("baseWidgetRadius") && (e.baseWidgetRadius = n.baseWidgetRadius), n.checkboxRadius != null && n.hasOwnProperty("checkboxRadius") && (e.checkboxRadius = n.checkboxRadius), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Radii";
  }, r;
})();
$root.FontSizes = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.tinyFontSize = 0, r.prototype.smallFontSize = 0, r.prototype.baseFontSize = 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.tinyFontSize != null && Object.hasOwnProperty.call(n, "tinyFontSize") && t.uint32(
      /* id 1, wireType 0 =*/
      8
    ).int32(n.tinyFontSize), n.smallFontSize != null && Object.hasOwnProperty.call(n, "smallFontSize") && t.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int32(n.smallFontSize), n.baseFontSize != null && Object.hasOwnProperty.call(n, "baseFontSize") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(n.baseFontSize), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.FontSizes();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.tinyFontSize = n.int32();
          break;
        }
        case 2: {
          p.smallFontSize = n.int32();
          break;
        }
        case 3: {
          p.baseFontSize = n.int32();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.tinyFontSize != null && n.hasOwnProperty("tinyFontSize") && !$util.isInteger(n.tinyFontSize) ? "tinyFontSize: integer expected" : n.smallFontSize != null && n.hasOwnProperty("smallFontSize") && !$util.isInteger(n.smallFontSize) ? "smallFontSize: integer expected" : n.baseFontSize != null && n.hasOwnProperty("baseFontSize") && !$util.isInteger(n.baseFontSize) ? "baseFontSize: integer expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.FontSizes)
      return n;
    let t = new $root.FontSizes();
    return n.tinyFontSize != null && (t.tinyFontSize = n.tinyFontSize | 0), n.smallFontSize != null && (t.smallFontSize = n.smallFontSize | 0), n.baseFontSize != null && (t.baseFontSize = n.baseFontSize | 0), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.tinyFontSize = 0, e.smallFontSize = 0, e.baseFontSize = 0), n.tinyFontSize != null && n.hasOwnProperty("tinyFontSize") && (e.tinyFontSize = n.tinyFontSize), n.smallFontSize != null && n.hasOwnProperty("smallFontSize") && (e.smallFontSize = n.smallFontSize), n.baseFontSize != null && n.hasOwnProperty("baseFontSize") && (e.baseFontSize = n.baseFontSize), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/FontSizes";
  }, r;
})();
$root.UserInfo = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.installationId = "", r.prototype.installationIdV3 = "", r.prototype.installationIdV4 = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.installationId != null && Object.hasOwnProperty.call(n, "installationId") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.installationId), n.installationIdV3 != null && Object.hasOwnProperty.call(n, "installationIdV3") && t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).string(n.installationIdV3), n.installationIdV4 != null && Object.hasOwnProperty.call(n, "installationIdV4") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.installationIdV4), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.UserInfo();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.installationId = n.string();
          break;
        }
        case 5: {
          p.installationIdV3 = n.string();
          break;
        }
        case 6: {
          p.installationIdV4 = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.installationId != null && n.hasOwnProperty("installationId") && !$util.isString(n.installationId) ? "installationId: string expected" : n.installationIdV3 != null && n.hasOwnProperty("installationIdV3") && !$util.isString(n.installationIdV3) ? "installationIdV3: string expected" : n.installationIdV4 != null && n.hasOwnProperty("installationIdV4") && !$util.isString(n.installationIdV4) ? "installationIdV4: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.UserInfo)
      return n;
    let t = new $root.UserInfo();
    return n.installationId != null && (t.installationId = String(n.installationId)), n.installationIdV3 != null && (t.installationIdV3 = String(n.installationIdV3)), n.installationIdV4 != null && (t.installationIdV4 = String(n.installationIdV4)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.installationId = "", e.installationIdV3 = "", e.installationIdV4 = ""), n.installationId != null && n.hasOwnProperty("installationId") && (e.installationId = n.installationId), n.installationIdV3 != null && n.hasOwnProperty("installationIdV3") && (e.installationIdV3 = n.installationIdV3), n.installationIdV4 != null && n.hasOwnProperty("installationIdV4") && (e.installationIdV4 = n.installationIdV4), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/UserInfo";
  }, r;
})();
$root.EnvironmentInfo = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.streamlitVersion = "", r.prototype.pythonVersion = "", r.prototype.serverOs = "", r.prototype.hasDisplay = !1, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.streamlitVersion != null && Object.hasOwnProperty.call(n, "streamlitVersion") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.streamlitVersion), n.pythonVersion != null && Object.hasOwnProperty.call(n, "pythonVersion") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.pythonVersion), n.serverOs != null && Object.hasOwnProperty.call(n, "serverOs") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.serverOs), n.hasDisplay != null && Object.hasOwnProperty.call(n, "hasDisplay") && t.uint32(
      /* id 4, wireType 0 =*/
      32
    ).bool(n.hasDisplay), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.EnvironmentInfo();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.streamlitVersion = n.string();
          break;
        }
        case 2: {
          p.pythonVersion = n.string();
          break;
        }
        case 3: {
          p.serverOs = n.string();
          break;
        }
        case 4: {
          p.hasDisplay = n.bool();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.streamlitVersion != null && n.hasOwnProperty("streamlitVersion") && !$util.isString(n.streamlitVersion) ? "streamlitVersion: string expected" : n.pythonVersion != null && n.hasOwnProperty("pythonVersion") && !$util.isString(n.pythonVersion) ? "pythonVersion: string expected" : n.serverOs != null && n.hasOwnProperty("serverOs") && !$util.isString(n.serverOs) ? "serverOs: string expected" : n.hasDisplay != null && n.hasOwnProperty("hasDisplay") && typeof n.hasDisplay != "boolean" ? "hasDisplay: boolean expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.EnvironmentInfo)
      return n;
    let t = new $root.EnvironmentInfo();
    return n.streamlitVersion != null && (t.streamlitVersion = String(n.streamlitVersion)), n.pythonVersion != null && (t.pythonVersion = String(n.pythonVersion)), n.serverOs != null && (t.serverOs = String(n.serverOs)), n.hasDisplay != null && (t.hasDisplay = !!n.hasDisplay), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.streamlitVersion = "", e.pythonVersion = "", e.serverOs = "", e.hasDisplay = !1), n.streamlitVersion != null && n.hasOwnProperty("streamlitVersion") && (e.streamlitVersion = n.streamlitVersion), n.pythonVersion != null && n.hasOwnProperty("pythonVersion") && (e.pythonVersion = n.pythonVersion), n.serverOs != null && n.hasOwnProperty("serverOs") && (e.serverOs = n.serverOs), n.hasDisplay != null && n.hasOwnProperty("hasDisplay") && (e.hasDisplay = n.hasDisplay), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/EnvironmentInfo";
  }, r;
})();
$root.SessionStatus = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.runOnSave = !1, r.prototype.scriptIsRunning = !1, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.runOnSave != null && Object.hasOwnProperty.call(n, "runOnSave") && t.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(n.runOnSave), n.scriptIsRunning != null && Object.hasOwnProperty.call(n, "scriptIsRunning") && t.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(n.scriptIsRunning), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.SessionStatus();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.runOnSave = n.bool();
          break;
        }
        case 2: {
          p.scriptIsRunning = n.bool();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.runOnSave != null && n.hasOwnProperty("runOnSave") && typeof n.runOnSave != "boolean" ? "runOnSave: boolean expected" : n.scriptIsRunning != null && n.hasOwnProperty("scriptIsRunning") && typeof n.scriptIsRunning != "boolean" ? "scriptIsRunning: boolean expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.SessionStatus)
      return n;
    let t = new $root.SessionStatus();
    return n.runOnSave != null && (t.runOnSave = !!n.runOnSave), n.scriptIsRunning != null && (t.scriptIsRunning = !!n.scriptIsRunning), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.runOnSave = !1, e.scriptIsRunning = !1), n.runOnSave != null && n.hasOwnProperty("runOnSave") && (e.runOnSave = n.runOnSave), n.scriptIsRunning != null && n.hasOwnProperty("scriptIsRunning") && (e.scriptIsRunning = n.scriptIsRunning), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/SessionStatus";
  }, r;
})();
$root.PageConfig = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.title = "", r.prototype.favicon = "", r.prototype.layout = 0, r.prototype.initialSidebarState = 0, r.prototype.menuItems = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.title != null && Object.hasOwnProperty.call(n, "title") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.title), n.favicon != null && Object.hasOwnProperty.call(n, "favicon") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.favicon), n.layout != null && Object.hasOwnProperty.call(n, "layout") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int32(n.layout), n.initialSidebarState != null && Object.hasOwnProperty.call(n, "initialSidebarState") && t.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int32(n.initialSidebarState), n.menuItems != null && Object.hasOwnProperty.call(n, "menuItems") && $root.PageConfig.MenuItems.encode(n.menuItems, t.uint32(
      /* id 5, wireType 2 =*/
      42
    ).fork()).ldelim(), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.PageConfig();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.title = n.string();
          break;
        }
        case 2: {
          p.favicon = n.string();
          break;
        }
        case 3: {
          p.layout = n.int32();
          break;
        }
        case 4: {
          p.initialSidebarState = n.int32();
          break;
        }
        case 5: {
          p.menuItems = $root.PageConfig.MenuItems.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.title != null && n.hasOwnProperty("title") && !$util.isString(n.title))
      return "title: string expected";
    if (n.favicon != null && n.hasOwnProperty("favicon") && !$util.isString(n.favicon))
      return "favicon: string expected";
    if (n.layout != null && n.hasOwnProperty("layout"))
      switch (n.layout) {
        default:
          return "layout: enum value expected";
        case 0:
        case 1:
        case 2:
          break;
      }
    if (n.initialSidebarState != null && n.hasOwnProperty("initialSidebarState"))
      switch (n.initialSidebarState) {
        default:
          return "initialSidebarState: enum value expected";
        case 0:
        case 1:
        case 2:
        case 3:
          break;
      }
    if (n.menuItems != null && n.hasOwnProperty("menuItems")) {
      let t = $root.PageConfig.MenuItems.verify(n.menuItems);
      if (t)
        return "menuItems." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.PageConfig)
      return n;
    let t = new $root.PageConfig();
    switch (n.title != null && (t.title = String(n.title)), n.favicon != null && (t.favicon = String(n.favicon)), n.layout) {
      default:
        if (typeof n.layout == "number") {
          t.layout = n.layout;
          break;
        }
        break;
      case "CENTERED":
      case 0:
        t.layout = 0;
        break;
      case "WIDE":
      case 1:
        t.layout = 1;
        break;
      case "LAYOUT_UNSET":
      case 2:
        t.layout = 2;
        break;
    }
    switch (n.initialSidebarState) {
      default:
        if (typeof n.initialSidebarState == "number") {
          t.initialSidebarState = n.initialSidebarState;
          break;
        }
        break;
      case "AUTO":
      case 0:
        t.initialSidebarState = 0;
        break;
      case "EXPANDED":
      case 1:
        t.initialSidebarState = 1;
        break;
      case "COLLAPSED":
      case 2:
        t.initialSidebarState = 2;
        break;
      case "SIDEBAR_UNSET":
      case 3:
        t.initialSidebarState = 3;
        break;
    }
    if (n.menuItems != null) {
      if (typeof n.menuItems != "object")
        throw TypeError(".PageConfig.menuItems: object expected");
      t.menuItems = $root.PageConfig.MenuItems.fromObject(n.menuItems);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.title = "", e.favicon = "", e.layout = t.enums === String ? "CENTERED" : 0, e.initialSidebarState = t.enums === String ? "AUTO" : 0, e.menuItems = null), n.title != null && n.hasOwnProperty("title") && (e.title = n.title), n.favicon != null && n.hasOwnProperty("favicon") && (e.favicon = n.favicon), n.layout != null && n.hasOwnProperty("layout") && (e.layout = t.enums === String ? $root.PageConfig.Layout[n.layout] === void 0 ? n.layout : $root.PageConfig.Layout[n.layout] : n.layout), n.initialSidebarState != null && n.hasOwnProperty("initialSidebarState") && (e.initialSidebarState = t.enums === String ? $root.PageConfig.SidebarState[n.initialSidebarState] === void 0 ? n.initialSidebarState : $root.PageConfig.SidebarState[n.initialSidebarState] : n.initialSidebarState), n.menuItems != null && n.hasOwnProperty("menuItems") && (e.menuItems = $root.PageConfig.MenuItems.toObject(n.menuItems, t)), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/PageConfig";
  }, r.MenuItems = (function() {
    function c(n) {
      if (n)
        for (let t = Object.keys(n), e = 0; e < t.length; ++e)
          n[t[e]] != null && (this[t[e]] = n[t[e]]);
    }
    return c.prototype.getHelpUrl = "", c.prototype.hideGetHelp = !1, c.prototype.reportABugUrl = "", c.prototype.hideReportABug = !1, c.prototype.aboutSectionMd = "", c.prototype.clearAboutMd = !1, c.create = function(t) {
      return new c(t);
    }, c.encode = function(t, e) {
      return e || (e = $Writer.create()), t.getHelpUrl != null && Object.hasOwnProperty.call(t, "getHelpUrl") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.getHelpUrl), t.hideGetHelp != null && Object.hasOwnProperty.call(t, "hideGetHelp") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(t.hideGetHelp), t.reportABugUrl != null && Object.hasOwnProperty.call(t, "reportABugUrl") && e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(t.reportABugUrl), t.hideReportABug != null && Object.hasOwnProperty.call(t, "hideReportABug") && e.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(t.hideReportABug), t.aboutSectionMd != null && Object.hasOwnProperty.call(t, "aboutSectionMd") && e.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(t.aboutSectionMd), t.clearAboutMd != null && Object.hasOwnProperty.call(t, "clearAboutMd") && e.uint32(
        /* id 6, wireType 0 =*/
        48
      ).bool(t.clearAboutMd), e;
    }, c.encodeDelimited = function(t, e) {
      return this.encode(t, e).ldelim();
    }, c.decode = function(t, e, o) {
      t instanceof $Reader || (t = $Reader.create(t));
      let p = e === void 0 ? t.len : t.pos + e, h = new $root.PageConfig.MenuItems();
      for (; t.pos < p; ) {
        let y = t.uint32();
        if (y === o)
          break;
        switch (y >>> 3) {
          case 1: {
            h.getHelpUrl = t.string();
            break;
          }
          case 2: {
            h.hideGetHelp = t.bool();
            break;
          }
          case 3: {
            h.reportABugUrl = t.string();
            break;
          }
          case 4: {
            h.hideReportABug = t.bool();
            break;
          }
          case 5: {
            h.aboutSectionMd = t.string();
            break;
          }
          case 6: {
            h.clearAboutMd = t.bool();
            break;
          }
          default:
            t.skipType(y & 7);
            break;
        }
      }
      return h;
    }, c.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, c.verify = function(t) {
      return typeof t != "object" || t === null ? "object expected" : t.getHelpUrl != null && t.hasOwnProperty("getHelpUrl") && !$util.isString(t.getHelpUrl) ? "getHelpUrl: string expected" : t.hideGetHelp != null && t.hasOwnProperty("hideGetHelp") && typeof t.hideGetHelp != "boolean" ? "hideGetHelp: boolean expected" : t.reportABugUrl != null && t.hasOwnProperty("reportABugUrl") && !$util.isString(t.reportABugUrl) ? "reportABugUrl: string expected" : t.hideReportABug != null && t.hasOwnProperty("hideReportABug") && typeof t.hideReportABug != "boolean" ? "hideReportABug: boolean expected" : t.aboutSectionMd != null && t.hasOwnProperty("aboutSectionMd") && !$util.isString(t.aboutSectionMd) ? "aboutSectionMd: string expected" : t.clearAboutMd != null && t.hasOwnProperty("clearAboutMd") && typeof t.clearAboutMd != "boolean" ? "clearAboutMd: boolean expected" : null;
    }, c.fromObject = function(t) {
      if (t instanceof $root.PageConfig.MenuItems)
        return t;
      let e = new $root.PageConfig.MenuItems();
      return t.getHelpUrl != null && (e.getHelpUrl = String(t.getHelpUrl)), t.hideGetHelp != null && (e.hideGetHelp = !!t.hideGetHelp), t.reportABugUrl != null && (e.reportABugUrl = String(t.reportABugUrl)), t.hideReportABug != null && (e.hideReportABug = !!t.hideReportABug), t.aboutSectionMd != null && (e.aboutSectionMd = String(t.aboutSectionMd)), t.clearAboutMd != null && (e.clearAboutMd = !!t.clearAboutMd), e;
    }, c.toObject = function(t, e) {
      e || (e = {});
      let o = {};
      return e.defaults && (o.getHelpUrl = "", o.hideGetHelp = !1, o.reportABugUrl = "", o.hideReportABug = !1, o.aboutSectionMd = "", o.clearAboutMd = !1), t.getHelpUrl != null && t.hasOwnProperty("getHelpUrl") && (o.getHelpUrl = t.getHelpUrl), t.hideGetHelp != null && t.hasOwnProperty("hideGetHelp") && (o.hideGetHelp = t.hideGetHelp), t.reportABugUrl != null && t.hasOwnProperty("reportABugUrl") && (o.reportABugUrl = t.reportABugUrl), t.hideReportABug != null && t.hasOwnProperty("hideReportABug") && (o.hideReportABug = t.hideReportABug), t.aboutSectionMd != null && t.hasOwnProperty("aboutSectionMd") && (o.aboutSectionMd = t.aboutSectionMd), t.clearAboutMd != null && t.hasOwnProperty("clearAboutMd") && (o.clearAboutMd = t.clearAboutMd), o;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/PageConfig.MenuItems";
    }, c;
  })(), r.Layout = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "CENTERED"] = 0, n[c[1] = "WIDE"] = 1, n[c[2] = "LAYOUT_UNSET"] = 2, n;
  })(), r.SidebarState = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "AUTO"] = 0, n[c[1] = "EXPANDED"] = 1, n[c[2] = "COLLAPSED"] = 2, n[c[3] = "SIDEBAR_UNSET"] = 3, n;
  })(), r;
})();
$root.PageInfo = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.queryString = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.queryString != null && Object.hasOwnProperty.call(n, "queryString") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.queryString), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.PageInfo();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.queryString = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.queryString != null && n.hasOwnProperty("queryString") && !$util.isString(n.queryString) ? "queryString: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.PageInfo)
      return n;
    let t = new $root.PageInfo();
    return n.queryString != null && (t.queryString = String(n.queryString)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.queryString = ""), n.queryString != null && n.hasOwnProperty("queryString") && (e.queryString = n.queryString), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/PageInfo";
  }, r;
})();
$root.PageProfile = (() => {
  function r(c) {
    if (this.commands = [], this.config = [], this.attributions = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.commands = $util.emptyArray, r.prototype.execTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, r.prototype.prepTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, r.prototype.config = $util.emptyArray, r.prototype.uncaughtException = "", r.prototype.attributions = $util.emptyArray, r.prototype.os = "", r.prototype.timezone = "", r.prototype.headless = !1, r.prototype.isFragmentRun = !1, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.commands != null && n.commands.length)
      for (let e = 0; e < n.commands.length; ++e)
        $root.Command.encode(n.commands[e], t.uint32(
          /* id 1, wireType 2 =*/
          10
        ).fork()).ldelim();
    if (n.execTime != null && Object.hasOwnProperty.call(n, "execTime") && t.uint32(
      /* id 2, wireType 0 =*/
      16
    ).int64(n.execTime), n.prepTime != null && Object.hasOwnProperty.call(n, "prepTime") && t.uint32(
      /* id 3, wireType 0 =*/
      24
    ).int64(n.prepTime), n.config != null && n.config.length)
      for (let e = 0; e < n.config.length; ++e)
        t.uint32(
          /* id 5, wireType 2 =*/
          42
        ).string(n.config[e]);
    if (n.uncaughtException != null && Object.hasOwnProperty.call(n, "uncaughtException") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.uncaughtException), n.attributions != null && n.attributions.length)
      for (let e = 0; e < n.attributions.length; ++e)
        t.uint32(
          /* id 7, wireType 2 =*/
          58
        ).string(n.attributions[e]);
    return n.os != null && Object.hasOwnProperty.call(n, "os") && t.uint32(
      /* id 8, wireType 2 =*/
      66
    ).string(n.os), n.timezone != null && Object.hasOwnProperty.call(n, "timezone") && t.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(n.timezone), n.headless != null && Object.hasOwnProperty.call(n, "headless") && t.uint32(
      /* id 10, wireType 0 =*/
      80
    ).bool(n.headless), n.isFragmentRun != null && Object.hasOwnProperty.call(n, "isFragmentRun") && t.uint32(
      /* id 11, wireType 0 =*/
      88
    ).bool(n.isFragmentRun), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.PageProfile();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.commands && p.commands.length || (p.commands = []), p.commands.push($root.Command.decode(n, n.uint32()));
          break;
        }
        case 2: {
          p.execTime = n.int64();
          break;
        }
        case 3: {
          p.prepTime = n.int64();
          break;
        }
        case 5: {
          p.config && p.config.length || (p.config = []), p.config.push(n.string());
          break;
        }
        case 6: {
          p.uncaughtException = n.string();
          break;
        }
        case 7: {
          p.attributions && p.attributions.length || (p.attributions = []), p.attributions.push(n.string());
          break;
        }
        case 8: {
          p.os = n.string();
          break;
        }
        case 9: {
          p.timezone = n.string();
          break;
        }
        case 10: {
          p.headless = n.bool();
          break;
        }
        case 11: {
          p.isFragmentRun = n.bool();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.commands != null && n.hasOwnProperty("commands")) {
      if (!Array.isArray(n.commands))
        return "commands: array expected";
      for (let t = 0; t < n.commands.length; ++t) {
        let e = $root.Command.verify(n.commands[t]);
        if (e)
          return "commands." + e;
      }
    }
    if (n.execTime != null && n.hasOwnProperty("execTime") && !$util.isInteger(n.execTime) && !(n.execTime && $util.isInteger(n.execTime.low) && $util.isInteger(n.execTime.high)))
      return "execTime: integer|Long expected";
    if (n.prepTime != null && n.hasOwnProperty("prepTime") && !$util.isInteger(n.prepTime) && !(n.prepTime && $util.isInteger(n.prepTime.low) && $util.isInteger(n.prepTime.high)))
      return "prepTime: integer|Long expected";
    if (n.config != null && n.hasOwnProperty("config")) {
      if (!Array.isArray(n.config))
        return "config: array expected";
      for (let t = 0; t < n.config.length; ++t)
        if (!$util.isString(n.config[t]))
          return "config: string[] expected";
    }
    if (n.uncaughtException != null && n.hasOwnProperty("uncaughtException") && !$util.isString(n.uncaughtException))
      return "uncaughtException: string expected";
    if (n.attributions != null && n.hasOwnProperty("attributions")) {
      if (!Array.isArray(n.attributions))
        return "attributions: array expected";
      for (let t = 0; t < n.attributions.length; ++t)
        if (!$util.isString(n.attributions[t]))
          return "attributions: string[] expected";
    }
    return n.os != null && n.hasOwnProperty("os") && !$util.isString(n.os) ? "os: string expected" : n.timezone != null && n.hasOwnProperty("timezone") && !$util.isString(n.timezone) ? "timezone: string expected" : n.headless != null && n.hasOwnProperty("headless") && typeof n.headless != "boolean" ? "headless: boolean expected" : n.isFragmentRun != null && n.hasOwnProperty("isFragmentRun") && typeof n.isFragmentRun != "boolean" ? "isFragmentRun: boolean expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.PageProfile)
      return n;
    let t = new $root.PageProfile();
    if (n.commands) {
      if (!Array.isArray(n.commands))
        throw TypeError(".PageProfile.commands: array expected");
      t.commands = [];
      for (let e = 0; e < n.commands.length; ++e) {
        if (typeof n.commands[e] != "object")
          throw TypeError(".PageProfile.commands: object expected");
        t.commands[e] = $root.Command.fromObject(n.commands[e]);
      }
    }
    if (n.execTime != null && ($util.Long ? (t.execTime = $util.Long.fromValue(n.execTime)).unsigned = !1 : typeof n.execTime == "string" ? t.execTime = parseInt(n.execTime, 10) : typeof n.execTime == "number" ? t.execTime = n.execTime : typeof n.execTime == "object" && (t.execTime = new $util.LongBits(n.execTime.low >>> 0, n.execTime.high >>> 0).toNumber())), n.prepTime != null && ($util.Long ? (t.prepTime = $util.Long.fromValue(n.prepTime)).unsigned = !1 : typeof n.prepTime == "string" ? t.prepTime = parseInt(n.prepTime, 10) : typeof n.prepTime == "number" ? t.prepTime = n.prepTime : typeof n.prepTime == "object" && (t.prepTime = new $util.LongBits(n.prepTime.low >>> 0, n.prepTime.high >>> 0).toNumber())), n.config) {
      if (!Array.isArray(n.config))
        throw TypeError(".PageProfile.config: array expected");
      t.config = [];
      for (let e = 0; e < n.config.length; ++e)
        t.config[e] = String(n.config[e]);
    }
    if (n.uncaughtException != null && (t.uncaughtException = String(n.uncaughtException)), n.attributions) {
      if (!Array.isArray(n.attributions))
        throw TypeError(".PageProfile.attributions: array expected");
      t.attributions = [];
      for (let e = 0; e < n.attributions.length; ++e)
        t.attributions[e] = String(n.attributions[e]);
    }
    return n.os != null && (t.os = String(n.os)), n.timezone != null && (t.timezone = String(n.timezone)), n.headless != null && (t.headless = !!n.headless), n.isFragmentRun != null && (t.isFragmentRun = !!n.isFragmentRun), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.commands = [], e.config = [], e.attributions = []), t.defaults) {
      if ($util.Long) {
        let o = new $util.Long(0, 0, !1);
        e.execTime = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
      } else
        e.execTime = t.longs === String ? "0" : 0;
      if ($util.Long) {
        let o = new $util.Long(0, 0, !1);
        e.prepTime = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
      } else
        e.prepTime = t.longs === String ? "0" : 0;
      e.uncaughtException = "", e.os = "", e.timezone = "", e.headless = !1, e.isFragmentRun = !1;
    }
    if (n.commands && n.commands.length) {
      e.commands = [];
      for (let o = 0; o < n.commands.length; ++o)
        e.commands[o] = $root.Command.toObject(n.commands[o], t);
    }
    if (n.execTime != null && n.hasOwnProperty("execTime") && (typeof n.execTime == "number" ? e.execTime = t.longs === String ? String(n.execTime) : n.execTime : e.execTime = t.longs === String ? $util.Long.prototype.toString.call(n.execTime) : t.longs === Number ? new $util.LongBits(n.execTime.low >>> 0, n.execTime.high >>> 0).toNumber() : n.execTime), n.prepTime != null && n.hasOwnProperty("prepTime") && (typeof n.prepTime == "number" ? e.prepTime = t.longs === String ? String(n.prepTime) : n.prepTime : e.prepTime = t.longs === String ? $util.Long.prototype.toString.call(n.prepTime) : t.longs === Number ? new $util.LongBits(n.prepTime.low >>> 0, n.prepTime.high >>> 0).toNumber() : n.prepTime), n.config && n.config.length) {
      e.config = [];
      for (let o = 0; o < n.config.length; ++o)
        e.config[o] = n.config[o];
    }
    if (n.uncaughtException != null && n.hasOwnProperty("uncaughtException") && (e.uncaughtException = n.uncaughtException), n.attributions && n.attributions.length) {
      e.attributions = [];
      for (let o = 0; o < n.attributions.length; ++o)
        e.attributions[o] = n.attributions[o];
    }
    return n.os != null && n.hasOwnProperty("os") && (e.os = n.os), n.timezone != null && n.hasOwnProperty("timezone") && (e.timezone = n.timezone), n.headless != null && n.hasOwnProperty("headless") && (e.headless = n.headless), n.isFragmentRun != null && n.hasOwnProperty("isFragmentRun") && (e.isFragmentRun = n.isFragmentRun), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/PageProfile";
  }, r;
})();
$root.Argument = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.k = "", r.prototype.t = "", r.prototype.m = "", r.prototype.p = 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.k != null && Object.hasOwnProperty.call(n, "k") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.k), n.t != null && Object.hasOwnProperty.call(n, "t") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.t), n.m != null && Object.hasOwnProperty.call(n, "m") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.m), n.p != null && Object.hasOwnProperty.call(n, "p") && t.uint32(
      /* id 5, wireType 0 =*/
      40
    ).int32(n.p), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Argument();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.k = n.string();
          break;
        }
        case 2: {
          p.t = n.string();
          break;
        }
        case 3: {
          p.m = n.string();
          break;
        }
        case 5: {
          p.p = n.int32();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.k != null && n.hasOwnProperty("k") && !$util.isString(n.k) ? "k: string expected" : n.t != null && n.hasOwnProperty("t") && !$util.isString(n.t) ? "t: string expected" : n.m != null && n.hasOwnProperty("m") && !$util.isString(n.m) ? "m: string expected" : n.p != null && n.hasOwnProperty("p") && !$util.isInteger(n.p) ? "p: integer expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Argument)
      return n;
    let t = new $root.Argument();
    return n.k != null && (t.k = String(n.k)), n.t != null && (t.t = String(n.t)), n.m != null && (t.m = String(n.m)), n.p != null && (t.p = n.p | 0), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.k = "", e.t = "", e.m = "", e.p = 0), n.k != null && n.hasOwnProperty("k") && (e.k = n.k), n.t != null && n.hasOwnProperty("t") && (e.t = n.t), n.m != null && n.hasOwnProperty("m") && (e.m = n.m), n.p != null && n.hasOwnProperty("p") && (e.p = n.p), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Argument";
  }, r;
})();
$root.Command = (() => {
  function r(c) {
    if (this.args = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.name = "", r.prototype.args = $util.emptyArray, r.prototype.time = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.name != null && Object.hasOwnProperty.call(n, "name") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.name), n.args != null && n.args.length)
      for (let e = 0; e < n.args.length; ++e)
        $root.Argument.encode(n.args[e], t.uint32(
          /* id 2, wireType 2 =*/
          18
        ).fork()).ldelim();
    return n.time != null && Object.hasOwnProperty.call(n, "time") && t.uint32(
      /* id 4, wireType 0 =*/
      32
    ).int64(n.time), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.Command();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.name = n.string();
          break;
        }
        case 2: {
          p.args && p.args.length || (p.args = []), p.args.push($root.Argument.decode(n, n.uint32()));
          break;
        }
        case 4: {
          p.time = n.int64();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
      return "name: string expected";
    if (n.args != null && n.hasOwnProperty("args")) {
      if (!Array.isArray(n.args))
        return "args: array expected";
      for (let t = 0; t < n.args.length; ++t) {
        let e = $root.Argument.verify(n.args[t]);
        if (e)
          return "args." + e;
      }
    }
    return n.time != null && n.hasOwnProperty("time") && !$util.isInteger(n.time) && !(n.time && $util.isInteger(n.time.low) && $util.isInteger(n.time.high)) ? "time: integer|Long expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.Command)
      return n;
    let t = new $root.Command();
    if (n.name != null && (t.name = String(n.name)), n.args) {
      if (!Array.isArray(n.args))
        throw TypeError(".Command.args: array expected");
      t.args = [];
      for (let e = 0; e < n.args.length; ++e) {
        if (typeof n.args[e] != "object")
          throw TypeError(".Command.args: object expected");
        t.args[e] = $root.Argument.fromObject(n.args[e]);
      }
    }
    return n.time != null && ($util.Long ? (t.time = $util.Long.fromValue(n.time)).unsigned = !1 : typeof n.time == "string" ? t.time = parseInt(n.time, 10) : typeof n.time == "number" ? t.time = n.time : typeof n.time == "object" && (t.time = new $util.LongBits(n.time.low >>> 0, n.time.high >>> 0).toNumber())), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.args = []), t.defaults)
      if (e.name = "", $util.Long) {
        let o = new $util.Long(0, 0, !1);
        e.time = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
      } else
        e.time = t.longs === String ? "0" : 0;
    if (n.name != null && n.hasOwnProperty("name") && (e.name = n.name), n.args && n.args.length) {
      e.args = [];
      for (let o = 0; o < n.args.length; ++o)
        e.args[o] = $root.Argument.toObject(n.args[o], t);
    }
    return n.time != null && n.hasOwnProperty("time") && (typeof n.time == "number" ? e.time = t.longs === String ? String(n.time) : n.time : e.time = t.longs === String ? $util.Long.prototype.toString.call(n.time) : t.longs === Number ? new $util.LongBits(n.time.low >>> 0, n.time.high >>> 0).toNumber() : n.time), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/Command";
  }, r;
})();
$root.PageNotFound = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.pageName = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.pageName != null && Object.hasOwnProperty.call(n, "pageName") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.pageName), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.PageNotFound();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.pageName = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.pageName != null && n.hasOwnProperty("pageName") && !$util.isString(n.pageName) ? "pageName: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.PageNotFound)
      return n;
    let t = new $root.PageNotFound();
    return n.pageName != null && (t.pageName = String(n.pageName)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.pageName = ""), n.pageName != null && n.hasOwnProperty("pageName") && (e.pageName = n.pageName), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/PageNotFound";
  }, r;
})();
$root.PagesChanged = (() => {
  function r(c) {
    if (this.appPages = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.appPages = $util.emptyArray, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.appPages != null && n.appPages.length)
      for (let e = 0; e < n.appPages.length; ++e)
        $root.AppPage.encode(n.appPages[e], t.uint32(
          /* id 1, wireType 2 =*/
          10
        ).fork()).ldelim();
    return t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.PagesChanged();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.appPages && p.appPages.length || (p.appPages = []), p.appPages.push($root.AppPage.decode(n, n.uint32()));
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.appPages != null && n.hasOwnProperty("appPages")) {
      if (!Array.isArray(n.appPages))
        return "appPages: array expected";
      for (let t = 0; t < n.appPages.length; ++t) {
        let e = $root.AppPage.verify(n.appPages[t]);
        if (e)
          return "appPages." + e;
      }
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.PagesChanged)
      return n;
    let t = new $root.PagesChanged();
    if (n.appPages) {
      if (!Array.isArray(n.appPages))
        throw TypeError(".PagesChanged.appPages: array expected");
      t.appPages = [];
      for (let e = 0; e < n.appPages.length; ++e) {
        if (typeof n.appPages[e] != "object")
          throw TypeError(".PagesChanged.appPages: object expected");
        t.appPages[e] = $root.AppPage.fromObject(n.appPages[e]);
      }
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.appPages = []), n.appPages && n.appPages.length) {
      e.appPages = [];
      for (let o = 0; o < n.appPages.length; ++o)
        e.appPages[o] = $root.AppPage.toObject(n.appPages[o], t);
    }
    return e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/PagesChanged";
  }, r;
})();
$root.ParentMessage = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.message = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.message != null && Object.hasOwnProperty.call(n, "message") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.message), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.ParentMessage();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.message = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.message != null && n.hasOwnProperty("message") && !$util.isString(n.message) ? "message: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.ParentMessage)
      return n;
    let t = new $root.ParentMessage();
    return n.message != null && (t.message = String(n.message)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.message = ""), n.message != null && n.hasOwnProperty("message") && (e.message = n.message), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/ParentMessage";
  }, r;
})();
$root.SessionEvent = (() => {
  function r(n) {
    if (n)
      for (let t = Object.keys(n), e = 0; e < t.length; ++e)
        n[t[e]] != null && (this[t[e]] = n[t[e]]);
  }
  r.prototype.scriptChangedOnDisk = null, r.prototype.scriptWasManuallyStopped = null, r.prototype.scriptCompilationException = null;
  let c;
  return Object.defineProperty(r.prototype, "type", {
    get: $util.oneOfGetter(c = ["scriptChangedOnDisk", "scriptWasManuallyStopped", "scriptCompilationException"]),
    set: $util.oneOfSetter(c)
  }), r.create = function(t) {
    return new r(t);
  }, r.encode = function(t, e) {
    return e || (e = $Writer.create()), t.scriptChangedOnDisk != null && Object.hasOwnProperty.call(t, "scriptChangedOnDisk") && e.uint32(
      /* id 1, wireType 0 =*/
      8
    ).bool(t.scriptChangedOnDisk), t.scriptWasManuallyStopped != null && Object.hasOwnProperty.call(t, "scriptWasManuallyStopped") && e.uint32(
      /* id 2, wireType 0 =*/
      16
    ).bool(t.scriptWasManuallyStopped), t.scriptCompilationException != null && Object.hasOwnProperty.call(t, "scriptCompilationException") && $root.Exception.encode(t.scriptCompilationException, e.uint32(
      /* id 3, wireType 2 =*/
      26
    ).fork()).ldelim(), e;
  }, r.encodeDelimited = function(t, e) {
    return this.encode(t, e).ldelim();
  }, r.decode = function(t, e, o) {
    t instanceof $Reader || (t = $Reader.create(t));
    let p = e === void 0 ? t.len : t.pos + e, h = new $root.SessionEvent();
    for (; t.pos < p; ) {
      let y = t.uint32();
      if (y === o)
        break;
      switch (y >>> 3) {
        case 1: {
          h.scriptChangedOnDisk = t.bool();
          break;
        }
        case 2: {
          h.scriptWasManuallyStopped = t.bool();
          break;
        }
        case 3: {
          h.scriptCompilationException = $root.Exception.decode(t, t.uint32());
          break;
        }
        default:
          t.skipType(y & 7);
          break;
      }
    }
    return h;
  }, r.decodeDelimited = function(t) {
    return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
  }, r.verify = function(t) {
    if (typeof t != "object" || t === null)
      return "object expected";
    let e = {};
    if (t.scriptChangedOnDisk != null && t.hasOwnProperty("scriptChangedOnDisk") && (e.type = 1, typeof t.scriptChangedOnDisk != "boolean"))
      return "scriptChangedOnDisk: boolean expected";
    if (t.scriptWasManuallyStopped != null && t.hasOwnProperty("scriptWasManuallyStopped")) {
      if (e.type === 1)
        return "type: multiple values";
      if (e.type = 1, typeof t.scriptWasManuallyStopped != "boolean")
        return "scriptWasManuallyStopped: boolean expected";
    }
    if (t.scriptCompilationException != null && t.hasOwnProperty("scriptCompilationException")) {
      if (e.type === 1)
        return "type: multiple values";
      e.type = 1;
      {
        let o = $root.Exception.verify(t.scriptCompilationException);
        if (o)
          return "scriptCompilationException." + o;
      }
    }
    return null;
  }, r.fromObject = function(t) {
    if (t instanceof $root.SessionEvent)
      return t;
    let e = new $root.SessionEvent();
    if (t.scriptChangedOnDisk != null && (e.scriptChangedOnDisk = !!t.scriptChangedOnDisk), t.scriptWasManuallyStopped != null && (e.scriptWasManuallyStopped = !!t.scriptWasManuallyStopped), t.scriptCompilationException != null) {
      if (typeof t.scriptCompilationException != "object")
        throw TypeError(".SessionEvent.scriptCompilationException: object expected");
      e.scriptCompilationException = $root.Exception.fromObject(t.scriptCompilationException);
    }
    return e;
  }, r.toObject = function(t, e) {
    e || (e = {});
    let o = {};
    return t.scriptChangedOnDisk != null && t.hasOwnProperty("scriptChangedOnDisk") && (o.scriptChangedOnDisk = t.scriptChangedOnDisk, e.oneofs && (o.type = "scriptChangedOnDisk")), t.scriptWasManuallyStopped != null && t.hasOwnProperty("scriptWasManuallyStopped") && (o.scriptWasManuallyStopped = t.scriptWasManuallyStopped, e.oneofs && (o.type = "scriptWasManuallyStopped")), t.scriptCompilationException != null && t.hasOwnProperty("scriptCompilationException") && (o.scriptCompilationException = $root.Exception.toObject(t.scriptCompilationException, e), e.oneofs && (o.type = "scriptCompilationException")), o;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(t) {
    return t === void 0 && (t = "type.googleapis.com"), t + "/SessionEvent";
  }, r;
})();
$root.MetricsEvent = (() => {
  function r(c) {
    if (this.commands = [], this.config = [], this.attributions = [], c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.event = "", r.prototype.anonymousId = "", r.prototype.machineIdV3 = "", r.prototype.machineIdV4 = "", r.prototype.reportHash = "", r.prototype.dev = !1, r.prototype.source = "", r.prototype.streamlitVersion = "", r.prototype.isHello = !1, r.prototype.appId = "", r.prototype.sessionId = "", r.prototype.pythonVersion = "", r.prototype.serverOs = "", r.prototype.hasDisplay = !1, r.prototype.isWebdriver = !1, r.prototype.hostedAt = "", r.prototype.owner = "", r.prototype.repo = "", r.prototype.branch = "", r.prototype.mainModule = "", r.prototype.creatorId = "", r.prototype.contextPageUrl = "", r.prototype.contextPageTitle = "", r.prototype.contextPagePath = "", r.prototype.contextPageReferrer = "", r.prototype.contextPageSearch = "", r.prototype.contextLocale = "", r.prototype.contextUserAgent = "", r.prototype.label = "", r.prototype.commands = $util.emptyArray, r.prototype.execTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, r.prototype.prepTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, r.prototype.config = $util.emptyArray, r.prototype.uncaughtException = "", r.prototype.attributions = $util.emptyArray, r.prototype.os = "", r.prototype.timezone = "", r.prototype.headless = !1, r.prototype.isFragmentRun = !1, r.prototype.numPages = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, r.prototype.pageScriptHash = "", r.prototype.activeTheme = "", r.prototype.totalLoadTime = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, r.prototype.browserInfo = null, r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    if (t || (t = $Writer.create()), n.event != null && Object.hasOwnProperty.call(n, "event") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.event), n.anonymousId != null && Object.hasOwnProperty.call(n, "anonymousId") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.anonymousId), n.machineIdV3 != null && Object.hasOwnProperty.call(n, "machineIdV3") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.machineIdV3), n.reportHash != null && Object.hasOwnProperty.call(n, "reportHash") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.reportHash), n.dev != null && Object.hasOwnProperty.call(n, "dev") && t.uint32(
      /* id 5, wireType 0 =*/
      40
    ).bool(n.dev), n.source != null && Object.hasOwnProperty.call(n, "source") && t.uint32(
      /* id 6, wireType 2 =*/
      50
    ).string(n.source), n.streamlitVersion != null && Object.hasOwnProperty.call(n, "streamlitVersion") && t.uint32(
      /* id 7, wireType 2 =*/
      58
    ).string(n.streamlitVersion), n.isHello != null && Object.hasOwnProperty.call(n, "isHello") && t.uint32(
      /* id 8, wireType 0 =*/
      64
    ).bool(n.isHello), n.hostedAt != null && Object.hasOwnProperty.call(n, "hostedAt") && t.uint32(
      /* id 9, wireType 2 =*/
      74
    ).string(n.hostedAt), n.owner != null && Object.hasOwnProperty.call(n, "owner") && t.uint32(
      /* id 10, wireType 2 =*/
      82
    ).string(n.owner), n.repo != null && Object.hasOwnProperty.call(n, "repo") && t.uint32(
      /* id 11, wireType 2 =*/
      90
    ).string(n.repo), n.branch != null && Object.hasOwnProperty.call(n, "branch") && t.uint32(
      /* id 12, wireType 2 =*/
      98
    ).string(n.branch), n.mainModule != null && Object.hasOwnProperty.call(n, "mainModule") && t.uint32(
      /* id 13, wireType 2 =*/
      106
    ).string(n.mainModule), n.creatorId != null && Object.hasOwnProperty.call(n, "creatorId") && t.uint32(
      /* id 14, wireType 2 =*/
      114
    ).string(n.creatorId), n.contextPageUrl != null && Object.hasOwnProperty.call(n, "contextPageUrl") && t.uint32(
      /* id 15, wireType 2 =*/
      122
    ).string(n.contextPageUrl), n.contextPageTitle != null && Object.hasOwnProperty.call(n, "contextPageTitle") && t.uint32(
      /* id 16, wireType 2 =*/
      130
    ).string(n.contextPageTitle), n.contextPagePath != null && Object.hasOwnProperty.call(n, "contextPagePath") && t.uint32(
      /* id 17, wireType 2 =*/
      138
    ).string(n.contextPagePath), n.contextPageReferrer != null && Object.hasOwnProperty.call(n, "contextPageReferrer") && t.uint32(
      /* id 18, wireType 2 =*/
      146
    ).string(n.contextPageReferrer), n.contextPageSearch != null && Object.hasOwnProperty.call(n, "contextPageSearch") && t.uint32(
      /* id 19, wireType 2 =*/
      154
    ).string(n.contextPageSearch), n.contextLocale != null && Object.hasOwnProperty.call(n, "contextLocale") && t.uint32(
      /* id 20, wireType 2 =*/
      162
    ).string(n.contextLocale), n.contextUserAgent != null && Object.hasOwnProperty.call(n, "contextUserAgent") && t.uint32(
      /* id 21, wireType 2 =*/
      170
    ).string(n.contextUserAgent), n.label != null && Object.hasOwnProperty.call(n, "label") && t.uint32(
      /* id 22, wireType 2 =*/
      178
    ).string(n.label), n.commands != null && n.commands.length)
      for (let e = 0; e < n.commands.length; ++e)
        $root.Command.encode(n.commands[e], t.uint32(
          /* id 23, wireType 2 =*/
          186
        ).fork()).ldelim();
    if (n.execTime != null && Object.hasOwnProperty.call(n, "execTime") && t.uint32(
      /* id 24, wireType 0 =*/
      192
    ).int64(n.execTime), n.prepTime != null && Object.hasOwnProperty.call(n, "prepTime") && t.uint32(
      /* id 25, wireType 0 =*/
      200
    ).int64(n.prepTime), n.config != null && n.config.length)
      for (let e = 0; e < n.config.length; ++e)
        t.uint32(
          /* id 26, wireType 2 =*/
          210
        ).string(n.config[e]);
    if (n.uncaughtException != null && Object.hasOwnProperty.call(n, "uncaughtException") && t.uint32(
      /* id 27, wireType 2 =*/
      218
    ).string(n.uncaughtException), n.attributions != null && n.attributions.length)
      for (let e = 0; e < n.attributions.length; ++e)
        t.uint32(
          /* id 28, wireType 2 =*/
          226
        ).string(n.attributions[e]);
    return n.os != null && Object.hasOwnProperty.call(n, "os") && t.uint32(
      /* id 29, wireType 2 =*/
      234
    ).string(n.os), n.timezone != null && Object.hasOwnProperty.call(n, "timezone") && t.uint32(
      /* id 30, wireType 2 =*/
      242
    ).string(n.timezone), n.headless != null && Object.hasOwnProperty.call(n, "headless") && t.uint32(
      /* id 31, wireType 0 =*/
      248
    ).bool(n.headless), n.isFragmentRun != null && Object.hasOwnProperty.call(n, "isFragmentRun") && t.uint32(
      /* id 32, wireType 0 =*/
      256
    ).bool(n.isFragmentRun), n.appId != null && Object.hasOwnProperty.call(n, "appId") && t.uint32(
      /* id 33, wireType 2 =*/
      266
    ).string(n.appId), n.numPages != null && Object.hasOwnProperty.call(n, "numPages") && t.uint32(
      /* id 34, wireType 0 =*/
      272
    ).int64(n.numPages), n.sessionId != null && Object.hasOwnProperty.call(n, "sessionId") && t.uint32(
      /* id 35, wireType 2 =*/
      282
    ).string(n.sessionId), n.pythonVersion != null && Object.hasOwnProperty.call(n, "pythonVersion") && t.uint32(
      /* id 36, wireType 2 =*/
      290
    ).string(n.pythonVersion), n.pageScriptHash != null && Object.hasOwnProperty.call(n, "pageScriptHash") && t.uint32(
      /* id 37, wireType 2 =*/
      298
    ).string(n.pageScriptHash), n.activeTheme != null && Object.hasOwnProperty.call(n, "activeTheme") && t.uint32(
      /* id 38, wireType 2 =*/
      306
    ).string(n.activeTheme), n.totalLoadTime != null && Object.hasOwnProperty.call(n, "totalLoadTime") && t.uint32(
      /* id 39, wireType 0 =*/
      312
    ).int64(n.totalLoadTime), n.browserInfo != null && Object.hasOwnProperty.call(n, "browserInfo") && $root.BrowserInfo.encode(n.browserInfo, t.uint32(
      /* id 40, wireType 2 =*/
      322
    ).fork()).ldelim(), n.machineIdV4 != null && Object.hasOwnProperty.call(n, "machineIdV4") && t.uint32(
      /* id 41, wireType 2 =*/
      330
    ).string(n.machineIdV4), n.serverOs != null && Object.hasOwnProperty.call(n, "serverOs") && t.uint32(
      /* id 42, wireType 2 =*/
      338
    ).string(n.serverOs), n.hasDisplay != null && Object.hasOwnProperty.call(n, "hasDisplay") && t.uint32(
      /* id 43, wireType 0 =*/
      344
    ).bool(n.hasDisplay), n.isWebdriver != null && Object.hasOwnProperty.call(n, "isWebdriver") && t.uint32(
      /* id 44, wireType 0 =*/
      352
    ).bool(n.isWebdriver), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.MetricsEvent();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.event = n.string();
          break;
        }
        case 2: {
          p.anonymousId = n.string();
          break;
        }
        case 3: {
          p.machineIdV3 = n.string();
          break;
        }
        case 41: {
          p.machineIdV4 = n.string();
          break;
        }
        case 4: {
          p.reportHash = n.string();
          break;
        }
        case 5: {
          p.dev = n.bool();
          break;
        }
        case 6: {
          p.source = n.string();
          break;
        }
        case 7: {
          p.streamlitVersion = n.string();
          break;
        }
        case 8: {
          p.isHello = n.bool();
          break;
        }
        case 33: {
          p.appId = n.string();
          break;
        }
        case 35: {
          p.sessionId = n.string();
          break;
        }
        case 36: {
          p.pythonVersion = n.string();
          break;
        }
        case 42: {
          p.serverOs = n.string();
          break;
        }
        case 43: {
          p.hasDisplay = n.bool();
          break;
        }
        case 44: {
          p.isWebdriver = n.bool();
          break;
        }
        case 9: {
          p.hostedAt = n.string();
          break;
        }
        case 10: {
          p.owner = n.string();
          break;
        }
        case 11: {
          p.repo = n.string();
          break;
        }
        case 12: {
          p.branch = n.string();
          break;
        }
        case 13: {
          p.mainModule = n.string();
          break;
        }
        case 14: {
          p.creatorId = n.string();
          break;
        }
        case 15: {
          p.contextPageUrl = n.string();
          break;
        }
        case 16: {
          p.contextPageTitle = n.string();
          break;
        }
        case 17: {
          p.contextPagePath = n.string();
          break;
        }
        case 18: {
          p.contextPageReferrer = n.string();
          break;
        }
        case 19: {
          p.contextPageSearch = n.string();
          break;
        }
        case 20: {
          p.contextLocale = n.string();
          break;
        }
        case 21: {
          p.contextUserAgent = n.string();
          break;
        }
        case 22: {
          p.label = n.string();
          break;
        }
        case 23: {
          p.commands && p.commands.length || (p.commands = []), p.commands.push($root.Command.decode(n, n.uint32()));
          break;
        }
        case 24: {
          p.execTime = n.int64();
          break;
        }
        case 25: {
          p.prepTime = n.int64();
          break;
        }
        case 26: {
          p.config && p.config.length || (p.config = []), p.config.push(n.string());
          break;
        }
        case 27: {
          p.uncaughtException = n.string();
          break;
        }
        case 28: {
          p.attributions && p.attributions.length || (p.attributions = []), p.attributions.push(n.string());
          break;
        }
        case 29: {
          p.os = n.string();
          break;
        }
        case 30: {
          p.timezone = n.string();
          break;
        }
        case 31: {
          p.headless = n.bool();
          break;
        }
        case 32: {
          p.isFragmentRun = n.bool();
          break;
        }
        case 34: {
          p.numPages = n.int64();
          break;
        }
        case 37: {
          p.pageScriptHash = n.string();
          break;
        }
        case 38: {
          p.activeTheme = n.string();
          break;
        }
        case 39: {
          p.totalLoadTime = n.int64();
          break;
        }
        case 40: {
          p.browserInfo = $root.BrowserInfo.decode(n, n.uint32());
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    if (typeof n != "object" || n === null)
      return "object expected";
    if (n.event != null && n.hasOwnProperty("event") && !$util.isString(n.event))
      return "event: string expected";
    if (n.anonymousId != null && n.hasOwnProperty("anonymousId") && !$util.isString(n.anonymousId))
      return "anonymousId: string expected";
    if (n.machineIdV3 != null && n.hasOwnProperty("machineIdV3") && !$util.isString(n.machineIdV3))
      return "machineIdV3: string expected";
    if (n.machineIdV4 != null && n.hasOwnProperty("machineIdV4") && !$util.isString(n.machineIdV4))
      return "machineIdV4: string expected";
    if (n.reportHash != null && n.hasOwnProperty("reportHash") && !$util.isString(n.reportHash))
      return "reportHash: string expected";
    if (n.dev != null && n.hasOwnProperty("dev") && typeof n.dev != "boolean")
      return "dev: boolean expected";
    if (n.source != null && n.hasOwnProperty("source") && !$util.isString(n.source))
      return "source: string expected";
    if (n.streamlitVersion != null && n.hasOwnProperty("streamlitVersion") && !$util.isString(n.streamlitVersion))
      return "streamlitVersion: string expected";
    if (n.isHello != null && n.hasOwnProperty("isHello") && typeof n.isHello != "boolean")
      return "isHello: boolean expected";
    if (n.appId != null && n.hasOwnProperty("appId") && !$util.isString(n.appId))
      return "appId: string expected";
    if (n.sessionId != null && n.hasOwnProperty("sessionId") && !$util.isString(n.sessionId))
      return "sessionId: string expected";
    if (n.pythonVersion != null && n.hasOwnProperty("pythonVersion") && !$util.isString(n.pythonVersion))
      return "pythonVersion: string expected";
    if (n.serverOs != null && n.hasOwnProperty("serverOs") && !$util.isString(n.serverOs))
      return "serverOs: string expected";
    if (n.hasDisplay != null && n.hasOwnProperty("hasDisplay") && typeof n.hasDisplay != "boolean")
      return "hasDisplay: boolean expected";
    if (n.isWebdriver != null && n.hasOwnProperty("isWebdriver") && typeof n.isWebdriver != "boolean")
      return "isWebdriver: boolean expected";
    if (n.hostedAt != null && n.hasOwnProperty("hostedAt") && !$util.isString(n.hostedAt))
      return "hostedAt: string expected";
    if (n.owner != null && n.hasOwnProperty("owner") && !$util.isString(n.owner))
      return "owner: string expected";
    if (n.repo != null && n.hasOwnProperty("repo") && !$util.isString(n.repo))
      return "repo: string expected";
    if (n.branch != null && n.hasOwnProperty("branch") && !$util.isString(n.branch))
      return "branch: string expected";
    if (n.mainModule != null && n.hasOwnProperty("mainModule") && !$util.isString(n.mainModule))
      return "mainModule: string expected";
    if (n.creatorId != null && n.hasOwnProperty("creatorId") && !$util.isString(n.creatorId))
      return "creatorId: string expected";
    if (n.contextPageUrl != null && n.hasOwnProperty("contextPageUrl") && !$util.isString(n.contextPageUrl))
      return "contextPageUrl: string expected";
    if (n.contextPageTitle != null && n.hasOwnProperty("contextPageTitle") && !$util.isString(n.contextPageTitle))
      return "contextPageTitle: string expected";
    if (n.contextPagePath != null && n.hasOwnProperty("contextPagePath") && !$util.isString(n.contextPagePath))
      return "contextPagePath: string expected";
    if (n.contextPageReferrer != null && n.hasOwnProperty("contextPageReferrer") && !$util.isString(n.contextPageReferrer))
      return "contextPageReferrer: string expected";
    if (n.contextPageSearch != null && n.hasOwnProperty("contextPageSearch") && !$util.isString(n.contextPageSearch))
      return "contextPageSearch: string expected";
    if (n.contextLocale != null && n.hasOwnProperty("contextLocale") && !$util.isString(n.contextLocale))
      return "contextLocale: string expected";
    if (n.contextUserAgent != null && n.hasOwnProperty("contextUserAgent") && !$util.isString(n.contextUserAgent))
      return "contextUserAgent: string expected";
    if (n.label != null && n.hasOwnProperty("label") && !$util.isString(n.label))
      return "label: string expected";
    if (n.commands != null && n.hasOwnProperty("commands")) {
      if (!Array.isArray(n.commands))
        return "commands: array expected";
      for (let t = 0; t < n.commands.length; ++t) {
        let e = $root.Command.verify(n.commands[t]);
        if (e)
          return "commands." + e;
      }
    }
    if (n.execTime != null && n.hasOwnProperty("execTime") && !$util.isInteger(n.execTime) && !(n.execTime && $util.isInteger(n.execTime.low) && $util.isInteger(n.execTime.high)))
      return "execTime: integer|Long expected";
    if (n.prepTime != null && n.hasOwnProperty("prepTime") && !$util.isInteger(n.prepTime) && !(n.prepTime && $util.isInteger(n.prepTime.low) && $util.isInteger(n.prepTime.high)))
      return "prepTime: integer|Long expected";
    if (n.config != null && n.hasOwnProperty("config")) {
      if (!Array.isArray(n.config))
        return "config: array expected";
      for (let t = 0; t < n.config.length; ++t)
        if (!$util.isString(n.config[t]))
          return "config: string[] expected";
    }
    if (n.uncaughtException != null && n.hasOwnProperty("uncaughtException") && !$util.isString(n.uncaughtException))
      return "uncaughtException: string expected";
    if (n.attributions != null && n.hasOwnProperty("attributions")) {
      if (!Array.isArray(n.attributions))
        return "attributions: array expected";
      for (let t = 0; t < n.attributions.length; ++t)
        if (!$util.isString(n.attributions[t]))
          return "attributions: string[] expected";
    }
    if (n.os != null && n.hasOwnProperty("os") && !$util.isString(n.os))
      return "os: string expected";
    if (n.timezone != null && n.hasOwnProperty("timezone") && !$util.isString(n.timezone))
      return "timezone: string expected";
    if (n.headless != null && n.hasOwnProperty("headless") && typeof n.headless != "boolean")
      return "headless: boolean expected";
    if (n.isFragmentRun != null && n.hasOwnProperty("isFragmentRun") && typeof n.isFragmentRun != "boolean")
      return "isFragmentRun: boolean expected";
    if (n.numPages != null && n.hasOwnProperty("numPages") && !$util.isInteger(n.numPages) && !(n.numPages && $util.isInteger(n.numPages.low) && $util.isInteger(n.numPages.high)))
      return "numPages: integer|Long expected";
    if (n.pageScriptHash != null && n.hasOwnProperty("pageScriptHash") && !$util.isString(n.pageScriptHash))
      return "pageScriptHash: string expected";
    if (n.activeTheme != null && n.hasOwnProperty("activeTheme") && !$util.isString(n.activeTheme))
      return "activeTheme: string expected";
    if (n.totalLoadTime != null && n.hasOwnProperty("totalLoadTime") && !$util.isInteger(n.totalLoadTime) && !(n.totalLoadTime && $util.isInteger(n.totalLoadTime.low) && $util.isInteger(n.totalLoadTime.high)))
      return "totalLoadTime: integer|Long expected";
    if (n.browserInfo != null && n.hasOwnProperty("browserInfo")) {
      let t = $root.BrowserInfo.verify(n.browserInfo);
      if (t)
        return "browserInfo." + t;
    }
    return null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.MetricsEvent)
      return n;
    let t = new $root.MetricsEvent();
    if (n.event != null && (t.event = String(n.event)), n.anonymousId != null && (t.anonymousId = String(n.anonymousId)), n.machineIdV3 != null && (t.machineIdV3 = String(n.machineIdV3)), n.machineIdV4 != null && (t.machineIdV4 = String(n.machineIdV4)), n.reportHash != null && (t.reportHash = String(n.reportHash)), n.dev != null && (t.dev = !!n.dev), n.source != null && (t.source = String(n.source)), n.streamlitVersion != null && (t.streamlitVersion = String(n.streamlitVersion)), n.isHello != null && (t.isHello = !!n.isHello), n.appId != null && (t.appId = String(n.appId)), n.sessionId != null && (t.sessionId = String(n.sessionId)), n.pythonVersion != null && (t.pythonVersion = String(n.pythonVersion)), n.serverOs != null && (t.serverOs = String(n.serverOs)), n.hasDisplay != null && (t.hasDisplay = !!n.hasDisplay), n.isWebdriver != null && (t.isWebdriver = !!n.isWebdriver), n.hostedAt != null && (t.hostedAt = String(n.hostedAt)), n.owner != null && (t.owner = String(n.owner)), n.repo != null && (t.repo = String(n.repo)), n.branch != null && (t.branch = String(n.branch)), n.mainModule != null && (t.mainModule = String(n.mainModule)), n.creatorId != null && (t.creatorId = String(n.creatorId)), n.contextPageUrl != null && (t.contextPageUrl = String(n.contextPageUrl)), n.contextPageTitle != null && (t.contextPageTitle = String(n.contextPageTitle)), n.contextPagePath != null && (t.contextPagePath = String(n.contextPagePath)), n.contextPageReferrer != null && (t.contextPageReferrer = String(n.contextPageReferrer)), n.contextPageSearch != null && (t.contextPageSearch = String(n.contextPageSearch)), n.contextLocale != null && (t.contextLocale = String(n.contextLocale)), n.contextUserAgent != null && (t.contextUserAgent = String(n.contextUserAgent)), n.label != null && (t.label = String(n.label)), n.commands) {
      if (!Array.isArray(n.commands))
        throw TypeError(".MetricsEvent.commands: array expected");
      t.commands = [];
      for (let e = 0; e < n.commands.length; ++e) {
        if (typeof n.commands[e] != "object")
          throw TypeError(".MetricsEvent.commands: object expected");
        t.commands[e] = $root.Command.fromObject(n.commands[e]);
      }
    }
    if (n.execTime != null && ($util.Long ? (t.execTime = $util.Long.fromValue(n.execTime)).unsigned = !1 : typeof n.execTime == "string" ? t.execTime = parseInt(n.execTime, 10) : typeof n.execTime == "number" ? t.execTime = n.execTime : typeof n.execTime == "object" && (t.execTime = new $util.LongBits(n.execTime.low >>> 0, n.execTime.high >>> 0).toNumber())), n.prepTime != null && ($util.Long ? (t.prepTime = $util.Long.fromValue(n.prepTime)).unsigned = !1 : typeof n.prepTime == "string" ? t.prepTime = parseInt(n.prepTime, 10) : typeof n.prepTime == "number" ? t.prepTime = n.prepTime : typeof n.prepTime == "object" && (t.prepTime = new $util.LongBits(n.prepTime.low >>> 0, n.prepTime.high >>> 0).toNumber())), n.config) {
      if (!Array.isArray(n.config))
        throw TypeError(".MetricsEvent.config: array expected");
      t.config = [];
      for (let e = 0; e < n.config.length; ++e)
        t.config[e] = String(n.config[e]);
    }
    if (n.uncaughtException != null && (t.uncaughtException = String(n.uncaughtException)), n.attributions) {
      if (!Array.isArray(n.attributions))
        throw TypeError(".MetricsEvent.attributions: array expected");
      t.attributions = [];
      for (let e = 0; e < n.attributions.length; ++e)
        t.attributions[e] = String(n.attributions[e]);
    }
    if (n.os != null && (t.os = String(n.os)), n.timezone != null && (t.timezone = String(n.timezone)), n.headless != null && (t.headless = !!n.headless), n.isFragmentRun != null && (t.isFragmentRun = !!n.isFragmentRun), n.numPages != null && ($util.Long ? (t.numPages = $util.Long.fromValue(n.numPages)).unsigned = !1 : typeof n.numPages == "string" ? t.numPages = parseInt(n.numPages, 10) : typeof n.numPages == "number" ? t.numPages = n.numPages : typeof n.numPages == "object" && (t.numPages = new $util.LongBits(n.numPages.low >>> 0, n.numPages.high >>> 0).toNumber())), n.pageScriptHash != null && (t.pageScriptHash = String(n.pageScriptHash)), n.activeTheme != null && (t.activeTheme = String(n.activeTheme)), n.totalLoadTime != null && ($util.Long ? (t.totalLoadTime = $util.Long.fromValue(n.totalLoadTime)).unsigned = !1 : typeof n.totalLoadTime == "string" ? t.totalLoadTime = parseInt(n.totalLoadTime, 10) : typeof n.totalLoadTime == "number" ? t.totalLoadTime = n.totalLoadTime : typeof n.totalLoadTime == "object" && (t.totalLoadTime = new $util.LongBits(n.totalLoadTime.low >>> 0, n.totalLoadTime.high >>> 0).toNumber())), n.browserInfo != null) {
      if (typeof n.browserInfo != "object")
        throw TypeError(".MetricsEvent.browserInfo: object expected");
      t.browserInfo = $root.BrowserInfo.fromObject(n.browserInfo);
    }
    return t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    if ((t.arrays || t.defaults) && (e.commands = [], e.config = [], e.attributions = []), t.defaults) {
      if (e.event = "", e.anonymousId = "", e.machineIdV3 = "", e.reportHash = "", e.dev = !1, e.source = "", e.streamlitVersion = "", e.isHello = !1, e.hostedAt = "", e.owner = "", e.repo = "", e.branch = "", e.mainModule = "", e.creatorId = "", e.contextPageUrl = "", e.contextPageTitle = "", e.contextPagePath = "", e.contextPageReferrer = "", e.contextPageSearch = "", e.contextLocale = "", e.contextUserAgent = "", e.label = "", $util.Long) {
        let o = new $util.Long(0, 0, !1);
        e.execTime = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
      } else
        e.execTime = t.longs === String ? "0" : 0;
      if ($util.Long) {
        let o = new $util.Long(0, 0, !1);
        e.prepTime = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
      } else
        e.prepTime = t.longs === String ? "0" : 0;
      if (e.uncaughtException = "", e.os = "", e.timezone = "", e.headless = !1, e.isFragmentRun = !1, e.appId = "", $util.Long) {
        let o = new $util.Long(0, 0, !1);
        e.numPages = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
      } else
        e.numPages = t.longs === String ? "0" : 0;
      if (e.sessionId = "", e.pythonVersion = "", e.pageScriptHash = "", e.activeTheme = "", $util.Long) {
        let o = new $util.Long(0, 0, !1);
        e.totalLoadTime = t.longs === String ? o.toString() : t.longs === Number ? o.toNumber() : o;
      } else
        e.totalLoadTime = t.longs === String ? "0" : 0;
      e.browserInfo = null, e.machineIdV4 = "", e.serverOs = "", e.hasDisplay = !1, e.isWebdriver = !1;
    }
    if (n.event != null && n.hasOwnProperty("event") && (e.event = n.event), n.anonymousId != null && n.hasOwnProperty("anonymousId") && (e.anonymousId = n.anonymousId), n.machineIdV3 != null && n.hasOwnProperty("machineIdV3") && (e.machineIdV3 = n.machineIdV3), n.reportHash != null && n.hasOwnProperty("reportHash") && (e.reportHash = n.reportHash), n.dev != null && n.hasOwnProperty("dev") && (e.dev = n.dev), n.source != null && n.hasOwnProperty("source") && (e.source = n.source), n.streamlitVersion != null && n.hasOwnProperty("streamlitVersion") && (e.streamlitVersion = n.streamlitVersion), n.isHello != null && n.hasOwnProperty("isHello") && (e.isHello = n.isHello), n.hostedAt != null && n.hasOwnProperty("hostedAt") && (e.hostedAt = n.hostedAt), n.owner != null && n.hasOwnProperty("owner") && (e.owner = n.owner), n.repo != null && n.hasOwnProperty("repo") && (e.repo = n.repo), n.branch != null && n.hasOwnProperty("branch") && (e.branch = n.branch), n.mainModule != null && n.hasOwnProperty("mainModule") && (e.mainModule = n.mainModule), n.creatorId != null && n.hasOwnProperty("creatorId") && (e.creatorId = n.creatorId), n.contextPageUrl != null && n.hasOwnProperty("contextPageUrl") && (e.contextPageUrl = n.contextPageUrl), n.contextPageTitle != null && n.hasOwnProperty("contextPageTitle") && (e.contextPageTitle = n.contextPageTitle), n.contextPagePath != null && n.hasOwnProperty("contextPagePath") && (e.contextPagePath = n.contextPagePath), n.contextPageReferrer != null && n.hasOwnProperty("contextPageReferrer") && (e.contextPageReferrer = n.contextPageReferrer), n.contextPageSearch != null && n.hasOwnProperty("contextPageSearch") && (e.contextPageSearch = n.contextPageSearch), n.contextLocale != null && n.hasOwnProperty("contextLocale") && (e.contextLocale = n.contextLocale), n.contextUserAgent != null && n.hasOwnProperty("contextUserAgent") && (e.contextUserAgent = n.contextUserAgent), n.label != null && n.hasOwnProperty("label") && (e.label = n.label), n.commands && n.commands.length) {
      e.commands = [];
      for (let o = 0; o < n.commands.length; ++o)
        e.commands[o] = $root.Command.toObject(n.commands[o], t);
    }
    if (n.execTime != null && n.hasOwnProperty("execTime") && (typeof n.execTime == "number" ? e.execTime = t.longs === String ? String(n.execTime) : n.execTime : e.execTime = t.longs === String ? $util.Long.prototype.toString.call(n.execTime) : t.longs === Number ? new $util.LongBits(n.execTime.low >>> 0, n.execTime.high >>> 0).toNumber() : n.execTime), n.prepTime != null && n.hasOwnProperty("prepTime") && (typeof n.prepTime == "number" ? e.prepTime = t.longs === String ? String(n.prepTime) : n.prepTime : e.prepTime = t.longs === String ? $util.Long.prototype.toString.call(n.prepTime) : t.longs === Number ? new $util.LongBits(n.prepTime.low >>> 0, n.prepTime.high >>> 0).toNumber() : n.prepTime), n.config && n.config.length) {
      e.config = [];
      for (let o = 0; o < n.config.length; ++o)
        e.config[o] = n.config[o];
    }
    if (n.uncaughtException != null && n.hasOwnProperty("uncaughtException") && (e.uncaughtException = n.uncaughtException), n.attributions && n.attributions.length) {
      e.attributions = [];
      for (let o = 0; o < n.attributions.length; ++o)
        e.attributions[o] = n.attributions[o];
    }
    return n.os != null && n.hasOwnProperty("os") && (e.os = n.os), n.timezone != null && n.hasOwnProperty("timezone") && (e.timezone = n.timezone), n.headless != null && n.hasOwnProperty("headless") && (e.headless = n.headless), n.isFragmentRun != null && n.hasOwnProperty("isFragmentRun") && (e.isFragmentRun = n.isFragmentRun), n.appId != null && n.hasOwnProperty("appId") && (e.appId = n.appId), n.numPages != null && n.hasOwnProperty("numPages") && (typeof n.numPages == "number" ? e.numPages = t.longs === String ? String(n.numPages) : n.numPages : e.numPages = t.longs === String ? $util.Long.prototype.toString.call(n.numPages) : t.longs === Number ? new $util.LongBits(n.numPages.low >>> 0, n.numPages.high >>> 0).toNumber() : n.numPages), n.sessionId != null && n.hasOwnProperty("sessionId") && (e.sessionId = n.sessionId), n.pythonVersion != null && n.hasOwnProperty("pythonVersion") && (e.pythonVersion = n.pythonVersion), n.pageScriptHash != null && n.hasOwnProperty("pageScriptHash") && (e.pageScriptHash = n.pageScriptHash), n.activeTheme != null && n.hasOwnProperty("activeTheme") && (e.activeTheme = n.activeTheme), n.totalLoadTime != null && n.hasOwnProperty("totalLoadTime") && (typeof n.totalLoadTime == "number" ? e.totalLoadTime = t.longs === String ? String(n.totalLoadTime) : n.totalLoadTime : e.totalLoadTime = t.longs === String ? $util.Long.prototype.toString.call(n.totalLoadTime) : t.longs === Number ? new $util.LongBits(n.totalLoadTime.low >>> 0, n.totalLoadTime.high >>> 0).toNumber() : n.totalLoadTime), n.browserInfo != null && n.hasOwnProperty("browserInfo") && (e.browserInfo = $root.BrowserInfo.toObject(n.browserInfo, t)), n.machineIdV4 != null && n.hasOwnProperty("machineIdV4") && (e.machineIdV4 = n.machineIdV4), n.serverOs != null && n.hasOwnProperty("serverOs") && (e.serverOs = n.serverOs), n.hasDisplay != null && n.hasOwnProperty("hasDisplay") && (e.hasDisplay = n.hasDisplay), n.isWebdriver != null && n.hasOwnProperty("isWebdriver") && (e.isWebdriver = n.isWebdriver), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/MetricsEvent";
  }, r;
})();
$root.BrowserInfo = (() => {
  function r(c) {
    if (c)
      for (let n = Object.keys(c), t = 0; t < n.length; ++t)
        c[n[t]] != null && (this[n[t]] = c[n[t]]);
  }
  return r.prototype.browserName = "", r.prototype.browserVersion = "", r.prototype.deviceType = "", r.prototype.os = "", r.create = function(n) {
    return new r(n);
  }, r.encode = function(n, t) {
    return t || (t = $Writer.create()), n.browserName != null && Object.hasOwnProperty.call(n, "browserName") && t.uint32(
      /* id 1, wireType 2 =*/
      10
    ).string(n.browserName), n.browserVersion != null && Object.hasOwnProperty.call(n, "browserVersion") && t.uint32(
      /* id 2, wireType 2 =*/
      18
    ).string(n.browserVersion), n.deviceType != null && Object.hasOwnProperty.call(n, "deviceType") && t.uint32(
      /* id 3, wireType 2 =*/
      26
    ).string(n.deviceType), n.os != null && Object.hasOwnProperty.call(n, "os") && t.uint32(
      /* id 4, wireType 2 =*/
      34
    ).string(n.os), t;
  }, r.encodeDelimited = function(n, t) {
    return this.encode(n, t).ldelim();
  }, r.decode = function(n, t, e) {
    n instanceof $Reader || (n = $Reader.create(n));
    let o = t === void 0 ? n.len : n.pos + t, p = new $root.BrowserInfo();
    for (; n.pos < o; ) {
      let h = n.uint32();
      if (h === e)
        break;
      switch (h >>> 3) {
        case 1: {
          p.browserName = n.string();
          break;
        }
        case 2: {
          p.browserVersion = n.string();
          break;
        }
        case 3: {
          p.deviceType = n.string();
          break;
        }
        case 4: {
          p.os = n.string();
          break;
        }
        default:
          n.skipType(h & 7);
          break;
      }
    }
    return p;
  }, r.decodeDelimited = function(n) {
    return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
  }, r.verify = function(n) {
    return typeof n != "object" || n === null ? "object expected" : n.browserName != null && n.hasOwnProperty("browserName") && !$util.isString(n.browserName) ? "browserName: string expected" : n.browserVersion != null && n.hasOwnProperty("browserVersion") && !$util.isString(n.browserVersion) ? "browserVersion: string expected" : n.deviceType != null && n.hasOwnProperty("deviceType") && !$util.isString(n.deviceType) ? "deviceType: string expected" : n.os != null && n.hasOwnProperty("os") && !$util.isString(n.os) ? "os: string expected" : null;
  }, r.fromObject = function(n) {
    if (n instanceof $root.BrowserInfo)
      return n;
    let t = new $root.BrowserInfo();
    return n.browserName != null && (t.browserName = String(n.browserName)), n.browserVersion != null && (t.browserVersion = String(n.browserVersion)), n.deviceType != null && (t.deviceType = String(n.deviceType)), n.os != null && (t.os = String(n.os)), t;
  }, r.toObject = function(n, t) {
    t || (t = {});
    let e = {};
    return t.defaults && (e.browserName = "", e.browserVersion = "", e.deviceType = "", e.os = ""), n.browserName != null && n.hasOwnProperty("browserName") && (e.browserName = n.browserName), n.browserVersion != null && n.hasOwnProperty("browserVersion") && (e.browserVersion = n.browserVersion), n.deviceType != null && n.hasOwnProperty("deviceType") && (e.deviceType = n.deviceType), n.os != null && n.hasOwnProperty("os") && (e.os = n.os), e;
  }, r.prototype.toJSON = function() {
    return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
  }, r.getTypeUrl = function(n) {
    return n === void 0 && (n = "type.googleapis.com"), n + "/BrowserInfo";
  }, r;
})();
$root.openmetrics = (() => {
  const r = {};
  return r.MetricSet = (function() {
    function c(n) {
      if (this.metricFamilies = [], n)
        for (let t = Object.keys(n), e = 0; e < t.length; ++e)
          n[t[e]] != null && (this[t[e]] = n[t[e]]);
    }
    return c.prototype.metricFamilies = $util.emptyArray, c.create = function(t) {
      return new c(t);
    }, c.encode = function(t, e) {
      if (e || (e = $Writer.create()), t.metricFamilies != null && t.metricFamilies.length)
        for (let o = 0; o < t.metricFamilies.length; ++o)
          $root.openmetrics.MetricFamily.encode(t.metricFamilies[o], e.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return e;
    }, c.encodeDelimited = function(t, e) {
      return this.encode(t, e).ldelim();
    }, c.decode = function(t, e, o) {
      t instanceof $Reader || (t = $Reader.create(t));
      let p = e === void 0 ? t.len : t.pos + e, h = new $root.openmetrics.MetricSet();
      for (; t.pos < p; ) {
        let y = t.uint32();
        if (y === o)
          break;
        switch (y >>> 3) {
          case 1: {
            h.metricFamilies && h.metricFamilies.length || (h.metricFamilies = []), h.metricFamilies.push($root.openmetrics.MetricFamily.decode(t, t.uint32()));
            break;
          }
          default:
            t.skipType(y & 7);
            break;
        }
      }
      return h;
    }, c.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, c.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.metricFamilies != null && t.hasOwnProperty("metricFamilies")) {
        if (!Array.isArray(t.metricFamilies))
          return "metricFamilies: array expected";
        for (let e = 0; e < t.metricFamilies.length; ++e) {
          let o = $root.openmetrics.MetricFamily.verify(t.metricFamilies[e]);
          if (o)
            return "metricFamilies." + o;
        }
      }
      return null;
    }, c.fromObject = function(t) {
      if (t instanceof $root.openmetrics.MetricSet)
        return t;
      let e = new $root.openmetrics.MetricSet();
      if (t.metricFamilies) {
        if (!Array.isArray(t.metricFamilies))
          throw TypeError(".openmetrics.MetricSet.metricFamilies: array expected");
        e.metricFamilies = [];
        for (let o = 0; o < t.metricFamilies.length; ++o) {
          if (typeof t.metricFamilies[o] != "object")
            throw TypeError(".openmetrics.MetricSet.metricFamilies: object expected");
          e.metricFamilies[o] = $root.openmetrics.MetricFamily.fromObject(t.metricFamilies[o]);
        }
      }
      return e;
    }, c.toObject = function(t, e) {
      e || (e = {});
      let o = {};
      if ((e.arrays || e.defaults) && (o.metricFamilies = []), t.metricFamilies && t.metricFamilies.length) {
        o.metricFamilies = [];
        for (let p = 0; p < t.metricFamilies.length; ++p)
          o.metricFamilies[p] = $root.openmetrics.MetricFamily.toObject(t.metricFamilies[p], e);
      }
      return o;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/openmetrics.MetricSet";
    }, c;
  })(), r.MetricFamily = (function() {
    function c(n) {
      if (this.metrics = [], n)
        for (let t = Object.keys(n), e = 0; e < t.length; ++e)
          n[t[e]] != null && (this[t[e]] = n[t[e]]);
    }
    return c.prototype.name = "", c.prototype.type = 0, c.prototype.unit = "", c.prototype.help = "", c.prototype.metrics = $util.emptyArray, c.create = function(t) {
      return new c(t);
    }, c.encode = function(t, e) {
      if (e || (e = $Writer.create()), t.name != null && Object.hasOwnProperty.call(t, "name") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.name), t.type != null && Object.hasOwnProperty.call(t, "type") && e.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int32(t.type), t.unit != null && Object.hasOwnProperty.call(t, "unit") && e.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(t.unit), t.help != null && Object.hasOwnProperty.call(t, "help") && e.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(t.help), t.metrics != null && t.metrics.length)
        for (let o = 0; o < t.metrics.length; ++o)
          $root.Metric.encode(t.metrics[o], e.uint32(
            /* id 5, wireType 2 =*/
            42
          ).fork()).ldelim();
      return e;
    }, c.encodeDelimited = function(t, e) {
      return this.encode(t, e).ldelim();
    }, c.decode = function(t, e, o) {
      t instanceof $Reader || (t = $Reader.create(t));
      let p = e === void 0 ? t.len : t.pos + e, h = new $root.openmetrics.MetricFamily();
      for (; t.pos < p; ) {
        let y = t.uint32();
        if (y === o)
          break;
        switch (y >>> 3) {
          case 1: {
            h.name = t.string();
            break;
          }
          case 2: {
            h.type = t.int32();
            break;
          }
          case 3: {
            h.unit = t.string();
            break;
          }
          case 4: {
            h.help = t.string();
            break;
          }
          case 5: {
            h.metrics && h.metrics.length || (h.metrics = []), h.metrics.push($root.Metric.decode(t, t.uint32()));
            break;
          }
          default:
            t.skipType(y & 7);
            break;
        }
      }
      return h;
    }, c.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, c.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name))
        return "name: string expected";
      if (t.type != null && t.hasOwnProperty("type"))
        switch (t.type) {
          default:
            return "type: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
            break;
        }
      if (t.unit != null && t.hasOwnProperty("unit") && !$util.isString(t.unit))
        return "unit: string expected";
      if (t.help != null && t.hasOwnProperty("help") && !$util.isString(t.help))
        return "help: string expected";
      if (t.metrics != null && t.hasOwnProperty("metrics")) {
        if (!Array.isArray(t.metrics))
          return "metrics: array expected";
        for (let e = 0; e < t.metrics.length; ++e) {
          let o = $root.Metric.verify(t.metrics[e]);
          if (o)
            return "metrics." + o;
        }
      }
      return null;
    }, c.fromObject = function(t) {
      if (t instanceof $root.openmetrics.MetricFamily)
        return t;
      let e = new $root.openmetrics.MetricFamily();
      switch (t.name != null && (e.name = String(t.name)), t.type) {
        default:
          if (typeof t.type == "number") {
            e.type = t.type;
            break;
          }
          break;
        case "UNKNOWN":
        case 0:
          e.type = 0;
          break;
        case "GAUGE":
        case 1:
          e.type = 1;
          break;
        case "COUNTER":
        case 2:
          e.type = 2;
          break;
        case "STATE_SET":
        case 3:
          e.type = 3;
          break;
        case "INFO":
        case 4:
          e.type = 4;
          break;
        case "HISTOGRAM":
        case 5:
          e.type = 5;
          break;
        case "GAUGE_HISTOGRAM":
        case 6:
          e.type = 6;
          break;
        case "SUMMARY":
        case 7:
          e.type = 7;
          break;
      }
      if (t.unit != null && (e.unit = String(t.unit)), t.help != null && (e.help = String(t.help)), t.metrics) {
        if (!Array.isArray(t.metrics))
          throw TypeError(".openmetrics.MetricFamily.metrics: array expected");
        e.metrics = [];
        for (let o = 0; o < t.metrics.length; ++o) {
          if (typeof t.metrics[o] != "object")
            throw TypeError(".openmetrics.MetricFamily.metrics: object expected");
          e.metrics[o] = $root.Metric.fromObject(t.metrics[o]);
        }
      }
      return e;
    }, c.toObject = function(t, e) {
      e || (e = {});
      let o = {};
      if ((e.arrays || e.defaults) && (o.metrics = []), e.defaults && (o.name = "", o.type = e.enums === String ? "UNKNOWN" : 0, o.unit = "", o.help = ""), t.name != null && t.hasOwnProperty("name") && (o.name = t.name), t.type != null && t.hasOwnProperty("type") && (o.type = e.enums === String ? $root.openmetrics.MetricType[t.type] === void 0 ? t.type : $root.openmetrics.MetricType[t.type] : t.type), t.unit != null && t.hasOwnProperty("unit") && (o.unit = t.unit), t.help != null && t.hasOwnProperty("help") && (o.help = t.help), t.metrics && t.metrics.length) {
        o.metrics = [];
        for (let p = 0; p < t.metrics.length; ++p)
          o.metrics[p] = $root.Metric.toObject(t.metrics[p], e);
      }
      return o;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/openmetrics.MetricFamily";
    }, c;
  })(), r.MetricType = (function() {
    const c = {}, n = Object.create(c);
    return n[c[0] = "UNKNOWN"] = 0, n[c[1] = "GAUGE"] = 1, n[c[2] = "COUNTER"] = 2, n[c[3] = "STATE_SET"] = 3, n[c[4] = "INFO"] = 4, n[c[5] = "HISTOGRAM"] = 5, n[c[6] = "GAUGE_HISTOGRAM"] = 6, n[c[7] = "SUMMARY"] = 7, n;
  })(), r.Metric = (function() {
    function c(n) {
      if (this.labels = [], this.metricPoints = [], n)
        for (let t = Object.keys(n), e = 0; e < t.length; ++e)
          n[t[e]] != null && (this[t[e]] = n[t[e]]);
    }
    return c.prototype.labels = $util.emptyArray, c.prototype.metricPoints = $util.emptyArray, c.create = function(t) {
      return new c(t);
    }, c.encode = function(t, e) {
      if (e || (e = $Writer.create()), t.labels != null && t.labels.length)
        for (let o = 0; o < t.labels.length; ++o)
          $root.openmetrics.Label.encode(t.labels[o], e.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      if (t.metricPoints != null && t.metricPoints.length)
        for (let o = 0; o < t.metricPoints.length; ++o)
          $root.openmetrics.MetricPoint.encode(t.metricPoints[o], e.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim();
      return e;
    }, c.encodeDelimited = function(t, e) {
      return this.encode(t, e).ldelim();
    }, c.decode = function(t, e, o) {
      t instanceof $Reader || (t = $Reader.create(t));
      let p = e === void 0 ? t.len : t.pos + e, h = new $root.openmetrics.Metric();
      for (; t.pos < p; ) {
        let y = t.uint32();
        if (y === o)
          break;
        switch (y >>> 3) {
          case 1: {
            h.labels && h.labels.length || (h.labels = []), h.labels.push($root.openmetrics.Label.decode(t, t.uint32()));
            break;
          }
          case 2: {
            h.metricPoints && h.metricPoints.length || (h.metricPoints = []), h.metricPoints.push($root.openmetrics.MetricPoint.decode(t, t.uint32()));
            break;
          }
          default:
            t.skipType(y & 7);
            break;
        }
      }
      return h;
    }, c.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, c.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.labels != null && t.hasOwnProperty("labels")) {
        if (!Array.isArray(t.labels))
          return "labels: array expected";
        for (let e = 0; e < t.labels.length; ++e) {
          let o = $root.openmetrics.Label.verify(t.labels[e]);
          if (o)
            return "labels." + o;
        }
      }
      if (t.metricPoints != null && t.hasOwnProperty("metricPoints")) {
        if (!Array.isArray(t.metricPoints))
          return "metricPoints: array expected";
        for (let e = 0; e < t.metricPoints.length; ++e) {
          let o = $root.openmetrics.MetricPoint.verify(t.metricPoints[e]);
          if (o)
            return "metricPoints." + o;
        }
      }
      return null;
    }, c.fromObject = function(t) {
      if (t instanceof $root.openmetrics.Metric)
        return t;
      let e = new $root.openmetrics.Metric();
      if (t.labels) {
        if (!Array.isArray(t.labels))
          throw TypeError(".openmetrics.Metric.labels: array expected");
        e.labels = [];
        for (let o = 0; o < t.labels.length; ++o) {
          if (typeof t.labels[o] != "object")
            throw TypeError(".openmetrics.Metric.labels: object expected");
          e.labels[o] = $root.openmetrics.Label.fromObject(t.labels[o]);
        }
      }
      if (t.metricPoints) {
        if (!Array.isArray(t.metricPoints))
          throw TypeError(".openmetrics.Metric.metricPoints: array expected");
        e.metricPoints = [];
        for (let o = 0; o < t.metricPoints.length; ++o) {
          if (typeof t.metricPoints[o] != "object")
            throw TypeError(".openmetrics.Metric.metricPoints: object expected");
          e.metricPoints[o] = $root.openmetrics.MetricPoint.fromObject(t.metricPoints[o]);
        }
      }
      return e;
    }, c.toObject = function(t, e) {
      e || (e = {});
      let o = {};
      if ((e.arrays || e.defaults) && (o.labels = [], o.metricPoints = []), t.labels && t.labels.length) {
        o.labels = [];
        for (let p = 0; p < t.labels.length; ++p)
          o.labels[p] = $root.openmetrics.Label.toObject(t.labels[p], e);
      }
      if (t.metricPoints && t.metricPoints.length) {
        o.metricPoints = [];
        for (let p = 0; p < t.metricPoints.length; ++p)
          o.metricPoints[p] = $root.openmetrics.MetricPoint.toObject(t.metricPoints[p], e);
      }
      return o;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/openmetrics.Metric";
    }, c;
  })(), r.Label = (function() {
    function c(n) {
      if (n)
        for (let t = Object.keys(n), e = 0; e < t.length; ++e)
          n[t[e]] != null && (this[t[e]] = n[t[e]]);
    }
    return c.prototype.name = "", c.prototype.value = "", c.create = function(t) {
      return new c(t);
    }, c.encode = function(t, e) {
      return e || (e = $Writer.create()), t.name != null && Object.hasOwnProperty.call(t, "name") && e.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(t.name), t.value != null && Object.hasOwnProperty.call(t, "value") && e.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(t.value), e;
    }, c.encodeDelimited = function(t, e) {
      return this.encode(t, e).ldelim();
    }, c.decode = function(t, e, o) {
      t instanceof $Reader || (t = $Reader.create(t));
      let p = e === void 0 ? t.len : t.pos + e, h = new $root.openmetrics.Label();
      for (; t.pos < p; ) {
        let y = t.uint32();
        if (y === o)
          break;
        switch (y >>> 3) {
          case 1: {
            h.name = t.string();
            break;
          }
          case 2: {
            h.value = t.string();
            break;
          }
          default:
            t.skipType(y & 7);
            break;
        }
      }
      return h;
    }, c.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, c.verify = function(t) {
      return typeof t != "object" || t === null ? "object expected" : t.name != null && t.hasOwnProperty("name") && !$util.isString(t.name) ? "name: string expected" : t.value != null && t.hasOwnProperty("value") && !$util.isString(t.value) ? "value: string expected" : null;
    }, c.fromObject = function(t) {
      if (t instanceof $root.openmetrics.Label)
        return t;
      let e = new $root.openmetrics.Label();
      return t.name != null && (e.name = String(t.name)), t.value != null && (e.value = String(t.value)), e;
    }, c.toObject = function(t, e) {
      e || (e = {});
      let o = {};
      return e.defaults && (o.name = "", o.value = ""), t.name != null && t.hasOwnProperty("name") && (o.name = t.name), t.value != null && t.hasOwnProperty("value") && (o.value = t.value), o;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/openmetrics.Label";
    }, c;
  })(), r.MetricPoint = (function() {
    function c(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    c.prototype.unknownValue = null, c.prototype.gaugeValue = null, c.prototype.counterValue = null, c.prototype.histogramValue = null, c.prototype.stateSetValue = null, c.prototype.infoValue = null, c.prototype.summaryValue = null, c.prototype.timestamp = null;
    let n;
    return Object.defineProperty(c.prototype, "value", {
      get: $util.oneOfGetter(n = ["unknownValue", "gaugeValue", "counterValue", "histogramValue", "stateSetValue", "infoValue", "summaryValue"]),
      set: $util.oneOfSetter(n)
    }), c.create = function(e) {
      return new c(e);
    }, c.encode = function(e, o) {
      return o || (o = $Writer.create()), e.unknownValue != null && Object.hasOwnProperty.call(e, "unknownValue") && $root.openmetrics.UnknownValue.encode(e.unknownValue, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.gaugeValue != null && Object.hasOwnProperty.call(e, "gaugeValue") && $root.openmetrics.GaugeValue.encode(e.gaugeValue, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.counterValue != null && Object.hasOwnProperty.call(e, "counterValue") && $root.openmetrics.CounterValue.encode(e.counterValue, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), e.histogramValue != null && Object.hasOwnProperty.call(e, "histogramValue") && $root.openmetrics.HistogramValue.encode(e.histogramValue, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e.stateSetValue != null && Object.hasOwnProperty.call(e, "stateSetValue") && $root.openmetrics.StateSetValue.encode(e.stateSetValue, o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), e.infoValue != null && Object.hasOwnProperty.call(e, "infoValue") && $root.openmetrics.InfoValue.encode(e.infoValue, o.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), e.summaryValue != null && Object.hasOwnProperty.call(e, "summaryValue") && $root.openmetrics.SummaryValue.encode(e.summaryValue, o.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), e.timestamp != null && Object.hasOwnProperty.call(e, "timestamp") && $root.google.protobuf.Timestamp.encode(e.timestamp, o.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), o;
    }, c.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, c.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.openmetrics.MetricPoint();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.unknownValue = $root.openmetrics.UnknownValue.decode(e, e.uint32());
            break;
          }
          case 2: {
            y.gaugeValue = $root.openmetrics.GaugeValue.decode(e, e.uint32());
            break;
          }
          case 3: {
            y.counterValue = $root.openmetrics.CounterValue.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.histogramValue = $root.openmetrics.HistogramValue.decode(e, e.uint32());
            break;
          }
          case 5: {
            y.stateSetValue = $root.openmetrics.StateSetValue.decode(e, e.uint32());
            break;
          }
          case 6: {
            y.infoValue = $root.openmetrics.InfoValue.decode(e, e.uint32());
            break;
          }
          case 7: {
            y.summaryValue = $root.openmetrics.SummaryValue.decode(e, e.uint32());
            break;
          }
          case 8: {
            y.timestamp = $root.google.protobuf.Timestamp.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, c.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, c.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      let o = {};
      if (e.unknownValue != null && e.hasOwnProperty("unknownValue")) {
        o.value = 1;
        {
          let p = $root.openmetrics.UnknownValue.verify(e.unknownValue);
          if (p)
            return "unknownValue." + p;
        }
      }
      if (e.gaugeValue != null && e.hasOwnProperty("gaugeValue")) {
        if (o.value === 1)
          return "value: multiple values";
        o.value = 1;
        {
          let p = $root.openmetrics.GaugeValue.verify(e.gaugeValue);
          if (p)
            return "gaugeValue." + p;
        }
      }
      if (e.counterValue != null && e.hasOwnProperty("counterValue")) {
        if (o.value === 1)
          return "value: multiple values";
        o.value = 1;
        {
          let p = $root.openmetrics.CounterValue.verify(e.counterValue);
          if (p)
            return "counterValue." + p;
        }
      }
      if (e.histogramValue != null && e.hasOwnProperty("histogramValue")) {
        if (o.value === 1)
          return "value: multiple values";
        o.value = 1;
        {
          let p = $root.openmetrics.HistogramValue.verify(e.histogramValue);
          if (p)
            return "histogramValue." + p;
        }
      }
      if (e.stateSetValue != null && e.hasOwnProperty("stateSetValue")) {
        if (o.value === 1)
          return "value: multiple values";
        o.value = 1;
        {
          let p = $root.openmetrics.StateSetValue.verify(e.stateSetValue);
          if (p)
            return "stateSetValue." + p;
        }
      }
      if (e.infoValue != null && e.hasOwnProperty("infoValue")) {
        if (o.value === 1)
          return "value: multiple values";
        o.value = 1;
        {
          let p = $root.openmetrics.InfoValue.verify(e.infoValue);
          if (p)
            return "infoValue." + p;
        }
      }
      if (e.summaryValue != null && e.hasOwnProperty("summaryValue")) {
        if (o.value === 1)
          return "value: multiple values";
        o.value = 1;
        {
          let p = $root.openmetrics.SummaryValue.verify(e.summaryValue);
          if (p)
            return "summaryValue." + p;
        }
      }
      if (e.timestamp != null && e.hasOwnProperty("timestamp")) {
        let p = $root.google.protobuf.Timestamp.verify(e.timestamp);
        if (p)
          return "timestamp." + p;
      }
      return null;
    }, c.fromObject = function(e) {
      if (e instanceof $root.openmetrics.MetricPoint)
        return e;
      let o = new $root.openmetrics.MetricPoint();
      if (e.unknownValue != null) {
        if (typeof e.unknownValue != "object")
          throw TypeError(".openmetrics.MetricPoint.unknownValue: object expected");
        o.unknownValue = $root.openmetrics.UnknownValue.fromObject(e.unknownValue);
      }
      if (e.gaugeValue != null) {
        if (typeof e.gaugeValue != "object")
          throw TypeError(".openmetrics.MetricPoint.gaugeValue: object expected");
        o.gaugeValue = $root.openmetrics.GaugeValue.fromObject(e.gaugeValue);
      }
      if (e.counterValue != null) {
        if (typeof e.counterValue != "object")
          throw TypeError(".openmetrics.MetricPoint.counterValue: object expected");
        o.counterValue = $root.openmetrics.CounterValue.fromObject(e.counterValue);
      }
      if (e.histogramValue != null) {
        if (typeof e.histogramValue != "object")
          throw TypeError(".openmetrics.MetricPoint.histogramValue: object expected");
        o.histogramValue = $root.openmetrics.HistogramValue.fromObject(e.histogramValue);
      }
      if (e.stateSetValue != null) {
        if (typeof e.stateSetValue != "object")
          throw TypeError(".openmetrics.MetricPoint.stateSetValue: object expected");
        o.stateSetValue = $root.openmetrics.StateSetValue.fromObject(e.stateSetValue);
      }
      if (e.infoValue != null) {
        if (typeof e.infoValue != "object")
          throw TypeError(".openmetrics.MetricPoint.infoValue: object expected");
        o.infoValue = $root.openmetrics.InfoValue.fromObject(e.infoValue);
      }
      if (e.summaryValue != null) {
        if (typeof e.summaryValue != "object")
          throw TypeError(".openmetrics.MetricPoint.summaryValue: object expected");
        o.summaryValue = $root.openmetrics.SummaryValue.fromObject(e.summaryValue);
      }
      if (e.timestamp != null) {
        if (typeof e.timestamp != "object")
          throw TypeError(".openmetrics.MetricPoint.timestamp: object expected");
        o.timestamp = $root.google.protobuf.Timestamp.fromObject(e.timestamp);
      }
      return o;
    }, c.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return o.defaults && (p.timestamp = null), e.unknownValue != null && e.hasOwnProperty("unknownValue") && (p.unknownValue = $root.openmetrics.UnknownValue.toObject(e.unknownValue, o), o.oneofs && (p.value = "unknownValue")), e.gaugeValue != null && e.hasOwnProperty("gaugeValue") && (p.gaugeValue = $root.openmetrics.GaugeValue.toObject(e.gaugeValue, o), o.oneofs && (p.value = "gaugeValue")), e.counterValue != null && e.hasOwnProperty("counterValue") && (p.counterValue = $root.openmetrics.CounterValue.toObject(e.counterValue, o), o.oneofs && (p.value = "counterValue")), e.histogramValue != null && e.hasOwnProperty("histogramValue") && (p.histogramValue = $root.openmetrics.HistogramValue.toObject(e.histogramValue, o), o.oneofs && (p.value = "histogramValue")), e.stateSetValue != null && e.hasOwnProperty("stateSetValue") && (p.stateSetValue = $root.openmetrics.StateSetValue.toObject(e.stateSetValue, o), o.oneofs && (p.value = "stateSetValue")), e.infoValue != null && e.hasOwnProperty("infoValue") && (p.infoValue = $root.openmetrics.InfoValue.toObject(e.infoValue, o), o.oneofs && (p.value = "infoValue")), e.summaryValue != null && e.hasOwnProperty("summaryValue") && (p.summaryValue = $root.openmetrics.SummaryValue.toObject(e.summaryValue, o), o.oneofs && (p.value = "summaryValue")), e.timestamp != null && e.hasOwnProperty("timestamp") && (p.timestamp = $root.google.protobuf.Timestamp.toObject(e.timestamp, o)), p;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.MetricPoint";
    }, c;
  })(), r.UnknownValue = (function() {
    function c(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    c.prototype.doubleValue = null, c.prototype.intValue = null;
    let n;
    return Object.defineProperty(c.prototype, "value", {
      get: $util.oneOfGetter(n = ["doubleValue", "intValue"]),
      set: $util.oneOfSetter(n)
    }), c.create = function(e) {
      return new c(e);
    }, c.encode = function(e, o) {
      return o || (o = $Writer.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && o.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(e.intValue), o;
    }, c.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, c.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.openmetrics.UnknownValue();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.doubleValue = e.double();
            break;
          }
          case 2: {
            y.intValue = e.int64();
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, c.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, c.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      let o = {};
      if (e.doubleValue != null && e.hasOwnProperty("doubleValue") && (o.value = 1, typeof e.doubleValue != "number"))
        return "doubleValue: number expected";
      if (e.intValue != null && e.hasOwnProperty("intValue")) {
        if (o.value === 1)
          return "value: multiple values";
        if (o.value = 1, !$util.isInteger(e.intValue) && !(e.intValue && $util.isInteger(e.intValue.low) && $util.isInteger(e.intValue.high)))
          return "intValue: integer|Long expected";
      }
      return null;
    }, c.fromObject = function(e) {
      if (e instanceof $root.openmetrics.UnknownValue)
        return e;
      let o = new $root.openmetrics.UnknownValue();
      return e.doubleValue != null && (o.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util.Long ? (o.intValue = $util.Long.fromValue(e.intValue)).unsigned = !1 : typeof e.intValue == "string" ? o.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? o.intValue = e.intValue : typeof e.intValue == "object" && (o.intValue = new $util.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), o;
    }, c.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return e.doubleValue != null && e.hasOwnProperty("doubleValue") && (p.doubleValue = o.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, o.oneofs && (p.value = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? p.intValue = o.longs === String ? String(e.intValue) : e.intValue : p.intValue = o.longs === String ? $util.Long.prototype.toString.call(e.intValue) : o.longs === Number ? new $util.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, o.oneofs && (p.value = "intValue")), p;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.UnknownValue";
    }, c;
  })(), r.GaugeValue = (function() {
    function c(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    c.prototype.doubleValue = null, c.prototype.intValue = null;
    let n;
    return Object.defineProperty(c.prototype, "value", {
      get: $util.oneOfGetter(n = ["doubleValue", "intValue"]),
      set: $util.oneOfSetter(n)
    }), c.create = function(e) {
      return new c(e);
    }, c.encode = function(e, o) {
      return o || (o = $Writer.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && o.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(e.intValue), o;
    }, c.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, c.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.openmetrics.GaugeValue();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.doubleValue = e.double();
            break;
          }
          case 2: {
            y.intValue = e.int64();
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, c.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, c.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      let o = {};
      if (e.doubleValue != null && e.hasOwnProperty("doubleValue") && (o.value = 1, typeof e.doubleValue != "number"))
        return "doubleValue: number expected";
      if (e.intValue != null && e.hasOwnProperty("intValue")) {
        if (o.value === 1)
          return "value: multiple values";
        if (o.value = 1, !$util.isInteger(e.intValue) && !(e.intValue && $util.isInteger(e.intValue.low) && $util.isInteger(e.intValue.high)))
          return "intValue: integer|Long expected";
      }
      return null;
    }, c.fromObject = function(e) {
      if (e instanceof $root.openmetrics.GaugeValue)
        return e;
      let o = new $root.openmetrics.GaugeValue();
      return e.doubleValue != null && (o.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util.Long ? (o.intValue = $util.Long.fromValue(e.intValue)).unsigned = !1 : typeof e.intValue == "string" ? o.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? o.intValue = e.intValue : typeof e.intValue == "object" && (o.intValue = new $util.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), o;
    }, c.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return e.doubleValue != null && e.hasOwnProperty("doubleValue") && (p.doubleValue = o.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, o.oneofs && (p.value = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? p.intValue = o.longs === String ? String(e.intValue) : e.intValue : p.intValue = o.longs === String ? $util.Long.prototype.toString.call(e.intValue) : o.longs === Number ? new $util.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, o.oneofs && (p.value = "intValue")), p;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.GaugeValue";
    }, c;
  })(), r.CounterValue = (function() {
    function c(t) {
      if (t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    c.prototype.doubleValue = null, c.prototype.intValue = null, c.prototype.created = null, c.prototype.exemplar = null;
    let n;
    return Object.defineProperty(c.prototype, "total", {
      get: $util.oneOfGetter(n = ["doubleValue", "intValue"]),
      set: $util.oneOfSetter(n)
    }), c.create = function(e) {
      return new c(e);
    }, c.encode = function(e, o) {
      return o || (o = $Writer.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && o.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(e.intValue), e.created != null && Object.hasOwnProperty.call(e, "created") && $root.google.protobuf.Timestamp.encode(e.created, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), e.exemplar != null && Object.hasOwnProperty.call(e, "exemplar") && $root.openmetrics.Exemplar.encode(e.exemplar, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), o;
    }, c.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, c.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.openmetrics.CounterValue();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.doubleValue = e.double();
            break;
          }
          case 2: {
            y.intValue = e.uint64();
            break;
          }
          case 3: {
            y.created = $root.google.protobuf.Timestamp.decode(e, e.uint32());
            break;
          }
          case 4: {
            y.exemplar = $root.openmetrics.Exemplar.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, c.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, c.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      let o = {};
      if (e.doubleValue != null && e.hasOwnProperty("doubleValue") && (o.total = 1, typeof e.doubleValue != "number"))
        return "doubleValue: number expected";
      if (e.intValue != null && e.hasOwnProperty("intValue")) {
        if (o.total === 1)
          return "total: multiple values";
        if (o.total = 1, !$util.isInteger(e.intValue) && !(e.intValue && $util.isInteger(e.intValue.low) && $util.isInteger(e.intValue.high)))
          return "intValue: integer|Long expected";
      }
      if (e.created != null && e.hasOwnProperty("created")) {
        let p = $root.google.protobuf.Timestamp.verify(e.created);
        if (p)
          return "created." + p;
      }
      if (e.exemplar != null && e.hasOwnProperty("exemplar")) {
        let p = $root.openmetrics.Exemplar.verify(e.exemplar);
        if (p)
          return "exemplar." + p;
      }
      return null;
    }, c.fromObject = function(e) {
      if (e instanceof $root.openmetrics.CounterValue)
        return e;
      let o = new $root.openmetrics.CounterValue();
      if (e.doubleValue != null && (o.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util.Long ? (o.intValue = $util.Long.fromValue(e.intValue)).unsigned = !0 : typeof e.intValue == "string" ? o.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? o.intValue = e.intValue : typeof e.intValue == "object" && (o.intValue = new $util.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber(!0))), e.created != null) {
        if (typeof e.created != "object")
          throw TypeError(".openmetrics.CounterValue.created: object expected");
        o.created = $root.google.protobuf.Timestamp.fromObject(e.created);
      }
      if (e.exemplar != null) {
        if (typeof e.exemplar != "object")
          throw TypeError(".openmetrics.CounterValue.exemplar: object expected");
        o.exemplar = $root.openmetrics.Exemplar.fromObject(e.exemplar);
      }
      return o;
    }, c.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      return o.defaults && (p.created = null, p.exemplar = null), e.doubleValue != null && e.hasOwnProperty("doubleValue") && (p.doubleValue = o.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, o.oneofs && (p.total = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? p.intValue = o.longs === String ? String(e.intValue) : e.intValue : p.intValue = o.longs === String ? $util.Long.prototype.toString.call(e.intValue) : o.longs === Number ? new $util.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber(!0) : e.intValue, o.oneofs && (p.total = "intValue")), e.created != null && e.hasOwnProperty("created") && (p.created = $root.google.protobuf.Timestamp.toObject(e.created, o)), e.exemplar != null && e.hasOwnProperty("exemplar") && (p.exemplar = $root.openmetrics.Exemplar.toObject(e.exemplar, o)), p;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.CounterValue";
    }, c;
  })(), r.HistogramValue = (function() {
    function c(t) {
      if (this.buckets = [], t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    c.prototype.doubleValue = null, c.prototype.intValue = null, c.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, c.prototype.created = null, c.prototype.buckets = $util.emptyArray;
    let n;
    return Object.defineProperty(c.prototype, "sum", {
      get: $util.oneOfGetter(n = ["doubleValue", "intValue"]),
      set: $util.oneOfSetter(n)
    }), c.create = function(e) {
      return new c(e);
    }, c.encode = function(e, o) {
      if (o || (o = $Writer.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && o.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(e.intValue), e.count != null && Object.hasOwnProperty.call(e, "count") && o.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(e.count), e.created != null && Object.hasOwnProperty.call(e, "created") && $root.google.protobuf.Timestamp.encode(e.created, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e.buckets != null && e.buckets.length)
        for (let p = 0; p < e.buckets.length; ++p)
          $root.openmetrics.HistogramValue.Bucket.encode(e.buckets[p], o.uint32(
            /* id 5, wireType 2 =*/
            42
          ).fork()).ldelim();
      return o;
    }, c.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, c.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.openmetrics.HistogramValue();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.doubleValue = e.double();
            break;
          }
          case 2: {
            y.intValue = e.int64();
            break;
          }
          case 3: {
            y.count = e.uint64();
            break;
          }
          case 4: {
            y.created = $root.google.protobuf.Timestamp.decode(e, e.uint32());
            break;
          }
          case 5: {
            y.buckets && y.buckets.length || (y.buckets = []), y.buckets.push($root.openmetrics.HistogramValue.Bucket.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, c.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, c.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      let o = {};
      if (e.doubleValue != null && e.hasOwnProperty("doubleValue") && (o.sum = 1, typeof e.doubleValue != "number"))
        return "doubleValue: number expected";
      if (e.intValue != null && e.hasOwnProperty("intValue")) {
        if (o.sum === 1)
          return "sum: multiple values";
        if (o.sum = 1, !$util.isInteger(e.intValue) && !(e.intValue && $util.isInteger(e.intValue.low) && $util.isInteger(e.intValue.high)))
          return "intValue: integer|Long expected";
      }
      if (e.count != null && e.hasOwnProperty("count") && !$util.isInteger(e.count) && !(e.count && $util.isInteger(e.count.low) && $util.isInteger(e.count.high)))
        return "count: integer|Long expected";
      if (e.created != null && e.hasOwnProperty("created")) {
        let p = $root.google.protobuf.Timestamp.verify(e.created);
        if (p)
          return "created." + p;
      }
      if (e.buckets != null && e.hasOwnProperty("buckets")) {
        if (!Array.isArray(e.buckets))
          return "buckets: array expected";
        for (let p = 0; p < e.buckets.length; ++p) {
          let h = $root.openmetrics.HistogramValue.Bucket.verify(e.buckets[p]);
          if (h)
            return "buckets." + h;
        }
      }
      return null;
    }, c.fromObject = function(e) {
      if (e instanceof $root.openmetrics.HistogramValue)
        return e;
      let o = new $root.openmetrics.HistogramValue();
      if (e.doubleValue != null && (o.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util.Long ? (o.intValue = $util.Long.fromValue(e.intValue)).unsigned = !1 : typeof e.intValue == "string" ? o.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? o.intValue = e.intValue : typeof e.intValue == "object" && (o.intValue = new $util.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), e.count != null && ($util.Long ? (o.count = $util.Long.fromValue(e.count)).unsigned = !0 : typeof e.count == "string" ? o.count = parseInt(e.count, 10) : typeof e.count == "number" ? o.count = e.count : typeof e.count == "object" && (o.count = new $util.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0))), e.created != null) {
        if (typeof e.created != "object")
          throw TypeError(".openmetrics.HistogramValue.created: object expected");
        o.created = $root.google.protobuf.Timestamp.fromObject(e.created);
      }
      if (e.buckets) {
        if (!Array.isArray(e.buckets))
          throw TypeError(".openmetrics.HistogramValue.buckets: array expected");
        o.buckets = [];
        for (let p = 0; p < e.buckets.length; ++p) {
          if (typeof e.buckets[p] != "object")
            throw TypeError(".openmetrics.HistogramValue.buckets: object expected");
          o.buckets[p] = $root.openmetrics.HistogramValue.Bucket.fromObject(e.buckets[p]);
        }
      }
      return o;
    }, c.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      if ((o.arrays || o.defaults) && (p.buckets = []), o.defaults) {
        if ($util.Long) {
          let h = new $util.Long(0, 0, !0);
          p.count = o.longs === String ? h.toString() : o.longs === Number ? h.toNumber() : h;
        } else
          p.count = o.longs === String ? "0" : 0;
        p.created = null;
      }
      if (e.doubleValue != null && e.hasOwnProperty("doubleValue") && (p.doubleValue = o.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, o.oneofs && (p.sum = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? p.intValue = o.longs === String ? String(e.intValue) : e.intValue : p.intValue = o.longs === String ? $util.Long.prototype.toString.call(e.intValue) : o.longs === Number ? new $util.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, o.oneofs && (p.sum = "intValue")), e.count != null && e.hasOwnProperty("count") && (typeof e.count == "number" ? p.count = o.longs === String ? String(e.count) : e.count : p.count = o.longs === String ? $util.Long.prototype.toString.call(e.count) : o.longs === Number ? new $util.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0) : e.count), e.created != null && e.hasOwnProperty("created") && (p.created = $root.google.protobuf.Timestamp.toObject(e.created, o)), e.buckets && e.buckets.length) {
        p.buckets = [];
        for (let h = 0; h < e.buckets.length; ++h)
          p.buckets[h] = $root.openmetrics.HistogramValue.Bucket.toObject(e.buckets[h], o);
      }
      return p;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.HistogramValue";
    }, c.Bucket = (function() {
      function t(e) {
        if (e)
          for (let o = Object.keys(e), p = 0; p < o.length; ++p)
            e[o[p]] != null && (this[o[p]] = e[o[p]]);
      }
      return t.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, t.prototype.upperBound = 0, t.prototype.exemplar = null, t.create = function(o) {
        return new t(o);
      }, t.encode = function(o, p) {
        return p || (p = $Writer.create()), o.count != null && Object.hasOwnProperty.call(o, "count") && p.uint32(
          /* id 1, wireType 0 =*/
          8
        ).uint64(o.count), o.upperBound != null && Object.hasOwnProperty.call(o, "upperBound") && p.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(o.upperBound), o.exemplar != null && Object.hasOwnProperty.call(o, "exemplar") && $root.openmetrics.Exemplar.encode(o.exemplar, p.uint32(
          /* id 3, wireType 2 =*/
          26
        ).fork()).ldelim(), p;
      }, t.encodeDelimited = function(o, p) {
        return this.encode(o, p).ldelim();
      }, t.decode = function(o, p, h) {
        o instanceof $Reader || (o = $Reader.create(o));
        let y = p === void 0 ? o.len : o.pos + p, b = new $root.openmetrics.HistogramValue.Bucket();
        for (; o.pos < y; ) {
          let O = o.uint32();
          if (O === h)
            break;
          switch (O >>> 3) {
            case 1: {
              b.count = o.uint64();
              break;
            }
            case 2: {
              b.upperBound = o.double();
              break;
            }
            case 3: {
              b.exemplar = $root.openmetrics.Exemplar.decode(o, o.uint32());
              break;
            }
            default:
              o.skipType(O & 7);
              break;
          }
        }
        return b;
      }, t.decodeDelimited = function(o) {
        return o instanceof $Reader || (o = new $Reader(o)), this.decode(o, o.uint32());
      }, t.verify = function(o) {
        if (typeof o != "object" || o === null)
          return "object expected";
        if (o.count != null && o.hasOwnProperty("count") && !$util.isInteger(o.count) && !(o.count && $util.isInteger(o.count.low) && $util.isInteger(o.count.high)))
          return "count: integer|Long expected";
        if (o.upperBound != null && o.hasOwnProperty("upperBound") && typeof o.upperBound != "number")
          return "upperBound: number expected";
        if (o.exemplar != null && o.hasOwnProperty("exemplar")) {
          let p = $root.openmetrics.Exemplar.verify(o.exemplar);
          if (p)
            return "exemplar." + p;
        }
        return null;
      }, t.fromObject = function(o) {
        if (o instanceof $root.openmetrics.HistogramValue.Bucket)
          return o;
        let p = new $root.openmetrics.HistogramValue.Bucket();
        if (o.count != null && ($util.Long ? (p.count = $util.Long.fromValue(o.count)).unsigned = !0 : typeof o.count == "string" ? p.count = parseInt(o.count, 10) : typeof o.count == "number" ? p.count = o.count : typeof o.count == "object" && (p.count = new $util.LongBits(o.count.low >>> 0, o.count.high >>> 0).toNumber(!0))), o.upperBound != null && (p.upperBound = Number(o.upperBound)), o.exemplar != null) {
          if (typeof o.exemplar != "object")
            throw TypeError(".openmetrics.HistogramValue.Bucket.exemplar: object expected");
          p.exemplar = $root.openmetrics.Exemplar.fromObject(o.exemplar);
        }
        return p;
      }, t.toObject = function(o, p) {
        p || (p = {});
        let h = {};
        if (p.defaults) {
          if ($util.Long) {
            let y = new $util.Long(0, 0, !0);
            h.count = p.longs === String ? y.toString() : p.longs === Number ? y.toNumber() : y;
          } else
            h.count = p.longs === String ? "0" : 0;
          h.upperBound = 0, h.exemplar = null;
        }
        return o.count != null && o.hasOwnProperty("count") && (typeof o.count == "number" ? h.count = p.longs === String ? String(o.count) : o.count : h.count = p.longs === String ? $util.Long.prototype.toString.call(o.count) : p.longs === Number ? new $util.LongBits(o.count.low >>> 0, o.count.high >>> 0).toNumber(!0) : o.count), o.upperBound != null && o.hasOwnProperty("upperBound") && (h.upperBound = p.json && !isFinite(o.upperBound) ? String(o.upperBound) : o.upperBound), o.exemplar != null && o.hasOwnProperty("exemplar") && (h.exemplar = $root.openmetrics.Exemplar.toObject(o.exemplar, p)), h;
      }, t.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, t.getTypeUrl = function(o) {
        return o === void 0 && (o = "type.googleapis.com"), o + "/openmetrics.HistogramValue.Bucket";
      }, t;
    })(), c;
  })(), r.Exemplar = (function() {
    function c(n) {
      if (this.label = [], n)
        for (let t = Object.keys(n), e = 0; e < t.length; ++e)
          n[t[e]] != null && (this[t[e]] = n[t[e]]);
    }
    return c.prototype.value = 0, c.prototype.timestamp = null, c.prototype.label = $util.emptyArray, c.create = function(t) {
      return new c(t);
    }, c.encode = function(t, e) {
      if (e || (e = $Writer.create()), t.value != null && Object.hasOwnProperty.call(t, "value") && e.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(t.value), t.timestamp != null && Object.hasOwnProperty.call(t, "timestamp") && $root.google.protobuf.Timestamp.encode(t.timestamp, e.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), t.label != null && t.label.length)
        for (let o = 0; o < t.label.length; ++o)
          $root.openmetrics.Label.encode(t.label[o], e.uint32(
            /* id 3, wireType 2 =*/
            26
          ).fork()).ldelim();
      return e;
    }, c.encodeDelimited = function(t, e) {
      return this.encode(t, e).ldelim();
    }, c.decode = function(t, e, o) {
      t instanceof $Reader || (t = $Reader.create(t));
      let p = e === void 0 ? t.len : t.pos + e, h = new $root.openmetrics.Exemplar();
      for (; t.pos < p; ) {
        let y = t.uint32();
        if (y === o)
          break;
        switch (y >>> 3) {
          case 1: {
            h.value = t.double();
            break;
          }
          case 2: {
            h.timestamp = $root.google.protobuf.Timestamp.decode(t, t.uint32());
            break;
          }
          case 3: {
            h.label && h.label.length || (h.label = []), h.label.push($root.openmetrics.Label.decode(t, t.uint32()));
            break;
          }
          default:
            t.skipType(y & 7);
            break;
        }
      }
      return h;
    }, c.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, c.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.value != null && t.hasOwnProperty("value") && typeof t.value != "number")
        return "value: number expected";
      if (t.timestamp != null && t.hasOwnProperty("timestamp")) {
        let e = $root.google.protobuf.Timestamp.verify(t.timestamp);
        if (e)
          return "timestamp." + e;
      }
      if (t.label != null && t.hasOwnProperty("label")) {
        if (!Array.isArray(t.label))
          return "label: array expected";
        for (let e = 0; e < t.label.length; ++e) {
          let o = $root.openmetrics.Label.verify(t.label[e]);
          if (o)
            return "label." + o;
        }
      }
      return null;
    }, c.fromObject = function(t) {
      if (t instanceof $root.openmetrics.Exemplar)
        return t;
      let e = new $root.openmetrics.Exemplar();
      if (t.value != null && (e.value = Number(t.value)), t.timestamp != null) {
        if (typeof t.timestamp != "object")
          throw TypeError(".openmetrics.Exemplar.timestamp: object expected");
        e.timestamp = $root.google.protobuf.Timestamp.fromObject(t.timestamp);
      }
      if (t.label) {
        if (!Array.isArray(t.label))
          throw TypeError(".openmetrics.Exemplar.label: array expected");
        e.label = [];
        for (let o = 0; o < t.label.length; ++o) {
          if (typeof t.label[o] != "object")
            throw TypeError(".openmetrics.Exemplar.label: object expected");
          e.label[o] = $root.openmetrics.Label.fromObject(t.label[o]);
        }
      }
      return e;
    }, c.toObject = function(t, e) {
      e || (e = {});
      let o = {};
      if ((e.arrays || e.defaults) && (o.label = []), e.defaults && (o.value = 0, o.timestamp = null), t.value != null && t.hasOwnProperty("value") && (o.value = e.json && !isFinite(t.value) ? String(t.value) : t.value), t.timestamp != null && t.hasOwnProperty("timestamp") && (o.timestamp = $root.google.protobuf.Timestamp.toObject(t.timestamp, e)), t.label && t.label.length) {
        o.label = [];
        for (let p = 0; p < t.label.length; ++p)
          o.label[p] = $root.openmetrics.Label.toObject(t.label[p], e);
      }
      return o;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/openmetrics.Exemplar";
    }, c;
  })(), r.StateSetValue = (function() {
    function c(n) {
      if (this.states = [], n)
        for (let t = Object.keys(n), e = 0; e < t.length; ++e)
          n[t[e]] != null && (this[t[e]] = n[t[e]]);
    }
    return c.prototype.states = $util.emptyArray, c.create = function(t) {
      return new c(t);
    }, c.encode = function(t, e) {
      if (e || (e = $Writer.create()), t.states != null && t.states.length)
        for (let o = 0; o < t.states.length; ++o)
          $root.openmetrics.StateSetValue.State.encode(t.states[o], e.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return e;
    }, c.encodeDelimited = function(t, e) {
      return this.encode(t, e).ldelim();
    }, c.decode = function(t, e, o) {
      t instanceof $Reader || (t = $Reader.create(t));
      let p = e === void 0 ? t.len : t.pos + e, h = new $root.openmetrics.StateSetValue();
      for (; t.pos < p; ) {
        let y = t.uint32();
        if (y === o)
          break;
        switch (y >>> 3) {
          case 1: {
            h.states && h.states.length || (h.states = []), h.states.push($root.openmetrics.StateSetValue.State.decode(t, t.uint32()));
            break;
          }
          default:
            t.skipType(y & 7);
            break;
        }
      }
      return h;
    }, c.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, c.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.states != null && t.hasOwnProperty("states")) {
        if (!Array.isArray(t.states))
          return "states: array expected";
        for (let e = 0; e < t.states.length; ++e) {
          let o = $root.openmetrics.StateSetValue.State.verify(t.states[e]);
          if (o)
            return "states." + o;
        }
      }
      return null;
    }, c.fromObject = function(t) {
      if (t instanceof $root.openmetrics.StateSetValue)
        return t;
      let e = new $root.openmetrics.StateSetValue();
      if (t.states) {
        if (!Array.isArray(t.states))
          throw TypeError(".openmetrics.StateSetValue.states: array expected");
        e.states = [];
        for (let o = 0; o < t.states.length; ++o) {
          if (typeof t.states[o] != "object")
            throw TypeError(".openmetrics.StateSetValue.states: object expected");
          e.states[o] = $root.openmetrics.StateSetValue.State.fromObject(t.states[o]);
        }
      }
      return e;
    }, c.toObject = function(t, e) {
      e || (e = {});
      let o = {};
      if ((e.arrays || e.defaults) && (o.states = []), t.states && t.states.length) {
        o.states = [];
        for (let p = 0; p < t.states.length; ++p)
          o.states[p] = $root.openmetrics.StateSetValue.State.toObject(t.states[p], e);
      }
      return o;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/openmetrics.StateSetValue";
    }, c.State = (function() {
      function n(t) {
        if (t)
          for (let e = Object.keys(t), o = 0; o < e.length; ++o)
            t[e[o]] != null && (this[e[o]] = t[e[o]]);
      }
      return n.prototype.enabled = !1, n.prototype.name = "", n.create = function(e) {
        return new n(e);
      }, n.encode = function(e, o) {
        return o || (o = $Writer.create()), e.enabled != null && Object.hasOwnProperty.call(e, "enabled") && o.uint32(
          /* id 1, wireType 0 =*/
          8
        ).bool(e.enabled), e.name != null && Object.hasOwnProperty.call(e, "name") && o.uint32(
          /* id 2, wireType 2 =*/
          18
        ).string(e.name), o;
      }, n.encodeDelimited = function(e, o) {
        return this.encode(e, o).ldelim();
      }, n.decode = function(e, o, p) {
        e instanceof $Reader || (e = $Reader.create(e));
        let h = o === void 0 ? e.len : e.pos + o, y = new $root.openmetrics.StateSetValue.State();
        for (; e.pos < h; ) {
          let b = e.uint32();
          if (b === p)
            break;
          switch (b >>> 3) {
            case 1: {
              y.enabled = e.bool();
              break;
            }
            case 2: {
              y.name = e.string();
              break;
            }
            default:
              e.skipType(b & 7);
              break;
          }
        }
        return y;
      }, n.decodeDelimited = function(e) {
        return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
      }, n.verify = function(e) {
        return typeof e != "object" || e === null ? "object expected" : e.enabled != null && e.hasOwnProperty("enabled") && typeof e.enabled != "boolean" ? "enabled: boolean expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
      }, n.fromObject = function(e) {
        if (e instanceof $root.openmetrics.StateSetValue.State)
          return e;
        let o = new $root.openmetrics.StateSetValue.State();
        return e.enabled != null && (o.enabled = !!e.enabled), e.name != null && (o.name = String(e.name)), o;
      }, n.toObject = function(e, o) {
        o || (o = {});
        let p = {};
        return o.defaults && (p.enabled = !1, p.name = ""), e.enabled != null && e.hasOwnProperty("enabled") && (p.enabled = e.enabled), e.name != null && e.hasOwnProperty("name") && (p.name = e.name), p;
      }, n.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, n.getTypeUrl = function(e) {
        return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.StateSetValue.State";
      }, n;
    })(), c;
  })(), r.InfoValue = (function() {
    function c(n) {
      if (this.info = [], n)
        for (let t = Object.keys(n), e = 0; e < t.length; ++e)
          n[t[e]] != null && (this[t[e]] = n[t[e]]);
    }
    return c.prototype.info = $util.emptyArray, c.create = function(t) {
      return new c(t);
    }, c.encode = function(t, e) {
      if (e || (e = $Writer.create()), t.info != null && t.info.length)
        for (let o = 0; o < t.info.length; ++o)
          $root.openmetrics.Label.encode(t.info[o], e.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return e;
    }, c.encodeDelimited = function(t, e) {
      return this.encode(t, e).ldelim();
    }, c.decode = function(t, e, o) {
      t instanceof $Reader || (t = $Reader.create(t));
      let p = e === void 0 ? t.len : t.pos + e, h = new $root.openmetrics.InfoValue();
      for (; t.pos < p; ) {
        let y = t.uint32();
        if (y === o)
          break;
        switch (y >>> 3) {
          case 1: {
            h.info && h.info.length || (h.info = []), h.info.push($root.openmetrics.Label.decode(t, t.uint32()));
            break;
          }
          default:
            t.skipType(y & 7);
            break;
        }
      }
      return h;
    }, c.decodeDelimited = function(t) {
      return t instanceof $Reader || (t = new $Reader(t)), this.decode(t, t.uint32());
    }, c.verify = function(t) {
      if (typeof t != "object" || t === null)
        return "object expected";
      if (t.info != null && t.hasOwnProperty("info")) {
        if (!Array.isArray(t.info))
          return "info: array expected";
        for (let e = 0; e < t.info.length; ++e) {
          let o = $root.openmetrics.Label.verify(t.info[e]);
          if (o)
            return "info." + o;
        }
      }
      return null;
    }, c.fromObject = function(t) {
      if (t instanceof $root.openmetrics.InfoValue)
        return t;
      let e = new $root.openmetrics.InfoValue();
      if (t.info) {
        if (!Array.isArray(t.info))
          throw TypeError(".openmetrics.InfoValue.info: array expected");
        e.info = [];
        for (let o = 0; o < t.info.length; ++o) {
          if (typeof t.info[o] != "object")
            throw TypeError(".openmetrics.InfoValue.info: object expected");
          e.info[o] = $root.openmetrics.Label.fromObject(t.info[o]);
        }
      }
      return e;
    }, c.toObject = function(t, e) {
      e || (e = {});
      let o = {};
      if ((e.arrays || e.defaults) && (o.info = []), t.info && t.info.length) {
        o.info = [];
        for (let p = 0; p < t.info.length; ++p)
          o.info[p] = $root.openmetrics.Label.toObject(t.info[p], e);
      }
      return o;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(t) {
      return t === void 0 && (t = "type.googleapis.com"), t + "/openmetrics.InfoValue";
    }, c;
  })(), r.SummaryValue = (function() {
    function c(t) {
      if (this.quantile = [], t)
        for (let e = Object.keys(t), o = 0; o < e.length; ++o)
          t[e[o]] != null && (this[e[o]] = t[e[o]]);
    }
    c.prototype.doubleValue = null, c.prototype.intValue = null, c.prototype.count = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, c.prototype.created = null, c.prototype.quantile = $util.emptyArray;
    let n;
    return Object.defineProperty(c.prototype, "sum", {
      get: $util.oneOfGetter(n = ["doubleValue", "intValue"]),
      set: $util.oneOfSetter(n)
    }), c.create = function(e) {
      return new c(e);
    }, c.encode = function(e, o) {
      if (o || (o = $Writer.create()), e.doubleValue != null && Object.hasOwnProperty.call(e, "doubleValue") && o.uint32(
        /* id 1, wireType 1 =*/
        9
      ).double(e.doubleValue), e.intValue != null && Object.hasOwnProperty.call(e, "intValue") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int64(e.intValue), e.count != null && Object.hasOwnProperty.call(e, "count") && o.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(e.count), e.created != null && Object.hasOwnProperty.call(e, "created") && $root.google.protobuf.Timestamp.encode(e.created, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e.quantile != null && e.quantile.length)
        for (let p = 0; p < e.quantile.length; ++p)
          $root.openmetrics.SummaryValue.Quantile.encode(e.quantile[p], o.uint32(
            /* id 5, wireType 2 =*/
            42
          ).fork()).ldelim();
      return o;
    }, c.encodeDelimited = function(e, o) {
      return this.encode(e, o).ldelim();
    }, c.decode = function(e, o, p) {
      e instanceof $Reader || (e = $Reader.create(e));
      let h = o === void 0 ? e.len : e.pos + o, y = new $root.openmetrics.SummaryValue();
      for (; e.pos < h; ) {
        let b = e.uint32();
        if (b === p)
          break;
        switch (b >>> 3) {
          case 1: {
            y.doubleValue = e.double();
            break;
          }
          case 2: {
            y.intValue = e.int64();
            break;
          }
          case 3: {
            y.count = e.uint64();
            break;
          }
          case 4: {
            y.created = $root.google.protobuf.Timestamp.decode(e, e.uint32());
            break;
          }
          case 5: {
            y.quantile && y.quantile.length || (y.quantile = []), y.quantile.push($root.openmetrics.SummaryValue.Quantile.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(b & 7);
            break;
        }
      }
      return y;
    }, c.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, c.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      let o = {};
      if (e.doubleValue != null && e.hasOwnProperty("doubleValue") && (o.sum = 1, typeof e.doubleValue != "number"))
        return "doubleValue: number expected";
      if (e.intValue != null && e.hasOwnProperty("intValue")) {
        if (o.sum === 1)
          return "sum: multiple values";
        if (o.sum = 1, !$util.isInteger(e.intValue) && !(e.intValue && $util.isInteger(e.intValue.low) && $util.isInteger(e.intValue.high)))
          return "intValue: integer|Long expected";
      }
      if (e.count != null && e.hasOwnProperty("count") && !$util.isInteger(e.count) && !(e.count && $util.isInteger(e.count.low) && $util.isInteger(e.count.high)))
        return "count: integer|Long expected";
      if (e.created != null && e.hasOwnProperty("created")) {
        let p = $root.google.protobuf.Timestamp.verify(e.created);
        if (p)
          return "created." + p;
      }
      if (e.quantile != null && e.hasOwnProperty("quantile")) {
        if (!Array.isArray(e.quantile))
          return "quantile: array expected";
        for (let p = 0; p < e.quantile.length; ++p) {
          let h = $root.openmetrics.SummaryValue.Quantile.verify(e.quantile[p]);
          if (h)
            return "quantile." + h;
        }
      }
      return null;
    }, c.fromObject = function(e) {
      if (e instanceof $root.openmetrics.SummaryValue)
        return e;
      let o = new $root.openmetrics.SummaryValue();
      if (e.doubleValue != null && (o.doubleValue = Number(e.doubleValue)), e.intValue != null && ($util.Long ? (o.intValue = $util.Long.fromValue(e.intValue)).unsigned = !1 : typeof e.intValue == "string" ? o.intValue = parseInt(e.intValue, 10) : typeof e.intValue == "number" ? o.intValue = e.intValue : typeof e.intValue == "object" && (o.intValue = new $util.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), e.count != null && ($util.Long ? (o.count = $util.Long.fromValue(e.count)).unsigned = !0 : typeof e.count == "string" ? o.count = parseInt(e.count, 10) : typeof e.count == "number" ? o.count = e.count : typeof e.count == "object" && (o.count = new $util.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0))), e.created != null) {
        if (typeof e.created != "object")
          throw TypeError(".openmetrics.SummaryValue.created: object expected");
        o.created = $root.google.protobuf.Timestamp.fromObject(e.created);
      }
      if (e.quantile) {
        if (!Array.isArray(e.quantile))
          throw TypeError(".openmetrics.SummaryValue.quantile: array expected");
        o.quantile = [];
        for (let p = 0; p < e.quantile.length; ++p) {
          if (typeof e.quantile[p] != "object")
            throw TypeError(".openmetrics.SummaryValue.quantile: object expected");
          o.quantile[p] = $root.openmetrics.SummaryValue.Quantile.fromObject(e.quantile[p]);
        }
      }
      return o;
    }, c.toObject = function(e, o) {
      o || (o = {});
      let p = {};
      if ((o.arrays || o.defaults) && (p.quantile = []), o.defaults) {
        if ($util.Long) {
          let h = new $util.Long(0, 0, !0);
          p.count = o.longs === String ? h.toString() : o.longs === Number ? h.toNumber() : h;
        } else
          p.count = o.longs === String ? "0" : 0;
        p.created = null;
      }
      if (e.doubleValue != null && e.hasOwnProperty("doubleValue") && (p.doubleValue = o.json && !isFinite(e.doubleValue) ? String(e.doubleValue) : e.doubleValue, o.oneofs && (p.sum = "doubleValue")), e.intValue != null && e.hasOwnProperty("intValue") && (typeof e.intValue == "number" ? p.intValue = o.longs === String ? String(e.intValue) : e.intValue : p.intValue = o.longs === String ? $util.Long.prototype.toString.call(e.intValue) : o.longs === Number ? new $util.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, o.oneofs && (p.sum = "intValue")), e.count != null && e.hasOwnProperty("count") && (typeof e.count == "number" ? p.count = o.longs === String ? String(e.count) : e.count : p.count = o.longs === String ? $util.Long.prototype.toString.call(e.count) : o.longs === Number ? new $util.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0) : e.count), e.created != null && e.hasOwnProperty("created") && (p.created = $root.google.protobuf.Timestamp.toObject(e.created, o)), e.quantile && e.quantile.length) {
        p.quantile = [];
        for (let h = 0; h < e.quantile.length; ++h)
          p.quantile[h] = $root.openmetrics.SummaryValue.Quantile.toObject(e.quantile[h], o);
      }
      return p;
    }, c.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
    }, c.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/openmetrics.SummaryValue";
    }, c.Quantile = (function() {
      function t(e) {
        if (e)
          for (let o = Object.keys(e), p = 0; p < o.length; ++p)
            e[o[p]] != null && (this[o[p]] = e[o[p]]);
      }
      return t.prototype.quantile = 0, t.prototype.value = 0, t.create = function(o) {
        return new t(o);
      }, t.encode = function(o, p) {
        return p || (p = $Writer.create()), o.quantile != null && Object.hasOwnProperty.call(o, "quantile") && p.uint32(
          /* id 1, wireType 1 =*/
          9
        ).double(o.quantile), o.value != null && Object.hasOwnProperty.call(o, "value") && p.uint32(
          /* id 2, wireType 1 =*/
          17
        ).double(o.value), p;
      }, t.encodeDelimited = function(o, p) {
        return this.encode(o, p).ldelim();
      }, t.decode = function(o, p, h) {
        o instanceof $Reader || (o = $Reader.create(o));
        let y = p === void 0 ? o.len : o.pos + p, b = new $root.openmetrics.SummaryValue.Quantile();
        for (; o.pos < y; ) {
          let O = o.uint32();
          if (O === h)
            break;
          switch (O >>> 3) {
            case 1: {
              b.quantile = o.double();
              break;
            }
            case 2: {
              b.value = o.double();
              break;
            }
            default:
              o.skipType(O & 7);
              break;
          }
        }
        return b;
      }, t.decodeDelimited = function(o) {
        return o instanceof $Reader || (o = new $Reader(o)), this.decode(o, o.uint32());
      }, t.verify = function(o) {
        return typeof o != "object" || o === null ? "object expected" : o.quantile != null && o.hasOwnProperty("quantile") && typeof o.quantile != "number" ? "quantile: number expected" : o.value != null && o.hasOwnProperty("value") && typeof o.value != "number" ? "value: number expected" : null;
      }, t.fromObject = function(o) {
        if (o instanceof $root.openmetrics.SummaryValue.Quantile)
          return o;
        let p = new $root.openmetrics.SummaryValue.Quantile();
        return o.quantile != null && (p.quantile = Number(o.quantile)), o.value != null && (p.value = Number(o.value)), p;
      }, t.toObject = function(o, p) {
        p || (p = {});
        let h = {};
        return p.defaults && (h.quantile = 0, h.value = 0), o.quantile != null && o.hasOwnProperty("quantile") && (h.quantile = p.json && !isFinite(o.quantile) ? String(o.quantile) : o.quantile), o.value != null && o.hasOwnProperty("value") && (h.value = p.json && !isFinite(o.value) ? String(o.value) : o.value), h;
      }, t.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, t.getTypeUrl = function(o) {
        return o === void 0 && (o = "type.googleapis.com"), o + "/openmetrics.SummaryValue.Quantile";
      }, t;
    })(), c;
  })(), r;
})();
$root.google = (() => {
  const r = {};
  return r.protobuf = (function() {
    const c = {};
    return c.Timestamp = (function() {
      function n(t) {
        if (t)
          for (let e = Object.keys(t), o = 0; o < e.length; ++o)
            t[e[o]] != null && (this[e[o]] = t[e[o]]);
      }
      return n.prototype.seconds = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, n.prototype.nanos = 0, n.create = function(e) {
        return new n(e);
      }, n.encode = function(e, o) {
        return o || (o = $Writer.create()), e.seconds != null && Object.hasOwnProperty.call(e, "seconds") && o.uint32(
          /* id 1, wireType 0 =*/
          8
        ).int64(e.seconds), e.nanos != null && Object.hasOwnProperty.call(e, "nanos") && o.uint32(
          /* id 2, wireType 0 =*/
          16
        ).int32(e.nanos), o;
      }, n.encodeDelimited = function(e, o) {
        return this.encode(e, o).ldelim();
      }, n.decode = function(e, o, p) {
        e instanceof $Reader || (e = $Reader.create(e));
        let h = o === void 0 ? e.len : e.pos + o, y = new $root.google.protobuf.Timestamp();
        for (; e.pos < h; ) {
          let b = e.uint32();
          if (b === p)
            break;
          switch (b >>> 3) {
            case 1: {
              y.seconds = e.int64();
              break;
            }
            case 2: {
              y.nanos = e.int32();
              break;
            }
            default:
              e.skipType(b & 7);
              break;
          }
        }
        return y;
      }, n.decodeDelimited = function(e) {
        return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
      }, n.verify = function(e) {
        return typeof e != "object" || e === null ? "object expected" : e.seconds != null && e.hasOwnProperty("seconds") && !$util.isInteger(e.seconds) && !(e.seconds && $util.isInteger(e.seconds.low) && $util.isInteger(e.seconds.high)) ? "seconds: integer|Long expected" : e.nanos != null && e.hasOwnProperty("nanos") && !$util.isInteger(e.nanos) ? "nanos: integer expected" : null;
      }, n.fromObject = function(e) {
        if (e instanceof $root.google.protobuf.Timestamp)
          return e;
        let o = new $root.google.protobuf.Timestamp();
        return e.seconds != null && ($util.Long ? (o.seconds = $util.Long.fromValue(e.seconds)).unsigned = !1 : typeof e.seconds == "string" ? o.seconds = parseInt(e.seconds, 10) : typeof e.seconds == "number" ? o.seconds = e.seconds : typeof e.seconds == "object" && (o.seconds = new $util.LongBits(e.seconds.low >>> 0, e.seconds.high >>> 0).toNumber())), e.nanos != null && (o.nanos = e.nanos | 0), o;
      }, n.toObject = function(e, o) {
        o || (o = {});
        let p = {};
        if (o.defaults) {
          if ($util.Long) {
            let h = new $util.Long(0, 0, !1);
            p.seconds = o.longs === String ? h.toString() : o.longs === Number ? h.toNumber() : h;
          } else
            p.seconds = o.longs === String ? "0" : 0;
          p.nanos = 0;
        }
        return e.seconds != null && e.hasOwnProperty("seconds") && (typeof e.seconds == "number" ? p.seconds = o.longs === String ? String(e.seconds) : e.seconds : p.seconds = o.longs === String ? $util.Long.prototype.toString.call(e.seconds) : o.longs === Number ? new $util.LongBits(e.seconds.low >>> 0, e.seconds.high >>> 0).toNumber() : e.seconds), e.nanos != null && e.hasOwnProperty("nanos") && (p.nanos = e.nanos), p;
      }, n.prototype.toJSON = function() {
        return this.constructor.toObject(this, minimalExports.util.toJSONOptions);
      }, n.getTypeUrl = function(e) {
        return e === void 0 && (e = "type.googleapis.com"), e + "/google.protobuf.Timestamp";
      }, n;
    })(), c;
  })(), r;
})();
$root.RootContainer = (() => {
  const r = {}, c = Object.create(r);
  return c[r[0] = "MAIN"] = 0, c[r[1] = "SIDEBAR"] = 1, c[r[2] = "EVENT"] = 2, c[r[3] = "BOTTOM"] = 3, c;
})();
typeof Promise.withResolvers > "u" && (Promise.withResolvers = () => {
  let r, c;
  const n = new Promise((t, e) => {
    r = t, c = e;
  });
  return { resolve: r, reject: c, promise: n };
});
function u(r) {
  const c = document.cookie.match(`\\b${r}=([^;]*)\\b`);
  return c ? c[1] : void 0;
}
function a() {
  const r = "testData";
  try {
    const { localStorage: c } = window;
    c.setItem(r, r), c.getItem(r), c.removeItem(r);
  } catch {
    return !1;
  }
  return !0;
}
function m(r) {
  return r != null;
}
function d(r) {
  return r == null;
}
const i = /\/+$/, l = /^\/+/;
function f({ hostname: r, port: c, pathname: n, protocol: t }, e) {
  const o = s(n, e);
  return `${t}//${r}${c ? `:${c}` : ""}/${o}`;
}
function s(r, c) {
  return r = r.replace(i, "").replace(l, ""), c = c.replace(i, "").replace(l, ""), r.length === 0 ? c : `${r}/${c}`;
}
const STATIC_ASSET_CONFIG = "https://data.streamlit.io/static.json", LOG$5 = loglevelExports.getLogger("StaticConnection");
async function getStaticConfig() {
  const r = a();
  let c = "";
  if (r) {
    const n = window.localStorage.getItem("stStaticAssetUrl");
    if (n)
      return n;
  }
  try {
    const n = await fetch(STATIC_ASSET_CONFIG, {
      signal: AbortSignal.timeout(5e3)
    });
    n.ok ? (c = (await n.json()).static_url ?? void 0, r && c && window.localStorage.setItem("stStaticAssetUrl", c)) : LOG$5.error("Failed to fetch static config url: ", n.status);
  } catch (n) {
    LOG$5.error("Failed to fetch static config url:", n);
  }
  return c;
}
async function getProtoResponse(r, c) {
  const n = `${c}/${r}/protos.pb`, t = await fetch(n, {
    signal: AbortSignal.timeout(5e3)
  });
  if (!t.ok)
    LOG$5.error(
      `Failed to fetch static app protos for id: ${r}`,
      t.status
    );
  else
    return t.arrayBuffer();
  return null;
}
async function dispatchAppForwardMessages(r, c, n, t) {
  const e = await getProtoResponse(r, c);
  if (!e) {
    LOG$5.error("Failed to retrieve static app protos"), t(
      `Failed to retrieve static app protos. Please confirm the id is correct and try again. Given static app id: ${r}`
    );
    return;
  }
  ForwardMsgList.decode(new Uint8Array(e)).messages.forEach((p) => {
    n(p);
  });
}
async function establishStaticConnection(r, c, n, t, e) {
  c(ConnectionState.STATIC_CONNECTING);
  const o = await getStaticConfig();
  e.setStaticConfigUrl(o), dispatchAppForwardMessages(
    r,
    o,
    n,
    t
  ), c(ConnectionState.STATIC_CONNECTED);
}
const FINAL_SLASH_RE = /\/+$/, INITIAL_SLASH_RE = /^\/+/;
function parseUriIntoBaseParts(r) {
  const c = new URL(
    window.location.href === "about:blank" ? "" : window.location.href
  );
  return c.pathname = c.pathname.replace(FINAL_SLASH_RE, "").replace(INITIAL_SLASH_RE, ""), c;
}
function getPossibleBaseUris() {
  const r = parseUriIntoBaseParts(
    window.__streamlit?.BACKEND_BASE_URL
  ), { pathname: c } = r;
  if (c === "/")
    return [r];
  const n = c.split("/"), t = [];
  for (; n.length > 0; ) {
    const e = new URL(r);
    e.pathname = n.join("/"), t.push(e), n.pop();
  }
  return t.length <= 2 ? t : t.slice(0, 2);
}
function buildWsUri({ hostname: r, port: c, pathname: n, protocol: t }, e) {
  const o = t === "https:" ? "wss" : "ws", p = s(n, e);
  return `${o}://${r}:${c}/${p}`;
}
function bind(r, c) {
  return function() {
    return r.apply(c, arguments);
  };
}
const { toString } = Object.prototype, { getPrototypeOf } = Object, { iterator, toStringTag } = Symbol, kindOf = /* @__PURE__ */ ((r) => (c) => {
  const n = toString.call(c);
  return r[n] || (r[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest = (r) => (r = r.toLowerCase(), (c) => kindOf(c) === r), typeOfTest = (r) => (c) => typeof c === r, { isArray } = Array, isUndefined = typeOfTest("undefined");
function isBuffer(r) {
  return r !== null && !isUndefined(r) && r.constructor !== null && !isUndefined(r.constructor) && isFunction$1(r.constructor.isBuffer) && r.constructor.isBuffer(r);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(r) {
  let c;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? c = ArrayBuffer.isView(r) : c = r && r.buffer && isArrayBuffer(r.buffer), c;
}
const isString = typeOfTest("string"), isFunction$1 = typeOfTest("function"), isNumber = typeOfTest("number"), isObject = (r) => r !== null && typeof r == "object", isBoolean = (r) => r === !0 || r === !1, isPlainObject = (r) => {
  if (kindOf(r) !== "object")
    return !1;
  const c = getPrototypeOf(r);
  return (c === null || c === Object.prototype || Object.getPrototypeOf(c) === null) && !(toStringTag in r) && !(iterator in r);
}, isEmptyObject = (r) => {
  if (!isObject(r) || isBuffer(r))
    return !1;
  try {
    return Object.keys(r).length === 0 && Object.getPrototypeOf(r) === Object.prototype;
  } catch {
    return !1;
  }
}, isDate = kindOfTest("Date"), isFile = kindOfTest("File"), isBlob = kindOfTest("Blob"), isFileList = kindOfTest("FileList"), isStream = (r) => isObject(r) && isFunction$1(r.pipe), isFormData = (r) => {
  let c;
  return r && (typeof FormData == "function" && r instanceof FormData || isFunction$1(r.append) && ((c = kindOf(r)) === "formdata" || // detect form-data instance
  c === "object" && isFunction$1(r.toString) && r.toString() === "[object FormData]"));
}, isURLSearchParams = kindOfTest("URLSearchParams"), [isReadableStream, isRequest, isResponse, isHeaders] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest), trim = (r) => r.trim ? r.trim() : r.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(r, c, { allOwnKeys: n = !1 } = {}) {
  if (r === null || typeof r > "u")
    return;
  let t, e;
  if (typeof r != "object" && (r = [r]), isArray(r))
    for (t = 0, e = r.length; t < e; t++)
      c.call(null, r[t], t, r);
  else {
    if (isBuffer(r))
      return;
    const o = n ? Object.getOwnPropertyNames(r) : Object.keys(r), p = o.length;
    let h;
    for (t = 0; t < p; t++)
      h = o[t], c.call(null, r[h], h, r);
  }
}
function findKey(r, c) {
  if (isBuffer(r))
    return null;
  c = c.toLowerCase();
  const n = Object.keys(r);
  let t = n.length, e;
  for (; t-- > 0; )
    if (e = n[t], c === e.toLowerCase())
      return e;
  return null;
}
const _global = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, isContextDefined = (r) => !isUndefined(r) && r !== _global;
function merge() {
  const { caseless: r, skipUndefined: c } = isContextDefined(this) && this || {}, n = {}, t = (e, o) => {
    const p = r && findKey(n, o) || o;
    isPlainObject(n[p]) && isPlainObject(e) ? n[p] = merge(n[p], e) : isPlainObject(e) ? n[p] = merge({}, e) : isArray(e) ? n[p] = e.slice() : (!c || !isUndefined(e)) && (n[p] = e);
  };
  for (let e = 0, o = arguments.length; e < o; e++)
    arguments[e] && forEach(arguments[e], t);
  return n;
}
const extend = (r, c, n, { allOwnKeys: t } = {}) => (forEach(c, (e, o) => {
  n && isFunction$1(e) ? r[o] = bind(e, n) : r[o] = e;
}, { allOwnKeys: t }), r), stripBOM = (r) => (r.charCodeAt(0) === 65279 && (r = r.slice(1)), r), inherits = (r, c, n, t) => {
  r.prototype = Object.create(c.prototype, t), r.prototype.constructor = r, Object.defineProperty(r, "super", {
    value: c.prototype
  }), n && Object.assign(r.prototype, n);
}, toFlatObject = (r, c, n, t) => {
  let e, o, p;
  const h = {};
  if (c = c || {}, r == null) return c;
  do {
    for (e = Object.getOwnPropertyNames(r), o = e.length; o-- > 0; )
      p = e[o], (!t || t(p, r, c)) && !h[p] && (c[p] = r[p], h[p] = !0);
    r = n !== !1 && getPrototypeOf(r);
  } while (r && (!n || n(r, c)) && r !== Object.prototype);
  return c;
}, endsWith = (r, c, n) => {
  r = String(r), (n === void 0 || n > r.length) && (n = r.length), n -= c.length;
  const t = r.indexOf(c, n);
  return t !== -1 && t === n;
}, toArray = (r) => {
  if (!r) return null;
  if (isArray(r)) return r;
  let c = r.length;
  if (!isNumber(c)) return null;
  const n = new Array(c);
  for (; c-- > 0; )
    n[c] = r[c];
  return n;
}, isTypedArray = /* @__PURE__ */ ((r) => (c) => r && c instanceof r)(typeof Uint8Array < "u" && getPrototypeOf(Uint8Array)), forEachEntry = (r, c) => {
  const t = (r && r[iterator]).call(r);
  let e;
  for (; (e = t.next()) && !e.done; ) {
    const o = e.value;
    c.call(r, o[0], o[1]);
  }
}, matchAll = (r, c) => {
  let n;
  const t = [];
  for (; (n = r.exec(c)) !== null; )
    t.push(n);
  return t;
}, isHTMLForm = kindOfTest("HTMLFormElement"), toCamelCase = (r) => r.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, t, e) {
    return t.toUpperCase() + e;
  }
), hasOwnProperty = (({ hasOwnProperty: r }) => (c, n) => r.call(c, n))(Object.prototype), isRegExp = kindOfTest("RegExp"), reduceDescriptors = (r, c) => {
  const n = Object.getOwnPropertyDescriptors(r), t = {};
  forEach(n, (e, o) => {
    let p;
    (p = c(e, o, r)) !== !1 && (t[o] = p || e);
  }), Object.defineProperties(r, t);
}, freezeMethods = (r) => {
  reduceDescriptors(r, (c, n) => {
    if (isFunction$1(r) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const t = r[n];
    if (isFunction$1(t)) {
      if (c.enumerable = !1, "writable" in c) {
        c.writable = !1;
        return;
      }
      c.set || (c.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, toObjectSet = (r, c) => {
  const n = {}, t = (e) => {
    e.forEach((o) => {
      n[o] = !0;
    });
  };
  return isArray(r) ? t(r) : t(String(r).split(c)), n;
}, noop = () => {
}, toFiniteNumber = (r, c) => r != null && Number.isFinite(r = +r) ? r : c;
function isSpecCompliantForm(r) {
  return !!(r && isFunction$1(r.append) && r[toStringTag] === "FormData" && r[iterator]);
}
const toJSONObject = (r) => {
  const c = new Array(10), n = (t, e) => {
    if (isObject(t)) {
      if (c.indexOf(t) >= 0)
        return;
      if (isBuffer(t))
        return t;
      if (!("toJSON" in t)) {
        c[e] = t;
        const o = isArray(t) ? [] : {};
        return forEach(t, (p, h) => {
          const y = n(p, e + 1);
          !isUndefined(y) && (o[h] = y);
        }), c[e] = void 0, o;
      }
    }
    return t;
  };
  return n(r, 0);
}, isAsyncFn = kindOfTest("AsyncFunction"), isThenable = (r) => r && (isObject(r) || isFunction$1(r)) && isFunction$1(r.then) && isFunction$1(r.catch), _setImmediate = ((r, c) => r ? setImmediate : c ? ((n, t) => (_global.addEventListener("message", ({ source: e, data: o }) => {
  e === _global && o === n && t.length && t.shift()();
}, !1), (e) => {
  t.push(e), _global.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  isFunction$1(_global.postMessage)
), asap = typeof queueMicrotask < "u" ? queueMicrotask.bind(_global) : typeof process < "u" && process.nextTick || _setImmediate, isIterable = (r) => r != null && isFunction$1(r[iterator]), utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isEmptyObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction: isFunction$1,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap,
  isIterable
};
function AxiosError$1(r, c, n, t, e) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = r, this.name = "AxiosError", c && (this.code = c), n && (this.config = n), t && (this.request = t), e && (this.response = e, this.status = e.status ? e.status : null);
}
utils$1.inherits(AxiosError$1, Error, {
  toJSON: function r() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const prototype$1 = AxiosError$1.prototype, descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((r) => {
  descriptors[r] = { value: r };
});
Object.defineProperties(AxiosError$1, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: !0 });
AxiosError$1.from = (r, c, n, t, e, o) => {
  const p = Object.create(prototype$1);
  utils$1.toFlatObject(r, p, function(O) {
    return O !== Error.prototype;
  }, (b) => b !== "isAxiosError");
  const h = r && r.message ? r.message : "Error", y = c == null && r ? r.code : c;
  return AxiosError$1.call(p, h, y, n, t, e), r && p.cause == null && Object.defineProperty(p, "cause", { value: r, configurable: !0 }), p.name = r && r.name || "Error", o && Object.assign(p, o), p;
};
const httpAdapter = null;
function isVisitable(r) {
  return utils$1.isPlainObject(r) || utils$1.isArray(r);
}
function removeBrackets(r) {
  return utils$1.endsWith(r, "[]") ? r.slice(0, -2) : r;
}
function renderKey(r, c, n) {
  return r ? r.concat(c).map(function(e, o) {
    return e = removeBrackets(e), !n && o ? "[" + e + "]" : e;
  }).join(n ? "." : "") : c;
}
function isFlatArray(r) {
  return utils$1.isArray(r) && !r.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function r(c) {
  return /^is[A-Z]/.test(c);
});
function toFormData$1(r, c, n) {
  if (!utils$1.isObject(r))
    throw new TypeError("target must be an object");
  c = c || new FormData(), n = utils$1.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(x, k) {
    return !utils$1.isUndefined(k[x]);
  });
  const t = n.metaTokens, e = n.visitor || O, o = n.dots, p = n.indexes, y = (n.Blob || typeof Blob < "u" && Blob) && utils$1.isSpecCompliantForm(c);
  if (!utils$1.isFunction(e))
    throw new TypeError("visitor must be a function");
  function b(w) {
    if (w === null) return "";
    if (utils$1.isDate(w))
      return w.toISOString();
    if (utils$1.isBoolean(w))
      return w.toString();
    if (!y && utils$1.isBlob(w))
      throw new AxiosError$1("Blob is not supported. Use a Buffer instead.");
    return utils$1.isArrayBuffer(w) || utils$1.isTypedArray(w) ? y && typeof Blob == "function" ? new Blob([w]) : Buffer.from(w) : w;
  }
  function O(w, x, k) {
    let P = w;
    if (w && !k && typeof w == "object") {
      if (utils$1.endsWith(x, "{}"))
        x = t ? x : x.slice(0, -2), w = JSON.stringify(w);
      else if (utils$1.isArray(w) && isFlatArray(w) || (utils$1.isFileList(w) || utils$1.endsWith(x, "[]")) && (P = utils$1.toArray(w)))
        return x = removeBrackets(x), P.forEach(function(T, V) {
          !(utils$1.isUndefined(T) || T === null) && c.append(
            // eslint-disable-next-line no-nested-ternary
            p === !0 ? renderKey([x], V, o) : p === null ? x : x + "[]",
            b(T)
          );
        }), !1;
    }
    return isVisitable(w) ? !0 : (c.append(renderKey(k, x, o), b(w)), !1);
  }
  const $ = [], S = Object.assign(predicates, {
    defaultVisitor: O,
    convertValue: b,
    isVisitable
  });
  function C(w, x) {
    if (!utils$1.isUndefined(w)) {
      if ($.indexOf(w) !== -1)
        throw Error("Circular reference detected in " + x.join("."));
      $.push(w), utils$1.forEach(w, function(P, I) {
        (!(utils$1.isUndefined(P) || P === null) && e.call(
          c,
          P,
          utils$1.isString(I) ? I.trim() : I,
          x,
          S
        )) === !0 && C(P, x ? x.concat(I) : [I]);
      }), $.pop();
    }
  }
  if (!utils$1.isObject(r))
    throw new TypeError("data must be an object");
  return C(r), c;
}
function encode$1(r) {
  const c = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(r).replace(/[!'()~]|%20|%00/g, function(t) {
    return c[t];
  });
}
function AxiosURLSearchParams(r, c) {
  this._pairs = [], r && toFormData$1(r, this, c);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function r(c, n) {
  this._pairs.push([c, n]);
};
prototype.toString = function r(c) {
  const n = c ? function(t) {
    return c.call(this, t, encode$1);
  } : encode$1;
  return this._pairs.map(function(e) {
    return n(e[0]) + "=" + n(e[1]);
  }, "").join("&");
};
function encode(r) {
  return encodeURIComponent(r).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function buildURL(r, c, n) {
  if (!c)
    return r;
  const t = n && n.encode || encode;
  utils$1.isFunction(n) && (n = {
    serialize: n
  });
  const e = n && n.serialize;
  let o;
  if (e ? o = e(c, n) : o = utils$1.isURLSearchParams(c) ? c.toString() : new AxiosURLSearchParams(c, n).toString(t), o) {
    const p = r.indexOf("#");
    p !== -1 && (r = r.slice(0, p)), r += (r.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return r;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(c, n, t) {
    return this.handlers.push({
      fulfilled: c,
      rejected: n,
      synchronous: t ? t.synchronous : !1,
      runWhen: t ? t.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(c) {
    this.handlers[c] && (this.handlers[c] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(c) {
    utils$1.forEach(this.handlers, function(t) {
      t !== null && c(t);
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, URLSearchParams$1 = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams, FormData$1 = typeof FormData < "u" ? FormData : null, Blob$1 = typeof Blob < "u" ? Blob : null, platform$1 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, hasBrowserEnv = typeof window < "u" && typeof document < "u", _navigator = typeof navigator == "object" && navigator || void 0, hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator.product) < 0), hasStandardBrowserWebWorkerEnv = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", origin = hasBrowserEnv && window.location.href || "http://localhost", utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  navigator: _navigator,
  origin
}, Symbol.toStringTag, { value: "Module" })), platform = {
  ...utils,
  ...platform$1
};
function toURLEncodedForm(r, c) {
  return toFormData$1(r, new platform.classes.URLSearchParams(), {
    visitor: function(n, t, e, o) {
      return platform.isNode && utils$1.isBuffer(n) ? (this.append(t, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...c
  });
}
function parsePropPath(r) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, r).map((c) => c[0] === "[]" ? "" : c[1] || c[0]);
}
function arrayToObject(r) {
  const c = {}, n = Object.keys(r);
  let t;
  const e = n.length;
  let o;
  for (t = 0; t < e; t++)
    o = n[t], c[o] = r[o];
  return c;
}
function formDataToJSON(r) {
  function c(n, t, e, o) {
    let p = n[o++];
    if (p === "__proto__") return !0;
    const h = Number.isFinite(+p), y = o >= n.length;
    return p = !p && utils$1.isArray(e) ? e.length : p, y ? (utils$1.hasOwnProp(e, p) ? e[p] = [e[p], t] : e[p] = t, !h) : ((!e[p] || !utils$1.isObject(e[p])) && (e[p] = []), c(n, t, e[p], o) && utils$1.isArray(e[p]) && (e[p] = arrayToObject(e[p])), !h);
  }
  if (utils$1.isFormData(r) && utils$1.isFunction(r.entries)) {
    const n = {};
    return utils$1.forEachEntry(r, (t, e) => {
      c(parsePropPath(t), e, n, 0);
    }), n;
  }
  return null;
}
function stringifySafely(r, c, n) {
  if (utils$1.isString(r))
    try {
      return (c || JSON.parse)(r), utils$1.trim(r);
    } catch (t) {
      if (t.name !== "SyntaxError")
        throw t;
    }
  return (n || JSON.stringify)(r);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function r(c, n) {
    const t = n.getContentType() || "", e = t.indexOf("application/json") > -1, o = utils$1.isObject(c);
    if (o && utils$1.isHTMLForm(c) && (c = new FormData(c)), utils$1.isFormData(c))
      return e ? JSON.stringify(formDataToJSON(c)) : c;
    if (utils$1.isArrayBuffer(c) || utils$1.isBuffer(c) || utils$1.isStream(c) || utils$1.isFile(c) || utils$1.isBlob(c) || utils$1.isReadableStream(c))
      return c;
    if (utils$1.isArrayBufferView(c))
      return c.buffer;
    if (utils$1.isURLSearchParams(c))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), c.toString();
    let h;
    if (o) {
      if (t.indexOf("application/x-www-form-urlencoded") > -1)
        return toURLEncodedForm(c, this.formSerializer).toString();
      if ((h = utils$1.isFileList(c)) || t.indexOf("multipart/form-data") > -1) {
        const y = this.env && this.env.FormData;
        return toFormData$1(
          h ? { "files[]": c } : c,
          y && new y(),
          this.formSerializer
        );
      }
    }
    return o || e ? (n.setContentType("application/json", !1), stringifySafely(c)) : c;
  }],
  transformResponse: [function r(c) {
    const n = this.transitional || defaults.transitional, t = n && n.forcedJSONParsing, e = this.responseType === "json";
    if (utils$1.isResponse(c) || utils$1.isReadableStream(c))
      return c;
    if (c && utils$1.isString(c) && (t && !this.responseType || e)) {
      const p = !(n && n.silentJSONParsing) && e;
      try {
        return JSON.parse(c, this.parseReviver);
      } catch (h) {
        if (p)
          throw h.name === "SyntaxError" ? AxiosError$1.from(h, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response) : h;
      }
    }
    return c;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function r(c) {
    return c >= 200 && c < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (r) => {
  defaults.headers[r] = {};
});
const ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), parseHeaders = (r) => {
  const c = {};
  let n, t, e;
  return r && r.split(`
`).forEach(function(p) {
    e = p.indexOf(":"), n = p.substring(0, e).trim().toLowerCase(), t = p.substring(e + 1).trim(), !(!n || c[n] && ignoreDuplicateOf[n]) && (n === "set-cookie" ? c[n] ? c[n].push(t) : c[n] = [t] : c[n] = c[n] ? c[n] + ", " + t : t);
  }), c;
}, $internals = Symbol("internals");
function normalizeHeader(r) {
  return r && String(r).trim().toLowerCase();
}
function normalizeValue(r) {
  return r === !1 || r == null ? r : utils$1.isArray(r) ? r.map(normalizeValue) : String(r);
}
function parseTokens(r) {
  const c = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let t;
  for (; t = n.exec(r); )
    c[t[1]] = t[2];
  return c;
}
const isValidHeaderName = (r) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(r.trim());
function matchHeaderValue(r, c, n, t, e) {
  if (utils$1.isFunction(t))
    return t.call(this, c, n);
  if (e && (c = n), !!utils$1.isString(c)) {
    if (utils$1.isString(t))
      return c.indexOf(t) !== -1;
    if (utils$1.isRegExp(t))
      return t.test(c);
  }
}
function formatHeader(r) {
  return r.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (c, n, t) => n.toUpperCase() + t);
}
function buildAccessors(r, c) {
  const n = utils$1.toCamelCase(" " + c);
  ["get", "set", "has"].forEach((t) => {
    Object.defineProperty(r, t + n, {
      value: function(e, o, p) {
        return this[t].call(this, c, e, o, p);
      },
      configurable: !0
    });
  });
}
let AxiosHeaders$1 = class {
  constructor(c) {
    c && this.set(c);
  }
  set(c, n, t) {
    const e = this;
    function o(h, y, b) {
      const O = normalizeHeader(y);
      if (!O)
        throw new Error("header name must be a non-empty string");
      const $ = utils$1.findKey(e, O);
      (!$ || e[$] === void 0 || b === !0 || b === void 0 && e[$] !== !1) && (e[$ || y] = normalizeValue(h));
    }
    const p = (h, y) => utils$1.forEach(h, (b, O) => o(b, O, y));
    if (utils$1.isPlainObject(c) || c instanceof this.constructor)
      p(c, n);
    else if (utils$1.isString(c) && (c = c.trim()) && !isValidHeaderName(c))
      p(parseHeaders(c), n);
    else if (utils$1.isObject(c) && utils$1.isIterable(c)) {
      let h = {}, y, b;
      for (const O of c) {
        if (!utils$1.isArray(O))
          throw TypeError("Object iterator must return a key-value pair");
        h[b = O[0]] = (y = h[b]) ? utils$1.isArray(y) ? [...y, O[1]] : [y, O[1]] : O[1];
      }
      p(h, n);
    } else
      c != null && o(n, c, t);
    return this;
  }
  get(c, n) {
    if (c = normalizeHeader(c), c) {
      const t = utils$1.findKey(this, c);
      if (t) {
        const e = this[t];
        if (!n)
          return e;
        if (n === !0)
          return parseTokens(e);
        if (utils$1.isFunction(n))
          return n.call(this, e, t);
        if (utils$1.isRegExp(n))
          return n.exec(e);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(c, n) {
    if (c = normalizeHeader(c), c) {
      const t = utils$1.findKey(this, c);
      return !!(t && this[t] !== void 0 && (!n || matchHeaderValue(this, this[t], t, n)));
    }
    return !1;
  }
  delete(c, n) {
    const t = this;
    let e = !1;
    function o(p) {
      if (p = normalizeHeader(p), p) {
        const h = utils$1.findKey(t, p);
        h && (!n || matchHeaderValue(t, t[h], h, n)) && (delete t[h], e = !0);
      }
    }
    return utils$1.isArray(c) ? c.forEach(o) : o(c), e;
  }
  clear(c) {
    const n = Object.keys(this);
    let t = n.length, e = !1;
    for (; t--; ) {
      const o = n[t];
      (!c || matchHeaderValue(this, this[o], o, c, !0)) && (delete this[o], e = !0);
    }
    return e;
  }
  normalize(c) {
    const n = this, t = {};
    return utils$1.forEach(this, (e, o) => {
      const p = utils$1.findKey(t, o);
      if (p) {
        n[p] = normalizeValue(e), delete n[o];
        return;
      }
      const h = c ? formatHeader(o) : String(o).trim();
      h !== o && delete n[o], n[h] = normalizeValue(e), t[h] = !0;
    }), this;
  }
  concat(...c) {
    return this.constructor.concat(this, ...c);
  }
  toJSON(c) {
    const n = /* @__PURE__ */ Object.create(null);
    return utils$1.forEach(this, (t, e) => {
      t != null && t !== !1 && (n[e] = c && utils$1.isArray(t) ? t.join(", ") : t);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([c, n]) => c + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(c) {
    return c instanceof this ? c : new this(c);
  }
  static concat(c, ...n) {
    const t = new this(c);
    return n.forEach((e) => t.set(e)), t;
  }
  static accessor(c) {
    const t = (this[$internals] = this[$internals] = {
      accessors: {}
    }).accessors, e = this.prototype;
    function o(p) {
      const h = normalizeHeader(p);
      t[h] || (buildAccessors(e, p), t[h] = !0);
    }
    return utils$1.isArray(c) ? c.forEach(o) : o(c), this;
  }
};
AxiosHeaders$1.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders$1.prototype, ({ value: r }, c) => {
  let n = c[0].toUpperCase() + c.slice(1);
  return {
    get: () => r,
    set(t) {
      this[n] = t;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders$1);
function transformData(r, c) {
  const n = this || defaults, t = c || n, e = AxiosHeaders$1.from(t.headers);
  let o = t.data;
  return utils$1.forEach(r, function(h) {
    o = h.call(n, o, e.normalize(), c ? c.status : void 0);
  }), e.normalize(), o;
}
function isCancel$1(r) {
  return !!(r && r.__CANCEL__);
}
function CanceledError$1(r, c, n) {
  AxiosError$1.call(this, r ?? "canceled", AxiosError$1.ERR_CANCELED, c, n), this.name = "CanceledError";
}
utils$1.inherits(CanceledError$1, AxiosError$1, {
  __CANCEL__: !0
});
function settle(r, c, n) {
  const t = n.config.validateStatus;
  !n.status || !t || t(n.status) ? r(n) : c(new AxiosError$1(
    "Request failed with status code " + n.status,
    [AxiosError$1.ERR_BAD_REQUEST, AxiosError$1.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function parseProtocol(r) {
  const c = /^([-+\w]{1,25})(:?\/\/|:)/.exec(r);
  return c && c[1] || "";
}
function speedometer(r, c) {
  r = r || 10;
  const n = new Array(r), t = new Array(r);
  let e = 0, o = 0, p;
  return c = c !== void 0 ? c : 1e3, function(y) {
    const b = Date.now(), O = t[o];
    p || (p = b), n[e] = y, t[e] = b;
    let $ = o, S = 0;
    for (; $ !== e; )
      S += n[$++], $ = $ % r;
    if (e = (e + 1) % r, e === o && (o = (o + 1) % r), b - p < c)
      return;
    const C = O && b - O;
    return C ? Math.round(S * 1e3 / C) : void 0;
  };
}
function throttle(r, c) {
  let n = 0, t = 1e3 / c, e, o;
  const p = (b, O = Date.now()) => {
    n = O, e = null, o && (clearTimeout(o), o = null), r(...b);
  };
  return [(...b) => {
    const O = Date.now(), $ = O - n;
    $ >= t ? p(b, O) : (e = b, o || (o = setTimeout(() => {
      o = null, p(e);
    }, t - $)));
  }, () => e && p(e)];
}
const progressEventReducer = (r, c, n = 3) => {
  let t = 0;
  const e = speedometer(50, 250);
  return throttle((o) => {
    const p = o.loaded, h = o.lengthComputable ? o.total : void 0, y = p - t, b = e(y), O = p <= h;
    t = p;
    const $ = {
      loaded: p,
      total: h,
      progress: h ? p / h : void 0,
      bytes: y,
      rate: b || void 0,
      estimated: b && h && O ? (h - p) / b : void 0,
      event: o,
      lengthComputable: h != null,
      [c ? "download" : "upload"]: !0
    };
    r($);
  }, n);
}, progressEventDecorator = (r, c) => {
  const n = r != null;
  return [(t) => c[0]({
    lengthComputable: n,
    total: r,
    loaded: t
  }), c[1]];
}, asyncDecorator = (r) => (...c) => utils$1.asap(() => r(...c)), isURLSameOrigin = platform.hasStandardBrowserEnv ? /* @__PURE__ */ ((r, c) => (n) => (n = new URL(n, platform.origin), r.protocol === n.protocol && r.host === n.host && (c || r.port === n.port)))(
  new URL(platform.origin),
  platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
) : () => !0, cookies = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(r, c, n, t, e, o, p) {
      if (typeof document > "u") return;
      const h = [`${r}=${encodeURIComponent(c)}`];
      utils$1.isNumber(n) && h.push(`expires=${new Date(n).toUTCString()}`), utils$1.isString(t) && h.push(`path=${t}`), utils$1.isString(e) && h.push(`domain=${e}`), o === !0 && h.push("secure"), utils$1.isString(p) && h.push(`SameSite=${p}`), document.cookie = h.join("; ");
    },
    read(r) {
      if (typeof document > "u") return null;
      const c = document.cookie.match(new RegExp("(?:^|; )" + r + "=([^;]*)"));
      return c ? decodeURIComponent(c[1]) : null;
    },
    remove(r) {
      this.write(r, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL(r) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(r);
}
function combineURLs(r, c) {
  return c ? r.replace(/\/?\/$/, "") + "/" + c.replace(/^\/+/, "") : r;
}
function buildFullPath(r, c, n) {
  let t = !isAbsoluteURL(c);
  return r && (t || n == !1) ? combineURLs(r, c) : c;
}
const headersToObject = (r) => r instanceof AxiosHeaders$1 ? { ...r } : r;
function mergeConfig$1(r, c) {
  c = c || {};
  const n = {};
  function t(b, O, $, S) {
    return utils$1.isPlainObject(b) && utils$1.isPlainObject(O) ? utils$1.merge.call({ caseless: S }, b, O) : utils$1.isPlainObject(O) ? utils$1.merge({}, O) : utils$1.isArray(O) ? O.slice() : O;
  }
  function e(b, O, $, S) {
    if (utils$1.isUndefined(O)) {
      if (!utils$1.isUndefined(b))
        return t(void 0, b, $, S);
    } else return t(b, O, $, S);
  }
  function o(b, O) {
    if (!utils$1.isUndefined(O))
      return t(void 0, O);
  }
  function p(b, O) {
    if (utils$1.isUndefined(O)) {
      if (!utils$1.isUndefined(b))
        return t(void 0, b);
    } else return t(void 0, O);
  }
  function h(b, O, $) {
    if ($ in c)
      return t(b, O);
    if ($ in r)
      return t(void 0, b);
  }
  const y = {
    url: o,
    method: o,
    data: o,
    baseURL: p,
    transformRequest: p,
    transformResponse: p,
    paramsSerializer: p,
    timeout: p,
    timeoutMessage: p,
    withCredentials: p,
    withXSRFToken: p,
    adapter: p,
    responseType: p,
    xsrfCookieName: p,
    xsrfHeaderName: p,
    onUploadProgress: p,
    onDownloadProgress: p,
    decompress: p,
    maxContentLength: p,
    maxBodyLength: p,
    beforeRedirect: p,
    transport: p,
    httpAgent: p,
    httpsAgent: p,
    cancelToken: p,
    socketPath: p,
    responseEncoding: p,
    validateStatus: h,
    headers: (b, O, $) => e(headersToObject(b), headersToObject(O), $, !0)
  };
  return utils$1.forEach(Object.keys({ ...r, ...c }), function(O) {
    const $ = y[O] || e, S = $(r[O], c[O], O);
    utils$1.isUndefined(S) && $ !== h || (n[O] = S);
  }), n;
}
const resolveConfig = (r) => {
  const c = mergeConfig$1({}, r);
  let { data: n, withXSRFToken: t, xsrfHeaderName: e, xsrfCookieName: o, headers: p, auth: h } = c;
  if (c.headers = p = AxiosHeaders$1.from(p), c.url = buildURL(buildFullPath(c.baseURL, c.url, c.allowAbsoluteUrls), r.params, r.paramsSerializer), h && p.set(
    "Authorization",
    "Basic " + btoa((h.username || "") + ":" + (h.password ? unescape(encodeURIComponent(h.password)) : ""))
  ), utils$1.isFormData(n)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv)
      p.setContentType(void 0);
    else if (utils$1.isFunction(n.getHeaders)) {
      const y = n.getHeaders(), b = ["content-type", "content-length"];
      Object.entries(y).forEach(([O, $]) => {
        b.includes(O.toLowerCase()) && p.set(O, $);
      });
    }
  }
  if (platform.hasStandardBrowserEnv && (t && utils$1.isFunction(t) && (t = t(c)), t || t !== !1 && isURLSameOrigin(c.url))) {
    const y = e && o && cookies.read(o);
    y && p.set(e, y);
  }
  return c;
}, isXHRAdapterSupported = typeof XMLHttpRequest < "u", xhrAdapter = isXHRAdapterSupported && function(r) {
  return new Promise(function(n, t) {
    const e = resolveConfig(r);
    let o = e.data;
    const p = AxiosHeaders$1.from(e.headers).normalize();
    let { responseType: h, onUploadProgress: y, onDownloadProgress: b } = e, O, $, S, C, w;
    function x() {
      C && C(), w && w(), e.cancelToken && e.cancelToken.unsubscribe(O), e.signal && e.signal.removeEventListener("abort", O);
    }
    let k = new XMLHttpRequest();
    k.open(e.method.toUpperCase(), e.url, !0), k.timeout = e.timeout;
    function P() {
      if (!k)
        return;
      const T = AxiosHeaders$1.from(
        "getAllResponseHeaders" in k && k.getAllResponseHeaders()
      ), R = {
        data: !h || h === "text" || h === "json" ? k.responseText : k.response,
        status: k.status,
        statusText: k.statusText,
        headers: T,
        config: r,
        request: k
      };
      settle(function(D) {
        n(D), x();
      }, function(D) {
        t(D), x();
      }, R), k = null;
    }
    "onloadend" in k ? k.onloadend = P : k.onreadystatechange = function() {
      !k || k.readyState !== 4 || k.status === 0 && !(k.responseURL && k.responseURL.indexOf("file:") === 0) || setTimeout(P);
    }, k.onabort = function() {
      k && (t(new AxiosError$1("Request aborted", AxiosError$1.ECONNABORTED, r, k)), k = null);
    }, k.onerror = function(V) {
      const R = V && V.message ? V.message : "Network Error", B = new AxiosError$1(R, AxiosError$1.ERR_NETWORK, r, k);
      B.event = V || null, t(B), k = null;
    }, k.ontimeout = function() {
      let V = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const R = e.transitional || transitionalDefaults;
      e.timeoutErrorMessage && (V = e.timeoutErrorMessage), t(new AxiosError$1(
        V,
        R.clarifyTimeoutError ? AxiosError$1.ETIMEDOUT : AxiosError$1.ECONNABORTED,
        r,
        k
      )), k = null;
    }, o === void 0 && p.setContentType(null), "setRequestHeader" in k && utils$1.forEach(p.toJSON(), function(V, R) {
      k.setRequestHeader(R, V);
    }), utils$1.isUndefined(e.withCredentials) || (k.withCredentials = !!e.withCredentials), h && h !== "json" && (k.responseType = e.responseType), b && ([S, w] = progressEventReducer(b, !0), k.addEventListener("progress", S)), y && k.upload && ([$, C] = progressEventReducer(y), k.upload.addEventListener("progress", $), k.upload.addEventListener("loadend", C)), (e.cancelToken || e.signal) && (O = (T) => {
      k && (t(!T || T.type ? new CanceledError$1(null, r, k) : T), k.abort(), k = null);
    }, e.cancelToken && e.cancelToken.subscribe(O), e.signal && (e.signal.aborted ? O() : e.signal.addEventListener("abort", O)));
    const I = parseProtocol(e.url);
    if (I && platform.protocols.indexOf(I) === -1) {
      t(new AxiosError$1("Unsupported protocol " + I + ":", AxiosError$1.ERR_BAD_REQUEST, r));
      return;
    }
    k.send(o || null);
  });
}, composeSignals = (r, c) => {
  const { length: n } = r = r ? r.filter(Boolean) : [];
  if (c || n) {
    let t = new AbortController(), e;
    const o = function(b) {
      if (!e) {
        e = !0, h();
        const O = b instanceof Error ? b : this.reason;
        t.abort(O instanceof AxiosError$1 ? O : new CanceledError$1(O instanceof Error ? O.message : O));
      }
    };
    let p = c && setTimeout(() => {
      p = null, o(new AxiosError$1(`timeout ${c} of ms exceeded`, AxiosError$1.ETIMEDOUT));
    }, c);
    const h = () => {
      r && (p && clearTimeout(p), p = null, r.forEach((b) => {
        b.unsubscribe ? b.unsubscribe(o) : b.removeEventListener("abort", o);
      }), r = null);
    };
    r.forEach((b) => b.addEventListener("abort", o));
    const { signal: y } = t;
    return y.unsubscribe = () => utils$1.asap(h), y;
  }
}, streamChunk = function* (r, c) {
  let n = r.byteLength;
  if (n < c) {
    yield r;
    return;
  }
  let t = 0, e;
  for (; t < n; )
    e = t + c, yield r.slice(t, e), t = e;
}, readBytes = async function* (r, c) {
  for await (const n of readStream(r))
    yield* streamChunk(n, c);
}, readStream = async function* (r) {
  if (r[Symbol.asyncIterator]) {
    yield* r;
    return;
  }
  const c = r.getReader();
  try {
    for (; ; ) {
      const { done: n, value: t } = await c.read();
      if (n)
        break;
      yield t;
    }
  } finally {
    await c.cancel();
  }
}, trackStream = (r, c, n, t) => {
  const e = readBytes(r, c);
  let o = 0, p, h = (y) => {
    p || (p = !0, t && t(y));
  };
  return new ReadableStream({
    async pull(y) {
      try {
        const { done: b, value: O } = await e.next();
        if (b) {
          h(), y.close();
          return;
        }
        let $ = O.byteLength;
        if (n) {
          let S = o += $;
          n(S);
        }
        y.enqueue(new Uint8Array(O));
      } catch (b) {
        throw h(b), b;
      }
    },
    cancel(y) {
      return h(y), e.return();
    }
  }, {
    highWaterMark: 2
  });
}, DEFAULT_CHUNK_SIZE = 64 * 1024, { isFunction } = utils$1, globalFetchAPI = (({ Request: r, Response: c }) => ({
  Request: r,
  Response: c
}))(utils$1.global), {
  ReadableStream: ReadableStream$1,
  TextEncoder
} = utils$1.global, test = (r, ...c) => {
  try {
    return !!r(...c);
  } catch {
    return !1;
  }
}, factory = (r) => {
  r = utils$1.merge.call({
    skipUndefined: !0
  }, globalFetchAPI, r);
  const { fetch: c, Request: n, Response: t } = r, e = c ? isFunction(c) : typeof fetch == "function", o = isFunction(n), p = isFunction(t);
  if (!e)
    return !1;
  const h = e && isFunction(ReadableStream$1), y = e && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((w) => (x) => w.encode(x))(new TextEncoder()) : async (w) => new Uint8Array(await new n(w).arrayBuffer())), b = o && h && test(() => {
    let w = !1;
    const x = new n(platform.origin, {
      body: new ReadableStream$1(),
      method: "POST",
      get duplex() {
        return w = !0, "half";
      }
    }).headers.has("Content-Type");
    return w && !x;
  }), O = p && h && test(() => utils$1.isReadableStream(new t("").body)), $ = {
    stream: O && ((w) => w.body)
  };
  e && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((w) => {
    !$[w] && ($[w] = (x, k) => {
      let P = x && x[w];
      if (P)
        return P.call(x);
      throw new AxiosError$1(`Response type '${w}' is not supported`, AxiosError$1.ERR_NOT_SUPPORT, k);
    });
  });
  const S = async (w) => {
    if (w == null)
      return 0;
    if (utils$1.isBlob(w))
      return w.size;
    if (utils$1.isSpecCompliantForm(w))
      return (await new n(platform.origin, {
        method: "POST",
        body: w
      }).arrayBuffer()).byteLength;
    if (utils$1.isArrayBufferView(w) || utils$1.isArrayBuffer(w))
      return w.byteLength;
    if (utils$1.isURLSearchParams(w) && (w = w + ""), utils$1.isString(w))
      return (await y(w)).byteLength;
  }, C = async (w, x) => {
    const k = utils$1.toFiniteNumber(w.getContentLength());
    return k ?? S(x);
  };
  return async (w) => {
    let {
      url: x,
      method: k,
      data: P,
      signal: I,
      cancelToken: T,
      timeout: V,
      onDownloadProgress: R,
      onUploadProgress: B,
      responseType: D,
      headers: N,
      withCredentials: A = "same-origin",
      fetchOptions: g
    } = resolveConfig(w), v = c || fetch;
    D = D ? (D + "").toLowerCase() : "text";
    let E = composeSignals([I, T && T.toAbortSignal()], V), F = null;
    const M = E && E.unsubscribe && (() => {
      E.unsubscribe();
    });
    let _;
    try {
      if (B && b && k !== "get" && k !== "head" && (_ = await C(N, P)) !== 0) {
        let U = new n(x, {
          method: "POST",
          body: P,
          duplex: "half"
        }), W;
        if (utils$1.isFormData(P) && (W = U.headers.get("content-type")) && N.setContentType(W), U.body) {
          const [J, H] = progressEventDecorator(
            _,
            progressEventReducer(asyncDecorator(B))
          );
          P = trackStream(U.body, DEFAULT_CHUNK_SIZE, J, H);
        }
      }
      utils$1.isString(A) || (A = A ? "include" : "omit");
      const L = o && "credentials" in n.prototype, z = {
        ...g,
        signal: E,
        method: k.toUpperCase(),
        headers: N.normalize().toJSON(),
        body: P,
        duplex: "half",
        credentials: L ? A : void 0
      };
      F = o && new n(x, z);
      let j = await (o ? v(F, g) : v(x, z));
      const G = O && (D === "stream" || D === "response");
      if (O && (R || G && M)) {
        const U = {};
        ["status", "statusText", "headers"].forEach((q) => {
          U[q] = j[q];
        });
        const W = utils$1.toFiniteNumber(j.headers.get("content-length")), [J, H] = R && progressEventDecorator(
          W,
          progressEventReducer(asyncDecorator(R), !0)
        ) || [];
        j = new t(
          trackStream(j.body, DEFAULT_CHUNK_SIZE, J, () => {
            H && H(), M && M();
          }),
          U
        );
      }
      D = D || "text";
      let Y = await $[utils$1.findKey($, D) || "text"](j, w);
      return !G && M && M(), await new Promise((U, W) => {
        settle(U, W, {
          data: Y,
          headers: AxiosHeaders$1.from(j.headers),
          status: j.status,
          statusText: j.statusText,
          config: w,
          request: F
        });
      });
    } catch (L) {
      throw M && M(), L && L.name === "TypeError" && /Load failed|fetch/i.test(L.message) ? Object.assign(
        new AxiosError$1("Network Error", AxiosError$1.ERR_NETWORK, w, F),
        {
          cause: L.cause || L
        }
      ) : AxiosError$1.from(L, L && L.code, w, F);
    }
  };
}, seedCache = /* @__PURE__ */ new Map(), getFetch = (r) => {
  let c = r && r.env || {};
  const { fetch: n, Request: t, Response: e } = c, o = [
    t,
    e,
    n
  ];
  let p = o.length, h = p, y, b, O = seedCache;
  for (; h--; )
    y = o[h], b = O.get(y), b === void 0 && O.set(y, b = h ? /* @__PURE__ */ new Map() : factory(c)), O = b;
  return b;
};
getFetch();
const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: {
    get: getFetch
  }
};
utils$1.forEach(knownAdapters, (r, c) => {
  if (r) {
    try {
      Object.defineProperty(r, "name", { value: c });
    } catch {
    }
    Object.defineProperty(r, "adapterName", { value: c });
  }
});
const renderReason = (r) => `- ${r}`, isResolvedHandle = (r) => utils$1.isFunction(r) || r === null || r === !1;
function getAdapter$1(r, c) {
  r = utils$1.isArray(r) ? r : [r];
  const { length: n } = r;
  let t, e;
  const o = {};
  for (let p = 0; p < n; p++) {
    t = r[p];
    let h;
    if (e = t, !isResolvedHandle(t) && (e = knownAdapters[(h = String(t)).toLowerCase()], e === void 0))
      throw new AxiosError$1(`Unknown adapter '${h}'`);
    if (e && (utils$1.isFunction(e) || (e = e.get(c))))
      break;
    o[h || "#" + p] = e;
  }
  if (!e) {
    const p = Object.entries(o).map(
      ([y, b]) => `adapter ${y} ` + (b === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let h = n ? p.length > 1 ? `since :
` + p.map(renderReason).join(`
`) : " " + renderReason(p[0]) : "as no adapter specified";
    throw new AxiosError$1(
      "There is no suitable adapter to dispatch the request " + h,
      "ERR_NOT_SUPPORT"
    );
  }
  return e;
}
const adapters = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: getAdapter$1,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: knownAdapters
};
function throwIfCancellationRequested(r) {
  if (r.cancelToken && r.cancelToken.throwIfRequested(), r.signal && r.signal.aborted)
    throw new CanceledError$1(null, r);
}
function dispatchRequest(r) {
  return throwIfCancellationRequested(r), r.headers = AxiosHeaders$1.from(r.headers), r.data = transformData.call(
    r,
    r.transformRequest
  ), ["post", "put", "patch"].indexOf(r.method) !== -1 && r.headers.setContentType("application/x-www-form-urlencoded", !1), adapters.getAdapter(r.adapter || defaults.adapter, r)(r).then(function(t) {
    return throwIfCancellationRequested(r), t.data = transformData.call(
      r,
      r.transformResponse,
      t
    ), t.headers = AxiosHeaders$1.from(t.headers), t;
  }, function(t) {
    return isCancel$1(t) || (throwIfCancellationRequested(r), t && t.response && (t.response.data = transformData.call(
      r,
      r.transformResponse,
      t.response
    ), t.response.headers = AxiosHeaders$1.from(t.response.headers))), Promise.reject(t);
  });
}
const VERSION$1 = "1.13.2", validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((r, c) => {
  validators$1[r] = function(t) {
    return typeof t === r || "a" + (c < 1 ? "n " : " ") + r;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function r(c, n, t) {
  function e(o, p) {
    return "[Axios v" + VERSION$1 + "] Transitional option '" + o + "'" + p + (t ? ". " + t : "");
  }
  return (o, p, h) => {
    if (c === !1)
      throw new AxiosError$1(
        e(p, " has been removed" + (n ? " in " + n : "")),
        AxiosError$1.ERR_DEPRECATED
      );
    return n && !deprecatedWarnings[p] && (deprecatedWarnings[p] = !0, console.warn(
      e(
        p,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), c ? c(o, p, h) : !0;
  };
};
validators$1.spelling = function r(c) {
  return (n, t) => (console.warn(`${t} is likely a misspelling of ${c}`), !0);
};
function assertOptions(r, c, n) {
  if (typeof r != "object")
    throw new AxiosError$1("options must be an object", AxiosError$1.ERR_BAD_OPTION_VALUE);
  const t = Object.keys(r);
  let e = t.length;
  for (; e-- > 0; ) {
    const o = t[e], p = c[o];
    if (p) {
      const h = r[o], y = h === void 0 || p(h, o, r);
      if (y !== !0)
        throw new AxiosError$1("option " + o + " must be " + y, AxiosError$1.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new AxiosError$1("Unknown option " + o, AxiosError$1.ERR_BAD_OPTION);
  }
}
const validator = {
  assertOptions,
  validators: validators$1
}, validators = validator.validators;
let Axios$1 = class {
  constructor(c) {
    this.defaults = c || {}, this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(c, n) {
    try {
      return await this._request(c, n);
    } catch (t) {
      if (t instanceof Error) {
        let e = {};
        Error.captureStackTrace ? Error.captureStackTrace(e) : e = new Error();
        const o = e.stack ? e.stack.replace(/^.+\n/, "") : "";
        try {
          t.stack ? o && !String(t.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (t.stack += `
` + o) : t.stack = o;
        } catch {
        }
      }
      throw t;
    }
  }
  _request(c, n) {
    typeof c == "string" ? (n = n || {}, n.url = c) : n = c || {}, n = mergeConfig$1(this.defaults, n);
    const { transitional: t, paramsSerializer: e, headers: o } = n;
    t !== void 0 && validator.assertOptions(t, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, !1), e != null && (utils$1.isFunction(e) ? n.paramsSerializer = {
      serialize: e
    } : validator.assertOptions(e, {
      encode: validators.function,
      serialize: validators.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), validator.assertOptions(n, {
      baseUrl: validators.spelling("baseURL"),
      withXsrfToken: validators.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let p = o && utils$1.merge(
      o.common,
      o[n.method]
    );
    o && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (w) => {
        delete o[w];
      }
    ), n.headers = AxiosHeaders$1.concat(p, o);
    const h = [];
    let y = !0;
    this.interceptors.request.forEach(function(x) {
      typeof x.runWhen == "function" && x.runWhen(n) === !1 || (y = y && x.synchronous, h.unshift(x.fulfilled, x.rejected));
    });
    const b = [];
    this.interceptors.response.forEach(function(x) {
      b.push(x.fulfilled, x.rejected);
    });
    let O, $ = 0, S;
    if (!y) {
      const w = [dispatchRequest.bind(this), void 0];
      for (w.unshift(...h), w.push(...b), S = w.length, O = Promise.resolve(n); $ < S; )
        O = O.then(w[$++], w[$++]);
      return O;
    }
    S = h.length;
    let C = n;
    for (; $ < S; ) {
      const w = h[$++], x = h[$++];
      try {
        C = w(C);
      } catch (k) {
        x.call(this, k);
        break;
      }
    }
    try {
      O = dispatchRequest.call(this, C);
    } catch (w) {
      return Promise.reject(w);
    }
    for ($ = 0, S = b.length; $ < S; )
      O = O.then(b[$++], b[$++]);
    return O;
  }
  getUri(c) {
    c = mergeConfig$1(this.defaults, c);
    const n = buildFullPath(c.baseURL, c.url, c.allowAbsoluteUrls);
    return buildURL(n, c.params, c.paramsSerializer);
  }
};
utils$1.forEach(["delete", "get", "head", "options"], function r(c) {
  Axios$1.prototype[c] = function(n, t) {
    return this.request(mergeConfig$1(t || {}, {
      method: c,
      url: n,
      data: (t || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function r(c) {
  function n(t) {
    return function(o, p, h) {
      return this.request(mergeConfig$1(h || {}, {
        method: c,
        headers: t ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: p
      }));
    };
  }
  Axios$1.prototype[c] = n(), Axios$1.prototype[c + "Form"] = n(!0);
});
let CancelToken$1 = class K {
  constructor(c) {
    if (typeof c != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const t = this;
    this.promise.then((e) => {
      if (!t._listeners) return;
      let o = t._listeners.length;
      for (; o-- > 0; )
        t._listeners[o](e);
      t._listeners = null;
    }), this.promise.then = (e) => {
      let o;
      const p = new Promise((h) => {
        t.subscribe(h), o = h;
      }).then(e);
      return p.cancel = function() {
        t.unsubscribe(o);
      }, p;
    }, c(function(o, p, h) {
      t.reason || (t.reason = new CanceledError$1(o, p, h), n(t.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(c) {
    if (this.reason) {
      c(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(c) : this._listeners = [c];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(c) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(c);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const c = new AbortController(), n = (t) => {
      c.abort(t);
    };
    return this.subscribe(n), c.signal.unsubscribe = () => this.unsubscribe(n), c.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let c;
    return {
      token: new K(function(e) {
        c = e;
      }),
      cancel: c
    };
  }
};
function spread$1(r) {
  return function(n) {
    return r.apply(null, n);
  };
}
function isAxiosError$1(r) {
  return utils$1.isObject(r) && r.isAxiosError === !0;
}
const HttpStatusCode$1 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(HttpStatusCode$1).forEach(([r, c]) => {
  HttpStatusCode$1[c] = r;
});
function createInstance(r) {
  const c = new Axios$1(r), n = bind(Axios$1.prototype.request, c);
  return utils$1.extend(n, Axios$1.prototype, c, { allOwnKeys: !0 }), utils$1.extend(n, c, null, { allOwnKeys: !0 }), n.create = function(e) {
    return createInstance(mergeConfig$1(r, e));
  }, n;
}
const axios = createInstance(defaults);
axios.Axios = Axios$1;
axios.CanceledError = CanceledError$1;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel$1;
axios.VERSION = VERSION$1;
axios.toFormData = toFormData$1;
axios.AxiosError = AxiosError$1;
axios.Cancel = axios.CanceledError;
axios.all = function r(c) {
  return Promise.all(c);
};
axios.spread = spread$1;
axios.isAxiosError = isAxiosError$1;
axios.mergeConfig = mergeConfig$1;
axios.AxiosHeaders = AxiosHeaders$1;
axios.formToJSON = (r) => formDataToJSON(utils$1.isHTMLForm(r) ? new FormData(r) : r);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode$1;
axios.default = axios;
const {
  Axios,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken,
  VERSION,
  all,
  Cancel,
  isAxiosError,
  spread,
  toFormData,
  AxiosHeaders,
  HttpStatusCode,
  formToJSON,
  getAdapter,
  mergeConfig
} = axios, LOG$4 = loglevelExports.getLogger("DoInitPings");
class PingCancelledError extends Error {
  constructor() {
    super("Ping cancelled");
  }
}
function doInitPings(r, c, n, t, e, o) {
  const { promise: p, resolve: h, reject: y } = Promise.withResolvers();
  let b = 0, O = 0, $, S = () => {
  };
  const C = () => {
    O++, O >= r.length && (O = 0), S();
  }, w = (T) => {
    const V = Math.random() * 0.4 - 0.2, R = b === 1 ? c : c * 2 ** (b - 1) * (1 + V), B = Math.min(n, R);
    t(b, T, B), !(typeof window > "u") && ($ = globalThis.setTimeout(C, B));
  }, x = () => {
    const T = r[O];
    new URL(f(T, "")).hostname === "localhost" ? w("\nIs Streamlit still running? If you accidentally stopped Streamlit, just restart it in your terminal:\n\n```bash\nstreamlit run yourscript.py\n```\n      ") : w(
      "Streamlit server is not responding. Are you connected to the internet?"
    );
  }, k = () => {
    const T = `Cannot connect to Streamlit (HTTP status: 403).

If you are trying to access a Streamlit app running on another server, this could be due to the app's [CORS](${CORS_ERROR_MESSAGE_DOCUMENTATION_LINK}) settings.`;
    w(T);
  }, P = (T) => {
    let V = "DoInitPings";
    if (T)
      try {
        V = new URL(T).pathname;
      } catch {
        LOG$4.error(`unrecognized url: ${T}`);
      }
    return V;
  };
  return S = () => {
    const T = r[O], V = f(T, SERVER_PING_PATH), B = (typeof window < "u" ? window.__streamlit?.HOST_CONFIG_BASE_URL : void 0) ? parseUriIntoBaseParts() : T, D = f(
      B,
      HOST_CONFIG_PATH
    );
    LOG$4.info(`Attempting to connect to ${V}.`), O === 0 && b++, Promise.all([
      axios.get(V, { timeout: PING_TIMEOUT_MS }),
      axios.get(D, { timeout: PING_TIMEOUT_MS })
    ]).then(([N, A]) => {
      o(A.data), h(O);
    }).catch((N) => {
      const A = b >= MAX_RETRIES_BEFORE_CLIENT_ERROR;
      if (N.code === "ECONNABORTED") {
        if (A) {
          const g = P(N.config?.url);
          LOG$4.error("Client error: DoInitPings timed out"), e(
            "DoInitPings timed out",
            "Connection timed out - ECONNABORTED",
            g
          );
        }
        return w("Connection timed out.");
      }
      if (N.response) {
        const { data: g, status: v, statusText: E } = N.response, F = P(N.response.config?.url);
        return v === /* NO RESPONSE */
        0 ? (A && (LOG$4.error(
          `Client Error: response received with status ${v} when attempting to reach ${F}`
        ), e(
          `Response received with status ${v}`,
          E,
          F
        )), x()) : v === 403 ? (A && (LOG$4.error(
          `Client Error: response received with status ${v} when attempting to reach ${F}`
        ), e(v, E, F)), k()) : (A && (LOG$4.error(
          `Client Error: response received with status ${v} when attempting to reach ${F}`
        ), e(v, E, F)), w(
          `Connection failed with status ${v}, and response "${g}".`
        ));
      }
      if (N.request) {
        if (A) {
          const g = P(N.request.path);
          LOG$4.error(
            `Client Error in reaching server endpoint - No response received when attempting to reach ${g}`
          ), e(
            "No response received from server",
            N.request.status,
            g
          );
        }
        return x();
      }
      if (A) {
        const g = P(N.config?.url);
        LOG$4.error(
          `Client Error in reaching server endpoint - error in setting up request when attempting to reach ${g}`
        ), e(
          "Error setting up request to server",
          N.message ?? "",
          g
        );
      }
      return w(N.message);
    });
  }, S(), {
    promise: p,
    cancel: () => {
      m($) && globalThis.clearTimeout($), y(new PingCancelledError());
    }
  };
}
const LOG$3 = loglevelExports.getLogger("ForwardMessageCache");
class CacheEntry {
  constructor(c, n, t) {
    this.scriptRunCount = 0, this.encodedMsg = c, this.scriptRunCount = n, this.fragmentId = t;
  }
  getAge(c) {
    return c - this.scriptRunCount;
  }
}
class ForwardMsgCache {
  constructor() {
    this.messages = /* @__PURE__ */ new Map(), this.scriptRunCount = 0;
  }
  /**
   * Increment our scriptRunCount, and remove all entries from the cache
   * that have expired. This should be called after the script has finished
   * running.
   *
   * @param maxMessageAge Max age of a message in the cache.
   * The "age" of a message is defined by how many times the underlying script
   * has finished running (without a compile error) since the message was
   * last accessed.
   *
   * @param fragmentIdsThisRun The fragment IDs being run in this rerun.
   */
  incrementRunCount(c, n) {
    this.scriptRunCount += 1, this.messages.forEach((t, e) => {
      n.length > 0 && (!t.fragmentId || !n.includes(t.fragmentId)) || t.getAge(this.scriptRunCount) > c && (LOG$3.info(`Removing expired ForwardMsg [hash=${e}]`), this.messages.delete(e));
    });
  }
  /**
   * Return a list of all the hashes of messages currently in the cache.
   */
  getCachedMessageHashes() {
    return Array.from(this.messages.keys());
  }
  /**
   * Process a ForwardMsg, "de-referencing" it if it's a reference to
   * a cached message.
   *
   * - If the message is cacheable, store it in the cache and return it
   *   unmodified.
   * - If the message is instead a reference to another message, look for
   *   the referenced message in the cache, and return it.
   */
  // eslint-disable-next-line @typescript-eslint/require-await
  async processMessagePayload(c, n) {
    if (this.maybeCacheMessage(c, n), c.type !== "refHash")
      return c;
    const t = this.getCachedMessage(c.refHash, !0);
    if (m(t))
      LOG$3.info(`Cached ForwardMsg HIT [hash=${c.refHash}]`);
    else
      throw new Error(
        `Cached ForwardMsg MISS [hash=${c.refHash}]. This is not expected to happen. Please [report this bug](https://github.com/streamlit/streamlit/issues).`
      );
    if (!c.metadata)
      throw new Error(
        "Reference ForwardMsg has no metadata. This is not expected to happen. Please [report this bug](https://github.com/streamlit/streamlit/issues)."
      );
    return t.metadata = ForwardMsg.decode(n).metadata, t;
  }
  /**
   * Add a new message to the cache if appropriate.
   */
  maybeCacheMessage(c, n) {
    if (c.type !== "refHash" && c.metadata?.cacheable) {
      if (!c.hash) {
        LOG$3.error(
          "ForwardMsg has no hash. This is not expected to happen, please report this bug.",
          c
        );
        return;
      }
      this.getCachedMessage(c.hash, !0) === void 0 && (LOG$3.info(`Caching ForwardMsg [hash=${c.hash}]`), this.messages.set(
        c.hash,
        new CacheEntry(
          n,
          this.scriptRunCount,
          // Only delta messages have an associated fragment ID:
          c.delta?.fragmentId ?? void 0
        )
      ));
    }
  }
  /**
   * Return a new copy of the ForwardMsg with the given hash
   * from the cache, or undefined if no such message exists.
   *
   * If the message's entry exists, its scriptRunCount will be
   * updated to the current value.
   */
  getCachedMessage(c, n) {
    const t = this.messages.get(c);
    if (!d(t))
      return n && (t.scriptRunCount = this.scriptRunCount), ForwardMsg.decode(t.encodedMsg);
  }
}
const LOG$2 = loglevelExports.getLogger("WebsocketConnection");
class WebsocketConnection {
  constructor(c) {
    this.uriIndex = 0, this.lastDispatchedMessageIndex = -1, this.nextMessageIndex = 0, this.messageQueue = {}, this.state = ConnectionState.INITIAL, this.args = c, this.cache = new ForwardMsgCache(), this.stepFsm("INITIALIZED");
  }
  /**
   * Return the BaseUriParts for the server we're connected to,
   * if we are connected to a server.
   */
  getBaseUriParts() {
    if (this.state === ConnectionState.CONNECTED)
      return this.args.baseUriPartsList[this.uriIndex];
  }
  disconnect() {
    this.setFsmState(ConnectionState.DISCONNECTED_FOREVER);
  }
  // This should only be called inside stepFsm().
  setFsmState(c, n) {
    switch (LOG$2.info(`New state: ${c}`), this.state = c, this.state) {
      case ConnectionState.PINGING_SERVER:
        this.pingServer();
        break;
    }
    switch (this.args.onConnectionStateChange(c, n), this.state) {
      case ConnectionState.CONNECTING:
        this.connectToWebSocket();
        break;
      case ConnectionState.DISCONNECTED_FOREVER:
        this.closeConnection();
        break;
    }
  }
  /**
   * Process an event in our FSM.
   *
   * @param event The event to process.
   * @param errMsg an optional error message to send to the OnStateChanged
   * callback. This is meaningful only for the FATAL_ERROR event. The message
   * will be displayed to the user in a "Connection Error" dialog.
   */
  stepFsm(c, n) {
    if (LOG$2.info(`State: ${this.state}; Event: ${c}`), c === "FATAL_ERROR" && this.state !== ConnectionState.DISCONNECTED_FOREVER) {
      LOG$2.error(
        `Client Error: Websocket connection encountered fatal error - ${n}`
      ), this.args.sendClientError(
        "Websocket connection fatal error encountered",
        // @ts-expect-error - errMsg always passed with FATAL_ERROR event
        n,
        "Websocket Connection"
      ), this.setFsmState(ConnectionState.DISCONNECTED_FOREVER, n);
      return;
    }
    switch (this.state) {
      case ConnectionState.INITIAL:
        if (c === "INITIALIZED") {
          this.setFsmState(ConnectionState.PINGING_SERVER);
          return;
        }
        break;
      case ConnectionState.CONNECTING:
        if (c === "CONNECTION_SUCCEEDED") {
          this.setFsmState(ConnectionState.CONNECTED);
          return;
        }
        if (c === "CONNECTION_TIMED_OUT" || c === "CONNECTION_ERROR" || c === "CONNECTION_CLOSED") {
          this.setFsmState(ConnectionState.PINGING_SERVER);
          return;
        }
        break;
      case ConnectionState.CONNECTED:
        if (c === "CONNECTION_CLOSED" || c === "CONNECTION_ERROR") {
          this.setFsmState(ConnectionState.PINGING_SERVER);
          return;
        }
        break;
      case ConnectionState.PINGING_SERVER:
        if (c === "SERVER_PING_SUCCEEDED") {
          this.setFsmState(ConnectionState.CONNECTING);
          return;
        }
        break;
      case ConnectionState.DISCONNECTED_FOREVER:
        LOG$2.warn(
          `Discarding ${c} while in ${ConnectionState.DISCONNECTED_FOREVER}`
        );
        return;
    }
    throw new Error(
      `Unsupported state transition.
State: ${this.state}
Event: ${c}`
    );
  }
  async pingServer() {
    this.pingRequest = doInitPings(
      this.args.baseUriPartsList,
      PING_MINIMUM_RETRY_PERIOD_MS,
      PING_MAXIMUM_RETRY_PERIOD_MS,
      this.args.onRetry,
      this.args.sendClientError,
      this.args.onHostConfigResp
    );
    try {
      this.uriIndex = await this.pingRequest.promise, this.pingRequest = void 0, this.stepFsm("SERVER_PING_SUCCEEDED");
    } catch (c) {
      c instanceof PingCancelledError ? LOG$2.info("Ping cancelled") : this.stepFsm("FATAL_ERROR", c instanceof Error ? c.message : String(c));
    } finally {
      this.pingRequest = void 0;
    }
  }
  /**
   * Get the session tokens to use to initialize a WebSocket connection.
   *
   * This method returns an array containing either one or two elements:
   *   1. The first element contains an auth token to be used in environments
   *      where the parent frame of this app needs to pass down an external
   *      auth token. If no token is provided, a placeholder is used.
   *   2. The second element is the session ID to attempt to reconnect to if
   *      one is available (that is, if this websocket has disconnected and is
   *      reconnecting). On the initial connection attempt, this is unset and
   *      the return value of this method is a singleton array.
   */
  async getSessionTokens() {
    const c = await this.args.claimHostAuthToken(), n = u("_streamlit_xsrf");
    this.args.resetHostAuthToken();
    const t = this.args.getLastSessionId();
    return [
      // NOTE: We have to set the auth token to some arbitrary placeholder if
      // not provided since the empty string is an invalid protocol option.
      c ?? n ?? "PLACEHOLDER_AUTH_TOKEN",
      ...t ? [t] : []
    ];
  }
  async connectToWebSocket() {
    const c = buildWsUri(
      this.args.baseUriPartsList[this.uriIndex],
      WEBSOCKET_STREAM_PATH
    );
    if (m(this.websocket))
      throw new Error("Websocket already exists");
    LOG$2.info("creating WebSocket");
    const n = await this.getSessionTokens();
    this.websocket = new WebSocket(c, ["streamlit", ...n]), this.websocket.binaryType = "arraybuffer", this.setConnectionTimeout(c);
    const t = this.websocket, e = () => t === this.websocket;
    this.websocket.addEventListener("message", (o) => {
      e() && this.handleMessage(o.data).catch((p) => {
        const h = `Failed to process a Websocket message. ${p}`;
        LOG$2.error(h), this.stepFsm("FATAL_ERROR", h);
      });
    }), this.websocket.addEventListener("open", () => {
      e() && (LOG$2.info("WebSocket onopen"), this.stepFsm("CONNECTION_SUCCEEDED"));
    }), this.websocket.addEventListener("close", () => {
      e() && (LOG$2.warn("WebSocket onclose"), this.closeConnection(), this.stepFsm("CONNECTION_CLOSED"));
    }), this.websocket.addEventListener("error", (o) => {
      e() && (LOG$2.error("Client Error: WebSocket onerror"), this.args.sendClientError(
        "Websocket connection onerror triggered",
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- TODO: Fix this
        `Error: ${o}`,
        "Websocket Connection"
      ), this.closeConnection(), this.stepFsm("CONNECTION_ERROR"));
    });
  }
  setConnectionTimeout(c) {
    if (m(this.wsConnectionTimeout))
      throw new Error("WS timeout is already set");
    const n = this.websocket;
    this.wsConnectionTimeout = globalThis.setTimeout(() => {
      if (n === this.websocket) {
        if (d(this.wsConnectionTimeout)) {
          LOG$2.warn("Timeout fired after cancellation");
          return;
        }
        if (d(this.websocket)) {
          this.closeConnection(), this.stepFsm("FATAL_ERROR", "Null Websocket in setConnectionTimeout");
          return;
        }
        this.websocket.readyState === 0 && (LOG$2.info(`Client error: ${c} timed out`), this.args.sendClientError(
          "Websocket connection timed out",
          `${c} timed out`,
          "Websocket Connection"
        ), this.closeConnection(), this.stepFsm("CONNECTION_TIMED_OUT"));
      }
    }, WEBSOCKET_TIMEOUT_MS), LOG$2.info(`Set WS timeout ${Number(this.wsConnectionTimeout)}`);
  }
  closeConnection() {
    this.websocket && (this.websocket.close(), this.websocket = void 0), m(this.wsConnectionTimeout) && (LOG$2.info(`Clearing WS timeout ${Number(this.wsConnectionTimeout)}`), globalThis.clearTimeout(this.wsConnectionTimeout), this.wsConnectionTimeout = void 0), this.pingRequest && (this.pingRequest.cancel(), this.pingRequest = void 0);
  }
  /**
   * Encodes the message with the outgoingMessageType and sends it over the
   * wire.
   */
  sendMessage(c) {
    if (!this.websocket)
      return;
    const n = BackMsg.create(c), t = BackMsg.encode(n).finish();
    this.websocket.send(t);
  }
  /**
   * Called when our script has finished running. Calls through
   * to the ForwardMsgCache, to handle cached entry expiry.
   */
  incrementMessageCacheRunCount(c, n) {
    this.cache.incrementRunCount(c, n);
  }
  /**
   * Return a list of all the hashes of messages currently in the cache.
   */
  getCachedMessageHashes() {
    return this.cache.getCachedMessageHashes();
  }
  async handleMessage(c) {
    const n = this.nextMessageIndex;
    this.nextMessageIndex += 1;
    const t = new Uint8Array(c), e = ForwardMsg.decode(t);
    for (this.messageQueue[n] = await this.cache.processMessagePayload(
      e,
      t
    ); this.lastDispatchedMessageIndex + 1 in this.messageQueue; ) {
      const o = this.lastDispatchedMessageIndex + 1;
      this.args.onMessage(this.messageQueue[o]), delete this.messageQueue[o], this.lastDispatchedMessageIndex = o;
    }
  }
}
const LOG$1 = loglevelExports.getLogger("ConnectionManager");
class ConnectionManager {
  constructor(c) {
    this.connectionState = ConnectionState.INITIAL, this.setConnectionState = (n, t) => {
      this.connectionState !== n && (this.connectionState = n, this.props.connectionStateChanged(n)), t && this.props.onConnectionError(t);
    }, this.showRetryError = (n, t, e) => {
      n >= MAX_RETRIES_BEFORE_CLIENT_ERROR && this.props.onConnectionError(t);
    }, this.props = c, this.connect();
  }
  /**
   * Indicates whether we're connected to the server.
   */
  isConnected() {
    return this.connectionState === ConnectionState.CONNECTED;
  }
  /**
   * Return the BaseUriParts for the server we're connected to,
   * if we are connected to a server.
   */
  getBaseUriParts() {
    if (this.websocketConnection instanceof WebsocketConnection)
      return this.websocketConnection.getBaseUriParts();
  }
  sendMessage(c) {
    this.websocketConnection instanceof WebsocketConnection && this.isConnected() ? this.websocketConnection.sendMessage(c) : LOG$1.error(`Cannot send message when server is disconnected: ${c}`);
  }
  /**
   * Increment the runCount on our message cache, and clear entries
   * whose age is greater than the max.
   */
  incrementMessageCacheRunCount(c, n) {
    this.websocketConnection instanceof WebsocketConnection && this.websocketConnection.incrementMessageCacheRunCount(
      c,
      n
    );
  }
  getCachedMessageHashes() {
    return this.websocketConnection instanceof WebsocketConnection ? this.websocketConnection?.getCachedMessageHashes() ?? [] : [];
  }
  /**
   * Checks query params to determine if static notebook Id has been passed.
   * If so, returns the Id.
   */
  checkStaticConnection() {
    return new URLSearchParams(document.location.search).get("staticAppId");
  }
  /**
   * Establish either a WebsocketConnection or StaticConnection
   * based on query params.
   */
  async connect() {
    const c = this.checkStaticConnection();
    if (c)
      establishStaticConnection(
        c,
        this.setConnectionState,
        this.props.onMessage,
        this.props.onConnectionError,
        this.props.endpoints
      ), this.websocketConnection = null;
    else
      try {
        this.websocketConnection = await this.connectToRunningServer();
      } catch (n) {
        const t = n instanceof Error ? n : new Error(`${n}`);
        LOG$1.error(`Client Error: Websocket connection - ${t.message}`), this.props.sendClientError(
          "Failed to establish websocket connection",
          t.message,
          "Connection Manager"
        ), this.setConnectionState(
          ConnectionState.DISCONNECTED_FOREVER,
          t.message
        );
      }
  }
  disconnect() {
    this.websocketConnection?.disconnect();
  }
  connectToRunningServer() {
    const c = getPossibleBaseUris();
    return new WebsocketConnection({
      getLastSessionId: this.props.getLastSessionId,
      endpoints: this.props.endpoints,
      baseUriPartsList: c,
      onMessage: this.props.onMessage,
      onConnectionStateChange: this.setConnectionState,
      onRetry: this.showRetryError,
      claimHostAuthToken: this.props.claimHostAuthToken,
      resetHostAuthToken: this.props.resetHostAuthToken,
      sendClientError: this.props.sendClientError,
      onHostConfigResp: this.props.onHostConfigResp
    });
  }
}
const LOG = loglevelExports.getLogger("DefaultStreamlitEndpoints"), MEDIA_ENDPOINT = "/media", UPLOAD_FILE_ENDPOINT = "/_stcore/upload_file", COMPONENT_ENDPOINT_BASE = "/component";
class DefaultStreamlitEndpoints {
  constructor(c) {
    this.getServerUri = c.getServerUri, this.csrfEnabled = c.csrfEnabled, this.sendClientError = c.sendClientError, this.staticConfigUrl = null;
  }
  setStaticConfigUrl(c) {
    this.staticConfigUrl = c;
  }
  sendClientErrorToHost(c, n, t, e, o) {
    this.sendClientError(
      c,
      n,
      t,
      e,
      o
    );
  }
  /**
   * Check the source of a component for successful response (for those without onerror event)
   * If the response is not ok, or fetch otherwise fails, send an error to the host.
   */
  async checkSourceUrlResponse(c, n, t) {
    const e = t ? `${n} ${t}` : n;
    try {
      const o = await fetch(c);
      o.ok || (LOG.error(
        `Client Error: ${e} source error - ${o.status}`
      ), this.sendClientErrorToHost(
        n,
        o.status,
        o.statusText,
        c,
        t
      ));
    } catch (o) {
      const p = o instanceof Error ? o.message : "Unknown Error";
      LOG.error(`Client Error: ${e} fetch error - ${p}`), this.sendClientErrorToHost(
        n,
        "Error fetching source",
        p,
        c,
        t
      );
    }
  }
  buildComponentURL(c, n) {
    return f(
      this.requireServerUri(),
      `${COMPONENT_ENDPOINT_BASE}/${c}/${n}`
    );
  }
  setFileUploadClientConfig({
    prefix: c,
    headers: n
  }) {
    this.fileUploadClientConfig = {
      prefix: c,
      headers: n
    };
  }
  /**
   * If we are using a static connection, return S3 URL for that file. Otherwise, return null.
   */
  buildStaticUrl(c) {
    const t = new URLSearchParams(document.location.search).get("staticAppId");
    return `${this.staticConfigUrl}/${t}${c}`;
  }
  /**
   * Construct a URL for a media file. If the `staticConfigUrl` is set, we have a static app
   * and will serve media from S3. If the url is relative and starts with  "/media",
   * assume it's being served from Streamlit and construct it appropriately.
   * Otherwise leave it alone.
   */
  buildMediaURL(c) {
    return this.staticConfigUrl && c.startsWith(MEDIA_ENDPOINT) ? this.buildStaticUrl(c) : c.startsWith(MEDIA_ENDPOINT) ? f(this.requireServerUri(), c) : c;
  }
  /**
   * Construct a URL for a download file.
   * @param url a relative or absolute URL. If `url` is absolute, it will be
   * returned unchanged. Otherwise, the return value will be a URL for fetching
   * the media file from the connected Streamlit instance. The target server can
   * be changed by setting window.__streamlit?.DOWNLOAD_ASSETS_BASE_URL.
   */
  buildDownloadUrl(c) {
    if (!c.startsWith(MEDIA_ENDPOINT))
      return c;
    const n = window.__streamlit?.DOWNLOAD_ASSETS_BASE_URL;
    return f(n ? parseUriIntoBaseParts() : this.requireServerUri(), c);
  }
  /**
   * Construct a URL for uploading a file. If the `fileUploadClientConfig`
   * exists, we build URL by prefixing URL with prefix from the config,
   * otherwise if the `fileUploadClientConfig` is not present, if URL is
   * relative and starts with "/_stcore/upload_file", assume we're uploading
   * the file to the Streamlit Tornado server and construct the URL
   * appropriately. Otherwise, we're probably uploading the file to some
   * external service, so we leave the URL alone.
   */
  buildFileUploadURL(c) {
    return this.fileUploadClientConfig ? s(this.fileUploadClientConfig.prefix, c) : c.startsWith(UPLOAD_FILE_ENDPOINT) ? f(this.requireServerUri(), c) : c;
  }
  /** Construct a URL for an app page in a multi-page app. */
  buildAppPageURL(c, n) {
    const t = n.urlPathname, e = n.isDefault ? "" : t;
    if (typeof c == "string" && c.length > 0)
      return `${c}/${e}`;
    const { port: o, protocol: p } = window.location, { pathname: h, hostname: y } = this.requireServerUri(), b = o ? `:${o}` : "", O = h === "/" ? "/" : `${h}/`;
    return `${p}//${y}${b}${O}${e}`;
  }
  async uploadFileUploaderFile(c, n, t, e, o) {
    const p = new FormData(), { name: h, webkitRelativePath: y } = n, b = y || h;
    p.append(h, n, b);
    const O = this.getAdditionalHeaders(), $ = this.buildFileUploadURL(c);
    try {
      await this.csrfRequest($, {
        signal: o,
        method: "PUT",
        data: p,
        responseType: "text",
        headers: O,
        onUploadProgress: e
      });
    } catch (S) {
      LOG.error(`Client Error: File uploader error on file upload - ${S}`);
      const C = S instanceof Error ? S.message : "Unknown Error";
      throw this.sendClientErrorToHost(
        "File Uploader",
        "Error uploading file",
        C,
        $
      ), S;
    }
  }
  getAdditionalHeaders() {
    let c = {};
    return this.fileUploadClientConfig && (c = {
      ...c,
      ...this.fileUploadClientConfig.headers
    }), c;
  }
  /**
   * Send an HTTP DELETE request to the given URL.
   */
  async deleteFileAtURL(c, n) {
    const t = this.getAdditionalHeaders(), e = this.buildFileUploadURL(c);
    try {
      await this.csrfRequest(e, {
        method: "DELETE",
        data: { sessionId: n },
        headers: t
      });
    } catch (o) {
      LOG.error(`Client Error: File uploader error on file delete - ${o}`);
      const p = o instanceof Error ? o.message : "Unknown Error";
      throw this.sendClientErrorToHost(
        "File Uploader",
        "Error deleting file",
        p,
        e
      ), o;
    }
  }
  /**
   * Fetch the server URI. If our server is disconnected, default to the most
   * recent cached value of the URI. If we're disconnected and have no cached
   * value, throw an Error.
   */
  requireServerUri() {
    const c = this.getServerUri();
    if (m(c))
      return this.cachedServerUri = c, c;
    if (m(this.cachedServerUri))
      return this.cachedServerUri;
    throw new Error("not connected to a server!");
  }
  /**
   * Wrapper around axios.request to update the request config with
   * CSRF headers if client has CSRF protection enabled.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace 'any' with a more specific type.
  csrfRequest(c, n) {
    if (n.url = c, this.csrfEnabled) {
      const t = u("_streamlit_xsrf");
      m(t) && (n.headers = {
        "X-Xsrftoken": t,
        ...n.headers || {}
      }, n.withCredentials = !0);
    }
    return axios.request(n);
  }
}
function mockEndpoints(r = {}) {
  return {
    setStaticConfigUrl: vi.fn(),
    sendClientErrorToHost: vi.fn(),
    checkSourceUrlResponse: vi.fn(),
    buildComponentURL: vi.fn(),
    buildMediaURL: vi.fn(),
    buildDownloadUrl: vi.fn(),
    buildFileUploadURL: vi.fn(),
    buildAppPageURL: vi.fn().mockImplementation(
      (c, n, t) => `http://mock/app/page/${n.pageName}.${t}`
    ),
    uploadFileUploaderFile: vi.fn().mockRejectedValue(new Error("unimplemented mock endpoint")),
    deleteFileAtURL: vi.fn().mockRejectedValue(new Error("unimplemented mock endpoint")),
    ...r
  };
}
export {
  ConnectionManager,
  ConnectionState,
  DefaultStreamlitEndpoints,
  IS_DEV_ENV,
  mockEndpoints,
  parseUriIntoBaseParts
};
